import { defineComponent as oe, computed as T, watch as Se, h as la, ref as le, openBlock as S, createElementBlock as D, normalizeClass as j, createElementVNode as B, renderSlot as H, createVNode as re, unref as P, createCommentVNode as Z, createStaticVNode as z_, createBlock as ye, resolveDynamicComponent as ht, withCtx as G, useSlots as xs, Fragment as _e, renderList as Fe, normalizeStyle as yt, toDisplayString as Pe, createTextVNode as ft, getCurrentScope as s7, onScopeDispose as o7, toRef as jl, readonly as a7, customRef as l7, Teleport as V_, Transition as Gn, withDirectives as Yn, mergeProps as Nt, onMounted as rn, nextTick as gt, withModifiers as Lt, onBeforeUnmount as Ba, createSlots as ca, withKeys as Yt, shallowRef as Tp, inject as Fa, toRaw as c7, reactive as yd, onUnmounted as bd, toRefs as H_, watchEffect as lc, provide as qc, normalizeProps as Ct, guardReactiveProps as on, isRef as ol, resolveComponent as ai, resolveDirective as Y_, toHandlers as W_, useAttrs as u7, mergeModels as Zm, useModel as j_, TransitionGroup as f7, vShow as cc } from "vue";
const qy = () => {
};
let yv = {}, q_ = {}, U_ = null, K_ = {
  mark: qy,
  measure: qy
};
try {
  typeof window != "undefined" && (yv = window), typeof document != "undefined" && (q_ = document), typeof MutationObserver != "undefined" && (U_ = MutationObserver), typeof performance != "undefined" && (K_ = performance);
} catch (t) {
}
const {
  userAgent: Uy = ""
} = yv.navigator || {}, os = yv, Je = q_, Ky = U_, Lu = K_;
os.document;
const Ai = !!Je.documentElement && !!Je.head && typeof Je.addEventListener == "function" && typeof Je.createElement == "function", G_ = ~Uy.indexOf("MSIE") || ~Uy.indexOf("Trident/");
var nt = "classic", X_ = "duotone", Cn = "sharp", $n = "sharp-duotone", h7 = [nt, X_, Cn, $n], d7 = {
  classic: {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  sharp: {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
  },
  "sharp-duotone": {
    900: "fasds"
  }
}, Gy = {
  kit: {
    fak: "kit",
    "fa-kit": "kit"
  },
  "kit-duotone": {
    fakd: "kit-duotone",
    "fa-kit-duotone": "kit-duotone"
  }
}, p7 = ["kit"], m7 = /fa(s|r|l|t|d|b|k|kd|ss|sr|sl|st|sds)?[\-\ ]/, g7 = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i, v7 = {
  "Font Awesome 5 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 5 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal"
  },
  "Font Awesome 5 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 5 Duotone": {
    900: "fad"
  }
}, y7 = {
  "Font Awesome 6 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 6 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  "Font Awesome 6 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 6 Duotone": {
    900: "fad"
  },
  "Font Awesome 6 Sharp": {
    900: "fass",
    400: "fasr",
    normal: "fasr",
    300: "fasl",
    100: "fast"
  },
  "Font Awesome 6 Sharp Duotone": {
    900: "fasds"
  }
}, b7 = {
  classic: {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
  },
  sharp: {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
  },
  "sharp-duotone": {
    "fa-solid": "fasds"
  }
}, x7 = {
  classic: ["fas", "far", "fal", "fat"],
  sharp: ["fass", "fasr", "fasl", "fast"],
  "sharp-duotone": ["fasds"]
}, w7 = {
  classic: {
    fab: "fa-brands",
    fad: "fa-duotone",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
  },
  sharp: {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
  },
  "sharp-duotone": {
    fasds: "fa-solid"
  }
}, k7 = {
  classic: {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    duotone: "fad",
    brands: "fab"
  },
  sharp: {
    solid: "fass",
    regular: "fasr",
    light: "fasl",
    thin: "fast"
  },
  "sharp-duotone": {
    solid: "fasds"
  }
}, Z_ = {
  classic: {
    fa: "solid",
    fas: "solid",
    "fa-solid": "solid",
    far: "regular",
    "fa-regular": "regular",
    fal: "light",
    "fa-light": "light",
    fat: "thin",
    "fa-thin": "thin",
    fad: "duotone",
    "fa-duotone": "duotone",
    fab: "brands",
    "fa-brands": "brands"
  },
  sharp: {
    fa: "solid",
    fass: "solid",
    "fa-solid": "solid",
    fasr: "regular",
    "fa-regular": "regular",
    fasl: "light",
    "fa-light": "light",
    fast: "thin",
    "fa-thin": "thin"
  },
  "sharp-duotone": {
    fa: "solid",
    fasds: "solid",
    "fa-solid": "solid"
  }
}, _7 = ["solid", "regular", "light", "thin", "duotone", "brands"], J_ = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], S7 = J_.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), Sl = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, M7 = [...Object.keys(x7), ..._7, "2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", Sl.GROUP, Sl.SWAP_OPACITY, Sl.PRIMARY, Sl.SECONDARY].concat(J_.map((t) => "".concat(t, "x"))).concat(S7.map((t) => "w-".concat(t))), C7 = {
  "Font Awesome Kit": {
    400: "fak",
    normal: "fak"
  },
  "Font Awesome Kit Duotone": {
    400: "fakd",
    normal: "fakd"
  }
}, $7 = {
  kit: {
    "fa-kit": "fak"
  },
  "kit-duotone": {
    "fa-kit-duotone": "fakd"
  }
}, A7 = {
  kit: {
    fak: "fa-kit"
  },
  "kit-duotone": {
    fakd: "fa-kit-duotone"
  }
}, Xy = {
  kit: {
    kit: "fak"
  },
  "kit-duotone": {
    "kit-duotone": "fakd"
  }
};
const gi = "___FONT_AWESOME___", Jm = 16, Q_ = "fa", e3 = "svg-inline--fa", eo = "data-fa-i2svg", Qm = "data-fa-pseudo-element", D7 = "data-fa-pseudo-element-pending", bv = "data-prefix", xv = "data-icon", Zy = "fontawesome-i2svg", T7 = "async", O7 = ["HTML", "HEAD", "STYLE", "SCRIPT"], t3 = (() => {
  try {
    return process.env.NODE_ENV === "production";
  } catch (t) {
    return !1;
  }
})(), n3 = [nt, Cn, $n];
function Uc(t) {
  return new Proxy(t, {
    get(e, n) {
      return n in e ? e[n] : e[nt];
    }
  });
}
const r3 = {
  ...Z_
};
r3[nt] = {
  ...Z_[nt],
  ...Gy.kit,
  ...Gy["kit-duotone"]
};
const qs = Uc(r3), eg = {
  ...k7
};
eg[nt] = {
  ...eg[nt],
  ...Xy.kit,
  ...Xy["kit-duotone"]
};
const uc = Uc(eg), tg = {
  ...w7
};
tg[nt] = {
  ...tg[nt],
  ...A7.kit
};
const Us = Uc(tg), ng = {
  ...b7
};
ng[nt] = {
  ...ng[nt],
  ...$7.kit
};
const E7 = Uc(ng), P7 = m7, i3 = "fa-layers-text", L7 = g7, N7 = {
  ...d7
};
Uc(N7);
const I7 = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], Op = Sl, ua = /* @__PURE__ */ new Set();
Object.keys(uc[nt]).map(ua.add.bind(ua));
Object.keys(uc[Cn]).map(ua.add.bind(ua));
Object.keys(uc[$n]).map(ua.add.bind(ua));
const R7 = [...p7, ...M7], ql = os.FontAwesomeConfig || {};
function B7(t) {
  var e = Je.querySelector("script[" + t + "]");
  if (e)
    return e.getAttribute(t);
}
function F7(t) {
  return t === "" ? !0 : t === "false" ? !1 : t === "true" ? !0 : t;
}
Je && typeof Je.querySelector == "function" && [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach((e) => {
  let [n, r] = e;
  const i = F7(B7(n));
  i != null && (ql[r] = i);
});
const s3 = {
  styleDefault: "solid",
  familyDefault: "classic",
  cssPrefix: Q_,
  replacementClass: e3,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
ql.familyPrefix && (ql.cssPrefix = ql.familyPrefix);
const fa = {
  ...s3,
  ...ql
};
fa.autoReplaceSvg || (fa.observeMutations = !1);
const be = {};
Object.keys(s3).forEach((t) => {
  Object.defineProperty(be, t, {
    enumerable: !0,
    set: function(e) {
      fa[t] = e, Ul.forEach((n) => n(be));
    },
    get: function() {
      return fa[t];
    }
  });
});
Object.defineProperty(be, "familyPrefix", {
  enumerable: !0,
  set: function(t) {
    fa.cssPrefix = t, Ul.forEach((e) => e(be));
  },
  get: function() {
    return fa.cssPrefix;
  }
});
os.FontAwesomeConfig = be;
const Ul = [];
function z7(t) {
  return Ul.push(t), () => {
    Ul.splice(Ul.indexOf(t), 1);
  };
}
const zi = Jm, Pr = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function V7(t) {
  if (!t || !Ai)
    return;
  const e = Je.createElement("style");
  e.setAttribute("type", "text/css"), e.innerHTML = t;
  const n = Je.head.childNodes;
  let r = null;
  for (let i = n.length - 1; i > -1; i--) {
    const s = n[i], o = (s.tagName || "").toUpperCase();
    ["STYLE", "LINK"].indexOf(o) > -1 && (r = s);
  }
  return Je.head.insertBefore(e, r), t;
}
const H7 = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function fc() {
  let t = 12, e = "";
  for (; t-- > 0; )
    e += H7[Math.random() * 62 | 0];
  return e;
}
function za(t) {
  const e = [];
  for (let n = (t || []).length >>> 0; n--; )
    e[n] = t[n];
  return e;
}
function wv(t) {
  return t.classList ? za(t.classList) : (t.getAttribute("class") || "").split(" ").filter((e) => e);
}
function o3(t) {
  return "".concat(t).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function Y7(t) {
  return Object.keys(t || {}).reduce((e, n) => e + "".concat(n, '="').concat(o3(t[n]), '" '), "").trim();
}
function xd(t) {
  return Object.keys(t || {}).reduce((e, n) => e + "".concat(n, ": ").concat(t[n].trim(), ";"), "");
}
function kv(t) {
  return t.size !== Pr.size || t.x !== Pr.x || t.y !== Pr.y || t.rotate !== Pr.rotate || t.flipX || t.flipY;
}
function W7(t) {
  let {
    transform: e,
    containerWidth: n,
    iconWidth: r
  } = t;
  const i = {
    transform: "translate(".concat(n / 2, " 256)")
  }, s = "translate(".concat(e.x * 32, ", ").concat(e.y * 32, ") "), o = "scale(".concat(e.size / 16 * (e.flipX ? -1 : 1), ", ").concat(e.size / 16 * (e.flipY ? -1 : 1), ") "), a = "rotate(".concat(e.rotate, " 0 0)"), l = {
    transform: "".concat(s, " ").concat(o, " ").concat(a)
  }, c = {
    transform: "translate(".concat(r / 2 * -1, " -256)")
  };
  return {
    outer: i,
    inner: l,
    path: c
  };
}
function j7(t) {
  let {
    transform: e,
    width: n = Jm,
    height: r = Jm,
    startCentered: i = !1
  } = t, s = "";
  return i && G_ ? s += "translate(".concat(e.x / zi - n / 2, "em, ").concat(e.y / zi - r / 2, "em) ") : i ? s += "translate(calc(-50% + ".concat(e.x / zi, "em), calc(-50% + ").concat(e.y / zi, "em)) ") : s += "translate(".concat(e.x / zi, "em, ").concat(e.y / zi, "em) "), s += "scale(".concat(e.size / zi * (e.flipX ? -1 : 1), ", ").concat(e.size / zi * (e.flipY ? -1 : 1), ") "), s += "rotate(".concat(e.rotate, "deg) "), s;
}
var q7 = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-counter-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(-1 * var(--fa-li-width, 2em));
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes fa-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-shake {
  0% {
    transform: rotate(-15deg);
  }
  4% {
    transform: rotate(15deg);
  }
  8%, 24% {
    transform: rotate(-18deg);
  }
  12%, 28% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-22deg);
  }
  20% {
    transform: rotate(22deg);
  }
  32% {
    transform: rotate(-12deg);
  }
  36% {
    transform: rotate(12deg);
  }
  40%, 100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}

.fad.fa-inverse,
.fa-duotone.fa-inverse {
  color: var(--fa-inverse, #fff);
}`;
function a3() {
  const t = Q_, e = e3, n = be.cssPrefix, r = be.replacementClass;
  let i = q7;
  if (n !== t || r !== e) {
    const s = new RegExp("\\.".concat(t, "\\-"), "g"), o = new RegExp("\\--".concat(t, "\\-"), "g"), a = new RegExp("\\.".concat(e), "g");
    i = i.replace(s, ".".concat(n, "-")).replace(o, "--".concat(n, "-")).replace(a, ".".concat(r));
  }
  return i;
}
let Jy = !1;
function Ep() {
  be.autoAddCss && !Jy && (V7(a3()), Jy = !0);
}
var U7 = {
  mixout() {
    return {
      dom: {
        css: a3,
        insertCss: Ep
      }
    };
  },
  hooks() {
    return {
      beforeDOMElementCreation() {
        Ep();
      },
      beforeI2svg() {
        Ep();
      }
    };
  }
};
const vi = os || {};
vi[gi] || (vi[gi] = {});
vi[gi].styles || (vi[gi].styles = {});
vi[gi].hooks || (vi[gi].hooks = {});
vi[gi].shims || (vi[gi].shims = []);
var Lr = vi[gi];
const l3 = [], c3 = function() {
  Je.removeEventListener("DOMContentLoaded", c3), Gf = 1, l3.map((t) => t());
};
let Gf = !1;
Ai && (Gf = (Je.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(Je.readyState), Gf || Je.addEventListener("DOMContentLoaded", c3));
function K7(t) {
  Ai && (Gf ? setTimeout(t, 0) : l3.push(t));
}
function Kc(t) {
  const {
    tag: e,
    attributes: n = {},
    children: r = []
  } = t;
  return typeof t == "string" ? o3(t) : "<".concat(e, " ").concat(Y7(n), ">").concat(r.map(Kc).join(""), "</").concat(e, ">");
}
function Qy(t, e, n) {
  if (t && t[e] && t[e][n])
    return {
      prefix: e,
      iconName: n,
      icon: t[e][n]
    };
}
var Pp = function(e, n, r, i) {
  var s = Object.keys(e), o = s.length, a = n, l, c, u;
  for (r === void 0 ? (l = 1, u = e[s[0]]) : (l = 0, u = r); l < o; l++)
    c = s[l], u = a(u, e[c], c, e);
  return u;
};
function G7(t) {
  const e = [];
  let n = 0;
  const r = t.length;
  for (; n < r; ) {
    const i = t.charCodeAt(n++);
    if (i >= 55296 && i <= 56319 && n < r) {
      const s = t.charCodeAt(n++);
      (s & 64512) == 56320 ? e.push(((i & 1023) << 10) + (s & 1023) + 65536) : (e.push(i), n--);
    } else
      e.push(i);
  }
  return e;
}
function rg(t) {
  const e = G7(t);
  return e.length === 1 ? e[0].toString(16) : null;
}
function X7(t, e) {
  const n = t.length;
  let r = t.charCodeAt(e), i;
  return r >= 55296 && r <= 56319 && n > e + 1 && (i = t.charCodeAt(e + 1), i >= 56320 && i <= 57343) ? (r - 55296) * 1024 + i - 56320 + 65536 : r;
}
function eb(t) {
  return Object.keys(t).reduce((e, n) => {
    const r = t[n];
    return !!r.icon ? e[r.iconName] = r.icon : e[n] = r, e;
  }, {});
}
function ig(t, e) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const {
    skipHooks: r = !1
  } = n, i = eb(e);
  typeof Lr.hooks.addPack == "function" && !r ? Lr.hooks.addPack(t, eb(e)) : Lr.styles[t] = {
    ...Lr.styles[t] || {},
    ...i
  }, t === "fas" && ig("fa", e);
}
const {
  styles: Is,
  shims: Z7
} = Lr, J7 = {
  [nt]: Object.values(Us[nt]),
  [Cn]: Object.values(Us[Cn]),
  [$n]: Object.values(Us[$n])
};
let _v = null, u3 = {}, f3 = {}, h3 = {}, d3 = {}, p3 = {};
const Q7 = {
  [nt]: Object.keys(qs[nt]),
  [Cn]: Object.keys(qs[Cn]),
  [$n]: Object.keys(qs[$n])
};
function eT(t) {
  return ~R7.indexOf(t);
}
function tT(t, e) {
  const n = e.split("-"), r = n[0], i = n.slice(1).join("-");
  return r === t && i !== "" && !eT(i) ? i : null;
}
const m3 = () => {
  const t = (r) => Pp(Is, (i, s, o) => (i[o] = Pp(s, r, {}), i), {});
  u3 = t((r, i, s) => (i[3] && (r[i[3]] = s), i[2] && i[2].filter((a) => typeof a == "number").forEach((a) => {
    r[a.toString(16)] = s;
  }), r)), f3 = t((r, i, s) => (r[s] = s, i[2] && i[2].filter((a) => typeof a == "string").forEach((a) => {
    r[a] = s;
  }), r)), p3 = t((r, i, s) => {
    const o = i[2];
    return r[s] = s, o.forEach((a) => {
      r[a] = s;
    }), r;
  });
  const e = "far" in Is || be.autoFetchSvg, n = Pp(Z7, (r, i) => {
    const s = i[0];
    let o = i[1];
    const a = i[2];
    return o === "far" && !e && (o = "fas"), typeof s == "string" && (r.names[s] = {
      prefix: o,
      iconName: a
    }), typeof s == "number" && (r.unicodes[s.toString(16)] = {
      prefix: o,
      iconName: a
    }), r;
  }, {
    names: {},
    unicodes: {}
  });
  h3 = n.names, d3 = n.unicodes, _v = wd(be.styleDefault, {
    family: be.familyDefault
  });
};
z7((t) => {
  _v = wd(t.styleDefault, {
    family: be.familyDefault
  });
});
m3();
function Sv(t, e) {
  return (u3[t] || {})[e];
}
function nT(t, e) {
  return (f3[t] || {})[e];
}
function Gi(t, e) {
  return (p3[t] || {})[e];
}
function g3(t) {
  return h3[t] || {
    prefix: null,
    iconName: null
  };
}
function rT(t) {
  const e = d3[t], n = Sv("fas", t);
  return e || (n ? {
    prefix: "fas",
    iconName: n
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function as() {
  return _v;
}
const Mv = () => ({
  prefix: null,
  iconName: null,
  rest: []
});
function wd(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    family: n = nt
  } = e, r = qs[n][t], i = uc[n][t] || uc[n][r], s = t in Lr.styles ? t : null;
  return i || s || null;
}
const iT = {
  [nt]: Object.keys(Us[nt]),
  [Cn]: Object.keys(Us[Cn]),
  [$n]: Object.keys(Us[$n])
};
function kd(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    skipLookups: n = !1
  } = e, r = {
    [nt]: "".concat(be.cssPrefix, "-").concat(nt),
    [Cn]: "".concat(be.cssPrefix, "-").concat(Cn),
    [$n]: "".concat(be.cssPrefix, "-").concat($n)
  };
  let i = null, s = nt;
  const o = h7.filter((l) => l !== X_);
  o.forEach((l) => {
    (t.includes(r[l]) || t.some((c) => iT[l].includes(c))) && (s = l);
  });
  const a = t.reduce((l, c) => {
    const u = tT(be.cssPrefix, c);
    if (Is[c] ? (c = J7[s].includes(c) ? E7[s][c] : c, i = c, l.prefix = c) : Q7[s].indexOf(c) > -1 ? (i = c, l.prefix = wd(c, {
      family: s
    })) : u ? l.iconName = u : c !== be.replacementClass && !o.some((h) => c === r[h]) && l.rest.push(c), !n && l.prefix && l.iconName) {
      const h = i === "fa" ? g3(l.iconName) : {}, f = Gi(l.prefix, l.iconName);
      h.prefix && (i = null), l.iconName = h.iconName || f || l.iconName, l.prefix = h.prefix || l.prefix, l.prefix === "far" && !Is.far && Is.fas && !be.autoFetchSvg && (l.prefix = "fas");
    }
    return l;
  }, Mv());
  return (t.includes("fa-brands") || t.includes("fab")) && (a.prefix = "fab"), (t.includes("fa-duotone") || t.includes("fad")) && (a.prefix = "fad"), !a.prefix && s === Cn && (Is.fass || be.autoFetchSvg) && (a.prefix = "fass", a.iconName = Gi(a.prefix, a.iconName) || a.iconName), !a.prefix && s === $n && (Is.fasds || be.autoFetchSvg) && (a.prefix = "fasds", a.iconName = Gi(a.prefix, a.iconName) || a.iconName), (a.prefix === "fa" || i === "fa") && (a.prefix = as() || "fas"), a;
}
class sT {
  constructor() {
    this.definitions = {};
  }
  add() {
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    const i = n.reduce(this._pullDefinitions, {});
    Object.keys(i).forEach((s) => {
      this.definitions[s] = {
        ...this.definitions[s] || {},
        ...i[s]
      }, ig(s, i[s]);
      const o = Us[nt][s];
      o && ig(o, i[s]), m3();
    });
  }
  reset() {
    this.definitions = {};
  }
  _pullDefinitions(e, n) {
    const r = n.prefix && n.iconName && n.icon ? {
      0: n
    } : n;
    return Object.keys(r).map((i) => {
      const {
        prefix: s,
        iconName: o,
        icon: a
      } = r[i], l = a[2];
      e[s] || (e[s] = {}), l.length > 0 && l.forEach((c) => {
        typeof c == "string" && (e[s][c] = a);
      }), e[s][o] = a;
    }), e;
  }
}
let tb = [], Yo = {};
const Go = {}, oT = Object.keys(Go);
function aT(t, e) {
  let {
    mixoutsTo: n
  } = e;
  return tb = t, Yo = {}, Object.keys(Go).forEach((r) => {
    oT.indexOf(r) === -1 && delete Go[r];
  }), tb.forEach((r) => {
    const i = r.mixout ? r.mixout() : {};
    if (Object.keys(i).forEach((s) => {
      typeof i[s] == "function" && (n[s] = i[s]), typeof i[s] == "object" && Object.keys(i[s]).forEach((o) => {
        n[s] || (n[s] = {}), n[s][o] = i[s][o];
      });
    }), r.hooks) {
      const s = r.hooks();
      Object.keys(s).forEach((o) => {
        Yo[o] || (Yo[o] = []), Yo[o].push(s[o]);
      });
    }
    r.provides && r.provides(Go);
  }), n;
}
function sg(t, e) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)
    r[i - 2] = arguments[i];
  return (Yo[t] || []).forEach((o) => {
    e = o.apply(null, [e, ...r]);
  }), e;
}
function to(t) {
  for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)
    n[r - 1] = arguments[r];
  (Yo[t] || []).forEach((s) => {
    s.apply(null, n);
  });
}
function ls() {
  const t = arguments[0], e = Array.prototype.slice.call(arguments, 1);
  return Go[t] ? Go[t].apply(null, e) : void 0;
}
function og(t) {
  t.prefix === "fa" && (t.prefix = "fas");
  let {
    iconName: e
  } = t;
  const n = t.prefix || as();
  if (e)
    return e = Gi(n, e) || e, Qy(v3.definitions, n, e) || Qy(Lr.styles, n, e);
}
const v3 = new sT(), lT = () => {
  be.autoReplaceSvg = !1, be.observeMutations = !1, to("noAuto");
}, cT = {
  i2svg: function() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return Ai ? (to("beforeI2svg", t), ls("pseudoElements2svg", t), ls("i2svg", t)) : Promise.reject(new Error("Operation requires a DOM of some kind."));
  },
  watch: function() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      autoReplaceSvgRoot: e
    } = t;
    be.autoReplaceSvg === !1 && (be.autoReplaceSvg = !0), be.observeMutations = !0, K7(() => {
      fT({
        autoReplaceSvgRoot: e
      }), to("watch", t);
    });
  }
}, uT = {
  icon: (t) => {
    if (t === null)
      return null;
    if (typeof t == "object" && t.prefix && t.iconName)
      return {
        prefix: t.prefix,
        iconName: Gi(t.prefix, t.iconName) || t.iconName
      };
    if (Array.isArray(t) && t.length === 2) {
      const e = t[1].indexOf("fa-") === 0 ? t[1].slice(3) : t[1], n = wd(t[0]);
      return {
        prefix: n,
        iconName: Gi(n, e) || e
      };
    }
    if (typeof t == "string" && (t.indexOf("".concat(be.cssPrefix, "-")) > -1 || t.match(P7))) {
      const e = kd(t.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: e.prefix || as(),
        iconName: Gi(e.prefix, e.iconName) || e.iconName
      };
    }
    if (typeof t == "string") {
      const e = as();
      return {
        prefix: e,
        iconName: Gi(e, t) || t
      };
    }
  }
}, En = {
  noAuto: lT,
  config: be,
  dom: cT,
  parse: uT,
  library: v3,
  findIconDefinition: og,
  toHtml: Kc
}, fT = function() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const {
    autoReplaceSvgRoot: e = Je
  } = t;
  (Object.keys(Lr.styles).length > 0 || be.autoFetchSvg) && Ai && be.autoReplaceSvg && En.dom.i2svg({
    node: e
  });
};
function _d(t, e) {
  return Object.defineProperty(t, "abstract", {
    get: e
  }), Object.defineProperty(t, "html", {
    get: function() {
      return t.abstract.map((n) => Kc(n));
    }
  }), Object.defineProperty(t, "node", {
    get: function() {
      if (!Ai) return;
      const n = Je.createElement("div");
      return n.innerHTML = t.html, n.children;
    }
  }), t;
}
function hT(t) {
  let {
    children: e,
    main: n,
    mask: r,
    attributes: i,
    styles: s,
    transform: o
  } = t;
  if (kv(o) && n.found && !r.found) {
    const {
      width: a,
      height: l
    } = n, c = {
      x: a / l / 2,
      y: 0.5
    };
    i.style = xd({
      ...s,
      "transform-origin": "".concat(c.x + o.x / 16, "em ").concat(c.y + o.y / 16, "em")
    });
  }
  return [{
    tag: "svg",
    attributes: i,
    children: e
  }];
}
function dT(t) {
  let {
    prefix: e,
    iconName: n,
    children: r,
    attributes: i,
    symbol: s
  } = t;
  const o = s === !0 ? "".concat(e, "-").concat(be.cssPrefix, "-").concat(n) : s;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: {
        ...i,
        id: o
      },
      children: r
    }]
  }];
}
function Cv(t) {
  const {
    icons: {
      main: e,
      mask: n
    },
    prefix: r,
    iconName: i,
    transform: s,
    symbol: o,
    title: a,
    maskId: l,
    titleId: c,
    extra: u,
    watchable: h = !1
  } = t, {
    width: f,
    height: d
  } = n.found ? n : e, p = r === "fak", m = [be.replacementClass, i ? "".concat(be.cssPrefix, "-").concat(i) : ""].filter((w) => u.classes.indexOf(w) === -1).filter((w) => w !== "" || !!w).concat(u.classes).join(" ");
  let v = {
    children: [],
    attributes: {
      ...u.attributes,
      "data-prefix": r,
      "data-icon": i,
      class: m,
      role: u.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(f, " ").concat(d)
    }
  };
  const g = p && !~u.classes.indexOf("fa-fw") ? {
    width: "".concat(f / d * 16 * 0.0625, "em")
  } : {};
  h && (v.attributes[eo] = ""), a && (v.children.push({
    tag: "title",
    attributes: {
      id: v.attributes["aria-labelledby"] || "title-".concat(c || fc())
    },
    children: [a]
  }), delete v.attributes.title);
  const y = {
    ...v,
    prefix: r,
    iconName: i,
    main: e,
    mask: n,
    maskId: l,
    transform: s,
    symbol: o,
    styles: {
      ...g,
      ...u.styles
    }
  }, {
    children: x,
    attributes: b
  } = n.found && e.found ? ls("generateAbstractMask", y) || {
    children: [],
    attributes: {}
  } : ls("generateAbstractIcon", y) || {
    children: [],
    attributes: {}
  };
  return y.children = x, y.attributes = b, o ? dT(y) : hT(y);
}
function nb(t) {
  const {
    content: e,
    width: n,
    height: r,
    transform: i,
    title: s,
    extra: o,
    watchable: a = !1
  } = t, l = {
    ...o.attributes,
    ...s ? {
      title: s
    } : {},
    class: o.classes.join(" ")
  };
  a && (l[eo] = "");
  const c = {
    ...o.styles
  };
  kv(i) && (c.transform = j7({
    transform: i,
    startCentered: !0,
    width: n,
    height: r
  }), c["-webkit-transform"] = c.transform);
  const u = xd(c);
  u.length > 0 && (l.style = u);
  const h = [];
  return h.push({
    tag: "span",
    attributes: l,
    children: [e]
  }), s && h.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [s]
  }), h;
}
function pT(t) {
  const {
    content: e,
    title: n,
    extra: r
  } = t, i = {
    ...r.attributes,
    ...n ? {
      title: n
    } : {},
    class: r.classes.join(" ")
  }, s = xd(r.styles);
  s.length > 0 && (i.style = s);
  const o = [];
  return o.push({
    tag: "span",
    attributes: i,
    children: [e]
  }), n && o.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [n]
  }), o;
}
const {
  styles: Lp
} = Lr;
function ag(t) {
  const e = t[0], n = t[1], [r] = t.slice(4);
  let i = null;
  return Array.isArray(r) ? i = {
    tag: "g",
    attributes: {
      class: "".concat(be.cssPrefix, "-").concat(Op.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(be.cssPrefix, "-").concat(Op.SECONDARY),
        fill: "currentColor",
        d: r[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(be.cssPrefix, "-").concat(Op.PRIMARY),
        fill: "currentColor",
        d: r[1]
      }
    }]
  } : i = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: r
    }
  }, {
    found: !0,
    width: e,
    height: n,
    icon: i
  };
}
const mT = {
  found: !1,
  width: 512,
  height: 512
};
function gT(t, e) {
  !t3 && !be.showMissingIcons && t && console.error('Icon with name "'.concat(t, '" and prefix "').concat(e, '" is missing.'));
}
function lg(t, e) {
  let n = e;
  return e === "fa" && be.styleDefault !== null && (e = as()), new Promise((r, i) => {
    if (n === "fa") {
      const s = g3(t) || {};
      t = s.iconName || t, e = s.prefix || e;
    }
    if (t && e && Lp[e] && Lp[e][t]) {
      const s = Lp[e][t];
      return r(ag(s));
    }
    gT(t, e), r({
      ...mT,
      icon: be.showMissingIcons && t ? ls("missingIconAbstract") || {} : {}
    });
  });
}
const rb = () => {
}, cg = be.measurePerformance && Lu && Lu.mark && Lu.measure ? Lu : {
  mark: rb,
  measure: rb
}, Ml = 'FA "6.6.0"', vT = (t) => (cg.mark("".concat(Ml, " ").concat(t, " begins")), () => y3(t)), y3 = (t) => {
  cg.mark("".concat(Ml, " ").concat(t, " ends")), cg.measure("".concat(Ml, " ").concat(t), "".concat(Ml, " ").concat(t, " begins"), "".concat(Ml, " ").concat(t, " ends"));
};
var $v = {
  begin: vT,
  end: y3
};
const Cf = () => {
};
function ib(t) {
  return typeof (t.getAttribute ? t.getAttribute(eo) : null) == "string";
}
function yT(t) {
  const e = t.getAttribute ? t.getAttribute(bv) : null, n = t.getAttribute ? t.getAttribute(xv) : null;
  return e && n;
}
function bT(t) {
  return t && t.classList && t.classList.contains && t.classList.contains(be.replacementClass);
}
function xT() {
  return be.autoReplaceSvg === !0 ? $f.replace : $f[be.autoReplaceSvg] || $f.replace;
}
function wT(t) {
  return Je.createElementNS("http://www.w3.org/2000/svg", t);
}
function kT(t) {
  return Je.createElement(t);
}
function b3(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    ceFn: n = t.tag === "svg" ? wT : kT
  } = e;
  if (typeof t == "string")
    return Je.createTextNode(t);
  const r = n(t.tag);
  return Object.keys(t.attributes || []).forEach(function(s) {
    r.setAttribute(s, t.attributes[s]);
  }), (t.children || []).forEach(function(s) {
    r.appendChild(b3(s, {
      ceFn: n
    }));
  }), r;
}
function _T(t) {
  let e = " ".concat(t.outerHTML, " ");
  return e = "".concat(e, "Font Awesome fontawesome.com "), e;
}
const $f = {
  replace: function(t) {
    const e = t[0];
    if (e.parentNode)
      if (t[1].forEach((n) => {
        e.parentNode.insertBefore(b3(n), e);
      }), e.getAttribute(eo) === null && be.keepOriginalSource) {
        let n = Je.createComment(_T(e));
        e.parentNode.replaceChild(n, e);
      } else
        e.remove();
  },
  nest: function(t) {
    const e = t[0], n = t[1];
    if (~wv(e).indexOf(be.replacementClass))
      return $f.replace(t);
    const r = new RegExp("".concat(be.cssPrefix, "-.*"));
    if (delete n[0].attributes.id, n[0].attributes.class) {
      const s = n[0].attributes.class.split(" ").reduce((o, a) => (a === be.replacementClass || a.match(r) ? o.toSvg.push(a) : o.toNode.push(a), o), {
        toNode: [],
        toSvg: []
      });
      n[0].attributes.class = s.toSvg.join(" "), s.toNode.length === 0 ? e.removeAttribute("class") : e.setAttribute("class", s.toNode.join(" "));
    }
    const i = n.map((s) => Kc(s)).join(`
`);
    e.setAttribute(eo, ""), e.innerHTML = i;
  }
};
function sb(t) {
  t();
}
function x3(t, e) {
  const n = typeof e == "function" ? e : Cf;
  if (t.length === 0)
    n();
  else {
    let r = sb;
    be.mutateApproach === T7 && (r = os.requestAnimationFrame || sb), r(() => {
      const i = xT(), s = $v.begin("mutate");
      t.map(i), s(), n();
    });
  }
}
let Av = !1;
function w3() {
  Av = !0;
}
function ug() {
  Av = !1;
}
let Xf = null;
function ob(t) {
  if (!Ky || !be.observeMutations)
    return;
  const {
    treeCallback: e = Cf,
    nodeCallback: n = Cf,
    pseudoElementsCallback: r = Cf,
    observeMutationsRoot: i = Je
  } = t;
  Xf = new Ky((s) => {
    if (Av) return;
    const o = as();
    za(s).forEach((a) => {
      if (a.type === "childList" && a.addedNodes.length > 0 && !ib(a.addedNodes[0]) && (be.searchPseudoElements && r(a.target), e(a.target)), a.type === "attributes" && a.target.parentNode && be.searchPseudoElements && r(a.target.parentNode), a.type === "attributes" && ib(a.target) && ~I7.indexOf(a.attributeName))
        if (a.attributeName === "class" && yT(a.target)) {
          const {
            prefix: l,
            iconName: c
          } = kd(wv(a.target));
          a.target.setAttribute(bv, l || o), c && a.target.setAttribute(xv, c);
        } else bT(a.target) && n(a.target);
    });
  }), Ai && Xf.observe(i, {
    childList: !0,
    attributes: !0,
    characterData: !0,
    subtree: !0
  });
}
function ST() {
  Xf && Xf.disconnect();
}
function MT(t) {
  const e = t.getAttribute("style");
  let n = [];
  return e && (n = e.split(";").reduce((r, i) => {
    const s = i.split(":"), o = s[0], a = s.slice(1);
    return o && a.length > 0 && (r[o] = a.join(":").trim()), r;
  }, {})), n;
}
function CT(t) {
  const e = t.getAttribute("data-prefix"), n = t.getAttribute("data-icon"), r = t.innerText !== void 0 ? t.innerText.trim() : "";
  let i = kd(wv(t));
  return i.prefix || (i.prefix = as()), e && n && (i.prefix = e, i.iconName = n), i.iconName && i.prefix || (i.prefix && r.length > 0 && (i.iconName = nT(i.prefix, t.innerText) || Sv(i.prefix, rg(t.innerText))), !i.iconName && be.autoFetchSvg && t.firstChild && t.firstChild.nodeType === Node.TEXT_NODE && (i.iconName = t.firstChild.data)), i;
}
function $T(t) {
  const e = za(t.attributes).reduce((i, s) => (i.name !== "class" && i.name !== "style" && (i[s.name] = s.value), i), {}), n = t.getAttribute("title"), r = t.getAttribute("data-fa-title-id");
  return be.autoA11y && (n ? e["aria-labelledby"] = "".concat(be.replacementClass, "-title-").concat(r || fc()) : (e["aria-hidden"] = "true", e.focusable = "false")), e;
}
function AT() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: Pr,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function ab(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  };
  const {
    iconName: n,
    prefix: r,
    rest: i
  } = CT(t), s = $T(t), o = sg("parseNodeAttributes", {}, t);
  let a = e.styleParser ? MT(t) : [];
  return {
    iconName: n,
    title: t.getAttribute("title"),
    titleId: t.getAttribute("data-fa-title-id"),
    prefix: r,
    transform: Pr,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: i,
      styles: a,
      attributes: s
    },
    ...o
  };
}
const {
  styles: DT
} = Lr;
function k3(t) {
  const e = be.autoReplaceSvg === "nest" ? ab(t, {
    styleParser: !1
  }) : ab(t);
  return ~e.extra.classes.indexOf(i3) ? ls("generateLayersText", t, e) : ls("generateSvgReplacementMutation", t, e);
}
let jr = /* @__PURE__ */ new Set();
n3.map((t) => {
  jr.add("fa-".concat(t));
});
Object.keys(qs[nt]).map(jr.add.bind(jr));
Object.keys(qs[Cn]).map(jr.add.bind(jr));
Object.keys(qs[$n]).map(jr.add.bind(jr));
jr = [...jr];
function lb(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!Ai) return Promise.resolve();
  const n = Je.documentElement.classList, r = (u) => n.add("".concat(Zy, "-").concat(u)), i = (u) => n.remove("".concat(Zy, "-").concat(u)), s = be.autoFetchSvg ? jr : n3.map((u) => "fa-".concat(u)).concat(Object.keys(DT));
  s.includes("fa") || s.push("fa");
  const o = [".".concat(i3, ":not([").concat(eo, "])")].concat(s.map((u) => ".".concat(u, ":not([").concat(eo, "])"))).join(", ");
  if (o.length === 0)
    return Promise.resolve();
  let a = [];
  try {
    a = za(t.querySelectorAll(o));
  } catch (u) {
  }
  if (a.length > 0)
    r("pending"), i("complete");
  else
    return Promise.resolve();
  const l = $v.begin("onTree"), c = a.reduce((u, h) => {
    try {
      const f = k3(h);
      f && u.push(f);
    } catch (f) {
      t3 || f.name === "MissingIcon" && console.error(f);
    }
    return u;
  }, []);
  return new Promise((u, h) => {
    Promise.all(c).then((f) => {
      x3(f, () => {
        r("active"), r("complete"), i("pending"), typeof e == "function" && e(), l(), u();
      });
    }).catch((f) => {
      l(), h(f);
    });
  });
}
function TT(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  k3(t).then((n) => {
    n && x3([n], e);
  });
}
function OT(t) {
  return function(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = (e || {}).icon ? e : og(e || {});
    let {
      mask: i
    } = n;
    return i && (i = (i || {}).icon ? i : og(i || {})), t(r, {
      ...n,
      mask: i
    });
  };
}
const ET = function(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    transform: n = Pr,
    symbol: r = !1,
    mask: i = null,
    maskId: s = null,
    title: o = null,
    titleId: a = null,
    classes: l = [],
    attributes: c = {},
    styles: u = {}
  } = e;
  if (!t) return;
  const {
    prefix: h,
    iconName: f,
    icon: d
  } = t;
  return _d({
    type: "icon",
    ...t
  }, () => (to("beforeDOMElementCreation", {
    iconDefinition: t,
    params: e
  }), be.autoA11y && (o ? c["aria-labelledby"] = "".concat(be.replacementClass, "-title-").concat(a || fc()) : (c["aria-hidden"] = "true", c.focusable = "false")), Cv({
    icons: {
      main: ag(d),
      mask: i ? ag(i.icon) : {
        found: !1,
        width: null,
        height: null,
        icon: {}
      }
    },
    prefix: h,
    iconName: f,
    transform: {
      ...Pr,
      ...n
    },
    symbol: r,
    title: o,
    maskId: s,
    titleId: a,
    extra: {
      attributes: c,
      styles: u,
      classes: l
    }
  })));
};
var PT = {
  mixout() {
    return {
      icon: OT(ET)
    };
  },
  hooks() {
    return {
      mutationObserverCallbacks(t) {
        return t.treeCallback = lb, t.nodeCallback = TT, t;
      }
    };
  },
  provides(t) {
    t.i2svg = function(e) {
      const {
        node: n = Je,
        callback: r = () => {
        }
      } = e;
      return lb(n, r);
    }, t.generateSvgReplacementMutation = function(e, n) {
      const {
        iconName: r,
        title: i,
        titleId: s,
        prefix: o,
        transform: a,
        symbol: l,
        mask: c,
        maskId: u,
        extra: h
      } = n;
      return new Promise((f, d) => {
        Promise.all([lg(r, o), c.iconName ? lg(c.iconName, c.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then((p) => {
          let [m, v] = p;
          f([e, Cv({
            icons: {
              main: m,
              mask: v
            },
            prefix: o,
            iconName: r,
            transform: a,
            symbol: l,
            maskId: u,
            title: i,
            titleId: s,
            extra: h,
            watchable: !0
          })]);
        }).catch(d);
      });
    }, t.generateAbstractIcon = function(e) {
      let {
        children: n,
        attributes: r,
        main: i,
        transform: s,
        styles: o
      } = e;
      const a = xd(o);
      a.length > 0 && (r.style = a);
      let l;
      return kv(s) && (l = ls("generateAbstractTransformGrouping", {
        main: i,
        transform: s,
        containerWidth: i.width,
        iconWidth: i.width
      })), n.push(l || i.icon), {
        children: n,
        attributes: r
      };
    };
  }
}, LT = {
  mixout() {
    return {
      layer(t) {
        let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          classes: n = []
        } = e;
        return _d({
          type: "layer"
        }, () => {
          to("beforeDOMElementCreation", {
            assembler: t,
            params: e
          });
          let r = [];
          return t((i) => {
            Array.isArray(i) ? i.map((s) => {
              r = r.concat(s.abstract);
            }) : r = r.concat(i.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(be.cssPrefix, "-layers"), ...n].join(" ")
            },
            children: r
          }];
        });
      }
    };
  }
}, NT = {
  mixout() {
    return {
      counter(t) {
        let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          title: n = null,
          classes: r = [],
          attributes: i = {},
          styles: s = {}
        } = e;
        return _d({
          type: "counter",
          content: t
        }, () => (to("beforeDOMElementCreation", {
          content: t,
          params: e
        }), pT({
          content: t.toString(),
          title: n,
          extra: {
            attributes: i,
            styles: s,
            classes: ["".concat(be.cssPrefix, "-layers-counter"), ...r]
          }
        })));
      }
    };
  }
}, IT = {
  mixout() {
    return {
      text(t) {
        let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          transform: n = Pr,
          title: r = null,
          classes: i = [],
          attributes: s = {},
          styles: o = {}
        } = e;
        return _d({
          type: "text",
          content: t
        }, () => (to("beforeDOMElementCreation", {
          content: t,
          params: e
        }), nb({
          content: t,
          transform: {
            ...Pr,
            ...n
          },
          title: r,
          extra: {
            attributes: s,
            styles: o,
            classes: ["".concat(be.cssPrefix, "-layers-text"), ...i]
          }
        })));
      }
    };
  },
  provides(t) {
    t.generateLayersText = function(e, n) {
      const {
        title: r,
        transform: i,
        extra: s
      } = n;
      let o = null, a = null;
      if (G_) {
        const l = parseInt(getComputedStyle(e).fontSize, 10), c = e.getBoundingClientRect();
        o = c.width / l, a = c.height / l;
      }
      return be.autoA11y && !r && (s.attributes["aria-hidden"] = "true"), Promise.resolve([e, nb({
        content: e.innerHTML,
        width: o,
        height: a,
        transform: i,
        title: r,
        extra: s,
        watchable: !0
      })]);
    };
  }
};
const RT = new RegExp('"', "ug"), cb = [1105920, 1112319], ub = {
  FontAwesome: {
    normal: "fas",
    400: "fas"
  },
  ...y7,
  ...v7,
  ...C7
}, fg = Object.keys(ub).reduce((t, e) => (t[e.toLowerCase()] = ub[e], t), {}), BT = Object.keys(fg).reduce((t, e) => {
  const n = fg[e];
  return t[e] = n[900] || [...Object.entries(n)][0][1], t;
}, {});
function FT(t) {
  const e = t.replace(RT, ""), n = X7(e, 0), r = n >= cb[0] && n <= cb[1], i = e.length === 2 ? e[0] === e[1] : !1;
  return {
    value: rg(i ? e[0] : e),
    isSecondary: r || i
  };
}
function zT(t, e) {
  const n = t.replace(/^['"]|['"]$/g, "").toLowerCase(), r = parseInt(e), i = isNaN(r) ? "normal" : r;
  return (fg[n] || {})[i] || BT[n];
}
function fb(t, e) {
  const n = "".concat(D7).concat(e.replace(":", "-"));
  return new Promise((r, i) => {
    if (t.getAttribute(n) !== null)
      return r();
    const o = za(t.children).filter((f) => f.getAttribute(Qm) === e)[0], a = os.getComputedStyle(t, e), l = a.getPropertyValue("font-family"), c = l.match(L7), u = a.getPropertyValue("font-weight"), h = a.getPropertyValue("content");
    if (o && !c)
      return t.removeChild(o), r();
    if (c && h !== "none" && h !== "") {
      const f = a.getPropertyValue("content");
      let d = zT(l, u);
      const {
        value: p,
        isSecondary: m
      } = FT(f), v = c[0].startsWith("FontAwesome");
      let g = Sv(d, p), y = g;
      if (v) {
        const x = rT(p);
        x.iconName && x.prefix && (g = x.iconName, d = x.prefix);
      }
      if (g && !m && (!o || o.getAttribute(bv) !== d || o.getAttribute(xv) !== y)) {
        t.setAttribute(n, y), o && t.removeChild(o);
        const x = AT(), {
          extra: b
        } = x;
        b.attributes[Qm] = e, lg(g, d).then((w) => {
          const k = Cv({
            ...x,
            icons: {
              main: w,
              mask: Mv()
            },
            prefix: d,
            iconName: y,
            extra: b,
            watchable: !0
          }), _ = Je.createElementNS("http://www.w3.org/2000/svg", "svg");
          e === "::before" ? t.insertBefore(_, t.firstChild) : t.appendChild(_), _.outerHTML = k.map((C) => Kc(C)).join(`
`), t.removeAttribute(n), r();
        }).catch(i);
      } else
        r();
    } else
      r();
  });
}
function VT(t) {
  return Promise.all([fb(t, "::before"), fb(t, "::after")]);
}
function HT(t) {
  return t.parentNode !== document.head && !~O7.indexOf(t.tagName.toUpperCase()) && !t.getAttribute(Qm) && (!t.parentNode || t.parentNode.tagName !== "svg");
}
function hb(t) {
  if (Ai)
    return new Promise((e, n) => {
      const r = za(t.querySelectorAll("*")).filter(HT).map(VT), i = $v.begin("searchPseudoElements");
      w3(), Promise.all(r).then(() => {
        i(), ug(), e();
      }).catch(() => {
        i(), ug(), n();
      });
    });
}
var YT = {
  hooks() {
    return {
      mutationObserverCallbacks(t) {
        return t.pseudoElementsCallback = hb, t;
      }
    };
  },
  provides(t) {
    t.pseudoElements2svg = function(e) {
      const {
        node: n = Je
      } = e;
      be.searchPseudoElements && hb(n);
    };
  }
};
let db = !1;
var WT = {
  mixout() {
    return {
      dom: {
        unwatch() {
          w3(), db = !0;
        }
      }
    };
  },
  hooks() {
    return {
      bootstrap() {
        ob(sg("mutationObserverCallbacks", {}));
      },
      noAuto() {
        ST();
      },
      watch(t) {
        const {
          observeMutationsRoot: e
        } = t;
        db ? ug() : ob(sg("mutationObserverCallbacks", {
          observeMutationsRoot: e
        }));
      }
    };
  }
};
const pb = (t) => {
  let e = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return t.toLowerCase().split(" ").reduce((n, r) => {
    const i = r.toLowerCase().split("-"), s = i[0];
    let o = i.slice(1).join("-");
    if (s && o === "h")
      return n.flipX = !0, n;
    if (s && o === "v")
      return n.flipY = !0, n;
    if (o = parseFloat(o), isNaN(o))
      return n;
    switch (s) {
      case "grow":
        n.size = n.size + o;
        break;
      case "shrink":
        n.size = n.size - o;
        break;
      case "left":
        n.x = n.x - o;
        break;
      case "right":
        n.x = n.x + o;
        break;
      case "up":
        n.y = n.y - o;
        break;
      case "down":
        n.y = n.y + o;
        break;
      case "rotate":
        n.rotate = n.rotate + o;
        break;
    }
    return n;
  }, e);
};
var jT = {
  mixout() {
    return {
      parse: {
        transform: (t) => pb(t)
      }
    };
  },
  hooks() {
    return {
      parseNodeAttributes(t, e) {
        const n = e.getAttribute("data-fa-transform");
        return n && (t.transform = pb(n)), t;
      }
    };
  },
  provides(t) {
    t.generateAbstractTransformGrouping = function(e) {
      let {
        main: n,
        transform: r,
        containerWidth: i,
        iconWidth: s
      } = e;
      const o = {
        transform: "translate(".concat(i / 2, " 256)")
      }, a = "translate(".concat(r.x * 32, ", ").concat(r.y * 32, ") "), l = "scale(".concat(r.size / 16 * (r.flipX ? -1 : 1), ", ").concat(r.size / 16 * (r.flipY ? -1 : 1), ") "), c = "rotate(".concat(r.rotate, " 0 0)"), u = {
        transform: "".concat(a, " ").concat(l, " ").concat(c)
      }, h = {
        transform: "translate(".concat(s / 2 * -1, " -256)")
      }, f = {
        outer: o,
        inner: u,
        path: h
      };
      return {
        tag: "g",
        attributes: {
          ...f.outer
        },
        children: [{
          tag: "g",
          attributes: {
            ...f.inner
          },
          children: [{
            tag: n.icon.tag,
            children: n.icon.children,
            attributes: {
              ...n.icon.attributes,
              ...f.path
            }
          }]
        }]
      };
    };
  }
};
const Np = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function mb(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return t.attributes && (t.attributes.fill || e) && (t.attributes.fill = "black"), t;
}
function qT(t) {
  return t.tag === "g" ? t.children : [t];
}
var UT = {
  hooks() {
    return {
      parseNodeAttributes(t, e) {
        const n = e.getAttribute("data-fa-mask"), r = n ? kd(n.split(" ").map((i) => i.trim())) : Mv();
        return r.prefix || (r.prefix = as()), t.mask = r, t.maskId = e.getAttribute("data-fa-mask-id"), t;
      }
    };
  },
  provides(t) {
    t.generateAbstractMask = function(e) {
      let {
        children: n,
        attributes: r,
        main: i,
        mask: s,
        maskId: o,
        transform: a
      } = e;
      const {
        width: l,
        icon: c
      } = i, {
        width: u,
        icon: h
      } = s, f = W7({
        transform: a,
        containerWidth: u,
        iconWidth: l
      }), d = {
        tag: "rect",
        attributes: {
          ...Np,
          fill: "white"
        }
      }, p = c.children ? {
        children: c.children.map(mb)
      } : {}, m = {
        tag: "g",
        attributes: {
          ...f.inner
        },
        children: [mb({
          tag: c.tag,
          attributes: {
            ...c.attributes,
            ...f.path
          },
          ...p
        })]
      }, v = {
        tag: "g",
        attributes: {
          ...f.outer
        },
        children: [m]
      }, g = "mask-".concat(o || fc()), y = "clip-".concat(o || fc()), x = {
        tag: "mask",
        attributes: {
          ...Np,
          id: g,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        },
        children: [d, v]
      }, b = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: y
          },
          children: qT(h)
        }, x]
      };
      return n.push(b, {
        tag: "rect",
        attributes: {
          fill: "currentColor",
          "clip-path": "url(#".concat(y, ")"),
          mask: "url(#".concat(g, ")"),
          ...Np
        }
      }), {
        children: n,
        attributes: r
      };
    };
  }
}, KT = {
  provides(t) {
    let e = !1;
    os.matchMedia && (e = os.matchMedia("(prefers-reduced-motion: reduce)").matches), t.missingIconAbstract = function() {
      const n = [], r = {
        fill: "currentColor"
      }, i = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      n.push({
        tag: "path",
        attributes: {
          ...r,
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        }
      });
      const s = {
        ...i,
        attributeName: "opacity"
      }, o = {
        tag: "circle",
        attributes: {
          ...r,
          cx: "256",
          cy: "364",
          r: "28"
        },
        children: []
      };
      return e || o.children.push({
        tag: "animate",
        attributes: {
          ...i,
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        }
      }, {
        tag: "animate",
        attributes: {
          ...s,
          values: "1;0;1;1;0;1;"
        }
      }), n.push(o), n.push({
        tag: "path",
        attributes: {
          ...r,
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        },
        children: e ? [] : [{
          tag: "animate",
          attributes: {
            ...s,
            values: "1;0;0;0;0;1;"
          }
        }]
      }), e || n.push({
        tag: "path",
        attributes: {
          ...r,
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        },
        children: [{
          tag: "animate",
          attributes: {
            ...s,
            values: "0;0;1;1;0;0;"
          }
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: n
      };
    };
  }
}, GT = {
  hooks() {
    return {
      parseNodeAttributes(t, e) {
        const n = e.getAttribute("data-fa-symbol"), r = n === null ? !1 : n === "" ? !0 : n;
        return t.symbol = r, t;
      }
    };
  }
}, XT = [U7, PT, LT, NT, IT, YT, WT, jT, UT, KT, GT];
aT(XT, {
  mixoutsTo: En
});
En.noAuto;
const _3 = En.config;
En.library;
En.dom;
const Zf = En.parse;
En.findIconDefinition;
En.toHtml;
const ZT = En.icon;
En.layer;
const JT = En.text;
En.counter;
function gb(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ar(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? gb(Object(n), !0).forEach(function(r) {
      sn(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : gb(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function QT(t, e) {
  if (typeof t != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e || "default");
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function eO(t) {
  var e = QT(t, "string");
  return typeof e == "symbol" ? e : e + "";
}
function Jf(t) {
  "@babel/helpers - typeof";
  return Jf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Jf(t);
}
function sn(t, e, n) {
  return e = eO(e), e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function tO(t, e) {
  if (t == null) return {};
  var n = {};
  for (var r in t)
    if (Object.prototype.hasOwnProperty.call(t, r)) {
      if (e.indexOf(r) >= 0) continue;
      n[r] = t[r];
    }
  return n;
}
function nO(t, e) {
  if (t == null) return {};
  var n = tO(t, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(t);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
  }
  return n;
}
function hg(t) {
  return rO(t) || iO(t) || sO(t) || oO();
}
function rO(t) {
  if (Array.isArray(t)) return dg(t);
}
function iO(t) {
  if (typeof Symbol != "undefined" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function sO(t, e) {
  if (t) {
    if (typeof t == "string") return dg(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set") return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return dg(t, e);
  }
}
function dg(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function oO() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var aO = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {}, S3 = { exports: {} };
(function(t) {
  (function(e) {
    var n = function(g, y, x) {
      if (!c(y) || h(y) || f(y) || d(y) || l(y))
        return y;
      var b, w = 0, k = 0;
      if (u(y))
        for (b = [], k = y.length; w < k; w++)
          b.push(n(g, y[w], x));
      else {
        b = {};
        for (var _ in y)
          Object.prototype.hasOwnProperty.call(y, _) && (b[g(_, x)] = n(g, y[_], x));
      }
      return b;
    }, r = function(g, y) {
      y = y || {};
      var x = y.separator || "_", b = y.split || /(?=[A-Z])/;
      return g.split(b).join(x);
    }, i = function(g) {
      return p(g) ? g : (g = g.replace(/[\-_\s]+(.)?/g, function(y, x) {
        return x ? x.toUpperCase() : "";
      }), g.substr(0, 1).toLowerCase() + g.substr(1));
    }, s = function(g) {
      var y = i(g);
      return y.substr(0, 1).toUpperCase() + y.substr(1);
    }, o = function(g, y) {
      return r(g, y).toLowerCase();
    }, a = Object.prototype.toString, l = function(g) {
      return typeof g == "function";
    }, c = function(g) {
      return g === Object(g);
    }, u = function(g) {
      return a.call(g) == "[object Array]";
    }, h = function(g) {
      return a.call(g) == "[object Date]";
    }, f = function(g) {
      return a.call(g) == "[object RegExp]";
    }, d = function(g) {
      return a.call(g) == "[object Boolean]";
    }, p = function(g) {
      return g = g - 0, g === g;
    }, m = function(g, y) {
      var x = y && "process" in y ? y.process : y;
      return typeof x != "function" ? g : function(b, w) {
        return x(b, g, w);
      };
    }, v = {
      camelize: i,
      decamelize: o,
      pascalize: s,
      depascalize: o,
      camelizeKeys: function(g, y) {
        return n(m(i, y), g);
      },
      decamelizeKeys: function(g, y) {
        return n(m(o, y), g, y);
      },
      pascalizeKeys: function(g, y) {
        return n(m(s, y), g);
      },
      depascalizeKeys: function() {
        return this.decamelizeKeys.apply(this, arguments);
      }
    };
    t.exports ? t.exports = v : e.humps = v;
  })(aO);
})(S3);
var lO = S3.exports, cO = ["class", "style"];
function uO(t) {
  return t.split(";").map(function(e) {
    return e.trim();
  }).filter(function(e) {
    return e;
  }).reduce(function(e, n) {
    var r = n.indexOf(":"), i = lO.camelize(n.slice(0, r)), s = n.slice(r + 1).trim();
    return e[i] = s, e;
  }, {});
}
function fO(t) {
  return t.split(/\s+/).reduce(function(e, n) {
    return e[n] = !0, e;
  }, {});
}
function Dv(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof t == "string")
    return t;
  var r = (t.children || []).map(function(l) {
    return Dv(l);
  }), i = Object.keys(t.attributes || {}).reduce(function(l, c) {
    var u = t.attributes[c];
    switch (c) {
      case "class":
        l.class = fO(u);
        break;
      case "style":
        l.style = uO(u);
        break;
      default:
        l.attrs[c] = u;
    }
    return l;
  }, {
    attrs: {},
    class: {},
    style: {}
  });
  n.class;
  var s = n.style, o = s === void 0 ? {} : s, a = nO(n, cO);
  return la(t.tag, ar(ar(ar({}, e), {}, {
    class: i.class,
    style: ar(ar({}, i.style), o)
  }, i.attrs), a), r);
}
var M3 = !1;
try {
  M3 = process.env.NODE_ENV === "production";
} catch (t) {
}
function hO() {
  if (!M3 && console && typeof console.error == "function") {
    var t;
    (t = console).error.apply(t, arguments);
  }
}
function Kl(t, e) {
  return Array.isArray(e) && e.length > 0 || !Array.isArray(e) && e ? sn({}, t, e) : {};
}
function dO(t) {
  var e, n = (e = {
    "fa-spin": t.spin,
    "fa-pulse": t.pulse,
    "fa-fw": t.fixedWidth,
    "fa-border": t.border,
    "fa-li": t.listItem,
    "fa-inverse": t.inverse,
    "fa-flip": t.flip === !0,
    "fa-flip-horizontal": t.flip === "horizontal" || t.flip === "both",
    "fa-flip-vertical": t.flip === "vertical" || t.flip === "both"
  }, sn(sn(sn(sn(sn(sn(sn(sn(sn(sn(e, "fa-".concat(t.size), t.size !== null), "fa-rotate-".concat(t.rotation), t.rotation !== null), "fa-pull-".concat(t.pull), t.pull !== null), "fa-swap-opacity", t.swapOpacity), "fa-bounce", t.bounce), "fa-shake", t.shake), "fa-beat", t.beat), "fa-fade", t.fade), "fa-beat-fade", t.beatFade), "fa-flash", t.flash), sn(sn(e, "fa-spin-pulse", t.spinPulse), "fa-spin-reverse", t.spinReverse));
  return Object.keys(n).map(function(r) {
    return n[r] ? r : null;
  }).filter(function(r) {
    return r;
  });
}
function vb(t) {
  if (t && Jf(t) === "object" && t.prefix && t.iconName && t.icon)
    return t;
  if (Zf.icon)
    return Zf.icon(t);
  if (t === null)
    return null;
  if (Jf(t) === "object" && t.prefix && t.iconName)
    return t;
  if (Array.isArray(t) && t.length === 2)
    return {
      prefix: t[0],
      iconName: t[1]
    };
  if (typeof t == "string")
    return {
      prefix: "fas",
      iconName: t
    };
}
var rt = oe({
  name: "FontAwesomeIcon",
  props: {
    border: {
      type: Boolean,
      default: !1
    },
    fixedWidth: {
      type: Boolean,
      default: !1
    },
    flip: {
      type: [Boolean, String],
      default: !1,
      validator: function(e) {
        return [!0, !1, "horizontal", "vertical", "both"].indexOf(e) > -1;
      }
    },
    icon: {
      type: [Object, Array, String],
      required: !0
    },
    mask: {
      type: [Object, Array, String],
      default: null
    },
    maskId: {
      type: String,
      default: null
    },
    listItem: {
      type: Boolean,
      default: !1
    },
    pull: {
      type: String,
      default: null,
      validator: function(e) {
        return ["right", "left"].indexOf(e) > -1;
      }
    },
    pulse: {
      type: Boolean,
      default: !1
    },
    rotation: {
      type: [String, Number],
      default: null,
      validator: function(e) {
        return [90, 180, 270].indexOf(Number.parseInt(e, 10)) > -1;
      }
    },
    swapOpacity: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: null,
      validator: function(e) {
        return ["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"].indexOf(e) > -1;
      }
    },
    spin: {
      type: Boolean,
      default: !1
    },
    transform: {
      type: [String, Object],
      default: null
    },
    symbol: {
      type: [Boolean, String],
      default: !1
    },
    title: {
      type: String,
      default: null
    },
    titleId: {
      type: String,
      default: null
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    bounce: {
      type: Boolean,
      default: !1
    },
    shake: {
      type: Boolean,
      default: !1
    },
    beat: {
      type: Boolean,
      default: !1
    },
    fade: {
      type: Boolean,
      default: !1
    },
    beatFade: {
      type: Boolean,
      default: !1
    },
    flash: {
      type: Boolean,
      default: !1
    },
    spinPulse: {
      type: Boolean,
      default: !1
    },
    spinReverse: {
      type: Boolean,
      default: !1
    }
  },
  setup: function(e, n) {
    var r = n.attrs, i = T(function() {
      return vb(e.icon);
    }), s = T(function() {
      return Kl("classes", dO(e));
    }), o = T(function() {
      return Kl("transform", typeof e.transform == "string" ? Zf.transform(e.transform) : e.transform);
    }), a = T(function() {
      return Kl("mask", vb(e.mask));
    }), l = T(function() {
      return ZT(i.value, ar(ar(ar(ar({}, s.value), o.value), a.value), {}, {
        symbol: e.symbol,
        title: e.title,
        titleId: e.titleId,
        maskId: e.maskId
      }));
    });
    Se(l, function(u) {
      if (!u)
        return hO("Could not find one or more icon(s)", i.value, a.value);
    }, {
      immediate: !0
    });
    var c = T(function() {
      return l.value ? Dv(l.value.abstract[0], {}, r) : null;
    });
    return function() {
      return c.value;
    };
  }
});
oe({
  name: "FontAwesomeLayers",
  props: {
    fixedWidth: {
      type: Boolean,
      default: !1
    }
  },
  setup: function(e, n) {
    var r = n.slots, i = _3.familyPrefix, s = T(function() {
      return ["".concat(i, "-layers")].concat(hg(e.fixedWidth ? ["".concat(i, "-fw")] : []));
    });
    return function() {
      return la("div", {
        class: s.value
      }, r.default ? r.default() : []);
    };
  }
});
oe({
  name: "FontAwesomeLayersText",
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    transform: {
      type: [String, Object],
      default: null
    },
    counter: {
      type: Boolean,
      default: !1
    },
    position: {
      type: String,
      default: null,
      validator: function(e) {
        return ["bottom-left", "bottom-right", "top-left", "top-right"].indexOf(e) > -1;
      }
    }
  },
  setup: function(e, n) {
    var r = n.attrs, i = _3.familyPrefix, s = T(function() {
      return Kl("classes", [].concat(hg(e.counter ? ["".concat(i, "-layers-counter")] : []), hg(e.position ? ["".concat(i, "-layers-").concat(e.position)] : [])));
    }), o = T(function() {
      return Kl("transform", typeof e.transform == "string" ? Zf.transform(e.transform) : e.transform);
    }), a = T(function() {
      var c = JT(e.value.toString(), ar(ar({}, o.value), s.value)), u = c.abstract;
      return e.counter && (u[0].attributes.class = u[0].attributes.class.replace("fa-layers-text", "")), u[0];
    }), l = T(function() {
      return Dv(a.value, {}, r);
    });
    return function() {
      return l.value;
    };
  }
});
const yb = {
  prefix: "fas",
  iconName: "circle-minus",
  icon: [512, 512, ["minus-circle"], "f056", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
}, pO = {
  prefix: "fas",
  iconName: "bars",
  icon: [448, 512, ["navicon"], "f0c9", "M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"]
}, mO = {
  prefix: "fas",
  iconName: "circle-exclamation",
  icon: [512, 512, ["exclamation-circle"], "f06a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
}, gO = {
  prefix: "fas",
  iconName: "eye-slash",
  icon: [640, 512, [], "f070", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z"]
}, vO = {
  prefix: "fas",
  iconName: "chevron-up",
  icon: [512, 512, [], "f077", "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"]
}, C3 = {
  prefix: "fas",
  iconName: "caret-up",
  icon: [320, 512, [], "f0d8", "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"]
}, $3 = {
  prefix: "fas",
  iconName: "arrow-right",
  icon: [448, 512, [8594], "f061", "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"]
}, yO = {
  prefix: "fas",
  iconName: "circle-question",
  icon: [512, 512, [62108, "question-circle"], "f059", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
}, bO = {
  prefix: "fas",
  iconName: "eye",
  icon: [576, 512, [128065], "f06e", "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"]
}, A3 = {
  prefix: "fas",
  iconName: "caret-down",
  icon: [320, 512, [], "f0d7", "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"]
}, Tv = {
  prefix: "fas",
  iconName: "angle-down",
  icon: [448, 512, [8964], "f107", "M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"]
}, xO = {
  prefix: "fas",
  iconName: "magnifying-glass",
  icon: [512, 512, [128269, "search"], "f002", "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
}, D3 = {
  prefix: "fas",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"]
}, T3 = {
  prefix: "fas",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"]
}, O3 = {
  prefix: "fas",
  iconName: "angle-up",
  icon: [448, 512, [8963], "f106", "M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z"]
}, wO = {
  prefix: "fas",
  iconName: "calendar",
  icon: [448, 512, [128197, 128198], "f133", "M96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192L0 192 0 464c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-272z"]
}, kO = {
  prefix: "fas",
  iconName: "check",
  icon: [448, 512, [10003, 10004], "f00c", "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"]
}, _O = {
  prefix: "fas",
  iconName: "circle-xmark",
  icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
}, SO = _O, MO = { class: "vx-flex" }, Ege = /* @__PURE__ */ oe({
  __name: "vx-alert",
  props: {
    color: {
      type: String,
      default: "primary"
    },
    visible: {
      type: Boolean,
      required: !1,
      default: !0
    },
    closeable: {
      type: Boolean,
      required: !1,
      default: !0
    },
    bordered: {
      type: Boolean,
      required: !1,
      default: !1
    },
    shadow: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: ["update:visible"],
  setup(t, { emit: e }) {
    const n = t, r = e, i = le(n.visible);
    Se(
      () => n.visible,
      (a) => {
        i.value = a;
      }
    );
    const s = () => {
      i.value = !1, r("update:visible", i.value);
    }, o = T(() => {
      const a = {
        elementBorder: "vx-border-sky-300",
        element: ["vx-bg-sky-100"],
        text: ["vx-text-sky-950"],
        icon: ["vx-text-sky-500"]
      };
      return n.color === "primary" ? a : n.color === "danger" ? {
        elementBorder: "vx-border-rose-300",
        element: ["vx-bg-rose-100"],
        text: ["vx-text-rose-950"],
        icon: ["vx-text-rose-500"]
      } : n.color === "info" ? {
        elementBorder: "vx-border-amber-300",
        element: ["vx-bg-amber-100"],
        text: ["vx-text-amber-950"],
        icon: ["vx-text-amber-500"]
      } : n.color === "success" ? {
        elementBorder: "vx-border-teal-300",
        element: ["vx-bg-teal-100"],
        text: ["vx-text-teal-950"],
        icon: ["vx-text-teal-500"]
      } : n.color === "slate" ? {
        elementBorder: "vx-border-slate-300",
        element: ["vx-bg-slate-100"],
        text: ["vx-text-slate-950"],
        icon: ["vx-text-slate-500"]
      } : n.color === "violet" ? {
        elementBorder: "vx-border-violet-300",
        element: ["vx-bg-violet-100"],
        text: ["vx-text-violet-900"],
        icon: ["vx-text-violet-500"]
      } : a;
    });
    return (a, l) => i.value ? (S(), D("div", {
      key: 0,
      class: j(["vx-alert vx-rounded-2xl vx-px-5 vx-py-4 vx-w-full", [
        o.value.element,
        {
          "vx-border vx-border-solid": n.bordered,
          [o.value.elementBorder]: n.bordered,
          "vx-shadow": n.shadow
        }
      ]]),
      role: "alert"
    }, [
      B("div", MO, [
        B("div", {
          class: j(["vx-self-center", o.value.icon])
        }, [
          H(a.$slots, "icon", {}, () => [
            re(P(rt), { icon: P(mO) }, null, 8, ["icon"])
          ])
        ], 2),
        B("div", {
          class: j(["vx-text-sm vx-font-normal vx-flex-grow vx-self-center vx-pl-3", [o.value.text, {
            "vx-pr-4 lg:vx-pr-8": n.closeable
          }]])
        }, [
          H(a.$slots, "default")
        ], 2),
        n.closeable ? (S(), D("button", {
          key: 0,
          onClick: s,
          role: "button",
          class: j([
            "vx-self-start vx-bg-transparent vx-appearance-none vx-border-0 vx-text-inherit"
          ])
        }, [
          re(P(rt), {
            icon: P(T3),
            role: "button"
          }, null, 8, ["icon"])
        ])) : Z("", !0)
      ])
    ], 2)) : Z("", !0);
  }
}), CO = /* @__PURE__ */ oe({
  __name: "vx-badge",
  props: {
    borders: {
      type: Boolean,
      required: !1,
      default: !0
    },
    color: {
      type: String,
      required: !1,
      default: "primary"
    },
    size: {
      type: String,
      required: !1,
      default: "md"
    }
  },
  setup(t) {
    const e = t, n = T(() => {
      const i = ["vx-bg-sky-100", "vx-text-sky-900", "vx-border-sky-300"];
      return e.color === "primary" ? i : e.color === "info" ? ["vx-bg-amber-300", "vx-text-amber-900", "vx-border-amber-500"] : e.color === "success" || e.color === "teal" ? ["vx-bg-teal-100", "vx-text-teal-900", "vx-border-teal-300"] : e.color === "neutral" ? ["vx-bg-blue-100", "vx-text-blue-900", "vx-border-blue-300"] : e.color === "purple" ? ["vx-bg-purple-300", "vx-text-purple-900", "vx-border-purple-500"] : e.color === "danger" || e.color === "rose" ? ["vx-bg-rose-100", "vx-text-rose-900", "vx-border-rose-300"] : e.color === "violet" ? ["vx-bg-violet-100", "vx-text-violet-900", "vx-border-violet-300"] : e.color === "amber" ? ["vx-bg-amber-100", "vx-text-amber-900", "vx-border-amber-300"] : e.color === "fuchsia" ? ["vx-bg-fuchsia-100", "vx-text-fuchsia-900", "vx-border-fuchsia-300"] : e.color === "orange" ? ["vx-bg-orange-100", "vx-text-orange-900", "vx-border-orange-300"] : e.color === "slate" ? ["vx-bg-slate-100", "vx-text-slate-900", "vx-border-slate-300"] : i;
    }), r = T(() => e.size === "xs" ? ["vx-px-2", "vx-h-5", "vx-text-xs"] : e.size === "sm" ? ["vx-px-3", "vx-h-6", "vx-text-xs"] : e.size === "lg" ? ["vx-px-4", "vx-h-8", "vx-text-sm"] : e.size === "xl" ? ["vx-px-5", "vx-h-9", "vx-text-base"] : ["vx-px-3", "vx-h-7", "vx-text-xs"]);
    return (i, s) => (S(), D("div", {
      class: j(["vx-inline-flex vx-items-center vx-rounded-full vx-font-medium vx-gap-[0.375rem]", [
        {
          "vx-border": e.borders,
          "vx-border-solid": e.borders,
          [`vx-badge-${e.size}`]: !0
        },
        n.value,
        r.value
      ]])
    }, [
      H(i.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), jt = (t, e) => {
  const n = t.__vccOpts || t;
  for (const [r, i] of e)
    n[r] = i;
  return n;
}, Pge = /* @__PURE__ */ jt(CO, [["__scopeId", "data-v-b99f471f"]]), E3 = /* @__PURE__ */ oe({
  __name: "vx-box",
  props: {
    color: {
      type: String,
      required: !1,
      default: "white"
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  setup(t, { expose: e }) {
    const n = t, r = T(() => {
      let o = [];
      return n.color === "info" ? o = [...o, "vx-bg-slate-100", "vx-border-white"] : o = [...o, "vx-bg-white", "vx-border-white"], n.disabled && (o = [...o, "vx-border-opacity-40", "vx-bg-opacity-40"]), o;
    }), i = le(null);
    return e({ getBoxElement: () => i.value }), (o, a) => (S(), D("div", {
      class: j(["vx-rounded-2xl vx-border vx-border-solid vx-shadow vx-transition", [r.value]]),
      ref_key: "box",
      ref: i
    }, [
      H(o.$slots, "default")
    ], 2));
  }
}), $O = { class: "vx-flex vx-items-stretch vx-pb-10 vx-pr-10 vx-border-red-400" }, AO = { class: "vx-relative vx-flex vx-w-full" }, DO = { class: "vx-w-full vx-rounded-2xl vx-bg-white vx-shadow-xl vx-shadow-sky-800/10 vx-overflow-hidden vx-relative after:vx-absolute after:vx-inset-0 after:vx-rounded-2xl after:vx-border after:vx-border-white/80 after:vx-pointer-events-none" }, TO = /* @__PURE__ */ B("div", { class: "vx-pointer-events-none vx-absolute vx-inset-0 -vx-z-10 vx-translate-x-5 vx-translate-y-5 vx-rounded-2xl vx-border vx-border-solid vx-border-white/60 vx-bg-white/30 vx-bg-[url('/noise.png')] vx-bg-[length:100px] vx-shadow-xl vx-shadow-sky-800/10 vx-backdrop-blur vx-transition vx-duration-300" }, null, -1), Lge = /* @__PURE__ */ oe({
  __name: "vx-box-glass",
  props: { active: { type: Boolean } },
  setup(t) {
    const e = t;
    return (n, r) => (S(), D("div", $O, [
      B("div", AO, [
        B("div", DO, [
          H(n.$slots, "default")
        ]),
        TO,
        B("div", {
          class: j(["vx-pointer-events-none vx-absolute vx-inset-0 -vx-z-20 vx-translate-x-10 vx-translate-y-10 vx-rounded-2xl vx-transition vx-duration-700", {
            "vx-bg-slate-300": !e.active,
            "vx-bg-sky-300": e.active
          }])
        }, null, 2)
      ])
    ]));
  }
}), OO = {}, EO = {
  "aria-hidden": "true",
  class: "vx-absolute vx-inset-0 -vx-z-40 vx-rounded-[inherit] vx-duration-200 group-active/btn:vx-scale-90 group-active/btn:!vx-opacity-30"
};
function PO(t, e) {
  return S(), D("div", EO);
}
const LO = /* @__PURE__ */ jt(OO, [["render", PO]]), NO = {}, IO = {
  "aria-hidden": "true",
  class: "vx-absolute vx-inset-0 -vx-z-30 vx-rounded-[inherit] vx-border vx-border-solid vx-duration-200 group-active/btn:vx-scale-90"
};
function RO(t, e) {
  return S(), D("div", IO);
}
const BO = /* @__PURE__ */ jt(NO, [["render", RO]]), FO = {};
function zO(t, e) {
  return S(), D("div", null, [
    H(t.$slots, "default")
  ]);
}
const VO = /* @__PURE__ */ jt(FO, [["render", zO]]), HO = {}, YO = {
  "aria-hidden": "true",
  class: "vx-absolute vx-inset-0 vx-rounded-[inherit] vx-border vx-border-white/50 vx-bg-white/30 vx-bg-[url('assets/noise.png')] vx-bg-[length:100px] vx-opacity-0 vx-shadow-lg vx-backdrop-blur vx-transition vx-ease-out group-focus-visible/btn:-vx-translate-y-[4%] group-active/btn:vx-scale-90 mouse:group-hover/btn:-vx-translate-y-[7%] mouse:group-hover/btn:vx-opacity-100 mouse:group-active/btn:vx-translate-y-0 mouse:group-active/btn:vx-bg-white/10"
};
function WO(t, e) {
  return S(), D("div", YO);
}
const jO = /* @__PURE__ */ jt(HO, [["render", WO]]), qO = /* @__PURE__ */ oe({
  __name: "vx-button-loader",
  props: {
    loading: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = t;
    return (n, r) => (S(), D("div", {
      class: j([
        "vx-absolute vx-left-1/2 vx-inline-flex -vx-translate-x-1/2 vx-gap-1.5 vx-text-sm vx-transition",
        e.loading ? "vx-delay-150 vx-duration-500 vx-ease-[cubic-bezier(0,2,.3,1)]" : "vx-opacity-0 motion-safe:vx-scale-0"
      ])
    }, [
      H(n.$slots, "default")
    ], 2));
  }
}), UO = /* @__PURE__ */ z_('<path d="M18 2C18 0.9375 17.0625 0 16 0C14.875 0 14 0.9375 14 2V6C14 7.125 14.875 8 16 8C17.0625 8 18 7.125 18 6V2Z" class="vx-fill-sky-900"></path><path d="M21.625 10.375C20.875 9.5625 20.875 8.3125 21.625 7.5625L24.4375 4.6875C25.25 3.9375 26.5 3.9375 27.3125 4.6875C28.0625 5.5 28.0625 6.75 27.3125 7.5625L24.4375 10.375C23.6875 11.125 22.4375 11.125 21.625 10.375Z" class="vx-fill-sky-900/90"></path><path d="M24 16C24 14.9375 24.875 14 26 14H30C31.0625 14 32 14.9375 32 16C32 17.125 31.0625 18 30 18H26C24.875 18 24 17.125 24 16Z" class="vx-fill-sky-900/70"></path><path d="M21.625 21.6875C22.4375 20.875 23.6875 20.875 24.4375 21.6875L27.3125 24.5C28.0625 25.3125 28.0625 26.5625 27.3125 27.3125C26.5 28.125 25.25 28.125 24.4375 27.3125L21.625 24.5C20.875 23.75 20.875 22.4375 21.625 21.6875Z" class="vx-fill-sky-900/60"></path><path d="M16 24C17.0625 24 18 24.9375 18 26V30C18 31.125 17.0625 32 16 32C14.875 32 14 31.125 14 30V26C14 24.9375 14.875 24 16 24Z" class="vx-fill-sky-900/50"></path><path d="M4.6875 27.3125C5.4375 28.125 6.6875 28.125 7.5 27.3125L10.3125 24.5C11.125 23.75 11.125 22.4375 10.3125 21.6875C9.5625 20.875 8.25 20.875 7.5 21.6875L4.6875 24.5C3.875 25.3125 3.875 26.5625 4.6875 27.375V27.3125Z" class="vx-fill-sky-900/40"></path><path d="M0 16C0 17.125 0.875 18 2 18H6C7.0625 18 8 17.125 8 16C8 14.9375 7.0625 14 6 14H2C0.875 14 0 14.9375 0 16Z" class="vx-fill-sky-900/20"></path><path d="M4.6875 4.6875C3.875 5.5 3.875 6.75 4.6875 7.5625L7.5 10.375C8.25 11.1875 9.5625 11.1875 10.3125 10.375C11.125 9.625 11.125 8.3125 10.3125 7.5625L7.5 4.6875C6.6875 3.9375 5.4375 3.9375 4.6875 4.6875Z" class="vx-fill-sky-900/20"></path>', 8), KO = [
  UO
], Ov = /* @__PURE__ */ oe({
  __name: "vx-icon-loading",
  props: {
    spin: Boolean
  },
  setup(t) {
    const e = t;
    return (n, r) => (S(), D("svg", {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      class: j(["vx-h-auto vx-w-4", {
        "vx-animate-loading-spin": e.spin
      }]),
      xmlns: "http://www.w3.org/2000/svg"
    }, KO, 2));
  }
}), cs = /* @__PURE__ */ oe({
  __name: "vx-button",
  props: {
    href: {
      type: String,
      required: !1
    },
    size: {
      type: String,
      default: "md"
    },
    color: {
      type: String,
      default: "primary"
    },
    outline: {
      type: Boolean,
      default: !1
    },
    shadow: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    block: {
      type: Boolean,
      default: !1
    },
    fancy: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = t, n = T(() => e.href ? "a" : "button"), r = T(() => e.outline ? {
      background: ["vx-opacity-0", "mouse:group-hover/btn:vx-opacity-10"],
      border: ["vx-opacity-100"]
    } : {
      background: ["vx-opacity-100"],
      border: ["vx-opacity-100"]
    }), i = T(() => e.fancy ? {
      element: [""],
      background: [
        "vx-origin-center",
        "vx-transition",
        "vx-ease-out",
        "group-focus-visible/btn:group-active/btn:vx-opacity-30",
        "mouse:group-hover/btn:vx-translate-y-[10%]",
        "mouse:group-hover/btn:vx-scale-[0.85]",
        "mouse:group-active/btn:vx-translate-y-[4%]",
        "touch:group-active/btn:vx-scale-90",
        "touch:group-active/btn:vx-opacity-70"
      ],
      border: [
        "vx-origin-center",
        "vx-transition",
        "vx-ease-out",
        "group-active/btn:vx-opacity-30",
        "mouse:group-hover/btn:vx-translate-y-[10%]",
        "mouse:group-hover/btn:vx-scale-[0.85]",
        "mouse:group-active/btn:vx-translate-y-[4%]",
        "touch:group-active/btn:vx-scale-90"
      ],
      content: [
        "vx-relative",
        "vx-z-10",
        "vx-transition",
        "vx-ease-out",
        "vx-will-change-transform",
        "group-active/btn:vx-scale-90",
        "mouse:group-hover/btn:-vx-translate-y-[15%]",
        "mouse:group-active/btn:vx-translate-y-0"
      ]
    } : {
      element: {
        "vx-shadow mouse:hover:vx-shadow-md": e.shadow
      },
      background: [],
      border: [],
      content: []
    }), s = T(() => {
      const l = {
        element: ["vx-rounded-lg", "vx-px-4", "vx-text-xs", "vx-h-10"],
        content: ["vx-gap-2"]
      };
      return e.size === "xs" ? {
        element: ["vx-rounded", "vx-px-2", "vx-text-xs", "vx-h-6"],
        content: ["vx-gap-1"]
      } : e.size === "sm" ? {
        element: ["vx-rounded-md", "vx-px-3", "vx-text-xs", "vx-h-8"],
        content: ["vx-gap-1.5"]
      } : e.size === "md" ? l : e.size === "lg" ? {
        element: ["vx-rounded-xl", "vx-px-5", "vx-text-sm", "vx-h-12"],
        content: ["vx-gap-2"]
      } : e.size === "xl" ? {
        element: ["vx-rounded-2xl", "vx-px-8", "vx-text-sm", "vx-h-16"],
        content: ["vx-gap-2"]
      } : l;
    }), o = T(() => {
      const l = {
        element: ["vx-text-black", "hover:vx-text-black"],
        background: ["vx-bg-sky-300", "mouse:group-hover/btn:vx-bg-sky-400"],
        border: ["vx-border-sky-300"]
      };
      return e.color === "primary" ? l : e.color === "secondary" ? {
        element: [
          e.outline ? "vx-text-black hover:vx-text-black" : "vx-text-white hover:vx-text-white"
        ],
        background: ["vx-bg-slate-600", "mouse:group-hover/btn:vx-bg-slate-700"],
        border: ["vx-border-slate-600"]
      } : e.color === "muted-dark" ? {
        element: ["vx-text-black", "hover:vx-text-black"],
        background: ["vx-bg-slate-300", "mouse:group-hover/btn:vx-bg-slate-400"],
        border: ["vx-border-slate-300"]
      } : e.color === "muted" ? {
        element: ["vx-text-black", "hover:vx-text-black"],
        background: ["vx-bg-slate-200", "mouse:group-hover/btn:vx-bg-slate-300"],
        border: ["vx-border-slate-200"]
      } : e.color === "muted-light" ? {
        element: ["vx-text-black", "hover:vx-text-black"],
        background: ["vx-bg-slate-100", "mouse:group-hover/btn:vx-bg-slate-200"],
        border: ["vx-border-slate-100"]
      } : e.color === "white" ? {
        element: ["vx-text-black", "hover:vx-text-black"],
        background: ["vx-bg-white", "mouse:group-hover/btn:vx-bg-slate-50"],
        border: ["vx-border-white"]
      } : e.color === "transparent" ? {
        element: ["vx-text-black", "hover:vx-text-black"],
        background: ["vx-bg-transparent", "mouse:group-hover/btn:vx-bg-slate-100"],
        border: ["vx-border-transparent"]
      } : e.color === "info" ? {
        element: ["vx-text-slate-800", "hover:vx-text-slate-800"],
        background: ["vx-bg-amber-300", "mouse:group-hover/btn:vx-bg-amber-400"],
        border: ["vx-border-amber-300"]
      } : e.color === "success" ? {
        element: ["vx-text-black", "hover:vx-text-black"],
        background: ["vx-bg-teal-300", "mouse:group-hover/btn:vx-bg-teal-400"],
        border: ["vx-border-teal-300"]
      } : e.color === "danger" ? {
        element: ["vx-text-black", "hover:vx-text-black"],
        background: ["vx-bg-rose-300", "mouse:group-hover/btn:vx-bg-rose-400"],
        border: ["vx-border-rose-300"]
      } : l;
    }), a = T(() => e.block ? {
      element: ["vx-w-full", "vx-flex"]
    } : {
      element: ["vx-inline-flex"]
    });
    return (l, c) => (S(), ye(ht(n.value), {
      href: e.href,
      disabled: e.disabled,
      class: j(["vx-group/btn vx-font-sans vx-relative vx-z-0 vx-font-semibold vx-outline-none vx-transition-all vx-no-tap focus-visible:vx-outline focus-visible:vx-outline-2 focus-visible:vx-outline-offset-4 focus-visible:vx-outline-blue-600 active:vx-outline-none vx-items-center disabled:vx-opacity-50 disabled:vx-pointer-events-none vx-justify-center hover:vx-no-underline vx-bg-transparent vx-text-center vx-will-change-transform", [
        o.value.element,
        s.value.element,
        i.value.element,
        a.value.element,
        {
          "vx-opacity-50 vx-pointer-events-none": e.disabled && e.href
        }
      ]])
    }, {
      default: G(() => [
        re(LO, {
          class: j([
            o.value.background,
            r.value.background,
            i.value.background
          ])
        }, null, 8, ["class"]),
        re(BO, {
          class: j([
            o.value.border,
            r.value.border,
            i.value.border
          ])
        }, null, 8, ["class"]),
        t.fancy ? (S(), ye(jO, { key: 0 })) : Z("", !0),
        re(VO, {
          class: j([i.value.content])
        }, {
          default: G(() => [
            B("div", {
              class: j(["vx-flex vx-items-center vx-justify-center vx-whitespace-nowrap vx-transition", [
                s.value.content,
                {
                  "vx-opacity-0 vx-ease-in motion-safe:vx-scale-0": e.loading,
                  "vx-duration-700 vx-ease-[cubic-bezier(0,1.3,.3,1)]": !e.loading
                }
              ]])
            }, [
              H(l.$slots, "default")
            ], 2)
          ]),
          _: 3
        }, 8, ["class"]),
        re(qO, {
          loading: e.loading
        }, {
          default: G(() => [
            re(Ov, { spin: "" })
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 3
    }, 8, ["href", "disabled", "class"]));
  }
}), GO = { class: "vx-inline-flex vx-items-center vx-space-x-[1px]" }, Nge = /* @__PURE__ */ oe({
  __name: "vx-button-group",
  props: {
    size: {
      type: String,
      default: "lg"
    }
  },
  setup(t) {
    const e = t, n = xs(), r = T(
      () => n.default ? n.default() : []
    );
    return (i, s) => (S(), D("div", GO, [
      (S(!0), D(_e, null, Fe(r.value, (o, a) => (S(), ye(ht(o), {
        key: `group-button-${a}`,
        class: j({
          "!vx-rounded-r-none": a === 0,
          "!vx-rounded-l-none": a === r.value.length - 1,
          "!vx-rounded-none": a !== 0 && a !== r.value.length - 1
        }),
        size: e.size
      }, null, 8, ["class", "size"]))), 128))
    ]));
  }
}), XO = { class: "" }, ZO = { class: "vx-w-full vx-flex vx-gap-0.5 vx-overflow-hidden vx-h-1 vx-rounded-sm" }, JO = /* @__PURE__ */ B("div", { class: "vx-bg-slate-500/20 vx-grow" }, null, -1), QO = { class: "vx-text-slate-500 vx-mt-1 vx-text-xs" }, e9 = /* @__PURE__ */ oe({
  __name: "vx-char-counter",
  props: {
    characters: {
      type: String,
      required: !0
    },
    max: {
      type: Number,
      required: !0
    },
    min: {
      type: Number
    },
    minWarning: {
      type: Number
    },
    maxWarning: {
      type: Number
    }
  },
  setup(t) {
    const e = t, n = T(() => Intl.NumberFormat("en").format(e.max)), r = T(() => Intl.NumberFormat("en").format(e.characters.length)), i = T(() => Math.ceil(e.characters.length / e.max * 100)), s = T(() => {
      if (e.characters.length === 0)
        return !1;
      const a = e.maxWarning || e.max * 0.9;
      return !!(e.characters.length > a || e.minWarning && e.characters.length < e.minWarning);
    }), o = T(() => e.characters.length === 0 ? !1 : !!(e.characters.length > e.max || e.min && e.characters.length < e.min));
    return (a, l) => (S(), D("div", XO, [
      B("div", ZO, [
        B("div", {
          class: j(["vx-h-1 vx-min-w-[4px] vx-shrink-0", {
            "vx-bg-slate-500": !o.value && !s.value,
            "vx-bg-amber-500": !o.value && s.value,
            "vx-bg-rose-500": o.value
          }]),
          style: yt({
            width: `${i.value}%`
          }),
          "data-test": "bar"
        }, null, 6),
        JO
      ]),
      B("div", QO, [
        B("span", {
          class: j({
            "vx-text-rose-800": o.value
          })
        }, Pe(r.value), 3),
        ft(" of " + Pe(n.value) + " characters ", 1)
      ])
    ]));
  }
}), t9 = { class: "vx-pointer-events-none vx-absolute vx-inset-x-5 vx-bottom-5 vx-overflow-clip -vx-m-5" }, n9 = /* @__PURE__ */ oe({
  __name: "vx-chart-container-skeleton",
  props: {
    loading: {
      type: Boolean,
      default: !1
    },
    hasData: {
      type: Boolean,
      default: !0
    },
    error: {
      type: Boolean,
      default: !0
    }
  },
  setup(t) {
    const e = t;
    return (n, r) => (S(), D("div", t9, [
      B("div", {
        class: j(["vx-flex vx-gap-1.5 vx-transition vx-duration-500 vx-ease-out", {
          "vx-opacity-0": e.hasData && !e.loading && !e.error
        }])
      }, [
        (S(), D(_e, null, Fe(96, (i) => B("div", {
          key: i,
          class: j(["vx-flex vx-h-14 vx-min-w-[8px] vx-origin-bottom vx-rounded-t-full vx-transition vx-duration-300 vx-will-change-transform", [
            i % 7 ? i % 3 ? "vx-translate-y-8" : "vx-translate-y-4" : "",
            e.loading ? "vx-bg-sky-200" : "vx-bg-slate-200",
            e.loading && "motion-safe:vx-animate-[pulse_1.3s_infinite]",
            e.hasData && !e.loading && !e.error && "!vx-translate-y-full"
          ]]),
          style: yt(
            i % 7 ? i % 5 ? "animation-delay: 0s" : "animation-delay: .2s" : "animation-delay: .4s"
          )
        }, null, 6)), 64))
      ], 2)
    ]));
  }
});
function Ev(t) {
  return s7() ? (o7(t), !0) : !1;
}
function Ks(t) {
  return typeof t == "function" ? t() : P(t);
}
const Pv = typeof window != "undefined" && typeof document != "undefined";
typeof WorkerGlobalScope != "undefined" && globalThis instanceof WorkerGlobalScope;
const r9 = Object.prototype.toString, P3 = (t) => r9.call(t) === "[object Object]", pi = () => {
}, Qf = /* @__PURE__ */ i9();
function i9() {
  var t, e;
  return Pv && ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
const bb = {
  mounted: "mounted",
  updated: "updated",
  unmounted: "unmounted"
};
function s9(...t) {
  if (t.length !== 1)
    return jl(...t);
  const e = t[0];
  return typeof e == "function" ? a7(l7(() => ({ get: e, set: pi }))) : le(e);
}
function Cl(t) {
  var e;
  const n = Ks(t);
  return (e = n == null ? void 0 : n.$el) != null ? e : n;
}
const L3 = Pv ? window : void 0;
function Xo(...t) {
  let e, n, r, i;
  if (typeof t[0] == "string" || Array.isArray(t[0]) ? ([n, r, i] = t, e = L3) : [e, n, r, i] = t, !e)
    return pi;
  Array.isArray(n) || (n = [n]), Array.isArray(r) || (r = [r]);
  const s = [], o = () => {
    s.forEach((u) => u()), s.length = 0;
  }, a = (u, h, f, d) => (u.addEventListener(h, f, d), () => u.removeEventListener(h, f, d)), l = Se(
    () => [Cl(e), Ks(i)],
    ([u, h]) => {
      if (o(), !u)
        return;
      const f = P3(h) ? { ...h } : h;
      s.push(
        ...n.flatMap((d) => r.map((p) => a(u, d, p, f)))
      );
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    l(), o();
  };
  return Ev(c), c;
}
let xb = !1;
function o9(t, e, n = {}) {
  const { window: r = L3, ignore: i = [], capture: s = !0, detectIframe: o = !1 } = n;
  if (!r)
    return pi;
  Qf && !xb && (xb = !0, Array.from(r.document.body.children).forEach((f) => f.addEventListener("click", pi)), r.document.documentElement.addEventListener("click", pi));
  let a = !0;
  const l = (f) => i.some((d) => {
    if (typeof d == "string")
      return Array.from(r.document.querySelectorAll(d)).some((p) => p === f.target || f.composedPath().includes(p));
    {
      const p = Cl(d);
      return p && (f.target === p || f.composedPath().includes(p));
    }
  }), u = [
    Xo(r, "click", (f) => {
      const d = Cl(t);
      if (!(!d || d === f.target || f.composedPath().includes(d))) {
        if (f.detail === 0 && (a = !l(f)), !a) {
          a = !0;
          return;
        }
        e(f);
      }
    }, { passive: !0, capture: s }),
    Xo(r, "pointerdown", (f) => {
      const d = Cl(t);
      a = !l(f) && !!(d && !f.composedPath().includes(d));
    }, { passive: !0 }),
    o && Xo(r, "blur", (f) => {
      setTimeout(() => {
        var d;
        const p = Cl(t);
        ((d = r.document.activeElement) == null ? void 0 : d.tagName) === "IFRAME" && !(p != null && p.contains(r.document.activeElement)) && e(f);
      }, 0);
    })
  ].filter(Boolean);
  return () => u.forEach((f) => f());
}
function $l(t) {
  var e;
  const n = Ks(t);
  return (e = n == null ? void 0 : n.$el) != null ? e : n;
}
const N3 = Pv ? window : void 0;
function Af(...t) {
  let e, n, r, i;
  if (typeof t[0] == "string" || Array.isArray(t[0]) ? ([n, r, i] = t, e = N3) : [e, n, r, i] = t, !e)
    return pi;
  Array.isArray(n) || (n = [n]), Array.isArray(r) || (r = [r]);
  const s = [], o = () => {
    s.forEach((u) => u()), s.length = 0;
  }, a = (u, h, f, d) => (u.addEventListener(h, f, d), () => u.removeEventListener(h, f, d)), l = Se(
    () => [$l(e), Ks(i)],
    ([u, h]) => {
      if (o(), !u)
        return;
      const f = P3(h) ? { ...h } : h;
      s.push(
        ...n.flatMap((d) => r.map((p) => a(u, d, p, f)))
      );
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    l(), o();
  };
  return Ev(c), c;
}
let wb = !1;
function kb(t, e, n = {}) {
  const { window: r = N3, ignore: i = [], capture: s = !0, detectIframe: o = !1 } = n;
  if (!r)
    return pi;
  Qf && !wb && (wb = !0, Array.from(r.document.body.children).forEach((f) => f.addEventListener("click", pi)), r.document.documentElement.addEventListener("click", pi));
  let a = !0;
  const l = (f) => i.some((d) => {
    if (typeof d == "string")
      return Array.from(r.document.querySelectorAll(d)).some((p) => p === f.target || f.composedPath().includes(p));
    {
      const p = $l(d);
      return p && (f.target === p || f.composedPath().includes(p));
    }
  }), u = [
    Af(r, "click", (f) => {
      const d = $l(t);
      if (!(!d || d === f.target || f.composedPath().includes(d))) {
        if (f.detail === 0 && (a = !l(f)), !a) {
          a = !0;
          return;
        }
        e(f);
      }
    }, { passive: !0, capture: s }),
    Af(r, "pointerdown", (f) => {
      const d = $l(t);
      a = !l(f) && !!(d && !f.composedPath().includes(d));
    }, { passive: !0 }),
    o && Af(r, "blur", (f) => {
      setTimeout(() => {
        var d;
        const p = $l(t);
        ((d = r.document.activeElement) == null ? void 0 : d.tagName) === "IFRAME" && !(p != null && p.contains(r.document.activeElement)) && e(f);
      }, 0);
    })
  ].filter(Boolean);
  return () => u.forEach((f) => f());
}
const Sd = {
  [bb.mounted](t, e) {
    const n = !e.modifiers.bubble;
    if (typeof e.value == "function")
      t.__onClickOutside_stop = kb(t, e.value, { capture: n });
    else {
      const [r, i] = e.value;
      t.__onClickOutside_stop = kb(t, r, Object.assign({ capture: n }, i));
    }
  },
  [bb.unmounted](t) {
    t.__onClickOutside_stop();
  }
};
function Ip(t) {
  return typeof Window != "undefined" && t instanceof Window ? t.document.documentElement : typeof Document != "undefined" && t instanceof Document ? t.documentElement : t;
}
function I3(t) {
  const e = window.getComputedStyle(t);
  if (e.overflowX === "scroll" || e.overflowY === "scroll" || e.overflowX === "auto" && t.clientWidth < t.scrollWidth || e.overflowY === "auto" && t.clientHeight < t.scrollHeight)
    return !0;
  {
    const n = t.parentNode;
    return !n || n.tagName === "BODY" ? !1 : I3(n);
  }
}
function a9(t) {
  const e = t || window.event, n = e.target;
  return I3(n) ? !1 : e.touches.length > 1 ? !0 : (e.preventDefault && e.preventDefault(), !1);
}
const Rp = /* @__PURE__ */ new WeakMap();
function l9(t, e = !1) {
  const n = le(e);
  let r = null, i = "";
  Se(s9(t), (a) => {
    const l = Ip(Ks(a));
    if (l) {
      const c = l;
      if (Rp.get(c) || Rp.set(c, c.style.overflow), c.style.overflow !== "hidden" && (i = c.style.overflow), c.style.overflow === "hidden")
        return n.value = !0;
      if (n.value)
        return c.style.overflow = "hidden";
    }
  }, {
    immediate: !0
  });
  const s = () => {
    const a = Ip(Ks(t));
    !a || n.value || (Qf && (r = Af(
      a,
      "touchmove",
      (l) => {
        a9(l);
      },
      { passive: !1 }
    )), a.style.overflow = "hidden", n.value = !0);
  }, o = () => {
    const a = Ip(Ks(t));
    !a || !n.value || (Qf && (r == null || r()), a.style.overflow = i, Rp.delete(a), n.value = !1);
  };
  return Ev(o), T({
    get() {
      return n.value;
    },
    set(a) {
      a ? s() : o();
    }
  });
}
function c9() {
  let t = !1;
  const e = le(!1);
  return (n, r) => {
    if (e.value = r.value, t)
      return;
    t = !0;
    const i = l9(n, r.value);
    Se(e, (s) => i.value = s);
  };
}
c9();
const u9 = {
  key: 0,
  class: "vx-pointer-events-auto vx-fixed vx-inset-0 vx-bg-slate-300/80 vx-transition vx-z-50"
}, f9 = {
  key: 0,
  class: "vx-fixed vx-inset-0 vx-z-50 vx-grid vx-place-items-center vx-w-full vx-h-full vx-transition"
}, h9 = { class: "vx-absolute vx-bg-slate-200 vx-right-2 vx-rounded-lg vx-top-2" }, d9 = {
  key: 0,
  class: "vx-text-xl vx-font-extrabold vx-text-slate-700 vx-mb-0"
}, p9 = {
  key: 1,
  class: "vx-text-sm vx-border-t-0 vx-border-x-0 vx-border-b vx-pb-6 vx-border-slate-100 vx-border-solid"
}, m9 = {
  key: 2,
  class: "vx-bg-white vx-border-t vx-border-x-0 vx-border-b-0 vx-border-slate-100 vx-border-solid vx-p-6"
}, g9 = {
  key: 0,
  class: "vx-absolute vx-bottom-4 vx-right-4"
}, v9 = {
  inheritAttrs: !1
}, y9 = /* @__PURE__ */ oe({
  ...v9,
  __name: "vx-modal",
  props: {
    padding: {
      type: Boolean,
      required: !1,
      default: !0
    },
    visible: {
      type: Boolean,
      required: !1,
      default: !0
    },
    background: {
      type: Boolean,
      required: !1,
      default: !0
    },
    stacked: {
      type: Boolean,
      default: !1
    },
    preventClosing: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      required: !1
    }
  },
  emits: ["update:visible", "close"],
  setup(t, { emit: e }) {
    const n = t, r = e, i = le(n.visible);
    Se(
      () => n.visible,
      (a) => {
        i.value = a;
      }
    );
    const s = T(() => n.size === "sm" ? ["vx-max-w-md"] : n.size === "md" ? ["vx-max-w-xl"] : n.size === "lg" ? ["vx-max-w-3xl"] : n.size === "xl" ? ["vx-max-w-5xl"] : []);
    Xo(window, "keydown", (a) => {
      a.key === "Escape" && o();
    });
    const o = () => {
      n.stacked || n.preventClosing || (i.value = !1, r("update:visible", i.value), r("close"));
    };
    return (a, l) => (S(), ye(V_, { to: "body" }, [
      re(Gn, {
        "enter-from-class": "vx-opacity-0",
        "enter-to-class": "vx-opacity-100",
        "leave-from-class": "vx-opacity-100",
        "leave-to-class": "vx-opacity-0"
      }, {
        default: G(() => [
          i.value && n.background ? (S(), D("div", u9)) : Z("", !0)
        ]),
        _: 1
      }),
      re(Gn, {
        "enter-from-class": "vx-opacity-0 vx-translate-y-64",
        "enter-to-class": "vx-opacity-100 vx-translate-y-0 vx-duration-300 vx-ease-out vx-delay-75",
        "leave-from-class": "vx-opacity-100 vx-translate-y-0",
        "leave-to-class": "vx-opacity-0 vx-translate-y-64 vx-duration-300 vx-ease"
      }, {
        default: G(() => [
          i.value ? (S(), D("div", f9, [
            Yn((S(), D("div", Nt(a.$attrs, {
              class: ["vx-absolute vx-flex vx-rounded-2xl vx-border vx-border-white vx-bg-white vx-shadow-xl vx-shadow-slate-400 vx-transition vx-duration-300 vx-overflow-hidden vx-w-[calc(100%-32px)] vx-max-h-[calc(100%-32px)]", [s.value, {
                "-vx-translate-y-12 vx-scale-75 vx-opacity-80 vx-blur-sm": n.stacked
              }]]
            }), [
              B("div", h9, [
                re(cs, {
                  size: "sm",
                  role: "button",
                  onClick: o,
                  color: "transparent"
                }, {
                  default: G(() => [
                    re(P(rt), { icon: P(T3) }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              B("div", {
                class: j(["vx-w-full vx-flex vx-flex-col vx-text-base vx-font-normal vx-font-sans vx-text-slate-500 [&_p]:vx-text-base [&_p]:vx-font-normal [&_p]:vx-font-sans [&_p]:vx-text-slate-500", {
                  "vx-p-8 sm:vx-p-12": n.padding
                }])
              }, [
                a.$slots.header ? (S(), D("h2", d9, [
                  H(a.$slots, "header")
                ])) : Z("", !0),
                a.$slots.subheader ? (S(), D("div", p9, [
                  H(a.$slots, "subheader")
                ])) : Z("", !0),
                B("div", {
                  class: j(["vx-space-y-2 vx-overflow-y-auto", {
                    "vx-bg-slate-50": a.$slots.footer || a.$slots.subheader
                  }])
                }, [
                  H(a.$slots, "default")
                ], 2),
                a.$slots.footer ? (S(), D("div", m9, [
                  H(a.$slots, "footer")
                ])) : Z("", !0)
              ], 2),
              a.$slots.actions ? (S(), D("div", g9, [
                H(a.$slots, "actions")
              ])) : Z("", !0)
            ], 16)), [
              [P(Sd), o]
            ])
          ])) : Z("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), b9 = { class: "vx-flex vx-grow vx-flex-col vx-w-full vx-justify-between vx-relative" }, x9 = {
  key: 0,
  class: "vx-pb-3"
}, w9 = { key: 0 }, k9 = {
  key: 1,
  class: "vx-text-slate-400 -vx-mt-1 vx-font-normal vx-text-xs vx-block"
}, _9 = {
  key: 0,
  class: "vx-pointer-events-none vx-absolute vx-grid vx-h-full vx-w-full vx-place-items-center vx-transition vx-animate-fade-in"
}, S9 = { key: 0 }, Md = /* @__PURE__ */ oe({
  __name: "vx-chart-container",
  props: {
    loading: {
      type: Boolean,
      default: !1
    },
    loadingStyle: {
      type: String,
      default: "bars"
    },
    hasData: {
      type: Boolean,
      default: !0
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["toggleLegend"],
  setup(t, { emit: e }) {
    const n = t, r = le(!1), i = le(!0), s = e;
    Se(i, (a) => {
      s("toggleLegend", a);
    });
    const o = () => {
      window.innerWidth > 1024 ? i.value = !0 : i.value = !1;
    };
    return rn(() => {
      gt().then(o);
    }), (a, l) => (S(), ye(E3, {
      class: j(["vx-flex vx-flex-row vx-relative vx-h-full vx-p-6", {
        "vx-gap-4 vx-w-max vx-min-w-full lg:vx-w-auto": a.$slots.legend && i.value
      }]),
      disabled: !n.hasData && !n.loading || n.error
    }, {
      default: G(() => [
        B("div", b9, [
          a.$slots.title || a.$slots.subtite ? (S(), D("div", x9, [
            a.$slots.title ? (S(), D("span", {
              key: 0,
              class: j(["vx-font-bold vx-text-base vx-flex vx-justify-between", n.hasData || n.loading ? "vx-text-slate-800" : "vx-text-slate-500"])
            }, [
              H(a.$slots, "title"),
              B("div", {
                class: j(["vx-flex vx-items-center vx-gap-4 vx-transition vx-duration-300", n.loading ? "vx-opacity-0" : ""])
              }, [
                H(a.$slots, "right"),
                a.$slots.legend && n.hasData ? (S(), D("div", w9, [
                  re(cs, {
                    onClick: l[0] || (l[0] = Lt((c) => i.value = !i.value, ["prevent"])),
                    type: "button",
                    color: "muted-light",
                    outline: "",
                    size: "xs"
                  }, {
                    default: G(() => [
                      re(P(rt), {
                        fixedWidth: "",
                        icon: i.value ? P(gO) : P(bO)
                      }, null, 8, ["icon"]),
                      ft(" Keys ")
                    ]),
                    _: 1
                  })
                ])) : Z("", !0)
              ], 2)
            ], 2)) : Z("", !0),
            a.$slots.subtitle || n.loading || !n.hasData || n.error ? (S(), D("span", k9, [
              n.loading ? (S(), D(_e, { key: 0 }, [
                ft(" Loading... ")
              ], 64)) : !n.loading && !n.hasData && !n.error ? (S(), D(_e, { key: 1 }, [
                ft(" No data yet ")
              ], 64)) : !n.loading && n.error ? (S(), D(_e, { key: 2 }, [
                ft(" Error ")
              ], 64)) : a.$slots.subtitle ? H(a.$slots, "subtitle", { key: 3 }) : Z("", !0)
            ])) : Z("", !0)
          ])) : Z("", !0),
          re(Gn, {
            "enter-from-class": "vx-opacity-0",
            "enter-to-class": "vx-opacity-100",
            "leave-from-class": "vx-opacity-100",
            "leave-to-class": "vx-opacity-0"
          }, {
            default: G(() => [
              n.loading && n.loadingStyle === "spinner" ? (S(), D("div", _9, [
                re(Ov, {
                  class: "vx-h-8 vx-w-8",
                  spin: ""
                })
              ])) : Z("", !0)
            ]),
            _: 1
          }),
          B("div", {
            class: j(["vx-transition vx-delay-75 vx-duration-500 vx-will-change-transform vx-h-full", {
              "vx-pointer-events-none vx-opacity-0 vx-duration-200": !n.hasData || n.loading || n.error
            }])
          }, [
            H(a.$slots, "default")
          ], 2),
          n.loadingStyle === "bars" || (!n.hasData || n.error) && !n.loading ? (S(), ye(n9, {
            key: 1,
            loading: n.loading,
            hasData: n.hasData,
            error: n.error
          }, null, 8, ["loading", "hasData", "error"])) : Z("", !0),
          a.$slots.footer ? (S(), D("div", {
            key: 2,
            class: j(["vx-pt-4 vx-flex vx-justify-between vx-transition vx-delay-150 vx-duration-300", {
              "vx-pointer-events-none vx-opacity-0": !n.hasData || n.loading || n.error
            }])
          }, [
            H(a.$slots, "footer"),
            a.$slots.explainHeader ? (S(), D("div", S9, [
              re(cs, {
                onClick: l[1] || (l[1] = (c) => r.value = !0),
                size: "xs",
                color: "muted-light",
                type: "button"
              }, {
                default: G(() => [
                  re(P(rt), { icon: P(yO) }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ])) : Z("", !0)
          ], 2)) : Z("", !0)
        ]),
        a.$slots.legend && i.value && (n.loading || n.hasData) ? H(a.$slots, "legend", { key: 0 }) : Z("", !0),
        a.$slots.explainHeader ? (S(), ye(y9, {
          key: 1,
          size: "sm",
          visible: r.value,
          "onUpdate:visible": l[2] || (l[2] = (c) => r.value = c)
        }, {
          header: G(() => [
            H(a.$slots, "explainHeader")
          ]),
          default: G(() => [
            H(a.$slots, "explainContent")
          ]),
          _: 3
        }, 8, ["visible"])) : Z("", !0)
      ]),
      _: 3
    }, 8, ["class", "disabled"]));
  }
}), M9 = { class: "vx-cursor-pointer vx-group vx-flex vx-justify-start" }, C9 = { class: "vx-font-sans vx-text-sm vx-leading-5 vx-font-normal vx-opacity-[0.67] vx-text-black vx-truncate" }, $9 = { class: "vx-font-sans vx-text-base vx-font-light vx-opacity-[0.67]" }, R3 = /* @__PURE__ */ oe({
  __name: "vx-chart-legend-item",
  props: {
    iconColor: {
      type: String,
      default: "#64748B"
    },
    bgColor: {
      type: String,
      default: "#CBD5E1"
    },
    opacity: {
      type: Number,
      default: 1
    },
    hovered: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = t;
    return (n, r) => (S(), D("li", M9, [
      B("div", {
        class: j(["vx-flex vx-items-center vx-rounded-full vx-py-0.5 vx-pl-2 vx-pr-3 vx-transition-all group-hover:vx-flex-grow", {
          "vx-flex-grow": e.hovered
        }]),
        style: yt({ backgroundColor: e.bgColor, opacity: e.opacity })
      }, [
        B("span", {
          class: "vx-rounded vx-w-2.5 vx-h-2.5 vx-mr-1 vx-shrink-0",
          style: yt({ backgroundColor: e.iconColor })
        }, null, 4),
        B("span", C9, [
          H(n.$slots, "default")
        ])
      ], 6),
      n.$slots.value ? (S(), D("div", {
        key: 0,
        class: "vx-py-0.5 vx-pl-2 vx-transition-all vx-w-full vx-truncate",
        style: yt({ color: e.iconColor, opacity: e.opacity })
      }, [
        B("span", $9, [
          H(n.$slots, "value")
        ])
      ], 4)) : Z("", !0)
    ]));
  }
});
function B3(t) {
  return t == null || isNaN(t) ? "" : t < 1e3 ? Intl.NumberFormat("en", { maximumSignificantDigits: 3 }).format(t) : Intl.NumberFormat("en", {
    notation: "compact",
    minimumSignificantDigits: 3,
    maximumSignificantDigits: 3
  }).format(t);
}
function F3(t) {
  var n, r, i;
  if (t == null || isNaN(t))
    return "";
  const e = Intl.NumberFormat("en", {
    style: "percent",
    minimumSignificantDigits: 3,
    maximumSignificantDigits: 3
  }).format(t);
  return ((i = (r = (n = e.replace("%", "").split(".")) == null ? void 0 : n[1]) == null ? void 0 : r.length) != null ? i : 0) <= 2 ? e : Intl.NumberFormat("en", {
    style: "percent",
    maximumFractionDigits: 2,
    minimumFractionDigits: 2
  }).format(t);
}
const Ige = /* @__PURE__ */ oe({
  __name: "vx-chart-categorical",
  props: {
    data: {
      type: Array,
      required: !0
    },
    colors: {
      type: Array,
      required: !0
    },
    percentage: {
      type: Boolean,
      default: !1
    },
    axis: {
      type: Object,
      required: !0
    },
    breakpoint: {
      type: Number,
      required: !1,
      default: 580
    },
    loading: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = t, n = le(null), r = T(() => e.data.reduce((f, d) => f + Number(d[e.axis.x.key]), 0)), i = T(() => {
      const f = {};
      return e.data.forEach((d) => {
        const p = e.axis.x.key, m = e.colors.find((g) => g.label === d.label), v = e.data.find((g) => g.label === d.label);
        v && (f[d.label] = {
          label: d.label,
          bgColor: m == null ? void 0 : m.bgColor,
          iconColor: m == null ? void 0 : m.iconColor,
          opacity: n.value ? n.value === d.label ? 1 : 0.4 : 1,
          hovered: n.value ? n.value === d.label : !1,
          value: Number(v[p]) || 0
        });
      }), Object.values(f);
    }), s = T(() => !!i.value.length), o = le(null), a = le("row"), l = T(() => a.value === "col" ? "vx-flex-col" : "vx-flex-row vx-space-x-2 vx-overflow-y-hidden vx-overflow-x-auto"), c = T(() => {
      var f;
      return ((f = i.value.slice().sort((d, p) => p.value - d.value)[0]) == null ? void 0 : f.value) || 1;
    }), u = (f) => {
      const d = a.value === "row" ? r.value : c.value;
      return f.value / d * 100;
    }, h = () => {
      if (!o.value)
        return;
      o.value.clientWidth < e.breakpoint ? a.value = "col" : a.value = "row";
    };
    return rn(() => {
      gt().then(h), window.addEventListener("resize", h);
    }), Ba(() => {
      window.removeEventListener("resize", h);
    }), (f, d) => (S(), ye(Md, {
      loading: e.loading,
      hasData: s.value,
      error: e.error
    }, ca({
      default: G(() => [
        e.error ? Z("", !0) : (S(), D("ul", {
          key: 0,
          class: j(["vx-flex vx-min-w-[240px]", l.value]),
          ref_key: "list",
          ref: o
        }, [
          (S(!0), D(_e, null, Fe(i.value, (p) => (S(), ye(R3, {
            "icon-color": p.iconColor,
            "bg-color": p.bgColor,
            opacity: p.opacity,
            hovered: p.hovered,
            key: p.label,
            title: `${p.label}: ${Intl.NumberFormat("en").format(p.value)}`,
            onMouseenter: (m) => n.value = p.label,
            onMouseleave: d[0] || (d[0] = (m) => n.value = null),
            class: "vx-flex-col vx-max-w-full",
            style: yt({ minWidth: "55px", width: `calc(55px + ${u(p)}%)` })
          }, {
            default: G(() => [
              ft(Pe(p.label), 1)
            ]),
            value: G(() => [
              ft(Pe(e.percentage ? P(F3)(p.value) : P(B3)(p.value)), 1)
            ]),
            _: 2
          }, 1032, ["icon-color", "bg-color", "opacity", "hovered", "title", "onMouseenter", "style"]))), 128))
        ], 2))
      ]),
      _: 2
    }, [
      f.$slots.title ? {
        name: "title",
        fn: G(() => [
          H(f.$slots, "title")
        ]),
        key: "0"
      } : void 0,
      f.$slots.subtitle ? {
        name: "subtitle",
        fn: G(() => [
          H(f.$slots, "subtitle")
        ]),
        key: "1"
      } : void 0,
      f.$slots.footer ? {
        name: "footer",
        fn: G(() => [
          H(f.$slots, "footer")
        ]),
        key: "2"
      } : void 0,
      f.$slots.explainHeader ? {
        name: "explainHeader",
        fn: G(() => [
          H(f.$slots, "explainHeader")
        ]),
        key: "3"
      } : void 0,
      f.$slots.explainContent ? {
        name: "explainContent",
        fn: G(() => [
          H(f.$slots, "explainContent")
        ]),
        key: "4"
      } : void 0
    ]), 1032, ["loading", "hasData", "error"]));
  }
});
function hn(t, e) {
  return t == null || e == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function Gc(t, e) {
  return t == null || e == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function Cd(t) {
  let e, n, r;
  t.length !== 2 ? (e = hn, n = (a, l) => hn(t(a), l), r = (a, l) => t(a) - l) : (e = t === hn || t === Gc ? t : A9, n = t, r = t);
  function i(a, l, c = 0, u = a.length) {
    if (c < u) {
      if (e(l, l) !== 0) return u;
      do {
        const h = c + u >>> 1;
        n(a[h], l) < 0 ? c = h + 1 : u = h;
      } while (c < u);
    }
    return c;
  }
  function s(a, l, c = 0, u = a.length) {
    if (c < u) {
      if (e(l, l) !== 0) return u;
      do {
        const h = c + u >>> 1;
        n(a[h], l) <= 0 ? c = h + 1 : u = h;
      } while (c < u);
    }
    return c;
  }
  function o(a, l, c = 0, u = a.length) {
    const h = i(a, l, c, u - 1);
    return h > c && r(a[h - 1], l) > -r(a[h], l) ? h - 1 : h;
  }
  return { left: i, center: o, right: s };
}
function A9() {
  return 0;
}
function z3(t) {
  return t === null ? NaN : +t;
}
function* D9(t, e) {
  if (e === void 0)
    for (let n of t)
      n != null && (n = +n) >= n && (yield n);
  else {
    let n = -1;
    for (let r of t)
      (r = e(r, ++n, t)) != null && (r = +r) >= r && (yield r);
  }
}
const T9 = Cd(hn), Lv = T9.right;
Cd(z3).center;
function O9(t) {
  return t.length | 0;
}
function E9(t) {
  return !(t > 0);
}
function P9(t) {
  return typeof t != "object" || "length" in t ? t : Array.from(t);
}
function L9(t) {
  return (e) => t(...e);
}
function N9(...t) {
  const e = typeof t[t.length - 1] == "function" && L9(t.pop());
  t = t.map(P9);
  const n = t.map(O9), r = t.length - 1, i = new Array(r + 1).fill(0), s = [];
  if (r < 0 || n.some(E9)) return s;
  for (; ; ) {
    s.push(i.map((a, l) => t[l][a]));
    let o = r;
    for (; ++i[o] === n[o]; ) {
      if (o === 0) return e ? s.map(e) : s;
      i[o--] = 0;
    }
  }
}
function I9(t, e) {
  var n = 0;
  return Float64Array.from(
    t,
    (r) => n += +r || 0
  );
}
function V3(t, e) {
  let n = 0, r, i = 0, s = 0;
  if (e === void 0)
    for (let o of t)
      o != null && (o = +o) >= o && (r = o - i, i += r / ++n, s += r * (o - i));
  else {
    let o = -1;
    for (let a of t)
      (a = e(a, ++o, t)) != null && (a = +a) >= a && (r = a - i, i += r / ++n, s += r * (a - i));
  }
  if (n > 1) return s / (n - 1);
}
function R9(t, e) {
  const n = V3(t, e);
  return n && Math.sqrt(n);
}
function ns(t, e) {
  let n, r;
  for (const i of t)
    i != null && (n === void 0 ? i >= i && (n = r = i) : (n > i && (n = i), r < i && (r = i)));
  return [n, r];
}
class no {
  constructor() {
    this._partials = new Float64Array(32), this._n = 0;
  }
  add(e) {
    const n = this._partials;
    let r = 0;
    for (let i = 0; i < this._n && i < 32; i++) {
      const s = n[i], o = e + s, a = Math.abs(e) < Math.abs(s) ? e - (o - s) : s - (o - e);
      a && (n[r++] = a), e = o;
    }
    return n[r] = e, this._n = r + 1, this;
  }
  valueOf() {
    const e = this._partials;
    let n = this._n, r, i, s, o = 0;
    if (n > 0) {
      for (o = e[--n]; n > 0 && (r = o, i = e[--n], o = r + i, s = i - (o - r), !s); )
        ;
      n > 0 && (s < 0 && e[n - 1] < 0 || s > 0 && e[n - 1] > 0) && (i = s * 2, r = o + i, i == r - o && (o = r));
    }
    return o;
  }
}
class ro extends Map {
  constructor(e, n = W3) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: n } }), e != null) for (const [r, i] of e) this.set(r, i);
  }
  get(e) {
    return super.get(pg(this, e));
  }
  has(e) {
    return super.has(pg(this, e));
  }
  set(e, n) {
    return super.set(H3(this, e), n);
  }
  delete(e) {
    return super.delete(Y3(this, e));
  }
}
class $d extends Set {
  constructor(e, n = W3) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: n } }), e != null) for (const r of e) this.add(r);
  }
  has(e) {
    return super.has(pg(this, e));
  }
  add(e) {
    return super.add(H3(this, e));
  }
  delete(e) {
    return super.delete(Y3(this, e));
  }
}
function pg({ _intern: t, _key: e }, n) {
  const r = e(n);
  return t.has(r) ? t.get(r) : n;
}
function H3({ _intern: t, _key: e }, n) {
  const r = e(n);
  return t.has(r) ? t.get(r) : (t.set(r, n), n);
}
function Y3({ _intern: t, _key: e }, n) {
  const r = e(n);
  return t.has(r) && (n = t.get(r), t.delete(r)), n;
}
function W3(t) {
  return t !== null && typeof t == "object" ? t.valueOf() : t;
}
function mg(t) {
  return t;
}
function Nv(t, ...e) {
  return Iv(t, mg, mg, e);
}
function Gl(t, e, ...n) {
  return Iv(t, mg, e, n);
}
function B9(t, e, ...n) {
  return Iv(t, Array.from, e, n);
}
function Iv(t, e, n, r) {
  return function i(s, o) {
    if (o >= r.length) return n(s);
    const a = new ro(), l = r[o++];
    let c = -1;
    for (const u of s) {
      const h = l(u, ++c, s), f = a.get(h);
      f ? f.push(u) : a.set(h, [u]);
    }
    for (const [u, h] of a)
      a.set(u, i(h, o));
    return e(a);
  }(t, 0);
}
function F9(t, e) {
  return Array.from(e, (n) => t[n]);
}
function gg(t, ...e) {
  if (typeof t[Symbol.iterator] != "function") throw new TypeError("values is not iterable");
  t = Array.from(t);
  let [n] = e;
  if (n && n.length !== 2 || e.length > 1) {
    const r = Uint32Array.from(t, (i, s) => s);
    return e.length > 1 ? (e = e.map((i) => t.map(i)), r.sort((i, s) => {
      for (const o of e) {
        const a = eh(o[i], o[s]);
        if (a) return a;
      }
    })) : (n = t.map(n), r.sort((i, s) => eh(n[i], n[s]))), F9(t, r);
  }
  return t.sort(j3(n));
}
function j3(t = hn) {
  if (t === hn) return eh;
  if (typeof t != "function") throw new TypeError("compare is not a function");
  return (e, n) => {
    const r = t(e, n);
    return r || r === 0 ? r : (t(n, n) === 0) - (t(e, e) === 0);
  };
}
function eh(t, e) {
  return (t == null || !(t >= t)) - (e == null || !(e >= e)) || (t < e ? -1 : t > e ? 1 : 0);
}
function Rv(t, e, n) {
  return (e.length !== 2 ? gg(Gl(t, e, n), ([r, i], [s, o]) => hn(i, o) || hn(r, s)) : gg(Nv(t, n), ([r, i], [s, o]) => e(i, o) || hn(r, s))).map(([r]) => r);
}
const z9 = Math.sqrt(50), V9 = Math.sqrt(10), H9 = Math.sqrt(2);
function th(t, e, n) {
  const r = (e - t) / Math.max(0, n), i = Math.floor(Math.log10(r)), s = r / Math.pow(10, i), o = s >= z9 ? 10 : s >= V9 ? 5 : s >= H9 ? 2 : 1;
  let a, l, c;
  return i < 0 ? (c = Math.pow(10, -i) / o, a = Math.round(t * c), l = Math.round(e * c), a / c < t && ++a, l / c > e && --l, c = -c) : (c = Math.pow(10, i) * o, a = Math.round(t / c), l = Math.round(e / c), a * c < t && ++a, l * c > e && --l), l < a && 0.5 <= n && n < 2 ? th(t, e, n * 2) : [a, l, c];
}
function nh(t, e, n) {
  if (e = +e, t = +t, n = +n, !(n > 0)) return [];
  if (t === e) return [t];
  const r = e < t, [i, s, o] = r ? th(e, t, n) : th(t, e, n);
  if (!(s >= i)) return [];
  const a = s - i + 1, l = new Array(a);
  if (r)
    if (o < 0) for (let c = 0; c < a; ++c) l[c] = (s - c) / -o;
    else for (let c = 0; c < a; ++c) l[c] = (s - c) * o;
  else if (o < 0) for (let c = 0; c < a; ++c) l[c] = (i + c) / -o;
  else for (let c = 0; c < a; ++c) l[c] = (i + c) * o;
  return l;
}
function vg(t, e, n) {
  return e = +e, t = +t, n = +n, th(t, e, n)[2];
}
function yg(t, e, n) {
  e = +e, t = +t, n = +n;
  const r = e < t, i = r ? vg(e, t, n) : vg(t, e, n);
  return (r ? -1 : 1) * (i < 0 ? 1 / -i : i);
}
function ur(t, e) {
  let n;
  if (e === void 0)
    for (const r of t)
      r != null && (n < r || n === void 0 && r >= r) && (n = r);
  else {
    let r = -1;
    for (let i of t)
      (i = e(i, ++r, t)) != null && (n < i || n === void 0 && i >= i) && (n = i);
  }
  return n;
}
function Y9(t, e) {
  let n, r = -1, i = -1;
  if (e === void 0)
    for (const s of t)
      ++i, s != null && (n < s || n === void 0 && s >= s) && (n = s, r = i);
  else
    for (let s of t)
      (s = e(s, ++i, t)) != null && (n < s || n === void 0 && s >= s) && (n = s, r = i);
  return r;
}
function yi(t, e) {
  let n;
  if (e === void 0)
    for (const r of t)
      r != null && (n > r || n === void 0 && r >= r) && (n = r);
  else {
    let r = -1;
    for (let i of t)
      (i = e(i, ++r, t)) != null && (n > i || n === void 0 && i >= i) && (n = i);
  }
  return n;
}
function W9(t, e) {
  let n, r = -1, i = -1;
  if (e === void 0)
    for (const s of t)
      ++i, s != null && (n > s || n === void 0 && s >= s) && (n = s, r = i);
  else
    for (let s of t)
      (s = e(s, ++i, t)) != null && (n > s || n === void 0 && s >= s) && (n = s, r = i);
  return r;
}
function q3(t, e, n = 0, r = 1 / 0, i) {
  if (e = Math.floor(e), n = Math.floor(Math.max(0, n)), r = Math.floor(Math.min(t.length - 1, r)), !(n <= e && e <= r)) return t;
  for (i = i === void 0 ? eh : j3(i); r > n; ) {
    if (r - n > 600) {
      const l = r - n + 1, c = e - n + 1, u = Math.log(l), h = 0.5 * Math.exp(2 * u / 3), f = 0.5 * Math.sqrt(u * h * (l - h) / l) * (c - l / 2 < 0 ? -1 : 1), d = Math.max(n, Math.floor(e - c * h / l + f)), p = Math.min(r, Math.floor(e + (l - c) * h / l + f));
      q3(t, e, d, p, i);
    }
    const s = t[e];
    let o = n, a = r;
    for (al(t, n, e), i(t[r], s) > 0 && al(t, n, r); o < a; ) {
      for (al(t, o, a), ++o, --a; i(t[o], s) < 0; ) ++o;
      for (; i(t[a], s) > 0; ) --a;
    }
    i(t[n], s) === 0 ? al(t, n, a) : (++a, al(t, a, r)), a <= e && (n = a + 1), e <= a && (r = a - 1);
  }
  return t;
}
function al(t, e, n) {
  const r = t[e];
  t[e] = t[n], t[n] = r;
}
function U3(t, e = hn) {
  let n, r = !1;
  if (e.length === 1) {
    let i;
    for (const s of t) {
      const o = e(s);
      (r ? hn(o, i) > 0 : hn(o, o) === 0) && (n = s, i = o, r = !0);
    }
  } else
    for (const i of t)
      (r ? e(i, n) > 0 : e(i, i) === 0) && (n = i, r = !0);
  return n;
}
function rh(t, e, n) {
  if (t = Float64Array.from(D9(t, n)), !(!(r = t.length) || isNaN(e = +e))) {
    if (e <= 0 || r < 2) return yi(t);
    if (e >= 1) return ur(t);
    var r, i = (r - 1) * e, s = Math.floor(i), o = ur(q3(t, s).subarray(0, s + 1)), a = yi(t.subarray(s + 1));
    return o + (a - o) * (i - s);
  }
}
function j9(t, e, n = z3) {
  if (!(!(r = t.length) || isNaN(e = +e))) {
    if (e <= 0 || r < 2) return +n(t[0], 0, t);
    if (e >= 1) return +n(t[r - 1], r - 1, t);
    var r, i = (r - 1) * e, s = Math.floor(i), o = +n(t[s], s, t), a = +n(t[s + 1], s + 1, t);
    return o + (a - o) * (i - s);
  }
}
function q9(t, e) {
  let n = 0, r = 0;
  if (e === void 0)
    for (let i of t)
      i != null && (i = +i) >= i && (++n, r += i);
  else {
    let i = -1;
    for (let s of t)
      (s = e(s, ++i, t)) != null && (s = +s) >= s && (++n, r += s);
  }
  if (n) return r / n;
}
function bg(t, e) {
  return rh(t, 0.5, e);
}
function* U9(t) {
  for (const e of t)
    yield* e;
}
function K3(t) {
  return Array.from(U9(t));
}
function K9(t, e) {
  const n = new ro();
  if (e === void 0)
    for (let s of t)
      s != null && s >= s && n.set(s, (n.get(s) || 0) + 1);
  else {
    let s = -1;
    for (let o of t)
      (o = e(o, ++s, t)) != null && o >= o && n.set(o, (n.get(o) || 0) + 1);
  }
  let r, i = 0;
  for (const [s, o] of n)
    o > i && (i = o, r = s);
  return r;
}
function G9(t, e = X9) {
  const n = [];
  let r, i = !1;
  for (const s of t)
    i && n.push(e(r, s)), r = s, i = !0;
  return n;
}
function X9(t, e) {
  return [t, e];
}
function xg(t, e, n) {
  t = +t, e = +e, n = (i = arguments.length) < 2 ? (e = t, t = 0, 1) : i < 3 ? 1 : +n;
  for (var r = -1, i = Math.max(0, Math.ceil((e - t) / n)) | 0, s = new Array(i); ++r < i; )
    s[r] = t + r * n;
  return s;
}
function io(t, e) {
  let n = 0;
  if (e === void 0)
    for (let r of t)
      (r = +r) && (n += r);
  else {
    let r = -1;
    for (let i of t)
      (i = +e(i, ++r, t)) && (n += i);
  }
  return n;
}
function ih(t) {
  if (typeof t[Symbol.iterator] != "function") throw new TypeError("values is not iterable");
  return Array.from(t).reverse();
}
function Z9(t) {
  return t;
}
var J9 = 3, _b = 1e-6;
function Q9(t) {
  return "translate(" + t + ",0)";
}
function eE(t) {
  return (e) => +t(e);
}
function tE(t, e) {
  return e = Math.max(0, t.bandwidth() - e * 2) / 2, t.round() && (e = Math.round(e)), (n) => +t(n) + e;
}
function nE() {
  return !this.__axis;
}
function rE(t, e) {
  var n = [], r = null, i = null, s = 6, o = 6, a = 3, l = typeof window != "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5, c = 1, u = "y", h = Q9;
  function f(d) {
    var p = r == null ? e.ticks ? e.ticks.apply(e, n) : e.domain() : r, m = i == null ? e.tickFormat ? e.tickFormat.apply(e, n) : Z9 : i, v = Math.max(s, 0) + a, g = e.range(), y = +g[0] + l, x = +g[g.length - 1] + l, b = (e.bandwidth ? tE : eE)(e.copy(), l), w = d.selection ? d.selection() : d, k = w.selectAll(".domain").data([null]), _ = w.selectAll(".tick").data(p, e).order(), C = _.exit(), E = _.enter().append("g").attr("class", "tick"), L = _.select("line"), M = _.select("text");
    k = k.merge(k.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor")), _ = _.merge(E), L = L.merge(E.append("line").attr("stroke", "currentColor").attr(u + "2", c * s)), M = M.merge(E.append("text").attr("fill", "currentColor").attr(u, c * v).attr("dy", "0.71em")), d !== w && (k = k.transition(d), _ = _.transition(d), L = L.transition(d), M = M.transition(d), C = C.transition(d).attr("opacity", _b).attr("transform", function(O) {
      return isFinite(O = b(O)) ? h(O + l) : this.getAttribute("transform");
    }), E.attr("opacity", _b).attr("transform", function(O) {
      var N = this.parentNode.__axis;
      return h((N && isFinite(N = N(O)) ? N : b(O)) + l);
    })), C.remove(), k.attr("d", o ? "M" + y + "," + c * o + "V" + l + "H" + x + "V" + c * o : "M" + y + "," + l + "H" + x), _.attr("opacity", 1).attr("transform", function(O) {
      return h(b(O) + l);
    }), L.attr(u + "2", c * s), M.attr(u, c * v).text(m), w.filter(nE).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", "middle"), w.each(function() {
      this.__axis = b;
    });
  }
  return f.scale = function(d) {
    return arguments.length ? (e = d, f) : e;
  }, f.ticks = function() {
    return n = Array.from(arguments), f;
  }, f.tickArguments = function(d) {
    return arguments.length ? (n = d == null ? [] : Array.from(d), f) : n.slice();
  }, f.tickValues = function(d) {
    return arguments.length ? (r = d == null ? null : Array.from(d), f) : r && r.slice();
  }, f.tickFormat = function(d) {
    return arguments.length ? (i = d, f) : i;
  }, f.tickSize = function(d) {
    return arguments.length ? (s = o = +d, f) : s;
  }, f.tickSizeInner = function(d) {
    return arguments.length ? (s = +d, f) : s;
  }, f.tickSizeOuter = function(d) {
    return arguments.length ? (o = +d, f) : o;
  }, f.tickPadding = function(d) {
    return arguments.length ? (a = +d, f) : a;
  }, f.offset = function(d) {
    return arguments.length ? (l = +d, f) : l;
  }, f;
}
function iE(t) {
  return rE(J9, t);
}
var sE = { value: () => {
} };
function G3() {
  for (var t = 0, e = arguments.length, n = {}, r; t < e; ++t) {
    if (!(r = arguments[t] + "") || r in n || /[\s.]/.test(r)) throw new Error("illegal type: " + r);
    n[r] = [];
  }
  return new Df(n);
}
function Df(t) {
  this._ = t;
}
function oE(t, e) {
  return t.trim().split(/^|\s+/).map(function(n) {
    var r = "", i = n.indexOf(".");
    if (i >= 0 && (r = n.slice(i + 1), n = n.slice(0, i)), n && !e.hasOwnProperty(n)) throw new Error("unknown type: " + n);
    return { type: n, name: r };
  });
}
Df.prototype = G3.prototype = {
  constructor: Df,
  on: function(t, e) {
    var n = this._, r = oE(t + "", n), i, s = -1, o = r.length;
    if (arguments.length < 2) {
      for (; ++s < o; ) if ((i = (t = r[s]).type) && (i = aE(n[i], t.name))) return i;
      return;
    }
    if (e != null && typeof e != "function") throw new Error("invalid callback: " + e);
    for (; ++s < o; )
      if (i = (t = r[s]).type) n[i] = Sb(n[i], t.name, e);
      else if (e == null) for (i in n) n[i] = Sb(n[i], t.name, null);
    return this;
  },
  copy: function() {
    var t = {}, e = this._;
    for (var n in e) t[n] = e[n].slice();
    return new Df(t);
  },
  call: function(t, e) {
    if ((i = arguments.length - 2) > 0) for (var n = new Array(i), r = 0, i, s; r < i; ++r) n[r] = arguments[r + 2];
    if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    for (s = this._[t], r = 0, i = s.length; r < i; ++r) s[r].value.apply(e, n);
  },
  apply: function(t, e, n) {
    if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    for (var r = this._[t], i = 0, s = r.length; i < s; ++i) r[i].value.apply(e, n);
  }
};
function aE(t, e) {
  for (var n = 0, r = t.length, i; n < r; ++n)
    if ((i = t[n]).name === e)
      return i.value;
}
function Sb(t, e, n) {
  for (var r = 0, i = t.length; r < i; ++r)
    if (t[r].name === e) {
      t[r] = sE, t = t.slice(0, r).concat(t.slice(r + 1));
      break;
    }
  return n != null && t.push({ name: e, value: n }), t;
}
var wg = "http://www.w3.org/1999/xhtml";
const ha = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: wg,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function Ad(t) {
  var e = t += "", n = e.indexOf(":");
  return n >= 0 && (e = t.slice(0, n)) !== "xmlns" && (t = t.slice(n + 1)), ha.hasOwnProperty(e) ? { space: ha[e], local: t } : t;
}
function lE(t) {
  return function() {
    var e = this.ownerDocument, n = this.namespaceURI;
    return n === wg && e.documentElement.namespaceURI === wg ? e.createElement(t) : e.createElementNS(n, t);
  };
}
function cE(t) {
  return function() {
    return this.ownerDocument.createElementNS(t.space, t.local);
  };
}
function Dd(t) {
  var e = Ad(t);
  return (e.local ? cE : lE)(e);
}
function uE() {
}
function Bv(t) {
  return t == null ? uE : function() {
    return this.querySelector(t);
  };
}
function fE(t) {
  typeof t != "function" && (t = Bv(t));
  for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i)
    for (var s = e[i], o = s.length, a = r[i] = new Array(o), l, c, u = 0; u < o; ++u)
      (l = s[u]) && (c = t.call(l, l.__data__, u, s)) && ("__data__" in l && (c.__data__ = l.__data__), a[u] = c);
  return new An(r, this._parents);
}
function hE(t) {
  return t == null ? [] : Array.isArray(t) ? t : Array.from(t);
}
function dE() {
  return [];
}
function X3(t) {
  return t == null ? dE : function() {
    return this.querySelectorAll(t);
  };
}
function pE(t) {
  return function() {
    return hE(t.apply(this, arguments));
  };
}
function mE(t) {
  typeof t == "function" ? t = pE(t) : t = X3(t);
  for (var e = this._groups, n = e.length, r = [], i = [], s = 0; s < n; ++s)
    for (var o = e[s], a = o.length, l, c = 0; c < a; ++c)
      (l = o[c]) && (r.push(t.call(l, l.__data__, c, o)), i.push(l));
  return new An(r, i);
}
function Z3(t) {
  return function() {
    return this.matches(t);
  };
}
function J3(t) {
  return function(e) {
    return e.matches(t);
  };
}
var gE = Array.prototype.find;
function vE(t) {
  return function() {
    return gE.call(this.children, t);
  };
}
function yE() {
  return this.firstElementChild;
}
function bE(t) {
  return this.select(t == null ? yE : vE(typeof t == "function" ? t : J3(t)));
}
var xE = Array.prototype.filter;
function wE() {
  return Array.from(this.children);
}
function kE(t) {
  return function() {
    return xE.call(this.children, t);
  };
}
function _E(t) {
  return this.selectAll(t == null ? wE : kE(typeof t == "function" ? t : J3(t)));
}
function SE(t) {
  typeof t != "function" && (t = Z3(t));
  for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i)
    for (var s = e[i], o = s.length, a = r[i] = [], l, c = 0; c < o; ++c)
      (l = s[c]) && t.call(l, l.__data__, c, s) && a.push(l);
  return new An(r, this._parents);
}
function Q3(t) {
  return new Array(t.length);
}
function ME() {
  return new An(this._enter || this._groups.map(Q3), this._parents);
}
function sh(t, e) {
  this.ownerDocument = t.ownerDocument, this.namespaceURI = t.namespaceURI, this._next = null, this._parent = t, this.__data__ = e;
}
sh.prototype = {
  constructor: sh,
  appendChild: function(t) {
    return this._parent.insertBefore(t, this._next);
  },
  insertBefore: function(t, e) {
    return this._parent.insertBefore(t, e);
  },
  querySelector: function(t) {
    return this._parent.querySelector(t);
  },
  querySelectorAll: function(t) {
    return this._parent.querySelectorAll(t);
  }
};
function CE(t) {
  return function() {
    return t;
  };
}
function $E(t, e, n, r, i, s) {
  for (var o = 0, a, l = e.length, c = s.length; o < c; ++o)
    (a = e[o]) ? (a.__data__ = s[o], r[o] = a) : n[o] = new sh(t, s[o]);
  for (; o < l; ++o)
    (a = e[o]) && (i[o] = a);
}
function AE(t, e, n, r, i, s, o) {
  var a, l, c = /* @__PURE__ */ new Map(), u = e.length, h = s.length, f = new Array(u), d;
  for (a = 0; a < u; ++a)
    (l = e[a]) && (f[a] = d = o.call(l, l.__data__, a, e) + "", c.has(d) ? i[a] = l : c.set(d, l));
  for (a = 0; a < h; ++a)
    d = o.call(t, s[a], a, s) + "", (l = c.get(d)) ? (r[a] = l, l.__data__ = s[a], c.delete(d)) : n[a] = new sh(t, s[a]);
  for (a = 0; a < u; ++a)
    (l = e[a]) && c.get(f[a]) === l && (i[a] = l);
}
function DE(t) {
  return t.__data__;
}
function TE(t, e) {
  if (!arguments.length) return Array.from(this, DE);
  var n = e ? AE : $E, r = this._parents, i = this._groups;
  typeof t != "function" && (t = CE(t));
  for (var s = i.length, o = new Array(s), a = new Array(s), l = new Array(s), c = 0; c < s; ++c) {
    var u = r[c], h = i[c], f = h.length, d = OE(t.call(u, u && u.__data__, c, r)), p = d.length, m = a[c] = new Array(p), v = o[c] = new Array(p), g = l[c] = new Array(f);
    n(u, h, m, v, g, d, e);
    for (var y = 0, x = 0, b, w; y < p; ++y)
      if (b = m[y]) {
        for (y >= x && (x = y + 1); !(w = v[x]) && ++x < p; ) ;
        b._next = w || null;
      }
  }
  return o = new An(o, r), o._enter = a, o._exit = l, o;
}
function OE(t) {
  return typeof t == "object" && "length" in t ? t : Array.from(t);
}
function EE() {
  return new An(this._exit || this._groups.map(Q3), this._parents);
}
function PE(t, e, n) {
  var r = this.enter(), i = this, s = this.exit();
  return typeof t == "function" ? (r = t(r), r && (r = r.selection())) : r = r.append(t + ""), e != null && (i = e(i), i && (i = i.selection())), n == null ? s.remove() : n(s), r && i ? r.merge(i).order() : i;
}
function LE(t) {
  for (var e = t.selection ? t.selection() : t, n = this._groups, r = e._groups, i = n.length, s = r.length, o = Math.min(i, s), a = new Array(i), l = 0; l < o; ++l)
    for (var c = n[l], u = r[l], h = c.length, f = a[l] = new Array(h), d, p = 0; p < h; ++p)
      (d = c[p] || u[p]) && (f[p] = d);
  for (; l < i; ++l)
    a[l] = n[l];
  return new An(a, this._parents);
}
function NE() {
  for (var t = this._groups, e = -1, n = t.length; ++e < n; )
    for (var r = t[e], i = r.length - 1, s = r[i], o; --i >= 0; )
      (o = r[i]) && (s && o.compareDocumentPosition(s) ^ 4 && s.parentNode.insertBefore(o, s), s = o);
  return this;
}
function IE(t) {
  t || (t = RE);
  function e(h, f) {
    return h && f ? t(h.__data__, f.__data__) : !h - !f;
  }
  for (var n = this._groups, r = n.length, i = new Array(r), s = 0; s < r; ++s) {
    for (var o = n[s], a = o.length, l = i[s] = new Array(a), c, u = 0; u < a; ++u)
      (c = o[u]) && (l[u] = c);
    l.sort(e);
  }
  return new An(i, this._parents).order();
}
function RE(t, e) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function BE() {
  var t = arguments[0];
  return arguments[0] = this, t.apply(null, arguments), this;
}
function FE() {
  return Array.from(this);
}
function zE() {
  for (var t = this._groups, e = 0, n = t.length; e < n; ++e)
    for (var r = t[e], i = 0, s = r.length; i < s; ++i) {
      var o = r[i];
      if (o) return o;
    }
  return null;
}
function VE() {
  let t = 0;
  for (const e of this) ++t;
  return t;
}
function HE() {
  return !this.node();
}
function YE(t) {
  for (var e = this._groups, n = 0, r = e.length; n < r; ++n)
    for (var i = e[n], s = 0, o = i.length, a; s < o; ++s)
      (a = i[s]) && t.call(a, a.__data__, s, i);
  return this;
}
function WE(t) {
  return function() {
    this.removeAttribute(t);
  };
}
function jE(t) {
  return function() {
    this.removeAttributeNS(t.space, t.local);
  };
}
function qE(t, e) {
  return function() {
    this.setAttribute(t, e);
  };
}
function UE(t, e) {
  return function() {
    this.setAttributeNS(t.space, t.local, e);
  };
}
function KE(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? this.removeAttribute(t) : this.setAttribute(t, n);
  };
}
function GE(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, n);
  };
}
function XE(t, e) {
  var n = Ad(t);
  if (arguments.length < 2) {
    var r = this.node();
    return n.local ? r.getAttributeNS(n.space, n.local) : r.getAttribute(n);
  }
  return this.each((e == null ? n.local ? jE : WE : typeof e == "function" ? n.local ? GE : KE : n.local ? UE : qE)(n, e));
}
function eS(t) {
  return t.ownerDocument && t.ownerDocument.defaultView || t.document && t || t.defaultView;
}
function ZE(t) {
  return function() {
    this.style.removeProperty(t);
  };
}
function JE(t, e, n) {
  return function() {
    this.style.setProperty(t, e, n);
  };
}
function QE(t, e, n) {
  return function() {
    var r = e.apply(this, arguments);
    r == null ? this.style.removeProperty(t) : this.style.setProperty(t, r, n);
  };
}
function eP(t, e, n) {
  return arguments.length > 1 ? this.each((e == null ? ZE : typeof e == "function" ? QE : JE)(t, e, n == null ? "" : n)) : da(this.node(), t);
}
function da(t, e) {
  return t.style.getPropertyValue(e) || eS(t).getComputedStyle(t, null).getPropertyValue(e);
}
function tP(t) {
  return function() {
    delete this[t];
  };
}
function nP(t, e) {
  return function() {
    this[t] = e;
  };
}
function rP(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? delete this[t] : this[t] = n;
  };
}
function iP(t, e) {
  return arguments.length > 1 ? this.each((e == null ? tP : typeof e == "function" ? rP : nP)(t, e)) : this.node()[t];
}
function tS(t) {
  return t.trim().split(/^|\s+/);
}
function Fv(t) {
  return t.classList || new nS(t);
}
function nS(t) {
  this._node = t, this._names = tS(t.getAttribute("class") || "");
}
nS.prototype = {
  add: function(t) {
    var e = this._names.indexOf(t);
    e < 0 && (this._names.push(t), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function(t) {
    var e = this._names.indexOf(t);
    e >= 0 && (this._names.splice(e, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function(t) {
    return this._names.indexOf(t) >= 0;
  }
};
function rS(t, e) {
  for (var n = Fv(t), r = -1, i = e.length; ++r < i; ) n.add(e[r]);
}
function iS(t, e) {
  for (var n = Fv(t), r = -1, i = e.length; ++r < i; ) n.remove(e[r]);
}
function sP(t) {
  return function() {
    rS(this, t);
  };
}
function oP(t) {
  return function() {
    iS(this, t);
  };
}
function aP(t, e) {
  return function() {
    (e.apply(this, arguments) ? rS : iS)(this, t);
  };
}
function lP(t, e) {
  var n = tS(t + "");
  if (arguments.length < 2) {
    for (var r = Fv(this.node()), i = -1, s = n.length; ++i < s; ) if (!r.contains(n[i])) return !1;
    return !0;
  }
  return this.each((typeof e == "function" ? aP : e ? sP : oP)(n, e));
}
function cP() {
  this.textContent = "";
}
function uP(t) {
  return function() {
    this.textContent = t;
  };
}
function fP(t) {
  return function() {
    var e = t.apply(this, arguments);
    this.textContent = e == null ? "" : e;
  };
}
function hP(t) {
  return arguments.length ? this.each(t == null ? cP : (typeof t == "function" ? fP : uP)(t)) : this.node().textContent;
}
function dP() {
  this.innerHTML = "";
}
function pP(t) {
  return function() {
    this.innerHTML = t;
  };
}
function mP(t) {
  return function() {
    var e = t.apply(this, arguments);
    this.innerHTML = e == null ? "" : e;
  };
}
function gP(t) {
  return arguments.length ? this.each(t == null ? dP : (typeof t == "function" ? mP : pP)(t)) : this.node().innerHTML;
}
function vP() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function yP() {
  return this.each(vP);
}
function bP() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function xP() {
  return this.each(bP);
}
function wP(t) {
  var e = typeof t == "function" ? t : Dd(t);
  return this.select(function() {
    return this.appendChild(e.apply(this, arguments));
  });
}
function kP() {
  return null;
}
function _P(t, e) {
  var n = typeof t == "function" ? t : Dd(t), r = e == null ? kP : typeof e == "function" ? e : Bv(e);
  return this.select(function() {
    return this.insertBefore(n.apply(this, arguments), r.apply(this, arguments) || null);
  });
}
function SP() {
  var t = this.parentNode;
  t && t.removeChild(this);
}
function MP() {
  return this.each(SP);
}
function CP() {
  var t = this.cloneNode(!1), e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}
function $P() {
  var t = this.cloneNode(!0), e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}
function AP(t) {
  return this.select(t ? $P : CP);
}
function DP(t) {
  return arguments.length ? this.property("__data__", t) : this.node().__data__;
}
function TP(t) {
  return function(e) {
    t.call(this, e, this.__data__);
  };
}
function OP(t) {
  return t.trim().split(/^|\s+/).map(function(e) {
    var n = "", r = e.indexOf(".");
    return r >= 0 && (n = e.slice(r + 1), e = e.slice(0, r)), { type: e, name: n };
  });
}
function EP(t) {
  return function() {
    var e = this.__on;
    if (e) {
      for (var n = 0, r = -1, i = e.length, s; n < i; ++n)
        s = e[n], (!t.type || s.type === t.type) && s.name === t.name ? this.removeEventListener(s.type, s.listener, s.options) : e[++r] = s;
      ++r ? e.length = r : delete this.__on;
    }
  };
}
function PP(t, e, n) {
  return function() {
    var r = this.__on, i, s = TP(e);
    if (r) {
      for (var o = 0, a = r.length; o < a; ++o)
        if ((i = r[o]).type === t.type && i.name === t.name) {
          this.removeEventListener(i.type, i.listener, i.options), this.addEventListener(i.type, i.listener = s, i.options = n), i.value = e;
          return;
        }
    }
    this.addEventListener(t.type, s, n), i = { type: t.type, name: t.name, value: e, listener: s, options: n }, r ? r.push(i) : this.__on = [i];
  };
}
function LP(t, e, n) {
  var r = OP(t + ""), i, s = r.length, o;
  if (arguments.length < 2) {
    var a = this.node().__on;
    if (a) {
      for (var l = 0, c = a.length, u; l < c; ++l)
        for (i = 0, u = a[l]; i < s; ++i)
          if ((o = r[i]).type === u.type && o.name === u.name)
            return u.value;
    }
    return;
  }
  for (a = e ? PP : EP, i = 0; i < s; ++i) this.each(a(r[i], e, n));
  return this;
}
function sS(t, e, n) {
  var r = eS(t), i = r.CustomEvent;
  typeof i == "function" ? i = new i(e, n) : (i = r.document.createEvent("Event"), n ? (i.initEvent(e, n.bubbles, n.cancelable), i.detail = n.detail) : i.initEvent(e, !1, !1)), t.dispatchEvent(i);
}
function NP(t, e) {
  return function() {
    return sS(this, t, e);
  };
}
function IP(t, e) {
  return function() {
    return sS(this, t, e.apply(this, arguments));
  };
}
function RP(t, e) {
  return this.each((typeof e == "function" ? IP : NP)(t, e));
}
function* BP() {
  for (var t = this._groups, e = 0, n = t.length; e < n; ++e)
    for (var r = t[e], i = 0, s = r.length, o; i < s; ++i)
      (o = r[i]) && (yield o);
}
var oS = [null];
function An(t, e) {
  this._groups = t, this._parents = e;
}
function Xc() {
  return new An([[document.documentElement]], oS);
}
function FP() {
  return this;
}
An.prototype = Xc.prototype = {
  constructor: An,
  select: fE,
  selectAll: mE,
  selectChild: bE,
  selectChildren: _E,
  filter: SE,
  data: TE,
  enter: ME,
  exit: EE,
  join: PE,
  merge: LE,
  selection: FP,
  order: NE,
  sort: IE,
  call: BE,
  nodes: FE,
  node: zE,
  size: VE,
  empty: HE,
  each: YE,
  attr: XE,
  style: eP,
  property: iP,
  classed: lP,
  text: hP,
  html: gP,
  raise: yP,
  lower: xP,
  append: wP,
  insert: _P,
  remove: MP,
  clone: AP,
  datum: DP,
  on: LP,
  dispatch: RP,
  [Symbol.iterator]: BP
};
function Xl(t) {
  return typeof t == "string" ? new An([[document.querySelector(t)]], [document.documentElement]) : new An([[t]], oS);
}
function zP(t) {
  let e;
  for (; e = t.sourceEvent; ) t = e;
  return t;
}
function VP(t, e) {
  if (t = zP(t), e === void 0 && (e = t.currentTarget), e) {
    var n = e.ownerSVGElement || e;
    if (n.createSVGPoint) {
      var r = n.createSVGPoint();
      return r.x = t.clientX, r.y = t.clientY, r = r.matrixTransform(e.getScreenCTM().inverse()), [r.x, r.y];
    }
    if (e.getBoundingClientRect) {
      var i = e.getBoundingClientRect();
      return [t.clientX - i.left - e.clientLeft, t.clientY - i.top - e.clientTop];
    }
  }
  return [t.pageX, t.pageY];
}
function Va(t, e, n) {
  t.prototype = e.prototype = n, n.constructor = t;
}
function Zc(t, e) {
  var n = Object.create(t.prototype);
  for (var r in e) n[r] = e[r];
  return n;
}
function ws() {
}
var so = 0.7, pa = 1 / so, Zo = "\\s*([+-]?\\d+)\\s*", hc = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", Vr = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", HP = /^#([0-9a-f]{3,8})$/, YP = new RegExp(`^rgb\\(${Zo},${Zo},${Zo}\\)$`), WP = new RegExp(`^rgb\\(${Vr},${Vr},${Vr}\\)$`), jP = new RegExp(`^rgba\\(${Zo},${Zo},${Zo},${hc}\\)$`), qP = new RegExp(`^rgba\\(${Vr},${Vr},${Vr},${hc}\\)$`), UP = new RegExp(`^hsl\\(${hc},${Vr},${Vr}\\)$`), KP = new RegExp(`^hsla\\(${hc},${Vr},${Vr},${hc}\\)$`), Mb = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
Va(ws, oo, {
  copy(t) {
    return Object.assign(new this.constructor(), this, t);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: Cb,
  // Deprecated! Use color.formatHex.
  formatHex: Cb,
  formatHex8: GP,
  formatHsl: XP,
  formatRgb: $b,
  toString: $b
});
function Cb() {
  return this.rgb().formatHex();
}
function GP() {
  return this.rgb().formatHex8();
}
function XP() {
  return aS(this).formatHsl();
}
function $b() {
  return this.rgb().formatRgb();
}
function oo(t) {
  var e, n;
  return t = (t + "").trim().toLowerCase(), (e = HP.exec(t)) ? (n = e[1].length, e = parseInt(e[1], 16), n === 6 ? Ab(e) : n === 3 ? new kt(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, (e & 15) << 4 | e & 15, 1) : n === 8 ? Nu(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (e & 255) / 255) : n === 4 ? Nu(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, ((e & 15) << 4 | e & 15) / 255) : null) : (e = YP.exec(t)) ? new kt(e[1], e[2], e[3], 1) : (e = WP.exec(t)) ? new kt(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, 1) : (e = jP.exec(t)) ? Nu(e[1], e[2], e[3], e[4]) : (e = qP.exec(t)) ? Nu(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, e[4]) : (e = UP.exec(t)) ? Ob(e[1], e[2] / 100, e[3] / 100, 1) : (e = KP.exec(t)) ? Ob(e[1], e[2] / 100, e[3] / 100, e[4]) : Mb.hasOwnProperty(t) ? Ab(Mb[t]) : t === "transparent" ? new kt(NaN, NaN, NaN, 0) : null;
}
function Ab(t) {
  return new kt(t >> 16 & 255, t >> 8 & 255, t & 255, 1);
}
function Nu(t, e, n, r) {
  return r <= 0 && (t = e = n = NaN), new kt(t, e, n, r);
}
function zv(t) {
  return t instanceof ws || (t = oo(t)), t ? (t = t.rgb(), new kt(t.r, t.g, t.b, t.opacity)) : new kt();
}
function us(t, e, n, r) {
  return arguments.length === 1 ? zv(t) : new kt(t, e, n, r == null ? 1 : r);
}
function kt(t, e, n, r) {
  this.r = +t, this.g = +e, this.b = +n, this.opacity = +r;
}
Va(kt, us, Zc(ws, {
  brighter(t) {
    return t = t == null ? pa : Math.pow(pa, t), new kt(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? so : Math.pow(so, t), new kt(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new kt(Gs(this.r), Gs(this.g), Gs(this.b), oh(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: Db,
  // Deprecated! Use color.formatHex.
  formatHex: Db,
  formatHex8: ZP,
  formatRgb: Tb,
  toString: Tb
}));
function Db() {
  return `#${Vs(this.r)}${Vs(this.g)}${Vs(this.b)}`;
}
function ZP() {
  return `#${Vs(this.r)}${Vs(this.g)}${Vs(this.b)}${Vs((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function Tb() {
  const t = oh(this.opacity);
  return `${t === 1 ? "rgb(" : "rgba("}${Gs(this.r)}, ${Gs(this.g)}, ${Gs(this.b)}${t === 1 ? ")" : `, ${t})`}`;
}
function oh(t) {
  return isNaN(t) ? 1 : Math.max(0, Math.min(1, t));
}
function Gs(t) {
  return Math.max(0, Math.min(255, Math.round(t) || 0));
}
function Vs(t) {
  return t = Gs(t), (t < 16 ? "0" : "") + t.toString(16);
}
function Ob(t, e, n, r) {
  return r <= 0 ? t = e = n = NaN : n <= 0 || n >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new lr(t, e, n, r);
}
function aS(t) {
  if (t instanceof lr) return new lr(t.h, t.s, t.l, t.opacity);
  if (t instanceof ws || (t = oo(t)), !t) return new lr();
  if (t instanceof lr) return t;
  t = t.rgb();
  var e = t.r / 255, n = t.g / 255, r = t.b / 255, i = Math.min(e, n, r), s = Math.max(e, n, r), o = NaN, a = s - i, l = (s + i) / 2;
  return a ? (e === s ? o = (n - r) / a + (n < r) * 6 : n === s ? o = (r - e) / a + 2 : o = (e - n) / a + 4, a /= l < 0.5 ? s + i : 2 - s - i, o *= 60) : a = l > 0 && l < 1 ? 0 : o, new lr(o, a, l, t.opacity);
}
function kg(t, e, n, r) {
  return arguments.length === 1 ? aS(t) : new lr(t, e, n, r == null ? 1 : r);
}
function lr(t, e, n, r) {
  this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
}
Va(lr, kg, Zc(ws, {
  brighter(t) {
    return t = t == null ? pa : Math.pow(pa, t), new lr(this.h, this.s, this.l * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? so : Math.pow(so, t), new lr(this.h, this.s, this.l * t, this.opacity);
  },
  rgb() {
    var t = this.h % 360 + (this.h < 0) * 360, e = isNaN(t) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * e, i = 2 * n - r;
    return new kt(
      Bp(t >= 240 ? t - 240 : t + 120, i, r),
      Bp(t, i, r),
      Bp(t < 120 ? t + 240 : t - 120, i, r),
      this.opacity
    );
  },
  clamp() {
    return new lr(Eb(this.h), Iu(this.s), Iu(this.l), oh(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const t = oh(this.opacity);
    return `${t === 1 ? "hsl(" : "hsla("}${Eb(this.h)}, ${Iu(this.s) * 100}%, ${Iu(this.l) * 100}%${t === 1 ? ")" : `, ${t})`}`;
  }
}));
function Eb(t) {
  return t = (t || 0) % 360, t < 0 ? t + 360 : t;
}
function Iu(t) {
  return Math.max(0, Math.min(1, t || 0));
}
function Bp(t, e, n) {
  return (t < 60 ? e + (n - e) * t / 60 : t < 180 ? n : t < 240 ? e + (n - e) * (240 - t) / 60 : e) * 255;
}
const lS = Math.PI / 180, cS = 180 / Math.PI, ah = 18, uS = 0.96422, fS = 1, hS = 0.82521, dS = 4 / 29, Jo = 6 / 29, pS = 3 * Jo * Jo, JP = Jo * Jo * Jo;
function mS(t) {
  if (t instanceof Hr) return new Hr(t.l, t.a, t.b, t.opacity);
  if (t instanceof ui) return gS(t);
  t instanceof kt || (t = zv(t));
  var e = Hp(t.r), n = Hp(t.g), r = Hp(t.b), i = Fp((0.2225045 * e + 0.7168786 * n + 0.0606169 * r) / fS), s, o;
  return e === n && n === r ? s = o = i : (s = Fp((0.4360747 * e + 0.3850649 * n + 0.1430804 * r) / uS), o = Fp((0.0139322 * e + 0.0971045 * n + 0.7141733 * r) / hS)), new Hr(116 * i - 16, 500 * (s - i), 200 * (i - o), t.opacity);
}
function _g(t, e, n, r) {
  return arguments.length === 1 ? mS(t) : new Hr(t, e, n, r == null ? 1 : r);
}
function Hr(t, e, n, r) {
  this.l = +t, this.a = +e, this.b = +n, this.opacity = +r;
}
Va(Hr, _g, Zc(ws, {
  brighter(t) {
    return new Hr(this.l + ah * (t == null ? 1 : t), this.a, this.b, this.opacity);
  },
  darker(t) {
    return new Hr(this.l - ah * (t == null ? 1 : t), this.a, this.b, this.opacity);
  },
  rgb() {
    var t = (this.l + 16) / 116, e = isNaN(this.a) ? t : t + this.a / 500, n = isNaN(this.b) ? t : t - this.b / 200;
    return e = uS * zp(e), t = fS * zp(t), n = hS * zp(n), new kt(
      Vp(3.1338561 * e - 1.6168667 * t - 0.4906146 * n),
      Vp(-0.9787684 * e + 1.9161415 * t + 0.033454 * n),
      Vp(0.0719453 * e - 0.2289914 * t + 1.4052427 * n),
      this.opacity
    );
  }
}));
function Fp(t) {
  return t > JP ? Math.pow(t, 1 / 3) : t / pS + dS;
}
function zp(t) {
  return t > Jo ? t * t * t : pS * (t - dS);
}
function Vp(t) {
  return 255 * (t <= 31308e-7 ? 12.92 * t : 1.055 * Math.pow(t, 1 / 2.4) - 0.055);
}
function Hp(t) {
  return (t /= 255) <= 0.04045 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
}
function QP(t) {
  if (t instanceof ui) return new ui(t.h, t.c, t.l, t.opacity);
  if (t instanceof Hr || (t = mS(t)), t.a === 0 && t.b === 0) return new ui(NaN, 0 < t.l && t.l < 100 ? 0 : NaN, t.l, t.opacity);
  var e = Math.atan2(t.b, t.a) * cS;
  return new ui(e < 0 ? e + 360 : e, Math.sqrt(t.a * t.a + t.b * t.b), t.l, t.opacity);
}
function Sg(t, e, n, r) {
  return arguments.length === 1 ? QP(t) : new ui(t, e, n, r == null ? 1 : r);
}
function ui(t, e, n, r) {
  this.h = +t, this.c = +e, this.l = +n, this.opacity = +r;
}
function gS(t) {
  if (isNaN(t.h)) return new Hr(t.l, 0, 0, t.opacity);
  var e = t.h * lS;
  return new Hr(t.l, Math.cos(e) * t.c, Math.sin(e) * t.c, t.opacity);
}
Va(ui, Sg, Zc(ws, {
  brighter(t) {
    return new ui(this.h, this.c, this.l + ah * (t == null ? 1 : t), this.opacity);
  },
  darker(t) {
    return new ui(this.h, this.c, this.l - ah * (t == null ? 1 : t), this.opacity);
  },
  rgb() {
    return gS(this).rgb();
  }
}));
var vS = -0.14861, Vv = 1.78277, Hv = -0.29227, Td = -0.90649, dc = 1.97294, Pb = dc * Td, Lb = dc * Vv, Nb = Vv * Hv - Td * vS;
function eL(t) {
  if (t instanceof Xs) return new Xs(t.h, t.s, t.l, t.opacity);
  t instanceof kt || (t = zv(t));
  var e = t.r / 255, n = t.g / 255, r = t.b / 255, i = (Nb * r + Pb * e - Lb * n) / (Nb + Pb - Lb), s = r - i, o = (dc * (n - i) - Hv * s) / Td, a = Math.sqrt(o * o + s * s) / (dc * i * (1 - i)), l = a ? Math.atan2(o, s) * cS - 120 : NaN;
  return new Xs(l < 0 ? l + 360 : l, a, i, t.opacity);
}
function qr(t, e, n, r) {
  return arguments.length === 1 ? eL(t) : new Xs(t, e, n, r == null ? 1 : r);
}
function Xs(t, e, n, r) {
  this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
}
Va(Xs, qr, Zc(ws, {
  brighter(t) {
    return t = t == null ? pa : Math.pow(pa, t), new Xs(this.h, this.s, this.l * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? so : Math.pow(so, t), new Xs(this.h, this.s, this.l * t, this.opacity);
  },
  rgb() {
    var t = isNaN(this.h) ? 0 : (this.h + 120) * lS, e = +this.l, n = isNaN(this.s) ? 0 : this.s * e * (1 - e), r = Math.cos(t), i = Math.sin(t);
    return new kt(
      255 * (e + n * (vS * r + Vv * i)),
      255 * (e + n * (Hv * r + Td * i)),
      255 * (e + n * (dc * r)),
      this.opacity
    );
  }
}));
function tL(t, e, n, r, i) {
  var s = t * t, o = s * t;
  return ((1 - 3 * t + 3 * s - o) * e + (4 - 6 * s + 3 * o) * n + (1 + 3 * t + 3 * s - 3 * o) * r + o * i) / 6;
}
function nL(t) {
  var e = t.length - 1;
  return function(n) {
    var r = n <= 0 ? n = 0 : n >= 1 ? (n = 1, e - 1) : Math.floor(n * e), i = t[r], s = t[r + 1], o = r > 0 ? t[r - 1] : 2 * i - s, a = r < e - 1 ? t[r + 2] : 2 * s - i;
    return tL((n - r / e) * e, o, i, s, a);
  };
}
const Od = (t) => () => t;
function yS(t, e) {
  return function(n) {
    return t + n * e;
  };
}
function rL(t, e, n) {
  return t = Math.pow(t, n), e = Math.pow(e, n) - t, n = 1 / n, function(r) {
    return Math.pow(t + r * e, n);
  };
}
function Yv(t, e) {
  var n = e - t;
  return n ? yS(t, n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n) : Od(isNaN(t) ? e : t);
}
function iL(t) {
  return (t = +t) == 1 ? Vt : function(e, n) {
    return n - e ? rL(e, n, t) : Od(isNaN(e) ? n : e);
  };
}
function Vt(t, e) {
  var n = e - t;
  return n ? yS(t, n) : Od(isNaN(t) ? e : t);
}
const ao = function t(e) {
  var n = iL(e);
  function r(i, s) {
    var o = n((i = us(i)).r, (s = us(s)).r), a = n(i.g, s.g), l = n(i.b, s.b), c = Vt(i.opacity, s.opacity);
    return function(u) {
      return i.r = o(u), i.g = a(u), i.b = l(u), i.opacity = c(u), i + "";
    };
  }
  return r.gamma = t, r;
}(1);
function sL(t) {
  return function(e) {
    var n = e.length, r = new Array(n), i = new Array(n), s = new Array(n), o, a;
    for (o = 0; o < n; ++o)
      a = us(e[o]), r[o] = a.r || 0, i[o] = a.g || 0, s[o] = a.b || 0;
    return r = t(r), i = t(i), s = t(s), a.opacity = 1, function(l) {
      return a.r = r(l), a.g = i(l), a.b = s(l), a + "";
    };
  };
}
var oL = sL(nL);
function aL(t, e) {
  e || (e = []);
  var n = t ? Math.min(e.length, t.length) : 0, r = e.slice(), i;
  return function(s) {
    for (i = 0; i < n; ++i) r[i] = t[i] * (1 - s) + e[i] * s;
    return r;
  };
}
function lL(t) {
  return ArrayBuffer.isView(t) && !(t instanceof DataView);
}
function cL(t, e) {
  var n = e ? e.length : 0, r = t ? Math.min(n, t.length) : 0, i = new Array(r), s = new Array(n), o;
  for (o = 0; o < r; ++o) i[o] = Jc(t[o], e[o]);
  for (; o < n; ++o) s[o] = e[o];
  return function(a) {
    for (o = 0; o < r; ++o) s[o] = i[o](a);
    return s;
  };
}
function uL(t, e) {
  var n = /* @__PURE__ */ new Date();
  return t = +t, e = +e, function(r) {
    return n.setTime(t * (1 - r) + e * r), n;
  };
}
function Ft(t, e) {
  return t = +t, e = +e, function(n) {
    return t * (1 - n) + e * n;
  };
}
function fL(t, e) {
  var n = {}, r = {}, i;
  (t === null || typeof t != "object") && (t = {}), (e === null || typeof e != "object") && (e = {});
  for (i in e)
    i in t ? n[i] = Jc(t[i], e[i]) : r[i] = e[i];
  return function(s) {
    for (i in n) r[i] = n[i](s);
    return r;
  };
}
var Mg = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, Yp = new RegExp(Mg.source, "g");
function hL(t) {
  return function() {
    return t;
  };
}
function dL(t) {
  return function(e) {
    return t(e) + "";
  };
}
function bS(t, e) {
  var n = Mg.lastIndex = Yp.lastIndex = 0, r, i, s, o = -1, a = [], l = [];
  for (t = t + "", e = e + ""; (r = Mg.exec(t)) && (i = Yp.exec(e)); )
    (s = i.index) > n && (s = e.slice(n, s), a[o] ? a[o] += s : a[++o] = s), (r = r[0]) === (i = i[0]) ? a[o] ? a[o] += i : a[++o] = i : (a[++o] = null, l.push({ i: o, x: Ft(r, i) })), n = Yp.lastIndex;
  return n < e.length && (s = e.slice(n), a[o] ? a[o] += s : a[++o] = s), a.length < 2 ? l[0] ? dL(l[0].x) : hL(e) : (e = l.length, function(c) {
    for (var u = 0, h; u < e; ++u) a[(h = l[u]).i] = h.x(c);
    return a.join("");
  });
}
function Jc(t, e) {
  var n = typeof e, r;
  return e == null || n === "boolean" ? Od(e) : (n === "number" ? Ft : n === "string" ? (r = oo(e)) ? (e = r, ao) : bS : e instanceof oo ? ao : e instanceof Date ? uL : lL(e) ? aL : Array.isArray(e) ? cL : typeof e.valueOf != "function" && typeof e.toString != "function" || isNaN(e) ? fL : Ft)(t, e);
}
function Wv(t, e) {
  return t = +t, e = +e, function(n) {
    return Math.round(t * (1 - n) + e * n);
  };
}
var Ib = 180 / Math.PI, Cg = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function xS(t, e, n, r, i, s) {
  var o, a, l;
  return (o = Math.sqrt(t * t + e * e)) && (t /= o, e /= o), (l = t * n + e * r) && (n -= t * l, r -= e * l), (a = Math.sqrt(n * n + r * r)) && (n /= a, r /= a, l /= a), t * r < e * n && (t = -t, e = -e, l = -l, o = -o), {
    translateX: i,
    translateY: s,
    rotate: Math.atan2(e, t) * Ib,
    skewX: Math.atan(l) * Ib,
    scaleX: o,
    scaleY: a
  };
}
var Ru;
function pL(t) {
  const e = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(t + "");
  return e.isIdentity ? Cg : xS(e.a, e.b, e.c, e.d, e.e, e.f);
}
function mL(t) {
  return t == null || (Ru || (Ru = document.createElementNS("http://www.w3.org/2000/svg", "g")), Ru.setAttribute("transform", t), !(t = Ru.transform.baseVal.consolidate())) ? Cg : (t = t.matrix, xS(t.a, t.b, t.c, t.d, t.e, t.f));
}
function wS(t, e, n, r) {
  function i(c) {
    return c.length ? c.pop() + " " : "";
  }
  function s(c, u, h, f, d, p) {
    if (c !== h || u !== f) {
      var m = d.push("translate(", null, e, null, n);
      p.push({ i: m - 4, x: Ft(c, h) }, { i: m - 2, x: Ft(u, f) });
    } else (h || f) && d.push("translate(" + h + e + f + n);
  }
  function o(c, u, h, f) {
    c !== u ? (c - u > 180 ? u += 360 : u - c > 180 && (c += 360), f.push({ i: h.push(i(h) + "rotate(", null, r) - 2, x: Ft(c, u) })) : u && h.push(i(h) + "rotate(" + u + r);
  }
  function a(c, u, h, f) {
    c !== u ? f.push({ i: h.push(i(h) + "skewX(", null, r) - 2, x: Ft(c, u) }) : u && h.push(i(h) + "skewX(" + u + r);
  }
  function l(c, u, h, f, d, p) {
    if (c !== h || u !== f) {
      var m = d.push(i(d) + "scale(", null, ",", null, ")");
      p.push({ i: m - 4, x: Ft(c, h) }, { i: m - 2, x: Ft(u, f) });
    } else (h !== 1 || f !== 1) && d.push(i(d) + "scale(" + h + "," + f + ")");
  }
  return function(c, u) {
    var h = [], f = [];
    return c = t(c), u = t(u), s(c.translateX, c.translateY, u.translateX, u.translateY, h, f), o(c.rotate, u.rotate, h, f), a(c.skewX, u.skewX, h, f), l(c.scaleX, c.scaleY, u.scaleX, u.scaleY, h, f), c = u = null, function(d) {
      for (var p = -1, m = f.length, v; ++p < m; ) h[(v = f[p]).i] = v.x(d);
      return h.join("");
    };
  };
}
var gL = wS(pL, "px, ", "px)", "deg)"), vL = wS(mL, ", ", ")", ")");
function yL(t) {
  return function(e, n) {
    var r = t((e = kg(e)).h, (n = kg(n)).h), i = Vt(e.s, n.s), s = Vt(e.l, n.l), o = Vt(e.opacity, n.opacity);
    return function(a) {
      return e.h = r(a), e.s = i(a), e.l = s(a), e.opacity = o(a), e + "";
    };
  };
}
const bL = yL(Yv);
function xL(t, e) {
  var n = Vt((t = _g(t)).l, (e = _g(e)).l), r = Vt(t.a, e.a), i = Vt(t.b, e.b), s = Vt(t.opacity, e.opacity);
  return function(o) {
    return t.l = n(o), t.a = r(o), t.b = i(o), t.opacity = s(o), t + "";
  };
}
function wL(t) {
  return function(e, n) {
    var r = t((e = Sg(e)).h, (n = Sg(n)).h), i = Vt(e.c, n.c), s = Vt(e.l, n.l), o = Vt(e.opacity, n.opacity);
    return function(a) {
      return e.h = r(a), e.c = i(a), e.l = s(a), e.opacity = o(a), e + "";
    };
  };
}
const kL = wL(Yv);
function kS(t) {
  return function e(n) {
    n = +n;
    function r(i, s) {
      var o = t((i = qr(i)).h, (s = qr(s)).h), a = Vt(i.s, s.s), l = Vt(i.l, s.l), c = Vt(i.opacity, s.opacity);
      return function(u) {
        return i.h = o(u), i.s = a(u), i.l = l(Math.pow(u, n)), i.opacity = c(u), i + "";
      };
    }
    return r.gamma = e, r;
  }(1);
}
kS(Yv);
var jv = kS(Vt);
function Ed(t, e) {
  e === void 0 && (e = t, t = Jc);
  for (var n = 0, r = e.length - 1, i = e[0], s = new Array(r < 0 ? 0 : r); n < r; ) s[n] = t(i, i = e[++n]);
  return function(o) {
    var a = Math.max(0, Math.min(r - 1, Math.floor(o *= r)));
    return s[a](o - a);
  };
}
function fr(t, e) {
  for (var n = new Array(e), r = 0; r < e; ++r) n[r] = t(r / (e - 1));
  return n;
}
var ma = 0, Al = 0, ll = 0, _S = 1e3, lh, Dl, ch = 0, lo = 0, Pd = 0, pc = typeof performance == "object" && performance.now ? performance : Date, SS = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(t) {
  setTimeout(t, 17);
};
function qv() {
  return lo || (SS(_L), lo = pc.now() + Pd);
}
function _L() {
  lo = 0;
}
function uh() {
  this._call = this._time = this._next = null;
}
uh.prototype = MS.prototype = {
  constructor: uh,
  restart: function(t, e, n) {
    if (typeof t != "function") throw new TypeError("callback is not a function");
    n = (n == null ? qv() : +n) + (e == null ? 0 : +e), !this._next && Dl !== this && (Dl ? Dl._next = this : lh = this, Dl = this), this._call = t, this._time = n, $g();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, $g());
  }
};
function MS(t, e, n) {
  var r = new uh();
  return r.restart(t, e, n), r;
}
function SL() {
  qv(), ++ma;
  for (var t = lh, e; t; )
    (e = lo - t._time) >= 0 && t._call.call(void 0, e), t = t._next;
  --ma;
}
function Rb() {
  lo = (ch = pc.now()) + Pd, ma = Al = 0;
  try {
    SL();
  } finally {
    ma = 0, CL(), lo = 0;
  }
}
function ML() {
  var t = pc.now(), e = t - ch;
  e > _S && (Pd -= e, ch = t);
}
function CL() {
  for (var t, e = lh, n, r = 1 / 0; e; )
    e._call ? (r > e._time && (r = e._time), t = e, e = e._next) : (n = e._next, e._next = null, e = t ? t._next = n : lh = n);
  Dl = t, $g(r);
}
function $g(t) {
  if (!ma) {
    Al && (Al = clearTimeout(Al));
    var e = t - lo;
    e > 24 ? (t < 1 / 0 && (Al = setTimeout(Rb, t - pc.now() - Pd)), ll && (ll = clearInterval(ll))) : (ll || (ch = pc.now(), ll = setInterval(ML, _S)), ma = 1, SS(Rb));
  }
}
function Bb(t, e, n) {
  var r = new uh();
  return e = e == null ? 0 : +e, r.restart((i) => {
    r.stop(), t(i + e);
  }, e, n), r;
}
var $L = G3("start", "end", "cancel", "interrupt"), AL = [], CS = 0, Fb = 1, Ag = 2, Tf = 3, zb = 4, Dg = 5, Of = 6;
function Ld(t, e, n, r, i, s) {
  var o = t.__transition;
  if (!o) t.__transition = {};
  else if (n in o) return;
  DL(t, n, {
    name: e,
    index: r,
    // For context during callback.
    group: i,
    // For context during callback.
    on: $L,
    tween: AL,
    time: s.time,
    delay: s.delay,
    duration: s.duration,
    ease: s.ease,
    timer: null,
    state: CS
  });
}
function Uv(t, e) {
  var n = vr(t, e);
  if (n.state > CS) throw new Error("too late; already scheduled");
  return n;
}
function Xr(t, e) {
  var n = vr(t, e);
  if (n.state > Tf) throw new Error("too late; already running");
  return n;
}
function vr(t, e) {
  var n = t.__transition;
  if (!n || !(n = n[e])) throw new Error("transition not found");
  return n;
}
function DL(t, e, n) {
  var r = t.__transition, i;
  r[e] = n, n.timer = MS(s, 0, n.time);
  function s(c) {
    n.state = Fb, n.timer.restart(o, n.delay, n.time), n.delay <= c && o(c - n.delay);
  }
  function o(c) {
    var u, h, f, d;
    if (n.state !== Fb) return l();
    for (u in r)
      if (d = r[u], d.name === n.name) {
        if (d.state === Tf) return Bb(o);
        d.state === zb ? (d.state = Of, d.timer.stop(), d.on.call("interrupt", t, t.__data__, d.index, d.group), delete r[u]) : +u < e && (d.state = Of, d.timer.stop(), d.on.call("cancel", t, t.__data__, d.index, d.group), delete r[u]);
      }
    if (Bb(function() {
      n.state === Tf && (n.state = zb, n.timer.restart(a, n.delay, n.time), a(c));
    }), n.state = Ag, n.on.call("start", t, t.__data__, n.index, n.group), n.state === Ag) {
      for (n.state = Tf, i = new Array(f = n.tween.length), u = 0, h = -1; u < f; ++u)
        (d = n.tween[u].value.call(t, t.__data__, n.index, n.group)) && (i[++h] = d);
      i.length = h + 1;
    }
  }
  function a(c) {
    for (var u = c < n.duration ? n.ease.call(null, c / n.duration) : (n.timer.restart(l), n.state = Dg, 1), h = -1, f = i.length; ++h < f; )
      i[h].call(t, u);
    n.state === Dg && (n.on.call("end", t, t.__data__, n.index, n.group), l());
  }
  function l() {
    n.state = Of, n.timer.stop(), delete r[e];
    for (var c in r) return;
    delete t.__transition;
  }
}
function TL(t, e) {
  var n = t.__transition, r, i, s = !0, o;
  if (n) {
    e = e == null ? null : e + "";
    for (o in n) {
      if ((r = n[o]).name !== e) {
        s = !1;
        continue;
      }
      i = r.state > Ag && r.state < Dg, r.state = Of, r.timer.stop(), r.on.call(i ? "interrupt" : "cancel", t, t.__data__, r.index, r.group), delete n[o];
    }
    s && delete t.__transition;
  }
}
function OL(t) {
  return this.each(function() {
    TL(this, t);
  });
}
function EL(t, e) {
  var n, r;
  return function() {
    var i = Xr(this, t), s = i.tween;
    if (s !== n) {
      r = n = s;
      for (var o = 0, a = r.length; o < a; ++o)
        if (r[o].name === e) {
          r = r.slice(), r.splice(o, 1);
          break;
        }
    }
    i.tween = r;
  };
}
function PL(t, e, n) {
  var r, i;
  if (typeof n != "function") throw new Error();
  return function() {
    var s = Xr(this, t), o = s.tween;
    if (o !== r) {
      i = (r = o).slice();
      for (var a = { name: e, value: n }, l = 0, c = i.length; l < c; ++l)
        if (i[l].name === e) {
          i[l] = a;
          break;
        }
      l === c && i.push(a);
    }
    s.tween = i;
  };
}
function LL(t, e) {
  var n = this._id;
  if (t += "", arguments.length < 2) {
    for (var r = vr(this.node(), n).tween, i = 0, s = r.length, o; i < s; ++i)
      if ((o = r[i]).name === t)
        return o.value;
    return null;
  }
  return this.each((e == null ? EL : PL)(n, t, e));
}
function Kv(t, e, n) {
  var r = t._id;
  return t.each(function() {
    var i = Xr(this, r);
    (i.value || (i.value = {}))[e] = n.apply(this, arguments);
  }), function(i) {
    return vr(i, r).value[e];
  };
}
function $S(t, e) {
  var n;
  return (typeof e == "number" ? Ft : e instanceof oo ? ao : (n = oo(e)) ? (e = n, ao) : bS)(t, e);
}
function NL(t) {
  return function() {
    this.removeAttribute(t);
  };
}
function IL(t) {
  return function() {
    this.removeAttributeNS(t.space, t.local);
  };
}
function RL(t, e, n) {
  var r, i = n + "", s;
  return function() {
    var o = this.getAttribute(t);
    return o === i ? null : o === r ? s : s = e(r = o, n);
  };
}
function BL(t, e, n) {
  var r, i = n + "", s;
  return function() {
    var o = this.getAttributeNS(t.space, t.local);
    return o === i ? null : o === r ? s : s = e(r = o, n);
  };
}
function FL(t, e, n) {
  var r, i, s;
  return function() {
    var o, a = n(this), l;
    return a == null ? void this.removeAttribute(t) : (o = this.getAttribute(t), l = a + "", o === l ? null : o === r && l === i ? s : (i = l, s = e(r = o, a)));
  };
}
function zL(t, e, n) {
  var r, i, s;
  return function() {
    var o, a = n(this), l;
    return a == null ? void this.removeAttributeNS(t.space, t.local) : (o = this.getAttributeNS(t.space, t.local), l = a + "", o === l ? null : o === r && l === i ? s : (i = l, s = e(r = o, a)));
  };
}
function VL(t, e) {
  var n = Ad(t), r = n === "transform" ? vL : $S;
  return this.attrTween(t, typeof e == "function" ? (n.local ? zL : FL)(n, r, Kv(this, "attr." + t, e)) : e == null ? (n.local ? IL : NL)(n) : (n.local ? BL : RL)(n, r, e));
}
function HL(t, e) {
  return function(n) {
    this.setAttribute(t, e.call(this, n));
  };
}
function YL(t, e) {
  return function(n) {
    this.setAttributeNS(t.space, t.local, e.call(this, n));
  };
}
function WL(t, e) {
  var n, r;
  function i() {
    var s = e.apply(this, arguments);
    return s !== r && (n = (r = s) && YL(t, s)), n;
  }
  return i._value = e, i;
}
function jL(t, e) {
  var n, r;
  function i() {
    var s = e.apply(this, arguments);
    return s !== r && (n = (r = s) && HL(t, s)), n;
  }
  return i._value = e, i;
}
function qL(t, e) {
  var n = "attr." + t;
  if (arguments.length < 2) return (n = this.tween(n)) && n._value;
  if (e == null) return this.tween(n, null);
  if (typeof e != "function") throw new Error();
  var r = Ad(t);
  return this.tween(n, (r.local ? WL : jL)(r, e));
}
function UL(t, e) {
  return function() {
    Uv(this, t).delay = +e.apply(this, arguments);
  };
}
function KL(t, e) {
  return e = +e, function() {
    Uv(this, t).delay = e;
  };
}
function GL(t) {
  var e = this._id;
  return arguments.length ? this.each((typeof t == "function" ? UL : KL)(e, t)) : vr(this.node(), e).delay;
}
function XL(t, e) {
  return function() {
    Xr(this, t).duration = +e.apply(this, arguments);
  };
}
function ZL(t, e) {
  return e = +e, function() {
    Xr(this, t).duration = e;
  };
}
function JL(t) {
  var e = this._id;
  return arguments.length ? this.each((typeof t == "function" ? XL : ZL)(e, t)) : vr(this.node(), e).duration;
}
function QL(t, e) {
  if (typeof e != "function") throw new Error();
  return function() {
    Xr(this, t).ease = e;
  };
}
function eN(t) {
  var e = this._id;
  return arguments.length ? this.each(QL(e, t)) : vr(this.node(), e).ease;
}
function tN(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    if (typeof n != "function") throw new Error();
    Xr(this, t).ease = n;
  };
}
function nN(t) {
  if (typeof t != "function") throw new Error();
  return this.each(tN(this._id, t));
}
function rN(t) {
  typeof t != "function" && (t = Z3(t));
  for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i)
    for (var s = e[i], o = s.length, a = r[i] = [], l, c = 0; c < o; ++c)
      (l = s[c]) && t.call(l, l.__data__, c, s) && a.push(l);
  return new bi(r, this._parents, this._name, this._id);
}
function iN(t) {
  if (t._id !== this._id) throw new Error();
  for (var e = this._groups, n = t._groups, r = e.length, i = n.length, s = Math.min(r, i), o = new Array(r), a = 0; a < s; ++a)
    for (var l = e[a], c = n[a], u = l.length, h = o[a] = new Array(u), f, d = 0; d < u; ++d)
      (f = l[d] || c[d]) && (h[d] = f);
  for (; a < r; ++a)
    o[a] = e[a];
  return new bi(o, this._parents, this._name, this._id);
}
function sN(t) {
  return (t + "").trim().split(/^|\s+/).every(function(e) {
    var n = e.indexOf(".");
    return n >= 0 && (e = e.slice(0, n)), !e || e === "start";
  });
}
function oN(t, e, n) {
  var r, i, s = sN(e) ? Uv : Xr;
  return function() {
    var o = s(this, t), a = o.on;
    a !== r && (i = (r = a).copy()).on(e, n), o.on = i;
  };
}
function aN(t, e) {
  var n = this._id;
  return arguments.length < 2 ? vr(this.node(), n).on.on(t) : this.each(oN(n, t, e));
}
function lN(t) {
  return function() {
    var e = this.parentNode;
    for (var n in this.__transition) if (+n !== t) return;
    e && e.removeChild(this);
  };
}
function cN() {
  return this.on("end.remove", lN(this._id));
}
function uN(t) {
  var e = this._name, n = this._id;
  typeof t != "function" && (t = Bv(t));
  for (var r = this._groups, i = r.length, s = new Array(i), o = 0; o < i; ++o)
    for (var a = r[o], l = a.length, c = s[o] = new Array(l), u, h, f = 0; f < l; ++f)
      (u = a[f]) && (h = t.call(u, u.__data__, f, a)) && ("__data__" in u && (h.__data__ = u.__data__), c[f] = h, Ld(c[f], e, n, f, c, vr(u, n)));
  return new bi(s, this._parents, e, n);
}
function fN(t) {
  var e = this._name, n = this._id;
  typeof t != "function" && (t = X3(t));
  for (var r = this._groups, i = r.length, s = [], o = [], a = 0; a < i; ++a)
    for (var l = r[a], c = l.length, u, h = 0; h < c; ++h)
      if (u = l[h]) {
        for (var f = t.call(u, u.__data__, h, l), d, p = vr(u, n), m = 0, v = f.length; m < v; ++m)
          (d = f[m]) && Ld(d, e, n, m, f, p);
        s.push(f), o.push(u);
      }
  return new bi(s, o, e, n);
}
var hN = Xc.prototype.constructor;
function dN() {
  return new hN(this._groups, this._parents);
}
function pN(t, e) {
  var n, r, i;
  return function() {
    var s = da(this, t), o = (this.style.removeProperty(t), da(this, t));
    return s === o ? null : s === n && o === r ? i : i = e(n = s, r = o);
  };
}
function AS(t) {
  return function() {
    this.style.removeProperty(t);
  };
}
function mN(t, e, n) {
  var r, i = n + "", s;
  return function() {
    var o = da(this, t);
    return o === i ? null : o === r ? s : s = e(r = o, n);
  };
}
function gN(t, e, n) {
  var r, i, s;
  return function() {
    var o = da(this, t), a = n(this), l = a + "";
    return a == null && (l = a = (this.style.removeProperty(t), da(this, t))), o === l ? null : o === r && l === i ? s : (i = l, s = e(r = o, a));
  };
}
function vN(t, e) {
  var n, r, i, s = "style." + e, o = "end." + s, a;
  return function() {
    var l = Xr(this, t), c = l.on, u = l.value[s] == null ? a || (a = AS(e)) : void 0;
    (c !== n || i !== u) && (r = (n = c).copy()).on(o, i = u), l.on = r;
  };
}
function yN(t, e, n) {
  var r = (t += "") == "transform" ? gL : $S;
  return e == null ? this.styleTween(t, pN(t, r)).on("end.style." + t, AS(t)) : typeof e == "function" ? this.styleTween(t, gN(t, r, Kv(this, "style." + t, e))).each(vN(this._id, t)) : this.styleTween(t, mN(t, r, e), n).on("end.style." + t, null);
}
function bN(t, e, n) {
  return function(r) {
    this.style.setProperty(t, e.call(this, r), n);
  };
}
function xN(t, e, n) {
  var r, i;
  function s() {
    var o = e.apply(this, arguments);
    return o !== i && (r = (i = o) && bN(t, o, n)), r;
  }
  return s._value = e, s;
}
function wN(t, e, n) {
  var r = "style." + (t += "");
  if (arguments.length < 2) return (r = this.tween(r)) && r._value;
  if (e == null) return this.tween(r, null);
  if (typeof e != "function") throw new Error();
  return this.tween(r, xN(t, e, n == null ? "" : n));
}
function kN(t) {
  return function() {
    this.textContent = t;
  };
}
function _N(t) {
  return function() {
    var e = t(this);
    this.textContent = e == null ? "" : e;
  };
}
function SN(t) {
  return this.tween("text", typeof t == "function" ? _N(Kv(this, "text", t)) : kN(t == null ? "" : t + ""));
}
function MN(t) {
  return function(e) {
    this.textContent = t.call(this, e);
  };
}
function CN(t) {
  var e, n;
  function r() {
    var i = t.apply(this, arguments);
    return i !== n && (e = (n = i) && MN(i)), e;
  }
  return r._value = t, r;
}
function $N(t) {
  var e = "text";
  if (arguments.length < 1) return (e = this.tween(e)) && e._value;
  if (t == null) return this.tween(e, null);
  if (typeof t != "function") throw new Error();
  return this.tween(e, CN(t));
}
function AN() {
  for (var t = this._name, e = this._id, n = DS(), r = this._groups, i = r.length, s = 0; s < i; ++s)
    for (var o = r[s], a = o.length, l, c = 0; c < a; ++c)
      if (l = o[c]) {
        var u = vr(l, e);
        Ld(l, t, n, c, o, {
          time: u.time + u.delay + u.duration,
          delay: 0,
          duration: u.duration,
          ease: u.ease
        });
      }
  return new bi(r, this._parents, t, n);
}
function DN() {
  var t, e, n = this, r = n._id, i = n.size();
  return new Promise(function(s, o) {
    var a = { value: o }, l = { value: function() {
      --i === 0 && s();
    } };
    n.each(function() {
      var c = Xr(this, r), u = c.on;
      u !== t && (e = (t = u).copy(), e._.cancel.push(a), e._.interrupt.push(a), e._.end.push(l)), c.on = e;
    }), i === 0 && s();
  });
}
var TN = 0;
function bi(t, e, n, r) {
  this._groups = t, this._parents = e, this._name = n, this._id = r;
}
function DS() {
  return ++TN;
}
var ni = Xc.prototype;
bi.prototype = {
  constructor: bi,
  select: uN,
  selectAll: fN,
  selectChild: ni.selectChild,
  selectChildren: ni.selectChildren,
  filter: rN,
  merge: iN,
  selection: dN,
  transition: AN,
  call: ni.call,
  nodes: ni.nodes,
  node: ni.node,
  size: ni.size,
  empty: ni.empty,
  each: ni.each,
  on: aN,
  attr: VL,
  attrTween: qL,
  style: yN,
  styleTween: wN,
  text: SN,
  textTween: $N,
  remove: cN,
  tween: LL,
  delay: GL,
  duration: JL,
  ease: eN,
  easeVarying: nN,
  end: DN,
  [Symbol.iterator]: ni[Symbol.iterator]
};
function ON(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}
var EN = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: ON
};
function PN(t, e) {
  for (var n; !(n = t.__transition) || !(n = n[e]); )
    if (!(t = t.parentNode))
      throw new Error(`transition ${e} not found`);
  return n;
}
function LN(t) {
  var e, n;
  t instanceof bi ? (e = t._id, t = t._name) : (e = DS(), (n = EN).time = qv(), t = t == null ? null : t + "");
  for (var r = this._groups, i = r.length, s = 0; s < i; ++s)
    for (var o = r[s], a = o.length, l, c = 0; c < a; ++c)
      (l = o[c]) && Ld(l, t, e, c, o, n || PN(l, e));
  return new bi(r, this._parents, t, e);
}
Xc.prototype.interrupt = OL;
Xc.prototype.transition = LN;
const Tg = Math.PI, Og = 2 * Tg, Ls = 1e-6, NN = Og - Ls;
function TS(t) {
  this._ += t[0];
  for (let e = 1, n = t.length; e < n; ++e)
    this._ += arguments[e] + t[e];
}
function IN(t) {
  let e = Math.floor(t);
  if (!(e >= 0)) throw new Error(`invalid digits: ${t}`);
  if (e > 15) return TS;
  const n = 10 ** e;
  return function(r) {
    this._ += r[0];
    for (let i = 1, s = r.length; i < s; ++i)
      this._ += Math.round(arguments[i] * n) / n + r[i];
  };
}
class OS {
  constructor(e) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = e == null ? TS : IN(e);
  }
  moveTo(e, n) {
    this._append`M${this._x0 = this._x1 = +e},${this._y0 = this._y1 = +n}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(e, n) {
    this._append`L${this._x1 = +e},${this._y1 = +n}`;
  }
  quadraticCurveTo(e, n, r, i) {
    this._append`Q${+e},${+n},${this._x1 = +r},${this._y1 = +i}`;
  }
  bezierCurveTo(e, n, r, i, s, o) {
    this._append`C${+e},${+n},${+r},${+i},${this._x1 = +s},${this._y1 = +o}`;
  }
  arcTo(e, n, r, i, s) {
    if (e = +e, n = +n, r = +r, i = +i, s = +s, s < 0) throw new Error(`negative radius: ${s}`);
    let o = this._x1, a = this._y1, l = r - e, c = i - n, u = o - e, h = a - n, f = u * u + h * h;
    if (this._x1 === null)
      this._append`M${this._x1 = e},${this._y1 = n}`;
    else if (f > Ls) if (!(Math.abs(h * l - c * u) > Ls) || !s)
      this._append`L${this._x1 = e},${this._y1 = n}`;
    else {
      let d = r - o, p = i - a, m = l * l + c * c, v = d * d + p * p, g = Math.sqrt(m), y = Math.sqrt(f), x = s * Math.tan((Tg - Math.acos((m + f - v) / (2 * g * y))) / 2), b = x / y, w = x / g;
      Math.abs(b - 1) > Ls && this._append`L${e + b * u},${n + b * h}`, this._append`A${s},${s},0,0,${+(h * d > u * p)},${this._x1 = e + w * l},${this._y1 = n + w * c}`;
    }
  }
  arc(e, n, r, i, s, o) {
    if (e = +e, n = +n, r = +r, o = !!o, r < 0) throw new Error(`negative radius: ${r}`);
    let a = r * Math.cos(i), l = r * Math.sin(i), c = e + a, u = n + l, h = 1 ^ o, f = o ? i - s : s - i;
    this._x1 === null ? this._append`M${c},${u}` : (Math.abs(this._x1 - c) > Ls || Math.abs(this._y1 - u) > Ls) && this._append`L${c},${u}`, r && (f < 0 && (f = f % Og + Og), f > NN ? this._append`A${r},${r},0,1,${h},${e - a},${n - l}A${r},${r},0,1,${h},${this._x1 = c},${this._y1 = u}` : f > Ls && this._append`A${r},${r},0,${+(f >= Tg)},${h},${this._x1 = e + r * Math.cos(s)},${this._y1 = n + r * Math.sin(s)}`);
  }
  rect(e, n, r, i) {
    this._append`M${this._x0 = this._x1 = +e},${this._y0 = this._y1 = +n}h${r = +r}v${+i}h${-r}Z`;
  }
  toString() {
    return this._;
  }
}
function Eg(t = 3) {
  return new OS(+t);
}
function RN(t) {
  return Math.abs(t = Math.round(t)) >= 1e21 ? t.toLocaleString("en").replace(/,/g, "") : t.toString(10);
}
function fh(t, e) {
  if ((n = (t = e ? t.toExponential(e - 1) : t.toExponential()).indexOf("e")) < 0) return null;
  var n, r = t.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +t.slice(n + 1)
  ];
}
function ga(t) {
  return t = fh(Math.abs(t)), t ? t[1] : NaN;
}
function BN(t, e) {
  return function(n, r) {
    for (var i = n.length, s = [], o = 0, a = t[0], l = 0; i > 0 && a > 0 && (l + a + 1 > r && (a = Math.max(1, r - l)), s.push(n.substring(i -= a, i + a)), !((l += a + 1) > r)); )
      a = t[o = (o + 1) % t.length];
    return s.reverse().join(e);
  };
}
function FN(t) {
  return function(e) {
    return e.replace(/[0-9]/g, function(n) {
      return t[+n];
    });
  };
}
var zN = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function mc(t) {
  if (!(e = zN.exec(t))) throw new Error("invalid format: " + t);
  var e;
  return new Gv({
    fill: e[1],
    align: e[2],
    sign: e[3],
    symbol: e[4],
    zero: e[5],
    width: e[6],
    comma: e[7],
    precision: e[8] && e[8].slice(1),
    trim: e[9],
    type: e[10]
  });
}
mc.prototype = Gv.prototype;
function Gv(t) {
  this.fill = t.fill === void 0 ? " " : t.fill + "", this.align = t.align === void 0 ? ">" : t.align + "", this.sign = t.sign === void 0 ? "-" : t.sign + "", this.symbol = t.symbol === void 0 ? "" : t.symbol + "", this.zero = !!t.zero, this.width = t.width === void 0 ? void 0 : +t.width, this.comma = !!t.comma, this.precision = t.precision === void 0 ? void 0 : +t.precision, this.trim = !!t.trim, this.type = t.type === void 0 ? "" : t.type + "";
}
Gv.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function VN(t) {
  e: for (var e = t.length, n = 1, r = -1, i; n < e; ++n)
    switch (t[n]) {
      case ".":
        r = i = n;
        break;
      case "0":
        r === 0 && (r = n), i = n;
        break;
      default:
        if (!+t[n]) break e;
        r > 0 && (r = 0);
        break;
    }
  return r > 0 ? t.slice(0, r) + t.slice(i + 1) : t;
}
var ES;
function HN(t, e) {
  var n = fh(t, e);
  if (!n) return t + "";
  var r = n[0], i = n[1], s = i - (ES = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, o = r.length;
  return s === o ? r : s > o ? r + new Array(s - o + 1).join("0") : s > 0 ? r.slice(0, s) + "." + r.slice(s) : "0." + new Array(1 - s).join("0") + fh(t, Math.max(0, e + s - 1))[0];
}
function Vb(t, e) {
  var n = fh(t, e);
  if (!n) return t + "";
  var r = n[0], i = n[1];
  return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
}
const Hb = {
  "%": (t, e) => (t * 100).toFixed(e),
  b: (t) => Math.round(t).toString(2),
  c: (t) => t + "",
  d: RN,
  e: (t, e) => t.toExponential(e),
  f: (t, e) => t.toFixed(e),
  g: (t, e) => t.toPrecision(e),
  o: (t) => Math.round(t).toString(8),
  p: (t, e) => Vb(t * 100, e),
  r: Vb,
  s: HN,
  X: (t) => Math.round(t).toString(16).toUpperCase(),
  x: (t) => Math.round(t).toString(16)
};
function Yb(t) {
  return t;
}
var Wb = Array.prototype.map, jb = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function YN(t) {
  var e = t.grouping === void 0 || t.thousands === void 0 ? Yb : BN(Wb.call(t.grouping, Number), t.thousands + ""), n = t.currency === void 0 ? "" : t.currency[0] + "", r = t.currency === void 0 ? "" : t.currency[1] + "", i = t.decimal === void 0 ? "." : t.decimal + "", s = t.numerals === void 0 ? Yb : FN(Wb.call(t.numerals, String)), o = t.percent === void 0 ? "%" : t.percent + "", a = t.minus === void 0 ? "−" : t.minus + "", l = t.nan === void 0 ? "NaN" : t.nan + "";
  function c(h) {
    h = mc(h);
    var f = h.fill, d = h.align, p = h.sign, m = h.symbol, v = h.zero, g = h.width, y = h.comma, x = h.precision, b = h.trim, w = h.type;
    w === "n" ? (y = !0, w = "g") : Hb[w] || (x === void 0 && (x = 12), b = !0, w = "g"), (v || f === "0" && d === "=") && (v = !0, f = "0", d = "=");
    var k = m === "$" ? n : m === "#" && /[boxX]/.test(w) ? "0" + w.toLowerCase() : "", _ = m === "$" ? r : /[%p]/.test(w) ? o : "", C = Hb[w], E = /[defgprs%]/.test(w);
    x = x === void 0 ? 6 : /[gprs]/.test(w) ? Math.max(1, Math.min(21, x)) : Math.max(0, Math.min(20, x));
    function L(M) {
      var O = k, N = _, R, $, F;
      if (w === "c")
        N = C(M) + N, M = "";
      else {
        M = +M;
        var U = M < 0 || 1 / M < 0;
        if (M = isNaN(M) ? l : C(Math.abs(M), x), b && (M = VN(M)), U && +M == 0 && p !== "+" && (U = !1), O = (U ? p === "(" ? p : a : p === "-" || p === "(" ? "" : p) + O, N = (w === "s" ? jb[8 + ES / 3] : "") + N + (U && p === "(" ? ")" : ""), E) {
          for (R = -1, $ = M.length; ++R < $; )
            if (F = M.charCodeAt(R), 48 > F || F > 57) {
              N = (F === 46 ? i + M.slice(R + 1) : M.slice(R)) + N, M = M.slice(0, R);
              break;
            }
        }
      }
      y && !v && (M = e(M, 1 / 0));
      var ee = O.length + M.length + N.length, ie = ee < g ? new Array(g - ee + 1).join(f) : "";
      switch (y && v && (M = e(ie + M, ie.length ? g - N.length : 1 / 0), ie = ""), d) {
        case "<":
          M = O + M + N + ie;
          break;
        case "=":
          M = O + ie + M + N;
          break;
        case "^":
          M = ie.slice(0, ee = ie.length >> 1) + O + M + N + ie.slice(ee);
          break;
        default:
          M = ie + O + M + N;
          break;
      }
      return s(M);
    }
    return L.toString = function() {
      return h + "";
    }, L;
  }
  function u(h, f) {
    var d = c((h = mc(h), h.type = "f", h)), p = Math.max(-8, Math.min(8, Math.floor(ga(f) / 3))) * 3, m = Math.pow(10, -p), v = jb[8 + p / 3];
    return function(g) {
      return d(m * g) + v;
    };
  }
  return {
    format: c,
    formatPrefix: u
  };
}
var Bu, Ha, PS;
WN({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function WN(t) {
  return Bu = YN(t), Ha = Bu.format, PS = Bu.formatPrefix, Bu;
}
function jN(t) {
  return Math.max(0, -ga(Math.abs(t)));
}
function qN(t, e) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(ga(e) / 3))) * 3 - ga(Math.abs(t)));
}
function UN(t, e) {
  return t = Math.abs(t), e = Math.abs(e) - t, Math.max(0, ga(e) - ga(t)) + 1;
}
var Ae = 1e-6, LS = 1e-12, Oe = Math.PI, lt = Oe / 2, qb = Oe / 4, Dn = Oe * 2, Gt = 180 / Oe, ot = Oe / 180, Ye = Math.abs, Ya = Math.atan, xi = Math.atan2, Te = Math.cos, NS = Math.exp, hh = Math.log, Wp = Math.pow, Ce = Math.sin, Rn = Math.sign || function(t) {
  return t > 0 ? 1 : t < 0 ? -1 : 0;
}, mn = Math.sqrt, Xv = Math.tan;
function IS(t) {
  return t > 1 ? 0 : t < -1 ? Oe : Math.acos(t);
}
function Xn(t) {
  return t > 1 ? lt : t < -1 ? -lt : Math.asin(t);
}
function Bn() {
}
function dh(t, e) {
  t && Kb.hasOwnProperty(t.type) && Kb[t.type](t, e);
}
var Ub = {
  Feature: function(t, e) {
    dh(t.geometry, e);
  },
  FeatureCollection: function(t, e) {
    for (var n = t.features, r = -1, i = n.length; ++r < i; ) dh(n[r].geometry, e);
  }
}, Kb = {
  Sphere: function(t, e) {
    e.sphere();
  },
  Point: function(t, e) {
    t = t.coordinates, e.point(t[0], t[1], t[2]);
  },
  MultiPoint: function(t, e) {
    for (var n = t.coordinates, r = -1, i = n.length; ++r < i; ) t = n[r], e.point(t[0], t[1], t[2]);
  },
  LineString: function(t, e) {
    Pg(t.coordinates, e, 0);
  },
  MultiLineString: function(t, e) {
    for (var n = t.coordinates, r = -1, i = n.length; ++r < i; ) Pg(n[r], e, 0);
  },
  Polygon: function(t, e) {
    Gb(t.coordinates, e);
  },
  MultiPolygon: function(t, e) {
    for (var n = t.coordinates, r = -1, i = n.length; ++r < i; ) Gb(n[r], e);
  },
  GeometryCollection: function(t, e) {
    for (var n = t.geometries, r = -1, i = n.length; ++r < i; ) dh(n[r], e);
  }
};
function Pg(t, e, n) {
  var r = -1, i = t.length - n, s;
  for (e.lineStart(); ++r < i; ) s = t[r], e.point(s[0], s[1], s[2]);
  e.lineEnd();
}
function Gb(t, e) {
  var n = -1, r = t.length;
  for (e.polygonStart(); ++n < r; ) Pg(t[n], e, 1);
  e.polygonEnd();
}
function Rs(t, e) {
  t && Ub.hasOwnProperty(t.type) ? Ub[t.type](t, e) : dh(t, e);
}
function Lg(t) {
  return [xi(t[1], t[0]), Xn(t[2])];
}
function va(t) {
  var e = t[0], n = t[1], r = Te(n);
  return [r * Te(e), r * Ce(e), Ce(n)];
}
function Fu(t, e) {
  return t[0] * e[0] + t[1] * e[1] + t[2] * e[2];
}
function ph(t, e) {
  return [t[1] * e[2] - t[2] * e[1], t[2] * e[0] - t[0] * e[2], t[0] * e[1] - t[1] * e[0]];
}
function jp(t, e) {
  t[0] += e[0], t[1] += e[1], t[2] += e[2];
}
function zu(t, e) {
  return [t[0] * e, t[1] * e, t[2] * e];
}
function Ng(t) {
  var e = mn(t[0] * t[0] + t[1] * t[1] + t[2] * t[2]);
  t[0] /= e, t[1] /= e, t[2] /= e;
}
function Ig(t, e) {
  function n(r, i) {
    return r = t(r, i), e(r[0], r[1]);
  }
  return t.invert && e.invert && (n.invert = function(r, i) {
    return r = e.invert(r, i), r && t.invert(r[0], r[1]);
  }), n;
}
function Rg(t, e) {
  return Ye(t) > Oe && (t -= Math.round(t / Dn) * Dn), [t, e];
}
Rg.invert = Rg;
function RS(t, e, n) {
  return (t %= Dn) ? e || n ? Ig(Zb(t), Jb(e, n)) : Zb(t) : e || n ? Jb(e, n) : Rg;
}
function Xb(t) {
  return function(e, n) {
    return e += t, Ye(e) > Oe && (e -= Math.round(e / Dn) * Dn), [e, n];
  };
}
function Zb(t) {
  var e = Xb(t);
  return e.invert = Xb(-t), e;
}
function Jb(t, e) {
  var n = Te(t), r = Ce(t), i = Te(e), s = Ce(e);
  function o(a, l) {
    var c = Te(l), u = Te(a) * c, h = Ce(a) * c, f = Ce(l), d = f * n + u * r;
    return [
      xi(h * i - d * s, u * n - f * r),
      Xn(d * i + h * s)
    ];
  }
  return o.invert = function(a, l) {
    var c = Te(l), u = Te(a) * c, h = Ce(a) * c, f = Ce(l), d = f * i - h * s;
    return [
      xi(h * i + f * s, u * n + d * r),
      Xn(d * n - u * r)
    ];
  }, o;
}
function KN(t) {
  t = RS(t[0] * ot, t[1] * ot, t.length > 2 ? t[2] * ot : 0);
  function e(n) {
    return n = t(n[0] * ot, n[1] * ot), n[0] *= Gt, n[1] *= Gt, n;
  }
  return e.invert = function(n) {
    return n = t.invert(n[0] * ot, n[1] * ot), n[0] *= Gt, n[1] *= Gt, n;
  }, e;
}
function GN(t, e, n, r, i, s) {
  if (n) {
    var o = Te(e), a = Ce(e), l = r * n;
    i == null ? (i = e + r * Dn, s = e - l / 2) : (i = Qb(o, i), s = Qb(o, s), (r > 0 ? i < s : i > s) && (i += r * Dn));
    for (var c, u = i; r > 0 ? u > s : u < s; u -= l)
      c = Lg([o, -a * Te(u), -a * Ce(u)]), t.point(c[0], c[1]);
  }
}
function Qb(t, e) {
  e = va(e), e[0] -= t, Ng(e);
  var n = IS(-e[1]);
  return ((-e[2] < 0 ? -n : n) + Dn - Ae) % Dn;
}
function BS() {
  var t = [], e;
  return {
    point: function(n, r, i) {
      e.push([n, r, i]);
    },
    lineStart: function() {
      t.push(e = []);
    },
    lineEnd: Bn,
    rejoin: function() {
      t.length > 1 && t.push(t.pop().concat(t.shift()));
    },
    result: function() {
      var n = t;
      return t = [], e = null, n;
    }
  };
}
function Ef(t, e) {
  return Ye(t[0] - e[0]) < Ae && Ye(t[1] - e[1]) < Ae;
}
function Vu(t, e, n, r) {
  this.x = t, this.z = e, this.o = n, this.e = r, this.v = !1, this.n = this.p = null;
}
function FS(t, e, n, r, i) {
  var s = [], o = [], a, l;
  if (t.forEach(function(p) {
    if (!((m = p.length - 1) <= 0)) {
      var m, v = p[0], g = p[m], y;
      if (Ef(v, g)) {
        if (!v[2] && !g[2]) {
          for (i.lineStart(), a = 0; a < m; ++a) i.point((v = p[a])[0], v[1]);
          i.lineEnd();
          return;
        }
        g[0] += 2 * Ae;
      }
      s.push(y = new Vu(v, p, null, !0)), o.push(y.o = new Vu(v, null, y, !1)), s.push(y = new Vu(g, p, null, !1)), o.push(y.o = new Vu(g, null, y, !0));
    }
  }), !!s.length) {
    for (o.sort(e), ex(s), ex(o), a = 0, l = o.length; a < l; ++a)
      o[a].e = n = !n;
    for (var c = s[0], u, h; ; ) {
      for (var f = c, d = !0; f.v; ) if ((f = f.n) === c) return;
      u = f.z, i.lineStart();
      do {
        if (f.v = f.o.v = !0, f.e) {
          if (d)
            for (a = 0, l = u.length; a < l; ++a) i.point((h = u[a])[0], h[1]);
          else
            r(f.x, f.n.x, 1, i);
          f = f.n;
        } else {
          if (d)
            for (u = f.p.z, a = u.length - 1; a >= 0; --a) i.point((h = u[a])[0], h[1]);
          else
            r(f.x, f.p.x, -1, i);
          f = f.p;
        }
        f = f.o, u = f.z, d = !d;
      } while (!f.v);
      i.lineEnd();
    }
  }
}
function ex(t) {
  if (e = t.length) {
    for (var e, n = 0, r = t[0], i; ++n < e; )
      r.n = i = t[n], i.p = r, r = i;
    r.n = i = t[0], i.p = r;
  }
}
function qp(t) {
  return Ye(t[0]) <= Oe ? t[0] : Rn(t[0]) * ((Ye(t[0]) + Oe) % Dn - Oe);
}
function XN(t, e) {
  var n = qp(e), r = e[1], i = Ce(r), s = [Ce(n), -Te(n), 0], o = 0, a = 0, l = new no();
  i === 1 ? r = lt + Ae : i === -1 && (r = -lt - Ae);
  for (var c = 0, u = t.length; c < u; ++c)
    if (f = (h = t[c]).length)
      for (var h, f, d = h[f - 1], p = qp(d), m = d[1] / 2 + qb, v = Ce(m), g = Te(m), y = 0; y < f; ++y, p = b, v = k, g = _, d = x) {
        var x = h[y], b = qp(x), w = x[1] / 2 + qb, k = Ce(w), _ = Te(w), C = b - p, E = C >= 0 ? 1 : -1, L = E * C, M = L > Oe, O = v * k;
        if (l.add(xi(O * E * Ce(L), g * _ + O * Te(L))), o += M ? C + E * Dn : C, M ^ p >= n ^ b >= n) {
          var N = ph(va(d), va(x));
          Ng(N);
          var R = ph(s, N);
          Ng(R);
          var $ = (M ^ C >= 0 ? -1 : 1) * Xn(R[2]);
          (r > $ || r === $ && (N[0] || N[1])) && (a += M ^ C >= 0 ? 1 : -1);
        }
      }
  return (o < -Ae || o < Ae && l < -LS) ^ a & 1;
}
function zS(t, e, n, r) {
  return function(i) {
    var s = e(i), o = BS(), a = e(o), l = !1, c, u, h, f = {
      point: d,
      lineStart: m,
      lineEnd: v,
      polygonStart: function() {
        f.point = g, f.lineStart = y, f.lineEnd = x, u = [], c = [];
      },
      polygonEnd: function() {
        f.point = d, f.lineStart = m, f.lineEnd = v, u = K3(u);
        var b = XN(c, r);
        u.length ? (l || (i.polygonStart(), l = !0), FS(u, JN, b, n, i)) : b && (l || (i.polygonStart(), l = !0), i.lineStart(), n(null, null, 1, i), i.lineEnd()), l && (i.polygonEnd(), l = !1), u = c = null;
      },
      sphere: function() {
        i.polygonStart(), i.lineStart(), n(null, null, 1, i), i.lineEnd(), i.polygonEnd();
      }
    };
    function d(b, w) {
      t(b, w) && i.point(b, w);
    }
    function p(b, w) {
      s.point(b, w);
    }
    function m() {
      f.point = p, s.lineStart();
    }
    function v() {
      f.point = d, s.lineEnd();
    }
    function g(b, w) {
      h.push([b, w]), a.point(b, w);
    }
    function y() {
      a.lineStart(), h = [];
    }
    function x() {
      g(h[0][0], h[0][1]), a.lineEnd();
      var b = a.clean(), w = o.result(), k, _ = w.length, C, E, L;
      if (h.pop(), c.push(h), h = null, !!_) {
        if (b & 1) {
          if (E = w[0], (C = E.length - 1) > 0) {
            for (l || (i.polygonStart(), l = !0), i.lineStart(), k = 0; k < C; ++k) i.point((L = E[k])[0], L[1]);
            i.lineEnd();
          }
          return;
        }
        _ > 1 && b & 2 && w.push(w.pop().concat(w.shift())), u.push(w.filter(ZN));
      }
    }
    return f;
  };
}
function ZN(t) {
  return t.length > 1;
}
function JN(t, e) {
  return ((t = t.x)[0] < 0 ? t[1] - lt - Ae : lt - t[1]) - ((e = e.x)[0] < 0 ? e[1] - lt - Ae : lt - e[1]);
}
const tx = zS(
  function() {
    return !0;
  },
  QN,
  tI,
  [-Oe, -lt]
);
function QN(t) {
  var e = NaN, n = NaN, r = NaN, i;
  return {
    lineStart: function() {
      t.lineStart(), i = 1;
    },
    point: function(s, o) {
      var a = s > 0 ? Oe : -Oe, l = Ye(s - e);
      Ye(l - Oe) < Ae ? (t.point(e, n = (n + o) / 2 > 0 ? lt : -lt), t.point(r, n), t.lineEnd(), t.lineStart(), t.point(a, n), t.point(s, n), i = 0) : r !== a && l >= Oe && (Ye(e - r) < Ae && (e -= r * Ae), Ye(s - a) < Ae && (s -= a * Ae), n = eI(e, n, s, o), t.point(r, n), t.lineEnd(), t.lineStart(), t.point(a, n), i = 0), t.point(e = s, n = o), r = a;
    },
    lineEnd: function() {
      t.lineEnd(), e = n = NaN;
    },
    clean: function() {
      return 2 - i;
    }
  };
}
function eI(t, e, n, r) {
  var i, s, o = Ce(t - n);
  return Ye(o) > Ae ? Ya((Ce(e) * (s = Te(r)) * Ce(n) - Ce(r) * (i = Te(e)) * Ce(t)) / (i * s * o)) : (e + r) / 2;
}
function tI(t, e, n, r) {
  var i;
  if (t == null)
    i = n * lt, r.point(-Oe, i), r.point(0, i), r.point(Oe, i), r.point(Oe, 0), r.point(Oe, -i), r.point(0, -i), r.point(-Oe, -i), r.point(-Oe, 0), r.point(-Oe, i);
  else if (Ye(t[0] - e[0]) > Ae) {
    var s = t[0] < e[0] ? Oe : -Oe;
    i = n * s / 2, r.point(-s, i), r.point(0, i), r.point(s, i);
  } else
    r.point(e[0], e[1]);
}
function nI(t) {
  var e = Te(t), n = 2 * ot, r = e > 0, i = Ye(e) > Ae;
  function s(u, h, f, d) {
    GN(d, t, n, f, u, h);
  }
  function o(u, h) {
    return Te(u) * Te(h) > e;
  }
  function a(u) {
    var h, f, d, p, m;
    return {
      lineStart: function() {
        p = d = !1, m = 1;
      },
      point: function(v, g) {
        var y = [v, g], x, b = o(v, g), w = r ? b ? 0 : c(v, g) : b ? c(v + (v < 0 ? Oe : -Oe), g) : 0;
        if (!h && (p = d = b) && u.lineStart(), b !== d && (x = l(h, y), (!x || Ef(h, x) || Ef(y, x)) && (y[2] = 1)), b !== d)
          m = 0, b ? (u.lineStart(), x = l(y, h), u.point(x[0], x[1])) : (x = l(h, y), u.point(x[0], x[1], 2), u.lineEnd()), h = x;
        else if (i && h && r ^ b) {
          var k;
          !(w & f) && (k = l(y, h, !0)) && (m = 0, r ? (u.lineStart(), u.point(k[0][0], k[0][1]), u.point(k[1][0], k[1][1]), u.lineEnd()) : (u.point(k[1][0], k[1][1]), u.lineEnd(), u.lineStart(), u.point(k[0][0], k[0][1], 3)));
        }
        b && (!h || !Ef(h, y)) && u.point(y[0], y[1]), h = y, d = b, f = w;
      },
      lineEnd: function() {
        d && u.lineEnd(), h = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return m | (p && d) << 1;
      }
    };
  }
  function l(u, h, f) {
    var d = va(u), p = va(h), m = [1, 0, 0], v = ph(d, p), g = Fu(v, v), y = v[0], x = g - y * y;
    if (!x) return !f && u;
    var b = e * g / x, w = -e * y / x, k = ph(m, v), _ = zu(m, b), C = zu(v, w);
    jp(_, C);
    var E = k, L = Fu(_, E), M = Fu(E, E), O = L * L - M * (Fu(_, _) - 1);
    if (!(O < 0)) {
      var N = mn(O), R = zu(E, (-L - N) / M);
      if (jp(R, _), R = Lg(R), !f) return R;
      var $ = u[0], F = h[0], U = u[1], ee = h[1], ie;
      F < $ && (ie = $, $ = F, F = ie);
      var z = F - $, te = Ye(z - Oe) < Ae, I = te || z < Ae;
      if (!te && ee < U && (ie = U, U = ee, ee = ie), I ? te ? U + ee > 0 ^ R[1] < (Ye(R[0] - $) < Ae ? U : ee) : U <= R[1] && R[1] <= ee : z > Oe ^ ($ <= R[0] && R[0] <= F)) {
        var X = zu(E, (-L + N) / M);
        return jp(X, _), [R, Lg(X)];
      }
    }
  }
  function c(u, h) {
    var f = r ? t : Oe - t, d = 0;
    return u < -f ? d |= 1 : u > f && (d |= 2), h < -f ? d |= 4 : h > f && (d |= 8), d;
  }
  return zS(o, a, s, r ? [0, -t] : [-Oe, t - Oe]);
}
function rI(t, e, n, r, i, s) {
  var o = t[0], a = t[1], l = e[0], c = e[1], u = 0, h = 1, f = l - o, d = c - a, p;
  if (p = n - o, !(!f && p > 0)) {
    if (p /= f, f < 0) {
      if (p < u) return;
      p < h && (h = p);
    } else if (f > 0) {
      if (p > h) return;
      p > u && (u = p);
    }
    if (p = i - o, !(!f && p < 0)) {
      if (p /= f, f < 0) {
        if (p > h) return;
        p > u && (u = p);
      } else if (f > 0) {
        if (p < u) return;
        p < h && (h = p);
      }
      if (p = r - a, !(!d && p > 0)) {
        if (p /= d, d < 0) {
          if (p < u) return;
          p < h && (h = p);
        } else if (d > 0) {
          if (p > h) return;
          p > u && (u = p);
        }
        if (p = s - a, !(!d && p < 0)) {
          if (p /= d, d < 0) {
            if (p > h) return;
            p > u && (u = p);
          } else if (d > 0) {
            if (p < u) return;
            p < h && (h = p);
          }
          return u > 0 && (t[0] = o + u * f, t[1] = a + u * d), h < 1 && (e[0] = o + h * f, e[1] = a + h * d), !0;
        }
      }
    }
  }
}
var Tl = 1e9, Hu = -Tl;
function VS(t, e, n, r) {
  function i(c, u) {
    return t <= c && c <= n && e <= u && u <= r;
  }
  function s(c, u, h, f) {
    var d = 0, p = 0;
    if (c == null || (d = o(c, h)) !== (p = o(u, h)) || l(c, u) < 0 ^ h > 0)
      do
        f.point(d === 0 || d === 3 ? t : n, d > 1 ? r : e);
      while ((d = (d + h + 4) % 4) !== p);
    else
      f.point(u[0], u[1]);
  }
  function o(c, u) {
    return Ye(c[0] - t) < Ae ? u > 0 ? 0 : 3 : Ye(c[0] - n) < Ae ? u > 0 ? 2 : 1 : Ye(c[1] - e) < Ae ? u > 0 ? 1 : 0 : u > 0 ? 3 : 2;
  }
  function a(c, u) {
    return l(c.x, u.x);
  }
  function l(c, u) {
    var h = o(c, 1), f = o(u, 1);
    return h !== f ? h - f : h === 0 ? u[1] - c[1] : h === 1 ? c[0] - u[0] : h === 2 ? c[1] - u[1] : u[0] - c[0];
  }
  return function(c) {
    var u = c, h = BS(), f, d, p, m, v, g, y, x, b, w, k, _ = {
      point: C,
      lineStart: O,
      lineEnd: N,
      polygonStart: L,
      polygonEnd: M
    };
    function C($, F) {
      i($, F) && u.point($, F);
    }
    function E() {
      for (var $ = 0, F = 0, U = d.length; F < U; ++F)
        for (var ee = d[F], ie = 1, z = ee.length, te = ee[0], I, X, Q = te[0], ce = te[1]; ie < z; ++ie)
          I = Q, X = ce, te = ee[ie], Q = te[0], ce = te[1], X <= r ? ce > r && (Q - I) * (r - X) > (ce - X) * (t - I) && ++$ : ce <= r && (Q - I) * (r - X) < (ce - X) * (t - I) && --$;
      return $;
    }
    function L() {
      u = h, f = [], d = [], k = !0;
    }
    function M() {
      var $ = E(), F = k && $, U = (f = K3(f)).length;
      (F || U) && (c.polygonStart(), F && (c.lineStart(), s(null, null, 1, c), c.lineEnd()), U && FS(f, a, $, s, c), c.polygonEnd()), u = c, f = d = p = null;
    }
    function O() {
      _.point = R, d && d.push(p = []), w = !0, b = !1, y = x = NaN;
    }
    function N() {
      f && (R(m, v), g && b && h.rejoin(), f.push(h.result())), _.point = C, b && u.lineEnd();
    }
    function R($, F) {
      var U = i($, F);
      if (d && p.push([$, F]), w)
        m = $, v = F, g = U, w = !1, U && (u.lineStart(), u.point($, F));
      else if (U && b) u.point($, F);
      else {
        var ee = [y = Math.max(Hu, Math.min(Tl, y)), x = Math.max(Hu, Math.min(Tl, x))], ie = [$ = Math.max(Hu, Math.min(Tl, $)), F = Math.max(Hu, Math.min(Tl, F))];
        rI(ee, ie, t, e, n, r) ? (b || (u.lineStart(), u.point(ee[0], ee[1])), u.point(ie[0], ie[1]), U || u.lineEnd(), k = !1) : U && (u.lineStart(), u.point($, F), k = !1);
      }
      y = $, x = F, b = U;
    }
    return _;
  };
}
const Bg = (t) => t;
var Up = new no(), Fg = new no(), HS, YS, zg, Vg, ci = {
  point: Bn,
  lineStart: Bn,
  lineEnd: Bn,
  polygonStart: function() {
    ci.lineStart = iI, ci.lineEnd = oI;
  },
  polygonEnd: function() {
    ci.lineStart = ci.lineEnd = ci.point = Bn, Up.add(Ye(Fg)), Fg = new no();
  },
  result: function() {
    var t = Up / 2;
    return Up = new no(), t;
  }
};
function iI() {
  ci.point = sI;
}
function sI(t, e) {
  ci.point = WS, HS = zg = t, YS = Vg = e;
}
function WS(t, e) {
  Fg.add(Vg * t - zg * e), zg = t, Vg = e;
}
function oI() {
  WS(HS, YS);
}
var ya = 1 / 0, mh = ya, gc = -ya, gh = gc, vh = {
  point: aI,
  lineStart: Bn,
  lineEnd: Bn,
  polygonStart: Bn,
  polygonEnd: Bn,
  result: function() {
    var t = [[ya, mh], [gc, gh]];
    return gc = gh = -(mh = ya = 1 / 0), t;
  }
};
function aI(t, e) {
  t < ya && (ya = t), t > gc && (gc = t), e < mh && (mh = e), e > gh && (gh = e);
}
var Hg = 0, Yg = 0, Ol = 0, yh = 0, bh = 0, Wo = 0, Wg = 0, jg = 0, El = 0, jS, qS, Dr, Tr, Nn = {
  point: co,
  lineStart: nx,
  lineEnd: rx,
  polygonStart: function() {
    Nn.lineStart = uI, Nn.lineEnd = fI;
  },
  polygonEnd: function() {
    Nn.point = co, Nn.lineStart = nx, Nn.lineEnd = rx;
  },
  result: function() {
    var t = El ? [Wg / El, jg / El] : Wo ? [yh / Wo, bh / Wo] : Ol ? [Hg / Ol, Yg / Ol] : [NaN, NaN];
    return Hg = Yg = Ol = yh = bh = Wo = Wg = jg = El = 0, t;
  }
};
function co(t, e) {
  Hg += t, Yg += e, ++Ol;
}
function nx() {
  Nn.point = lI;
}
function lI(t, e) {
  Nn.point = cI, co(Dr = t, Tr = e);
}
function cI(t, e) {
  var n = t - Dr, r = e - Tr, i = mn(n * n + r * r);
  yh += i * (Dr + t) / 2, bh += i * (Tr + e) / 2, Wo += i, co(Dr = t, Tr = e);
}
function rx() {
  Nn.point = co;
}
function uI() {
  Nn.point = hI;
}
function fI() {
  US(jS, qS);
}
function hI(t, e) {
  Nn.point = US, co(jS = Dr = t, qS = Tr = e);
}
function US(t, e) {
  var n = t - Dr, r = e - Tr, i = mn(n * n + r * r);
  yh += i * (Dr + t) / 2, bh += i * (Tr + e) / 2, Wo += i, i = Tr * t - Dr * e, Wg += i * (Dr + t), jg += i * (Tr + e), El += i * 3, co(Dr = t, Tr = e);
}
function KS(t) {
  this._context = t;
}
KS.prototype = {
  _radius: 4.5,
  pointRadius: function(t) {
    return this._radius = t, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._line === 0 && this._context.closePath(), this._point = NaN;
  },
  point: function(t, e) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(t, e), this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(t, e);
        break;
      }
      default: {
        this._context.moveTo(t + this._radius, e), this._context.arc(t, e, this._radius, 0, Dn);
        break;
      }
    }
  },
  result: Bn
};
var qg = new no(), Kp, GS, XS, Pl, Ll, vc = {
  point: Bn,
  lineStart: function() {
    vc.point = dI;
  },
  lineEnd: function() {
    Kp && ZS(GS, XS), vc.point = Bn;
  },
  polygonStart: function() {
    Kp = !0;
  },
  polygonEnd: function() {
    Kp = null;
  },
  result: function() {
    var t = +qg;
    return qg = new no(), t;
  }
};
function dI(t, e) {
  vc.point = ZS, GS = Pl = t, XS = Ll = e;
}
function ZS(t, e) {
  Pl -= t, Ll -= e, qg.add(mn(Pl * Pl + Ll * Ll)), Pl = t, Ll = e;
}
let ix, xh, sx, ox;
class ax {
  constructor(e) {
    this._append = e == null ? JS : pI(e), this._radius = 4.5, this._ = "";
  }
  pointRadius(e) {
    return this._radius = +e, this;
  }
  polygonStart() {
    this._line = 0;
  }
  polygonEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    this._line === 0 && (this._ += "Z"), this._point = NaN;
  }
  point(e, n) {
    switch (this._point) {
      case 0: {
        this._append`M${e},${n}`, this._point = 1;
        break;
      }
      case 1: {
        this._append`L${e},${n}`;
        break;
      }
      default: {
        if (this._append`M${e},${n}`, this._radius !== sx || this._append !== xh) {
          const r = this._radius, i = this._;
          this._ = "", this._append`m0,${r}a${r},${r} 0 1,1 0,${-2 * r}a${r},${r} 0 1,1 0,${2 * r}z`, sx = r, xh = this._append, ox = this._, this._ = i;
        }
        this._ += ox;
        break;
      }
    }
  }
  result() {
    const e = this._;
    return this._ = "", e.length ? e : null;
  }
}
function JS(t) {
  let e = 1;
  this._ += t[0];
  for (const n = t.length; e < n; ++e)
    this._ += arguments[e] + t[e];
}
function pI(t) {
  const e = Math.floor(t);
  if (!(e >= 0)) throw new RangeError(`invalid digits: ${t}`);
  if (e > 15) return JS;
  if (e !== ix) {
    const n = 10 ** e;
    ix = e, xh = function(i) {
      let s = 1;
      this._ += i[0];
      for (const o = i.length; s < o; ++s)
        this._ += Math.round(arguments[s] * n) / n + i[s];
    };
  }
  return xh;
}
function Zv(t, e) {
  let n = 3, r = 4.5, i, s;
  function o(a) {
    return a && (typeof r == "function" && s.pointRadius(+r.apply(this, arguments)), Rs(a, i(s))), s.result();
  }
  return o.area = function(a) {
    return Rs(a, i(ci)), ci.result();
  }, o.measure = function(a) {
    return Rs(a, i(vc)), vc.result();
  }, o.bounds = function(a) {
    return Rs(a, i(vh)), vh.result();
  }, o.centroid = function(a) {
    return Rs(a, i(Nn)), Nn.result();
  }, o.projection = function(a) {
    return arguments.length ? (i = a == null ? (t = null, Bg) : (t = a).stream, o) : t;
  }, o.context = function(a) {
    return arguments.length ? (s = a == null ? (e = null, new ax(n)) : new KS(e = a), typeof r != "function" && s.pointRadius(r), o) : e;
  }, o.pointRadius = function(a) {
    return arguments.length ? (r = typeof a == "function" ? a : (s.pointRadius(+a), +a), o) : r;
  }, o.digits = function(a) {
    if (!arguments.length) return n;
    if (a == null) n = null;
    else {
      const l = Math.floor(a);
      if (!(l >= 0)) throw new RangeError(`invalid digits: ${a}`);
      n = l;
    }
    return e === null && (s = new ax(n)), o;
  }, o.projection(t).digits(n).context(e);
}
function Ug(t) {
  return {
    stream: Nd(t)
  };
}
function Nd(t) {
  return function(e) {
    var n = new Kg();
    for (var r in t) n[r] = t[r];
    return n.stream = e, n;
  };
}
function Kg() {
}
Kg.prototype = {
  constructor: Kg,
  point: function(t, e) {
    this.stream.point(t, e);
  },
  sphere: function() {
    this.stream.sphere();
  },
  lineStart: function() {
    this.stream.lineStart();
  },
  lineEnd: function() {
    this.stream.lineEnd();
  },
  polygonStart: function() {
    this.stream.polygonStart();
  },
  polygonEnd: function() {
    this.stream.polygonEnd();
  }
};
function Jv(t, e, n) {
  var r = t.clipExtent && t.clipExtent();
  return t.scale(150).translate([0, 0]), r != null && t.clipExtent(null), Rs(n, t.stream(vh)), e(vh.result()), r != null && t.clipExtent(r), t;
}
function Qv(t, e, n) {
  return Jv(t, function(r) {
    var i = e[1][0] - e[0][0], s = e[1][1] - e[0][1], o = Math.min(i / (r[1][0] - r[0][0]), s / (r[1][1] - r[0][1])), a = +e[0][0] + (i - o * (r[1][0] + r[0][0])) / 2, l = +e[0][1] + (s - o * (r[1][1] + r[0][1])) / 2;
    t.scale(150 * o).translate([a, l]);
  }, n);
}
function QS(t, e, n) {
  return Qv(t, [[0, 0], e], n);
}
function e4(t, e, n) {
  return Jv(t, function(r) {
    var i = +e, s = i / (r[1][0] - r[0][0]), o = (i - s * (r[1][0] + r[0][0])) / 2, a = -s * r[0][1];
    t.scale(150 * s).translate([o, a]);
  }, n);
}
function t4(t, e, n) {
  return Jv(t, function(r) {
    var i = +e, s = i / (r[1][1] - r[0][1]), o = -s * r[0][0], a = (i - s * (r[1][1] + r[0][1])) / 2;
    t.scale(150 * s).translate([o, a]);
  }, n);
}
var lx = 16, mI = Te(30 * ot);
function cx(t, e) {
  return +e ? vI(t, e) : gI(t);
}
function gI(t) {
  return Nd({
    point: function(e, n) {
      e = t(e, n), this.stream.point(e[0], e[1]);
    }
  });
}
function vI(t, e) {
  function n(r, i, s, o, a, l, c, u, h, f, d, p, m, v) {
    var g = c - r, y = u - i, x = g * g + y * y;
    if (x > 4 * e && m--) {
      var b = o + f, w = a + d, k = l + p, _ = mn(b * b + w * w + k * k), C = Xn(k /= _), E = Ye(Ye(k) - 1) < Ae || Ye(s - h) < Ae ? (s + h) / 2 : xi(w, b), L = t(E, C), M = L[0], O = L[1], N = M - r, R = O - i, $ = y * N - g * R;
      ($ * $ / x > e || Ye((g * N + y * R) / x - 0.5) > 0.3 || o * f + a * d + l * p < mI) && (n(r, i, s, o, a, l, M, O, E, b /= _, w /= _, k, m, v), v.point(M, O), n(M, O, E, b, w, k, c, u, h, f, d, p, m, v));
    }
  }
  return function(r) {
    var i, s, o, a, l, c, u, h, f, d, p, m, v = {
      point: g,
      lineStart: y,
      lineEnd: b,
      polygonStart: function() {
        r.polygonStart(), v.lineStart = w;
      },
      polygonEnd: function() {
        r.polygonEnd(), v.lineStart = y;
      }
    };
    function g(C, E) {
      C = t(C, E), r.point(C[0], C[1]);
    }
    function y() {
      h = NaN, v.point = x, r.lineStart();
    }
    function x(C, E) {
      var L = va([C, E]), M = t(C, E);
      n(h, f, u, d, p, m, h = M[0], f = M[1], u = C, d = L[0], p = L[1], m = L[2], lx, r), r.point(h, f);
    }
    function b() {
      v.point = g, r.lineEnd();
    }
    function w() {
      y(), v.point = k, v.lineEnd = _;
    }
    function k(C, E) {
      x(i = C, E), s = h, o = f, a = d, l = p, c = m, v.point = x;
    }
    function _() {
      n(h, f, u, d, p, m, s, o, i, a, l, c, lx, r), v.lineEnd = b, b();
    }
    return v;
  };
}
var yI = Nd({
  point: function(t, e) {
    this.stream.point(t * ot, e * ot);
  }
});
function bI(t) {
  return Nd({
    point: function(e, n) {
      var r = t(e, n);
      return this.stream.point(r[0], r[1]);
    }
  });
}
function xI(t, e, n, r, i) {
  function s(o, a) {
    return o *= r, a *= i, [e + t * o, n - t * a];
  }
  return s.invert = function(o, a) {
    return [(o - e) / t * r, (n - a) / t * i];
  }, s;
}
function ux(t, e, n, r, i, s) {
  if (!s) return xI(t, e, n, r, i);
  var o = Te(s), a = Ce(s), l = o * t, c = a * t, u = o / t, h = a / t, f = (a * n - o * e) / t, d = (a * e + o * n) / t;
  function p(m, v) {
    return m *= r, v *= i, [l * m - c * v + e, n - c * m - l * v];
  }
  return p.invert = function(m, v) {
    return [r * (u * m - h * v + f), i * (d - h * m - u * v)];
  }, p;
}
function ks(t) {
  return n4(function() {
    return t;
  })();
}
function n4(t) {
  var e, n = 150, r = 480, i = 250, s = 0, o = 0, a = 0, l = 0, c = 0, u, h = 0, f = 1, d = 1, p = null, m = tx, v = null, g, y, x, b = Bg, w = 0.5, k, _, C, E, L;
  function M($) {
    return C($[0] * ot, $[1] * ot);
  }
  function O($) {
    return $ = C.invert($[0], $[1]), $ && [$[0] * Gt, $[1] * Gt];
  }
  M.stream = function($) {
    return E && L === $ ? E : E = yI(bI(u)(m(k(b(L = $)))));
  }, M.preclip = function($) {
    return arguments.length ? (m = $, p = void 0, R()) : m;
  }, M.postclip = function($) {
    return arguments.length ? (b = $, v = g = y = x = null, R()) : b;
  }, M.clipAngle = function($) {
    return arguments.length ? (m = +$ ? nI(p = $ * ot) : (p = null, tx), R()) : p * Gt;
  }, M.clipExtent = function($) {
    return arguments.length ? (b = $ == null ? (v = g = y = x = null, Bg) : VS(v = +$[0][0], g = +$[0][1], y = +$[1][0], x = +$[1][1]), R()) : v == null ? null : [[v, g], [y, x]];
  }, M.scale = function($) {
    return arguments.length ? (n = +$, N()) : n;
  }, M.translate = function($) {
    return arguments.length ? (r = +$[0], i = +$[1], N()) : [r, i];
  }, M.center = function($) {
    return arguments.length ? (s = $[0] % 360 * ot, o = $[1] % 360 * ot, N()) : [s * Gt, o * Gt];
  }, M.rotate = function($) {
    return arguments.length ? (a = $[0] % 360 * ot, l = $[1] % 360 * ot, c = $.length > 2 ? $[2] % 360 * ot : 0, N()) : [a * Gt, l * Gt, c * Gt];
  }, M.angle = function($) {
    return arguments.length ? (h = $ % 360 * ot, N()) : h * Gt;
  }, M.reflectX = function($) {
    return arguments.length ? (f = $ ? -1 : 1, N()) : f < 0;
  }, M.reflectY = function($) {
    return arguments.length ? (d = $ ? -1 : 1, N()) : d < 0;
  }, M.precision = function($) {
    return arguments.length ? (k = cx(_, w = $ * $), R()) : mn(w);
  }, M.fitExtent = function($, F) {
    return Qv(M, $, F);
  }, M.fitSize = function($, F) {
    return QS(M, $, F);
  }, M.fitWidth = function($, F) {
    return e4(M, $, F);
  }, M.fitHeight = function($, F) {
    return t4(M, $, F);
  };
  function N() {
    var $ = ux(n, 0, 0, f, d, h).apply(null, e(s, o)), F = ux(n, r - $[0], i - $[1], f, d, h);
    return u = RS(a, l, c), _ = Ig(e, F), C = Ig(u, _), k = cx(_, w), R();
  }
  function R() {
    return E = L = null, M;
  }
  return function() {
    return e = t.apply(this, arguments), M.invert = e.invert && O, N();
  };
}
function e1(t) {
  var e = 0, n = Oe / 3, r = n4(t), i = r(e, n);
  return i.parallels = function(s) {
    return arguments.length ? r(e = s[0] * ot, n = s[1] * ot) : [e * Gt, n * Gt];
  }, i;
}
function wI(t) {
  var e = Te(t);
  function n(r, i) {
    return [r * e, Ce(i) / e];
  }
  return n.invert = function(r, i) {
    return [r / e, Xn(i * e)];
  }, n;
}
function kI(t, e) {
  var n = Ce(t), r = (n + Ce(e)) / 2;
  if (Ye(r) < Ae) return wI(t);
  var i = 1 + n * (2 * r - n), s = mn(i) / r;
  function o(a, l) {
    var c = mn(i - 2 * r * Ce(l)) / r;
    return [c * Ce(a *= r), s - c * Te(a)];
  }
  return o.invert = function(a, l) {
    var c = s - l, u = xi(a, Ye(c)) * Rn(c);
    return c * r < 0 && (u -= Oe * Rn(a) * Rn(c)), [u / r, Xn((i - (a * a + c * c) * r * r) / (2 * r))];
  }, o;
}
function wh() {
  return e1(kI).scale(155.424).center([0, 33.6442]);
}
function r4() {
  return wh().parallels([29.5, 45.5]).scale(1070).translate([480, 250]).rotate([96, 0]).center([-0.6, 38.7]);
}
function _I(t) {
  var e = t.length;
  return {
    point: function(n, r) {
      for (var i = -1; ++i < e; ) t[i].point(n, r);
    },
    sphere: function() {
      for (var n = -1; ++n < e; ) t[n].sphere();
    },
    lineStart: function() {
      for (var n = -1; ++n < e; ) t[n].lineStart();
    },
    lineEnd: function() {
      for (var n = -1; ++n < e; ) t[n].lineEnd();
    },
    polygonStart: function() {
      for (var n = -1; ++n < e; ) t[n].polygonStart();
    },
    polygonEnd: function() {
      for (var n = -1; ++n < e; ) t[n].polygonEnd();
    }
  };
}
function SI() {
  var t, e, n = r4(), r, i = wh().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), s, o = wh().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), a, l, c = { point: function(f, d) {
    l = [f, d];
  } };
  function u(f) {
    var d = f[0], p = f[1];
    return l = null, r.point(d, p), l || (s.point(d, p), l) || (a.point(d, p), l);
  }
  u.invert = function(f) {
    var d = n.scale(), p = n.translate(), m = (f[0] - p[0]) / d, v = (f[1] - p[1]) / d;
    return (v >= 0.12 && v < 0.234 && m >= -0.425 && m < -0.214 ? i : v >= 0.166 && v < 0.234 && m >= -0.214 && m < -0.115 ? o : n).invert(f);
  }, u.stream = function(f) {
    return t && e === f ? t : t = _I([n.stream(e = f), i.stream(f), o.stream(f)]);
  }, u.precision = function(f) {
    return arguments.length ? (n.precision(f), i.precision(f), o.precision(f), h()) : n.precision();
  }, u.scale = function(f) {
    return arguments.length ? (n.scale(f), i.scale(f * 0.35), o.scale(f), u.translate(n.translate())) : n.scale();
  }, u.translate = function(f) {
    if (!arguments.length) return n.translate();
    var d = n.scale(), p = +f[0], m = +f[1];
    return r = n.translate(f).clipExtent([[p - 0.455 * d, m - 0.238 * d], [p + 0.455 * d, m + 0.238 * d]]).stream(c), s = i.translate([p - 0.307 * d, m + 0.201 * d]).clipExtent([[p - 0.425 * d + Ae, m + 0.12 * d + Ae], [p - 0.214 * d - Ae, m + 0.234 * d - Ae]]).stream(c), a = o.translate([p - 0.205 * d, m + 0.212 * d]).clipExtent([[p - 0.214 * d + Ae, m + 0.166 * d + Ae], [p - 0.115 * d - Ae, m + 0.234 * d - Ae]]).stream(c), h();
  }, u.fitExtent = function(f, d) {
    return Qv(u, f, d);
  }, u.fitSize = function(f, d) {
    return QS(u, f, d);
  }, u.fitWidth = function(f, d) {
    return e4(u, f, d);
  }, u.fitHeight = function(f, d) {
    return t4(u, f, d);
  };
  function h() {
    return t = e = null, u;
  }
  return u.scale(1070);
}
function i4(t) {
  return function(e, n) {
    var r = Te(e), i = Te(n), s = t(r * i);
    return s === 1 / 0 ? [2, 0] : [
      s * i * Ce(e),
      s * Ce(n)
    ];
  };
}
function Qc(t) {
  return function(e, n) {
    var r = mn(e * e + n * n), i = t(r), s = Ce(i), o = Te(i);
    return [
      xi(e * s, r * o),
      Xn(r && n * s / r)
    ];
  };
}
var s4 = i4(function(t) {
  return mn(2 / (1 + t));
});
s4.invert = Qc(function(t) {
  return 2 * Xn(t / 2);
});
function MI() {
  return ks(s4).scale(124.75).clipAngle(180 - 1e-3);
}
var o4 = i4(function(t) {
  return (t = IS(t)) && t / Ce(t);
});
o4.invert = Qc(function(t) {
  return t;
});
function CI() {
  return ks(o4).scale(79.4188).clipAngle(180 - 1e-3);
}
function Id(t, e) {
  return [t, hh(Xv((lt + e) / 2))];
}
Id.invert = function(t, e) {
  return [t, 2 * Ya(NS(e)) - lt];
};
function $I() {
  return a4(Id).scale(961 / Dn);
}
function a4(t) {
  var e = ks(t), n = e.center, r = e.scale, i = e.translate, s = e.clipExtent, o = null, a, l, c;
  e.scale = function(h) {
    return arguments.length ? (r(h), u()) : r();
  }, e.translate = function(h) {
    return arguments.length ? (i(h), u()) : i();
  }, e.center = function(h) {
    return arguments.length ? (n(h), u()) : n();
  }, e.clipExtent = function(h) {
    return arguments.length ? (h == null ? o = a = l = c = null : (o = +h[0][0], a = +h[0][1], l = +h[1][0], c = +h[1][1]), u()) : o == null ? null : [[o, a], [l, c]];
  };
  function u() {
    var h = Oe * r(), f = e(KN(e.rotate()).invert([0, 0]));
    return s(o == null ? [[f[0] - h, f[1] - h], [f[0] + h, f[1] + h]] : t === Id ? [[Math.max(f[0] - h, o), a], [Math.min(f[0] + h, l), c]] : [[o, Math.max(f[1] - h, a)], [l, Math.min(f[1] + h, c)]]);
  }
  return u();
}
function Yu(t) {
  return Xv((lt + t) / 2);
}
function AI(t, e) {
  var n = Te(t), r = t === e ? Ce(t) : hh(n / Te(e)) / hh(Yu(e) / Yu(t)), i = n * Wp(Yu(t), r) / r;
  if (!r) return Id;
  function s(o, a) {
    i > 0 ? a < -lt + Ae && (a = -lt + Ae) : a > lt - Ae && (a = lt - Ae);
    var l = i / Wp(Yu(a), r);
    return [l * Ce(r * o), i - l * Te(r * o)];
  }
  return s.invert = function(o, a) {
    var l = i - a, c = Rn(r) * mn(o * o + l * l), u = xi(o, Ye(l)) * Rn(l);
    return l * r < 0 && (u -= Oe * Rn(o) * Rn(l)), [u / r, 2 * Ya(Wp(i / c, 1 / r)) - lt];
  }, s;
}
function DI() {
  return e1(AI).scale(109.5).parallels([30, 30]);
}
function kh(t, e) {
  return [t, e];
}
kh.invert = kh;
function TI() {
  return ks(kh).scale(152.63);
}
function OI(t, e) {
  var n = Te(t), r = t === e ? Ce(t) : (n - Te(e)) / (e - t), i = n / r + t;
  if (Ye(r) < Ae) return kh;
  function s(o, a) {
    var l = i - a, c = r * o;
    return [l * Ce(c), i - l * Te(c)];
  }
  return s.invert = function(o, a) {
    var l = i - a, c = xi(o, Ye(l)) * Rn(l);
    return l * r < 0 && (c -= Oe * Rn(o) * Rn(l)), [c / r, i - Rn(r) * mn(o * o + l * l)];
  }, s;
}
function EI() {
  return e1(OI).scale(131.154).center([0, 13.9389]);
}
var Zl = 1.340264, Jl = -0.081106, Ql = 893e-6, ec = 3796e-6, _h = mn(3) / 2, PI = 12;
function l4(t, e) {
  var n = Xn(_h * Ce(e)), r = n * n, i = r * r * r;
  return [
    t * Te(n) / (_h * (Zl + 3 * Jl * r + i * (7 * Ql + 9 * ec * r))),
    n * (Zl + Jl * r + i * (Ql + ec * r))
  ];
}
l4.invert = function(t, e) {
  for (var n = e, r = n * n, i = r * r * r, s = 0, o, a, l; s < PI && (a = n * (Zl + Jl * r + i * (Ql + ec * r)) - e, l = Zl + 3 * Jl * r + i * (7 * Ql + 9 * ec * r), n -= o = a / l, r = n * n, i = r * r * r, !(Ye(o) < LS)); ++s)
    ;
  return [
    _h * t * (Zl + 3 * Jl * r + i * (7 * Ql + 9 * ec * r)) / Te(n),
    Xn(Ce(n) / _h)
  ];
};
function LI() {
  return ks(l4).scale(177.158);
}
function c4(t, e) {
  var n = Te(e), r = Te(t) * n;
  return [n * Ce(t) / r, Ce(e) / r];
}
c4.invert = Qc(Ya);
function NI() {
  return ks(c4).scale(144.049).clipAngle(60);
}
function u4(t, e) {
  return [Te(e) * Ce(t), Ce(e)];
}
u4.invert = Qc(Xn);
function II() {
  return ks(u4).scale(249.5).clipAngle(90 + Ae);
}
function f4(t, e) {
  var n = Te(e), r = 1 + Te(t) * n;
  return [n * Ce(t) / r, Ce(e) / r];
}
f4.invert = Qc(function(t) {
  return 2 * Ya(t);
});
function RI() {
  return ks(f4).scale(250).clipAngle(142);
}
function h4(t, e) {
  return [hh(Xv((lt + e) / 2)), -t];
}
h4.invert = function(t, e) {
  return [-e, 2 * Ya(NS(t)) - lt];
};
function BI() {
  var t = a4(h4), e = t.center, n = t.rotate;
  return t.center = function(r) {
    return arguments.length ? e([-r[1], r[0]]) : (r = e(), [r[1], -r[0]]);
  }, t.rotate = function(r) {
    return arguments.length ? n([r[0], r[1], r.length > 2 ? r[2] + 90 : 90]) : (r = n(), [r[0], r[1], r[2] - 90]);
  }, n([0, 0, 90]).scale(159.155);
}
function Zr(t, e) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(t);
      break;
    default:
      this.range(e).domain(t);
      break;
  }
  return this;
}
function Rd(t, e) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
    default: {
      this.domain(t), typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
  }
  return this;
}
const Gg = Symbol("implicit");
function t1() {
  var t = new ro(), e = [], n = [], r = Gg;
  function i(s) {
    let o = t.get(s);
    if (o === void 0) {
      if (r !== Gg) return r;
      t.set(s, o = e.push(s) - 1);
    }
    return n[o % n.length];
  }
  return i.domain = function(s) {
    if (!arguments.length) return e.slice();
    e = [], t = new ro();
    for (const o of s)
      t.has(o) || t.set(o, e.push(o) - 1);
    return i;
  }, i.range = function(s) {
    return arguments.length ? (n = Array.from(s), i) : n.slice();
  }, i.unknown = function(s) {
    return arguments.length ? (r = s, i) : r;
  }, i.copy = function() {
    return t1(e, n).unknown(r);
  }, Zr.apply(i, arguments), i;
}
function Bd() {
  var t = t1().unknown(void 0), e = t.domain, n = t.range, r = 0, i = 1, s, o, a = !1, l = 0, c = 0, u = 0.5;
  delete t.unknown;
  function h() {
    var f = e().length, d = i < r, p = d ? i : r, m = d ? r : i;
    s = (m - p) / Math.max(1, f - l + c * 2), a && (s = Math.floor(s)), p += (m - p - s * (f - l)) * u, o = s * (1 - l), a && (p = Math.round(p), o = Math.round(o));
    var v = xg(f).map(function(g) {
      return p + s * g;
    });
    return n(d ? v.reverse() : v);
  }
  return t.domain = function(f) {
    return arguments.length ? (e(f), h()) : e();
  }, t.range = function(f) {
    return arguments.length ? ([r, i] = f, r = +r, i = +i, h()) : [r, i];
  }, t.rangeRound = function(f) {
    return [r, i] = f, r = +r, i = +i, a = !0, h();
  }, t.bandwidth = function() {
    return o;
  }, t.step = function() {
    return s;
  }, t.round = function(f) {
    return arguments.length ? (a = !!f, h()) : a;
  }, t.padding = function(f) {
    return arguments.length ? (l = Math.min(1, c = +f), h()) : l;
  }, t.paddingInner = function(f) {
    return arguments.length ? (l = Math.min(1, f), h()) : l;
  }, t.paddingOuter = function(f) {
    return arguments.length ? (c = +f, h()) : c;
  }, t.align = function(f) {
    return arguments.length ? (u = Math.max(0, Math.min(1, f)), h()) : u;
  }, t.copy = function() {
    return Bd(e(), [r, i]).round(a).paddingInner(l).paddingOuter(c).align(u);
  }, Zr.apply(h(), arguments);
}
function d4(t) {
  var e = t.copy;
  return t.padding = t.paddingOuter, delete t.paddingInner, delete t.paddingOuter, t.copy = function() {
    return d4(e());
  }, t;
}
function FI() {
  return d4(Bd.apply(null, arguments).paddingInner(1));
}
function zI(t) {
  return function() {
    return t;
  };
}
function Xg(t) {
  return +t;
}
var fx = [0, 1];
function Fn(t) {
  return t;
}
function Zg(t, e) {
  return (e -= t = +t) ? function(n) {
    return (n - t) / e;
  } : zI(isNaN(e) ? NaN : 0.5);
}
function VI(t, e) {
  var n;
  return t > e && (n = t, t = e, e = n), function(r) {
    return Math.max(t, Math.min(e, r));
  };
}
function HI(t, e, n) {
  var r = t[0], i = t[1], s = e[0], o = e[1];
  return i < r ? (r = Zg(i, r), s = n(o, s)) : (r = Zg(r, i), s = n(s, o)), function(a) {
    return s(r(a));
  };
}
function YI(t, e, n) {
  var r = Math.min(t.length, e.length) - 1, i = new Array(r), s = new Array(r), o = -1;
  for (t[r] < t[0] && (t = t.slice().reverse(), e = e.slice().reverse()); ++o < r; )
    i[o] = Zg(t[o], t[o + 1]), s[o] = n(e[o], e[o + 1]);
  return function(a) {
    var l = Lv(t, a, 1, r) - 1;
    return s[l](i[l](a));
  };
}
function eu(t, e) {
  return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown());
}
function Fd() {
  var t = fx, e = fx, n = Jc, r, i, s, o = Fn, a, l, c;
  function u() {
    var f = Math.min(t.length, e.length);
    return o !== Fn && (o = VI(t[0], t[f - 1])), a = f > 2 ? YI : HI, l = c = null, h;
  }
  function h(f) {
    return f == null || isNaN(f = +f) ? s : (l || (l = a(t.map(r), e, n)))(r(o(f)));
  }
  return h.invert = function(f) {
    return o(i((c || (c = a(e, t.map(r), Ft)))(f)));
  }, h.domain = function(f) {
    return arguments.length ? (t = Array.from(f, Xg), u()) : t.slice();
  }, h.range = function(f) {
    return arguments.length ? (e = Array.from(f), u()) : e.slice();
  }, h.rangeRound = function(f) {
    return e = Array.from(f), n = Wv, u();
  }, h.clamp = function(f) {
    return arguments.length ? (o = f ? !0 : Fn, u()) : o !== Fn;
  }, h.interpolate = function(f) {
    return arguments.length ? (n = f, u()) : n;
  }, h.unknown = function(f) {
    return arguments.length ? (s = f, h) : s;
  }, function(f, d) {
    return r = f, i = d, u();
  };
}
function p4() {
  return Fd()(Fn, Fn);
}
function WI(t, e, n, r) {
  var i = yg(t, e, n), s;
  switch (r = mc(r == null ? ",f" : r), r.type) {
    case "s": {
      var o = Math.max(Math.abs(t), Math.abs(e));
      return r.precision == null && !isNaN(s = qN(i, o)) && (r.precision = s), PS(r, o);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      r.precision == null && !isNaN(s = UN(i, Math.max(Math.abs(t), Math.abs(e)))) && (r.precision = s - (r.type === "e"));
      break;
    }
    case "f":
    case "%": {
      r.precision == null && !isNaN(s = jN(i)) && (r.precision = s - (r.type === "%") * 2);
      break;
    }
  }
  return Ha(r);
}
function tu(t) {
  var e = t.domain;
  return t.ticks = function(n) {
    var r = e();
    return nh(r[0], r[r.length - 1], n == null ? 10 : n);
  }, t.tickFormat = function(n, r) {
    var i = e();
    return WI(i[0], i[i.length - 1], n == null ? 10 : n, r);
  }, t.nice = function(n) {
    n == null && (n = 10);
    var r = e(), i = 0, s = r.length - 1, o = r[i], a = r[s], l, c, u = 10;
    for (a < o && (c = o, o = a, a = c, c = i, i = s, s = c); u-- > 0; ) {
      if (c = vg(o, a, n), c === l)
        return r[i] = o, r[s] = a, e(r);
      if (c > 0)
        o = Math.floor(o / c) * c, a = Math.ceil(a / c) * c;
      else if (c < 0)
        o = Math.ceil(o * c) / c, a = Math.floor(a * c) / c;
      else
        break;
      l = c;
    }
    return t;
  }, t;
}
function n1() {
  var t = p4();
  return t.copy = function() {
    return eu(t, n1());
  }, Zr.apply(t, arguments), tu(t);
}
function m4(t) {
  var e;
  function n(r) {
    return r == null || isNaN(r = +r) ? e : r;
  }
  return n.invert = n, n.domain = n.range = function(r) {
    return arguments.length ? (t = Array.from(r, Xg), n) : t.slice();
  }, n.unknown = function(r) {
    return arguments.length ? (e = r, n) : e;
  }, n.copy = function() {
    return m4(t).unknown(e);
  }, t = arguments.length ? Array.from(t, Xg) : [0, 1], tu(n);
}
function g4(t, e) {
  t = t.slice();
  var n = 0, r = t.length - 1, i = t[n], s = t[r], o;
  return s < i && (o = n, n = r, r = o, o = i, i = s, s = o), t[n] = e.floor(i), t[r] = e.ceil(s), t;
}
function hx(t) {
  return Math.log(t);
}
function dx(t) {
  return Math.exp(t);
}
function jI(t) {
  return -Math.log(-t);
}
function qI(t) {
  return -Math.exp(-t);
}
function UI(t) {
  return isFinite(t) ? +("1e" + t) : t < 0 ? 0 : t;
}
function KI(t) {
  return t === 10 ? UI : t === Math.E ? Math.exp : (e) => Math.pow(t, e);
}
function GI(t) {
  return t === Math.E ? Math.log : t === 10 && Math.log10 || t === 2 && Math.log2 || (t = Math.log(t), (e) => Math.log(e) / t);
}
function px(t) {
  return (e, n) => -t(-e, n);
}
function v4(t) {
  const e = t(hx, dx), n = e.domain;
  let r = 10, i, s;
  function o() {
    return i = GI(r), s = KI(r), n()[0] < 0 ? (i = px(i), s = px(s), t(jI, qI)) : t(hx, dx), e;
  }
  return e.base = function(a) {
    return arguments.length ? (r = +a, o()) : r;
  }, e.domain = function(a) {
    return arguments.length ? (n(a), o()) : n();
  }, e.ticks = (a) => {
    const l = n();
    let c = l[0], u = l[l.length - 1];
    const h = u < c;
    h && ([c, u] = [u, c]);
    let f = i(c), d = i(u), p, m;
    const v = a == null ? 10 : +a;
    let g = [];
    if (!(r % 1) && d - f < v) {
      if (f = Math.floor(f), d = Math.ceil(d), c > 0) {
        for (; f <= d; ++f)
          for (p = 1; p < r; ++p)
            if (m = f < 0 ? p / s(-f) : p * s(f), !(m < c)) {
              if (m > u) break;
              g.push(m);
            }
      } else for (; f <= d; ++f)
        for (p = r - 1; p >= 1; --p)
          if (m = f > 0 ? p / s(-f) : p * s(f), !(m < c)) {
            if (m > u) break;
            g.push(m);
          }
      g.length * 2 < v && (g = nh(c, u, v));
    } else
      g = nh(f, d, Math.min(d - f, v)).map(s);
    return h ? g.reverse() : g;
  }, e.tickFormat = (a, l) => {
    if (a == null && (a = 10), l == null && (l = r === 10 ? "s" : ","), typeof l != "function" && (!(r % 1) && (l = mc(l)).precision == null && (l.trim = !0), l = Ha(l)), a === 1 / 0) return l;
    const c = Math.max(1, r * a / e.ticks().length);
    return (u) => {
      let h = u / s(Math.round(i(u)));
      return h * r < r - 0.5 && (h *= r), h <= c ? l(u) : "";
    };
  }, e.nice = () => n(g4(n(), {
    floor: (a) => s(Math.floor(i(a))),
    ceil: (a) => s(Math.ceil(i(a)))
  })), e;
}
function y4() {
  const t = v4(Fd()).domain([1, 10]);
  return t.copy = () => eu(t, y4()).base(t.base()), Zr.apply(t, arguments), t;
}
function mx(t) {
  return function(e) {
    return Math.sign(e) * Math.log1p(Math.abs(e / t));
  };
}
function gx(t) {
  return function(e) {
    return Math.sign(e) * Math.expm1(Math.abs(e)) * t;
  };
}
function b4(t) {
  var e = 1, n = t(mx(e), gx(e));
  return n.constant = function(r) {
    return arguments.length ? t(mx(e = +r), gx(e)) : e;
  }, tu(n);
}
function x4() {
  var t = b4(Fd());
  return t.copy = function() {
    return eu(t, x4()).constant(t.constant());
  }, Zr.apply(t, arguments);
}
function vx(t) {
  return function(e) {
    return e < 0 ? -Math.pow(-e, t) : Math.pow(e, t);
  };
}
function XI(t) {
  return t < 0 ? -Math.sqrt(-t) : Math.sqrt(t);
}
function ZI(t) {
  return t < 0 ? -t * t : t * t;
}
function w4(t) {
  var e = t(Fn, Fn), n = 1;
  function r() {
    return n === 1 ? t(Fn, Fn) : n === 0.5 ? t(XI, ZI) : t(vx(n), vx(1 / n));
  }
  return e.exponent = function(i) {
    return arguments.length ? (n = +i, r()) : n;
  }, tu(e);
}
function k4() {
  var t = w4(Fd());
  return t.copy = function() {
    return eu(t, k4()).exponent(t.exponent());
  }, Zr.apply(t, arguments), t;
}
function _4() {
  var t = [], e = [], n = [], r;
  function i() {
    var o = 0, a = Math.max(1, e.length);
    for (n = new Array(a - 1); ++o < a; ) n[o - 1] = j9(t, o / a);
    return s;
  }
  function s(o) {
    return o == null || isNaN(o = +o) ? r : e[Lv(n, o)];
  }
  return s.invertExtent = function(o) {
    var a = e.indexOf(o);
    return a < 0 ? [NaN, NaN] : [
      a > 0 ? n[a - 1] : t[0],
      a < n.length ? n[a] : t[t.length - 1]
    ];
  }, s.domain = function(o) {
    if (!arguments.length) return t.slice();
    t = [];
    for (let a of o) a != null && !isNaN(a = +a) && t.push(a);
    return t.sort(hn), i();
  }, s.range = function(o) {
    return arguments.length ? (e = Array.from(o), i()) : e.slice();
  }, s.unknown = function(o) {
    return arguments.length ? (r = o, s) : r;
  }, s.quantiles = function() {
    return n.slice();
  }, s.copy = function() {
    return _4().domain(t).range(e).unknown(r);
  }, Zr.apply(s, arguments);
}
function S4() {
  var t = [0.5], e = [0, 1], n, r = 1;
  function i(s) {
    return s != null && s <= s ? e[Lv(t, s, 0, r)] : n;
  }
  return i.domain = function(s) {
    return arguments.length ? (t = Array.from(s), r = Math.min(t.length, e.length - 1), i) : t.slice();
  }, i.range = function(s) {
    return arguments.length ? (e = Array.from(s), r = Math.min(t.length, e.length - 1), i) : e.slice();
  }, i.invertExtent = function(s) {
    var o = e.indexOf(s);
    return [t[o - 1], t[o]];
  }, i.unknown = function(s) {
    return arguments.length ? (n = s, i) : n;
  }, i.copy = function() {
    return S4().domain(t).range(e).unknown(n);
  }, Zr.apply(i, arguments);
}
const Gp = /* @__PURE__ */ new Date(), Xp = /* @__PURE__ */ new Date();
function bt(t, e, n, r) {
  function i(s) {
    return t(s = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+s)), s;
  }
  return i.floor = (s) => (t(s = /* @__PURE__ */ new Date(+s)), s), i.ceil = (s) => (t(s = new Date(s - 1)), e(s, 1), t(s), s), i.round = (s) => {
    const o = i(s), a = i.ceil(s);
    return s - o < a - s ? o : a;
  }, i.offset = (s, o) => (e(s = /* @__PURE__ */ new Date(+s), o == null ? 1 : Math.floor(o)), s), i.range = (s, o, a) => {
    const l = [];
    if (s = i.ceil(s), a = a == null ? 1 : Math.floor(a), !(s < o) || !(a > 0)) return l;
    let c;
    do
      l.push(c = /* @__PURE__ */ new Date(+s)), e(s, a), t(s);
    while (c < s && s < o);
    return l;
  }, i.filter = (s) => bt((o) => {
    if (o >= o) for (; t(o), !s(o); ) o.setTime(o - 1);
  }, (o, a) => {
    if (o >= o)
      if (a < 0) for (; ++a <= 0; )
        for (; e(o, -1), !s(o); )
          ;
      else for (; --a >= 0; )
        for (; e(o, 1), !s(o); )
          ;
  }), n && (i.count = (s, o) => (Gp.setTime(+s), Xp.setTime(+o), t(Gp), t(Xp), Math.floor(n(Gp, Xp))), i.every = (s) => (s = Math.floor(s), !isFinite(s) || !(s > 0) ? null : s > 1 ? i.filter(r ? (o) => r(o) % s === 0 : (o) => i.count(0, o) % s === 0) : i)), i;
}
const Sh = bt(() => {
}, (t, e) => {
  t.setTime(+t + e);
}, (t, e) => e - t);
Sh.every = (t) => (t = Math.floor(t), !isFinite(t) || !(t > 0) ? null : t > 1 ? bt((e) => {
  e.setTime(Math.floor(e / t) * t);
}, (e, n) => {
  e.setTime(+e + n * t);
}, (e, n) => (n - e) / t) : Sh);
Sh.range;
const fi = 1e3, zn = fi * 60, hi = zn * 60, wi = hi * 24, r1 = wi * 7, yx = wi * 30, Zp = wi * 365, cr = bt((t) => {
  t.setTime(t - t.getMilliseconds());
}, (t, e) => {
  t.setTime(+t + e * fi);
}, (t, e) => (e - t) / fi, (t) => t.getUTCSeconds());
cr.range;
const nu = bt((t) => {
  t.setTime(t - t.getMilliseconds() - t.getSeconds() * fi);
}, (t, e) => {
  t.setTime(+t + e * zn);
}, (t, e) => (e - t) / zn, (t) => t.getMinutes());
nu.range;
const ru = bt((t) => {
  t.setUTCSeconds(0, 0);
}, (t, e) => {
  t.setTime(+t + e * zn);
}, (t, e) => (e - t) / zn, (t) => t.getUTCMinutes());
ru.range;
const iu = bt((t) => {
  t.setTime(t - t.getMilliseconds() - t.getSeconds() * fi - t.getMinutes() * zn);
}, (t, e) => {
  t.setTime(+t + e * hi);
}, (t, e) => (e - t) / hi, (t) => t.getHours());
iu.range;
const su = bt((t) => {
  t.setUTCMinutes(0, 0, 0);
}, (t, e) => {
  t.setTime(+t + e * hi);
}, (t, e) => (e - t) / hi, (t) => t.getUTCHours());
su.range;
const wo = bt(
  (t) => t.setHours(0, 0, 0, 0),
  (t, e) => t.setDate(t.getDate() + e),
  (t, e) => (e - t - (e.getTimezoneOffset() - t.getTimezoneOffset()) * zn) / wi,
  (t) => t.getDate() - 1
);
wo.range;
const zd = bt((t) => {
  t.setUTCHours(0, 0, 0, 0);
}, (t, e) => {
  t.setUTCDate(t.getUTCDate() + e);
}, (t, e) => (e - t) / wi, (t) => t.getUTCDate() - 1);
zd.range;
const Vd = bt((t) => {
  t.setUTCHours(0, 0, 0, 0);
}, (t, e) => {
  t.setUTCDate(t.getUTCDate() + e);
}, (t, e) => (e - t) / wi, (t) => Math.floor(t / wi));
Vd.range;
function ko(t) {
  return bt((e) => {
    e.setDate(e.getDate() - (e.getDay() + 7 - t) % 7), e.setHours(0, 0, 0, 0);
  }, (e, n) => {
    e.setDate(e.getDate() + n * 7);
  }, (e, n) => (n - e - (n.getTimezoneOffset() - e.getTimezoneOffset()) * zn) / r1);
}
const ba = ko(0), yc = ko(1), M4 = ko(2), C4 = ko(3), uo = ko(4), $4 = ko(5), A4 = ko(6);
ba.range;
yc.range;
M4.range;
C4.range;
uo.range;
$4.range;
A4.range;
function _o(t) {
  return bt((e) => {
    e.setUTCDate(e.getUTCDate() - (e.getUTCDay() + 7 - t) % 7), e.setUTCHours(0, 0, 0, 0);
  }, (e, n) => {
    e.setUTCDate(e.getUTCDate() + n * 7);
  }, (e, n) => (n - e) / r1);
}
const xa = _o(0), bc = _o(1), D4 = _o(2), T4 = _o(3), fo = _o(4), O4 = _o(5), E4 = _o(6);
xa.range;
bc.range;
D4.range;
T4.range;
fo.range;
O4.range;
E4.range;
const ou = bt((t) => {
  t.setDate(1), t.setHours(0, 0, 0, 0);
}, (t, e) => {
  t.setMonth(t.getMonth() + e);
}, (t, e) => e.getMonth() - t.getMonth() + (e.getFullYear() - t.getFullYear()) * 12, (t) => t.getMonth());
ou.range;
const au = bt((t) => {
  t.setUTCDate(1), t.setUTCHours(0, 0, 0, 0);
}, (t, e) => {
  t.setUTCMonth(t.getUTCMonth() + e);
}, (t, e) => e.getUTCMonth() - t.getUTCMonth() + (e.getUTCFullYear() - t.getUTCFullYear()) * 12, (t) => t.getUTCMonth());
au.range;
const hr = bt((t) => {
  t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, e) => {
  t.setFullYear(t.getFullYear() + e);
}, (t, e) => e.getFullYear() - t.getFullYear(), (t) => t.getFullYear());
hr.every = (t) => !isFinite(t = Math.floor(t)) || !(t > 0) ? null : bt((e) => {
  e.setFullYear(Math.floor(e.getFullYear() / t) * t), e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, n) => {
  e.setFullYear(e.getFullYear() + n * t);
});
hr.range;
const dr = bt((t) => {
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, e) => {
  t.setUTCFullYear(t.getUTCFullYear() + e);
}, (t, e) => e.getUTCFullYear() - t.getUTCFullYear(), (t) => t.getUTCFullYear());
dr.every = (t) => !isFinite(t = Math.floor(t)) || !(t > 0) ? null : bt((e) => {
  e.setUTCFullYear(Math.floor(e.getUTCFullYear() / t) * t), e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, n) => {
  e.setUTCFullYear(e.getUTCFullYear() + n * t);
});
dr.range;
function P4(t, e, n, r, i, s) {
  const o = [
    [cr, 1, fi],
    [cr, 5, 5 * fi],
    [cr, 15, 15 * fi],
    [cr, 30, 30 * fi],
    [s, 1, zn],
    [s, 5, 5 * zn],
    [s, 15, 15 * zn],
    [s, 30, 30 * zn],
    [i, 1, hi],
    [i, 3, 3 * hi],
    [i, 6, 6 * hi],
    [i, 12, 12 * hi],
    [r, 1, wi],
    [r, 2, 2 * wi],
    [n, 1, r1],
    [e, 1, yx],
    [e, 3, 3 * yx],
    [t, 1, Zp]
  ];
  function a(c, u, h) {
    const f = u < c;
    f && ([c, u] = [u, c]);
    const d = h && typeof h.range == "function" ? h : l(c, u, h), p = d ? d.range(c, +u + 1) : [];
    return f ? p.reverse() : p;
  }
  function l(c, u, h) {
    const f = Math.abs(u - c) / h, d = Cd(([, , v]) => v).right(o, f);
    if (d === o.length) return t.every(yg(c / Zp, u / Zp, h));
    if (d === 0) return Sh.every(Math.max(yg(c, u, h), 1));
    const [p, m] = o[f / o[d - 1][2] < o[d][2] / f ? d - 1 : d];
    return p.every(m);
  }
  return [a, l];
}
const [JI, QI] = P4(dr, au, xa, Vd, su, ru), [eR, tR] = P4(hr, ou, ba, wo, iu, nu);
function Jp(t) {
  if (0 <= t.y && t.y < 100) {
    var e = new Date(-1, t.m, t.d, t.H, t.M, t.S, t.L);
    return e.setFullYear(t.y), e;
  }
  return new Date(t.y, t.m, t.d, t.H, t.M, t.S, t.L);
}
function Qp(t) {
  if (0 <= t.y && t.y < 100) {
    var e = new Date(Date.UTC(-1, t.m, t.d, t.H, t.M, t.S, t.L));
    return e.setUTCFullYear(t.y), e;
  }
  return new Date(Date.UTC(t.y, t.m, t.d, t.H, t.M, t.S, t.L));
}
function cl(t, e, n) {
  return { y: t, m: e, d: n, H: 0, M: 0, S: 0, L: 0 };
}
function nR(t) {
  var e = t.dateTime, n = t.date, r = t.time, i = t.periods, s = t.days, o = t.shortDays, a = t.months, l = t.shortMonths, c = ul(i), u = fl(i), h = ul(s), f = fl(s), d = ul(o), p = fl(o), m = ul(a), v = fl(a), g = ul(l), y = fl(l), x = {
    a: U,
    A: ee,
    b: ie,
    B: z,
    c: null,
    d: Sx,
    e: Sx,
    f: MR,
    g: NR,
    G: RR,
    H: kR,
    I: _R,
    j: SR,
    L: L4,
    m: CR,
    M: $R,
    p: te,
    q: I,
    Q: $x,
    s: Ax,
    S: AR,
    u: DR,
    U: TR,
    V: OR,
    w: ER,
    W: PR,
    x: null,
    X: null,
    y: LR,
    Y: IR,
    Z: BR,
    "%": Cx
  }, b = {
    a: X,
    A: Q,
    b: ce,
    B: he,
    c: null,
    d: Mx,
    e: Mx,
    f: HR,
    g: JR,
    G: eB,
    H: FR,
    I: zR,
    j: VR,
    L: I4,
    m: YR,
    M: WR,
    p: J,
    q: pe,
    Q: $x,
    s: Ax,
    S: jR,
    u: qR,
    U: UR,
    V: KR,
    w: GR,
    W: XR,
    x: null,
    X: null,
    y: ZR,
    Y: QR,
    Z: tB,
    "%": Cx
  }, w = {
    a: L,
    A: M,
    b: O,
    B: N,
    c: R,
    d: kx,
    e: kx,
    f: yR,
    g: wx,
    G: xx,
    H: _x,
    I: _x,
    j: pR,
    L: vR,
    m: dR,
    M: mR,
    p: E,
    q: hR,
    Q: xR,
    s: wR,
    S: gR,
    u: aR,
    U: lR,
    V: cR,
    w: oR,
    W: uR,
    x: $,
    X: F,
    y: wx,
    Y: xx,
    Z: fR,
    "%": bR
  };
  x.x = k(n, x), x.X = k(r, x), x.c = k(e, x), b.x = k(n, b), b.X = k(r, b), b.c = k(e, b);
  function k(Y, se) {
    return function(ge) {
      var V = [], Ee = -1, ke = 0, Ie = Y.length, He, st, gn;
      for (ge instanceof Date || (ge = /* @__PURE__ */ new Date(+ge)); ++Ee < Ie; )
        Y.charCodeAt(Ee) === 37 && (V.push(Y.slice(ke, Ee)), (st = bx[He = Y.charAt(++Ee)]) != null ? He = Y.charAt(++Ee) : st = He === "e" ? " " : "0", (gn = se[He]) && (He = gn(ge, st)), V.push(He), ke = Ee + 1);
      return V.push(Y.slice(ke, Ee)), V.join("");
    };
  }
  function _(Y, se) {
    return function(ge) {
      var V = cl(1900, void 0, 1), Ee = C(V, Y, ge += "", 0), ke, Ie;
      if (Ee != ge.length) return null;
      if ("Q" in V) return new Date(V.Q);
      if ("s" in V) return new Date(V.s * 1e3 + ("L" in V ? V.L : 0));
      if (se && !("Z" in V) && (V.Z = 0), "p" in V && (V.H = V.H % 12 + V.p * 12), V.m === void 0 && (V.m = "q" in V ? V.q : 0), "V" in V) {
        if (V.V < 1 || V.V > 53) return null;
        "w" in V || (V.w = 1), "Z" in V ? (ke = Qp(cl(V.y, 0, 1)), Ie = ke.getUTCDay(), ke = Ie > 4 || Ie === 0 ? bc.ceil(ke) : bc(ke), ke = zd.offset(ke, (V.V - 1) * 7), V.y = ke.getUTCFullYear(), V.m = ke.getUTCMonth(), V.d = ke.getUTCDate() + (V.w + 6) % 7) : (ke = Jp(cl(V.y, 0, 1)), Ie = ke.getDay(), ke = Ie > 4 || Ie === 0 ? yc.ceil(ke) : yc(ke), ke = wo.offset(ke, (V.V - 1) * 7), V.y = ke.getFullYear(), V.m = ke.getMonth(), V.d = ke.getDate() + (V.w + 6) % 7);
      } else ("W" in V || "U" in V) && ("w" in V || (V.w = "u" in V ? V.u % 7 : "W" in V ? 1 : 0), Ie = "Z" in V ? Qp(cl(V.y, 0, 1)).getUTCDay() : Jp(cl(V.y, 0, 1)).getDay(), V.m = 0, V.d = "W" in V ? (V.w + 6) % 7 + V.W * 7 - (Ie + 5) % 7 : V.w + V.U * 7 - (Ie + 6) % 7);
      return "Z" in V ? (V.H += V.Z / 100 | 0, V.M += V.Z % 100, Qp(V)) : Jp(V);
    };
  }
  function C(Y, se, ge, V) {
    for (var Ee = 0, ke = se.length, Ie = ge.length, He, st; Ee < ke; ) {
      if (V >= Ie) return -1;
      if (He = se.charCodeAt(Ee++), He === 37) {
        if (He = se.charAt(Ee++), st = w[He in bx ? se.charAt(Ee++) : He], !st || (V = st(Y, ge, V)) < 0) return -1;
      } else if (He != ge.charCodeAt(V++))
        return -1;
    }
    return V;
  }
  function E(Y, se, ge) {
    var V = c.exec(se.slice(ge));
    return V ? (Y.p = u.get(V[0].toLowerCase()), ge + V[0].length) : -1;
  }
  function L(Y, se, ge) {
    var V = d.exec(se.slice(ge));
    return V ? (Y.w = p.get(V[0].toLowerCase()), ge + V[0].length) : -1;
  }
  function M(Y, se, ge) {
    var V = h.exec(se.slice(ge));
    return V ? (Y.w = f.get(V[0].toLowerCase()), ge + V[0].length) : -1;
  }
  function O(Y, se, ge) {
    var V = g.exec(se.slice(ge));
    return V ? (Y.m = y.get(V[0].toLowerCase()), ge + V[0].length) : -1;
  }
  function N(Y, se, ge) {
    var V = m.exec(se.slice(ge));
    return V ? (Y.m = v.get(V[0].toLowerCase()), ge + V[0].length) : -1;
  }
  function R(Y, se, ge) {
    return C(Y, e, se, ge);
  }
  function $(Y, se, ge) {
    return C(Y, n, se, ge);
  }
  function F(Y, se, ge) {
    return C(Y, r, se, ge);
  }
  function U(Y) {
    return o[Y.getDay()];
  }
  function ee(Y) {
    return s[Y.getDay()];
  }
  function ie(Y) {
    return l[Y.getMonth()];
  }
  function z(Y) {
    return a[Y.getMonth()];
  }
  function te(Y) {
    return i[+(Y.getHours() >= 12)];
  }
  function I(Y) {
    return 1 + ~~(Y.getMonth() / 3);
  }
  function X(Y) {
    return o[Y.getUTCDay()];
  }
  function Q(Y) {
    return s[Y.getUTCDay()];
  }
  function ce(Y) {
    return l[Y.getUTCMonth()];
  }
  function he(Y) {
    return a[Y.getUTCMonth()];
  }
  function J(Y) {
    return i[+(Y.getUTCHours() >= 12)];
  }
  function pe(Y) {
    return 1 + ~~(Y.getUTCMonth() / 3);
  }
  return {
    format: function(Y) {
      var se = k(Y += "", x);
      return se.toString = function() {
        return Y;
      }, se;
    },
    parse: function(Y) {
      var se = _(Y += "", !1);
      return se.toString = function() {
        return Y;
      }, se;
    },
    utcFormat: function(Y) {
      var se = k(Y += "", b);
      return se.toString = function() {
        return Y;
      }, se;
    },
    utcParse: function(Y) {
      var se = _(Y += "", !0);
      return se.toString = function() {
        return Y;
      }, se;
    }
  };
}
var bx = { "-": "", _: " ", 0: "0" }, St = /^\s*\d+/, rR = /^%/, iR = /[\\^$*+?|[\]().{}]/g;
function Ve(t, e, n) {
  var r = t < 0 ? "-" : "", i = (r ? -t : t) + "", s = i.length;
  return r + (s < n ? new Array(n - s + 1).join(e) + i : i);
}
function sR(t) {
  return t.replace(iR, "\\$&");
}
function ul(t) {
  return new RegExp("^(?:" + t.map(sR).join("|") + ")", "i");
}
function fl(t) {
  return new Map(t.map((e, n) => [e.toLowerCase(), n]));
}
function oR(t, e, n) {
  var r = St.exec(e.slice(n, n + 1));
  return r ? (t.w = +r[0], n + r[0].length) : -1;
}
function aR(t, e, n) {
  var r = St.exec(e.slice(n, n + 1));
  return r ? (t.u = +r[0], n + r[0].length) : -1;
}
function lR(t, e, n) {
  var r = St.exec(e.slice(n, n + 2));
  return r ? (t.U = +r[0], n + r[0].length) : -1;
}
function cR(t, e, n) {
  var r = St.exec(e.slice(n, n + 2));
  return r ? (t.V = +r[0], n + r[0].length) : -1;
}
function uR(t, e, n) {
  var r = St.exec(e.slice(n, n + 2));
  return r ? (t.W = +r[0], n + r[0].length) : -1;
}
function xx(t, e, n) {
  var r = St.exec(e.slice(n, n + 4));
  return r ? (t.y = +r[0], n + r[0].length) : -1;
}
function wx(t, e, n) {
  var r = St.exec(e.slice(n, n + 2));
  return r ? (t.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
}
function fR(t, e, n) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(e.slice(n, n + 6));
  return r ? (t.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
}
function hR(t, e, n) {
  var r = St.exec(e.slice(n, n + 1));
  return r ? (t.q = r[0] * 3 - 3, n + r[0].length) : -1;
}
function dR(t, e, n) {
  var r = St.exec(e.slice(n, n + 2));
  return r ? (t.m = r[0] - 1, n + r[0].length) : -1;
}
function kx(t, e, n) {
  var r = St.exec(e.slice(n, n + 2));
  return r ? (t.d = +r[0], n + r[0].length) : -1;
}
function pR(t, e, n) {
  var r = St.exec(e.slice(n, n + 3));
  return r ? (t.m = 0, t.d = +r[0], n + r[0].length) : -1;
}
function _x(t, e, n) {
  var r = St.exec(e.slice(n, n + 2));
  return r ? (t.H = +r[0], n + r[0].length) : -1;
}
function mR(t, e, n) {
  var r = St.exec(e.slice(n, n + 2));
  return r ? (t.M = +r[0], n + r[0].length) : -1;
}
function gR(t, e, n) {
  var r = St.exec(e.slice(n, n + 2));
  return r ? (t.S = +r[0], n + r[0].length) : -1;
}
function vR(t, e, n) {
  var r = St.exec(e.slice(n, n + 3));
  return r ? (t.L = +r[0], n + r[0].length) : -1;
}
function yR(t, e, n) {
  var r = St.exec(e.slice(n, n + 6));
  return r ? (t.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
}
function bR(t, e, n) {
  var r = rR.exec(e.slice(n, n + 1));
  return r ? n + r[0].length : -1;
}
function xR(t, e, n) {
  var r = St.exec(e.slice(n));
  return r ? (t.Q = +r[0], n + r[0].length) : -1;
}
function wR(t, e, n) {
  var r = St.exec(e.slice(n));
  return r ? (t.s = +r[0], n + r[0].length) : -1;
}
function Sx(t, e) {
  return Ve(t.getDate(), e, 2);
}
function kR(t, e) {
  return Ve(t.getHours(), e, 2);
}
function _R(t, e) {
  return Ve(t.getHours() % 12 || 12, e, 2);
}
function SR(t, e) {
  return Ve(1 + wo.count(hr(t), t), e, 3);
}
function L4(t, e) {
  return Ve(t.getMilliseconds(), e, 3);
}
function MR(t, e) {
  return L4(t, e) + "000";
}
function CR(t, e) {
  return Ve(t.getMonth() + 1, e, 2);
}
function $R(t, e) {
  return Ve(t.getMinutes(), e, 2);
}
function AR(t, e) {
  return Ve(t.getSeconds(), e, 2);
}
function DR(t) {
  var e = t.getDay();
  return e === 0 ? 7 : e;
}
function TR(t, e) {
  return Ve(ba.count(hr(t) - 1, t), e, 2);
}
function N4(t) {
  var e = t.getDay();
  return e >= 4 || e === 0 ? uo(t) : uo.ceil(t);
}
function OR(t, e) {
  return t = N4(t), Ve(uo.count(hr(t), t) + (hr(t).getDay() === 4), e, 2);
}
function ER(t) {
  return t.getDay();
}
function PR(t, e) {
  return Ve(yc.count(hr(t) - 1, t), e, 2);
}
function LR(t, e) {
  return Ve(t.getFullYear() % 100, e, 2);
}
function NR(t, e) {
  return t = N4(t), Ve(t.getFullYear() % 100, e, 2);
}
function IR(t, e) {
  return Ve(t.getFullYear() % 1e4, e, 4);
}
function RR(t, e) {
  var n = t.getDay();
  return t = n >= 4 || n === 0 ? uo(t) : uo.ceil(t), Ve(t.getFullYear() % 1e4, e, 4);
}
function BR(t) {
  var e = t.getTimezoneOffset();
  return (e > 0 ? "-" : (e *= -1, "+")) + Ve(e / 60 | 0, "0", 2) + Ve(e % 60, "0", 2);
}
function Mx(t, e) {
  return Ve(t.getUTCDate(), e, 2);
}
function FR(t, e) {
  return Ve(t.getUTCHours(), e, 2);
}
function zR(t, e) {
  return Ve(t.getUTCHours() % 12 || 12, e, 2);
}
function VR(t, e) {
  return Ve(1 + zd.count(dr(t), t), e, 3);
}
function I4(t, e) {
  return Ve(t.getUTCMilliseconds(), e, 3);
}
function HR(t, e) {
  return I4(t, e) + "000";
}
function YR(t, e) {
  return Ve(t.getUTCMonth() + 1, e, 2);
}
function WR(t, e) {
  return Ve(t.getUTCMinutes(), e, 2);
}
function jR(t, e) {
  return Ve(t.getUTCSeconds(), e, 2);
}
function qR(t) {
  var e = t.getUTCDay();
  return e === 0 ? 7 : e;
}
function UR(t, e) {
  return Ve(xa.count(dr(t) - 1, t), e, 2);
}
function R4(t) {
  var e = t.getUTCDay();
  return e >= 4 || e === 0 ? fo(t) : fo.ceil(t);
}
function KR(t, e) {
  return t = R4(t), Ve(fo.count(dr(t), t) + (dr(t).getUTCDay() === 4), e, 2);
}
function GR(t) {
  return t.getUTCDay();
}
function XR(t, e) {
  return Ve(bc.count(dr(t) - 1, t), e, 2);
}
function ZR(t, e) {
  return Ve(t.getUTCFullYear() % 100, e, 2);
}
function JR(t, e) {
  return t = R4(t), Ve(t.getUTCFullYear() % 100, e, 2);
}
function QR(t, e) {
  return Ve(t.getUTCFullYear() % 1e4, e, 4);
}
function eB(t, e) {
  var n = t.getUTCDay();
  return t = n >= 4 || n === 0 ? fo(t) : fo.ceil(t), Ve(t.getUTCFullYear() % 1e4, e, 4);
}
function tB() {
  return "+0000";
}
function Cx() {
  return "%";
}
function $x(t) {
  return +t;
}
function Ax(t) {
  return Math.floor(+t / 1e3);
}
var Po, i1, lu;
nB({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function nB(t) {
  return Po = nR(t), i1 = Po.format, Po.parse, lu = Po.utcFormat, Po.utcParse, Po;
}
function rB(t) {
  return new Date(t);
}
function iB(t) {
  return t instanceof Date ? +t : +/* @__PURE__ */ new Date(+t);
}
function s1(t, e, n, r, i, s, o, a, l, c) {
  var u = p4(), h = u.invert, f = u.domain, d = c(".%L"), p = c(":%S"), m = c("%I:%M"), v = c("%I %p"), g = c("%a %d"), y = c("%b %d"), x = c("%B"), b = c("%Y");
  function w(k) {
    return (l(k) < k ? d : a(k) < k ? p : o(k) < k ? m : s(k) < k ? v : r(k) < k ? i(k) < k ? g : y : n(k) < k ? x : b)(k);
  }
  return u.invert = function(k) {
    return new Date(h(k));
  }, u.domain = function(k) {
    return arguments.length ? f(Array.from(k, iB)) : f().map(rB);
  }, u.ticks = function(k) {
    var _ = f();
    return t(_[0], _[_.length - 1], k == null ? 10 : k);
  }, u.tickFormat = function(k, _) {
    return _ == null ? w : c(_);
  }, u.nice = function(k) {
    var _ = f();
    return (!k || typeof k.range != "function") && (k = e(_[0], _[_.length - 1], k == null ? 10 : k)), k ? f(g4(_, k)) : u;
  }, u.copy = function() {
    return eu(u, s1(t, e, n, r, i, s, o, a, l, c));
  }, u;
}
function sB() {
  return Zr.apply(s1(eR, tR, hr, ou, ba, wo, iu, nu, cr, i1).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function oB() {
  return Zr.apply(s1(JI, QI, dr, au, xa, zd, su, ru, cr, lu).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function Hd(t, e) {
  return e.domain(t.domain()).interpolator(t.interpolator()).clamp(t.clamp()).unknown(t.unknown());
}
function Yd() {
  var t = 0, e = 0.5, n = 1, r = 1, i, s, o, a, l, c = Fn, u, h = !1, f;
  function d(m) {
    return isNaN(m = +m) ? f : (m = 0.5 + ((m = +u(m)) - s) * (r * m < r * s ? a : l), c(h ? Math.max(0, Math.min(1, m)) : m));
  }
  d.domain = function(m) {
    return arguments.length ? ([t, e, n] = m, i = u(t = +t), s = u(e = +e), o = u(n = +n), a = i === s ? 0 : 0.5 / (s - i), l = s === o ? 0 : 0.5 / (o - s), r = s < i ? -1 : 1, d) : [t, e, n];
  }, d.clamp = function(m) {
    return arguments.length ? (h = !!m, d) : h;
  }, d.interpolator = function(m) {
    return arguments.length ? (c = m, d) : c;
  };
  function p(m) {
    return function(v) {
      var g, y, x;
      return arguments.length ? ([g, y, x] = v, c = Ed(m, [g, y, x]), d) : [c(0), c(0.5), c(1)];
    };
  }
  return d.range = p(Jc), d.rangeRound = p(Wv), d.unknown = function(m) {
    return arguments.length ? (f = m, d) : f;
  }, function(m) {
    return u = m, i = m(t), s = m(e), o = m(n), a = i === s ? 0 : 0.5 / (s - i), l = s === o ? 0 : 0.5 / (o - s), r = s < i ? -1 : 1, d;
  };
}
function B4() {
  var t = tu(Yd()(Fn));
  return t.copy = function() {
    return Hd(t, B4());
  }, Rd.apply(t, arguments);
}
function F4() {
  var t = v4(Yd()).domain([0.1, 1, 10]);
  return t.copy = function() {
    return Hd(t, F4()).base(t.base());
  }, Rd.apply(t, arguments);
}
function z4() {
  var t = b4(Yd());
  return t.copy = function() {
    return Hd(t, z4()).constant(t.constant());
  }, Rd.apply(t, arguments);
}
function V4() {
  var t = w4(Yd());
  return t.copy = function() {
    return Hd(t, V4()).exponent(t.exponent());
  }, Rd.apply(t, arguments);
}
function $e(t) {
  for (var e = t.length / 6 | 0, n = new Array(e), r = 0; r < e; ) n[r] = "#" + t.slice(r * 6, ++r * 6);
  return n;
}
const aB = $e("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"), lB = $e("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666"), cB = $e("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666"), uB = $e("4269d0efb118ff725c6cc5b03ca951ff8ab7a463f297bbf59c6b4e9498a0"), fB = $e("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928"), hB = $e("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2"), dB = $e("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc"), pB = $e("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999"), mB = $e("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3"), gB = $e("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f"), vB = $e("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab"), Ke = (t) => oL(t[t.length - 1]);
var H4 = new Array(3).concat(
  "d8b365f5f5f55ab4ac",
  "a6611adfc27d80cdc1018571",
  "a6611adfc27df5f5f580cdc1018571",
  "8c510ad8b365f6e8c3c7eae55ab4ac01665e",
  "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e",
  "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e",
  "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e",
  "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30",
  "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30"
).map($e);
const Y4 = Ke(H4);
var W4 = new Array(3).concat(
  "af8dc3f7f7f77fbf7b",
  "7b3294c2a5cfa6dba0008837",
  "7b3294c2a5cff7f7f7a6dba0008837",
  "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837",
  "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837",
  "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837",
  "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837",
  "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b",
  "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b"
).map($e);
const j4 = Ke(W4);
var q4 = new Array(3).concat(
  "e9a3c9f7f7f7a1d76a",
  "d01c8bf1b6dab8e1864dac26",
  "d01c8bf1b6daf7f7f7b8e1864dac26",
  "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221",
  "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221",
  "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221",
  "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221",
  "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419",
  "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419"
).map($e);
const U4 = Ke(q4);
var K4 = new Array(3).concat(
  "998ec3f7f7f7f1a340",
  "5e3c99b2abd2fdb863e66101",
  "5e3c99b2abd2f7f7f7fdb863e66101",
  "542788998ec3d8daebfee0b6f1a340b35806",
  "542788998ec3d8daebf7f7f7fee0b6f1a340b35806",
  "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806",
  "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806",
  "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08",
  "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08"
).map($e);
const G4 = Ke(K4);
var Jg = new Array(3).concat(
  "ef8a62f7f7f767a9cf",
  "ca0020f4a58292c5de0571b0",
  "ca0020f4a582f7f7f792c5de0571b0",
  "b2182bef8a62fddbc7d1e5f067a9cf2166ac",
  "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac",
  "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac",
  "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac",
  "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061",
  "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061"
).map($e);
const Mh = Ke(Jg);
var X4 = new Array(3).concat(
  "ef8a62ffffff999999",
  "ca0020f4a582bababa404040",
  "ca0020f4a582ffffffbababa404040",
  "b2182bef8a62fddbc7e0e0e09999994d4d4d",
  "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d",
  "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d",
  "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d",
  "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a",
  "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a"
).map($e);
const Z4 = Ke(X4);
var Qg = new Array(3).concat(
  "fc8d59ffffbf91bfdb",
  "d7191cfdae61abd9e92c7bb6",
  "d7191cfdae61ffffbfabd9e92c7bb6",
  "d73027fc8d59fee090e0f3f891bfdb4575b4",
  "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4",
  "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4",
  "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4",
  "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695",
  "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695"
).map($e);
const Ch = Ke(Qg);
var J4 = new Array(3).concat(
  "fc8d59ffffbf91cf60",
  "d7191cfdae61a6d96a1a9641",
  "d7191cfdae61ffffbfa6d96a1a9641",
  "d73027fc8d59fee08bd9ef8b91cf601a9850",
  "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850",
  "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850",
  "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850",
  "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837",
  "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837"
).map($e);
const Q4 = Ke(J4);
var e5 = new Array(3).concat(
  "fc8d59ffffbf99d594",
  "d7191cfdae61abdda42b83ba",
  "d7191cfdae61ffffbfabdda42b83ba",
  "d53e4ffc8d59fee08be6f59899d5943288bd",
  "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd",
  "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd",
  "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd",
  "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2",
  "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2"
).map($e);
const t5 = Ke(e5);
var n5 = new Array(3).concat(
  "e5f5f999d8c92ca25f",
  "edf8fbb2e2e266c2a4238b45",
  "edf8fbb2e2e266c2a42ca25f006d2c",
  "edf8fbccece699d8c966c2a42ca25f006d2c",
  "edf8fbccece699d8c966c2a441ae76238b45005824",
  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824",
  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b"
).map($e);
const r5 = Ke(n5);
var i5 = new Array(3).concat(
  "e0ecf49ebcda8856a7",
  "edf8fbb3cde38c96c688419d",
  "edf8fbb3cde38c96c68856a7810f7c",
  "edf8fbbfd3e69ebcda8c96c68856a7810f7c",
  "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b",
  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b",
  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b"
).map($e);
const s5 = Ke(i5);
var o5 = new Array(3).concat(
  "e0f3dba8ddb543a2ca",
  "f0f9e8bae4bc7bccc42b8cbe",
  "f0f9e8bae4bc7bccc443a2ca0868ac",
  "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac",
  "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e",
  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e",
  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081"
).map($e);
const a5 = Ke(o5);
var l5 = new Array(3).concat(
  "fee8c8fdbb84e34a33",
  "fef0d9fdcc8afc8d59d7301f",
  "fef0d9fdcc8afc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000"
).map($e);
const c5 = Ke(l5);
var u5 = new Array(3).concat(
  "ece2f0a6bddb1c9099",
  "f6eff7bdc9e167a9cf02818a",
  "f6eff7bdc9e167a9cf1c9099016c59",
  "f6eff7d0d1e6a6bddb67a9cf1c9099016c59",
  "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450",
  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450",
  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636"
).map($e);
const f5 = Ke(u5);
var h5 = new Array(3).concat(
  "ece7f2a6bddb2b8cbe",
  "f1eef6bdc9e174a9cf0570b0",
  "f1eef6bdc9e174a9cf2b8cbe045a8d",
  "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d",
  "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b",
  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b",
  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858"
).map($e);
const d5 = Ke(h5);
var p5 = new Array(3).concat(
  "e7e1efc994c7dd1c77",
  "f1eef6d7b5d8df65b0ce1256",
  "f1eef6d7b5d8df65b0dd1c77980043",
  "f1eef6d4b9dac994c7df65b0dd1c77980043",
  "f1eef6d4b9dac994c7df65b0e7298ace125691003f",
  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f",
  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f"
).map($e);
const m5 = Ke(p5);
var g5 = new Array(3).concat(
  "fde0ddfa9fb5c51b8a",
  "feebe2fbb4b9f768a1ae017e",
  "feebe2fbb4b9f768a1c51b8a7a0177",
  "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177",
  "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177",
  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177",
  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a"
).map($e);
const v5 = Ke(g5);
var y5 = new Array(3).concat(
  "edf8b17fcdbb2c7fb8",
  "ffffcca1dab441b6c4225ea8",
  "ffffcca1dab441b6c42c7fb8253494",
  "ffffccc7e9b47fcdbb41b6c42c7fb8253494",
  "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84",
  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84",
  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58"
).map($e);
const b5 = Ke(y5);
var x5 = new Array(3).concat(
  "f7fcb9addd8e31a354",
  "ffffccc2e69978c679238443",
  "ffffccc2e69978c67931a354006837",
  "ffffccd9f0a3addd8e78c67931a354006837",
  "ffffccd9f0a3addd8e78c67941ab5d238443005a32",
  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32",
  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529"
).map($e);
const w5 = Ke(x5);
var k5 = new Array(3).concat(
  "fff7bcfec44fd95f0e",
  "ffffd4fed98efe9929cc4c02",
  "ffffd4fed98efe9929d95f0e993404",
  "ffffd4fee391fec44ffe9929d95f0e993404",
  "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04",
  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04",
  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506"
).map($e);
const _5 = Ke(k5);
var S5 = new Array(3).concat(
  "ffeda0feb24cf03b20",
  "ffffb2fecc5cfd8d3ce31a1c",
  "ffffb2fecc5cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026"
).map($e);
const M5 = Ke(S5);
var C5 = new Array(3).concat(
  "deebf79ecae13182bd",
  "eff3ffbdd7e76baed62171b5",
  "eff3ffbdd7e76baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b"
).map($e);
const $5 = Ke(C5);
var A5 = new Array(3).concat(
  "e5f5e0a1d99b31a354",
  "edf8e9bae4b374c476238b45",
  "edf8e9bae4b374c47631a354006d2c",
  "edf8e9c7e9c0a1d99b74c47631a354006d2c",
  "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32",
  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32",
  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b"
).map($e);
const D5 = Ke(A5);
var T5 = new Array(3).concat(
  "f0f0f0bdbdbd636363",
  "f7f7f7cccccc969696525252",
  "f7f7f7cccccc969696636363252525",
  "f7f7f7d9d9d9bdbdbd969696636363252525",
  "f7f7f7d9d9d9bdbdbd969696737373525252252525",
  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525",
  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000"
).map($e);
const O5 = Ke(T5);
var E5 = new Array(3).concat(
  "efedf5bcbddc756bb1",
  "f2f0f7cbc9e29e9ac86a51a3",
  "f2f0f7cbc9e29e9ac8756bb154278f",
  "f2f0f7dadaebbcbddc9e9ac8756bb154278f",
  "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486",
  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486",
  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d"
).map($e);
const P5 = Ke(E5);
var L5 = new Array(3).concat(
  "fee0d2fc9272de2d26",
  "fee5d9fcae91fb6a4acb181d",
  "fee5d9fcae91fb6a4ade2d26a50f15",
  "fee5d9fcbba1fc9272fb6a4ade2d26a50f15",
  "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d",
  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d",
  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d"
).map($e);
const N5 = Ke(L5);
var I5 = new Array(3).concat(
  "fee6cefdae6be6550d",
  "feeddefdbe85fd8d3cd94701",
  "feeddefdbe85fd8d3ce6550da63603",
  "feeddefdd0a2fdae6bfd8d3ce6550da63603",
  "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04",
  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04",
  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704"
).map($e);
const R5 = Ke(I5);
function B5(t) {
  return t = Math.max(0, Math.min(1, t)), "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67))))))) + ")";
}
const F5 = jv(qr(300, 0.5, 0), qr(-240, 0.5, 1));
var z5 = jv(qr(-100, 0.75, 0.35), qr(80, 1.5, 0.8)), V5 = jv(qr(260, 0.75, 0.35), qr(80, 1.5, 0.8)), Wu = qr();
function H5(t) {
  (t < 0 || t > 1) && (t -= Math.floor(t));
  var e = Math.abs(t - 0.5);
  return Wu.h = 360 * t - 100, Wu.s = 1.5 - 1.5 * e, Wu.l = 0.8 - 0.9 * e, Wu + "";
}
var ju = us(), yB = Math.PI / 3, bB = Math.PI * 2 / 3;
function Y5(t) {
  var e;
  return t = (0.5 - t) * Math.PI, ju.r = 255 * (e = Math.sin(t)) * e, ju.g = 255 * (e = Math.sin(t + yB)) * e, ju.b = 255 * (e = Math.sin(t + bB)) * e, ju + "";
}
function W5(t) {
  return t = Math.max(0, Math.min(1, t)), "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66))))))) + ")";
}
function Wd(t) {
  var e = t.length;
  return function(n) {
    return t[Math.max(0, Math.min(e - 1, Math.floor(n * e)))];
  };
}
const j5 = Wd($e("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var q5 = Wd($e("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf")), U5 = Wd($e("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4")), K5 = Wd($e("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
function Lo(t) {
  return function() {
    return t;
  };
}
const G5 = Math.cos, o1 = Math.min, $h = Math.sin, xt = Math.sqrt, Dx = 1e-12, Ah = Math.PI, jd = 2 * Ah;
function xB(t) {
  let e = 3;
  return t.digits = function(n) {
    if (!arguments.length) return e;
    if (n == null)
      e = null;
    else {
      const r = Math.floor(n);
      if (!(r >= 0)) throw new RangeError(`invalid digits: ${n}`);
      e = r;
    }
    return t;
  }, () => new OS(e);
}
function wB(t) {
  return typeof t == "object" && "length" in t ? t : Array.from(t);
}
function X5(t) {
  this._context = t;
}
X5.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(t, e);
        break;
    }
  }
};
function qd(t) {
  return new X5(t);
}
function kB(t) {
  return t[0];
}
function _B(t) {
  return t[1];
}
function SB(t, e) {
  var n = Lo(!0), r = null, i = qd, s = null, o = xB(a);
  t = typeof t == "function" ? t : t === void 0 ? kB : Lo(t), e = typeof e == "function" ? e : e === void 0 ? _B : Lo(e);
  function a(l) {
    var c, u = (l = wB(l)).length, h, f = !1, d;
    for (r == null && (s = i(d = o())), c = 0; c <= u; ++c)
      !(c < u && n(h = l[c], c, l)) === f && ((f = !f) ? s.lineStart() : s.lineEnd()), f && s.point(+t(h, c, l), +e(h, c, l));
    if (d) return s = null, d + "" || null;
  }
  return a.x = function(l) {
    return arguments.length ? (t = typeof l == "function" ? l : Lo(+l), a) : t;
  }, a.y = function(l) {
    return arguments.length ? (e = typeof l == "function" ? l : Lo(+l), a) : e;
  }, a.defined = function(l) {
    return arguments.length ? (n = typeof l == "function" ? l : Lo(!!l), a) : n;
  }, a.curve = function(l) {
    return arguments.length ? (i = l, r != null && (s = i(r)), a) : i;
  }, a.context = function(l) {
    return arguments.length ? (l == null ? r = s = null : s = i(r = l), a) : r;
  }, a;
}
class Z5 {
  constructor(e, n) {
    this._context = e, this._x = n;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(e, n) {
    switch (e = +e, n = +n, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(e, n) : this._context.moveTo(e, n);
        break;
      }
      case 1:
        this._point = 2;
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + e) / 2, this._y0, this._x0, n, e, n) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + n) / 2, e, this._y0, e, n);
        break;
      }
    }
    this._x0 = e, this._y0 = n;
  }
}
function MB(t) {
  return new Z5(t, !0);
}
function CB(t) {
  return new Z5(t, !1);
}
const $B = xt(3), J5 = {
  draw(t, e) {
    const n = xt(e + o1(e / 28, 0.75)) * 0.59436, r = n / 2, i = r * $B;
    t.moveTo(0, n), t.lineTo(0, -n), t.moveTo(-i, -r), t.lineTo(i, r), t.moveTo(-i, r), t.lineTo(i, -r);
  }
}, a1 = {
  draw(t, e) {
    const n = xt(e / Ah);
    t.moveTo(n, 0), t.arc(0, 0, n, 0, jd);
  }
}, Q5 = {
  draw(t, e) {
    const n = xt(e / 5) / 2;
    t.moveTo(-3 * n, -n), t.lineTo(-n, -n), t.lineTo(-n, -3 * n), t.lineTo(n, -3 * n), t.lineTo(n, -n), t.lineTo(3 * n, -n), t.lineTo(3 * n, n), t.lineTo(n, n), t.lineTo(n, 3 * n), t.lineTo(-n, 3 * n), t.lineTo(-n, n), t.lineTo(-3 * n, n), t.closePath();
  }
}, eM = xt(1 / 3), AB = eM * 2, tM = {
  draw(t, e) {
    const n = xt(e / AB), r = n * eM;
    t.moveTo(0, -n), t.lineTo(r, 0), t.lineTo(0, n), t.lineTo(-r, 0), t.closePath();
  }
}, nM = {
  draw(t, e) {
    const n = xt(e) * 0.62625;
    t.moveTo(0, -n), t.lineTo(n, 0), t.lineTo(0, n), t.lineTo(-n, 0), t.closePath();
  }
}, rM = {
  draw(t, e) {
    const n = xt(e - o1(e / 7, 2)) * 0.87559;
    t.moveTo(-n, 0), t.lineTo(n, 0), t.moveTo(0, n), t.lineTo(0, -n);
  }
}, iM = {
  draw(t, e) {
    const n = xt(e), r = -n / 2;
    t.rect(r, r, n, n);
  }
}, sM = {
  draw(t, e) {
    const n = xt(e) * 0.4431;
    t.moveTo(n, n), t.lineTo(n, -n), t.lineTo(-n, -n), t.lineTo(-n, n), t.closePath();
  }
}, DB = 0.8908130915292852, oM = $h(Ah / 10) / $h(7 * Ah / 10), TB = $h(jd / 10) * oM, OB = -G5(jd / 10) * oM, aM = {
  draw(t, e) {
    const n = xt(e * DB), r = TB * n, i = OB * n;
    t.moveTo(0, -n), t.lineTo(r, i);
    for (let s = 1; s < 5; ++s) {
      const o = jd * s / 5, a = G5(o), l = $h(o);
      t.lineTo(l * n, -a * n), t.lineTo(a * r - l * i, l * r + a * i);
    }
    t.closePath();
  }
}, em = xt(3), lM = {
  draw(t, e) {
    const n = -xt(e / (em * 3));
    t.moveTo(0, n * 2), t.lineTo(-em * n, -n), t.lineTo(em * n, -n), t.closePath();
  }
}, EB = xt(3), cM = {
  draw(t, e) {
    const n = xt(e) * 0.6824, r = n / 2, i = n * EB / 2;
    t.moveTo(0, -n), t.lineTo(i, r), t.lineTo(-i, r), t.closePath();
  }
}, Pn = -0.5, Ln = xt(3) / 2, e0 = 1 / xt(12), PB = (e0 / 2 + 1) * 3, uM = {
  draw(t, e) {
    const n = xt(e / PB), r = n / 2, i = n * e0, s = r, o = n * e0 + n, a = -s, l = o;
    t.moveTo(r, i), t.lineTo(s, o), t.lineTo(a, l), t.lineTo(Pn * r - Ln * i, Ln * r + Pn * i), t.lineTo(Pn * s - Ln * o, Ln * s + Pn * o), t.lineTo(Pn * a - Ln * l, Ln * a + Pn * l), t.lineTo(Pn * r + Ln * i, Pn * i - Ln * r), t.lineTo(Pn * s + Ln * o, Pn * o - Ln * s), t.lineTo(Pn * a + Ln * l, Pn * l - Ln * a), t.closePath();
  }
}, fM = {
  draw(t, e) {
    const n = xt(e - o1(e / 6, 1.7)) * 0.6189;
    t.moveTo(-n, -n), t.lineTo(n, n), t.moveTo(-n, n), t.lineTo(n, -n);
  }
}, LB = [
  a1,
  Q5,
  tM,
  iM,
  aM,
  lM,
  uM
], NB = [
  a1,
  rM,
  fM,
  cM,
  J5,
  sM,
  nM
];
function fs() {
}
function Dh(t, e, n) {
  t._context.bezierCurveTo(
    (2 * t._x0 + t._x1) / 3,
    (2 * t._y0 + t._y1) / 3,
    (t._x0 + 2 * t._x1) / 3,
    (t._y0 + 2 * t._y1) / 3,
    (t._x0 + 4 * t._x1 + e) / 6,
    (t._y0 + 4 * t._y1 + n) / 6
  );
}
function Ud(t) {
  this._context = t;
}
Ud.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        Dh(this, this._x1, this._y1);
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      default:
        Dh(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
  }
};
function IB(t) {
  return new Ud(t);
}
function hM(t) {
  this._context = t;
}
hM.prototype = {
  areaStart: fs,
  areaEnd: fs,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._x2 = t, this._y2 = e;
        break;
      case 1:
        this._point = 2, this._x3 = t, this._y3 = e;
        break;
      case 2:
        this._point = 3, this._x4 = t, this._y4 = e, this._context.moveTo((this._x0 + 4 * this._x1 + t) / 6, (this._y0 + 4 * this._y1 + e) / 6);
        break;
      default:
        Dh(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
  }
};
function RB(t) {
  return new hM(t);
}
function dM(t) {
  this._context = t;
}
dM.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var n = (this._x0 + 4 * this._x1 + t) / 6, r = (this._y0 + 4 * this._y1 + e) / 6;
        this._line ? this._context.lineTo(n, r) : this._context.moveTo(n, r);
        break;
      case 3:
        this._point = 4;
      default:
        Dh(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
  }
};
function BB(t) {
  return new dM(t);
}
function pM(t, e) {
  this._basis = new Ud(t), this._beta = e;
}
pM.prototype = {
  lineStart: function() {
    this._x = [], this._y = [], this._basis.lineStart();
  },
  lineEnd: function() {
    var t = this._x, e = this._y, n = t.length - 1;
    if (n > 0)
      for (var r = t[0], i = e[0], s = t[n] - r, o = e[n] - i, a = -1, l; ++a <= n; )
        l = a / n, this._basis.point(
          this._beta * t[a] + (1 - this._beta) * (r + l * s),
          this._beta * e[a] + (1 - this._beta) * (i + l * o)
        );
    this._x = this._y = null, this._basis.lineEnd();
  },
  point: function(t, e) {
    this._x.push(+t), this._y.push(+e);
  }
};
const FB = function t(e) {
  function n(r) {
    return e === 1 ? new Ud(r) : new pM(r, e);
  }
  return n.beta = function(r) {
    return t(+r);
  }, n;
}(0.85);
function Th(t, e, n) {
  t._context.bezierCurveTo(
    t._x1 + t._k * (t._x2 - t._x0),
    t._y1 + t._k * (t._y2 - t._y0),
    t._x2 + t._k * (t._x1 - e),
    t._y2 + t._k * (t._y1 - n),
    t._x2,
    t._y2
  );
}
function l1(t, e) {
  this._context = t, this._k = (1 - e) / 6;
}
l1.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        Th(this, this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2, this._x1 = t, this._y1 = e;
        break;
      case 2:
        this._point = 3;
      default:
        Th(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const zB = function t(e) {
  function n(r) {
    return new l1(r, e);
  }
  return n.tension = function(r) {
    return t(+r);
  }, n;
}(0);
function c1(t, e) {
  this._context = t, this._k = (1 - e) / 6;
}
c1.prototype = {
  areaStart: fs,
  areaEnd: fs,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._x3 = t, this._y3 = e;
        break;
      case 1:
        this._point = 2, this._context.moveTo(this._x4 = t, this._y4 = e);
        break;
      case 2:
        this._point = 3, this._x5 = t, this._y5 = e;
        break;
      default:
        Th(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const VB = function t(e) {
  function n(r) {
    return new c1(r, e);
  }
  return n.tension = function(r) {
    return t(+r);
  }, n;
}(0);
function u1(t, e) {
  this._context = t, this._k = (1 - e) / 6;
}
u1.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      default:
        Th(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const HB = function t(e) {
  function n(r) {
    return new u1(r, e);
  }
  return n.tension = function(r) {
    return t(+r);
  }, n;
}(0);
function f1(t, e, n) {
  var r = t._x1, i = t._y1, s = t._x2, o = t._y2;
  if (t._l01_a > Dx) {
    var a = 2 * t._l01_2a + 3 * t._l01_a * t._l12_a + t._l12_2a, l = 3 * t._l01_a * (t._l01_a + t._l12_a);
    r = (r * a - t._x0 * t._l12_2a + t._x2 * t._l01_2a) / l, i = (i * a - t._y0 * t._l12_2a + t._y2 * t._l01_2a) / l;
  }
  if (t._l23_a > Dx) {
    var c = 2 * t._l23_2a + 3 * t._l23_a * t._l12_a + t._l12_2a, u = 3 * t._l23_a * (t._l23_a + t._l12_a);
    s = (s * c + t._x1 * t._l23_2a - e * t._l12_2a) / u, o = (o * c + t._y1 * t._l23_2a - n * t._l12_2a) / u;
  }
  t._context.bezierCurveTo(r, i, s, o, t._x2, t._y2);
}
function mM(t, e) {
  this._context = t, this._alpha = e;
}
mM.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        this.point(this._x2, this._y2);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    if (t = +t, e = +e, this._point) {
      var n = this._x2 - t, r = this._y2 - e;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
      default:
        f1(this, t, e);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const YB = function t(e) {
  function n(r) {
    return e ? new mM(r, e) : new l1(r, 0);
  }
  return n.alpha = function(r) {
    return t(+r);
  }, n;
}(0.5);
function gM(t, e) {
  this._context = t, this._alpha = e;
}
gM.prototype = {
  areaStart: fs,
  areaEnd: fs,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(t, e) {
    if (t = +t, e = +e, this._point) {
      var n = this._x2 - t, r = this._y2 - e;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._x3 = t, this._y3 = e;
        break;
      case 1:
        this._point = 2, this._context.moveTo(this._x4 = t, this._y4 = e);
        break;
      case 2:
        this._point = 3, this._x5 = t, this._y5 = e;
        break;
      default:
        f1(this, t, e);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const WB = function t(e) {
  function n(r) {
    return e ? new gM(r, e) : new c1(r, 0);
  }
  return n.alpha = function(r) {
    return t(+r);
  }, n;
}(0.5);
function vM(t, e) {
  this._context = t, this._alpha = e;
}
vM.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    if (t = +t, e = +e, this._point) {
      var n = this._x2 - t, r = this._y2 - e;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      default:
        f1(this, t, e);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const jB = function t(e) {
  function n(r) {
    return e ? new vM(r, e) : new u1(r, 0);
  }
  return n.alpha = function(r) {
    return t(+r);
  }, n;
}(0.5);
function yM(t) {
  this._context = t;
}
yM.prototype = {
  areaStart: fs,
  areaEnd: fs,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(t, e) {
    t = +t, e = +e, this._point ? this._context.lineTo(t, e) : (this._point = 1, this._context.moveTo(t, e));
  }
};
function qB(t) {
  return new yM(t);
}
function Tx(t) {
  return t < 0 ? -1 : 1;
}
function Ox(t, e, n) {
  var r = t._x1 - t._x0, i = e - t._x1, s = (t._y1 - t._y0) / (r || i < 0 && -0), o = (n - t._y1) / (i || r < 0 && -0), a = (s * i + o * r) / (r + i);
  return (Tx(s) + Tx(o)) * Math.min(Math.abs(s), Math.abs(o), 0.5 * Math.abs(a)) || 0;
}
function Ex(t, e) {
  var n = t._x1 - t._x0;
  return n ? (3 * (t._y1 - t._y0) / n - e) / 2 : e;
}
function tm(t, e, n) {
  var r = t._x0, i = t._y0, s = t._x1, o = t._y1, a = (s - r) / 3;
  t._context.bezierCurveTo(r + a, i + a * e, s - a, o - a * n, s, o);
}
function Oh(t) {
  this._context = t;
}
Oh.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        tm(this, this._t0, Ex(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    var n = NaN;
    if (t = +t, e = +e, !(t === this._x1 && e === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, tm(this, Ex(this, n = Ox(this, t, e)), n);
          break;
        default:
          tm(this, this._t0, n = Ox(this, t, e));
          break;
      }
      this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e, this._t0 = n;
    }
  }
};
function bM(t) {
  this._context = new xM(t);
}
(bM.prototype = Object.create(Oh.prototype)).point = function(t, e) {
  Oh.prototype.point.call(this, e, t);
};
function xM(t) {
  this._context = t;
}
xM.prototype = {
  moveTo: function(t, e) {
    this._context.moveTo(e, t);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(t, e) {
    this._context.lineTo(e, t);
  },
  bezierCurveTo: function(t, e, n, r, i, s) {
    this._context.bezierCurveTo(e, t, r, n, s, i);
  }
};
function UB(t) {
  return new Oh(t);
}
function KB(t) {
  return new bM(t);
}
function wM(t) {
  this._context = t;
}
wM.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var t = this._x, e = this._y, n = t.length;
    if (n)
      if (this._line ? this._context.lineTo(t[0], e[0]) : this._context.moveTo(t[0], e[0]), n === 2)
        this._context.lineTo(t[1], e[1]);
      else
        for (var r = Px(t), i = Px(e), s = 0, o = 1; o < n; ++s, ++o)
          this._context.bezierCurveTo(r[0][s], i[0][s], r[1][s], i[1][s], t[o], e[o]);
    (this._line || this._line !== 0 && n === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(t, e) {
    this._x.push(+t), this._y.push(+e);
  }
};
function Px(t) {
  var e, n = t.length - 1, r, i = new Array(n), s = new Array(n), o = new Array(n);
  for (i[0] = 0, s[0] = 2, o[0] = t[0] + 2 * t[1], e = 1; e < n - 1; ++e) i[e] = 1, s[e] = 4, o[e] = 4 * t[e] + 2 * t[e + 1];
  for (i[n - 1] = 2, s[n - 1] = 7, o[n - 1] = 8 * t[n - 1] + t[n], e = 1; e < n; ++e) r = i[e] / s[e - 1], s[e] -= r, o[e] -= r * o[e - 1];
  for (i[n - 1] = o[n - 1] / s[n - 1], e = n - 2; e >= 0; --e) i[e] = (o[e] - i[e + 1]) / s[e];
  for (s[n - 1] = (t[n] + i[n - 1]) / 2, e = 0; e < n - 1; ++e) s[e] = 2 * t[e + 1] - i[e + 1];
  return [i, s];
}
function GB(t) {
  return new wM(t);
}
function Kd(t, e) {
  this._context = t, this._t = e;
}
Kd.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, e), this._context.lineTo(t, e);
        else {
          var n = this._x * (1 - this._t) + t * this._t;
          this._context.lineTo(n, this._y), this._context.lineTo(n, e);
        }
        break;
      }
    }
    this._x = t, this._y = e;
  }
};
function XB(t) {
  return new Kd(t, 0.5);
}
function ZB(t) {
  return new Kd(t, 0);
}
function JB(t) {
  return new Kd(t, 1);
}
function Nl(t, e, n) {
  this.k = t, this.x = e, this.y = n;
}
Nl.prototype = {
  constructor: Nl,
  scale: function(t) {
    return t === 1 ? this : new Nl(this.k * t, this.x, this.y);
  },
  translate: function(t, e) {
    return t === 0 & e === 0 ? this : new Nl(this.k, this.x + this.k * t, this.y + this.k * e);
  },
  apply: function(t) {
    return [t[0] * this.k + this.x, t[1] * this.k + this.y];
  },
  applyX: function(t) {
    return t * this.k + this.x;
  },
  applyY: function(t) {
    return t * this.k + this.y;
  },
  invert: function(t) {
    return [(t[0] - this.x) / this.k, (t[1] - this.y) / this.k];
  },
  invertX: function(t) {
    return (t - this.x) / this.k;
  },
  invertY: function(t) {
    return (t - this.y) / this.k;
  },
  rescaleX: function(t) {
    return t.copy().domain(t.range().map(this.invertX, this).map(t.invert, t));
  },
  rescaleY: function(t) {
    return t.copy().domain(t.range().map(this.invertY, this).map(t.invert, t));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
Nl.prototype;
function hs(t) {
  return t != null && !Number.isNaN(t);
}
function Ur(t, e) {
  return +hs(e) - +hs(t) || hn(t, e);
}
function Eh(t, e) {
  return +hs(e) - +hs(t) || Gc(t, e);
}
function h1(t) {
  return t != null && `${t}` != "";
}
function kM(t) {
  return isFinite(t) ? t : NaN;
}
function d1(t) {
  return t > 0 && isFinite(t) ? t : NaN;
}
function _M(t) {
  return t < 0 && isFinite(t) ? t : NaN;
}
function QB(t, e) {
  if (t instanceof Date || (t = /* @__PURE__ */ new Date(+t)), isNaN(t)) return typeof e == "function" ? e(t) : e;
  const n = t.getUTCHours(), r = t.getUTCMinutes(), i = t.getUTCSeconds(), s = t.getUTCMilliseconds();
  return `${eF(t.getUTCFullYear())}-${li(t.getUTCMonth() + 1, 2)}-${li(t.getUTCDate(), 2)}${n || r || i || s ? `T${li(n, 2)}:${li(r, 2)}${i || s ? `:${li(i, 2)}${s ? `.${li(s, 3)}` : ""}` : ""}Z` : ""}`;
}
function eF(t) {
  return t < 0 ? `-${li(-t, 6)}` : t > 9999 ? `+${li(t, 6)}` : li(t, 4);
}
function li(t, e) {
  return `${t}`.padStart(e, "0");
}
const tF = /^(?:[-+]\d{2})?\d{4}(?:-\d{2}(?:-\d{2})?)?(?:T\d{2}:\d{2}(?::\d{2}(?:\.\d{3})?)?(?:Z|[-+]\d{2}:?\d{2})?)?$/;
function SM(t, e) {
  return tF.test(t += "") ? new Date(t) : typeof e == "function" ? e(t) : e;
}
function wa(t) {
  if (t == null) return;
  const e = t[0], n = t[t.length - 1];
  return Gc(e, n);
}
const jo = 1e3, Xi = jo * 60, Zi = Xi * 60, Kr = Zi * 24, $r = Kr * 7, Zs = Kr * 30, Hi = Kr * 365, nm = [
  ["millisecond", 1],
  ["2 milliseconds", 2],
  ["5 milliseconds", 5],
  ["10 milliseconds", 10],
  ["20 milliseconds", 20],
  ["50 milliseconds", 50],
  ["100 milliseconds", 100],
  ["200 milliseconds", 200],
  ["500 milliseconds", 500],
  ["second", jo],
  ["5 seconds", 5 * jo],
  ["15 seconds", 15 * jo],
  ["30 seconds", 30 * jo],
  ["minute", Xi],
  ["5 minutes", 5 * Xi],
  ["15 minutes", 15 * Xi],
  ["30 minutes", 30 * Xi],
  ["hour", Zi],
  ["3 hours", 3 * Zi],
  ["6 hours", 6 * Zi],
  ["12 hours", 12 * Zi],
  ["day", Kr],
  ["2 days", 2 * Kr],
  ["week", $r],
  ["2 weeks", 2 * $r],
  // https://github.com/d3/d3-time/issues/46
  ["month", Zs],
  ["3 months", 3 * Zs],
  ["6 months", 6 * Zs],
  // https://github.com/d3/d3-time/issues/46
  ["year", Hi],
  ["2 years", 2 * Hi],
  ["5 years", 5 * Hi],
  ["10 years", 10 * Hi],
  ["20 years", 20 * Hi],
  ["50 years", 50 * Hi],
  ["100 years", 100 * Hi]
  // TODO generalize to longer time scales
], p1 = /* @__PURE__ */ new Map([
  ["second", jo],
  ["minute", Xi],
  ["hour", Zi],
  ["day", Kr],
  ["monday", $r],
  ["tuesday", $r],
  ["wednesday", $r],
  ["thursday", $r],
  ["friday", $r],
  ["saturday", $r],
  ["sunday", $r],
  ["week", $r],
  ["month", Zs],
  ["year", Hi]
]), MM = /* @__PURE__ */ new Map([
  ["second", cr],
  ["minute", nu],
  ["hour", iu],
  ["day", wo],
  // https://github.com/d3/d3-time/issues/62
  ["monday", yc],
  ["tuesday", M4],
  ["wednesday", C4],
  ["thursday", uo],
  ["friday", $4],
  ["saturday", A4],
  ["sunday", ba],
  ["week", ba],
  ["month", ou],
  ["year", hr]
]), m1 = /* @__PURE__ */ new Map([
  ["second", cr],
  ["minute", ru],
  ["hour", su],
  ["day", Vd],
  ["monday", bc],
  ["tuesday", D4],
  ["wednesday", T4],
  ["thursday", fo],
  ["friday", O4],
  ["saturday", E4],
  ["sunday", xa],
  ["week", xa],
  ["month", au],
  ["year", dr]
]), cu = Symbol("intervalDuration"), Gd = Symbol("intervalType");
for (const [t, e] of MM)
  e[cu] = p1.get(t), e[Gd] = "time";
for (const [t, e] of m1)
  e[cu] = p1.get(t), e[Gd] = "utc";
const Il = [
  ["year", dr, "utc"],
  ["month", au, "utc"],
  ["day", Vd, "utc", 6 * Zs],
  ["hour", su, "utc", 3 * Kr],
  ["minute", ru, "utc", 6 * Zi],
  ["second", cr, "utc", 30 * Xi]
], Pf = [
  ["year", hr, "time"],
  ["month", ou, "time"],
  ["day", wo, "time", 6 * Zs],
  ["hour", iu, "time", 3 * Kr],
  ["minute", nu, "time", 6 * Zi],
  ["second", cr, "time", 30 * Xi]
], nF = [
  Il[0],
  Pf[0],
  Il[1],
  Pf[1],
  Il[2],
  Pf[2],
  // Below day, local time typically has an hourly offset from UTC and hence the
  // two are aligned and indistinguishable; therefore, we only consider UTC, and
  // we don’t consider these if the domain only has a single value.
  ...Il.slice(3)
];
function CM(t) {
  let e = `${t}`.toLowerCase();
  e.endsWith("s") && (e = e.slice(0, -1));
  let n = 1;
  const r = /^(?:(\d+)\s+)/.exec(e);
  switch (r && (e = e.slice(r[0].length), n = +r[1]), e) {
    case "quarter":
      e = "month", n *= 3;
      break;
    case "half":
      e = "month", n *= 6;
      break;
  }
  let i = m1.get(e);
  if (!i) throw new Error(`unknown interval: ${t}`);
  if (n > 1 && !i.every) throw new Error(`non-periodic interval: ${e}`);
  return [e, n];
}
function $M(t) {
  return DM(CM(t), "time");
}
function AM(t) {
  return DM(CM(t), "utc");
}
function DM([t, e], n) {
  let r = (n === "time" ? MM : m1).get(t);
  return e > 1 && (r = r.every(e), r[cu] = p1.get(t) * e, r[Gd] = n), r;
}
function Lx(t, e) {
  if (!(e > 1)) return;
  const n = t[cu];
  if (!nm.some(([, i]) => i === n) || n % Kr === 0 && Kr < n && n < Zs) return;
  const [r] = nm[Cd(([, i]) => Math.log(i)).center(nm, Math.log(n * e))];
  return (t[Gd] === "time" ? $M : AM)(r);
}
function Nx(t, e, n) {
  const r = e === "time" ? i1 : lu;
  if (n == null)
    return r(
      t === "year" ? "%Y" : t === "month" ? "%Y-%m" : t === "day" ? "%Y-%m-%d" : t === "hour" || t === "minute" ? "%Y-%m-%dT%H:%M" : t === "second" ? "%Y-%m-%dT%H:%M:%S" : "%Y-%m-%dT%H:%M:%S.%L"
    );
  const i = rF(n);
  switch (t) {
    case "millisecond":
      return No(r(".%L"), r(":%M:%S"), i);
    case "second":
      return No(r(":%S"), r("%-I:%M"), i);
    case "minute":
      return No(r("%-I:%M"), r("%p"), i);
    case "hour":
      return No(r("%-I %p"), r("%b %-d"), i);
    case "day":
      return No(r("%-d"), r("%b"), i);
    case "month":
      return No(r("%b"), r("%Y"), i);
    case "year":
      return r("%Y");
  }
  throw new Error("unable to format time ticks");
}
function rF(t) {
  return t === "left" || t === "right" ? (e, n) => `
${e}
${n}` : t === "top" ? (e, n) => `${n}
${e}` : (e, n) => `${e}
${n}`;
}
function iF(t) {
  return t === "time" ? Pf : t === "utc" ? Il : nF;
}
function sF(t, e, n) {
  const r = ur(G9(e, (i, s) => Math.abs(s - i)));
  if (r < 1e3) return Nx("millisecond", "utc", n);
  for (const [i, s, o, a] of iF(t)) {
    if (r > a || i === "hour" && !r) break;
    if (e.every((l) => s.floor(l) >= l)) return Nx(i, o, n);
  }
}
function No(t, e, n) {
  return (r, i, s) => {
    const o = t(r, i), a = e(r, i), l = i - wa(s);
    return i !== l && s[l] !== void 0 && a === e(s[l], l) ? o : n(o, a);
  };
}
const xc = Object.getPrototypeOf(Uint8Array), oF = Object.prototype.toString, TM = Symbol("reindex");
function Wn(t, e, n) {
  const r = typeof e;
  return r === "string" ? Ix(t, OM(e), n) : r === "function" ? Ix(t, e, n) : r === "number" || e instanceof Date || r === "boolean" ? _t(t, uu(e), n) : typeof (e == null ? void 0 : e.transform) == "function" ? Rx(e.transform(t), n) : aF(Rx(e, n), t == null ? void 0 : t[TM]);
}
function aF(t, e) {
  return t != null && e ? b1(t, e) : t;
}
function Ix(t, e, n) {
  return _t(t, (n == null ? void 0 : n.prototype) instanceof xc ? lF(e) : e, n);
}
function Rx(t, e) {
  return e === void 0 ? Tn(t) : t instanceof e ? t : e.prototype instanceof xc && !(t instanceof xc) ? e.from(t, g1) : e.from(t);
}
function lF(t) {
  return (e, n) => g1(t(e, n));
}
const Lf = [null], OM = (t) => (e) => e[t], EM = { transform: _s }, nr = { transform: (t) => t }, cF = () => 1, uF = () => !0, Jt = (t) => t == null ? t : `${t}`, at = (t) => t == null ? t : +t, PM = (t) => t ? t[0] : void 0, fF = (t) => t ? t[1] : void 0, uu = (t) => () => t;
function hF(t) {
  const e = +`${t}`.slice(1) / 100;
  return (n, r) => rh(n, e, r);
}
function Ph(t) {
  return t instanceof xc ? t : _t(t, g1, Float64Array);
}
function g1(t) {
  return t == null ? NaN : Number(t);
}
function dF(t) {
  return _t(t, pF);
}
function pF(t) {
  return t instanceof Date && !isNaN(t) ? t : typeof t == "string" ? SM(t) : t == null || isNaN(t = +t) ? void 0 : new Date(t);
}
function ho(t, e) {
  return t === void 0 && (t = e), t === null ? [void 0, "none"] : Zd(t) ? [void 0, t] : [t, void 0];
}
function _n(t, e) {
  return t === void 0 && (t = e), t === null || typeof t == "number" ? [void 0, t] : [t, void 0];
}
function LM(t, e, n) {
  if (t != null) return yr(t, e, n);
}
function yr(t, e, n) {
  const r = `${t}`.toLowerCase();
  if (!n.includes(r)) throw new Error(`invalid ${e}: ${t}`);
  return r;
}
function Tn(t) {
  return t == null || t instanceof Array || t instanceof xc ? t : Array.from(t);
}
function _t(t, e, n = Array) {
  return t == null ? t : t instanceof n ? t.map(e) : n.from(t, e);
}
function wc(t, e = Array) {
  return t instanceof e ? t.slice() : e.from(t);
}
function mF({ x: t, x1: e, x2: n }) {
  return t !== void 0 || e !== void 0 || n !== void 0;
}
function NM({ y: t, y1: e, y2: n }) {
  return t !== void 0 || e !== void 0 || n !== void 0;
}
function gF(t) {
  return mF(t) || NM(t) || t.interval !== void 0;
}
function So(t) {
  return (t == null ? void 0 : t.toString) === oF;
}
function t0(t) {
  return So(t) && (t.type !== void 0 || t.domain !== void 0);
}
function v1(t) {
  return So(t) && typeof t.transform != "function";
}
function kc(t) {
  return v1(t) && t.value === void 0 && t.channel === void 0;
}
function vF(t, e, n, r = nr) {
  return e === void 0 && n === void 0 ? (e = 0, n = t === void 0 ? r : t) : e === void 0 ? e = t === void 0 ? 0 : t : n === void 0 && (n = t === void 0 ? 0 : t), [e, n];
}
function y1(t, e) {
  return t === void 0 && e === void 0 ? [PM, fF] : [t, e];
}
function IM({ z: t, fill: e, stroke: n } = {}) {
  return t === void 0 && ([t] = ho(e)), t === void 0 && ([t] = ho(n)), t;
}
function _s(t) {
  const e = t.length, n = new Uint32Array(e);
  for (let r = 0; r < e; ++r) n[r] = r;
  return n;
}
function b1(t, e) {
  return _t(e, (n) => t[n], t.constructor);
}
function yF(t, e, n) {
  return t.subarray ? t.subarray(e, n) : t.slice(e, n);
}
function Hs(t) {
  return t !== null && typeof t == "object" ? t.valueOf() : t;
}
function n0(t) {
  let e;
  return [
    {
      transform: () => e,
      label: fu(t)
    },
    (n) => e = n
  ];
}
function bF(t) {
  return t == null ? [t] : n0(t);
}
function fu(t, e) {
  return typeof t == "string" ? t : t && t.label !== void 0 ? t.label : e;
}
function xF(t, e) {
  return {
    transform(n) {
      const r = t.transform(n), i = e.transform(n);
      return Zn(r) || Zn(i) ? _t(r, (s, o) => new Date((+r[o] + +i[o]) / 2)) : _t(r, (s, o) => (+r[o] + +i[o]) / 2, Float64Array);
    },
    label: t.label
  };
}
function wF(t, e) {
  const n = RM(e == null ? void 0 : e.interval, e == null ? void 0 : e.type);
  return n ? _t(t, n) : t;
}
function RM(t, e) {
  const n = x1(t, e);
  return n && ((r) => hs(r) ? n.floor(r) : r);
}
function x1(t, e) {
  if (t != null) {
    if (typeof t == "number") return kF(t);
    if (typeof t == "string") return (e === "time" ? $M : AM)(t);
    if (typeof t.floor != "function") throw new Error("invalid interval; missing floor method");
    if (typeof t.offset != "function") throw new Error("invalid interval; missing offset method");
    return t;
  }
}
function kF(t) {
  t = +t, 0 < t && t < 1 && Number.isInteger(1 / t) && (t = -1 / t);
  const e = Math.abs(t);
  return t < 0 ? {
    floor: (n) => Math.floor(n * e) / e,
    offset: (n, r = 1) => (n * e + Math.floor(r)) / e,
    range: (n, r) => xg(Math.ceil(n * e), r * e).map((i) => i / e)
  } : {
    floor: (n) => Math.floor(n / e) * e,
    offset: (n, r = 1) => n + e * Math.floor(r),
    range: (n, r) => xg(Math.ceil(n / e), r / e).map((i) => i * e)
  };
}
function hu(t, e) {
  if (t = x1(t, e), t && typeof t.range != "function") throw new Error("invalid interval: missing range method");
  return t;
}
function _F(t, e) {
  if (t = hu(t, e), t && typeof t.ceil != "function") throw new Error("invalid interval: missing ceil method");
  return t;
}
function SF(t) {
  return typeof (t == null ? void 0 : t.range) == "function";
}
function Xd(t) {
  return t === void 0 || v1(t) ? t : { value: t };
}
function MF(t) {
  return t == null ? null : {
    transform: (e) => Wn(e, t, Float64Array),
    label: fu(t)
  };
}
function Mo(t) {
  return t && typeof t[Symbol.iterator] == "function";
}
function BM(t) {
  for (const e of t)
    if (e != null)
      return typeof e != "object" || e instanceof Date;
}
function Bx(t) {
  for (const e of t) {
    if (e == null) continue;
    const n = typeof e;
    return n === "string" || n === "boolean";
  }
}
function Zn(t) {
  for (const e of t)
    if (e != null)
      return e instanceof Date;
}
function CF(t) {
  for (const e of t)
    if (e != null)
      return typeof e == "string" && isNaN(e) && SM(e);
}
function $F(t) {
  for (const e of t)
    if (e != null) {
      if (typeof e != "string") return !1;
      if (e.trim())
        return !isNaN(e);
    }
}
function AF(t) {
  for (const e of t)
    if (e != null)
      return typeof e == "number";
}
function rm(t, e) {
  let n;
  for (const r of t)
    if (r != null) {
      if (!e(r)) return !1;
      n = !0;
    }
  return n;
}
const DF = new Set("none,currentcolor,transparent,aliceblue,antiquewhite,aqua,aquamarine,azure,beige,bisque,black,blanchedalmond,blue,blueviolet,brown,burlywood,cadetblue,chartreuse,chocolate,coral,cornflowerblue,cornsilk,crimson,cyan,darkblue,darkcyan,darkgoldenrod,darkgray,darkgreen,darkgrey,darkkhaki,darkmagenta,darkolivegreen,darkorange,darkorchid,darkred,darksalmon,darkseagreen,darkslateblue,darkslategray,darkslategrey,darkturquoise,darkviolet,deeppink,deepskyblue,dimgray,dimgrey,dodgerblue,firebrick,floralwhite,forestgreen,fuchsia,gainsboro,ghostwhite,gold,goldenrod,gray,green,greenyellow,grey,honeydew,hotpink,indianred,indigo,ivory,khaki,lavender,lavenderblush,lawngreen,lemonchiffon,lightblue,lightcoral,lightcyan,lightgoldenrodyellow,lightgray,lightgreen,lightgrey,lightpink,lightsalmon,lightseagreen,lightskyblue,lightslategray,lightslategrey,lightsteelblue,lightyellow,lime,limegreen,linen,magenta,maroon,mediumaquamarine,mediumblue,mediumorchid,mediumpurple,mediumseagreen,mediumslateblue,mediumspringgreen,mediumturquoise,mediumvioletred,midnightblue,mintcream,mistyrose,moccasin,navajowhite,navy,oldlace,olive,olivedrab,orange,orangered,orchid,palegoldenrod,palegreen,paleturquoise,palevioletred,papayawhip,peachpuff,peru,pink,plum,powderblue,purple,rebeccapurple,red,rosybrown,royalblue,saddlebrown,salmon,sandybrown,seagreen,seashell,sienna,silver,skyblue,slateblue,slategray,slategrey,snow,springgreen,steelblue,tan,teal,thistle,tomato,turquoise,violet,wheat,white,whitesmoke,yellow".split(","));
function Zd(t) {
  return typeof t != "string" ? !1 : (t = t.toLowerCase().trim(), /^#[0-9a-f]{3,8}$/.test(t) || // hex rgb, rgba, rrggbb, rrggbbaa
  /^(?:url|var|rgb|rgba|hsl|hsla|hwb|lab|lch|oklab|oklch|color|color-mix)\(.*\)$/.test(t) || // <funciri>, CSS variable, color, etc.
  DF.has(t));
}
function TF(t) {
  return typeof t == "number" && (0 <= t && t <= 1 || isNaN(t));
}
function cn(t) {
  return t == null || _c(t);
}
function _c(t) {
  return /^\s*none\s*$/i.test(t);
}
function OF(t) {
  return /^\s*round\s*$/i.test(t);
}
function r0(t, e) {
  return LM(t, e, [
    "middle",
    "top-left",
    "top",
    "top-right",
    "right",
    "bottom-right",
    "bottom",
    "bottom-left",
    "left"
  ]);
}
function w1(t = "middle") {
  return r0(t, "frameAnchor");
}
function EF(t = {}, ...e) {
  let n = t;
  for (const r of e)
    for (const i in r)
      if (n[i] === void 0) {
        const s = r[i];
        n === t ? n = { ...n, [i]: s } : n[i] = s;
      }
  return n;
}
function PF(t) {
  console.warn("named iterables are deprecated; please use an object instead");
  const e = /* @__PURE__ */ new Set();
  return Object.fromEntries(
    Array.from(t, (n) => {
      const { name: r } = n;
      if (r == null) throw new Error("missing name");
      const i = `${r}`;
      if (i === "__proto__") throw new Error(`illegal name: ${i}`);
      if (e.has(i)) throw new Error(`duplicate name: ${i}`);
      return e.add(i), [r, n];
    })
  );
}
function FM(t) {
  return Mo(t) ? PF(t) : t;
}
function zM(t) {
  return t === !0 ? t = "frame" : t === !1 ? t = null : t != null && (t = yr(t, "clip", ["frame", "sphere"])), t;
}
const Nr = Symbol("position"), Di = Symbol("color"), du = Symbol("radius"), pu = Symbol("length"), mu = Symbol("opacity"), Jd = Symbol("symbol"), VM = Symbol("projection"), ct = /* @__PURE__ */ new Map([
  ["x", Nr],
  ["y", Nr],
  ["fx", Nr],
  ["fy", Nr],
  ["r", du],
  ["color", Di],
  ["opacity", mu],
  ["symbol", Jd],
  ["length", pu],
  ["projection", VM]
]);
function LF(t) {
  return t === Nr || t === VM;
}
function NF(t) {
  return t === Nr || t === du || t === pu || t === mu;
}
const IF = Math.sqrt(3), RF = 2 / IF, BF = {
  draw(t, e) {
    const n = Math.sqrt(e / Math.PI), r = n * RF, i = r / 2;
    t.moveTo(0, r), t.lineTo(n, i), t.lineTo(n, -i), t.lineTo(0, -r), t.lineTo(-n, -i), t.lineTo(-n, i), t.closePath();
  }
}, HM = /* @__PURE__ */ new Map([
  ["asterisk", J5],
  ["circle", a1],
  ["cross", Q5],
  ["diamond", tM],
  ["diamond2", nM],
  ["hexagon", BF],
  ["plus", rM],
  ["square", iM],
  ["square2", sM],
  ["star", aM],
  ["times", fM],
  ["triangle", lM],
  ["triangle2", cM],
  ["wye", uM]
]);
function YM(t) {
  return t && typeof t.draw == "function";
}
function FF(t) {
  return YM(t) ? !0 : typeof t != "string" ? !1 : HM.has(t.toLowerCase());
}
function k1(t) {
  if (t == null || YM(t)) return t;
  const e = HM.get(`${t}`.toLowerCase());
  if (e) return e;
  throw new Error(`invalid symbol: ${t}`);
}
function WM({ filter: t, sort: e, reverse: n, transform: r, initializer: i, ...s } = {}, o) {
  if (r === void 0 && (t != null && (r = jM(t)), e != null && !kc(e) && (r = im(r, UM(e))), n && (r = im(r, qM))), o != null && i != null) throw new Error("transforms cannot be applied after initializers");
  return {
    ...s,
    ...(e === null || kc(e)) && { sort: e },
    transform: im(r, o)
  };
}
function Lh({ filter: t, sort: e, reverse: n, initializer: r, ...i } = {}, s) {
  return r === void 0 && (t != null && (r = jM(t)), e != null && !kc(e) && (r = sm(r, UM(e))), n && (r = sm(r, qM))), {
    ...i,
    ...(e === null || kc(e)) && { sort: e },
    initializer: sm(r, s)
  };
}
function im(t, e) {
  return t == null ? e === null ? void 0 : e : e == null ? t === null ? void 0 : t : function(n, r, i) {
    return { data: n, facets: r } = t.call(this, n, r, i), e.call(this, Tn(n), r, i);
  };
}
function sm(t, e) {
  return t == null ? e === null ? void 0 : e : e == null ? t === null ? void 0 : t : function(n, r, i, ...s) {
    let o, a, l, c, u, h;
    return { data: a = n, facets: l = r, channels: o } = t.call(this, n, r, i, ...s), { data: u = a, facets: h = l, channels: c } = e.call(this, a, l, { ...i, ...o }, ...s), { data: u, facets: h, channels: { ...o, ...c } };
  };
}
function jM(t) {
  return (e, n) => {
    const r = Wn(e, t);
    return { data: e, facets: n.map((i) => i.filter((s) => r[s])) };
  };
}
function qM(t, e) {
  return { data: t, facets: e.map((n) => n.slice().reverse()) };
}
function UM(t) {
  return (typeof t == "function" && t.length !== 1 ? zF : VF)(t);
}
function zF(t) {
  return (e, n) => {
    const r = (i, s) => t(e[i], e[s]);
    return { data: e, facets: n.map((i) => i.slice().sort(r)) };
  };
}
function VF(t) {
  let e, n;
  ({ channel: e, value: t, order: n } = { ...Xd(t) });
  const r = e == null ? void 0 : e.startsWith("-");
  if (r && (e = e.slice(1)), n === void 0 && (n = r ? Eh : Ur), typeof n != "function")
    switch (`${n}`.toLowerCase()) {
      case "ascending":
        n = Ur;
        break;
      case "descending":
        n = Eh;
        break;
      default:
        throw new Error(`invalid order: ${n}`);
    }
  return (i, s, o) => {
    let a;
    if (e === void 0)
      a = Wn(i, t);
    else {
      if (o === void 0) throw new Error("channel sort requires an initializer");
      if (a = o[e], !a) return {};
      a = a.value;
    }
    const l = (c, u) => n(a[c], a[u]);
    return { data: i, facets: s.map((c) => c.slice().sort(l)) };
  };
}
function HF(t, e, n = YF) {
  if (t == null) return n(t);
  if (typeof t.reduceIndex == "function") return t;
  if (typeof t.reduce == "function" && So(t)) return WF(t);
  if (typeof t == "function") return jF(t);
  if (/^p\d{2}$/i.test(t)) return oi(hF(t));
  switch (`${t}`.toLowerCase()) {
    case "first":
      return UF;
    case "last":
      return KF;
    case "identity":
      return qF;
    case "count":
      return zx;
    case "distinct":
      return GF;
    case "sum":
      return e == null ? zx : XF;
    case "proportion":
      return Vx(e, "data");
    case "proportion-facet":
      return Vx(e, "facet");
    case "deviation":
      return oi(R9);
    case "min":
      return oi(yi);
    case "min-index":
      return oi(W9);
    case "max":
      return oi(ur);
    case "max-index":
      return oi(Y9);
    case "mean":
      return Fx(q9);
    case "median":
      return Fx(bg);
    case "variance":
      return oi(V3);
    case "mode":
      return oi(K9);
  }
  return n(t);
}
function YF(t) {
  throw new Error(`invalid reduce: ${t}`);
}
function WF(t) {
  return console.warn("deprecated reduce interface; implement reduceIndex instead."), { ...t, reduceIndex: t.reduce.bind(t) };
}
function jF(t) {
  return {
    reduceIndex(e, n, r) {
      return t(b1(n, e), r);
    }
  };
}
function oi(t) {
  return {
    reduceIndex(e, n) {
      return t(e, (r) => n[r]);
    }
  };
}
function Fx(t) {
  return {
    reduceIndex(e, n) {
      const r = t(e, (i) => n[i]);
      return Zn(n) ? new Date(r) : r;
    }
  };
}
const qF = {
  reduceIndex(t, e) {
    return b1(e, t);
  }
}, UF = {
  reduceIndex(t, e) {
    return e[t[0]];
  }
}, KF = {
  reduceIndex(t, e) {
    return e[t[t.length - 1]];
  }
}, zx = {
  label: "Frequency",
  reduceIndex(t) {
    return t.length;
  }
}, GF = {
  label: "Distinct",
  reduceIndex(t, e) {
    const n = new $d();
    for (const r of t) n.add(e[r]);
    return n.size;
  }
}, XF = oi(io);
function Vx(t, e) {
  return t == null ? { scope: e, label: "Frequency", reduceIndex: (n, r, i = 1) => n.length / i } : { scope: e, reduceIndex: (n, r, i = 1) => io(n, (s) => r[s]) / i };
}
function Sc(t, { scale: e, type: n, value: r, filter: i, hint: s, label: o = fu(r) }, a) {
  return s === void 0 && typeof (r == null ? void 0 : r.transform) == "function" && (s = r.hint), KM(a, {
    scale: e,
    type: n,
    value: Wn(t, r),
    label: o,
    filter: i,
    hint: s
  });
}
function ZF(t, e) {
  return Object.fromEntries(
    Object.entries(t).map(([n, r]) => [n, Sc(e, r, n)])
  );
}
function JF(t, e) {
  const n = Object.fromEntries(
    Object.entries(t).map(([r, { scale: i, value: s }]) => {
      const o = i == null ? null : e[i];
      return [r, o == null ? s : _t(s, o)];
    })
  );
  return n.channels = t, n;
}
function KM(t, e) {
  const { scale: n, value: r } = e;
  if (n === !0 || n === "auto")
    switch (t) {
      case "fill":
      case "stroke":
      case "color":
        e.scale = n !== !0 && rm(r, Zd) ? null : "color";
        break;
      case "fillOpacity":
      case "strokeOpacity":
      case "opacity":
        e.scale = n !== !0 && rm(r, TF) ? null : "opacity";
        break;
      case "symbol":
        n !== !0 && rm(r, FF) ? (e.scale = null, e.value = _t(r, k1)) : e.scale = "symbol";
        break;
      default:
        e.scale = ct.has(t) ? t : null;
        break;
    }
  else if (n === !1)
    e.scale = null;
  else if (n != null && !ct.has(n))
    throw new Error(`unknown scale: ${n}`);
  return e;
}
function QF(t, e, n, r, i) {
  const { order: s, reverse: o, reduce: a = !0, limit: l } = i;
  for (const c in i) {
    if (!ct.has(c)) continue;
    let { value: u, order: h = s, reverse: f = o, reduce: d = a, limit: p = l } = Xd(i[c]);
    const m = u == null ? void 0 : u.startsWith("-");
    if (m && (u = u.slice(1)), h = h === void 0 ? m !== (u === "width" || u === "height") ? XM : GM : nz(h), d == null || d === !1) continue;
    const v = c === "fx" || c === "fy" ? tz(e, r[c]) : ez(n, c);
    if (!v) throw new Error(`missing channel for scale: ${c}`);
    const g = v.value, [y = 0, x = 1 / 0] = Mo(p) ? p : p < 0 ? [p] : [0, p];
    if (u == null)
      v.domain = () => {
        let b = Array.from(new $d(g));
        return f && (b = b.reverse()), (y !== 0 || x !== 1 / 0) && (b = b.slice(y, x)), b;
      };
    else {
      const b = u === "data" ? t : u === "height" ? Hx(n, "y1", "y2") : u === "width" ? Hx(n, "x1", "x2") : i0(n, u, u === "y" ? "y2" : u === "x" ? "x2" : void 0), w = HF(d === !0 ? "max" : d, b);
      v.domain = () => {
        let k = B9(
          _s(g),
          (_) => w.reduceIndex(_, b),
          (_) => g[_]
        );
        return h && k.sort(h), f && k.reverse(), (y !== 0 || x !== 1 / 0) && (k = k.slice(y, x)), k.map(PM);
      };
    }
  }
}
function ez(t, e) {
  for (const n in t) {
    const r = t[n];
    if (r.scale === e) return r;
  }
}
function tz(t, e) {
  const n = t.original;
  if (n === t) return e;
  const r = e.value, i = e.value = [];
  for (let s = 0; s < n.length; ++s) {
    const o = r[n[s][0]];
    for (const a of t[s]) i[a] = o;
  }
  return e;
}
function Hx(t, e, n) {
  const r = i0(t, e), i = i0(t, n);
  return _t(i, (s, o) => Math.abs(s - r[o]), Float64Array);
}
function i0(t, e, n) {
  let r = t[e];
  if (!r && n !== void 0 && (r = t[n]), r) return r.value;
  throw new Error(`missing channel: ${e}`);
}
function nz(t) {
  if (t == null || typeof t == "function") return t;
  switch (`${t}`.toLowerCase()) {
    case "ascending":
      return GM;
    case "descending":
      return XM;
  }
  throw new Error(`invalid order: ${t}`);
}
function GM([t, e], [n, r]) {
  return Ur(e, r) || Ur(t, n);
}
function XM([t, e], [n, r]) {
  return Eh(e, r) || Ur(t, n);
}
function Yx(t, e) {
  let n = t[e];
  if (n) {
    for (; n.source; ) n = n.source;
    return n.source === null ? null : n;
  }
}
const ZM = /* @__PURE__ */ new Map([
  ["accent", lB],
  ["category10", aB],
  ["dark2", cB],
  ["observable10", uB],
  ["paired", fB],
  ["pastel1", hB],
  ["pastel2", dB],
  ["set1", pB],
  ["set2", mB],
  ["set3", gB],
  ["tableau10", vB]
]);
function rz(t) {
  return t != null && ZM.has(`${t}`.toLowerCase());
}
const Wx = new Map([
  ...ZM,
  // diverging
  ["brbg", ri(H4, Y4)],
  ["prgn", ri(W4, j4)],
  ["piyg", ri(q4, U4)],
  ["puor", ri(K4, G4)],
  ["rdbu", ri(Jg, Mh)],
  ["rdgy", ri(X4, Z4)],
  ["rdylbu", ri(Qg, Ch)],
  ["rdylgn", ri(J4, Q4)],
  ["spectral", ri(e5, t5)],
  // reversed diverging (for temperature data)
  ["burd", jx(Jg, Mh)],
  ["buylrd", jx(Qg, Ch)],
  // sequential (single-hue)
  ["blues", wt(C5, $5)],
  ["greens", wt(A5, D5)],
  ["greys", wt(T5, O5)],
  ["oranges", wt(I5, R5)],
  ["purples", wt(E5, P5)],
  ["reds", wt(L5, N5)],
  // sequential (multi-hue)
  ["turbo", ii(W5)],
  ["viridis", ii(j5)],
  ["magma", ii(q5)],
  ["inferno", ii(U5)],
  ["plasma", ii(K5)],
  ["cividis", ii(B5)],
  ["cubehelix", ii(F5)],
  ["warm", ii(z5)],
  ["cool", ii(V5)],
  ["bugn", wt(n5, r5)],
  ["bupu", wt(i5, s5)],
  ["gnbu", wt(o5, a5)],
  ["orrd", wt(l5, c5)],
  ["pubu", wt(h5, d5)],
  ["pubugn", wt(u5, f5)],
  ["purd", wt(p5, m5)],
  ["rdpu", wt(g5, v5)],
  ["ylgn", wt(x5, w5)],
  ["ylgnbu", wt(y5, b5)],
  ["ylorbr", wt(k5, _5)],
  ["ylorrd", wt(S5, M5)],
  // cyclical
  ["rainbow", qx(H5)],
  ["sinebow", qx(Y5)]
]);
function wt(t, e) {
  return ({ length: n }) => n === 1 ? [t[3][1]] : n === 2 ? [t[3][1], t[3][2]] : (n = Math.max(3, Math.floor(n)), n > 9 ? fr(e, n) : t[n]);
}
function ri(t, e) {
  return ({ length: n }) => n === 2 ? [t[3][0], t[3][2]] : (n = Math.max(3, Math.floor(n)), n > 11 ? fr(e, n) : t[n]);
}
function jx(t, e) {
  return ({ length: n }) => n === 2 ? [t[3][2], t[3][0]] : (n = Math.max(3, Math.floor(n)), n > 11 ? fr((r) => e(1 - r), n) : t[n].slice().reverse());
}
function ii(t) {
  return ({ length: e }) => fr(t, Math.max(2, Math.floor(e)));
}
function qx(t) {
  return ({ length: e }) => fr(t, Math.floor(e) + 1).slice(0, -1);
}
function JM(t) {
  const e = `${t}`.toLowerCase();
  if (!Wx.has(e)) throw new Error(`unknown ordinal scheme: ${e}`);
  return Wx.get(e);
}
function Qd(t, e) {
  const n = JM(t), r = typeof n == "function" ? n({ length: e }) : n;
  return r.length !== e ? r.slice(0, e) : r;
}
function iz(t, e = "greys") {
  const n = /* @__PURE__ */ new Set(), [r, i] = Qd(e, 2);
  for (const s of t)
    if (s != null)
      if (s === !0) n.add(i);
      else if (s === !1) n.add(r);
      else return;
  return [...n];
}
const Ux = /* @__PURE__ */ new Map([
  // diverging
  ["brbg", Y4],
  ["prgn", j4],
  ["piyg", U4],
  ["puor", G4],
  ["rdbu", Mh],
  ["rdgy", Z4],
  ["rdylbu", Ch],
  ["rdylgn", Q4],
  ["spectral", t5],
  // reversed diverging (for temperature data)
  ["burd", (t) => Mh(1 - t)],
  ["buylrd", (t) => Ch(1 - t)],
  // sequential (single-hue)
  ["blues", $5],
  ["greens", D5],
  ["greys", O5],
  ["purples", P5],
  ["reds", N5],
  ["oranges", R5],
  // sequential (multi-hue)
  ["turbo", W5],
  ["viridis", j5],
  ["magma", q5],
  ["inferno", U5],
  ["plasma", K5],
  ["cividis", B5],
  ["cubehelix", F5],
  ["warm", z5],
  ["cool", V5],
  ["bugn", r5],
  ["bupu", s5],
  ["gnbu", a5],
  ["orrd", c5],
  ["pubugn", f5],
  ["pubu", d5],
  ["purd", m5],
  ["rdpu", v5],
  ["ylgnbu", b5],
  ["ylgn", w5],
  ["ylorbr", _5],
  ["ylorrd", M5],
  // cyclical
  ["rainbow", H5],
  ["sinebow", Y5]
]);
function _1(t) {
  const e = `${t}`.toLowerCase();
  if (!Ux.has(e)) throw new Error(`unknown quantitative scheme: ${e}`);
  return Ux.get(e);
}
const sz = /* @__PURE__ */ new Set([
  "brbg",
  "prgn",
  "piyg",
  "puor",
  "rdbu",
  "rdgy",
  "rdylbu",
  "rdylgn",
  "spectral",
  "burd",
  "buylrd"
]);
function oz(t) {
  return t != null && sz.has(`${t}`.toLowerCase());
}
const QM = (t) => (e) => t(1 - e), om = [0, 1], Kx = /* @__PURE__ */ new Map([
  // numbers
  ["number", Ft],
  // color spaces
  ["rgb", ao],
  ["hsl", bL],
  ["hcl", kL],
  ["lab", xL]
]);
function eC(t) {
  const e = `${t}`.toLowerCase();
  if (!Kx.has(e)) throw new Error(`unknown interpolator: ${e}`);
  return Kx.get(e);
}
function gu(t, e, n, {
  type: r,
  nice: i,
  clamp: s,
  zero: o,
  domain: a = nC(t, n),
  unknown: l,
  round: c,
  scheme: u,
  interval: h,
  range: f = ct.get(t) === du ? vz(n, a) : ct.get(t) === pu ? yz(n, a) : ct.get(t) === mu ? om : void 0,
  interpolate: d = ct.get(t) === Di ? u == null && f !== void 0 ? ao : _1(u !== void 0 ? u : r === "cyclical" ? "rainbow" : "turbo") : c ? Wv : Ft,
  reverse: p
}) {
  if (h = hu(h, r), (r === "cyclical" || r === "sequential") && (r = "linear"), typeof d != "function" && (d = eC(d)), p = !!p, f !== void 0) {
    const m = (a = Tn(a)).length, v = (f = Tn(f)).length;
    if (m !== v) {
      if (d.length === 1) throw new Error("invalid piecewise interpolator");
      d = Ed(d, f), f = void 0;
    }
  }
  if (d.length === 1 ? (p && (d = QM(d), p = !1), f === void 0 && (f = Float64Array.from(a, (m, v) => v / (a.length - 1)), f.length === 2 && (f = om)), e.interpolate((f === om ? uu : M1)(d))) : e.interpolate(d), o) {
    const [m, v] = ns(a);
    (m > 0 || v < 0) && (a = wc(a), (wa(a) || 1) === Math.sign(m) ? a[0] = 0 : a[a.length - 1] = 0);
  }
  return p && (a = ih(a)), e.domain(a).unknown(l), i && (e.nice(az(i, r)), a = e.domain()), f !== void 0 && e.range(f), s && e.clamp(s), { type: r, domain: a, range: f, scale: e, interpolate: d, interval: h };
}
function az(t, e) {
  return t === !0 ? void 0 : typeof t == "number" ? t : _F(t, e);
}
function lz(t, e, n) {
  return gu(t, n1(), e, n);
}
function cz(t, e, n) {
  return tC(t, e, { ...n, exponent: 0.5 });
}
function tC(t, e, { exponent: n = 1, ...r }) {
  return gu(t, k4().exponent(n), e, { ...r, type: "pow" });
}
function uz(t, e, { base: n = 10, domain: r = bz(e), ...i }) {
  return gu(t, y4().base(n), e, { ...i, domain: r });
}
function fz(t, e, { constant: n = 1, ...r }) {
  return gu(t, x4().constant(n), e, r);
}
function hz(t, e, {
  range: n,
  quantiles: r = n === void 0 ? 5 : (n = [...n]).length,
  // deprecated; use n instead
  n: i = r,
  scheme: s = "rdylbu",
  domain: o = xz(e),
  unknown: a,
  interpolate: l,
  reverse: c
}) {
  return n === void 0 && (n = l !== void 0 ? fr(l, i) : ct.get(t) === Di ? Qd(s, i) : void 0), o.length > 0 && (o = _4(o, n === void 0 ? { length: i } : n).quantiles()), S1(t, e, { domain: o, range: n, reverse: c, unknown: a });
}
function dz(t, e, {
  range: n,
  n: r = n === void 0 ? 5 : (n = [...n]).length,
  scheme: i = "rdylbu",
  domain: s = nC(t, e),
  unknown: o,
  interpolate: a,
  reverse: l
}) {
  const [c, u] = ns(s);
  let h;
  return n === void 0 ? (h = nh(c, u, r), h[0] <= c && h.splice(0, 1), h[h.length - 1] >= u && h.pop(), r = h.length + 1, n = a !== void 0 ? fr(a, r) : ct.get(t) === Di ? Qd(i, r) : void 0) : (h = fr(Ft(c, u), r + 1).slice(1, -1), c instanceof Date && (h = h.map((f) => new Date(f)))), wa(Tn(s)) < 0 && h.reverse(), S1(t, e, { domain: h, range: n, reverse: l, unknown: o });
}
function S1(t, e, {
  domain: n = [0],
  // explicit thresholds in ascending order
  unknown: r,
  scheme: i = "rdylbu",
  interpolate: s,
  range: o = s !== void 0 ? fr(s, n.length + 1) : ct.get(t) === Di ? Qd(i, n.length + 1) : void 0,
  reverse: a
}) {
  n = Tn(n);
  const l = wa(n);
  if (!isNaN(l) && !pz(n, l)) throw new Error(`the ${t} scale has a non-monotonic domain`);
  return a && (o = ih(o)), {
    type: "threshold",
    scale: S4(l < 0 ? ih(n) : n, o === void 0 ? [] : o).unknown(r),
    domain: n,
    range: o
  };
}
function pz(t, e) {
  for (let n = 1, r = t.length, i = t[0]; n < r; ++n) {
    const s = Gc(i, i = t[n]);
    if (s !== 0 && s !== e) return !1;
  }
  return !0;
}
function mz(t) {
  return { type: "identity", scale: NF(ct.get(t)) ? m4() : (e) => e };
}
function Mc(t, e = kM) {
  return t.length ? [
    yi(t, ({ value: n }) => n === void 0 ? n : yi(n, e)),
    ur(t, ({ value: n }) => n === void 0 ? n : ur(n, e))
  ] : [0, 1];
}
function nC(t, e) {
  const n = ct.get(t);
  return (n === du || n === mu || n === pu ? gz : Mc)(e);
}
function gz(t) {
  return [0, t.length ? ur(t, ({ value: e }) => e === void 0 ? e : ur(e, kM)) : 1];
}
function vz(t, e) {
  const n = t.find(({ radius: o }) => o !== void 0);
  if (n !== void 0) return [0, n.radius];
  const r = rh(t, 0.5, ({ value: o }) => o === void 0 ? NaN : rh(o, 0.25, d1)), i = e.map((o) => 3 * Math.sqrt(o / r)), s = 30 / ur(i);
  return s < 1 ? i.map((o) => o * s) : i;
}
function yz(t, e) {
  const n = bg(t, ({ value: s }) => s === void 0 ? NaN : bg(s, Math.abs)), r = e.map((s) => 12 * s / n), i = 60 / ur(r);
  return i < 1 ? r.map((s) => s * i) : r;
}
function bz(t) {
  for (const { value: e } of t)
    if (e !== void 0)
      for (let n of e) {
        if (n > 0) return Mc(t, d1);
        if (n < 0) return Mc(t, _M);
      }
  return [1, 10];
}
function xz(t) {
  const e = [];
  for (const { value: n } of t)
    if (n !== void 0)
      for (const r of n) e.push(r);
  return e;
}
function M1(t) {
  return (e, n) => (r) => t(e + r * (n - e));
}
let s0 = 0, o0;
function wz() {
  const t = s0;
  return s0 = 0, o0 = void 0, t;
}
function rs(t) {
  t !== o0 && (o0 = t, console.warn(t), ++s0);
}
function ep(t, e, n, r, {
  type: i,
  nice: s,
  clamp: o,
  domain: a = Mc(r),
  unknown: l,
  pivot: c = 0,
  scheme: u,
  range: h,
  symmetric: f = !0,
  interpolate: d = ct.get(t) === Di ? u == null && h !== void 0 ? ao : _1(u !== void 0 ? u : "rdbu") : Ft,
  reverse: p
}) {
  c = +c, a = Tn(a);
  let [m, v] = a;
  if (a.length > 2 && rs(`Warning: the diverging ${t} scale domain contains extra elements.`), Gc(m, v) < 0 && ([m, v] = [v, m], p = !p), m = Math.min(m, c), v = Math.max(v, c), typeof d != "function" && (d = eC(d)), h !== void 0 && (d = d.length === 1 ? M1(d)(...h) : Ed(d, h)), p && (d = QM(d)), f) {
    const g = n.apply(c), y = g - n.apply(m), x = n.apply(v) - g;
    y < x ? m = n.invert(g - x) : y > x && (v = n.invert(g + y));
  }
  return e.domain([m, c, v]).unknown(l).interpolator(d), o && e.clamp(o), s && e.nice(s), { type: i, domain: [m, v], pivot: c, interpolate: d, scale: e };
}
function kz(t, e, n) {
  return ep(t, B4(), Cz, e, n);
}
function _z(t, e, n) {
  return rC(t, e, { ...n, exponent: 0.5 });
}
function rC(t, e, { exponent: n = 1, ...r }) {
  return ep(t, V4().exponent(n = +n), Dz(n), e, {
    ...r,
    type: "diverging-pow"
  });
}
function Sz(t, e, { base: n = 10, pivot: r = 1, domain: i = Mc(e, r < 0 ? _M : d1), ...s }) {
  return ep(t, F4().base(n = +n), $z, e, {
    domain: i,
    pivot: r,
    ...s
  });
}
function Mz(t, e, { constant: n = 1, ...r }) {
  return ep(
    t,
    z4().constant(n = +n),
    Tz(n),
    e,
    r
  );
}
const Cz = {
  apply(t) {
    return t;
  },
  invert(t) {
    return t;
  }
}, $z = {
  apply: Math.log,
  invert: Math.exp
}, Az = {
  apply(t) {
    return Math.sign(t) * Math.sqrt(Math.abs(t));
  },
  invert(t) {
    return Math.sign(t) * (t * t);
  }
};
function Dz(t) {
  return t === 0.5 ? Az : {
    apply(e) {
      return Math.sign(e) * Math.pow(Math.abs(e), t);
    },
    invert(e) {
      return Math.sign(e) * Math.pow(Math.abs(e), 1 / t);
    }
  };
}
function Tz(t) {
  return {
    apply(e) {
      return Math.sign(e) * Math.log1p(Math.abs(e / t));
    },
    invert(e) {
      return Math.sign(e) * Math.expm1(Math.abs(e)) * t;
    }
  };
}
function iC(t, e, n, r) {
  return gu(t, e, n, r);
}
function Oz(t, e, n) {
  return iC(t, sB(), e, n);
}
function Ez(t, e, n) {
  return iC(t, oB(), e, n);
}
const vu = Symbol("ordinal");
function sC(t, e, n, { type: r, interval: i, domain: s, range: o, reverse: a, hint: l }) {
  return i = hu(i, r), s === void 0 && (s = aC(n, i, t)), (r === "categorical" || r === vu) && (r = "ordinal"), a && (s = ih(s)), s = e.domain(s).domain(), o !== void 0 && (typeof o == "function" && (o = o(s)), e.range(o)), { type: r, domain: s, range: o, scale: e, hint: l, interval: i };
}
function Pz(t, e, { type: n, interval: r, domain: i, range: s, scheme: o, unknown: a, ...l }) {
  r = hu(r, n), i === void 0 && (i = aC(e, r, t));
  let c;
  if (ct.get(t) === Jd)
    c = Iz(e), s = s === void 0 ? Rz(c) : _t(s, k1);
  else if (ct.get(t) === Di && (s === void 0 && (n === "ordinal" || n === vu) && (s = iz(i, o), s !== void 0 && (o = void 0)), o === void 0 && s === void 0 && (o = n === "ordinal" ? "turbo" : "observable10"), o !== void 0))
    if (s !== void 0) {
      const u = _1(o), h = s[0], f = s[1] - s[0];
      s = ({ length: d }) => fr((p) => u(h + f * p), d);
    } else
      s = JM(o);
  if (a === Gg)
    throw new Error(`implicit unknown on ${t} scale is not supported`);
  return sC(t, t1().unknown(a), e, { ...l, type: n, domain: i, range: s, hint: c });
}
function Lz(t, e, { align: n = 0.5, padding: r = 0.5, ...i }) {
  return oC(FI().align(n).padding(r), e, i, t);
}
function Nz(t, e, {
  align: n = 0.5,
  padding: r = 0.1,
  paddingInner: i = r,
  paddingOuter: s = t === "fx" || t === "fy" ? 0 : r,
  ...o
}) {
  return oC(
    Bd().align(n).paddingInner(i).paddingOuter(s),
    e,
    o,
    t
  );
}
function oC(t, e, n, r) {
  let { round: i } = n;
  return i !== void 0 && t.round(i = !!i), t = sC(r, t, e, n), t.round = i, t;
}
function aC(t, e, n) {
  const r = new $d();
  for (const { value: i, domain: s } of t) {
    if (s !== void 0) return s();
    if (i !== void 0)
      for (const o of i) r.add(o);
  }
  if (e !== void 0) {
    const [i, s] = ns(r).map(e.floor, e);
    return e.range(i, e.offset(s));
  }
  if (r.size > 1e4 && ct.get(n) === Nr)
    throw new Error(`implicit ordinal domain of ${n} scale has more than 10,000 values`);
  return gg(r, Ur);
}
function Gx(t, e) {
  let n;
  for (const { hint: r } of t) {
    const i = r == null ? void 0 : r[e];
    if (i !== void 0) {
      if (n === void 0) n = i;
      else if (n !== i) return;
    }
  }
  return n;
}
function Iz(t) {
  return {
    fill: Gx(t, "fill"),
    stroke: Gx(t, "stroke")
  };
}
function Rz(t) {
  return cn(t.fill) ? NB : LB;
}
function a0(t, {
  label: e,
  inset: n = 0,
  insetTop: r = n,
  insetRight: i = n,
  insetBottom: s = n,
  insetLeft: o = n,
  round: a,
  nice: l,
  clamp: c,
  zero: u,
  align: h,
  padding: f,
  projection: d,
  facet: { label: p = e } = {},
  ...m
} = {}) {
  const v = {};
  for (const [g, y] of t) {
    const x = m[g], b = Hz(g, y, {
      round: ct.get(g) === Nr ? a : void 0,
      // only for position
      nice: l,
      clamp: c,
      zero: u,
      align: h,
      padding: f,
      projection: d,
      ...x
    });
    if (b) {
      let {
        label: w = g === "fx" || g === "fy" ? p : e,
        percent: k,
        transform: _,
        inset: C,
        insetTop: E = C !== void 0 ? C : g === "y" ? r : 0,
        // not fy
        insetRight: L = C !== void 0 ? C : g === "x" ? i : 0,
        // not fx
        insetBottom: M = C !== void 0 ? C : g === "y" ? s : 0,
        // not fy
        insetLeft: O = C !== void 0 ? C : g === "x" ? o : 0
        // not fx
      } = x || {};
      if (_ == null) _ = void 0;
      else if (typeof _ != "function") throw new Error("invalid scale transform; not a function");
      b.percent = !!k, b.label = w === void 0 ? Fz(y, b) : w, b.transform = _, g === "x" || g === "fx" ? (b.insetLeft = +O, b.insetRight = +L) : (g === "y" || g === "fy") && (b.insetTop = +E, b.insetBottom = +M), v[g] = b;
    }
  }
  return v;
}
function Xx(t) {
  const e = {}, n = { scales: e };
  for (const [r, i] of Object.entries(t)) {
    const { scale: s, type: o, interval: a, label: l } = i;
    e[r] = Uz(i), n[r] = s, s.type = o, a != null && (s.interval = a), l != null && (s.label = l);
  }
  return n;
}
function Bz(t, e) {
  const { x: n, y: r, fx: i, fy: s } = t, o = i || s ? C1(e) : e;
  i && Zx(i, o), s && Jx(s, o);
  const a = i || s ? lC(t, e) : e;
  n && Zx(n, a), r && Jx(r, a);
}
function Fz(t = [], e) {
  let n;
  for (const { label: r } of t)
    if (r !== void 0) {
      if (n === void 0) n = r;
      else if (n !== r) return;
    }
  if (n !== void 0)
    return !Co(e) && e.percent && (n = `${n} (%)`), { inferred: !0, toString: () => n };
}
function zz(t) {
  return Math.sign(wa(t.domain())) * Math.sign(wa(t.range()));
}
function C1(t) {
  const {
    marginTop: e,
    marginRight: n,
    marginBottom: r,
    marginLeft: i,
    width: s,
    height: o,
    facet: {
      marginTop: a,
      marginRight: l,
      marginBottom: c,
      marginLeft: u
    }
  } = t;
  return {
    marginTop: Math.max(e, a),
    marginRight: Math.max(n, l),
    marginBottom: Math.max(r, c),
    marginLeft: Math.max(i, u),
    width: s,
    height: o
  };
}
function lC({ fx: t, fy: e }, n) {
  const { marginTop: r, marginRight: i, marginBottom: s, marginLeft: o, width: a, height: l } = C1(n);
  return {
    marginTop: r,
    marginRight: i,
    marginBottom: s,
    marginLeft: o,
    width: t ? t.scale.bandwidth() + o + i : a,
    height: e ? e.scale.bandwidth() + r + s : l,
    facet: { width: a, height: l }
  };
}
function Zx(t, e) {
  if (t.range === void 0) {
    const { insetLeft: n, insetRight: r } = t, { width: i, marginLeft: s = 0, marginRight: o = 0 } = e, a = s + n, l = i - o - r;
    t.range = [a, Math.max(a, l)], Co(t) || (t.range = uC(t)), t.scale.range(t.range);
  }
  cC(t);
}
function Jx(t, e) {
  if (t.range === void 0) {
    const { insetTop: n, insetBottom: r } = t, { height: i, marginTop: s = 0, marginBottom: o = 0 } = e, a = s + n, l = i - o - r;
    t.range = [Math.max(a, l), a], Co(t) ? t.range.reverse() : t.range = uC(t), t.scale.range(t.range);
  }
  cC(t);
}
function cC(t) {
  t.round === void 0 && Wz(t) && Vz(t) <= 30 && t.scale.round(!0);
}
function Vz({ scale: t }) {
  const e = t.domain().length, [n, r] = t.range(), i = t.paddingInner ? t.paddingInner() : 1, s = t.paddingOuter ? t.paddingOuter() : t.padding(), o = e - i, a = Math.abs(r - n) / Math.max(1, o + s * 2);
  return (a - Math.floor(a)) * o;
}
function uC(t) {
  const e = t.scale.domain().length + fC(t);
  if (!(e > 2)) return t.range;
  const [n, r] = t.range;
  return Array.from({ length: e }, (i, s) => n + s / (e - 1) * (r - n));
}
function Hz(t, e = [], n = {}) {
  const r = Yz(t, e, n);
  if (n.type === void 0 && n.domain === void 0 && n.range === void 0 && n.interval == null && t !== "fx" && t !== "fy" && Co({ type: r })) {
    const i = e.map(({ value: s }) => s).filter((s) => s !== void 0);
    i.some(Zn) ? rs(
      `Warning: some data associated with the ${t} scale are dates. Dates are typically associated with a "utc" or "time" scale rather than a "${Io(
        r
      )}" scale. If you are using a bar mark, you probably want a rect mark with the interval option instead; if you are using a group transform, you probably want a bin transform instead. If you want to treat this data as ordinal, you can specify the interval of the ${t} scale (e.g., d3.utcDay), or you can suppress this warning by setting the type of the ${t} scale to "${Io(
        r
      )}".`
    ) : i.some(CF) ? rs(
      `Warning: some data associated with the ${t} scale are strings that appear to be dates (e.g., YYYY-MM-DD). If these strings represent dates, you should parse them to Date objects. Dates are typically associated with a "utc" or "time" scale rather than a "${Io(
        r
      )}" scale. If you are using a bar mark, you probably want a rect mark with the interval option instead; if you are using a group transform, you probably want a bin transform instead. If you want to treat this data as ordinal, you can suppress this warning by setting the type of the ${t} scale to "${Io(
        r
      )}".`
    ) : i.some($F) && rs(
      `Warning: some data associated with the ${t} scale are strings that appear to be numbers. If these strings represent numbers, you should parse or coerce them to numbers. Numbers are typically associated with a "linear" scale rather than a "${Io(
        r
      )}" scale. If you want to treat this data as ordinal, you can specify the interval of the ${t} scale (e.g., 1 for integers), or you can suppress this warning by setting the type of the ${t} scale to "${Io(
        r
      )}".`
    );
  }
  switch (n.type = r, r) {
    case "diverging":
    case "diverging-sqrt":
    case "diverging-pow":
    case "diverging-log":
    case "diverging-symlog":
    case "cyclical":
    case "sequential":
    case "linear":
    case "sqrt":
    case "threshold":
    case "quantile":
    case "pow":
    case "log":
    case "symlog":
      n = qu(e, n, Ph);
      break;
    case "identity":
      switch (ct.get(t)) {
        case Nr:
          n = qu(e, n, Ph);
          break;
        case Jd:
          n = qu(e, n, jz);
          break;
      }
      break;
    case "utc":
    case "time":
      n = qu(e, n, dF);
      break;
  }
  switch (r) {
    case "diverging":
      return kz(t, e, n);
    case "diverging-sqrt":
      return _z(t, e, n);
    case "diverging-pow":
      return rC(t, e, n);
    case "diverging-log":
      return Sz(t, e, n);
    case "diverging-symlog":
      return Mz(t, e, n);
    case "categorical":
    case "ordinal":
    case vu:
      return Pz(t, e, n);
    case "cyclical":
    case "sequential":
    case "linear":
      return lz(t, e, n);
    case "sqrt":
      return cz(t, e, n);
    case "threshold":
      return S1(t, e, n);
    case "quantile":
      return hz(t, e, n);
    case "quantize":
      return dz(t, e, n);
    case "pow":
      return tC(t, e, n);
    case "log":
      return uz(t, e, n);
    case "symlog":
      return fz(t, e, n);
    case "utc":
      return Ez(t, e, n);
    case "time":
      return Oz(t, e, n);
    case "point":
      return Lz(t, e, n);
    case "band":
      return Nz(t, e, n);
    case "identity":
      return mz(t);
    case void 0:
      return;
    default:
      throw new Error(`unknown scale type: ${r}`);
  }
}
function Io(t) {
  return typeof t == "symbol" ? t.description : t;
}
function Qx(t) {
  return typeof t == "string" ? `${t}`.toLowerCase() : t;
}
const e2 = { toString: () => "projection" };
function Yz(t, e, { type: n, domain: r, range: i, scheme: s, pivot: o, projection: a }) {
  if (n = Qx(n), t === "fx" || t === "fy") return "band";
  (t === "x" || t === "y") && a != null && (n = e2);
  for (const c of e) {
    const u = Qx(c.type);
    if (u !== void 0) {
      if (n === void 0) n = u;
      else if (n !== u) throw new Error(`scale incompatible with channel: ${n} !== ${u}`);
    }
  }
  if (n === e2) return;
  if (n !== void 0) return n;
  if (r === void 0 && !e.some(({ value: c }) => c !== void 0)) return;
  const l = ct.get(t);
  if (l === du) return "sqrt";
  if (l === mu || l === pu) return "linear";
  if (l === Jd) return "ordinal";
  if ((r || i || []).length > 2) return am(l);
  if (r !== void 0) {
    if (Bx(r)) return am(l);
    if (Zn(r)) return "utc";
  } else {
    const c = e.map(({ value: u }) => u).filter((u) => u !== void 0);
    if (c.some(Bx)) return am(l);
    if (c.some(Zn)) return "utc";
  }
  if (l === Di) {
    if (o != null || oz(s)) return "diverging";
    if (rz(s)) return "categorical";
  }
  return "linear";
}
function am(t) {
  switch (t) {
    case Nr:
      return "point";
    case Di:
      return vu;
    default:
      return "ordinal";
  }
}
function Co({ type: t }) {
  return t === "ordinal" || t === "point" || t === "band" || t === vu;
}
function fC({ type: t }) {
  return t === "threshold";
}
function Wz({ type: t }) {
  return t === "point" || t === "band";
}
function ka(t) {
  if (t === void 0) return !0;
  const e = t.domain(), n = t(e[0]);
  for (let r = 1, i = e.length; r < i; ++r)
    if (t(e[r]) - n)
      return !1;
  return !0;
}
function qu(t, { domain: e, ...n }, r) {
  var i;
  for (const s of t)
    s.value !== void 0 && (e === void 0 && (e = (i = s.value) == null ? void 0 : i.domain), s.value = r(s.value));
  return {
    domain: e === void 0 ? e : r(e),
    ...n
  };
}
function jz(t) {
  return _t(t, k1);
}
function qz(t) {
  return (e) => {
    if (!ct.has(e = `${e}`)) throw new Error(`unknown scale: ${e}`);
    return t[e];
  };
}
function Uz({ scale: t, type: e, domain: n, range: r, interpolate: i, interval: s, transform: o, percent: a, pivot: l }) {
  if (e === "identity") return { type: "identity", apply: (u) => u, invert: (u) => u };
  const c = t.unknown ? t.unknown() : void 0;
  return {
    type: e,
    domain: wc(n),
    // defensive copy
    ...r !== void 0 && { range: wc(r) },
    // defensive copy
    ...o !== void 0 && { transform: o },
    ...a && { percent: a },
    // only exposed if truthy
    ...c !== void 0 && { unknown: c },
    ...s !== void 0 && { interval: s },
    // quantitative
    ...i !== void 0 && { interpolate: i },
    ...t.clamp && { clamp: t.clamp() },
    // diverging (always asymmetric; we never want to apply the symmetric transform twice)
    ...l !== void 0 && { pivot: l, symmetric: !1 },
    // log, diverging-log
    ...t.base && { base: t.base() },
    // pow, diverging-pow
    ...t.exponent && { exponent: t.exponent() },
    // symlog, diverging-symlog
    ...t.constant && { constant: t.constant() },
    // band, point
    ...t.align && { align: t.align(), round: t.round() },
    ...t.padding && (t.paddingInner ? { paddingInner: t.paddingInner(), paddingOuter: t.paddingOuter() } : { padding: t.padding() }),
    ...t.bandwidth && { bandwidth: t.bandwidth(), step: t.step() },
    // utilities
    apply: (u) => t(u),
    ...t.invert && { invert: (u) => t.invert(u) }
  };
}
function Kz(t, e) {
  const { fx: n, fy: r } = a0(t, e), i = n == null ? void 0 : n.scale.domain(), s = r == null ? void 0 : r.scale.domain();
  return i && s ? N9(i, s).map(([o, a], l) => ({ x: o, y: a, i: l })) : i ? i.map((o, a) => ({ x: o, i: a })) : s ? s.map((o, a) => ({ y: o, i: a })) : void 0;
}
function Gz(t, { x: e, y: n }) {
  return e && (e = l0(e)), n && (n = l0(n)), t.filter(
    e && n ? (r) => e.has(r.x) && n.has(r.y) : e ? (r) => e.has(r.x) : (r) => n.has(r.y)
  ).sort(
    e && n ? (r, i) => e.get(r.x) - e.get(i.x) || n.get(r.y) - n.get(i.y) : e ? (r, i) => e.get(r.x) - e.get(i.x) : (r, i) => n.get(r.y) - n.get(i.y)
  );
}
function $1(t, { fx: e, fy: n }) {
  const r = _s(t), i = e == null ? void 0 : e.value, s = n == null ? void 0 : n.value;
  return e && n ? Gl(
    r,
    (o) => (o.fx = i[o[0]], o.fy = s[o[0]], o),
    (o) => i[o],
    (o) => s[o]
  ) : e ? Gl(
    r,
    (o) => (o.fx = i[o[0]], o),
    (o) => i[o]
  ) : Gl(
    r,
    (o) => (o.fy = s[o[0]], o),
    (o) => s[o]
  );
}
function Xz(t, e, { marginTop: n, marginLeft: r }) {
  return t && e ? ({ x: i, y: s }) => `translate(${t(i) - r},${e(s) - n})` : t ? ({ x: i }) => `translate(${t(i) - r},0)` : ({ y: i }) => `translate(0,${e(i) - n})`;
}
function Zz(t) {
  const e = [], n = new Uint32Array(io(t, (r) => r.length));
  for (const r of t) {
    let i = 0;
    for (const s of t)
      r !== s && (n.set(s, i), i += s.length);
    e.push(n.slice(0, i));
  }
  return e;
}
const Jz = /* @__PURE__ */ new Map([
  ["top", lm],
  ["right", fm],
  ["bottom", cm],
  ["left", um],
  ["top-left", Uu(lm, um)],
  ["top-right", Uu(lm, fm)],
  ["bottom-left", Uu(cm, um)],
  ["bottom-right", Uu(cm, fm)],
  ["top-empty", tV],
  ["right-empty", iV],
  ["bottom-empty", nV],
  ["left-empty", rV],
  ["empty", sV]
]);
function Qz(t) {
  if (t == null) return null;
  const e = Jz.get(`${t}`.toLowerCase());
  if (e) return e;
  throw new Error(`invalid facet anchor: ${t}`);
}
const t2 = /* @__PURE__ */ new WeakMap();
function l0(t) {
  let e = t2.get(t);
  return e || t2.set(t, e = new ro(_t(t, (n, r) => [n, r]))), e;
}
function Ss(t, e) {
  return l0(t).get(e);
}
function eV(t, e, n) {
  return e = Hs(e), n = Hs(n), t.find((r) => Object.is(Hs(r.x), e) && Object.is(Hs(r.y), n));
}
function tp(t, e, n) {
  var r;
  return (r = eV(t, e, n)) == null ? void 0 : r.empty;
}
function lm(t, { y: e }, { y: n }) {
  return e ? Ss(e, n) === 0 : !0;
}
function cm(t, { y: e }, { y: n }) {
  return e ? Ss(e, n) === e.length - 1 : !0;
}
function um(t, { x: e }, { x: n }) {
  return e ? Ss(e, n) === 0 : !0;
}
function fm(t, { x: e }, { x: n }) {
  return e ? Ss(e, n) === e.length - 1 : !0;
}
function tV(t, { y: e }, { x: n, y: r, empty: i }) {
  if (i) return !1;
  if (!e) return;
  const s = Ss(e, r);
  if (s > 0) return tp(t, n, e[s - 1]);
}
function nV(t, { y: e }, { x: n, y: r, empty: i }) {
  if (i) return !1;
  if (!e) return;
  const s = Ss(e, r);
  if (s < e.length - 1) return tp(t, n, e[s + 1]);
}
function rV(t, { x: e }, { x: n, y: r, empty: i }) {
  if (i) return !1;
  if (!e) return;
  const s = Ss(e, n);
  if (s > 0) return tp(t, e[s - 1], r);
}
function iV(t, { x: e }, { x: n, y: r, empty: i }) {
  if (i) return !1;
  if (!e) return;
  const s = Ss(e, n);
  if (s < e.length - 1) return tp(t, e[s + 1], r);
}
function sV(t, e, { empty: n }) {
  return n;
}
function Uu(t, e) {
  return function() {
    return t.apply(null, arguments) && e.apply(null, arguments);
  };
}
function hm(t, { channels: { fx: e, fy: n }, groups: r }) {
  return e && n ? t.map(({ x: i, y: s }) => {
    var o, a;
    return (a = (o = r.get(i)) == null ? void 0 : o.get(s)) != null ? a : [];
  }) : e ? t.map(({ x: i }) => {
    var s;
    return (s = r.get(i)) != null ? s : [];
  }) : t.map(({ y: i }) => {
    var s;
    return (s = r.get(i)) != null ? s : [];
  });
}
const hC = Math.PI, si = 2 * hC, n2 = 0.618;
function oV({
  projection: t,
  inset: e = 0,
  insetTop: n = e,
  insetRight: r = e,
  insetBottom: i = e,
  insetLeft: s = e
} = {}, o) {
  if (t == null) return;
  if (typeof t.stream == "function") return t;
  let a, l, c = "frame";
  if (So(t)) {
    let w;
    if ({
      type: t,
      domain: l,
      inset: w,
      insetTop: n = w !== void 0 ? w : n,
      insetRight: r = w !== void 0 ? w : r,
      insetBottom: i = w !== void 0 ? w : i,
      insetLeft: s = w !== void 0 ? w : s,
      clip: c = c,
      ...a
    } = t, t == null) return;
  }
  typeof t != "function" && ({ type: t } = dC(t));
  const { width: u, height: h, marginLeft: f, marginRight: d, marginTop: p, marginBottom: m } = o, v = u - f - d - s - r, g = h - p - m - n - i;
  if (t = t == null ? void 0 : t({ width: v, height: g, clip: c, ...a }), t == null) return;
  c = aV(c, f, p, u - d, h - m);
  let y = f + s, x = p + n, b;
  if (l != null) {
    const [[w, k], [_, C]] = Zv(t).bounds(l), E = Math.min(v / (_ - w), g / (C - k));
    E > 0 ? (y -= (E * (w + _) - v) / 2, x -= (E * (k + C) - g) / 2, b = Ug({
      point(L, M) {
        this.stream.point(L * E + y, M * E + x);
      }
    })) : rs("Warning: the projection could not be fit to the specified domain; using the default scale.");
  }
  return b != null || (b = y === 0 && x === 0 ? pC() : Ug({
    point(w, k) {
      this.stream.point(w + y, k + x);
    }
  })), { stream: (w) => t.stream(b.stream(c(w))) };
}
function dC(t) {
  switch (`${t}`.toLowerCase()) {
    case "albers-usa":
      return or(SI, 0.7463, 0.4673);
    case "albers":
      return Ku(r4, 0.7463, 0.4673);
    case "azimuthal-equal-area":
      return or(MI, 4, 4);
    case "azimuthal-equidistant":
      return or(CI, si, si);
    case "conic-conformal":
      return Ku(DI, si, si);
    case "conic-equal-area":
      return Ku(wh, 6.1702, 2.9781);
    case "conic-equidistant":
      return Ku(EI, 7.312, 3.6282);
    case "equal-earth":
      return or(LI, 5.4133, 2.6347);
    case "equirectangular":
      return or(TI, si, hC);
    case "gnomonic":
      return or(NI, 3.4641, 3.4641);
    case "identity":
      return { type: pC };
    case "reflect-y":
      return { type: lV };
    case "mercator":
      return or($I, si, si);
    case "orthographic":
      return or(II, 2, 2);
    case "stereographic":
      return or(RI, 2, 2);
    case "transverse-mercator":
      return or(BI, si, si);
    default:
      throw new Error(`unknown projection type: ${t}`);
  }
}
function aV(t, e, n, r, i) {
  if (t === !1 || t == null || typeof t == "number") return (s) => s;
  switch (t === !0 && (t = "frame"), `${t}`.toLowerCase()) {
    case "frame":
      return VS(e, n, r, i);
    default:
      throw new Error(`unknown projection clip type: ${t}`);
  }
}
function or(t, e, n) {
  return {
    type: ({ width: r, height: i, rotate: s, precision: o = 0.15, clip: a }) => {
      var c, u, h;
      const l = t();
      return o != null && ((c = l.precision) == null || c.call(l, o)), s != null && ((u = l.rotate) == null || u.call(l, s)), typeof a == "number" && ((h = l.clipAngle) == null || h.call(l, a)), l.scale(Math.min(r / e, i / n)), l.translate([r / 2, i / 2]), l;
    },
    aspectRatio: n / e
  };
}
function Ku(t, e, n) {
  const { type: r, aspectRatio: i } = or(t, e, n);
  return {
    type: (s) => {
      const { parallels: o, domain: a, width: l, height: c } = s, u = r(s);
      return o != null && (u.parallels(o), a === void 0 && u.fitSize([l, c], { type: "Sphere" })), u;
    },
    aspectRatio: i
  };
}
const pC = uu({ stream: (t) => t }), lV = uu(
  Ug({
    point(t, e) {
      this.stream.point(t, -e);
    }
  })
);
function cV(t, e, n, r) {
  const i = n[t], s = n[e], o = i.length, a = n[t] = new Float64Array(o).fill(NaN), l = n[e] = new Float64Array(o).fill(NaN);
  let c;
  const u = r.stream({
    point(h, f) {
      a[c] = h, l[c] = f;
    }
  });
  for (c = 0; c < o; ++c)
    u.point(i[c], s[c]);
}
function uV({ projection: t } = {}) {
  return t == null ? !1 : typeof t.stream == "function" ? !0 : (So(t) && (t = t.type), t != null);
}
function fV(t) {
  if (typeof (t == null ? void 0 : t.stream) == "function") return n2;
  if (So(t) && (t = t.type), t != null) {
    if (typeof t != "function") {
      const { aspectRatio: e } = dC(t);
      if (e) return e;
    }
    return n2;
  }
}
function hV(t) {
  const e = [], n = [], r = { scale: "x", value: e }, i = { scale: "y", value: n }, s = {
    point(o, a) {
      e.push(o), n.push(a);
    },
    lineStart() {
    },
    lineEnd() {
    },
    polygonStart() {
    },
    polygonEnd() {
    },
    sphere() {
    }
  };
  for (const o of t.value) Rs(o, s);
  return [r, i];
}
function A1(t = {}) {
  const { document: e = typeof window != "undefined" ? window.document : void 0, clip: n } = t;
  return { document: e, clip: zM(n) };
}
function qt(t, { document: e }) {
  return Xl(Dd(t).call(e.documentElement));
}
function dV(t) {
  let e, n;
  return (...r) => (((n == null ? void 0 : n.length) !== r.length || n.some((i, s) => i !== r[s])) && (n = r, e = t(...r)), e);
}
const pV = dV((t) => new Intl.NumberFormat(t));
function mV(t = "en-US") {
  const e = pV(t);
  return (n) => n != null && !isNaN(n) ? e.format(n) : void 0;
}
function gV(t) {
  return QB(t, "Invalid Date");
}
function vV(t = "en-US") {
  const e = mV(t);
  return (n) => (n instanceof Date ? gV : typeof n == "number" ? e : Jt)(n);
}
const _a = vV(), Sn = (typeof window != "undefined" ? window.devicePixelRatio > 1 : typeof it == "undefined") ? 0 : 0.5;
let yV = 0;
function r2() {
  return `plot-clip-${++yV}`;
}
function bV(t, {
  title: e,
  href: n,
  ariaLabel: r,
  ariaDescription: i,
  ariaHidden: s,
  target: o,
  fill: a,
  fillOpacity: l,
  stroke: c,
  strokeWidth: u,
  strokeOpacity: h,
  strokeLinejoin: f,
  strokeLinecap: d,
  strokeMiterlimit: p,
  strokeDasharray: m,
  strokeDashoffset: v,
  opacity: g,
  mixBlendMode: y,
  imageFilter: x,
  paintOrder: b,
  pointerEvents: w,
  shapeRendering: k,
  channels: _
}, {
  ariaLabel: C,
  fill: E = "currentColor",
  fillOpacity: L,
  stroke: M = "none",
  strokeOpacity: O,
  strokeWidth: N,
  strokeLinecap: R,
  strokeLinejoin: $,
  strokeMiterlimit: F,
  paintOrder: U
}) {
  E === null && (a = null, l = null), M === null && (c = null, h = null), cn(E) ? !cn(M) && (!cn(a) || _ != null && _.fill) && (M = "none") : cn(M) && (!cn(c) || _ != null && _.stroke) && (E = "none");
  const [ee, ie] = ho(a, E), [z, te] = _n(l, L), [I, X] = ho(c, M), [Q, ce] = _n(h, O), [he, J] = _n(g);
  _c(X) || (u === void 0 && (u = N), d === void 0 && (d = R), f === void 0 && (f = $), p === void 0 && !OF(f) && (p = F), !_c(ie) && b === void 0 && (b = U));
  const [pe, Y] = _n(u);
  return E !== null && (t.fill = $t(ie, "currentColor"), t.fillOpacity = hl(te, 1)), M !== null && (t.stroke = $t(X, "none"), t.strokeWidth = hl(Y, 1), t.strokeOpacity = hl(ce, 1), t.strokeLinejoin = $t(f, "miter"), t.strokeLinecap = $t(d, "butt"), t.strokeMiterlimit = hl(p, 4), t.strokeDasharray = $t(m, "none"), t.strokeDashoffset = $t(v, "0")), t.target = Jt(o), t.ariaLabel = Jt(C), t.ariaDescription = Jt(i), t.ariaHidden = Jt(s), t.opacity = hl(J, 1), t.mixBlendMode = $t(y, "normal"), t.imageFilter = $t(x, "none"), t.paintOrder = $t(b, "normal"), t.pointerEvents = $t(w, "auto"), t.shapeRendering = $t(k, "auto"), {
    title: { value: e, optional: !0, filter: null },
    href: { value: n, optional: !0, filter: null },
    ariaLabel: { value: r, optional: !0, filter: null },
    fill: { value: ee, scale: "auto", optional: !0 },
    fillOpacity: { value: z, scale: "auto", optional: !0 },
    stroke: { value: I, scale: "auto", optional: !0 },
    strokeOpacity: { value: Q, scale: "auto", optional: !0 },
    strokeWidth: { value: pe, optional: !0 },
    opacity: { value: he, scale: "auto", optional: !0 }
  };
}
function xV(t, e) {
  e && t.filter((n) => h1(e[n])).append("title").call(kV, e);
}
function wV(t, e) {
  e && t.filter(([n]) => h1(e[n])).append("title").call(_V, e);
}
function kV(t, e) {
  e && t.text((n) => _a(e[n]));
}
function _V(t, e) {
  e && t.text(([n]) => _a(e[n]));
}
function Wa(t, { target: e, tip: n }, {
  ariaLabel: r,
  title: i,
  fill: s,
  fillOpacity: o,
  stroke: a,
  strokeOpacity: l,
  strokeWidth: c,
  opacity: u,
  href: h
}) {
  r && Me(t, "aria-label", (f) => r[f]), s && Me(t, "fill", (f) => s[f]), o && Me(t, "fill-opacity", (f) => o[f]), a && Me(t, "stroke", (f) => a[f]), l && Me(t, "stroke-opacity", (f) => l[f]), c && Me(t, "stroke-width", (f) => c[f]), u && Me(t, "opacity", (f) => u[f]), h && mC(t, (f) => h[f], e), n || xV(t, i);
}
function SV(t, { target: e, tip: n }, {
  ariaLabel: r,
  title: i,
  fill: s,
  fillOpacity: o,
  stroke: a,
  strokeOpacity: l,
  strokeWidth: c,
  opacity: u,
  href: h
}) {
  r && Me(t, "aria-label", ([f]) => r[f]), s && Me(t, "fill", ([f]) => s[f]), o && Me(t, "fill-opacity", ([f]) => o[f]), a && Me(t, "stroke", ([f]) => a[f]), l && Me(t, "stroke-opacity", ([f]) => l[f]), c && Me(t, "stroke-width", ([f]) => c[f]), u && Me(t, "opacity", ([f]) => u[f]), h && mC(t, ([f]) => h[f], e), n || wV(t, i);
}
function MV({
  ariaLabel: t,
  title: e,
  fill: n,
  fillOpacity: r,
  stroke: i,
  strokeOpacity: s,
  strokeWidth: o,
  opacity: a,
  href: l
}, { tip: c }) {
  return [t, c ? void 0 : e, n, r, i, s, o, a, l].filter((u) => u !== void 0);
}
function CV(t, e, n) {
  const r = Nv(t, (i) => e[i]);
  return n === void 0 && r.size > 1 + t.length >> 1 && rs(
    "Warning: the implicit z channel has high cardinality. This may occur when the fill or stroke channel is associated with quantitative data rather than ordinal or categorical data. You can suppress this warning by setting the z option explicitly; if this data represents a single series, set z to null."
  ), r.values();
}
function* $V(t, e, n, r) {
  const { z: i } = n, { z: s } = r, o = MV(r, n), a = [...e, ...o];
  for (const l of s ? CV(t, s, i) : [t]) {
    let c, u;
    e: for (const h of l) {
      for (const f of a)
        if (!hs(f[h])) {
          u && u.push(-1);
          continue e;
        }
      if (c === void 0) {
        u && (yield u), c = o.map((f) => Hs(f[h])), u = [h];
        continue;
      }
      u.push(h);
      for (let f = 0; f < o.length; ++f)
        if (Hs(o[f][h]) !== c[f]) {
          yield u, c = o.map((p) => Hs(p[h])), u = [h];
          continue e;
        }
    }
    u && (yield u);
  }
}
function AV(t, e, n, r) {
  let i;
  const { clip: s = r.clip } = e;
  switch (s) {
    case "frame": {
      const { width: o, height: a, marginLeft: l, marginRight: c, marginTop: u, marginBottom: h } = n, f = r2();
      i = `url(#${f})`, t = qt("svg:g", r).call(
        (d) => d.append("svg:clipPath").attr("id", f).append("rect").attr("x", l).attr("y", u).attr("width", o - c - l).attr("height", a - u - h)
      ).each(function() {
        this.appendChild(t.node()), t.node = () => this;
      });
      break;
    }
    case "sphere": {
      const { projection: o } = r;
      if (!o) throw new Error('the "sphere" clip option requires a projection');
      const a = r2();
      i = `url(#${a})`, t.append("clipPath").attr("id", a).append("path").attr("d", Zv(o)({ type: "Sphere" }));
      break;
    }
  }
  Me(t, "aria-label", e.ariaLabel), Me(t, "aria-description", e.ariaDescription), Me(t, "aria-hidden", e.ariaHidden), Me(t, "clip-path", i);
}
function Ms(t, e, n, r) {
  AV(t, e, n, r), Me(t, "fill", e.fill), Me(t, "fill-opacity", e.fillOpacity), Me(t, "stroke", e.stroke), Me(t, "stroke-width", e.strokeWidth), Me(t, "stroke-opacity", e.strokeOpacity), Me(t, "stroke-linejoin", e.strokeLinejoin), Me(t, "stroke-linecap", e.strokeLinecap), Me(t, "stroke-miterlimit", e.strokeMiterlimit), Me(t, "stroke-dasharray", e.strokeDasharray), Me(t, "stroke-dashoffset", e.strokeDashoffset), Me(t, "shape-rendering", e.shapeRendering), Me(t, "filter", e.imageFilter), Me(t, "paint-order", e.paintOrder);
  const { pointerEvents: i = r.pointerSticky === !1 ? "none" : void 0 } = e;
  Me(t, "pointer-events", i);
}
function Cs(t, e) {
  DV(t, "mix-blend-mode", e.mixBlendMode), Me(t, "opacity", e.opacity);
}
function mC(t, e, n) {
  t.each(function(r) {
    const i = e(r);
    if (i != null) {
      const s = this.ownerDocument.createElementNS(ha.svg, "a");
      s.setAttribute("fill", "inherit"), s.setAttributeNS(ha.xlink, "href", i), n != null && s.setAttribute("target", n), this.parentNode.insertBefore(s, this).appendChild(this);
    }
  });
}
function Me(t, e, n) {
  n != null && t.attr(e, n);
}
function DV(t, e, n) {
  n != null && t.style(e, n);
}
function $s(t, e, { x: n, y: r }, i = Sn, s = Sn) {
  i += e.dx, s += e.dy, n != null && n.bandwidth && (i += n.bandwidth() / 2), r != null && r.bandwidth && (s += r.bandwidth() / 2), (i || s) && t.attr("transform", `translate(${i},${s})`);
}
function $t(t, e) {
  if ((t = Jt(t)) !== e) return t;
}
function hl(t, e) {
  if ((t = at(t)) !== e) return t;
}
const TV = /^-?([_a-z]|[\240-\377]|\\[0-9a-f]{1,6}(\r\n|[ \t\r\n\f])?|\\[^\r\n\f0-9a-f])([_a-z0-9-]|[\240-\377]|\\[0-9a-f]{1,6}(\r\n|[ \t\r\n\f])?|\\[^\r\n\f0-9a-f])*$/i;
function D1(t) {
  if (t === void 0) return "plot-d6a7b5";
  if (t = `${t}`, !TV.test(t)) throw new Error(`invalid class name: ${t}`);
  return t;
}
function T1(t, e) {
  if (typeof e == "string")
    t.property("style", e);
  else if (e != null)
    for (const n of t)
      Object.assign(n.style, e);
}
function np({ frameAnchor: t }, { width: e, height: n, marginTop: r, marginRight: i, marginBottom: s, marginLeft: o }) {
  return [
    /left$/.test(t) ? o : /right$/.test(t) ? e - i : (o + e - i) / 2,
    /^top/.test(t) ? r : /^bottom/.test(t) ? n - s : (r + n - s) / 2
  ];
}
class br {
  constructor(e, n = {}, r = {}, i) {
    const {
      facet: s = "auto",
      facetAnchor: o,
      fx: a,
      fy: l,
      sort: c,
      dx: u = 0,
      dy: h = 0,
      margin: f = 0,
      marginTop: d = f,
      marginRight: p = f,
      marginBottom: m = f,
      marginLeft: v = f,
      clip: g = i == null ? void 0 : i.clip,
      channels: y,
      tip: x,
      render: b
    } = r;
    if (this.data = e, this.sort = kc(c) ? c : null, this.initializer = Lh(r).initializer, this.transform = this.initializer ? r.transform : WM(r).transform, s === null || s === !1 ? this.facet = null : (this.facet = yr(s === !0 ? "include" : s, "facet", ["auto", "include", "exclude", "super"]), this.fx = e === Lf && typeof a == "string" ? [a] : a, this.fy = e === Lf && typeof l == "string" ? [l] : l), this.facetAnchor = Qz(o), n = FM(n), y !== void 0 && (n = { ...OV(y), ...n }), i !== void 0 && (n = { ...bV(this, r, i), ...n }), this.channels = Object.fromEntries(
      Object.entries(n).map(([w, k]) => {
        if (v1(k.value)) {
          const { value: _, label: C = k.label, scale: E = k.scale } = k.value;
          k = { ...k, label: C, scale: E, value: _ };
        }
        if (e === Lf && typeof k.value == "string") {
          const { value: _ } = k;
          k = { ...k, value: [_] };
        }
        return [w, k];
      }).filter(([w, { value: k, optional: _ }]) => {
        if (k != null) return !0;
        if (_) return !1;
        throw new Error(`missing channel value: ${w}`);
      })
    ), this.dx = +u, this.dy = +h, this.marginTop = +d, this.marginRight = +p, this.marginBottom = +m, this.marginLeft = +v, this.clip = zM(g), this.tip = EV(x), this.facet === "super") {
      if (a || l) throw new Error("super-faceting cannot use fx or fy");
      for (const w in this.channels) {
        const { scale: k } = n[w];
        if (!(k !== "x" && k !== "y"))
          throw new Error("super-faceting cannot use x or y");
      }
    }
    b != null && (this.render = vC(b, this.render));
  }
  initialize(e, n, r) {
    let i = Tn(this.data);
    e === void 0 && i != null && (e = [_s(i)]);
    const s = e;
    this.transform != null && ({ facets: e, data: i } = this.transform(i, e, r), i = Tn(i)), e !== void 0 && (e.original = s);
    const o = ZF(this.channels, i);
    return this.sort != null && QF(i, e, o, n, this.sort), { data: i, facets: e, channels: o };
  }
  filter(e, n, r) {
    for (const i in n) {
      const { filter: s = hs } = n[i];
      if (s !== null) {
        const o = r[i];
        e = e.filter((a) => s(o[a]));
      }
    }
    return e;
  }
  // If there is a projection, and there are paired x and y channels associated
  // with the x and y scale respectively (and not already in screen coordinates
  // as with an initializer), then apply the projection, replacing the x and y
  // values. Note that the x and y scales themselves don’t exist if there is a
  // projection, but whether the channels are associated with scales still
  // determines whether the projection should apply; think of the projection as
  // a combination xy-scale.
  project(e, n, r) {
    for (const i in e)
      if (e[i].scale === "x" && /^x|x$/.test(i)) {
        const s = i.replace(/^x|x$/, "y");
        s in e && e[s].scale === "y" && cV(i, s, n, r.projection);
      }
  }
  scale(e, n, r) {
    const i = JF(e, n);
    return r.projection && this.project(e, i, r), i;
  }
}
function gC(...t) {
  return t.plot = br.prototype.plot, t;
}
function vC(t, e) {
  if (t == null) return e === null ? void 0 : e;
  if (e == null) return t === null ? void 0 : t;
  if (typeof t != "function") throw new TypeError(`invalid render transform: ${t}`);
  if (typeof e != "function") throw new TypeError(`invalid render transform: ${e}`);
  return function(n, r, i, s, o, a) {
    return t.call(this, n, r, i, s, o, (l, c, u, h, f) => e.call(this, l, c, u, h, f, a));
  };
}
function OV(t) {
  return Object.fromEntries(
    Object.entries(FM(t)).map(([e, n]) => (n = typeof n == "string" ? { value: n, label: e } : Xd(n), n.filter === void 0 && n.scale == null && (n = { ...n, filter: null }), [e, n]))
  );
}
function EV(t) {
  return t === !0 ? "xy" : t === !1 || t == null ? null : typeof t == "string" ? yr(t, "tip", ["x", "y", "xy"]) : t;
}
function O1(t, e) {
  return (t == null ? void 0 : t.tip) === !0 ? { ...t, tip: e } : So(t == null ? void 0 : t.tip) && t.tip.pointer === void 0 ? { ...t, tip: { ...t.tip, pointer: e } } : t;
}
function PV(t, e, n = {}) {
  var m;
  let r = 0.5 - Sn, i = 0.5 + Sn, s = 0.5 + Sn, o = 0.5 - Sn;
  for (const { marginTop: v, marginRight: g, marginBottom: y, marginLeft: x } of e)
    v > r && (r = v), g > i && (i = g), y > s && (s = y), x > o && (o = x);
  let {
    margin: a,
    marginTop: l = a !== void 0 ? a : r,
    marginRight: c = a !== void 0 ? a : i,
    marginBottom: u = a !== void 0 ? a : s,
    marginLeft: h = a !== void 0 ? a : o
  } = n;
  l = +l, c = +c, u = +u, h = +h;
  let {
    width: f = 640,
    height: d = LV(t, n, {
      width: f,
      marginTopDefault: r,
      marginRightDefault: i,
      marginBottomDefault: s,
      marginLeftDefault: o
    }) + Math.max(0, l - r + u - s)
  } = n;
  f = +f, d = +d;
  const p = {
    width: f,
    height: d,
    marginTop: l,
    marginRight: c,
    marginBottom: u,
    marginLeft: h
  };
  if (t.fx || t.fy) {
    let {
      margin: v,
      marginTop: g = v !== void 0 ? v : l,
      marginRight: y = v !== void 0 ? v : c,
      marginBottom: x = v !== void 0 ? v : u,
      marginLeft: b = v !== void 0 ? v : h
    } = (m = n.facet) != null ? m : {};
    g = +g, y = +y, x = +x, b = +b, p.facet = {
      marginTop: g,
      marginRight: y,
      marginBottom: x,
      marginLeft: b
    };
  }
  return p;
}
function LV({ x: t, y: e, fy: n, fx: r }, { projection: i, aspectRatio: s }, { width: o, marginTopDefault: a, marginRightDefault: l, marginBottomDefault: c, marginLeftDefault: u }) {
  const h = n ? n.scale.domain().length : 1, f = fV(i);
  if (f) {
    const p = r ? r.scale.domain().length : 1, m = (1.1 * h - 0.1) / (1.1 * p - 0.1) * f, v = Math.max(0.1, Math.min(10, m));
    return Math.round((o - u - l) * v + a + c);
  }
  const d = e ? Co(e) ? e.scale.domain().length : Math.max(7, 17 / h) : 1;
  if (s != null) {
    if (s = +s, !(isFinite(s) && s > 0)) throw new Error(`invalid aspectRatio: ${s}`);
    const p = i2("y", e) / (i2("x", t) * s), m = r ? r.scale.bandwidth() : 1, v = n ? n.scale.bandwidth() : 1, g = m * (o - u - l) - t.insetLeft - t.insetRight;
    return (p * g + e.insetTop + e.insetBottom) / v + a + c;
  }
  return !!(e || n) * Math.max(1, Math.min(60, d * h)) * 20 + !!r * 30 + 60;
}
function i2(t, e) {
  if (!e) throw new Error(`aspectRatio requires ${t} scale`);
  const { type: n, domain: r } = e;
  let i;
  switch (n) {
    case "linear":
    case "utc":
    case "time":
      i = Number;
      break;
    case "pow": {
      const a = e.scale.exponent();
      i = (l) => Math.pow(l, a);
      break;
    }
    case "log":
      i = Math.log;
      break;
    case "point":
    case "band":
      return r.length;
    default:
      throw new Error(`unsupported ${t} scale for aspectRatio: ${n}`);
  }
  const [s, o] = ns(r);
  return Math.abs(i(o) - i(s));
}
const s2 = /* @__PURE__ */ new WeakMap();
function E1(t, e, { x: n, y: r, px: i, py: s, maxRadius: o = 40, channels: a, render: l, ...c } = {}) {
  return o = +o, i != null && (n != null || (n = null), a = { ...a, px: { value: i, scale: "x" } }), s != null && (r != null || (r = null), a = { ...a, py: { value: s, scale: "y" } }), {
    x: n,
    y: r,
    channels: a,
    ...c,
    // Unlike other composed transforms, the render transform must be the
    // outermost render function because it will re-render dynamically in
    // response to pointer events.
    render: vC(function(u, h, f, d, p, m) {
      p = { ...p, pointerSticky: !1 };
      const v = p.ownerSVGElement, { data: g } = p.getMarkState(this);
      let y = s2.get(v);
      y || s2.set(v, y = { sticky: !1, roots: [], renders: [] });
      let x = y.renders.push(X) - 1;
      const { x: b, y: w, fx: k, fy: _ } = h;
      let C = k ? k(u.fx) - d.marginLeft : 0, E = _ ? _(u.fy) - d.marginTop : 0;
      b != null && b.bandwidth && (C += b.bandwidth() / 2), w != null && w.bandwidth && (E += w.bandwidth() / 2);
      const L = u.fi != null;
      let M;
      if (L) {
        let J = y.facetStates;
        J || (y.facetStates = J = /* @__PURE__ */ new Map()), M = J.get(this), M || J.set(this, M = /* @__PURE__ */ new Map());
      }
      const [O, N] = np(this, d), { px: R, py: $ } = f, F = R ? (J) => R[J] : yC(f, O), U = $ ? (J) => $[J] : bC(f, N);
      let ee, ie, z, te;
      function I(J, pe) {
        if (L)
          if (te && (te = cancelAnimationFrame(te)), J == null) M.delete(u.fi);
          else {
            M.set(u.fi, pe), te = requestAnimationFrame(() => {
              te = null;
              for (const [Y, se] of M)
                if (se < pe || se === pe && Y < u.fi) {
                  J = null;
                  break;
                }
              X(J);
            });
            return;
          }
        X(J);
      }
      function X(J) {
        if (ee === J && z === y.sticky) return;
        ee = J, z = p.pointerSticky = y.sticky;
        const pe = ee == null ? [] : [ee];
        L && (pe.fx = u.fx, pe.fy = u.fy, pe.fi = u.fi);
        const Y = m(pe, h, f, d, p);
        if (ie) {
          if (L) {
            const se = ie.parentNode, ge = ie.getAttribute("transform"), V = Y.getAttribute("transform");
            ge ? Y.setAttribute("transform", ge) : Y.removeAttribute("transform"), V ? se.setAttribute("transform", V) : se.removeAttribute("transform"), Y.removeAttribute("aria-label"), Y.removeAttribute("aria-description"), Y.removeAttribute("aria-hidden");
          }
          ie.replaceWith(Y);
        }
        return y.roots[x] = ie = Y, ee == null && (M == null ? void 0 : M.size) > 1 || p.dispatchValue(ee == null ? null : g[ee]), Y;
      }
      function Q(J) {
        if (y.sticky || J.pointerType === "mouse" && J.buttons === 1) return;
        let [pe, Y] = VP(J);
        pe -= C, Y -= E;
        const se = pe < d.marginLeft || pe > d.width - d.marginRight ? 1 : t, ge = Y < d.marginTop || Y > d.height - d.marginBottom ? 1 : e;
        let V = null, Ee = o * o;
        for (const ke of u) {
          const Ie = se * (F(ke) - pe), He = ge * (U(ke) - Y), st = Ie * Ie + He * He;
          st <= Ee && (V = ke, Ee = st);
        }
        if (V != null && (t !== 1 || e !== 1)) {
          const ke = F(V) - pe, Ie = U(V) - Y;
          Ee = ke * ke + Ie * Ie;
        }
        I(V, Ee);
      }
      function ce(J) {
        J.pointerType === "mouse" && ee != null && (y.sticky && y.roots.some((pe) => pe == null ? void 0 : pe.contains(J.target)) || (y.sticky ? (y.sticky = !1, y.renders.forEach((pe) => pe(null))) : (y.sticky = !0, X(ee)), J.stopImmediatePropagation()));
      }
      function he(J) {
        J.pointerType === "mouse" && (y.sticky || I(null));
      }
      return v.addEventListener("pointerenter", Q), v.addEventListener("pointermove", Q), v.addEventListener("pointerdown", ce), v.addEventListener("pointerleave", he), X(null);
    }, l)
  };
}
function NV(t) {
  return E1(1, 1, t);
}
function IV(t) {
  return E1(1, 0.01, t);
}
function o2(t) {
  return E1(0.01, 1, t);
}
function yC({ x1: t, x2: e, x: n = t }, r) {
  return t && e ? (i) => (t[i] + e[i]) / 2 : n ? (i) => n[i] : () => r;
}
function bC({ y1: t, y2: e, y: n = t }, r) {
  return t && e ? (i) => (t[i] + e[i]) / 2 : n ? (i) => n[i] : () => r;
}
function xC(t) {
  return Co(t) && t.interval === void 0 ? void 0 : "tabular-nums";
}
function RV(t, e) {
  let {
    label: n = t.label,
    tickSize: r = 6,
    width: i = 240,
    height: s = 44 + r,
    marginTop: o = 18,
    marginRight: a = 0,
    marginBottom: l = 16 + r,
    marginLeft: c = 0,
    style: u,
    ticks: h = (i - c - a) / 64,
    tickFormat: f,
    fontVariant: d = xC(t),
    round: p = !0,
    opacity: m,
    className: v
  } = e;
  const g = A1(e);
  v = D1(v), m = _n(m)[1], f === null && (f = () => null);
  const y = qt("svg", g).attr("class", `${v}-ramp`).attr("font-family", "system-ui, sans-serif").attr("font-size", 10).attr("width", i).attr("height", s).attr("viewBox", `0 0 ${i} ${s}`).call(
    (O) => (
      // Warning: if you edit this, change defaultClassName.
      O.append("style").text(
        `:where(.${v}-ramp) {
  display: block;
  height: auto;
  height: intrinsic;
  max-width: 100%;
  overflow: visible;
}
:where(.${v}-ramp text) {
  white-space: pre;
}`
      )
    )
  ).call(T1, u);
  let x = (O) => O.selectAll(".tick line").attr("y1", o + l - s), b;
  const w = p ? (O, N) => O.rangeRound(N) : (O, N) => O.range(N), { type: k, domain: _, range: C, interpolate: E, scale: L, pivot: M } = t;
  if (E) {
    const O = C === void 0 ? E : Ed(E.length === 1 ? M1(E) : E, C);
    b = w(
      L.copy(),
      fr(
        Ft(c, i - a),
        Math.min(_.length + (M !== void 0), C === void 0 ? 1 / 0 : C.length)
      )
    );
    const N = 256, R = g.document.createElement("canvas");
    R.width = N, R.height = 1;
    const $ = R.getContext("2d");
    for (let F = 0, U = N - 1; F < N; ++F)
      $.fillStyle = O(F / U), $.fillRect(F, 0, 1, 1);
    y.append("image").attr("opacity", m).attr("x", c).attr("y", o).attr("width", i - c - a).attr("height", s - o - l).attr("preserveAspectRatio", "none").attr("xlink:href", R.toDataURL());
  } else if (k === "threshold") {
    const O = _, N = f === void 0 ? (R) => R : typeof f == "string" ? Ha(f) : f;
    b = w(n1().domain([-1, C.length - 1]), [c, i - a]), y.append("g").attr("fill-opacity", m).selectAll().data(C).enter().append("rect").attr("x", (R, $) => b($ - 1)).attr("y", o).attr("width", (R, $) => b($) - b($ - 1)).attr("height", s - o - l).attr("fill", (R) => R), h = _t(O, (R, $) => $), f = (R) => N(O[R], R);
  } else
    b = w(Bd().domain(_), [c, i - a]), y.append("g").attr("fill-opacity", m).selectAll().data(_).enter().append("rect").attr("x", b).attr("y", o).attr("width", Math.max(0, b.bandwidth() - 1)).attr("height", s - o - l).attr("fill", L), x = () => {
    };
  return y.append("g").attr("transform", `translate(0,${s - l})`).call(
    iE(b).ticks(Array.isArray(h) ? null : h, typeof f == "string" ? f : void 0).tickFormat(typeof f == "function" ? f : void 0).tickSize(r).tickValues(Array.isArray(h) ? h : null)
  ).attr("font-size", null).attr("font-family", null).attr("font-variant", $t(d, "normal")).call(x).call((O) => O.select(".domain").remove()), n !== void 0 && y.append("text").attr("x", c).attr("y", o - 6).attr("fill", "currentColor").attr("font-weight", "bold").text(n), y.node();
}
const wC = Math.PI / 180;
function P1(t, { marker: e, markerStart: n = e, markerMid: r = e, markerEnd: i = e } = {}) {
  t.markerStart = dm(n), t.markerMid = dm(r), t.markerEnd = dm(i);
}
function dm(t) {
  if (t == null || t === !1) return null;
  if (t === !0) return l2;
  if (typeof t == "function") return t;
  switch (`${t}`.toLowerCase()) {
    case "none":
      return null;
    case "arrow":
      return a2("auto");
    case "arrow-reverse":
      return a2("auto-start-reverse");
    case "dot":
      return BV;
    case "circle":
    case "circle-fill":
      return l2;
    case "circle-stroke":
      return FV;
    case "tick":
      return pm("auto");
    case "tick-x":
      return pm(90);
    case "tick-y":
      return pm(0);
  }
  throw new Error(`invalid marker: ${t}`);
}
function a2(t) {
  return (e, n) => qt("svg:marker", n).attr("viewBox", "-5 -5 10 10").attr("markerWidth", 6.67).attr("markerHeight", 6.67).attr("orient", t).attr("fill", "none").attr("stroke", e).attr("stroke-width", 1.5).attr("stroke-linecap", "round").attr("stroke-linejoin", "round").call((r) => r.append("path").attr("d", "M-1.5,-3l3,3l-3,3")).node();
}
function BV(t, e) {
  return qt("svg:marker", e).attr("viewBox", "-5 -5 10 10").attr("markerWidth", 6.67).attr("markerHeight", 6.67).attr("fill", t).attr("stroke", "none").call((n) => n.append("circle").attr("r", 2.5)).node();
}
function l2(t, e) {
  return qt("svg:marker", e).attr("viewBox", "-5 -5 10 10").attr("markerWidth", 6.67).attr("markerHeight", 6.67).attr("fill", t).attr("stroke", "var(--plot-background)").attr("stroke-width", 1.5).call((n) => n.append("circle").attr("r", 3)).node();
}
function FV(t, e) {
  return qt("svg:marker", e).attr("viewBox", "-5 -5 10 10").attr("markerWidth", 6.67).attr("markerHeight", 6.67).attr("fill", "var(--plot-background)").attr("stroke", t).attr("stroke-width", 1.5).call((n) => n.append("circle").attr("r", 3)).node();
}
function pm(t) {
  return (e, n) => qt("svg:marker", n).attr("viewBox", "-3 -3 6 6").attr("markerWidth", 6).attr("markerHeight", 6).attr("orient", t).attr("stroke", e).call((r) => r.append("path").attr("d", "M0,-3v6")).node();
}
let zV = 0;
function kC(t, e, { stroke: n }, r) {
  return _C(t, e, n && ((i) => n[i]), r);
}
function VV(t, e, { stroke: n }, r) {
  return _C(t, e, n && (([i]) => n[i]), r);
}
function _C(t, { markerStart: e, markerMid: n, markerEnd: r, stroke: i }, s = () => i, o) {
  const a = /* @__PURE__ */ new Map();
  function l(c) {
    return function(u) {
      const h = s(u);
      let f = a.get(c);
      f || a.set(c, f = /* @__PURE__ */ new Map());
      let d = f.get(h);
      if (!d) {
        const p = this.parentNode.insertBefore(c(h, o), this), m = `plot-marker-${++zV}`;
        p.setAttribute("id", m), f.set(h, d = `url(#${m})`);
      }
      return d;
    };
  }
  e && t.attr("marker-start", l(e)), n && t.attr("marker-mid", l(n)), r && t.attr("marker-end", l(r));
}
function SC({ inset: t, insetLeft: e, insetRight: n, ...r } = {}) {
  return [e, n] = CC(t, e, n), { inset: t, insetLeft: e, insetRight: n, ...r };
}
function MC({ inset: t, insetTop: e, insetBottom: n, ...r } = {}) {
  return [e, n] = CC(t, e, n), { inset: t, insetTop: e, insetBottom: n, ...r };
}
function CC(t, e, n) {
  return t === void 0 && e === void 0 && n === void 0 ? Sn ? [1, 0] : [0.5, 0.5] : [e, n];
}
function $C(t, { interval: e }) {
  return t = { ...Xd(t) }, t.interval = x1(t.interval === void 0 ? e : t.interval), t;
}
function AC(t, e, n, r) {
  const { [t]: i, [`${t}1`]: s, [`${t}2`]: o } = n, { value: a, interval: l } = $C(i, n);
  if (a == null || l == null && !r) return n;
  const c = fu(i);
  if (l == null) {
    let d;
    const p = { transform: (m) => d || (d = Wn(m, a)), label: c };
    return {
      ...n,
      [t]: void 0,
      [`${t}1`]: s === void 0 ? p : s,
      [`${t}2`]: o === void 0 && !(s === o && r) ? p : o
    };
  }
  let u, h;
  function f(d) {
    return h !== void 0 && d === u ? h : h = _t(Wn(u = d, a), (p) => l.floor(p));
  }
  return e({
    ...n,
    [t]: void 0,
    [`${t}1`]: s === void 0 ? { transform: f, label: c } : s,
    [`${t}2`]: o === void 0 ? { transform: (d) => f(d).map((p) => l.offset(p)), label: c } : o
  });
}
function DC(t, e, n) {
  const { [t]: r } = n, { value: i, interval: s } = $C(r, n);
  return i == null || s == null ? n : e({
    ...n,
    [t]: {
      label: fu(r),
      transform: (o) => {
        const a = _t(Wn(o, i), (c) => s.floor(c)), l = a.map((c) => s.offset(c));
        return a.map(
          Zn(a) ? (c, u) => c == null || isNaN(c = +c) || (u = l[u], u == null) || isNaN(u = +u) ? void 0 : new Date((c + u) / 2) : (c, u) => c == null || (u = l[u], u == null) ? NaN : (+c + +u) / 2
        );
      }
    }
  });
}
function HV(t = {}) {
  return AC("x", SC, t);
}
function TC(t = {}) {
  return AC("y", MC, t);
}
function YV(t = {}) {
  return DC("x", SC, t);
}
function WV(t = {}) {
  return DC("y", MC, t);
}
const OC = {
  ariaLabel: "rule",
  fill: null,
  stroke: "currentColor"
};
class jV extends br {
  constructor(e, n = {}) {
    const { x: r, y1: i, y2: s, inset: o = 0, insetTop: a = o, insetBottom: l = o } = n;
    super(
      e,
      {
        x: { value: r, scale: "x", optional: !0 },
        y1: { value: i, scale: "y", optional: !0 },
        y2: { value: s, scale: "y", optional: !0 }
      },
      O1(n, "x"),
      OC
    ), this.insetTop = at(a), this.insetBottom = at(l), P1(this, n);
  }
  render(e, n, r, i, s) {
    const { x: o, y: a } = n, { x: l, y1: c, y2: u } = r, { width: h, height: f, marginTop: d, marginRight: p, marginLeft: m, marginBottom: v } = i, { insetTop: g, insetBottom: y } = this;
    return qt("svg:g", s).call(Ms, this, i, s).call($s, this, { x: l && o }, Sn, 0).call(
      (x) => x.selectAll().data(e).enter().append("line").call(Cs, this).attr("x1", l ? (b) => l[b] : (m + h - p) / 2).attr("x2", l ? (b) => l[b] : (m + h - p) / 2).attr("y1", c && !ka(a) ? (b) => c[b] + g : d + g).attr(
        "y2",
        u && !ka(a) ? a.bandwidth ? (b) => u[b] + a.bandwidth() - y : (b) => u[b] - y : f - v - y
      ).call(Wa, this, r).call(kC, this, r, s)
    ).node();
  }
}
class qV extends br {
  constructor(e, n = {}) {
    const { x1: r, x2: i, y: s, inset: o = 0, insetRight: a = o, insetLeft: l = o } = n;
    super(
      e,
      {
        y: { value: s, scale: "y", optional: !0 },
        x1: { value: r, scale: "x", optional: !0 },
        x2: { value: i, scale: "x", optional: !0 }
      },
      O1(n, "y"),
      OC
    ), this.insetRight = at(a), this.insetLeft = at(l), P1(this, n);
  }
  render(e, n, r, i, s) {
    const { x: o, y: a } = n, { y: l, x1: c, x2: u } = r, { width: h, height: f, marginTop: d, marginRight: p, marginLeft: m, marginBottom: v } = i, { insetLeft: g, insetRight: y } = this;
    return qt("svg:g", s).call(Ms, this, i, s).call($s, this, { y: l && a }, 0, Sn).call(
      (x) => x.selectAll().data(e).enter().append("line").call(Cs, this).attr("x1", c && !ka(o) ? (b) => c[b] + g : m + g).attr(
        "x2",
        u && !ka(o) ? o.bandwidth ? (b) => u[b] + o.bandwidth() - y : (b) => u[b] - y : h - p - y
      ).attr("y1", l ? (b) => l[b] : (d + f - v) / 2).attr("y2", l ? (b) => l[b] : (d + f - v) / 2).call(Wa, this, r).call(kC, this, r, s)
    ).node();
  }
}
function UV(t, e) {
  let { x: n = nr, y: r, y1: i, y2: s, ...o } = TC(e);
  return [i, s] = EC(r, i, s), new jV(t, { ...o, x: n, y1: i, y2: s });
}
function L1(t, e) {
  let { y: n = nr, x: r, x1: i, x2: s, ...o } = HV(e);
  return [i, s] = EC(r, i, s), new qV(t, { ...o, y: n, x1: i, x2: s });
}
function EC(t, e, n) {
  if (t == null) {
    if (e === void 0) {
      if (n !== void 0) return [0, n];
    } else if (n === void 0) return [0, e];
  } else {
    if (e === void 0)
      return n === void 0 ? [0, t] : [t, n];
    if (n === void 0)
      return [t, e];
  }
  return [e, n];
}
function PC(t, ...e) {
  let n = e.length;
  for (let r = 0, i = !0; r < n; ++r)
    typeof e[r] != "function" && (i && (t = t.slice(), i = !1), t.splice(r, 2, t[r] + e[r] + t[r + 1]), e.splice(r, 1), --r, --n);
  return (r) => {
    let i = t[0];
    for (let s = 0; s < n; ++s)
      i += e[s](r) + t[s + 1];
    return i;
  };
}
const KV = {
  ariaLabel: "text",
  strokeLinejoin: "round",
  strokeWidth: 3,
  paintOrder: "stroke"
}, LC = "­";
let N1 = class extends br {
  constructor(e, n = {}) {
    const {
      x: r,
      y: i,
      text: s = Mo(e) && BM(e) ? nr : EM,
      frameAnchor: o,
      textAnchor: a = /right$/i.test(o) ? "end" : /left$/i.test(o) ? "start" : "middle",
      lineAnchor: l = /^top/i.test(o) ? "top" : /^bottom/i.test(o) ? "bottom" : "middle",
      lineHeight: c = 1,
      lineWidth: u = 1 / 0,
      textOverflow: h,
      monospace: f,
      fontFamily: d = f ? "ui-monospace, monospace" : void 0,
      fontSize: p,
      fontStyle: m,
      fontVariant: v,
      fontWeight: g,
      rotate: y
    } = n, [x, b] = _n(y, 0), [w, k] = eH(p);
    if (super(
      e,
      {
        x: { value: r, scale: "x", optional: !0 },
        y: { value: i, scale: "y", optional: !0 },
        fontSize: { value: w, optional: !0 },
        rotate: { value: MF(x), optional: !0 },
        text: { value: s, filter: h1, optional: !0 }
      },
      n,
      KV
    ), this.rotate = b, this.textAnchor = $t(a, "middle"), this.lineAnchor = yr(l, "lineAnchor", ["top", "middle", "bottom"]), this.lineHeight = +c, this.lineWidth = +u, this.textOverflow = NC(h), this.monospace = !!f, this.fontFamily = Jt(d), this.fontSize = k, this.fontStyle = Jt(m), this.fontVariant = Jt(v), this.fontWeight = Jt(g), this.frameAnchor = w1(o), !(this.lineWidth >= 0)) throw new Error(`invalid lineWidth: ${u}`);
    this.splitLines = BC(this), this.clipLine = FC(this);
  }
  render(e, n, r, i, s) {
    const { x: o, y: a } = n, { x: l, y: c, rotate: u, text: h, title: f, fontSize: d } = r, { rotate: p } = this, [m, v] = np(this, i);
    return qt("svg:g", s).call(Ms, this, i, s).call(RC, this, h, i).call($s, this, { x: l && o, y: c && a }).call(
      (g) => g.selectAll().data(e).enter().append("text").call(Cs, this).call(GV, this, h, f).attr(
        "transform",
        PC`translate(${l ? (y) => l[y] : m},${c ? (y) => c[y] : v})${u ? (y) => ` rotate(${u[y]})` : p ? ` rotate(${p})` : ""}`
      ).call(Me, "font-size", d && ((y) => d[y])).call(Wa, this, r)
    ).node();
  }
};
function NC(t) {
  return t == null ? null : yr(t, "textOverflow", [
    "clip",
    // shorthand for clip-end
    "ellipsis",
    // … ellipsis-end
    "clip-start",
    "clip-end",
    "ellipsis-start",
    "ellipsis-middle",
    "ellipsis-end"
  ]).replace(/^(clip|ellipsis)$/, "$1-end");
}
function GV(t, e, n, r) {
  if (!n) return;
  const { lineAnchor: i, lineHeight: s, textOverflow: o, splitLines: a, clipLine: l } = e;
  t.each(function(c) {
    var d;
    const u = a((d = _a(n[c])) != null ? d : "").map(l), h = u.length, f = i === "top" ? 0.71 : i === "bottom" ? 1 - h : (164 - h * 100) / 200;
    if (h > 1) {
      let p = 0;
      for (let m = 0; m < h; ++m) {
        if (++p, !u[m]) continue;
        const v = this.ownerDocument.createElementNS(ha.svg, "tspan");
        v.setAttribute("x", 0), m === p - 1 ? v.setAttribute("y", `${(f + m) * s}em`) : v.setAttribute("dy", `${p * s}em`), v.textContent = u[m], this.appendChild(v), p = 0;
      }
    } else
      f && this.setAttribute("y", `${f * s}em`), this.textContent = u[0];
    if (o && !r && u[0] !== n[c]) {
      const p = this.ownerDocument.createElementNS(ha.svg, "title");
      p.textContent = n[c], this.appendChild(p);
    }
  });
}
function IC(t, { x: e, y: n, ...r } = {}) {
  return r.frameAnchor === void 0 && ([e, n] = y1(e, n)), new N1(t, { ...r, x: e, y: n });
}
function XV(t, { x: e = nr, ...n } = {}) {
  return new N1(t, WV({ ...n, x: e }));
}
function ZV(t, { y: e = nr, ...n } = {}) {
  return new N1(t, YV({ ...n, y: e }));
}
function RC(t, e, n) {
  Me(t, "text-anchor", e.textAnchor), Me(t, "font-family", e.fontFamily), Me(t, "font-size", e.fontSize), Me(t, "font-style", e.fontStyle), Me(t, "font-variant", e.fontVariant === void 0 ? JV(n) : e.fontVariant), Me(t, "font-weight", e.fontWeight);
}
function JV(t) {
  return t && (AF(t) || Zn(t)) ? "tabular-nums" : void 0;
}
const QV = /* @__PURE__ */ new Set([
  // global keywords
  "inherit",
  "initial",
  "revert",
  "unset",
  // absolute keywords
  "xx-small",
  "x-small",
  "small",
  "medium",
  "large",
  "x-large",
  "xx-large",
  "xxx-large",
  // relative keywords
  "larger",
  "smaller"
]);
function eH(t) {
  return t == null || typeof t == "number" ? [void 0, t] : typeof t != "string" ? [t, void 0] : (t = t.trim().toLowerCase(), QV.has(t) || /^[+-]?\d*\.?\d+(e[+-]?\d+)?(\w*|%)$/.test(t) ? [void 0, t] : [t, void 0]);
}
function tH(t, e, n) {
  const r = [];
  let i, s = 0;
  for (const [o, a, l] of nH(t)) {
    if (i === void 0 && (i = o), s > i && n(t, i, a) > e && (r.push(t.slice(i, s) + (t[s - 1] === LC ? "-" : "")), i = o), l) {
      r.push(t.slice(i, a)), i = void 0;
      continue;
    }
    s = a;
  }
  return r;
}
function* nH(t) {
  let e = 0, n = 0;
  const r = t.length;
  for (; n < r; ) {
    let i = 1;
    switch (t[n]) {
      case LC:
      case "-":
        ++n, yield [e, n, !1], e = n;
        break;
      case " ":
        for (yield [e, n, !1]; t[++n] === " "; ) ;
        e = n;
        break;
      case "\r":
        t[n + 1] === `
` && ++i;
      case `
`:
        yield [e, n, !0], n += i, e = n;
        break;
      default:
        ++n;
        break;
    }
  }
  yield [e, n, !0];
}
const c2 = {
  a: 56,
  b: 63,
  c: 57,
  d: 63,
  e: 58,
  f: 37,
  g: 62,
  h: 60,
  i: 26,
  j: 26,
  k: 55,
  l: 26,
  m: 88,
  n: 60,
  o: 60,
  p: 62,
  q: 62,
  r: 39,
  s: 54,
  t: 38,
  u: 60,
  v: 55,
  w: 79,
  x: 54,
  y: 55,
  z: 55,
  A: 69,
  B: 67,
  C: 73,
  D: 74,
  E: 61,
  F: 58,
  G: 76,
  H: 75,
  I: 28,
  J: 55,
  K: 67,
  L: 58,
  M: 89,
  N: 75,
  O: 78,
  P: 65,
  Q: 78,
  R: 67,
  S: 65,
  T: 65,
  U: 75,
  V: 69,
  W: 98,
  X: 69,
  Y: 67,
  Z: 67,
  0: 64,
  1: 48,
  2: 62,
  3: 64,
  4: 66,
  5: 63,
  6: 65,
  7: 58,
  8: 65,
  9: 65,
  " ": 29,
  "!": 32,
  '"': 49,
  "'": 31,
  "(": 39,
  ")": 39,
  ",": 31,
  "-": 48,
  ".": 31,
  "/": 32,
  ":": 31,
  ";": 31,
  "?": 52,
  "‘": 31,
  "’": 31,
  "“": 47,
  "”": 47,
  "…": 82
};
function I1(t, e = 0, n = t.length) {
  var i;
  let r = 0;
  for (let s = e; s < n; s = ja(t, s))
    r += (i = c2[t[s]]) != null ? i : VC(t, s) ? 120 : c2.e;
  return r;
}
function R1(t, e = 0, n = t.length) {
  let r = 0;
  for (let i = e; i < n; i = ja(t, i))
    r += VC(t, i) ? 126 : 63;
  return r;
}
function BC({ monospace: t, lineWidth: e, textOverflow: n }) {
  if (n != null || e == 1 / 0) return (s) => s.split(/\r\n?|\n/g);
  const r = t ? R1 : I1, i = e * 100;
  return (s) => tH(s, i, r);
}
function FC({ monospace: t, lineWidth: e, textOverflow: n }) {
  if (n == null || e == 1 / 0) return (s) => s;
  const r = t ? R1 : I1, i = e * 100;
  switch (n) {
    case "clip-start":
      return (s) => f2(s, i, r, "");
    case "clip-end":
      return (s) => u2(s, i, r, "");
    case "ellipsis-start":
      return (s) => f2(s, i, r, Qo);
    case "ellipsis-middle":
      return (s) => rH(s, i, r, Qo);
    case "ellipsis-end":
      return (s) => u2(s, i, r, Qo);
  }
}
const Qo = "…";
function Sa(t, e, n, r) {
  const i = [];
  let s = 0;
  for (let o = 0, a = 0, l = t.length; o < l; o = a) {
    a = ja(t, o);
    const c = n(t, o, a);
    if (s + c > e) {
      for (s += r; s > e && o > 0; ) a = o, o = i.pop(), s -= n(t, o, a);
      return [o, e - s];
    }
    s += c, i.push(o);
  }
  return [-1, 0];
}
function u2(t, e, n, r) {
  t = t.trim();
  const i = n(r), [s] = Sa(t, e, n, i);
  return s < 0 ? t : t.slice(0, s).trimEnd() + r;
}
function rH(t, e, n, r) {
  t = t.trim();
  const i = n(t);
  if (i <= e) return t;
  const s = n(r) / 2, [o, a] = Sa(t, e / 2, n, s), [l] = Sa(t, i - e / 2 - a + s, n, -s);
  return l < 0 ? r : t.slice(0, o).trimEnd() + r + t.slice(ja(t, l)).trimStart();
}
function f2(t, e, n, r) {
  t = t.trim();
  const i = n(t);
  if (i <= e) return t;
  const s = n(r), [o] = Sa(t, i - e + s, n, -s);
  return o < 0 ? r : r + t.slice(ja(t, o)).trimStart();
}
const c0 = /[\p{Combining_Mark}\p{Emoji_Modifier}]+/uy, h2 = /\p{Extended_Pictographic}/uy;
function ja(t, e) {
  return e += iH(t, e) ? 2 : 1, oH(t, e) && (e = c0.lastIndex), sH(t, e) ? ja(t, e + 1) : e;
}
function zC(t, e) {
  return t.charCodeAt(e) < 128;
}
function iH(t, e) {
  const n = t.charCodeAt(e);
  if (n >= 55296 && n < 56320) {
    const r = t.charCodeAt(e + 1);
    return r >= 56320 && r < 57344;
  }
  return !1;
}
function sH(t, e) {
  return t.charCodeAt(e) === 8205;
}
function oH(t, e) {
  return zC(t, e) ? !1 : (c0.lastIndex = e, c0.test(t));
}
function VC(t, e) {
  return zC(t, e) ? !1 : (h2.lastIndex = e, h2.test(t));
}
const aH = {
  ariaLabel: "vector",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinejoin: "round",
  strokeLinecap: "round"
}, HC = 3.5, lH = HC * 5, YC = {
  draw(t, e, n) {
    const r = e * n / lH;
    t.moveTo(0, 0), t.lineTo(0, -e), t.moveTo(-r, r - e), t.lineTo(0, -e), t.lineTo(r, r - e);
  }
}, cH = {
  draw(t, e, n) {
    t.moveTo(-n, 0), t.lineTo(0, -e), t.lineTo(n, 0);
  }
}, uH = /* @__PURE__ */ new Map([
  ["arrow", YC],
  ["spike", cH]
]);
function fH(t) {
  return t && typeof t.draw == "function";
}
function hH(t) {
  if (fH(t)) return t;
  const e = uH.get(`${t}`.toLowerCase());
  if (e) return e;
  throw new Error(`invalid shape: ${t}`);
}
class WC extends br {
  constructor(e, n = {}) {
    const { x: r, y: i, r: s = HC, length: o, rotate: a, shape: l = YC, anchor: c = "middle", frameAnchor: u } = n, [h, f] = _n(o, 12), [d, p] = _n(a, 0);
    super(
      e,
      {
        x: { value: r, scale: "x", optional: !0 },
        y: { value: i, scale: "y", optional: !0 },
        length: { value: h, scale: "length", optional: !0 },
        rotate: { value: d, optional: !0 }
      },
      n,
      aH
    ), this.r = +s, this.length = f, this.rotate = p, this.shape = hH(l), this.anchor = yr(c, "anchor", ["start", "middle", "end"]), this.frameAnchor = w1(u);
  }
  render(e, n, r, i, s) {
    const { x: o, y: a } = n, { x: l, y: c, length: u, rotate: h } = r, { length: f, rotate: d, anchor: p, shape: m, r: v } = this, [g, y] = np(this, i);
    return qt("svg:g", s).call(Ms, this, i, s).call($s, this, { x: l && o, y: c && a }).call(
      (x) => x.selectAll().data(e).enter().append("path").call(Cs, this).attr(
        "transform",
        PC`translate(${l ? (b) => l[b] : g},${c ? (b) => c[b] : y})${h ? (b) => ` rotate(${h[b]})` : d ? ` rotate(${d})` : ""}${p === "start" ? "" : p === "end" ? u ? (b) => ` translate(0,${u[b]})` : ` translate(0,${f})` : u ? (b) => ` translate(0,${u[b] / 2})` : ` translate(0,${f / 2})`}`
      ).attr(
        "d",
        u ? (b) => {
          const w = Eg();
          return m.draw(w, u[b], v), w;
        } : (() => {
          const b = Eg();
          return m.draw(b, f, v), b;
        })()
      ).call(Wa, this, r)
    ).node();
  }
}
function dH(t, e = {}) {
  const { x: n = nr, ...r } = e;
  return new WC(t, { ...r, x: n });
}
function pH(t, e = {}) {
  const { y: n = nr, ...r } = e;
  return new WC(t, { ...r, y: n });
}
function As(t, e) {
  return arguments.length < 2 && !Mo(t) && (e = t, t = null), e === void 0 && (e = {}), [t, e];
}
function rp({ anchor: t } = {}, e) {
  return t === void 0 ? e[0] : yr(t, "anchor", e);
}
function jC(t) {
  return rp(t, ["left", "right"]);
}
function qC(t) {
  return rp(t, ["right", "left"]);
}
function UC(t) {
  return rp(t, ["bottom", "top"]);
}
function KC(t) {
  return rp(t, ["top", "bottom"]);
}
function GC() {
  const [t, e] = As(...arguments);
  return ZC("y", jC(e), t, e);
}
function mH() {
  const [t, e] = As(...arguments);
  return ZC("fy", qC(e), t, e);
}
function XC() {
  const [t, e] = As(...arguments);
  return JC("x", UC(e), t, e);
}
function gH() {
  const [t, e] = As(...arguments);
  return JC("fx", KC(e), t, e);
}
function ZC(t, e, n, {
  color: r = "currentColor",
  opacity: i = 1,
  stroke: s = r,
  strokeOpacity: o = i,
  strokeWidth: a = 1,
  fill: l = r,
  fillOpacity: c = i,
  textAnchor: u,
  textStroke: h,
  textStrokeOpacity: f,
  textStrokeWidth: d,
  tickSize: p = t === "y" ? 6 : 0,
  tickPadding: m,
  tickRotate: v,
  x: g,
  margin: y,
  marginTop: x = y === void 0 ? 20 : y,
  marginRight: b = y === void 0 ? e === "right" ? 40 : 0 : y,
  marginBottom: w = y === void 0 ? 20 : y,
  marginLeft: k = y === void 0 ? e === "left" ? 40 : 0 : y,
  label: _,
  labelAnchor: C,
  labelArrow: E,
  labelOffset: L,
  ...M
}) {
  return p = at(p), m = at(m), v = at(v), C !== void 0 && (C = yr(C, "labelAnchor", ["center", "top", "bottom"])), E = o8(E), gC(
    p && !cn(s) ? vH(t, e, n, {
      stroke: s,
      strokeOpacity: o,
      strokeWidth: a,
      tickSize: p,
      tickPadding: m,
      tickRotate: v,
      x: g,
      ...M
    }) : null,
    cn(l) ? null : bH(t, e, n, {
      fill: l,
      fillOpacity: c,
      stroke: h,
      strokeOpacity: f,
      strokeWidth: d,
      textAnchor: u,
      tickSize: p,
      tickPadding: m,
      tickRotate: v,
      x: g,
      marginTop: x,
      marginRight: b,
      marginBottom: w,
      marginLeft: k,
      ...M
    }),
    !cn(l) && _ !== null ? IC(
      [],
      n8({ fill: l, fillOpacity: c, ...M }, function(O, N, R, $, F) {
        const U = $[t], { marginTop: ee, marginRight: ie, marginBottom: z, marginLeft: te } = t === "y" && F.inset || F, I = C != null ? C : U.bandwidth ? "center" : "top", X = L != null ? L : (e === "right" ? ie : te) - 3;
        return I === "center" ? (this.textAnchor = void 0, this.lineAnchor = e === "right" ? "bottom" : "top", this.frameAnchor = e, this.rotate = -90) : (this.textAnchor = e === "right" ? "end" : "start", this.lineAnchor = I, this.frameAnchor = `${I}-${e}`, this.rotate = 0), this.dy = I === "top" ? 3 - ee : I === "bottom" ? z - 3 : 0, this.dx = e === "right" ? X : -X, this.ariaLabel = `${t}-axis label`, {
          facets: [[0]],
          channels: { text: { value: [s8(t, U, { anchor: e, label: _, labelAnchor: I, labelArrow: E })] } }
        };
      })
    ) : null
  );
}
function JC(t, e, n, {
  color: r = "currentColor",
  opacity: i = 1,
  stroke: s = r,
  strokeOpacity: o = i,
  strokeWidth: a = 1,
  fill: l = r,
  fillOpacity: c = i,
  textAnchor: u,
  textStroke: h,
  textStrokeOpacity: f,
  textStrokeWidth: d,
  tickSize: p = t === "x" ? 6 : 0,
  tickPadding: m,
  tickRotate: v,
  y: g,
  margin: y,
  marginTop: x = y === void 0 ? e === "top" ? 30 : 0 : y,
  marginRight: b = y === void 0 ? 20 : y,
  marginBottom: w = y === void 0 ? e === "bottom" ? 30 : 0 : y,
  marginLeft: k = y === void 0 ? 20 : y,
  label: _,
  labelAnchor: C,
  labelArrow: E,
  labelOffset: L,
  ...M
}) {
  return p = at(p), m = at(m), v = at(v), C !== void 0 && (C = yr(C, "labelAnchor", ["center", "left", "right"])), E = o8(E), gC(
    p && !cn(s) ? yH(t, e, n, {
      stroke: s,
      strokeOpacity: o,
      strokeWidth: a,
      tickSize: p,
      tickPadding: m,
      tickRotate: v,
      y: g,
      ...M
    }) : null,
    cn(l) ? null : xH(t, e, n, {
      fill: l,
      fillOpacity: c,
      stroke: h,
      strokeOpacity: f,
      strokeWidth: d,
      textAnchor: u,
      tickSize: p,
      tickPadding: m,
      tickRotate: v,
      y: g,
      marginTop: x,
      marginRight: b,
      marginBottom: w,
      marginLeft: k,
      ...M
    }),
    !cn(l) && _ !== null ? IC(
      [],
      n8({ fill: l, fillOpacity: c, ...M }, function(O, N, R, $, F) {
        const U = $[t], { marginTop: ee, marginRight: ie, marginBottom: z, marginLeft: te } = t === "x" && F.inset || F, I = C != null ? C : U.bandwidth ? "center" : "right", X = L != null ? L : (e === "top" ? ee : z) - 3;
        return I === "center" ? (this.frameAnchor = e, this.textAnchor = void 0) : (this.frameAnchor = `${e}-${I}`, this.textAnchor = I === "right" ? "end" : "start"), this.lineAnchor = e, this.dy = e === "top" ? -X : X, this.dx = I === "right" ? ie - 3 : I === "left" ? 3 - te : 0, this.ariaLabel = `${t}-axis label`, {
          facets: [[0]],
          channels: { text: { value: [s8(t, U, { anchor: e, label: _, labelAnchor: I, labelArrow: E })] } }
        };
      })
    ) : null
  );
}
function vH(t, e, n, {
  strokeWidth: r = 1,
  strokeLinecap: i = null,
  strokeLinejoin: s = null,
  facetAnchor: o = e + (t === "y" ? "-empty" : ""),
  frameAnchor: a = e,
  tickSize: l,
  inset: c = 0,
  insetLeft: u = c,
  insetRight: h = c,
  dx: f = 0,
  y: d = t === "y" ? void 0 : null,
  ...p
}) {
  return qa(
    pH,
    t,
    n,
    {
      ariaLabel: `${t}-axis tick`,
      ariaHidden: !0
    },
    {
      strokeWidth: r,
      strokeLinecap: i,
      strokeLinejoin: s,
      facetAnchor: o,
      frameAnchor: a,
      y: d,
      ...p,
      dx: e === "left" ? +f - Sn + +u : +f + Sn - h,
      anchor: "start",
      length: l,
      shape: e === "left" ? AH : DH
    }
  );
}
function yH(t, e, n, {
  strokeWidth: r = 1,
  strokeLinecap: i = null,
  strokeLinejoin: s = null,
  facetAnchor: o = e + (t === "x" ? "-empty" : ""),
  frameAnchor: a = e,
  tickSize: l,
  inset: c = 0,
  insetTop: u = c,
  insetBottom: h = c,
  dy: f = 0,
  x: d = t === "x" ? void 0 : null,
  ...p
}) {
  return qa(
    dH,
    t,
    n,
    {
      ariaLabel: `${t}-axis tick`,
      ariaHidden: !0
    },
    {
      strokeWidth: r,
      strokeLinejoin: s,
      strokeLinecap: i,
      facetAnchor: o,
      frameAnchor: a,
      x: d,
      ...p,
      dy: e === "bottom" ? +f - Sn - h : +f + Sn + +u,
      anchor: "start",
      length: l,
      shape: e === "bottom" ? CH : $H
    }
  );
}
function bH(t, e, n, {
  facetAnchor: r = e + (t === "y" ? "-empty" : ""),
  frameAnchor: i = e,
  tickSize: s,
  tickRotate: o = 0,
  tickPadding: a = Math.max(3, 9 - s) + (Math.abs(o) > 60 ? 4 * Math.cos(o * wC) : 0),
  text: l,
  textAnchor: c = Math.abs(o) > 60 ? "middle" : e === "left" ? "end" : "start",
  lineAnchor: u = o > 60 ? "top" : o < -60 ? "bottom" : "middle",
  fontVariant: h,
  inset: f = 0,
  insetLeft: d = f,
  insetRight: p = f,
  dx: m = 0,
  y: v = t === "y" ? void 0 : null,
  ...g
}) {
  return qa(
    ZV,
    t,
    n,
    { ariaLabel: `${t}-axis tick label` },
    {
      facetAnchor: r,
      frameAnchor: i,
      text: l,
      textAnchor: c,
      lineAnchor: u,
      fontVariant: h,
      rotate: o,
      y: v,
      ...g,
      dx: e === "left" ? +m - s - a + +d : +m + +s + +a - p
    },
    function(y, x, b, w, k) {
      h === void 0 && (this.fontVariant = i8(y)), l === void 0 && (k.text = r8(y, x, b, w, e));
    }
  );
}
function xH(t, e, n, {
  facetAnchor: r = e + (t === "x" ? "-empty" : ""),
  frameAnchor: i = e,
  tickSize: s,
  tickRotate: o = 0,
  tickPadding: a = Math.max(3, 9 - s) + (Math.abs(o) >= 10 ? 4 * Math.cos(o * wC) : 0),
  text: l,
  textAnchor: c = Math.abs(o) >= 10 ? o < 0 ^ e === "bottom" ? "start" : "end" : "middle",
  lineAnchor: u = Math.abs(o) >= 10 ? "middle" : e === "bottom" ? "top" : "bottom",
  fontVariant: h,
  inset: f = 0,
  insetTop: d = f,
  insetBottom: p = f,
  dy: m = 0,
  x: v = t === "x" ? void 0 : null,
  ...g
}) {
  return qa(
    XV,
    t,
    n,
    { ariaLabel: `${t}-axis tick label` },
    {
      facetAnchor: r,
      frameAnchor: i,
      text: l === void 0 ? null : l,
      textAnchor: c,
      lineAnchor: u,
      fontVariant: h,
      rotate: o,
      x: v,
      ...g,
      dy: e === "bottom" ? +m + +s + +a - p : +m - s - a + +d
    },
    function(y, x, b, w, k) {
      h === void 0 && (this.fontVariant = i8(y)), l === void 0 && (k.text = r8(y, x, b, w, e));
    }
  );
}
function wH() {
  const [t, e] = As(...arguments);
  return QC("y", jC(e), t, e);
}
function kH() {
  const [t, e] = As(...arguments);
  return QC("fy", qC(e), t, e);
}
function _H() {
  const [t, e] = As(...arguments);
  return e8("x", UC(e), t, e);
}
function SH() {
  const [t, e] = As(...arguments);
  return e8("fx", KC(e), t, e);
}
function QC(t, e, n, {
  y: r = t === "y" ? void 0 : null,
  x: i = null,
  x1: s = e === "left" ? i : null,
  x2: o = e === "right" ? i : null,
  ...a
}) {
  return qa(L1, t, n, { ariaLabel: `${t}-grid`, ariaHidden: !0 }, { y: r, x1: s, x2: o, ...t8(a) });
}
function e8(t, e, n, {
  x: r = t === "x" ? void 0 : null,
  y: i = null,
  y1: s = e === "top" ? i : null,
  y2: o = e === "bottom" ? i : null,
  ...a
}) {
  return qa(UV, t, n, { ariaLabel: `${t}-grid`, ariaHidden: !0 }, { x: r, y1: s, y2: o, ...t8(a) });
}
function t8({
  color: t = "currentColor",
  opacity: e = 0.1,
  stroke: n = t,
  strokeOpacity: r = e,
  strokeWidth: i = 1,
  ...s
}) {
  return { stroke: n, strokeOpacity: r, strokeWidth: i, ...s };
}
function n8({
  fill: t,
  fillOpacity: e,
  fontFamily: n,
  fontSize: r,
  fontStyle: i,
  fontVariant: s,
  fontWeight: o,
  monospace: a,
  pointerEvents: l,
  shapeRendering: c,
  clip: u = !1
}, h) {
  return [, t] = ho(t), [, e] = _n(e), {
    facet: "super",
    x: null,
    y: null,
    fill: t,
    fillOpacity: e,
    fontFamily: n,
    fontSize: r,
    fontStyle: i,
    fontVariant: s,
    fontWeight: o,
    monospace: a,
    pointerEvents: l,
    shapeRendering: c,
    clip: u,
    initializer: h
  };
}
function qa(t, e, n, r, i, s) {
  let o;
  function a(u, h, f, d, p, m) {
    var C, E, L;
    const v = u == null && (e === "fx" || e === "fy"), { [e]: g } = d;
    if (!g) throw new Error(`missing scale: ${e}`);
    const y = g.domain();
    let { interval: x, ticks: b, tickFormat: w, tickSpacing: k = e === "x" ? 80 : 35 } = i;
    if (typeof b == "string" && a8(g) && (x = b, b = void 0), b === void 0 && (b = (C = hu(x, g.type)) != null ? C : MH(g, k)), u == null) {
      if (Mo(b))
        u = Tn(b);
      else if (SF(b))
        u = mm(b, ...ns(y));
      else if (g.interval) {
        let M = g.interval;
        if (g.ticks) {
          const [O, N] = ns(y), R = (N - O) / M[cu];
          M = (E = Lx(M, R / b)) != null ? E : M, u = mm(M, O, N);
        } else {
          u = y;
          const O = u.length;
          M = (L = Lx(M, O / b)) != null ? L : M, M !== g.interval && (u = mm(M, ...ns(u)));
        }
        if (M === g.interval) {
          const O = Math.round(u.length / b);
          O > 1 && (u = u.filter((N, R) => R % O === 0));
        }
      } else g.ticks ? u = g.ticks(b) : u = y;
      if (!g.ticks && u.length && u !== y) {
        const M = new $d(y);
        u = u.filter((O) => M.has(O)), u.length || rs(`Warning: the ${e}-axis ticks appear to not align with the scale domain, resulting in no ticks. Try different ticks?`);
      }
      e === "y" || e === "x" ? h = [_s(u)] : o[e] = { scale: e, value: nr };
    }
    s == null || s.call(this, g, u, b, w, o);
    const _ = Object.fromEntries(
      Object.entries(o).map(([M, O]) => [M, { ...O, value: Wn(u, O.value) }])
    );
    return v && (h = m.filterFacets(u, _)), { data: u, facets: h, channels: _ };
  }
  const l = Lh(i).initializer, c = t(n, Lh({ ...i, initializer: a }, l));
  return n == null ? (o = c.channels, c.channels = {}) : o = {}, r !== void 0 && Object.assign(c, r), c.clip === void 0 && (c.clip = !1), c;
}
function MH(t, e) {
  const [n, r] = ns(t.range());
  return (r - n) / e;
}
function r8(t, e, n, r, i) {
  return { value: B1(t, e, n, r, i) };
}
function B1(t, e, n, r, i) {
  var s;
  return typeof r == "function" && !(t.type === "log" && t.tickFormat) ? r : r === void 0 && e && Zn(e) ? (s = sF(t.type, e, i)) != null ? s : _a : t.tickFormat ? t.tickFormat(typeof n == "number" ? n : null, r) : r === void 0 ? _a : typeof r == "string" ? (Zn(t.domain()) ? lu : Ha)(r) : uu(r);
}
function mm(t, e, n) {
  return t.range(e, t.offset(t.floor(n)));
}
const CH = {
  draw(t, e) {
    t.moveTo(0, 0), t.lineTo(0, e);
  }
}, $H = {
  draw(t, e) {
    t.moveTo(0, 0), t.lineTo(0, -e);
  }
}, AH = {
  draw(t, e) {
    t.moveTo(0, 0), t.lineTo(-e, 0);
  }
}, DH = {
  draw(t, e) {
    t.moveTo(0, 0), t.lineTo(e, 0);
  }
};
function i8(t) {
  return t.bandwidth && !t.interval ? void 0 : "tabular-nums";
}
function s8(t, e, { anchor: n, label: r = e.label, labelAnchor: i, labelArrow: s } = {}) {
  if (!(r == null || r.inferred && a8(e) && /^(date|time|year)$/i.test(r))) {
    if (r = String(r), s === "auto" && (s = (!e.bandwidth || e.interval) && !/[↑↓→←]/.test(r)), !s) return r;
    if (s === !0) {
      const o = zz(e);
      o && (s = /x$/.test(t) || i === "center" ? /x$/.test(t) === o < 0 ? "left" : "right" : o < 0 ? "up" : "down");
    }
    switch (s) {
      case "left":
        return `← ${r}`;
      case "right":
        return `${r} →`;
      case "up":
        return n === "right" ? `${r} ↑` : `↑ ${r}`;
      case "down":
        return n === "right" ? `${r} ↓` : `↓ ${r}`;
    }
    return r;
  }
}
function o8(t = "auto") {
  return cn(t) ? !1 : typeof t == "boolean" ? t : yr(t, "labelArrow", ["auto", "up", "right", "down", "left"]);
}
function a8(t) {
  return Zn(t.domain());
}
function d2(t, e) {
  if (e == null) return e;
  const n = t(e);
  if (!n) throw new Error(`scale not found: ${e}`);
  return n;
}
function TH(t, { opacity: e, ...n } = {}) {
  if (!Co(t) && !fC(t))
    throw new Error(`swatches legend requires ordinal or threshold color scale (not ${t.type})`);
  return l8(
    t,
    n,
    (r, i, s, o) => r.append("svg").attr("width", s).attr("height", o).attr("fill", i.scale).attr("fill-opacity", _n(e)[1]).append("rect").attr("width", "100%").attr("height", "100%")
  );
}
function OH(t, {
  fill: e = ((c) => (c = t.hint) == null ? void 0 : c.fill)() !== void 0 ? t.hint.fill : "none",
  fillOpacity: n = 1,
  stroke: r = ((u) => (u = t.hint) == null ? void 0 : u.stroke)() !== void 0 ? t.hint.stroke : cn(e) ? "currentColor" : "none",
  strokeOpacity: i = 1,
  strokeWidth: s = 1.5,
  r: o = 4.5,
  ...a
} = {}, l) {
  const [h, f] = ho(e), [d, p] = ho(r), m = d2(l, h), v = d2(l, d), g = o * o * Math.PI;
  return n = _n(n)[1], i = _n(i)[1], s = _n(s)[1], l8(
    t,
    a,
    (y, x, b, w) => y.append("svg").attr("viewBox", "-8 -8 16 16").attr("width", b).attr("height", w).attr("fill", h === "color" ? (k) => m.scale(k) : f).attr("fill-opacity", n).attr("stroke", d === "color" ? (k) => v.scale(k) : p).attr("stroke-opacity", i).attr("stroke-width", s).append("path").attr("d", (k) => {
      const _ = Eg();
      return t.scale(k).draw(_, g), _;
    })
  );
}
function l8(t, e = {}, n) {
  let {
    columns: r,
    tickFormat: i,
    fontVariant: s = xC(t),
    // TODO label,
    swatchSize: o = 15,
    swatchWidth: a = o,
    swatchHeight: l = o,
    marginLeft: c = 0,
    className: u,
    style: h,
    width: f
  } = e;
  const d = A1(e);
  u = D1(u), i = B1(t.scale, t.domain, void 0, i);
  const p = qt("div", d).attr(
    "class",
    `${u}-swatches ${u}-swatches-${r != null ? "columns" : "wrap"}`
  );
  let m;
  return r != null ? (m = `:where(.${u}-swatches-columns .${u}-swatch) {
  display: flex;
  align-items: center;
  break-inside: avoid;
  padding-bottom: 1px;
}
:where(.${u}-swatches-columns .${u}-swatch::before) {
  flex-shrink: 0;
}
:where(.${u}-swatches-columns .${u}-swatch-label) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}`, p.style("columns", r).selectAll().data(t.domain).enter().append("div").attr("class", `${u}-swatch`).call(n, t, a, l).call(
    (v) => v.append("div").attr("class", `${u}-swatch-label`).attr("title", i).text(i)
  )) : (m = `:where(.${u}-swatches-wrap) {
  display: flex;
  align-items: center;
  min-height: 33px;
  flex-wrap: wrap;
}
:where(.${u}-swatches-wrap .${u}-swatch) {
  display: inline-flex;
  align-items: center;
  margin-right: 1em;
}`, p.selectAll().data(t.domain).enter().append("span").attr("class", `${u}-swatch`).call(n, t, a, l).append(function() {
    return this.ownerDocument.createTextNode(i.apply(this, arguments));
  })), p.call(
    (v) => v.insert("style", "*").text(
      `:where(.${u}-swatches) {
  font-family: system-ui, sans-serif;
  font-size: 10px;
  margin-bottom: 0.5em;
}
:where(.${u}-swatch > svg) {
  margin-right: 0.5em;
  overflow: visible;
}
${m}`
    )
  ).style("margin-left", c ? `${+c}px` : null).style("width", f === void 0 ? null : `${+f}px`).style("font-variant", $t(s, "normal")).call(T1, h).node();
}
const u0 = /* @__PURE__ */ new Map([
  ["symbol", OH],
  ["color", u8],
  ["opacity", PH]
]);
function EH(t, e, n = {}) {
  return (r, i) => {
    if (!u0.has(r)) throw new Error(`unknown legend type: ${r}`);
    if (r in t)
      return u0.get(r)(t[r], c8(e, n[r], i), (s) => t[s]);
  };
}
function c8({ className: t, ...e }, { label: n, ticks: r, tickFormat: i } = {}, s) {
  return EF(s, { className: t, ...e }, { label: n, ticks: r, tickFormat: i });
}
function u8(t, { legend: e = !0, ...n }) {
  if (e === !0 && (e = t.type === "ordinal" ? "swatches" : "ramp"), t.domain !== void 0)
    switch (`${e}`.toLowerCase()) {
      case "swatches":
        return TH(t, n);
      case "ramp":
        return RV(t, n);
      default:
        throw new Error(`unknown legend type: ${e}`);
    }
}
function PH({ type: t, interpolate: e, ...n }, { legend: r = !0, color: i = us(0, 0, 0), ...s }) {
  if (!e) throw new Error(`${t} opacity scales are not supported`);
  if (r === !0 && (r = "ramp"), `${r}`.toLowerCase() !== "ramp") throw new Error(`${r} opacity legends are not supported`);
  return u8({ type: t, ...n, interpolate: LH(i) }, { legend: r, ...s });
}
function LH(t) {
  const { r: e, g: n, b: r } = us(t) || us(0, 0, 0);
  return (i) => `rgba(${e},${n},${r},${i})`;
}
function NH(t, e, n) {
  const r = [];
  for (const [i, s] of u0) {
    const o = n[i];
    if (o != null && o.legend && i in t) {
      const a = s(t[i], c8(e, t[i], o), (l) => t[l]);
      a != null && r.push(a);
    }
  }
  return r;
}
const IH = {
  ariaLabel: "frame",
  fill: "none",
  stroke: "currentColor",
  clip: !1
}, RH = {
  ariaLabel: "frame",
  fill: null,
  stroke: "currentColor",
  strokeLinecap: "square",
  clip: !1
};
class BH extends br {
  constructor(e = {}) {
    const {
      anchor: n = null,
      inset: r = 0,
      insetTop: i = r,
      insetRight: s = r,
      insetBottom: o = r,
      insetLeft: a = r,
      rx: l,
      ry: c
    } = e;
    super(Lf, void 0, e, n == null ? IH : RH), this.anchor = LM(n, "anchor", ["top", "right", "bottom", "left"]), this.insetTop = at(i), this.insetRight = at(s), this.insetBottom = at(o), this.insetLeft = at(a), this.rx = at(l), this.ry = at(c);
  }
  render(e, n, r, i, s) {
    const { marginTop: o, marginRight: a, marginBottom: l, marginLeft: c, width: u, height: h } = i, { anchor: f, insetTop: d, insetRight: p, insetBottom: m, insetLeft: v, rx: g, ry: y } = this, x = c + v, b = u - a - p, w = o + d, k = h - l - m;
    return qt(f ? "svg:line" : "svg:rect", s).datum(0).call(Ms, this, i, s).call(Cs, this).call(Wa, this, r).call($s, this, {}).call(
      f === "left" ? (_) => _.attr("x1", x).attr("x2", x).attr("y1", w).attr("y2", k) : f === "right" ? (_) => _.attr("x1", b).attr("x2", b).attr("y1", w).attr("y2", k) : f === "top" ? (_) => _.attr("x1", x).attr("x2", b).attr("y1", w).attr("y2", w) : f === "bottom" ? (_) => _.attr("x1", x).attr("x2", b).attr("y1", k).attr("y2", k) : (_) => _.attr("x", x).attr("y", w).attr("width", b - x).attr("height", k - w).attr("rx", g).attr("ry", y)
    ).node();
  }
}
function FH(t) {
  return new BH(t);
}
const gm = {
  ariaLabel: "tip",
  fill: "var(--plot-background)",
  stroke: "currentColor"
}, zH = /* @__PURE__ */ new Set(["geometry", "href", "src", "ariaLabel", "scales"]);
class VH extends br {
  constructor(e, n = {}) {
    n.tip && (n = { ...n, tip: !1 }), n.title === void 0 && Mo(e) && BM(e) && (n = { ...n, title: nr });
    const {
      x: r,
      y: i,
      x1: s,
      x2: o,
      y1: a,
      y2: l,
      anchor: c,
      preferredAnchor: u = "bottom",
      monospace: h,
      fontFamily: f = h ? "ui-monospace, monospace" : void 0,
      fontSize: d,
      fontStyle: p,
      fontVariant: m,
      fontWeight: v,
      lineHeight: g = 1,
      lineWidth: y = 20,
      frameAnchor: x,
      format: b,
      textAnchor: w = "start",
      textOverflow: k,
      textPadding: _ = 8,
      title: C,
      pointerSize: E = 12,
      pathFilter: L = "drop-shadow(0 3px 4px rgba(0,0,0,0.2))"
    } = n;
    super(
      e,
      {
        x: { value: s != null && o != null ? null : r, scale: "x", optional: !0 },
        // ignore midpoint
        y: { value: a != null && l != null ? null : i, scale: "y", optional: !0 },
        // ignore midpoint
        x1: { value: s, scale: "x", optional: o == null },
        y1: { value: a, scale: "y", optional: l == null },
        x2: { value: o, scale: "x", optional: s == null },
        y2: { value: l, scale: "y", optional: a == null },
        title: { value: C, optional: !0 }
        // filter: defined
      },
      n,
      gm
    ), this.anchor = r0(c, "anchor"), this.preferredAnchor = r0(u, "preferredAnchor"), this.frameAnchor = w1(x), this.textAnchor = $t(w, "middle"), this.textPadding = +_, this.pointerSize = +E, this.pathFilter = Jt(L), this.lineHeight = +g, this.lineWidth = +y, this.textOverflow = NC(k), this.monospace = !!h, this.fontFamily = Jt(f), this.fontSize = at(d), this.fontStyle = Jt(p), this.fontVariant = Jt(m), this.fontWeight = Jt(v);
    for (const M in gm) M in this.channels && (this[M] = gm[M]);
    this.splitLines = BC(this), this.clipLine = FC(this), this.format = typeof b == "string" || typeof b == "function" ? { title: b } : { ...b };
  }
  render(e, n, r, i, s) {
    const o = this, { x: a, y: l, fx: c, fy: u } = n, { ownerSVGElement: h, document: f } = s, { anchor: d, monospace: p, lineHeight: m, lineWidth: v } = this, { textPadding: g, pointerSize: y, pathFilter: x } = this, { marginTop: b, marginLeft: w } = i, { x1: k, y1: _, x2: C, y2: E, x: L = k != null ? k : C, y: M = _ != null ? _ : E } = r, O = c ? c(e.fx) - w : 0, N = u ? u(e.fy) - b : 0, [R, $] = np(this, i), F = yC(r, R), U = bC(r, $), ee = p ? R1 : I1, ie = ee(Qo);
    let z, te;
    "title" in r ? (z = p2.call(this, { title: r.channels.title }, n), te = qH) : (z = p2.call(this, r.channels, n), te = UH);
    const I = qt("svg:g", s).call(Ms, this, i, s).call(RC, this).call($s, this, { x: L && a, y: M && l }).call(
      (ce) => ce.selectAll().data(e).enter().append("g").attr("transform", (he) => `translate(${Math.round(F(he))},${Math.round(U(he))})`).call(Cs, this).call((he) => he.append("path").attr("filter", x)).call(
        (he) => he.append("text").each(function(J) {
          const pe = Xl(this);
          this.setAttribute("fill", "currentColor"), this.setAttribute("fill-opacity", 1), this.setAttribute("stroke", "none");
          const Y = te.call(o, J, e, z, n, r);
          if (typeof Y == "string")
            for (const se of o.splitLines(Y))
              X(pe, { value: o.clipLine(se) });
          else {
            const se = /* @__PURE__ */ new Set();
            for (const ge of Y) {
              const { label: V = "" } = ge;
              V && se.has(V) || (se.add(V), X(pe, ge));
            }
          }
        })
      )
    );
    function X(ce, { label: he, value: J, color: pe, opacity: Y }) {
      he != null || (he = ""), J != null || (J = "");
      const se = pe != null || Y != null;
      let ge, V = v * 100;
      const [Ee] = Sa(he, V, ee, ie);
      if (Ee >= 0)
        he = he.slice(0, Ee).trimEnd() + Qo, ge = J.trim(), J = "";
      else {
        (he || !J && !se) && (J = " " + J);
        const [Ie] = Sa(J, V - ee(he), ee, ie);
        Ie >= 0 && (ge = J.trim(), J = J.slice(0, Ie).trimEnd() + Qo);
      }
      const ke = ce.append("tspan").attr("x", 0).attr("dy", `${m}em`).text("​");
      he && ke.append("tspan").attr("font-weight", "bold").text(he), J && ke.append(() => f.createTextNode(J)), se && ke.append("tspan").text(" ■").attr("fill", pe).attr("fill-opacity", Y).style("user-select", "none"), ge && ke.append("title").text(ge);
    }
    function Q() {
      var J;
      const { width: ce, height: he } = (J = i.facet) != null ? J : i;
      I.selectChildren().each(function(pe) {
        let { x: Y, width: se, height: ge } = this.getBBox();
        se = Math.round(se), ge = Math.round(ge);
        let V = d;
        if (V === void 0) {
          const Ie = F(pe) + O, He = U(pe) + N, st = Ie + se + y + g * 2 < ce, gn = Ie - se - y - g * 2 > 0, ir = He + ge + y + g * 2 < he, Mt = He - ge - y - g * 2 > 0;
          V = st && gn ? ir && Mt ? o.preferredAnchor : Mt ? "bottom" : "top" : ir && Mt ? st ? "left" : "right" : (st || gn) && (ir || Mt) ? `${Mt ? "bottom" : "top"}-${st ? "left" : "right"}` : o.preferredAnchor;
        }
        const Ee = this.firstChild, ke = this.lastChild;
        if (Ee.setAttribute("d", jH(V, y, g, se, ge)), Y) for (const Ie of ke.childNodes) Ie.setAttribute("x", -Y);
        ke.setAttribute("y", `${+YH(V, ke.childNodes.length, m).toFixed(6)}em`), ke.setAttribute("transform", `translate(${WH(V, y, g, se, ge)})`);
      }), I.attr("visibility", null);
    }
    return e.length && (I.attr("visibility", "hidden"), h.isConnected ? Promise.resolve().then(Q) : typeof requestAnimationFrame != "undefined" && requestAnimationFrame(Q)), I.node();
  }
}
function HH(t, { x: e, y: n, ...r } = {}) {
  return r.frameAnchor === void 0 && ([e, n] = y1(e, n)), new VH(t, { ...r, x: e, y: n });
}
function YH(t, e, n) {
  return /^top(?:-|$)/.test(t) ? 0.94 - n : -0.29 - e * n;
}
function WH(t, e, n, r, i) {
  switch (t) {
    case "middle":
      return [-r / 2, i / 2];
    case "top-left":
      return [n, e + n];
    case "top":
      return [-r / 2, e / 2 + n];
    case "top-right":
      return [-r - n, e + n];
    case "right":
      return [-e / 2 - r - n, i / 2];
    case "bottom-left":
      return [n, -e - n];
    case "bottom":
      return [-r / 2, -e / 2 - n];
    case "bottom-right":
      return [-r - n, -e - n];
    case "left":
      return [n + e / 2, i / 2];
  }
}
function jH(t, e, n, r, i) {
  const s = r + n * 2, o = i + n * 2;
  switch (t) {
    case "middle":
      return `M${-s / 2},${-o / 2}h${s}v${o}h${-s}z`;
    case "top-left":
      return `M0,0l${e},${e}h${s - e}v${o}h${-s}z`;
    case "top":
      return `M0,0l${e / 2},${e / 2}h${(s - e) / 2}v${o}h${-s}v${-o}h${(s - e) / 2}z`;
    case "top-right":
      return `M0,0l${-e},${e}h${e - s}v${o}h${s}z`;
    case "right":
      return `M0,0l${-e / 2},${-e / 2}v${e / 2 - o / 2}h${-s}v${o}h${s}v${e / 2 - o / 2}z`;
    case "bottom-left":
      return `M0,0l${e},${-e}h${s - e}v${-o}h${-s}z`;
    case "bottom":
      return `M0,0l${e / 2},${-e / 2}h${(s - e) / 2}v${-o}h${-s}v${o}h${(s - e) / 2}z`;
    case "bottom-right":
      return `M0,0l${-e},${-e}h${e - s}v${-o}h${s}z`;
    case "left":
      return `M0,0l${e / 2},${-e / 2}v${e / 2 - o / 2}h${s}v${o}h${-s}v${e / 2 - o / 2}z`;
  }
}
function p2(t, e) {
  var i, s, o, a;
  const n = {};
  let r = this.format;
  r = m2(r, t, "x"), r = m2(r, t, "y"), this.format = r;
  for (const l in r) {
    const c = r[l];
    if (!(c === null || c === !1))
      if (l === "fx" || l === "fy")
        n[l] = !0;
      else {
        const u = Yx(t, l);
        u && (n[l] = u);
      }
  }
  for (const l in t) {
    if (l in n || l in r || zH.has(l)) continue;
    const c = Yx(t, l);
    c && (n[l] = c);
  }
  this.facet && (e.fx && !("fx" in r) && (n.fx = !0), e.fy && !("fy" in r) && (n.fy = !0));
  for (const l in n) {
    const c = this.format[l];
    if (typeof c == "string") {
      const u = (a = (o = (i = n[l]) == null ? void 0 : i.value) != null ? o : (s = e[l]) == null ? void 0 : s.domain()) != null ? a : [];
      this.format[l] = (Zn(u) ? lu : Ha)(c);
    } else if (c === void 0 || c === !0) {
      const u = e[l];
      this.format[l] = u != null && u.bandwidth ? B1(u, u.domain()) : _a;
    }
  }
  return n;
}
function m2(t, e, n) {
  if (!(n in t)) return t;
  const r = `${n}1`, i = `${n}2`;
  if ((r in t || !(r in e)) && (i in t || !(i in e))) return t;
  const s = Object.entries(t), o = t[n];
  return s.splice(s.findIndex(([a]) => a === n) + 1, 0, [r, o], [i, o]), Object.fromEntries(s);
}
function qH(t, e, { title: n }) {
  return this.format.title(n.value[t], t);
}
function* UH(t, e, n, r, i) {
  for (const s in n) {
    if (s === "fx" || s === "fy") {
      yield {
        label: Nh(r, n, s),
        value: this.format[s](e[s], t)
      };
      continue;
    }
    if (s === "x1" && "x2" in n || s === "y1" && "y2" in n) continue;
    const o = n[s];
    if (s === "x2" && "x1" in n)
      yield {
        label: v2(r, n, "x"),
        value: g2(this.format.x2, n.x1, o, t)
      };
    else if (s === "y2" && "y1" in n)
      yield {
        label: v2(r, n, "y"),
        value: g2(this.format.y2, n.y1, o, t)
      };
    else {
      const a = o.value[t], l = o.scale;
      if (!hs(a) && l == null) continue;
      yield {
        label: Nh(r, n, s),
        value: this.format[s](a, t),
        color: l === "color" ? i[s][t] : null,
        opacity: l === "opacity" ? i[s][t] : null
      };
    }
  }
}
function g2(t, e, n, r) {
  var i;
  return (i = n.hint) != null && i.length ? `${t(n.value[r] - e.value[r], r)}` : `${t(e.value[r], r)}–${t(n.value[r], r)}`;
}
function v2(t, e, n) {
  const r = Nh(t, e, `${n}1`, n), i = Nh(t, e, `${n}2`, n);
  return r === i ? r : `${r}–${i}`;
}
function Nh(t, e, n, r = n) {
  var o, a, l;
  const i = e[n], s = t[(o = i == null ? void 0 : i.scale) != null ? o : n];
  return String((l = (a = s == null ? void 0 : s.label) != null ? a : i == null ? void 0 : i.label) != null ? l : r);
}
function f8(t = {}) {
  var ie, z, te;
  const { facet: e, style: n, title: r, subtitle: i, caption: s, ariaLabel: o, ariaDescription: a } = t, l = D1(t.className), c = t.marks === void 0 ? [] : b2(t.marks);
  c.push(...eY(c));
  const u = JH(e, t), h = /* @__PURE__ */ new Map();
  for (const I of c) {
    const X = x2(I, u, t);
    X && h.set(I, X);
  }
  const f = /* @__PURE__ */ new Map();
  u && dl(f, [u], t), dl(f, h, t);
  const d = b2(tY(c, f, t));
  for (const I of d) {
    const X = x2(I, u, t);
    X && h.set(I, X);
  }
  c.unshift(...d);
  let p = Kz(f, t);
  if (p !== void 0) {
    const I = u ? hm(p, u) : void 0;
    for (const Q of c) {
      if (Q.facet === null || Q.facet === "super") continue;
      const ce = h.get(Q);
      ce !== void 0 && (ce.facetsIndex = Q.fx != null || Q.fy != null ? hm(p, ce) : I);
    }
    const X = /* @__PURE__ */ new Set();
    for (const { facetsIndex: Q } of h.values())
      Q == null || Q.forEach((ce, he) => {
        (ce == null ? void 0 : ce.length) > 0 && X.add(he);
      });
    p.forEach(
      0 < X.size && X.size < p.length ? (Q, ce) => Q.empty = !X.has(ce) : (Q) => Q.empty = !1
    );
    for (const Q of c)
      if (Q.facet === "exclude") {
        const ce = h.get(Q);
        ce !== void 0 && (ce.facetsIndex = Zz(ce.facetsIndex));
      }
  }
  for (const I of ct.keys())
    t0(t[I]) && I !== "fx" && I !== "fy" && f.set(I, []);
  const m = /* @__PURE__ */ new Map();
  for (const I of c) {
    if (m.has(I)) throw new Error("duplicate mark; each mark must be unique");
    const { facetsIndex: X, channels: Q } = (ie = h.get(I)) != null ? ie : {}, { data: ce, facets: he, channels: J } = I.initialize(X, Q, t);
    F1(J, t), m.set(I, { data: ce, facets: he, channels: J });
  }
  const v = a0(dl(f, m, t), t), g = PV(v, c, t);
  Bz(v, g);
  const y = Xx(v), { fx: x, fy: b } = y, w = x || b ? lC(v, g) : g, k = x || b ? lY(y, g) : g, _ = A1(t), C = _.document, E = Dd("svg").call(C.documentElement);
  let L = E;
  _.ownerSVGElement = E, _.className = l, _.projection = oV(t, w), _.filterFacets = (I, X) => hm(p, { channels: X, groups: $1(I, X) }), _.getMarkState = (I) => {
    const X = m.get(I), Q = h.get(I);
    return { ...X, channels: { ...X.channels, ...Q == null ? void 0 : Q.channels } };
  }, _.dispatchValue = (I) => {
    L.value !== I && (L.value = I, L.dispatchEvent(new Event("input", { bubbles: !0 })));
  };
  const M = /* @__PURE__ */ new Set();
  for (const [I, X] of m)
    if (I.initializer != null) {
      const Q = I.facet === "super" ? k : w, ce = I.initializer(X.data, X.facets, X.channels, y, Q, _);
      if (ce.data !== void 0 && (X.data = ce.data), ce.facets !== void 0 && (X.facets = ce.facets), ce.channels !== void 0) {
        const { fx: he, fy: J, ...pe } = ce.channels;
        ZH(pe), Object.assign(X.channels, pe);
        for (const Y of Object.values(pe)) {
          const { scale: se } = Y;
          se != null && !LF(ct.get(se)) && (h8(Y, t), M.add(se));
        }
        (he != null || J != null) && h.set(I, !0);
      }
    }
  if (M.size) {
    const I = /* @__PURE__ */ new Map();
    dl(I, m, t, (he) => M.has(he)), dl(f, m, t, (he) => M.has(he));
    const X = aY(a0(I, t), v), { scales: Q, ...ce } = Xx(X);
    Object.assign(v, X), Object.assign(y, ce), Object.assign(y.scales, Q);
  }
  let O, N;
  p !== void 0 && (O = { x: x == null ? void 0 : x.domain(), y: b == null ? void 0 : b.domain() }, p = Gz(p, O), N = Xz(x, b, g));
  for (const [I, X] of m)
    X.values = I.scale(X.channels, y, _);
  const { width: R, height: $ } = g;
  Xl(E).attr("class", l).attr("fill", "currentColor").attr("font-family", "system-ui, sans-serif").attr("font-size", 10).attr("text-anchor", "middle").attr("width", R).attr("height", $).attr("viewBox", `0 0 ${R} ${$}`).attr("aria-label", o).attr("aria-description", a).call(
    (I) => (
      // Warning: if you edit this, change defaultClassName.
      I.append("style").text(
        `:where(.${l}) {
  --plot-background: white;
  display: block;
  height: auto;
  height: intrinsic;
  max-width: 100%;
}
:where(.${l} text),
:where(.${l} tspan) {
  white-space: pre;
}`
      )
    )
  ).call(T1, n);
  for (const I of c) {
    const { channels: X, values: Q, facets: ce } = m.get(I);
    if (p === void 0 || I.facet === "super") {
      let he = null;
      if (ce && (he = ce[0], he = I.filter(he, X, Q), he.length === 0))
        continue;
      const J = I.render(he, y, Q, k, _);
      if (J == null) continue;
      E.appendChild(J);
    } else {
      let he;
      for (const J of p) {
        if (!((te = (z = I.facetAnchor) == null ? void 0 : z.call(I, p, O, J)) != null ? te : !J.empty)) continue;
        let pe = null;
        if (ce) {
          const se = h.has(I);
          if (pe = ce[se ? J.i : 0], pe = I.filter(pe, X, Q), pe.length === 0) continue;
          !se && pe === ce[0] && (pe = yF(pe)), pe.fx = J.x, pe.fy = J.y, pe.fi = J.i;
        }
        const Y = I.render(pe, y, Q, w, _);
        if (Y != null) {
          (he != null ? he : he = Xl(E).append("g")).append(() => Y).datum(J);
          for (const se of ["aria-label", "aria-description", "aria-hidden", "transform"])
            Y.hasAttribute(se) && (he.attr(se, Y.getAttribute(se)), Y.removeAttribute(se));
        }
      }
      he == null || he.selectChildren().attr("transform", N);
    }
  }
  const F = NH(v, _, t), { figure: U = r != null || i != null || s != null || F.length > 0 } = t;
  U && (L = C.createElement("figure"), L.className = `${l}-figure`, L.style.maxWidth = "initial", r != null && L.append(y2(C, r, "h2")), i != null && L.append(y2(C, i, "h3")), L.append(...F, E), s != null && L.append(KH(C, s)), "value" in E && (L.value = E.value, delete E.value)), L.scale = qz(y.scales), L.legend = EH(v, _, t);
  const ee = wz();
  return ee > 0 && Xl(E).append("text").attr("x", R).attr("y", 20).attr("dy", "-1em").attr("text-anchor", "end").attr("font-family", "initial").text("⚠️").append("title").text(`${ee.toLocaleString("en-US")} warning${ee === 1 ? "" : "s"}. Please check the console.`), L;
}
function y2(t, e, n) {
  if (e.ownerDocument) return e;
  const r = t.createElement(n);
  return r.append(e), r;
}
function KH(t, e) {
  const n = t.createElement("figcaption");
  return n.append(e), n;
}
function b2(t) {
  return t.flat(1 / 0).filter((e) => e != null).map(GH);
}
function GH(t) {
  return typeof t.render == "function" ? t : new XH(t);
}
class XH extends br {
  constructor(e) {
    if (typeof e != "function") throw new TypeError("invalid mark; missing render function");
    super(), this.render = e;
  }
  render() {
  }
}
function F1(t, e) {
  for (const n in t) h8(t[n], e);
  return t;
}
function h8(t, e) {
  var l;
  const { scale: n, transform: r = !0 } = t;
  if (n == null || !r) return;
  const {
    type: i,
    percent: s,
    interval: o,
    transform: a = s ? (c) => c == null ? NaN : c * 100 : RM(o, i)
  } = (l = e[n]) != null ? l : {};
  a != null && (t.value = _t(t.value, a), t.transform = !1);
}
function ZH(t) {
  for (const e in t)
    KM(e, t[e]);
}
function dl(t, e, n, r = uF) {
  var i, s;
  for (const { channels: o } of e.values())
    for (const a in o) {
      const l = o[a], { scale: c } = l;
      if (c != null && r(c))
        if (c === "projection") {
          if (!uV(n)) {
            const u = ((i = n.x) == null ? void 0 : i.domain) === void 0, h = ((s = n.y) == null ? void 0 : s.domain) === void 0;
            if (u || h) {
              const [f, d] = hV(l);
              u && vm(t, "x", f), h && vm(t, "y", d);
            }
          }
        } else
          vm(t, c, l);
    }
  return t;
}
function vm(t, e, n) {
  const r = t.get(e);
  r !== void 0 ? r.push(n) : t.set(e, [n]);
}
function JH(t, e) {
  if (t == null) return;
  const { x: n, y: r } = t;
  if (n == null && r == null) return;
  const i = Tn(t.data);
  if (i == null) throw new Error("missing facet data");
  const s = {};
  n != null && (s.fx = Sc(i, { value: n, scale: "fx" })), r != null && (s.fy = Sc(i, { value: r, scale: "fy" })), F1(s, e);
  const o = $1(i, s);
  return { channels: s, groups: o, data: t.data };
}
function x2(t, e, n) {
  var l, c, u;
  if (t.facet === null || t.facet === "super") return;
  const { fx: r, fy: i } = t;
  if (r != null || i != null) {
    const h = Tn((c = (l = t.data) != null ? l : r) != null ? c : i);
    if (h === void 0) throw new Error(`missing facet data in ${t.ariaLabel}`);
    if (h === null) return;
    const f = {};
    return r != null && (f.fx = Sc(h, { value: r, scale: "fx" })), i != null && (f.fy = Sc(h, { value: i, scale: "fy" })), F1(f, n), { channels: f, groups: $1(h, f) };
  }
  if (e === void 0) return;
  const { channels: s, groups: o, data: a } = e;
  if (t.facet !== "auto" || t.data === a) return { channels: s, groups: o };
  a.length > 0 && (o.size > 1 || o.size === 1 && s.fx && s.fy && [...o][0][1].size > 1) && ((u = Tn(t.data)) == null ? void 0 : u.length) === a.length && rs(
    `Warning: the ${t.ariaLabel} mark appears to use faceted data, but isn’t faceted. The mark data has the same length as the facet data and the mark facet option is "auto", but the mark data and facet data are distinct. If this mark should be faceted, set the mark facet option to true; otherwise, suppress this warning by setting the mark facet option to false.`
  );
}
function QH(t, e = {}) {
  return Lh({ ...e, x: null, y: null }, (n, r, i, s, o, a) => a.getMarkState(t));
}
function eY(t) {
  const e = [];
  for (const n of t) {
    let r = n.tip;
    if (r) {
      r === !0 ? r = {} : typeof r == "string" && (r = { pointer: r });
      let { pointer: i, preferredAnchor: s } = r;
      i = /^x$/i.test(i) ? IV : /^y$/i.test(i) ? o2 : NV, r = i(QH(n, r)), r.title = null, s === void 0 && (r.preferredAnchor = i === o2 ? "left" : "bottom");
      const o = HH(n.data, r);
      o.facet = n.facet, o.facetAnchor = n.facetAnchor, e.push(o);
    }
  }
  return e;
}
function tY(t, e, n) {
  let {
    projection: r,
    x: i = {},
    y: s = {},
    fx: o = {},
    fy: a = {},
    axis: l,
    grid: c,
    facet: u = {},
    facet: { axis: h = l, grid: f } = u,
    x: { axis: d = l, grid: p = d === null ? null : c } = i,
    y: { axis: m = l, grid: v = m === null ? null : c } = s,
    fx: { axis: g = h, grid: y = g === null ? null : f } = o,
    fy: { axis: x = h, grid: b = x === null ? null : f } = a
  } = n;
  (r || !t0(i) && !w2("x", t)) && (d = p = null), (r || !t0(s) && !w2("y", t)) && (m = v = null), e.has("fx") || (g = y = null), e.has("fy") || (x = b = null), d === void 0 && (d = !Zu(t, "x")), m === void 0 && (m = !Zu(t, "y")), g === void 0 && (g = !Zu(t, "fx")), x === void 0 && (x = !Zu(t, "fy")), d === !0 && (d = "bottom"), m === !0 && (m = "left"), g === !0 && (g = d === "top" || d === null ? "bottom" : "top"), x === !0 && (x = m === "right" || m === null ? "left" : "right");
  const w = [];
  return Xu(w, b, kH, a), Gu(w, x, mH, "right", "left", u, a), Xu(w, y, SH, o), Gu(w, g, gH, "top", "bottom", u, o), Xu(w, v, wH, s), Gu(w, m, GC, "left", "right", n, s), Xu(w, p, _H, i), Gu(w, d, XC, "bottom", "top", n, i), w;
}
function Gu(t, e, n, r, i, s, o) {
  if (!e) return;
  const a = nY(e);
  o = rY(a ? r : e, s, o);
  const { line: l } = o;
  (n === GC || n === XC) && l && !_c(l) && t.push(FH(iY(o))), t.push(n(o)), a && t.push(n({ ...o, anchor: i, label: null }));
}
function Xu(t, e, n, r) {
  !e || _c(e) || t.push(n(sY(e, r)));
}
function nY(t) {
  return /^\s*both\s*$/i.test(t);
}
function rY(t, e, {
  line: n = e.line,
  ticks: r,
  tickSize: i,
  tickSpacing: s,
  tickPadding: o,
  tickFormat: a,
  tickRotate: l,
  fontVariant: c,
  ariaLabel: u,
  ariaDescription: h,
  label: f = e.label,
  labelAnchor: d,
  labelArrow: p = e.labelArrow,
  labelOffset: m
}) {
  return {
    anchor: t,
    line: n,
    ticks: r,
    tickSize: i,
    tickSpacing: s,
    tickPadding: o,
    tickFormat: a,
    tickRotate: l,
    fontVariant: c,
    ariaLabel: u,
    ariaDescription: h,
    label: f,
    labelAnchor: d,
    labelArrow: p,
    labelOffset: m
  };
}
function iY(t) {
  const { anchor: e, line: n } = t;
  return { anchor: e, facetAnchor: e + "-empty", stroke: n === !0 ? void 0 : n };
}
function sY(t, {
  stroke: e = Zd(t) ? t : void 0,
  ticks: n = oY(t) ? t : void 0,
  tickSpacing: r,
  ariaLabel: i,
  ariaDescription: s
}) {
  return {
    stroke: e,
    ticks: n,
    tickSpacing: r,
    ariaLabel: i,
    ariaDescription: s
  };
}
function oY(t) {
  switch (typeof t) {
    case "number":
      return !0;
    case "string":
      return !Zd(t);
  }
  return Mo(t) || typeof (t == null ? void 0 : t.range) == "function";
}
function Zu(t, e) {
  const n = `${e}-axis `;
  return t.some((r) => {
    var i;
    return (i = r.ariaLabel) == null ? void 0 : i.startsWith(n);
  });
}
function w2(t, e) {
  for (const n of e)
    for (const r in n.channels) {
      const { scale: i } = n.channels[r];
      if (i === t || i === "projection")
        return !0;
    }
  return !1;
}
function aY(t, e) {
  for (const n in t) {
    const r = t[n], i = e[n];
    r.label === void 0 && i && (r.label = i.label);
  }
  return t;
}
function lY({ fx: t, fy: e }, n) {
  const { marginTop: r, marginRight: i, marginBottom: s, marginLeft: o, width: a, height: l } = C1(n), c = t && k2(t), u = e && k2(e);
  return {
    marginTop: e ? u[0] : r,
    marginRight: t ? a - c[1] : i,
    marginBottom: e ? l - u[1] : s,
    marginLeft: t ? c[0] : o,
    // Some marks, namely the x- and y-axis labels, want to know what the
    // desired (rather than actual) margins are for positioning.
    inset: {
      marginTop: n.marginTop,
      marginRight: n.marginRight,
      marginBottom: n.marginBottom,
      marginLeft: n.marginLeft
    },
    width: a,
    height: l
  };
}
function k2(t) {
  const e = t.domain();
  let n = t(e[0]), r = t(e[e.length - 1]);
  return r < n && ([n, r] = [r, n]), [n, r + t.bandwidth()];
}
const cY = /* @__PURE__ */ new Map([
  ["basis", IB],
  ["basis-closed", RB],
  ["basis-open", BB],
  ["bundle", FB],
  ["bump-x", MB],
  ["bump-y", CB],
  ["cardinal", zB],
  ["cardinal-closed", VB],
  ["cardinal-open", HB],
  ["catmull-rom", YB],
  ["catmull-rom-closed", WB],
  ["catmull-rom-open", jB],
  ["linear", qd],
  ["linear-closed", qB],
  ["monotone-x", UB],
  ["monotone-y", KB],
  ["natural", GB],
  ["step", XB],
  ["step-after", JB],
  ["step-before", ZB]
]);
function uY(t = qd, e) {
  if (typeof t == "function") return t;
  const n = cY.get(`${t}`.toLowerCase());
  if (!n) throw new Error(`unknown curve: ${t}`);
  if (e !== void 0) {
    if ("beta" in n)
      return n.beta(e);
    if ("tension" in n)
      return n.tension(e);
    if ("alpha" in n)
      return n.alpha(e);
  }
  return n;
}
function fY(t = Ih, e) {
  return typeof t != "function" && `${t}`.toLowerCase() === "auto" ? Ih : uY(t, e);
}
function Ih(t) {
  return qd(t);
}
function hY(t = {}) {
  return NM(t) ? t : { ...t, y: nr };
}
function dY(t, e) {
  if (e.length === 1) return { data: t, facets: e };
  const n = t.length, r = new Uint8Array(n);
  let i = 0;
  for (const a of e)
    for (const l of a)
      r[l] && ++i, r[l] = 1;
  if (i === 0) return { data: t, facets: e };
  t = wc(t);
  const s = t[TM] = new Uint32Array(n + i);
  e = e.map((a) => wc(a, Uint32Array));
  let o = n;
  r.fill(0);
  for (const a of e)
    for (let l = 0, c = a.length; l < c; ++l) {
      const u = a[l];
      r[u] ? (a[l] = o, t[o] = t[u], s[o] = u, ++o) : s[u] = u, r[u] = 1;
    }
  return { data: t, facets: e };
}
function pY(t = {}, e = {}) {
  arguments.length === 1 && ([t, e] = gY(t));
  const { x1: n, x: r = n, y: i, ...s } = e, [o, a, l, c] = yY(r, i, "x", "y", t, s);
  return { ...o, x1: n, x: a, y1: l, y2: c, y: xF(l, c) };
}
function mY({ y: t, y1: e, y2: n, ...r } = {}) {
  return r = O1(r, "x"), e === void 0 && n === void 0 ? pY({ y: t, ...r }) : ([e, n] = vF(t, e, n), { ...r, y1: e, y2: n });
}
function gY(t) {
  const { offset: e, order: n, reverse: r, ...i } = t;
  return [{ offset: e, order: n, reverse: r }, i];
}
const vY = { length: !0 };
function yY(t, e = cF, n, r, { offset: i, order: s, reverse: o }, a) {
  if (e === null) throw new Error(`stack requires ${r}`);
  const l = IM(a), [c, u] = bF(t), [h, f] = n0(e), [d, p] = n0(e);
  return h.hint = d.hint = vY, i = bY(i), s = kY(s, i, r), [
    WM(a, (m, v, g) => {
      ({ data: m, facets: v } = dY(m, v));
      const y = t == null ? void 0 : u(wF(Wn(m, t), g == null ? void 0 : g[n])), x = Wn(m, e, Float64Array), b = Wn(m, l), w = s && s(m, y, x, b), k = m.length, _ = f(new Float64Array(k)), C = p(new Float64Array(k)), E = [];
      for (const L of v) {
        const M = y ? Array.from(Nv(L, (O) => y[O]).values()) : [L];
        if (w) for (const O of M) O.sort(w);
        for (const O of M) {
          let N = 0, R = 0;
          o && O.reverse();
          for (const $ of O) {
            const F = x[$];
            F < 0 ? N = C[$] = (_[$] = N) + F : F > 0 ? R = C[$] = (_[$] = R) + F : C[$] = _[$] = R;
          }
        }
        E.push(M);
      }
      return i && i(E, _, C, b), { data: m, facets: v };
    }),
    c,
    h,
    d
  ];
}
function bY(t) {
  if (t != null) {
    if (typeof t == "function") return t;
    switch (`${t}`.toLowerCase()) {
      case "expand":
      case "normalize":
        return xY;
      case "center":
      case "silhouette":
        return wY;
      case "wiggle":
        return p8;
    }
    throw new Error(`unknown offset: ${t}`);
  }
}
function d8(t, e) {
  let n = 0, r = 0;
  for (const i of t) {
    const s = e[i];
    s < n && (n = s), s > r && (r = s);
  }
  return [n, r];
}
function xY(t, e, n) {
  for (const r of t)
    for (const i of r) {
      const [s, o] = d8(i, n);
      for (const a of i) {
        const l = 1 / (o - s || 1);
        e[a] = l * (e[a] - s), n[a] = l * (n[a] - s);
      }
    }
}
function wY(t, e, n) {
  for (const r of t) {
    for (const i of r) {
      const [s, o] = d8(i, n);
      for (const a of i) {
        const l = (o + s) / 2;
        e[a] -= l, n[a] -= l;
      }
    }
    m8(r, e, n);
  }
  g8(t, e, n);
}
function p8(t, e, n, r) {
  for (const i of t) {
    const s = new ro();
    let o = 0;
    for (const a of i) {
      let l = -1;
      const c = a.map((d) => Math.abs(n[d] - e[d])), u = a.map((d) => {
        l = r ? r[d] : ++l;
        const p = n[d] - e[d], m = s.has(l) ? p - s.get(l) : 0;
        return s.set(l, p), m;
      }), h = [0, ...I9(u)];
      for (const d of a)
        e[d] += o, n[d] += o;
      const f = io(c);
      f && (o -= io(c, (d, p) => (u[p] / 2 + h[p]) * d) / f);
    }
    m8(i, e, n);
  }
  g8(t, e, n);
}
function m8(t, e, n) {
  const r = yi(t, (i) => yi(i, (s) => e[s]));
  for (const i of t)
    for (const s of i)
      e[s] -= r, n[s] -= r;
}
function g8(t, e, n) {
  const r = t.length;
  if (r === 1) return;
  const i = t.map((a) => a.flat()), s = i.map((a) => (yi(a, (l) => e[l]) + ur(a, (l) => n[l])) / 2), o = yi(s);
  for (let a = 0; a < r; a++) {
    const l = o - s[a];
    for (const c of i[a])
      e[c] += l, n[c] += l;
  }
}
function kY(t, e, n) {
  if (t === void 0 && e === p8) return _2(Ur);
  if (t != null) {
    if (typeof t == "string") {
      const r = t.startsWith("-"), i = r ? Eh : Ur;
      switch ((r ? t.slice(1) : t).toLowerCase()) {
        case "value":
        case n:
          return _Y(i);
        case "z":
          return SY(i);
        case "sum":
          return MY(i);
        case "appearance":
          return CY(i);
        case "inside-out":
          return _2(i);
      }
      return S2(OM(t));
    }
    if (typeof t == "function") return (t.length === 1 ? S2 : $Y)(t);
    if (Array.isArray(t)) return AY(t);
    throw new Error(`invalid order: ${t}`);
  }
}
function _Y(t) {
  return (e, n, r) => (i, s) => t(r[i], r[s]);
}
function SY(t) {
  return (e, n, r, i) => (s, o) => t(i[s], i[o]);
}
function MY(t) {
  return ip(
    t,
    (e, n, r, i) => Rv(
      _s(e),
      (s) => io(s, (o) => r[o]),
      (s) => i[s]
    )
  );
}
function CY(t) {
  return ip(
    t,
    (e, n, r, i) => Rv(
      _s(e),
      (s) => n[U3(s, (o) => r[o])],
      (s) => i[s]
    )
  );
}
function _2(t) {
  return ip(t, (e, n, r, i) => {
    const s = _s(e), o = Rv(
      s,
      (h) => n[U3(h, (f) => r[f])],
      (h) => i[h]
    ), a = Gl(
      s,
      (h) => io(h, (f) => r[f]),
      (h) => i[h]
    ), l = [], c = [];
    let u = 0;
    for (const h of o)
      u < 0 ? (u += a.get(h), l.push(h)) : (u -= a.get(h), c.push(h));
    return c.reverse().concat(l);
  });
}
function S2(t) {
  return (e) => {
    const n = Wn(e, t);
    return (r, i) => Ur(n[r], n[i]);
  };
}
function $Y(t) {
  return (e) => (n, r) => t(e[n], e[r]);
}
function AY(t) {
  return ip(Ur, () => t);
}
function ip(t, e) {
  return (n, r, i, s) => {
    if (!s) throw new Error("missing channel: z");
    const o = new ro(e(n, r, i, s).map((a, l) => [a, l]));
    return (a, l) => t(o.get(s[a]), o.get(s[l]));
  };
}
class DY extends br {
  constructor(e, n, r = {}, i) {
    super(e, n, r, i);
    const { inset: s = 0, insetTop: o = s, insetRight: a = s, insetBottom: l = s, insetLeft: c = s, rx: u, ry: h } = r;
    this.insetTop = at(o), this.insetRight = at(a), this.insetBottom = at(l), this.insetLeft = at(c), this.rx = $t(u, "auto"), this.ry = $t(h, "auto");
  }
  render(e, n, r, i, s) {
    const { rx: o, ry: a } = this;
    return qt("svg:g", s).call(Ms, this, i, s).call(this._transform, this, n).call(
      (l) => l.selectAll().data(e).enter().append("rect").call(Cs, this).attr("x", this._x(n, r, i)).attr("width", this._width(n, r, i)).attr("y", this._y(n, r, i)).attr("height", this._height(n, r, i)).call(Me, "rx", o).call(Me, "ry", a).call(Wa, this, r)
    ).node();
  }
  _x(e, { x: n }, { marginLeft: r }) {
    const { insetLeft: i } = this;
    return n ? (s) => n[s] + i : r + i;
  }
  _y(e, { y: n }, { marginTop: r }) {
    const { insetTop: i } = this;
    return n ? (s) => n[s] + i : r + i;
  }
  _width({ x: e }, { x: n }, { marginRight: r, marginLeft: i, width: s }) {
    const { insetLeft: o, insetRight: a } = this, l = n && e ? e.bandwidth() : s - r - i;
    return Math.max(0, l - o - a);
  }
  _height({ y: e }, { y: n }, { marginTop: r, marginBottom: i, height: s }) {
    const { insetTop: o, insetBottom: a } = this, l = n && e ? e.bandwidth() : s - r - i;
    return Math.max(0, l - o - a);
  }
}
const TY = {
  ariaLabel: "bar"
};
class OY extends DY {
  constructor(e, n = {}) {
    const { x: r, y1: i, y2: s } = n;
    super(
      e,
      {
        y1: { value: i, scale: "y" },
        y2: { value: s, scale: "y" },
        x: { value: r, scale: "x", type: "band", optional: !0 }
      },
      n,
      TY
    );
  }
  _transform(e, n, { y: r }) {
    e.call($s, n, { y: r }, 0, 0);
  }
  _y({ y: e }, { y1: n, y2: r }, { marginTop: i }) {
    const { insetTop: s } = this;
    return ka(e) ? i + s : (o) => Math.min(n[o], r[o]) + s;
  }
  _height({ y: e }, { y1: n, y2: r }, { marginTop: i, marginBottom: s, height: o }) {
    const { insetTop: a, insetBottom: l } = this;
    return ka(e) ? o - i - s - a - l : (c) => Math.max(0, Math.abs(r[c] - n[c]) - a - l);
  }
}
function EY(t, e = {}) {
  return gF(e) || (e = { ...e, x: EM, y2: nr }), new OY(t, mY(TC(hY(e))));
}
const PY = {
  ariaLabel: "line",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 1
};
let LY = class extends br {
  constructor(e, n = {}) {
    const { x: r, y: i, z: s, curve: o, tension: a } = n;
    super(
      e,
      {
        x: { value: r, scale: "x" },
        y: { value: i, scale: "y" },
        z: { value: IM(n), optional: !0 }
      },
      n,
      PY
    ), this.z = s, this.curve = fY(o, a), P1(this, n);
  }
  filter(e) {
    return e;
  }
  project(e, n, r) {
    this.curve !== Ih && super.project(e, n, r);
  }
  render(e, n, r, i, s) {
    const { x: o, y: a } = r, { curve: l } = this;
    return qt("svg:g", s).call(Ms, this, i, s).call($s, this, n).call(
      (c) => c.selectAll().data($V(e, [o, a], this, r)).enter().append("path").call(Cs, this).call(SV, this, r).call(VV, this, r, s).attr(
        "d",
        l === Ih && s.projection ? NY(s.projection, o, a) : SB().curve(l).defined((u) => u >= 0).x((u) => o[u]).y((u) => a[u])
      )
    ).node();
  }
};
function NY(t, e, n) {
  const r = Zv(t);
  return e = Ph(e), n = Ph(n), (i) => {
    let s = [];
    const o = [s];
    for (const a of i)
      a === -1 ? (s = [], o.push(s)) : s.push([e[a], n[a]]);
    return r({ type: "MultiLineString", coordinates: o });
  };
}
function IY(t, { x: e, y: n, ...r } = {}) {
  return [e, n] = y1(e, n), new LY(t, { ...r, x: e, y: n });
}
function RY(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
br.prototype.plot = function({ marks: t = [], ...e } = {}) {
  return f8({ ...e, marks: [...t, this] });
};
const BY = {
  inheritAttrs: !1
}, v8 = /* @__PURE__ */ oe({
  ...BY,
  __name: "vx-chart-base",
  props: {
    config: {
      type: Object,
      required: !0
    }
  },
  emits: ["rendered", "error"],
  setup(t, { expose: e, emit: n }) {
    const r = t, i = n, s = le(null), o = (l) => {
      var c;
      if (s.value !== null) {
        s.value.innerHTML = "";
        const u = (c = s.value.parentElement) == null ? void 0 : c.clientWidth, h = f8({
          ...l,
          width: u && u > 640 ? u : 640,
          style: {
            minWidth: 640
          }
        });
        if (s.value.append(h), [...s.value.getElementsByTagName("text")].filter((d) => d.innerHTML.includes("⚠️")).length) {
          i("error");
          return;
        }
        i("rendered", h);
      }
    }, a = async () => {
      await gt(), o(r.config);
    };
    return Se(() => r.config, (l) => {
      o(l);
    }), rn(() => {
      a(), window.addEventListener("resize", a);
    }), e({ buildChart: a }), (l, c) => (S(), D("div", {
      class: "vx-text-xs vx-leading-4 vx-font-medium vx-text-slate-500 vx-cursor-pointer vx-overflow-x-auto",
      ref_key: "chart",
      ref: s
    }, null, 512));
  }
}), FY = { class: "vx-relative vx-space-y-2 vx-rounded-xl vx-border vx-border-solid vx-border-slate-100 vx-bg-slate-50 vx-py-4 vx-px-4 vx-max-w-[240px] vx-overflow-y-auto vx-overflow-x-hidden" }, zY = /* @__PURE__ */ B("h3", { class: "vx-text-base vx-font-extrabold vx-text-slate-800" }, "Keys", -1), VY = {
  key: 0,
  class: "vx-absolute vx-inset-x-4 vx-flex vx-flex-col vx-transition vx-duration-500"
}, HY = /* @__PURE__ */ B("div", { class: "vx-h-2.5 vx-w-2.5 vx-rounded-2xl vx-bg-slate-200" }, null, -1), YY = [
  HY
], WY = { class: "vx-flex vx-flex-col" }, y8 = /* @__PURE__ */ oe({
  __name: "vx-chart-legend",
  props: {
    items: {
      type: Array,
      required: !0
    },
    loading: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["hover"],
  setup(t, { emit: e }) {
    const n = t, r = e;
    return (i, s) => (S(), D("div", FY, [
      zY,
      re(Gn, {
        "enter-from-class": "vx-opacity-0 ",
        "enter-to-class": "vx-opacity-100",
        "leave-from-class": "vx-opacity-100",
        "leave-to-class": "vx-opacity-0 "
      }, {
        default: G(() => [
          n.loading ? (S(), D("ul", VY, [
            (S(), D(_e, null, Fe(7, (o) => B("div", {
              class: "vx-my-1 vx-inline-flex vx-h-6 vx-w-full vx-items-center vx-justify-start vx-gap-1 vx-rounded-xl vx-bg-slate-100 vx-px-2 vx-py-0.5 vx-transition vx-will-change-transform motion-safe:vx-animate-[pulse_1.3s_infinite]",
              key: `loading-${o}`,
              style: yt(
                o % 5 ? o % 3 ? "animation-delay: 0s" : "animation-delay: .4s" : "animation-delay: .6s"
              )
            }, YY, 4)), 64))
          ])) : Z("", !0)
        ]),
        _: 1
      }),
      B("ul", WY, [
        (S(!0), D(_e, null, Fe(n.items, (o, a) => (S(), ye(R3, {
          key: o.label,
          "icon-color": o.iconColor,
          "bg-color": o.bgColor,
          opacity: o.opacity,
          hovered: o.hovered,
          title: String(o.label),
          onMouseenter: (l) => r("hover", o),
          onMouseleave: s[0] || (s[0] = (l) => r("hover", null)),
          class: j([
            "vx-ease-[cubic-bezier(1.1, .05, .24, 1)] vx-max-w-[160px] vx-py-1 vx-will-change-transform motion-reduce:!vx-delay-150",
            n.loading ? "vx-opacity-0 motion-safe:vx-translate-x-6" : "vx-translate-x-0 vx-opacity-100"
          ]),
          style: yt({
            transitionDuration: n.loading ? ".1s" : `${a * 30 + 150}ms`,
            transitionDelay: n.loading ? `${a * 20 + 100}ms` : `${a * 30 + 200}ms`
          })
        }, {
          default: G(() => [
            ft(Pe(o.label), 1)
          ]),
          _: 2
        }, 1032, ["icon-color", "bg-color", "opacity", "hovered", "title", "onMouseenter", "class", "style"]))), 128))
      ])
    ]));
  }
}), Fge = /* @__PURE__ */ oe({
  __name: "vx-chart-column",
  props: {
    grid: {
      type: Boolean,
      default: !1
    },
    tooltipItemKey: {
      type: String,
      required: !1,
      default: () => "label"
    },
    data: {
      type: Array,
      required: !0
    },
    colors: {
      type: Array,
      required: !0
    },
    legend: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    axis: {
      type: Object,
      required: !0
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["error"],
  setup(t, { emit: e }) {
    const n = t, r = e, i = le(!1), s = T(() => n.error || i.value), o = le(), a = le(null), l = le(null), c = T(() => {
      const x = {};
      return n.data.forEach((b) => {
        const w = n.colors.find((k) => k.label === b.label);
        x[b.label] = {
          label: b.label,
          bgColor: w == null ? void 0 : w.bgColor,
          iconColor: w == null ? void 0 : w.iconColor,
          opacity: a.value ? a.value.dataset.label === b.label ? 1 : 0.4 : 1,
          hovered: a.value ? a.value.dataset.label === b.label : !1
        };
      }), Object.values(x);
    }), u = T(() => {
      const x = {
        grid: n.grid,
        style: {
          paddingRight: n.legend ? "16px" : 0
        },
        color: {
          domain: n.colors.map((b) => b.label),
          range: n.colors.map((b) => b.iconColor)
        },
        marks: [
          L1([0], { stroke: n.axis.x.axis ? "#CBD5E1" : "transparent" }),
          EY(
            n.data,
            {
              x: n.axis.x.key,
              y: n.axis.y.key,
              fill: "label",
              title: (b) => b[n.tooltipItemKey]
            }
          )
        ]
      };
      return n.axis ? { ...x, ...n.axis } : x;
    }), h = le([]), f = () => {
      var b;
      if (!l.value) return;
      const x = document.createElementNS("http://www.w3.org/2000/svg", "defs");
      (b = l.value.querySelectorAll('g[aria-label="bar"]')[0]) == null || b.querySelectorAll("rect").forEach((w, k) => {
        w.setAttribute("clip-path", `url(#round-corner-${k})`), w.dataset.label = String(n.data[k].label);
        const _ = document.createElementNS("http://www.w3.org/2000/svg", "clipPath"), C = document.createElementNS("http://www.w3.org/2000/svg", "rect"), E = 8, L = w.getAttribute("x") || "0", M = w.getAttribute("y") || "0", O = w.getAttribute("width") || "0", N = (Number.parseFloat(w.getAttribute("height") || "0") + E).toString(), R = w.getAttribute("fill") || "#fff";
        _.setAttribute("id", `round-corner-${k}`), C.setAttribute("x", L), C.setAttribute("y", M), C.setAttribute("rx", Number(E).toString()), C.setAttribute("ry", Number(E).toString()), C.setAttribute("width", O), C.setAttribute("height", N), C.setAttribute("fill", R), _.append(C), x.append(_), h.value.push(w);
      }), l.value.prepend(x);
    }, d = (x) => {
      i.value = !1, l.value = x, f(), p();
    }, p = () => {
      h.value.length && h.value.forEach((x) => {
        x.addEventListener("mouseenter", () => {
          v(x);
        }), x.addEventListener("mouseleave", () => {
          v(null);
        });
      });
    }, m = (x) => {
      h.value.length && (h.value.forEach((b) => {
        x != null && x.label ? b.dataset.label === x.label && (a.value = b) : a.value = null;
      }), v(a.value));
    }, v = (x) => {
      a.value = x || null, h.value.forEach((b) => {
        const w = a.value ? a.value.dataset.label === b.dataset.label ? 1 : 0.2 : 1;
        b.setAttribute("style", `opacity: ${w}`);
      });
    }, g = T(() => !!n.data.length), y = () => {
      i.value = !0, r("error");
    };
    return (x, b) => (S(), ye(Md, {
      loading: n.loading,
      "loading-style": "spinner",
      hasData: g.value,
      error: s.value,
      onToggleLegend: b[0] || (b[0] = (w) => o.value.buildChart())
    }, ca({
      default: G(() => [
        re(v8, {
          ref_key: "chartBase",
          ref: o,
          config: u.value,
          onRendered: d,
          onError: y
        }, null, 8, ["config"])
      ]),
      _: 2
    }, [
      x.$slots.title ? {
        name: "title",
        fn: G(() => [
          H(x.$slots, "title")
        ]),
        key: "0"
      } : void 0,
      x.$slots.subtitle ? {
        name: "subtitle",
        fn: G(() => [
          H(x.$slots, "subtitle")
        ]),
        key: "1"
      } : void 0,
      x.$slots.right ? {
        name: "right",
        fn: G(() => [
          H(x.$slots, "right")
        ]),
        key: "2"
      } : void 0,
      x.$slots.footer ? {
        name: "footer",
        fn: G(() => [
          H(x.$slots, "footer")
        ]),
        key: "3"
      } : void 0,
      n.legend && !s.value ? {
        name: "legend",
        fn: G(() => [
          re(y8, {
            loading: n.loading,
            items: c.value,
            onHover: m,
            class: "vx-px-4 vx-w-full"
          }, null, 8, ["loading", "items"])
        ]),
        key: "4"
      } : void 0,
      x.$slots.explainHeader ? {
        name: "explainHeader",
        fn: G(() => [
          H(x.$slots, "explainHeader")
        ]),
        key: "5"
      } : void 0,
      x.$slots.explainContent ? {
        name: "explainContent",
        fn: G(() => [
          H(x.$slots, "explainContent")
        ]),
        key: "6"
      } : void 0
    ]), 1032, ["loading", "hasData", "error"]));
  }
}), zge = /* @__PURE__ */ oe({
  __name: "vx-chart-line",
  props: {
    grid: {
      type: Boolean,
      default: !1
    },
    tooltipItemKey: {
      type: String,
      required: !1,
      default: () => "label"
    },
    data: {
      type: Array,
      required: !0
    },
    colors: {
      type: Array,
      required: !0
    },
    legend: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    axis: {
      type: Object,
      required: !0
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["error"],
  setup(t, { emit: e }) {
    const n = t, r = le(), i = e, s = le(!1), o = T(() => n.error || s.value), a = le(null), l = le(null), c = le([]), u = T(() => {
      const g = {};
      return n.data.forEach((y) => {
        const x = n.colors.find((b) => b.label === y.label);
        g[y.label] = {
          label: y.label,
          bgColor: x == null ? void 0 : x.bgColor,
          iconColor: x == null ? void 0 : x.iconColor,
          opacity: a.value ? a.value.textContent === y.label ? 1 : 0.4 : 1,
          hovered: a.value ? a.value.textContent === y.label : !1
        };
      }), Object.values(g);
    }), h = T(() => {
      const g = {
        grid: n.grid,
        style: {
          paddingRight: n.legend ? "16px" : 0
        },
        color: {
          domain: n.colors.map((y) => y.label),
          range: n.colors.map((y) => y.iconColor)
        },
        marks: [
          L1([0], { stroke: n.axis.x.axis ? "#CBD5E1" : "transparent" }),
          IY(
            n.data,
            {
              x: n.axis.x.key,
              y: n.axis.y.key,
              stroke: "label",
              strokeWidth: 4,
              title: (y) => y[n.tooltipItemKey],
              curve: "bump-x"
            }
          )
        ]
      };
      return n.axis ? { ...g, ...n.axis } : g;
    }), f = (g) => {
      var y;
      s.value = !1, l.value = g, (y = g.querySelectorAll('g[aria-label="line"]')[0]) == null || y.querySelectorAll("path").forEach((x) => {
        c.value.push(x);
      }), d();
    }, d = () => {
      c.value.length && c.value.forEach((g) => {
        g.addEventListener("mouseenter", () => {
          m(g);
        }), g.addEventListener("mouseleave", () => {
          m(null);
        });
      });
    }, p = (g) => {
      c.value.length && (c.value.forEach((y) => {
        g != null && g.label ? y.textContent === g.label && (a.value = y) : a.value = null;
      }), m(a.value));
    }, m = (g) => {
      a.value = g || null, c.value.forEach((y) => {
        const x = a.value ? a.value.textContent === y.textContent ? 1 : 0.2 : 1;
        y.setAttribute("stroke-opacity", `${x}`);
        const b = a.value ? a.value.textContent === y.textContent ? 4 : 1 : 4;
        y.setAttribute("stroke-width", `${b}px`);
      });
    }, v = () => {
      s.value = !0, i("error");
    };
    return (g, y) => (S(), ye(Md, {
      loading: n.loading,
      "loading-style": "spinner",
      hasData: !!n.data.length,
      error: o.value,
      onToggleLegend: y[0] || (y[0] = (x) => r.value.buildChart())
    }, ca({
      default: G(() => [
        re(v8, {
          ref_key: "chartBase",
          ref: r,
          config: h.value,
          onRendered: f,
          onError: v
        }, null, 8, ["config"])
      ]),
      _: 2
    }, [
      g.$slots.title ? {
        name: "title",
        fn: G(() => [
          H(g.$slots, "title")
        ]),
        key: "0"
      } : void 0,
      g.$slots.subtitle ? {
        name: "subtitle",
        fn: G(() => [
          H(g.$slots, "subtitle")
        ]),
        key: "1"
      } : void 0,
      g.$slots.right ? {
        name: "right",
        fn: G(() => [
          H(g.$slots, "right")
        ]),
        key: "2"
      } : void 0,
      g.$slots.footer ? {
        name: "footer",
        fn: G(() => [
          H(g.$slots, "footer")
        ]),
        key: "3"
      } : void 0,
      n.legend && !o.value ? {
        name: "legend",
        fn: G(() => [
          re(y8, {
            loading: n.loading,
            items: u.value,
            onHover: p,
            class: "vx-px-4 vx-w-full"
          }, null, 8, ["loading", "items"])
        ]),
        key: "4"
      } : void 0,
      g.$slots.explainHeader ? {
        name: "explainHeader",
        fn: G(() => [
          H(g.$slots, "explainHeader")
        ]),
        key: "5"
      } : void 0,
      g.$slots.explainContent ? {
        name: "explainContent",
        fn: G(() => [
          H(g.$slots, "explainContent")
        ]),
        key: "6"
      } : void 0
    ]), 1032, ["loading", "hasData", "error"]));
  }
}), jY = /* @__PURE__ */ B("div", { class: "vx-bg-slate-50 vx-absolute -vx-left-6 -vx-right-6 vx-h-full vx-top-0 -vx-z-10 vx-opacity-0 vx-transition group-hover:vx-opacity-100" }, null, -1), qY = { class: "vx-flex vx-items-center vx-grid-rows-2 vx-min-w-0" }, UY = /* @__PURE__ */ B("div", { class: "vx-flex vx-items-center vx-justify-center vx-w-[24px] vx-h-[24px] vx-mr-2 vx-py-2 vx-bg-sky-300 vx-rounded-full vx-shrink-0" }, [
  /* @__PURE__ */ B("div", { class: "vx-w-[10px] vx-h-[10px] vx-bg-sky-500 vx-rounded-full" })
], -1), KY = { class: "vx-overflow-hidden" }, GY = ["title"], XY = ["title"], ZY = { class: "vx-flex vx-items-center vx-gap-1" }, JY = { class: "vx-max-w-[78px] vx-text-right vx-flex vx-items-center vx-justify-end vx-gap-1 @lg/record:vx-pl-2" }, QY = { class: "vx-text-slate-500 vx-text-xs vx-leading-4 vx-font-medium" }, eW = /* @__PURE__ */ B("span", { class: "vx-w-2.5 vx-inline-block vx-h-px vx-bg-slate-100" }, null, -1), tW = { class: "vx-h-[8px] vx-w-full vx-bg-sky-500/50 vx-rounded-lg vx-overflow-hidden @lg/record:vx-w-36" }, nW = /* @__PURE__ */ oe({
  __name: "vx-chart-record-item",
  props: {
    title: {
      type: String,
      required: !0
    },
    subtitle: {
      type: String,
      required: !1
    },
    value: {
      type: Number,
      required: !0
    },
    href: {
      type: String,
      default: void 0
    },
    max: {
      type: Number,
      required: !0
    },
    percentage: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = t, n = T(() => e.percentage ? e.value * 100 : e.max ? Math.floor(e.value * 100 / e.max) : 0), r = T(() => e.percentage ? F3(Math.abs(e.value)) : B3(e.value));
    return (i, s) => (S(), ye(ht(e.href ? "a" : "span"), {
      href: e.href,
      class: "vx-group vx-flex vx-justify-between vx-border-solid vx-border-b vx-border-x-0 vx-border-t-0 vx-border-slate-100 vx-py-2 first:vx-border-t vx-min-h-[56px] vx-flex-col vx-relative vx-cursor-pointer hover:vx-no-underline vx-text-slate-800 hover:vx-text-slate-800 @lg/record:vx-flex-row"
    }, {
      default: G(() => [
        jY,
        B("div", qY, [
          UY,
          B("div", KY, [
            B("span", {
              class: "vx-block vx-text-sm vx-leading-5 vx-font-extrabold hover:vx-no-underline vx-grow vx-truncate",
              title: e.title
            }, Pe(e.title), 9, GY),
            e.subtitle ? (S(), D("div", {
              key: 0,
              class: "vx-text-sm vx-text-slate-400 vx-leading-5 vx-font-normal vx-truncate",
              title: e.subtitle
            }, Pe(e.subtitle), 9, XY)) : Z("", !0)
          ])
        ]),
        B("div", ZY, [
          B("div", JY, [
            B("span", QY, Pe(r.value), 1),
            eW
          ]),
          B("div", tW, [
            B("div", {
              "data-test": "bar",
              class: j(["vx-bg-sky-500 vx-h-full vx-border-solid vx-border-l-0 vx-border-white vx-border-y-0", {
                "vx-border-r-0": n.value >= 100,
                "vx-border-r": n.value < 100
              }]),
              style: yt({
                width: `${n.value}%`
              })
            }, null, 6)
          ])
        ])
      ]),
      _: 1
    }, 8, ["href"]));
  }
}), rW = { class: "vx-@container/record vx-flex vx-flex-col vx-my-[22px] vx-border-t vx-border-slate-100" }, Vge = /* @__PURE__ */ oe({
  __name: "vx-chart-record",
  props: {
    data: {
      type: Array,
      required: !0
    },
    percentage: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = t, n = T(() => Math.max(...e.data.map((r) => r.value)));
    return (r, i) => (S(), ye(Md, {
      loading: e.loading,
      hasData: !!e.data.length,
      error: t.error
    }, ca({
      default: G(() => [
        B("div", rW, [
          (S(!0), D(_e, null, Fe(e.data, (s) => (S(), ye(nW, {
            key: s.key,
            max: n.value,
            title: s.title,
            subtitle: s.subtitle,
            href: s == null ? void 0 : s.href,
            value: s.value,
            percentage: t.percentage
          }, null, 8, ["max", "title", "subtitle", "href", "value", "percentage"]))), 128))
        ])
      ]),
      _: 2
    }, [
      r.$slots.title ? {
        name: "title",
        fn: G(() => [
          H(r.$slots, "title")
        ]),
        key: "0"
      } : void 0,
      r.$slots.subtitle ? {
        name: "subtitle",
        fn: G(() => [
          H(r.$slots, "subtitle")
        ]),
        key: "1"
      } : void 0,
      r.$slots.footer ? {
        name: "footer",
        fn: G(() => [
          H(r.$slots, "footer")
        ]),
        key: "2"
      } : void 0,
      r.$slots.explainHeader ? {
        name: "explainHeader",
        fn: G(() => [
          H(r.$slots, "explainHeader")
        ]),
        key: "3"
      } : void 0,
      r.$slots.explainContent ? {
        name: "explainContent",
        fn: G(() => [
          H(r.$slots, "explainContent")
        ]),
        key: "4"
      } : void 0
    ]), 1032, ["loading", "hasData", "error"]));
  }
}), iW = /* @__PURE__ */ oe({
  __name: "vx-checkbox",
  props: {
    modelValue: {
      type: Boolean
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "md"
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, r = e, i = () => {
      n.disabled || r("update:modelValue", !n.modelValue);
    }, s = T(() => n.size === "lg" ? "vx-rounded-[8px] vx-w-8 vx-h-8" : "vx-rounded-[4px] vx-w-4 vx-h-4");
    return (o, a) => (S(), D("div", {
      class: j(["vx-border-solid vx-border vx-flex vx-items-center vx-justify-center vx-shrink-0", [s.value, {
        "vx-border-slate-400": !n.modelValue,
        "vx-border-sky-500 vx-bg-sky-300": n.modelValue,
        "vx-opacity-60 vx-cursor-not-allowed": n.disabled,
        "vx-cursor-pointer": !n.disabled
      }]]),
      onClick: i
    }, [
      n.modelValue ? (S(), ye(P(rt), {
        key: 0,
        icon: P(kO),
        class: "vx-text-[11px]"
      }, null, 8, ["icon"])) : Z("", !0)
    ], 2));
  }
}), sW = { class: "vx-@container" }, oW = ["aria-selected"], aW = { class: "vx-grow-0" }, lW = { class: "vx-ml-2 vx-grow @md:vx-ml-4" }, cW = { class: "vx-text-slate-800 vx-text-sm vx-leading-4 vx-font-semibold vx-flex vx-items-center vx-justify-between" }, uW = {
  key: 0,
  class: "vx-transition vx-basis-full @md:vx-hidden"
}, M2 = "vx-text-slate-500 vx-text-xs", fW = /* @__PURE__ */ oe({
  __name: "vx-checkbox-selection-item",
  props: {
    active: {
      type: Boolean,
      required: !1,
      default: !1
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    value: {
      type: [String, Number]
    }
  },
  emits: ["selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, i = () => {
      n.disabled || r("selected", n.value);
    }, s = le(!1), o = (a) => {
      a.stopPropagation(), s.value = !s.value;
    };
    return (a, l) => (S(), D("div", sW, [
      B("div", {
        onClick: l[1] || (l[1] = Lt((c) => i(), ["prevent"])),
        "data-test": "vx-checkbox-selection-item",
        tabindex: "0",
        onKeydown: [
          l[2] || (l[2] = Yt(Lt((c) => i(), ["prevent"]), ["space"])),
          l[3] || (l[3] = Yt(Lt((c) => i(), ["prevent"]), ["enter"]))
        ],
        "aria-selected": n.active,
        class: j(["vx-flex vx-items-center vx-py-1.5 vx-pl-4 vx-pr-2 vx-border vx-border-solid vx-rounded-xl vx-font-sans vx-flex-wrap @md:vx-flex-nowrap @md:vx-py-4 @md:vx-px-5", {
          "vx-bg-slate-50 vx-border-slate-300": !n.active,
          "vx-bg-white vx-border-sky-500": n.active,
          "vx-opacity-60 vx-cursor-not-allowed": n.disabled,
          "vx-cursor-pointer": !n.disabled
        }])
      }, [
        B("div", aW, [
          re(iW, {
            "model-value": n.active,
            disabled: n.disabled
          }, null, 8, ["model-value", "disabled"])
        ]),
        B("div", lW, [
          B("div", cW, [
            H(a.$slots, "header"),
            H(a.$slots, "default"),
            re(cs, {
              class: j(["@md:vx-hidden", {
                "vx-opacity-0 vx-pointer-events-none": !a.$slots.content
                // hide button without breaking height on mobile
              }]),
              type: "button",
              onClick: l[0] || (l[0] = (c) => o(c)),
              size: "sm",
              color: n.active ? "muted-light" : "muted"
            }, {
              default: G(() => [
                re(P(rt), {
                  icon: s.value ? P(C3) : P(A3),
                  class: "vx-text-sm vx-mx-0.5"
                }, null, 8, ["icon"])
              ]),
              _: 1
            }, 8, ["class", "color"])
          ]),
          a.$slots.content ? (S(), D("p", {
            key: 0,
            class: j([M2, "vx-hidden @md:vx-block"])
          }, [
            H(a.$slots, "content")
          ], 2)) : Z("", !0)
        ]),
        re(Gn, {
          "enter-from-class": "vx-opacity-0 -vx-translate-y-4 vx-duration-300",
          "enter-to-class": "vx-opacity-100 vx-translate-y-0 vx-duration-300",
          "leave-from-class": "vx-opacity-100 vx-duration-0",
          "leave-to-class": "vx-opacity-0 vx-duration-0"
        }, {
          default: G(() => [
            s.value && a.$slots.content ? (S(), D("div", uW, [
              B("p", {
                class: j([M2, "vx-mb-1"])
              }, [
                H(a.$slots, "content")
              ], 2)
            ])) : Z("", !0)
          ]),
          _: 3
        })
      ], 42, oW)
    ]));
  }
}), Hge = /* @__PURE__ */ oe({
  __name: "vx-checkbox-selection",
  props: {
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    modelValue: {
      type: Array,
      required: !1
    },
    class: {
      type: String,
      required: !1,
      default: "vx-flex vx-flex-col vx-gap-2"
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, r = e, i = le(n.modelValue || []);
    Se(
      () => n.modelValue,
      (l) => {
        i.value = l || [];
      }
    );
    const s = xs(), o = T(() => {
      var c, u;
      let l = ((c = s.default) == null ? void 0 : c.call(s)) || [];
      return l.length === 1 && ((u = l[0].children) != null && u.length) && (l = l[0].children), l.filter((h) => h.type === fW);
    }), a = (l) => {
      i.value.includes(l) ? i.value = i.value.filter((c) => c !== l) : i.value.push(l), r("update:modelValue", i.value);
    };
    return (l, c) => (S(), D("div", {
      class: j(n.class)
    }, [
      (S(!0), D(_e, null, Fe(o.value, (u, h) => (S(), D(_e, {
        key: `checkbox-selection-item-${String(u.key || h)}`
      }, [
        u.props !== null ? (S(), ye(ht(u), {
          key: 0,
          value: u.props.value,
          onSelected: (f) => {
            var d;
            return a((d = u.props) == null ? void 0 : d.value);
          },
          onKeyup: Yt((f) => {
            var d;
            return a((d = u.props) == null ? void 0 : d.value);
          }, ["enter"]),
          active: i.value.includes(u.props.value),
          disabled: u.props.disabled || n.disabled
        }, null, 40, ["value", "onSelected", "onKeyup", "active", "disabled"])) : Z("", !0)
      ], 64))), 128))
    ], 2));
  }
});
class ze {
  /**
  Get the line description around the given position.
  */
  lineAt(e) {
    if (e < 0 || e > this.length)
      throw new RangeError(`Invalid position ${e} in document of length ${this.length}`);
    return this.lineInner(e, !1, 1, 0);
  }
  /**
  Get the description for the given (1-based) line number.
  */
  line(e) {
    if (e < 1 || e > this.lines)
      throw new RangeError(`Invalid line number ${e} in ${this.lines}-line document`);
    return this.lineInner(e, !0, 1, 0);
  }
  /**
  Replace a range of the text with the given content.
  */
  replace(e, n, r) {
    [e, n] = Ma(this, e, n);
    let i = [];
    return this.decompose(
      0,
      e,
      i,
      2
      /* Open.To */
    ), r.length && r.decompose(
      0,
      r.length,
      i,
      3
      /* Open.To */
    ), this.decompose(
      n,
      this.length,
      i,
      1
      /* Open.From */
    ), Or.from(i, this.length - (n - e) + r.length);
  }
  /**
  Append another document to this one.
  */
  append(e) {
    return this.replace(this.length, this.length, e);
  }
  /**
  Retrieve the text between the given points.
  */
  slice(e, n = this.length) {
    [e, n] = Ma(this, e, n);
    let r = [];
    return this.decompose(e, n, r, 0), Or.from(r, n - e);
  }
  /**
  Test whether this text is equal to another instance.
  */
  eq(e) {
    if (e == this)
      return !0;
    if (e.length != this.length || e.lines != this.lines)
      return !1;
    let n = this.scanIdentical(e, 1), r = this.length - this.scanIdentical(e, -1), i = new tc(this), s = new tc(e);
    for (let o = n, a = n; ; ) {
      if (i.next(o), s.next(o), o = 0, i.lineBreak != s.lineBreak || i.done != s.done || i.value != s.value)
        return !1;
      if (a += i.value.length, i.done || a >= r)
        return !0;
    }
  }
  /**
  Iterate over the text. When `dir` is `-1`, iteration happens
  from end to start. This will return lines and the breaks between
  them as separate strings.
  */
  iter(e = 1) {
    return new tc(this, e);
  }
  /**
  Iterate over a range of the text. When `from` > `to`, the
  iterator will run in reverse.
  */
  iterRange(e, n = this.length) {
    return new b8(this, e, n);
  }
  /**
  Return a cursor that iterates over the given range of lines,
  _without_ returning the line breaks between, and yielding empty
  strings for empty lines.
  
  When `from` and `to` are given, they should be 1-based line numbers.
  */
  iterLines(e, n) {
    let r;
    if (e == null)
      r = this.iter();
    else {
      n == null && (n = this.lines + 1);
      let i = this.line(e).from;
      r = this.iterRange(i, Math.max(i, n == this.lines + 1 ? this.length : n <= 1 ? 0 : this.line(n - 1).to));
    }
    return new x8(r);
  }
  /**
  Return the document as a string, using newline characters to
  separate lines.
  */
  toString() {
    return this.sliceString(0);
  }
  /**
  Convert the document to an array of lines (which can be
  deserialized again via [`Text.of`](https://codemirror.net/6/docs/ref/#state.Text^of)).
  */
  toJSON() {
    let e = [];
    return this.flatten(e), e;
  }
  /**
  @internal
  */
  constructor() {
  }
  /**
  Create a `Text` instance for the given array of lines.
  */
  static of(e) {
    if (e.length == 0)
      throw new RangeError("A document must have at least one line");
    return e.length == 1 && !e[0] ? ze.empty : e.length <= 32 ? new ut(e) : Or.from(ut.split(e, []));
  }
}
class ut extends ze {
  constructor(e, n = hW(e)) {
    super(), this.text = e, this.length = n;
  }
  get lines() {
    return this.text.length;
  }
  get children() {
    return null;
  }
  lineInner(e, n, r, i) {
    for (let s = 0; ; s++) {
      let o = this.text[s], a = i + o.length;
      if ((n ? r : a) >= e)
        return new dW(i, a, r, o);
      i = a + 1, r++;
    }
  }
  decompose(e, n, r, i) {
    let s = e <= 0 && n >= this.length ? this : new ut(C2(this.text, e, n), Math.min(n, this.length) - Math.max(0, e));
    if (i & 1) {
      let o = r.pop(), a = Nf(s.text, o.text.slice(), 0, s.length);
      if (a.length <= 32)
        r.push(new ut(a, o.length + s.length));
      else {
        let l = a.length >> 1;
        r.push(new ut(a.slice(0, l)), new ut(a.slice(l)));
      }
    } else
      r.push(s);
  }
  replace(e, n, r) {
    if (!(r instanceof ut))
      return super.replace(e, n, r);
    [e, n] = Ma(this, e, n);
    let i = Nf(this.text, Nf(r.text, C2(this.text, 0, e)), n), s = this.length + r.length - (n - e);
    return i.length <= 32 ? new ut(i, s) : Or.from(ut.split(i, []), s);
  }
  sliceString(e, n = this.length, r = `
`) {
    [e, n] = Ma(this, e, n);
    let i = "";
    for (let s = 0, o = 0; s <= n && o < this.text.length; o++) {
      let a = this.text[o], l = s + a.length;
      s > e && o && (i += r), e < l && n > s && (i += a.slice(Math.max(0, e - s), n - s)), s = l + 1;
    }
    return i;
  }
  flatten(e) {
    for (let n of this.text)
      e.push(n);
  }
  scanIdentical() {
    return 0;
  }
  static split(e, n) {
    let r = [], i = -1;
    for (let s of e)
      r.push(s), i += s.length + 1, r.length == 32 && (n.push(new ut(r, i)), r = [], i = -1);
    return i > -1 && n.push(new ut(r, i)), n;
  }
}
class Or extends ze {
  constructor(e, n) {
    super(), this.children = e, this.length = n, this.lines = 0;
    for (let r of e)
      this.lines += r.lines;
  }
  lineInner(e, n, r, i) {
    for (let s = 0; ; s++) {
      let o = this.children[s], a = i + o.length, l = r + o.lines - 1;
      if ((n ? l : a) >= e)
        return o.lineInner(e, n, r, i);
      i = a + 1, r = l + 1;
    }
  }
  decompose(e, n, r, i) {
    for (let s = 0, o = 0; o <= n && s < this.children.length; s++) {
      let a = this.children[s], l = o + a.length;
      if (e <= l && n >= o) {
        let c = i & ((o <= e ? 1 : 0) | (l >= n ? 2 : 0));
        o >= e && l <= n && !c ? r.push(a) : a.decompose(e - o, n - o, r, c);
      }
      o = l + 1;
    }
  }
  replace(e, n, r) {
    if ([e, n] = Ma(this, e, n), r.lines < this.lines)
      for (let i = 0, s = 0; i < this.children.length; i++) {
        let o = this.children[i], a = s + o.length;
        if (e >= s && n <= a) {
          let l = o.replace(e - s, n - s, r), c = this.lines - o.lines + l.lines;
          if (l.lines < c >> 4 && l.lines > c >> 6) {
            let u = this.children.slice();
            return u[i] = l, new Or(u, this.length - (n - e) + r.length);
          }
          return super.replace(s, a, l);
        }
        s = a + 1;
      }
    return super.replace(e, n, r);
  }
  sliceString(e, n = this.length, r = `
`) {
    [e, n] = Ma(this, e, n);
    let i = "";
    for (let s = 0, o = 0; s < this.children.length && o <= n; s++) {
      let a = this.children[s], l = o + a.length;
      o > e && s && (i += r), e < l && n > o && (i += a.sliceString(e - o, n - o, r)), o = l + 1;
    }
    return i;
  }
  flatten(e) {
    for (let n of this.children)
      n.flatten(e);
  }
  scanIdentical(e, n) {
    if (!(e instanceof Or))
      return 0;
    let r = 0, [i, s, o, a] = n > 0 ? [0, 0, this.children.length, e.children.length] : [this.children.length - 1, e.children.length - 1, -1, -1];
    for (; ; i += n, s += n) {
      if (i == o || s == a)
        return r;
      let l = this.children[i], c = e.children[s];
      if (l != c)
        return r + l.scanIdentical(c, n);
      r += l.length + 1;
    }
  }
  static from(e, n = e.reduce((r, i) => r + i.length + 1, -1)) {
    let r = 0;
    for (let d of e)
      r += d.lines;
    if (r < 32) {
      let d = [];
      for (let p of e)
        p.flatten(d);
      return new ut(d, n);
    }
    let i = Math.max(
      32,
      r >> 5
      /* Tree.BranchShift */
    ), s = i << 1, o = i >> 1, a = [], l = 0, c = -1, u = [];
    function h(d) {
      let p;
      if (d.lines > s && d instanceof Or)
        for (let m of d.children)
          h(m);
      else d.lines > o && (l > o || !l) ? (f(), a.push(d)) : d instanceof ut && l && (p = u[u.length - 1]) instanceof ut && d.lines + p.lines <= 32 ? (l += d.lines, c += d.length + 1, u[u.length - 1] = new ut(p.text.concat(d.text), p.length + 1 + d.length)) : (l + d.lines > i && f(), l += d.lines, c += d.length + 1, u.push(d));
    }
    function f() {
      l != 0 && (a.push(u.length == 1 ? u[0] : Or.from(u, c)), c = -1, l = u.length = 0);
    }
    for (let d of e)
      h(d);
    return f(), a.length == 1 ? a[0] : new Or(a, n);
  }
}
ze.empty = /* @__PURE__ */ new ut([""], 0);
function hW(t) {
  let e = -1;
  for (let n of t)
    e += n.length + 1;
  return e;
}
function Nf(t, e, n = 0, r = 1e9) {
  for (let i = 0, s = 0, o = !0; s < t.length && i <= r; s++) {
    let a = t[s], l = i + a.length;
    l >= n && (l > r && (a = a.slice(0, r - i)), i < n && (a = a.slice(n - i)), o ? (e[e.length - 1] += a, o = !1) : e.push(a)), i = l + 1;
  }
  return e;
}
function C2(t, e, n) {
  return Nf(t, [""], e, n);
}
class tc {
  constructor(e, n = 1) {
    this.dir = n, this.done = !1, this.lineBreak = !1, this.value = "", this.nodes = [e], this.offsets = [n > 0 ? 1 : (e instanceof ut ? e.text.length : e.children.length) << 1];
  }
  nextInner(e, n) {
    for (this.done = this.lineBreak = !1; ; ) {
      let r = this.nodes.length - 1, i = this.nodes[r], s = this.offsets[r], o = s >> 1, a = i instanceof ut ? i.text.length : i.children.length;
      if (o == (n > 0 ? a : 0)) {
        if (r == 0)
          return this.done = !0, this.value = "", this;
        n > 0 && this.offsets[r - 1]++, this.nodes.pop(), this.offsets.pop();
      } else if ((s & 1) == (n > 0 ? 0 : 1)) {
        if (this.offsets[r] += n, e == 0)
          return this.lineBreak = !0, this.value = `
`, this;
        e--;
      } else if (i instanceof ut) {
        let l = i.text[o + (n < 0 ? -1 : 0)];
        if (this.offsets[r] += n, l.length > Math.max(0, e))
          return this.value = e == 0 ? l : n > 0 ? l.slice(e) : l.slice(0, l.length - e), this;
        e -= l.length;
      } else {
        let l = i.children[o + (n < 0 ? -1 : 0)];
        e > l.length ? (e -= l.length, this.offsets[r] += n) : (n < 0 && this.offsets[r]--, this.nodes.push(l), this.offsets.push(n > 0 ? 1 : (l instanceof ut ? l.text.length : l.children.length) << 1));
      }
    }
  }
  next(e = 0) {
    return e < 0 && (this.nextInner(-e, -this.dir), e = this.value.length), this.nextInner(e, this.dir);
  }
}
class b8 {
  constructor(e, n, r) {
    this.value = "", this.done = !1, this.cursor = new tc(e, n > r ? -1 : 1), this.pos = n > r ? e.length : 0, this.from = Math.min(n, r), this.to = Math.max(n, r);
  }
  nextInner(e, n) {
    if (n < 0 ? this.pos <= this.from : this.pos >= this.to)
      return this.value = "", this.done = !0, this;
    e += Math.max(0, n < 0 ? this.pos - this.to : this.from - this.pos);
    let r = n < 0 ? this.pos - this.from : this.to - this.pos;
    e > r && (e = r), r -= e;
    let { value: i } = this.cursor.next(e);
    return this.pos += (i.length + e) * n, this.value = i.length <= r ? i : n < 0 ? i.slice(i.length - r) : i.slice(0, r), this.done = !this.value, this;
  }
  next(e = 0) {
    return e < 0 ? e = Math.max(e, this.from - this.pos) : e > 0 && (e = Math.min(e, this.to - this.pos)), this.nextInner(e, this.cursor.dir);
  }
  get lineBreak() {
    return this.cursor.lineBreak && this.value != "";
  }
}
class x8 {
  constructor(e) {
    this.inner = e, this.afterBreak = !0, this.value = "", this.done = !1;
  }
  next(e = 0) {
    let { done: n, lineBreak: r, value: i } = this.inner.next(e);
    return n && this.afterBreak ? (this.value = "", this.afterBreak = !1) : n ? (this.done = !0, this.value = "") : r ? this.afterBreak ? this.value = "" : (this.afterBreak = !0, this.next()) : (this.value = i, this.afterBreak = !1), this;
  }
  get lineBreak() {
    return !1;
  }
}
typeof Symbol != "undefined" && (ze.prototype[Symbol.iterator] = function() {
  return this.iter();
}, tc.prototype[Symbol.iterator] = b8.prototype[Symbol.iterator] = x8.prototype[Symbol.iterator] = function() {
  return this;
});
class dW {
  /**
  @internal
  */
  constructor(e, n, r, i) {
    this.from = e, this.to = n, this.number = r, this.text = i;
  }
  /**
  The length of the line (not including any line break after it).
  */
  get length() {
    return this.to - this.from;
  }
}
function Ma(t, e, n) {
  return e = Math.max(0, Math.min(t.length, e)), [e, Math.max(e, Math.min(t.length, n))];
}
let ea = /* @__PURE__ */ "lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o".split(",").map((t) => t ? parseInt(t, 36) : 1);
for (let t = 1; t < ea.length; t++)
  ea[t] += ea[t - 1];
function pW(t) {
  for (let e = 1; e < ea.length; e += 2)
    if (ea[e] > t)
      return ea[e - 1] <= t;
  return !1;
}
function $2(t) {
  return t >= 127462 && t <= 127487;
}
const A2 = 8205;
function Pt(t, e, n = !0, r = !0) {
  return (n ? w8 : mW)(t, e, r);
}
function w8(t, e, n) {
  if (e == t.length)
    return e;
  e && k8(t.charCodeAt(e)) && _8(t.charCodeAt(e - 1)) && e--;
  let r = Dt(t, e);
  for (e += In(r); e < t.length; ) {
    let i = Dt(t, e);
    if (r == A2 || i == A2 || n && pW(i))
      e += In(i), r = i;
    else if ($2(i)) {
      let s = 0, o = e - 2;
      for (; o >= 0 && $2(Dt(t, o)); )
        s++, o -= 2;
      if (s % 2 == 0)
        break;
      e += 2;
    } else
      break;
  }
  return e;
}
function mW(t, e, n) {
  for (; e > 0; ) {
    let r = w8(t, e - 2, n);
    if (r < e)
      return r;
    e--;
  }
  return 0;
}
function k8(t) {
  return t >= 56320 && t < 57344;
}
function _8(t) {
  return t >= 55296 && t < 56320;
}
function Dt(t, e) {
  let n = t.charCodeAt(e);
  if (!_8(n) || e + 1 == t.length)
    return n;
  let r = t.charCodeAt(e + 1);
  return k8(r) ? (n - 55296 << 10) + (r - 56320) + 65536 : n;
}
function z1(t) {
  return t <= 65535 ? String.fromCharCode(t) : (t -= 65536, String.fromCharCode((t >> 10) + 55296, (t & 1023) + 56320));
}
function In(t) {
  return t < 65536 ? 1 : 2;
}
const f0 = /\r\n?|\n/;
var Qt = /* @__PURE__ */ function(t) {
  return t[t.Simple = 0] = "Simple", t[t.TrackDel = 1] = "TrackDel", t[t.TrackBefore = 2] = "TrackBefore", t[t.TrackAfter = 3] = "TrackAfter", t;
}(Qt || (Qt = {}));
class Yr {
  // Sections are encoded as pairs of integers. The first is the
  // length in the current document, and the second is -1 for
  // unaffected sections, and the length of the replacement content
  // otherwise. So an insertion would be (0, n>0), a deletion (n>0,
  // 0), and a replacement two positive numbers.
  /**
  @internal
  */
  constructor(e) {
    this.sections = e;
  }
  /**
  The length of the document before the change.
  */
  get length() {
    let e = 0;
    for (let n = 0; n < this.sections.length; n += 2)
      e += this.sections[n];
    return e;
  }
  /**
  The length of the document after the change.
  */
  get newLength() {
    let e = 0;
    for (let n = 0; n < this.sections.length; n += 2) {
      let r = this.sections[n + 1];
      e += r < 0 ? this.sections[n] : r;
    }
    return e;
  }
  /**
  False when there are actual changes in this set.
  */
  get empty() {
    return this.sections.length == 0 || this.sections.length == 2 && this.sections[1] < 0;
  }
  /**
  Iterate over the unchanged parts left by these changes. `posA`
  provides the position of the range in the old document, `posB`
  the new position in the changed document.
  */
  iterGaps(e) {
    for (let n = 0, r = 0, i = 0; n < this.sections.length; ) {
      let s = this.sections[n++], o = this.sections[n++];
      o < 0 ? (e(r, i, s), i += s) : i += o, r += s;
    }
  }
  /**
  Iterate over the ranges changed by these changes. (See
  [`ChangeSet.iterChanges`](https://codemirror.net/6/docs/ref/#state.ChangeSet.iterChanges) for a
  variant that also provides you with the inserted text.)
  `fromA`/`toA` provides the extent of the change in the starting
  document, `fromB`/`toB` the extent of the replacement in the
  changed document.
  
  When `individual` is true, adjacent changes (which are kept
  separate for [position mapping](https://codemirror.net/6/docs/ref/#state.ChangeDesc.mapPos)) are
  reported separately.
  */
  iterChangedRanges(e, n = !1) {
    h0(this, e, n);
  }
  /**
  Get a description of the inverted form of these changes.
  */
  get invertedDesc() {
    let e = [];
    for (let n = 0; n < this.sections.length; ) {
      let r = this.sections[n++], i = this.sections[n++];
      i < 0 ? e.push(r, i) : e.push(i, r);
    }
    return new Yr(e);
  }
  /**
  Compute the combined effect of applying another set of changes
  after this one. The length of the document after this set should
  match the length before `other`.
  */
  composeDesc(e) {
    return this.empty ? e : e.empty ? this : S8(this, e);
  }
  /**
  Map this description, which should start with the same document
  as `other`, over another set of changes, so that it can be
  applied after it. When `before` is true, map as if the changes
  in `other` happened before the ones in `this`.
  */
  mapDesc(e, n = !1) {
    return e.empty ? this : d0(this, e, n);
  }
  mapPos(e, n = -1, r = Qt.Simple) {
    let i = 0, s = 0;
    for (let o = 0; o < this.sections.length; ) {
      let a = this.sections[o++], l = this.sections[o++], c = i + a;
      if (l < 0) {
        if (c > e)
          return s + (e - i);
        s += a;
      } else {
        if (r != Qt.Simple && c >= e && (r == Qt.TrackDel && i < e && c > e || r == Qt.TrackBefore && i < e || r == Qt.TrackAfter && c > e))
          return null;
        if (c > e || c == e && n < 0 && !a)
          return e == i || n < 0 ? s : s + l;
        s += l;
      }
      i = c;
    }
    if (e > i)
      throw new RangeError(`Position ${e} is out of range for changeset of length ${i}`);
    return s;
  }
  /**
  Check whether these changes touch a given range. When one of the
  changes entirely covers the range, the string `"cover"` is
  returned.
  */
  touchesRange(e, n = e) {
    for (let r = 0, i = 0; r < this.sections.length && i <= n; ) {
      let s = this.sections[r++], o = this.sections[r++], a = i + s;
      if (o >= 0 && i <= n && a >= e)
        return i < e && a > n ? "cover" : !0;
      i = a;
    }
    return !1;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let n = 0; n < this.sections.length; ) {
      let r = this.sections[n++], i = this.sections[n++];
      e += (e ? " " : "") + r + (i >= 0 ? ":" + i : "");
    }
    return e;
  }
  /**
  Serialize this change desc to a JSON-representable value.
  */
  toJSON() {
    return this.sections;
  }
  /**
  Create a change desc from its JSON representation (as produced
  by [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeDesc.toJSON).
  */
  static fromJSON(e) {
    if (!Array.isArray(e) || e.length % 2 || e.some((n) => typeof n != "number"))
      throw new RangeError("Invalid JSON representation of ChangeDesc");
    return new Yr(e);
  }
  /**
  @internal
  */
  static create(e) {
    return new Yr(e);
  }
}
class mt extends Yr {
  constructor(e, n) {
    super(e), this.inserted = n;
  }
  /**
  Apply the changes to a document, returning the modified
  document.
  */
  apply(e) {
    if (this.length != e.length)
      throw new RangeError("Applying change set to a document with the wrong length");
    return h0(this, (n, r, i, s, o) => e = e.replace(i, i + (r - n), o), !1), e;
  }
  mapDesc(e, n = !1) {
    return d0(this, e, n, !0);
  }
  /**
  Given the document as it existed _before_ the changes, return a
  change set that represents the inverse of this set, which could
  be used to go from the document created by the changes back to
  the document as it existed before the changes.
  */
  invert(e) {
    let n = this.sections.slice(), r = [];
    for (let i = 0, s = 0; i < n.length; i += 2) {
      let o = n[i], a = n[i + 1];
      if (a >= 0) {
        n[i] = a, n[i + 1] = o;
        let l = i >> 1;
        for (; r.length < l; )
          r.push(ze.empty);
        r.push(o ? e.slice(s, s + o) : ze.empty);
      }
      s += o;
    }
    return new mt(n, r);
  }
  /**
  Combine two subsequent change sets into a single set. `other`
  must start in the document produced by `this`. If `this` goes
  `docA` → `docB` and `other` represents `docB` → `docC`, the
  returned value will represent the change `docA` → `docC`.
  */
  compose(e) {
    return this.empty ? e : e.empty ? this : S8(this, e, !0);
  }
  /**
  Given another change set starting in the same document, maps this
  change set over the other, producing a new change set that can be
  applied to the document produced by applying `other`. When
  `before` is `true`, order changes as if `this` comes before
  `other`, otherwise (the default) treat `other` as coming first.
  
  Given two changes `A` and `B`, `A.compose(B.map(A))` and
  `B.compose(A.map(B, true))` will produce the same document. This
  provides a basic form of [operational
  transformation](https://en.wikipedia.org/wiki/Operational_transformation),
  and can be used for collaborative editing.
  */
  map(e, n = !1) {
    return e.empty ? this : d0(this, e, n, !0);
  }
  /**
  Iterate over the changed ranges in the document, calling `f` for
  each, with the range in the original document (`fromA`-`toA`)
  and the range that replaces it in the new document
  (`fromB`-`toB`).
  
  When `individual` is true, adjacent changes are reported
  separately.
  */
  iterChanges(e, n = !1) {
    h0(this, e, n);
  }
  /**
  Get a [change description](https://codemirror.net/6/docs/ref/#state.ChangeDesc) for this change
  set.
  */
  get desc() {
    return Yr.create(this.sections);
  }
  /**
  @internal
  */
  filter(e) {
    let n = [], r = [], i = [], s = new Cc(this);
    e: for (let o = 0, a = 0; ; ) {
      let l = o == e.length ? 1e9 : e[o++];
      for (; a < l || a == l && s.len == 0; ) {
        if (s.done)
          break e;
        let u = Math.min(s.len, l - a);
        Bt(i, u, -1);
        let h = s.ins == -1 ? -1 : s.off == 0 ? s.ins : 0;
        Bt(n, u, h), h > 0 && Ji(r, n, s.text), s.forward(u), a += u;
      }
      let c = e[o++];
      for (; a < c; ) {
        if (s.done)
          break e;
        let u = Math.min(s.len, c - a);
        Bt(n, u, -1), Bt(i, u, s.ins == -1 ? -1 : s.off == 0 ? s.ins : 0), s.forward(u), a += u;
      }
    }
    return {
      changes: new mt(n, r),
      filtered: Yr.create(i)
    };
  }
  /**
  Serialize this change set to a JSON-representable value.
  */
  toJSON() {
    let e = [];
    for (let n = 0; n < this.sections.length; n += 2) {
      let r = this.sections[n], i = this.sections[n + 1];
      i < 0 ? e.push(r) : i == 0 ? e.push([r]) : e.push([r].concat(this.inserted[n >> 1].toJSON()));
    }
    return e;
  }
  /**
  Create a change set for the given changes, for a document of the
  given length, using `lineSep` as line separator.
  */
  static of(e, n, r) {
    let i = [], s = [], o = 0, a = null;
    function l(u = !1) {
      if (!u && !i.length)
        return;
      o < n && Bt(i, n - o, -1);
      let h = new mt(i, s);
      a = a ? a.compose(h.map(a)) : h, i = [], s = [], o = 0;
    }
    function c(u) {
      if (Array.isArray(u))
        for (let h of u)
          c(h);
      else if (u instanceof mt) {
        if (u.length != n)
          throw new RangeError(`Mismatched change set length (got ${u.length}, expected ${n})`);
        l(), a = a ? a.compose(u.map(a)) : u;
      } else {
        let { from: h, to: f = h, insert: d } = u;
        if (h > f || h < 0 || f > n)
          throw new RangeError(`Invalid change range ${h} to ${f} (in doc of length ${n})`);
        let p = d ? typeof d == "string" ? ze.of(d.split(r || f0)) : d : ze.empty, m = p.length;
        if (h == f && m == 0)
          return;
        h < o && l(), h > o && Bt(i, h - o, -1), Bt(i, f - h, m), Ji(s, i, p), o = f;
      }
    }
    return c(e), l(!a), a;
  }
  /**
  Create an empty changeset of the given length.
  */
  static empty(e) {
    return new mt(e ? [e, -1] : [], []);
  }
  /**
  Create a changeset from its JSON representation (as produced by
  [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeSet.toJSON).
  */
  static fromJSON(e) {
    if (!Array.isArray(e))
      throw new RangeError("Invalid JSON representation of ChangeSet");
    let n = [], r = [];
    for (let i = 0; i < e.length; i++) {
      let s = e[i];
      if (typeof s == "number")
        n.push(s, -1);
      else {
        if (!Array.isArray(s) || typeof s[0] != "number" || s.some((o, a) => a && typeof o != "string"))
          throw new RangeError("Invalid JSON representation of ChangeSet");
        if (s.length == 1)
          n.push(s[0], 0);
        else {
          for (; r.length < i; )
            r.push(ze.empty);
          r[i] = ze.of(s.slice(1)), n.push(s[0], r[i].length);
        }
      }
    }
    return new mt(n, r);
  }
  /**
  @internal
  */
  static createSet(e, n) {
    return new mt(e, n);
  }
}
function Bt(t, e, n, r = !1) {
  if (e == 0 && n <= 0)
    return;
  let i = t.length - 2;
  i >= 0 && n <= 0 && n == t[i + 1] ? t[i] += e : e == 0 && t[i] == 0 ? t[i + 1] += n : r ? (t[i] += e, t[i + 1] += n) : t.push(e, n);
}
function Ji(t, e, n) {
  if (n.length == 0)
    return;
  let r = e.length - 2 >> 1;
  if (r < t.length)
    t[t.length - 1] = t[t.length - 1].append(n);
  else {
    for (; t.length < r; )
      t.push(ze.empty);
    t.push(n);
  }
}
function h0(t, e, n) {
  let r = t.inserted;
  for (let i = 0, s = 0, o = 0; o < t.sections.length; ) {
    let a = t.sections[o++], l = t.sections[o++];
    if (l < 0)
      i += a, s += a;
    else {
      let c = i, u = s, h = ze.empty;
      for (; c += a, u += l, l && r && (h = h.append(r[o - 2 >> 1])), !(n || o == t.sections.length || t.sections[o + 1] < 0); )
        a = t.sections[o++], l = t.sections[o++];
      e(i, c, s, u, h), i = c, s = u;
    }
  }
}
function d0(t, e, n, r = !1) {
  let i = [], s = r ? [] : null, o = new Cc(t), a = new Cc(e);
  for (let l = -1; ; )
    if (o.ins == -1 && a.ins == -1) {
      let c = Math.min(o.len, a.len);
      Bt(i, c, -1), o.forward(c), a.forward(c);
    } else if (a.ins >= 0 && (o.ins < 0 || l == o.i || o.off == 0 && (a.len < o.len || a.len == o.len && !n))) {
      let c = a.len;
      for (Bt(i, a.ins, -1); c; ) {
        let u = Math.min(o.len, c);
        o.ins >= 0 && l < o.i && o.len <= u && (Bt(i, 0, o.ins), s && Ji(s, i, o.text), l = o.i), o.forward(u), c -= u;
      }
      a.next();
    } else if (o.ins >= 0) {
      let c = 0, u = o.len;
      for (; u; )
        if (a.ins == -1) {
          let h = Math.min(u, a.len);
          c += h, u -= h, a.forward(h);
        } else if (a.ins == 0 && a.len < u)
          u -= a.len, a.next();
        else
          break;
      Bt(i, c, l < o.i ? o.ins : 0), s && l < o.i && Ji(s, i, o.text), l = o.i, o.forward(o.len - u);
    } else {
      if (o.done && a.done)
        return s ? mt.createSet(i, s) : Yr.create(i);
      throw new Error("Mismatched change set lengths");
    }
}
function S8(t, e, n = !1) {
  let r = [], i = n ? [] : null, s = new Cc(t), o = new Cc(e);
  for (let a = !1; ; ) {
    if (s.done && o.done)
      return i ? mt.createSet(r, i) : Yr.create(r);
    if (s.ins == 0)
      Bt(r, s.len, 0, a), s.next();
    else if (o.len == 0 && !o.done)
      Bt(r, 0, o.ins, a), i && Ji(i, r, o.text), o.next();
    else {
      if (s.done || o.done)
        throw new Error("Mismatched change set lengths");
      {
        let l = Math.min(s.len2, o.len), c = r.length;
        if (s.ins == -1) {
          let u = o.ins == -1 ? -1 : o.off ? 0 : o.ins;
          Bt(r, l, u, a), i && u && Ji(i, r, o.text);
        } else o.ins == -1 ? (Bt(r, s.off ? 0 : s.len, l, a), i && Ji(i, r, s.textBit(l))) : (Bt(r, s.off ? 0 : s.len, o.off ? 0 : o.ins, a), i && !o.off && Ji(i, r, o.text));
        a = (s.ins > l || o.ins >= 0 && o.len > l) && (a || r.length > c), s.forward2(l), o.forward(l);
      }
    }
  }
}
class Cc {
  constructor(e) {
    this.set = e, this.i = 0, this.next();
  }
  next() {
    let { sections: e } = this.set;
    this.i < e.length ? (this.len = e[this.i++], this.ins = e[this.i++]) : (this.len = 0, this.ins = -2), this.off = 0;
  }
  get done() {
    return this.ins == -2;
  }
  get len2() {
    return this.ins < 0 ? this.len : this.ins;
  }
  get text() {
    let { inserted: e } = this.set, n = this.i - 2 >> 1;
    return n >= e.length ? ze.empty : e[n];
  }
  textBit(e) {
    let { inserted: n } = this.set, r = this.i - 2 >> 1;
    return r >= n.length && !e ? ze.empty : n[r].slice(this.off, e == null ? void 0 : this.off + e);
  }
  forward(e) {
    e == this.len ? this.next() : (this.len -= e, this.off += e);
  }
  forward2(e) {
    this.ins == -1 ? this.forward(e) : e == this.ins ? this.next() : (this.ins -= e, this.off += e);
  }
}
class Ys {
  constructor(e, n, r) {
    this.from = e, this.to = n, this.flags = r;
  }
  /**
  The anchor of the range—the side that doesn't move when you
  extend it.
  */
  get anchor() {
    return this.flags & 32 ? this.to : this.from;
  }
  /**
  The head of the range, which is moved when the range is
  [extended](https://codemirror.net/6/docs/ref/#state.SelectionRange.extend).
  */
  get head() {
    return this.flags & 32 ? this.from : this.to;
  }
  /**
  True when `anchor` and `head` are at the same position.
  */
  get empty() {
    return this.from == this.to;
  }
  /**
  If this is a cursor that is explicitly associated with the
  character on one of its sides, this returns the side. -1 means
  the character before its position, 1 the character after, and 0
  means no association.
  */
  get assoc() {
    return this.flags & 8 ? -1 : this.flags & 16 ? 1 : 0;
  }
  /**
  The bidirectional text level associated with this cursor, if
  any.
  */
  get bidiLevel() {
    let e = this.flags & 7;
    return e == 7 ? null : e;
  }
  /**
  The goal column (stored vertical offset) associated with a
  cursor. This is used to preserve the vertical position when
  [moving](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) across
  lines of different length.
  */
  get goalColumn() {
    let e = this.flags >> 6;
    return e == 16777215 ? void 0 : e;
  }
  /**
  Map this range through a change, producing a valid range in the
  updated document.
  */
  map(e, n = -1) {
    let r, i;
    return this.empty ? r = i = e.mapPos(this.from, n) : (r = e.mapPos(this.from, 1), i = e.mapPos(this.to, -1)), r == this.from && i == this.to ? this : new Ys(r, i, this.flags);
  }
  /**
  Extend this range to cover at least `from` to `to`.
  */
  extend(e, n = e) {
    if (e <= this.anchor && n >= this.anchor)
      return W.range(e, n);
    let r = Math.abs(e - this.anchor) > Math.abs(n - this.anchor) ? e : n;
    return W.range(this.anchor, r);
  }
  /**
  Compare this range to another range.
  */
  eq(e, n = !1) {
    return this.anchor == e.anchor && this.head == e.head && (!n || !this.empty || this.assoc == e.assoc);
  }
  /**
  Return a JSON-serializable object representing the range.
  */
  toJSON() {
    return { anchor: this.anchor, head: this.head };
  }
  /**
  Convert a JSON representation of a range to a `SelectionRange`
  instance.
  */
  static fromJSON(e) {
    if (!e || typeof e.anchor != "number" || typeof e.head != "number")
      throw new RangeError("Invalid JSON representation for SelectionRange");
    return W.range(e.anchor, e.head);
  }
  /**
  @internal
  */
  static create(e, n, r) {
    return new Ys(e, n, r);
  }
}
class W {
  constructor(e, n) {
    this.ranges = e, this.mainIndex = n;
  }
  /**
  Map a selection through a change. Used to adjust the selection
  position for changes.
  */
  map(e, n = -1) {
    return e.empty ? this : W.create(this.ranges.map((r) => r.map(e, n)), this.mainIndex);
  }
  /**
  Compare this selection to another selection. By default, ranges
  are compared only by position. When `includeAssoc` is true,
  cursor ranges must also have the same
  [`assoc`](https://codemirror.net/6/docs/ref/#state.SelectionRange.assoc) value.
  */
  eq(e, n = !1) {
    if (this.ranges.length != e.ranges.length || this.mainIndex != e.mainIndex)
      return !1;
    for (let r = 0; r < this.ranges.length; r++)
      if (!this.ranges[r].eq(e.ranges[r], n))
        return !1;
    return !0;
  }
  /**
  Get the primary selection range. Usually, you should make sure
  your code applies to _all_ ranges, by using methods like
  [`changeByRange`](https://codemirror.net/6/docs/ref/#state.EditorState.changeByRange).
  */
  get main() {
    return this.ranges[this.mainIndex];
  }
  /**
  Make sure the selection only has one range. Returns a selection
  holding only the main range from this selection.
  */
  asSingle() {
    return this.ranges.length == 1 ? this : new W([this.main], 0);
  }
  /**
  Extend this selection with an extra range.
  */
  addRange(e, n = !0) {
    return W.create([e].concat(this.ranges), n ? 0 : this.mainIndex + 1);
  }
  /**
  Replace a given range with another range, and then normalize the
  selection to merge and sort ranges if necessary.
  */
  replaceRange(e, n = this.mainIndex) {
    let r = this.ranges.slice();
    return r[n] = e, W.create(r, this.mainIndex);
  }
  /**
  Convert this selection to an object that can be serialized to
  JSON.
  */
  toJSON() {
    return { ranges: this.ranges.map((e) => e.toJSON()), main: this.mainIndex };
  }
  /**
  Create a selection from a JSON representation.
  */
  static fromJSON(e) {
    if (!e || !Array.isArray(e.ranges) || typeof e.main != "number" || e.main >= e.ranges.length)
      throw new RangeError("Invalid JSON representation for EditorSelection");
    return new W(e.ranges.map((n) => Ys.fromJSON(n)), e.main);
  }
  /**
  Create a selection holding a single range.
  */
  static single(e, n = e) {
    return new W([W.range(e, n)], 0);
  }
  /**
  Sort and merge the given set of ranges, creating a valid
  selection.
  */
  static create(e, n = 0) {
    if (e.length == 0)
      throw new RangeError("A selection needs at least one range");
    for (let r = 0, i = 0; i < e.length; i++) {
      let s = e[i];
      if (s.empty ? s.from <= r : s.from < r)
        return W.normalized(e.slice(), n);
      r = s.to;
    }
    return new W(e, n);
  }
  /**
  Create a cursor selection range at the given position. You can
  safely ignore the optional arguments in most situations.
  */
  static cursor(e, n = 0, r, i) {
    return Ys.create(e, e, (n == 0 ? 0 : n < 0 ? 8 : 16) | (r == null ? 7 : Math.min(6, r)) | (i != null ? i : 16777215) << 6);
  }
  /**
  Create a selection range.
  */
  static range(e, n, r, i) {
    let s = (r != null ? r : 16777215) << 6 | (i == null ? 7 : Math.min(6, i));
    return n < e ? Ys.create(n, e, 48 | s) : Ys.create(e, n, (n > e ? 8 : 0) | s);
  }
  /**
  @internal
  */
  static normalized(e, n = 0) {
    let r = e[n];
    e.sort((i, s) => i.from - s.from), n = e.indexOf(r);
    for (let i = 1; i < e.length; i++) {
      let s = e[i], o = e[i - 1];
      if (s.empty ? s.from <= o.to : s.from < o.to) {
        let a = o.from, l = Math.max(s.to, o.to);
        i <= n && n--, e.splice(--i, 2, s.anchor > s.head ? W.range(l, a) : W.range(a, l));
      }
    }
    return new W(e, n);
  }
}
function M8(t, e) {
  for (let n of t.ranges)
    if (n.to > e)
      throw new RangeError("Selection points outside of document");
}
let V1 = 0;
class ve {
  constructor(e, n, r, i, s) {
    this.combine = e, this.compareInput = n, this.compare = r, this.isStatic = i, this.id = V1++, this.default = e([]), this.extensions = typeof s == "function" ? s(this) : s;
  }
  /**
  Returns a facet reader for this facet, which can be used to
  [read](https://codemirror.net/6/docs/ref/#state.EditorState.facet) it but not to define values for it.
  */
  get reader() {
    return this;
  }
  /**
  Define a new facet.
  */
  static define(e = {}) {
    return new ve(e.combine || ((n) => n), e.compareInput || ((n, r) => n === r), e.compare || (e.combine ? (n, r) => n === r : H1), !!e.static, e.enables);
  }
  /**
  Returns an extension that adds the given value to this facet.
  */
  of(e) {
    return new If([], this, 0, e);
  }
  /**
  Create an extension that computes a value for the facet from a
  state. You must take care to declare the parts of the state that
  this value depends on, since your function is only called again
  for a new state when one of those parts changed.
  
  In cases where your value depends only on a single field, you'll
  want to use the [`from`](https://codemirror.net/6/docs/ref/#state.Facet.from) method instead.
  */
  compute(e, n) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new If(e, this, 1, n);
  }
  /**
  Create an extension that computes zero or more values for this
  facet from a state.
  */
  computeN(e, n) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new If(e, this, 2, n);
  }
  from(e, n) {
    return n || (n = (r) => r), this.compute([e], (r) => n(r.field(e)));
  }
}
function H1(t, e) {
  return t == e || t.length == e.length && t.every((n, r) => n === e[r]);
}
class If {
  constructor(e, n, r, i) {
    this.dependencies = e, this.facet = n, this.type = r, this.value = i, this.id = V1++;
  }
  dynamicSlot(e) {
    var n;
    let r = this.value, i = this.facet.compareInput, s = this.id, o = e[s] >> 1, a = this.type == 2, l = !1, c = !1, u = [];
    for (let h of this.dependencies)
      h == "doc" ? l = !0 : h == "selection" ? c = !0 : ((n = e[h.id]) !== null && n !== void 0 ? n : 1) & 1 || u.push(e[h.id]);
    return {
      create(h) {
        return h.values[o] = r(h), 1;
      },
      update(h, f) {
        if (l && f.docChanged || c && (f.docChanged || f.selection) || p0(h, u)) {
          let d = r(h);
          if (a ? !D2(d, h.values[o], i) : !i(d, h.values[o]))
            return h.values[o] = d, 1;
        }
        return 0;
      },
      reconfigure: (h, f) => {
        let d, p = f.config.address[s];
        if (p != null) {
          let m = Bh(f, p);
          if (this.dependencies.every((v) => v instanceof ve ? f.facet(v) === h.facet(v) : v instanceof It ? f.field(v, !1) == h.field(v, !1) : !0) || (a ? D2(d = r(h), m, i) : i(d = r(h), m)))
            return h.values[o] = m, 0;
        } else
          d = r(h);
        return h.values[o] = d, 1;
      }
    };
  }
}
function D2(t, e, n) {
  if (t.length != e.length)
    return !1;
  for (let r = 0; r < t.length; r++)
    if (!n(t[r], e[r]))
      return !1;
  return !0;
}
function p0(t, e) {
  let n = !1;
  for (let r of e)
    nc(t, r) & 1 && (n = !0);
  return n;
}
function gW(t, e, n) {
  let r = n.map((l) => t[l.id]), i = n.map((l) => l.type), s = r.filter((l) => !(l & 1)), o = t[e.id] >> 1;
  function a(l) {
    let c = [];
    for (let u = 0; u < r.length; u++) {
      let h = Bh(l, r[u]);
      if (i[u] == 2)
        for (let f of h)
          c.push(f);
      else
        c.push(h);
    }
    return e.combine(c);
  }
  return {
    create(l) {
      for (let c of r)
        nc(l, c);
      return l.values[o] = a(l), 1;
    },
    update(l, c) {
      if (!p0(l, s))
        return 0;
      let u = a(l);
      return e.compare(u, l.values[o]) ? 0 : (l.values[o] = u, 1);
    },
    reconfigure(l, c) {
      let u = p0(l, r), h = c.config.facets[e.id], f = c.facet(e);
      if (h && !u && H1(n, h))
        return l.values[o] = f, 0;
      let d = a(l);
      return e.compare(d, f) ? (l.values[o] = f, 0) : (l.values[o] = d, 1);
    }
  };
}
const T2 = /* @__PURE__ */ ve.define({ static: !0 });
class It {
  constructor(e, n, r, i, s) {
    this.id = e, this.createF = n, this.updateF = r, this.compareF = i, this.spec = s, this.provides = void 0;
  }
  /**
  Define a state field.
  */
  static define(e) {
    let n = new It(V1++, e.create, e.update, e.compare || ((r, i) => r === i), e);
    return e.provide && (n.provides = e.provide(n)), n;
  }
  create(e) {
    let n = e.facet(T2).find((r) => r.field == this);
    return ((n == null ? void 0 : n.create) || this.createF)(e);
  }
  /**
  @internal
  */
  slot(e) {
    let n = e[this.id] >> 1;
    return {
      create: (r) => (r.values[n] = this.create(r), 1),
      update: (r, i) => {
        let s = r.values[n], o = this.updateF(s, i);
        return this.compareF(s, o) ? 0 : (r.values[n] = o, 1);
      },
      reconfigure: (r, i) => i.config.address[this.id] != null ? (r.values[n] = i.field(this), 0) : (r.values[n] = this.create(r), 1)
    };
  }
  /**
  Returns an extension that enables this field and overrides the
  way it is initialized. Can be useful when you need to provide a
  non-default starting value for the field.
  */
  init(e) {
    return [this, T2.of({ field: this, create: e })];
  }
  /**
  State field instances can be used as
  [`Extension`](https://codemirror.net/6/docs/ref/#state.Extension) values to enable the field in a
  given state.
  */
  get extension() {
    return this;
  }
}
const Bs = { lowest: 4, low: 3, default: 2, high: 1, highest: 0 };
function pl(t) {
  return (e) => new C8(e, t);
}
const $o = {
  /**
  The highest precedence level, for extensions that should end up
  near the start of the precedence ordering.
  */
  highest: /* @__PURE__ */ pl(Bs.highest),
  /**
  A higher-than-default precedence, for extensions that should
  come before those with default precedence.
  */
  high: /* @__PURE__ */ pl(Bs.high),
  /**
  The default precedence, which is also used for extensions
  without an explicit precedence.
  */
  default: /* @__PURE__ */ pl(Bs.default),
  /**
  A lower-than-default precedence.
  */
  low: /* @__PURE__ */ pl(Bs.low),
  /**
  The lowest precedence level. Meant for things that should end up
  near the end of the extension order.
  */
  lowest: /* @__PURE__ */ pl(Bs.lowest)
};
class C8 {
  constructor(e, n) {
    this.inner = e, this.prec = n;
  }
}
class yu {
  /**
  Create an instance of this compartment to add to your [state
  configuration](https://codemirror.net/6/docs/ref/#state.EditorStateConfig.extensions).
  */
  of(e) {
    return new m0(this, e);
  }
  /**
  Create an [effect](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) that
  reconfigures this compartment.
  */
  reconfigure(e) {
    return yu.reconfigure.of({ compartment: this, extension: e });
  }
  /**
  Get the current content of the compartment in the state, or
  `undefined` if it isn't present.
  */
  get(e) {
    return e.config.compartments.get(this);
  }
}
class m0 {
  constructor(e, n) {
    this.compartment = e, this.inner = n;
  }
}
class Rh {
  constructor(e, n, r, i, s, o) {
    for (this.base = e, this.compartments = n, this.dynamicSlots = r, this.address = i, this.staticValues = s, this.facets = o, this.statusTemplate = []; this.statusTemplate.length < r.length; )
      this.statusTemplate.push(
        0
        /* SlotStatus.Unresolved */
      );
  }
  staticFacet(e) {
    let n = this.address[e.id];
    return n == null ? e.default : this.staticValues[n >> 1];
  }
  static resolve(e, n, r) {
    let i = [], s = /* @__PURE__ */ Object.create(null), o = /* @__PURE__ */ new Map();
    for (let f of vW(e, n, o))
      f instanceof It ? i.push(f) : (s[f.facet.id] || (s[f.facet.id] = [])).push(f);
    let a = /* @__PURE__ */ Object.create(null), l = [], c = [];
    for (let f of i)
      a[f.id] = c.length << 1, c.push((d) => f.slot(d));
    let u = r == null ? void 0 : r.config.facets;
    for (let f in s) {
      let d = s[f], p = d[0].facet, m = u && u[f] || [];
      if (d.every(
        (v) => v.type == 0
        /* Provider.Static */
      ))
        if (a[p.id] = l.length << 1 | 1, H1(m, d))
          l.push(r.facet(p));
        else {
          let v = p.combine(d.map((g) => g.value));
          l.push(r && p.compare(v, r.facet(p)) ? r.facet(p) : v);
        }
      else {
        for (let v of d)
          v.type == 0 ? (a[v.id] = l.length << 1 | 1, l.push(v.value)) : (a[v.id] = c.length << 1, c.push((g) => v.dynamicSlot(g)));
        a[p.id] = c.length << 1, c.push((v) => gW(v, p, d));
      }
    }
    let h = c.map((f) => f(a));
    return new Rh(e, o, h, a, l, s);
  }
}
function vW(t, e, n) {
  let r = [[], [], [], [], []], i = /* @__PURE__ */ new Map();
  function s(o, a) {
    let l = i.get(o);
    if (l != null) {
      if (l <= a)
        return;
      let c = r[l].indexOf(o);
      c > -1 && r[l].splice(c, 1), o instanceof m0 && n.delete(o.compartment);
    }
    if (i.set(o, a), Array.isArray(o))
      for (let c of o)
        s(c, a);
    else if (o instanceof m0) {
      if (n.has(o.compartment))
        throw new RangeError("Duplicate use of compartment in extensions");
      let c = e.get(o.compartment) || o.inner;
      n.set(o.compartment, c), s(c, a);
    } else if (o instanceof C8)
      s(o.inner, o.prec);
    else if (o instanceof It)
      r[a].push(o), o.provides && s(o.provides, a);
    else if (o instanceof If)
      r[a].push(o), o.facet.extensions && s(o.facet.extensions, Bs.default);
    else {
      let c = o.extension;
      if (!c)
        throw new Error(`Unrecognized extension value in extension set (${o}). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks.`);
      s(c, a);
    }
  }
  return s(t, Bs.default), r.reduce((o, a) => o.concat(a));
}
function nc(t, e) {
  if (e & 1)
    return 2;
  let n = e >> 1, r = t.status[n];
  if (r == 4)
    throw new Error("Cyclic dependency between fields and/or facets");
  if (r & 2)
    return r;
  t.status[n] = 4;
  let i = t.computeSlot(t, t.config.dynamicSlots[n]);
  return t.status[n] = 2 | i;
}
function Bh(t, e) {
  return e & 1 ? t.config.staticValues[e >> 1] : t.values[e >> 1];
}
const $8 = /* @__PURE__ */ ve.define(), g0 = /* @__PURE__ */ ve.define({
  combine: (t) => t.some((e) => e),
  static: !0
}), A8 = /* @__PURE__ */ ve.define({
  combine: (t) => t.length ? t[0] : void 0,
  static: !0
}), D8 = /* @__PURE__ */ ve.define(), T8 = /* @__PURE__ */ ve.define(), O8 = /* @__PURE__ */ ve.define(), E8 = /* @__PURE__ */ ve.define({
  combine: (t) => t.length ? t[0] : !1
});
class Ti {
  /**
  @internal
  */
  constructor(e, n) {
    this.type = e, this.value = n;
  }
  /**
  Define a new type of annotation.
  */
  static define() {
    return new yW();
  }
}
class yW {
  /**
  Create an instance of this annotation.
  */
  of(e) {
    return new Ti(this, e);
  }
}
class bW {
  /**
  @internal
  */
  constructor(e) {
    this.map = e;
  }
  /**
  Create a [state effect](https://codemirror.net/6/docs/ref/#state.StateEffect) instance of this
  type.
  */
  of(e) {
    return new De(this, e);
  }
}
class De {
  /**
  @internal
  */
  constructor(e, n) {
    this.type = e, this.value = n;
  }
  /**
  Map this effect through a position mapping. Will return
  `undefined` when that ends up deleting the effect.
  */
  map(e) {
    let n = this.type.map(this.value, e);
    return n === void 0 ? void 0 : n == this.value ? this : new De(this.type, n);
  }
  /**
  Tells you whether this effect object is of a given
  [type](https://codemirror.net/6/docs/ref/#state.StateEffectType).
  */
  is(e) {
    return this.type == e;
  }
  /**
  Define a new effect type. The type parameter indicates the type
  of values that his effect holds. It should be a type that
  doesn't include `undefined`, since that is used in
  [mapping](https://codemirror.net/6/docs/ref/#state.StateEffect.map) to indicate that an effect is
  removed.
  */
  static define(e = {}) {
    return new bW(e.map || ((n) => n));
  }
  /**
  Map an array of effects through a change set.
  */
  static mapEffects(e, n) {
    if (!e.length)
      return e;
    let r = [];
    for (let i of e) {
      let s = i.map(n);
      s && r.push(s);
    }
    return r;
  }
}
De.reconfigure = /* @__PURE__ */ De.define();
De.appendConfig = /* @__PURE__ */ De.define();
class vt {
  constructor(e, n, r, i, s, o) {
    this.startState = e, this.changes = n, this.selection = r, this.effects = i, this.annotations = s, this.scrollIntoView = o, this._doc = null, this._state = null, r && M8(r, n.newLength), s.some((a) => a.type == vt.time) || (this.annotations = s.concat(vt.time.of(Date.now())));
  }
  /**
  @internal
  */
  static create(e, n, r, i, s, o) {
    return new vt(e, n, r, i, s, o);
  }
  /**
  The new document produced by the transaction. Contrary to
  [`.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state)`.doc`, accessing this won't
  force the entire new state to be computed right away, so it is
  recommended that [transaction
  filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) use this getter
  when they need to look at the new document.
  */
  get newDoc() {
    return this._doc || (this._doc = this.changes.apply(this.startState.doc));
  }
  /**
  The new selection produced by the transaction. If
  [`this.selection`](https://codemirror.net/6/docs/ref/#state.Transaction.selection) is undefined,
  this will [map](https://codemirror.net/6/docs/ref/#state.EditorSelection.map) the start state's
  current selection through the changes made by the transaction.
  */
  get newSelection() {
    return this.selection || this.startState.selection.map(this.changes);
  }
  /**
  The new state created by the transaction. Computed on demand
  (but retained for subsequent access), so it is recommended not to
  access it in [transaction
  filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) when possible.
  */
  get state() {
    return this._state || this.startState.applyTransaction(this), this._state;
  }
  /**
  Get the value of the given annotation type, if any.
  */
  annotation(e) {
    for (let n of this.annotations)
      if (n.type == e)
        return n.value;
  }
  /**
  Indicates whether the transaction changed the document.
  */
  get docChanged() {
    return !this.changes.empty;
  }
  /**
  Indicates whether this transaction reconfigures the state
  (through a [configuration compartment](https://codemirror.net/6/docs/ref/#state.Compartment) or
  with a top-level configuration
  [effect](https://codemirror.net/6/docs/ref/#state.StateEffect^reconfigure).
  */
  get reconfigured() {
    return this.startState.config != this.state.config;
  }
  /**
  Returns true if the transaction has a [user
  event](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent) annotation that is equal to
  or more specific than `event`. For example, if the transaction
  has `"select.pointer"` as user event, `"select"` and
  `"select.pointer"` will match it.
  */
  isUserEvent(e) {
    let n = this.annotation(vt.userEvent);
    return !!(n && (n == e || n.length > e.length && n.slice(0, e.length) == e && n[e.length] == "."));
  }
}
vt.time = /* @__PURE__ */ Ti.define();
vt.userEvent = /* @__PURE__ */ Ti.define();
vt.addToHistory = /* @__PURE__ */ Ti.define();
vt.remote = /* @__PURE__ */ Ti.define();
function xW(t, e) {
  let n = [];
  for (let r = 0, i = 0; ; ) {
    let s, o;
    if (r < t.length && (i == e.length || e[i] >= t[r]))
      s = t[r++], o = t[r++];
    else if (i < e.length)
      s = e[i++], o = e[i++];
    else
      return n;
    !n.length || n[n.length - 1] < s ? n.push(s, o) : n[n.length - 1] < o && (n[n.length - 1] = o);
  }
}
function P8(t, e, n) {
  var r;
  let i, s, o;
  return n ? (i = e.changes, s = mt.empty(e.changes.length), o = t.changes.compose(e.changes)) : (i = e.changes.map(t.changes), s = t.changes.mapDesc(e.changes, !0), o = t.changes.compose(i)), {
    changes: o,
    selection: e.selection ? e.selection.map(s) : (r = t.selection) === null || r === void 0 ? void 0 : r.map(i),
    effects: De.mapEffects(t.effects, i).concat(De.mapEffects(e.effects, s)),
    annotations: t.annotations.length ? t.annotations.concat(e.annotations) : e.annotations,
    scrollIntoView: t.scrollIntoView || e.scrollIntoView
  };
}
function v0(t, e, n) {
  let r = e.selection, i = ta(e.annotations);
  return e.userEvent && (i = i.concat(vt.userEvent.of(e.userEvent))), {
    changes: e.changes instanceof mt ? e.changes : mt.of(e.changes || [], n, t.facet(A8)),
    selection: r && (r instanceof W ? r : W.single(r.anchor, r.head)),
    effects: ta(e.effects),
    annotations: i,
    scrollIntoView: !!e.scrollIntoView
  };
}
function L8(t, e, n) {
  let r = v0(t, e.length ? e[0] : {}, t.doc.length);
  e.length && e[0].filter === !1 && (n = !1);
  for (let s = 1; s < e.length; s++) {
    e[s].filter === !1 && (n = !1);
    let o = !!e[s].sequential;
    r = P8(r, v0(t, e[s], o ? r.changes.newLength : t.doc.length), o);
  }
  let i = vt.create(t, r.changes, r.selection, r.effects, r.annotations, r.scrollIntoView);
  return kW(n ? wW(i) : i);
}
function wW(t) {
  let e = t.startState, n = !0;
  for (let i of e.facet(D8)) {
    let s = i(t);
    if (s === !1) {
      n = !1;
      break;
    }
    Array.isArray(s) && (n = n === !0 ? s : xW(n, s));
  }
  if (n !== !0) {
    let i, s;
    if (n === !1)
      s = t.changes.invertedDesc, i = mt.empty(e.doc.length);
    else {
      let o = t.changes.filter(n);
      i = o.changes, s = o.filtered.mapDesc(o.changes).invertedDesc;
    }
    t = vt.create(e, i, t.selection && t.selection.map(s), De.mapEffects(t.effects, s), t.annotations, t.scrollIntoView);
  }
  let r = e.facet(T8);
  for (let i = r.length - 1; i >= 0; i--) {
    let s = r[i](t);
    s instanceof vt ? t = s : Array.isArray(s) && s.length == 1 && s[0] instanceof vt ? t = s[0] : t = L8(e, ta(s), !1);
  }
  return t;
}
function kW(t) {
  let e = t.startState, n = e.facet(O8), r = t;
  for (let i = n.length - 1; i >= 0; i--) {
    let s = n[i](t);
    s && Object.keys(s).length && (r = P8(r, v0(e, s, t.changes.newLength), !0));
  }
  return r == t ? t : vt.create(e, t.changes, t.selection, r.effects, r.annotations, r.scrollIntoView);
}
const _W = [];
function ta(t) {
  return t == null ? _W : Array.isArray(t) ? t : [t];
}
var tt = /* @__PURE__ */ function(t) {
  return t[t.Word = 0] = "Word", t[t.Space = 1] = "Space", t[t.Other = 2] = "Other", t;
}(tt || (tt = {}));
const SW = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
let y0;
try {
  y0 = /* @__PURE__ */ new RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
} catch (t) {
}
function MW(t) {
  if (y0)
    return y0.test(t);
  for (let e = 0; e < t.length; e++) {
    let n = t[e];
    if (/\w/.test(n) || n > "" && (n.toUpperCase() != n.toLowerCase() || SW.test(n)))
      return !0;
  }
  return !1;
}
function CW(t) {
  return (e) => {
    if (!/\S/.test(e))
      return tt.Space;
    if (MW(e))
      return tt.Word;
    for (let n = 0; n < t.length; n++)
      if (e.indexOf(t[n]) > -1)
        return tt.Word;
    return tt.Other;
  };
}
class Le {
  constructor(e, n, r, i, s, o) {
    this.config = e, this.doc = n, this.selection = r, this.values = i, this.status = e.statusTemplate.slice(), this.computeSlot = s, o && (o._state = this);
    for (let a = 0; a < this.config.dynamicSlots.length; a++)
      nc(this, a << 1);
    this.computeSlot = null;
  }
  field(e, n = !0) {
    let r = this.config.address[e.id];
    if (r == null) {
      if (n)
        throw new RangeError("Field is not present in this state");
      return;
    }
    return nc(this, r), Bh(this, r);
  }
  /**
  Create a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction) that updates this
  state. Any number of [transaction specs](https://codemirror.net/6/docs/ref/#state.TransactionSpec)
  can be passed. Unless
  [`sequential`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.sequential) is set, the
  [changes](https://codemirror.net/6/docs/ref/#state.TransactionSpec.changes) (if any) of each spec
  are assumed to start in the _current_ document (not the document
  produced by previous specs), and its
  [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) and
  [effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) are assumed to refer
  to the document created by its _own_ changes. The resulting
  transaction contains the combined effect of all the different
  specs. For [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection), later
  specs take precedence over earlier ones.
  */
  update(...e) {
    return L8(this, e, !0);
  }
  /**
  @internal
  */
  applyTransaction(e) {
    let n = this.config, { base: r, compartments: i } = n;
    for (let a of e.effects)
      a.is(yu.reconfigure) ? (n && (i = /* @__PURE__ */ new Map(), n.compartments.forEach((l, c) => i.set(c, l)), n = null), i.set(a.value.compartment, a.value.extension)) : a.is(De.reconfigure) ? (n = null, r = a.value) : a.is(De.appendConfig) && (n = null, r = ta(r).concat(a.value));
    let s;
    n ? s = e.startState.values.slice() : (n = Rh.resolve(r, i, this), s = new Le(n, this.doc, this.selection, n.dynamicSlots.map(() => null), (l, c) => c.reconfigure(l, this), null).values);
    let o = e.startState.facet(g0) ? e.newSelection : e.newSelection.asSingle();
    new Le(n, e.newDoc, o, s, (a, l) => l.update(a, e), e);
  }
  /**
  Create a [transaction spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec) that
  replaces every selection range with the given content.
  */
  replaceSelection(e) {
    return typeof e == "string" && (e = this.toText(e)), this.changeByRange((n) => ({
      changes: { from: n.from, to: n.to, insert: e },
      range: W.cursor(n.from + e.length)
    }));
  }
  /**
  Create a set of changes and a new selection by running the given
  function for each range in the active selection. The function
  can return an optional set of changes (in the coordinate space
  of the start document), plus an updated range (in the coordinate
  space of the document produced by the call's own changes). This
  method will merge all the changes and ranges into a single
  changeset and selection, and return it as a [transaction
  spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec), which can be passed to
  [`update`](https://codemirror.net/6/docs/ref/#state.EditorState.update).
  */
  changeByRange(e) {
    let n = this.selection, r = e(n.ranges[0]), i = this.changes(r.changes), s = [r.range], o = ta(r.effects);
    for (let a = 1; a < n.ranges.length; a++) {
      let l = e(n.ranges[a]), c = this.changes(l.changes), u = c.map(i);
      for (let f = 0; f < a; f++)
        s[f] = s[f].map(u);
      let h = i.mapDesc(c, !0);
      s.push(l.range.map(h)), i = i.compose(u), o = De.mapEffects(o, u).concat(De.mapEffects(ta(l.effects), h));
    }
    return {
      changes: i,
      selection: W.create(s, n.mainIndex),
      effects: o
    };
  }
  /**
  Create a [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet) from the given change
  description, taking the state's document length and line
  separator into account.
  */
  changes(e = []) {
    return e instanceof mt ? e : mt.of(e, this.doc.length, this.facet(Le.lineSeparator));
  }
  /**
  Using the state's [line
  separator](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator), create a
  [`Text`](https://codemirror.net/6/docs/ref/#state.Text) instance from the given string.
  */
  toText(e) {
    return ze.of(e.split(this.facet(Le.lineSeparator) || f0));
  }
  /**
  Return the given range of the document as a string.
  */
  sliceDoc(e = 0, n = this.doc.length) {
    return this.doc.sliceString(e, n, this.lineBreak);
  }
  /**
  Get the value of a state [facet](https://codemirror.net/6/docs/ref/#state.Facet).
  */
  facet(e) {
    let n = this.config.address[e.id];
    return n == null ? e.default : (nc(this, n), Bh(this, n));
  }
  /**
  Convert this state to a JSON-serializable object. When custom
  fields should be serialized, you can pass them in as an object
  mapping property names (in the resulting object, which should
  not use `doc` or `selection`) to fields.
  */
  toJSON(e) {
    let n = {
      doc: this.sliceDoc(),
      selection: this.selection.toJSON()
    };
    if (e)
      for (let r in e) {
        let i = e[r];
        i instanceof It && this.config.address[i.id] != null && (n[r] = i.spec.toJSON(this.field(e[r]), this));
      }
    return n;
  }
  /**
  Deserialize a state from its JSON representation. When custom
  fields should be deserialized, pass the same object you passed
  to [`toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) when serializing as
  third argument.
  */
  static fromJSON(e, n = {}, r) {
    if (!e || typeof e.doc != "string")
      throw new RangeError("Invalid JSON representation for EditorState");
    let i = [];
    if (r) {
      for (let s in r)
        if (Object.prototype.hasOwnProperty.call(e, s)) {
          let o = r[s], a = e[s];
          i.push(o.init((l) => o.spec.fromJSON(a, l)));
        }
    }
    return Le.create({
      doc: e.doc,
      selection: W.fromJSON(e.selection),
      extensions: n.extensions ? i.concat([n.extensions]) : i
    });
  }
  /**
  Create a new state. You'll usually only need this when
  initializing an editor—updated states are created by applying
  transactions.
  */
  static create(e = {}) {
    let n = Rh.resolve(e.extensions || [], /* @__PURE__ */ new Map()), r = e.doc instanceof ze ? e.doc : ze.of((e.doc || "").split(n.staticFacet(Le.lineSeparator) || f0)), i = e.selection ? e.selection instanceof W ? e.selection : W.single(e.selection.anchor, e.selection.head) : W.single(0);
    return M8(i, r.length), n.staticFacet(g0) || (i = i.asSingle()), new Le(n, r, i, n.dynamicSlots.map(() => null), (s, o) => o.create(s), null);
  }
  /**
  The size (in columns) of a tab in the document, determined by
  the [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) facet.
  */
  get tabSize() {
    return this.facet(Le.tabSize);
  }
  /**
  Get the proper [line-break](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator)
  string for this state.
  */
  get lineBreak() {
    return this.facet(Le.lineSeparator) || `
`;
  }
  /**
  Returns true when the editor is
  [configured](https://codemirror.net/6/docs/ref/#state.EditorState^readOnly) to be read-only.
  */
  get readOnly() {
    return this.facet(E8);
  }
  /**
  Look up a translation for the given phrase (via the
  [`phrases`](https://codemirror.net/6/docs/ref/#state.EditorState^phrases) facet), or return the
  original string if no translation is found.
  
  If additional arguments are passed, they will be inserted in
  place of markers like `$1` (for the first value) and `$2`, etc.
  A single `$` is equivalent to `$1`, and `$$` will produce a
  literal dollar sign.
  */
  phrase(e, ...n) {
    for (let r of this.facet(Le.phrases))
      if (Object.prototype.hasOwnProperty.call(r, e)) {
        e = r[e];
        break;
      }
    return n.length && (e = e.replace(/\$(\$|\d*)/g, (r, i) => {
      if (i == "$")
        return "$";
      let s = +(i || 1);
      return !s || s > n.length ? r : n[s - 1];
    })), e;
  }
  /**
  Find the values for a given language data field, provided by the
  the [`languageData`](https://codemirror.net/6/docs/ref/#state.EditorState^languageData) facet.
  
  Examples of language data fields are...
  
  - [`"commentTokens"`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) for specifying
    comment syntax.
  - [`"autocomplete"`](https://codemirror.net/6/docs/ref/#autocomplete.autocompletion^config.override)
    for providing language-specific completion sources.
  - [`"wordChars"`](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) for adding
    characters that should be considered part of words in this
    language.
  - [`"closeBrackets"`](https://codemirror.net/6/docs/ref/#autocomplete.CloseBracketConfig) controls
    bracket closing behavior.
  */
  languageDataAt(e, n, r = -1) {
    let i = [];
    for (let s of this.facet($8))
      for (let o of s(this, n, r))
        Object.prototype.hasOwnProperty.call(o, e) && i.push(o[e]);
    return i;
  }
  /**
  Return a function that can categorize strings (expected to
  represent a single [grapheme cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak))
  into one of:
  
   - Word (contains an alphanumeric character or a character
     explicitly listed in the local language's `"wordChars"`
     language data, which should be a string)
   - Space (contains only whitespace)
   - Other (anything else)
  */
  charCategorizer(e) {
    return CW(this.languageDataAt("wordChars", e).join(""));
  }
  /**
  Find the word at the given position, meaning the range
  containing all [word](https://codemirror.net/6/docs/ref/#state.CharCategory.Word) characters
  around it. If no word characters are adjacent to the position,
  this returns null.
  */
  wordAt(e) {
    let { text: n, from: r, length: i } = this.doc.lineAt(e), s = this.charCategorizer(e), o = e - r, a = e - r;
    for (; o > 0; ) {
      let l = Pt(n, o, !1);
      if (s(n.slice(l, o)) != tt.Word)
        break;
      o = l;
    }
    for (; a < i; ) {
      let l = Pt(n, a);
      if (s(n.slice(a, l)) != tt.Word)
        break;
      a = l;
    }
    return o == a ? null : W.range(o + r, a + r);
  }
}
Le.allowMultipleSelections = g0;
Le.tabSize = /* @__PURE__ */ ve.define({
  combine: (t) => t.length ? t[0] : 4
});
Le.lineSeparator = A8;
Le.readOnly = E8;
Le.phrases = /* @__PURE__ */ ve.define({
  compare(t, e) {
    let n = Object.keys(t), r = Object.keys(e);
    return n.length == r.length && n.every((i) => t[i] == e[i]);
  }
});
Le.languageData = $8;
Le.changeFilter = D8;
Le.transactionFilter = T8;
Le.transactionExtender = O8;
yu.reconfigure = /* @__PURE__ */ De.define();
function Jr(t, e, n = {}) {
  let r = {};
  for (let i of t)
    for (let s of Object.keys(i)) {
      let o = i[s], a = r[s];
      if (a === void 0)
        r[s] = o;
      else if (!(a === o || o === void 0)) if (Object.hasOwnProperty.call(n, s))
        r[s] = n[s](a, o);
      else
        throw new Error("Config merge conflict for field " + s);
    }
  for (let i in e)
    r[i] === void 0 && (r[i] = e[i]);
  return r;
}
class po {
  /**
  Compare this value with another value. Used when comparing
  rangesets. The default implementation compares by identity.
  Unless you are only creating a fixed number of unique instances
  of your value type, it is a good idea to implement this
  properly.
  */
  eq(e) {
    return this == e;
  }
  /**
  Create a [range](https://codemirror.net/6/docs/ref/#state.Range) with this value.
  */
  range(e, n = e) {
    return b0.create(e, n, this);
  }
}
po.prototype.startSide = po.prototype.endSide = 0;
po.prototype.point = !1;
po.prototype.mapMode = Qt.TrackDel;
let b0 = class N8 {
  constructor(e, n, r) {
    this.from = e, this.to = n, this.value = r;
  }
  /**
  @internal
  */
  static create(e, n, r) {
    return new N8(e, n, r);
  }
};
function x0(t, e) {
  return t.from - e.from || t.value.startSide - e.value.startSide;
}
class Y1 {
  constructor(e, n, r, i) {
    this.from = e, this.to = n, this.value = r, this.maxPoint = i;
  }
  get length() {
    return this.to[this.to.length - 1];
  }
  // Find the index of the given position and side. Use the ranges'
  // `from` pos when `end == false`, `to` when `end == true`.
  findIndex(e, n, r, i = 0) {
    let s = r ? this.to : this.from;
    for (let o = i, a = s.length; ; ) {
      if (o == a)
        return o;
      let l = o + a >> 1, c = s[l] - e || (r ? this.value[l].endSide : this.value[l].startSide) - n;
      if (l == o)
        return c >= 0 ? o : a;
      c >= 0 ? a = l : o = l + 1;
    }
  }
  between(e, n, r, i) {
    for (let s = this.findIndex(n, -1e9, !0), o = this.findIndex(r, 1e9, !1, s); s < o; s++)
      if (i(this.from[s] + e, this.to[s] + e, this.value[s]) === !1)
        return !1;
  }
  map(e, n) {
    let r = [], i = [], s = [], o = -1, a = -1;
    for (let l = 0; l < this.value.length; l++) {
      let c = this.value[l], u = this.from[l] + e, h = this.to[l] + e, f, d;
      if (u == h) {
        let p = n.mapPos(u, c.startSide, c.mapMode);
        if (p == null || (f = d = p, c.startSide != c.endSide && (d = n.mapPos(u, c.endSide), d < f)))
          continue;
      } else if (f = n.mapPos(u, c.startSide), d = n.mapPos(h, c.endSide), f > d || f == d && c.startSide > 0 && c.endSide <= 0)
        continue;
      (d - f || c.endSide - c.startSide) < 0 || (o < 0 && (o = f), c.point && (a = Math.max(a, d - f)), r.push(c), i.push(f - o), s.push(d - o));
    }
    return { mapped: r.length ? new Y1(i, s, r, a) : null, pos: o };
  }
}
class Be {
  constructor(e, n, r, i) {
    this.chunkPos = e, this.chunk = n, this.nextLayer = r, this.maxPoint = i;
  }
  /**
  @internal
  */
  static create(e, n, r, i) {
    return new Be(e, n, r, i);
  }
  /**
  @internal
  */
  get length() {
    let e = this.chunk.length - 1;
    return e < 0 ? 0 : Math.max(this.chunkEnd(e), this.nextLayer.length);
  }
  /**
  The number of ranges in the set.
  */
  get size() {
    if (this.isEmpty)
      return 0;
    let e = this.nextLayer.size;
    for (let n of this.chunk)
      e += n.value.length;
    return e;
  }
  /**
  @internal
  */
  chunkEnd(e) {
    return this.chunkPos[e] + this.chunk[e].length;
  }
  /**
  Update the range set, optionally adding new ranges or filtering
  out existing ones.
  
  (Note: The type parameter is just there as a kludge to work
  around TypeScript variance issues that prevented `RangeSet<X>`
  from being a subtype of `RangeSet<Y>` when `X` is a subtype of
  `Y`.)
  */
  update(e) {
    let { add: n = [], sort: r = !1, filterFrom: i = 0, filterTo: s = this.length } = e, o = e.filter;
    if (n.length == 0 && !o)
      return this;
    if (r && (n = n.slice().sort(x0)), this.isEmpty)
      return n.length ? Be.of(n) : this;
    let a = new I8(this, null, -1).goto(0), l = 0, c = [], u = new ds();
    for (; a.value || l < n.length; )
      if (l < n.length && (a.from - n[l].from || a.startSide - n[l].value.startSide) >= 0) {
        let h = n[l++];
        u.addInner(h.from, h.to, h.value) || c.push(h);
      } else a.rangeIndex == 1 && a.chunkIndex < this.chunk.length && (l == n.length || this.chunkEnd(a.chunkIndex) < n[l].from) && (!o || i > this.chunkEnd(a.chunkIndex) || s < this.chunkPos[a.chunkIndex]) && u.addChunk(this.chunkPos[a.chunkIndex], this.chunk[a.chunkIndex]) ? a.nextChunk() : ((!o || i > a.to || s < a.from || o(a.from, a.to, a.value)) && (u.addInner(a.from, a.to, a.value) || c.push(b0.create(a.from, a.to, a.value))), a.next());
    return u.finishInner(this.nextLayer.isEmpty && !c.length ? Be.empty : this.nextLayer.update({ add: c, filter: o, filterFrom: i, filterTo: s }));
  }
  /**
  Map this range set through a set of changes, return the new set.
  */
  map(e) {
    if (e.empty || this.isEmpty)
      return this;
    let n = [], r = [], i = -1;
    for (let o = 0; o < this.chunk.length; o++) {
      let a = this.chunkPos[o], l = this.chunk[o], c = e.touchesRange(a, a + l.length);
      if (c === !1)
        i = Math.max(i, l.maxPoint), n.push(l), r.push(e.mapPos(a));
      else if (c === !0) {
        let { mapped: u, pos: h } = l.map(a, e);
        u && (i = Math.max(i, u.maxPoint), n.push(u), r.push(h));
      }
    }
    let s = this.nextLayer.map(e);
    return n.length == 0 ? s : new Be(r, n, s || Be.empty, i);
  }
  /**
  Iterate over the ranges that touch the region `from` to `to`,
  calling `f` for each. There is no guarantee that the ranges will
  be reported in any specific order. When the callback returns
  `false`, iteration stops.
  */
  between(e, n, r) {
    if (!this.isEmpty) {
      for (let i = 0; i < this.chunk.length; i++) {
        let s = this.chunkPos[i], o = this.chunk[i];
        if (n >= s && e <= s + o.length && o.between(s, e - s, n - s, r) === !1)
          return;
      }
      this.nextLayer.between(e, n, r);
    }
  }
  /**
  Iterate over the ranges in this set, in order, including all
  ranges that end at or after `from`.
  */
  iter(e = 0) {
    return $c.from([this]).goto(e);
  }
  /**
  @internal
  */
  get isEmpty() {
    return this.nextLayer == this;
  }
  /**
  Iterate over the ranges in a collection of sets, in order,
  starting from `from`.
  */
  static iter(e, n = 0) {
    return $c.from(e).goto(n);
  }
  /**
  Iterate over two groups of sets, calling methods on `comparator`
  to notify it of possible differences.
  */
  static compare(e, n, r, i, s = -1) {
    let o = e.filter((h) => h.maxPoint > 0 || !h.isEmpty && h.maxPoint >= s), a = n.filter((h) => h.maxPoint > 0 || !h.isEmpty && h.maxPoint >= s), l = O2(o, a, r), c = new ml(o, l, s), u = new ml(a, l, s);
    r.iterGaps((h, f, d) => E2(c, h, u, f, d, i)), r.empty && r.length == 0 && E2(c, 0, u, 0, 0, i);
  }
  /**
  Compare the contents of two groups of range sets, returning true
  if they are equivalent in the given range.
  */
  static eq(e, n, r = 0, i) {
    i == null && (i = 999999999);
    let s = e.filter((u) => !u.isEmpty && n.indexOf(u) < 0), o = n.filter((u) => !u.isEmpty && e.indexOf(u) < 0);
    if (s.length != o.length)
      return !1;
    if (!s.length)
      return !0;
    let a = O2(s, o), l = new ml(s, a, 0).goto(r), c = new ml(o, a, 0).goto(r);
    for (; ; ) {
      if (l.to != c.to || !w0(l.active, c.active) || l.point && (!c.point || !l.point.eq(c.point)))
        return !1;
      if (l.to > i)
        return !0;
      l.next(), c.next();
    }
  }
  /**
  Iterate over a group of range sets at the same time, notifying
  the iterator about the ranges covering every given piece of
  content. Returns the open count (see
  [`SpanIterator.span`](https://codemirror.net/6/docs/ref/#state.SpanIterator.span)) at the end
  of the iteration.
  */
  static spans(e, n, r, i, s = -1) {
    let o = new ml(e, null, s).goto(n), a = n, l = o.openStart;
    for (; ; ) {
      let c = Math.min(o.to, r);
      if (o.point) {
        let u = o.activeForPoint(o.to), h = o.pointFrom < n ? u.length + 1 : o.point.startSide < 0 ? u.length : Math.min(u.length, l);
        i.point(a, c, o.point, u, h, o.pointRank), l = Math.min(o.openEnd(c), u.length);
      } else c > a && (i.span(a, c, o.active, l), l = o.openEnd(c));
      if (o.to > r)
        return l + (o.point && o.to > r ? 1 : 0);
      a = o.to, o.next();
    }
  }
  /**
  Create a range set for the given range or array of ranges. By
  default, this expects the ranges to be _sorted_ (by start
  position and, if two start at the same position,
  `value.startSide`). You can pass `true` as second argument to
  cause the method to sort them.
  */
  static of(e, n = !1) {
    let r = new ds();
    for (let i of e instanceof b0 ? [e] : n ? $W(e) : e)
      r.add(i.from, i.to, i.value);
    return r.finish();
  }
  /**
  Join an array of range sets into a single set.
  */
  static join(e) {
    if (!e.length)
      return Be.empty;
    let n = e[e.length - 1];
    for (let r = e.length - 2; r >= 0; r--)
      for (let i = e[r]; i != Be.empty; i = i.nextLayer)
        n = new Be(i.chunkPos, i.chunk, n, Math.max(i.maxPoint, n.maxPoint));
    return n;
  }
}
Be.empty = /* @__PURE__ */ new Be([], [], null, -1);
function $W(t) {
  if (t.length > 1)
    for (let e = t[0], n = 1; n < t.length; n++) {
      let r = t[n];
      if (x0(e, r) > 0)
        return t.slice().sort(x0);
      e = r;
    }
  return t;
}
Be.empty.nextLayer = Be.empty;
class ds {
  finishChunk(e) {
    this.chunks.push(new Y1(this.from, this.to, this.value, this.maxPoint)), this.chunkPos.push(this.chunkStart), this.chunkStart = -1, this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint), this.maxPoint = -1, e && (this.from = [], this.to = [], this.value = []);
  }
  /**
  Create an empty builder.
  */
  constructor() {
    this.chunks = [], this.chunkPos = [], this.chunkStart = -1, this.last = null, this.lastFrom = -1e9, this.lastTo = -1e9, this.from = [], this.to = [], this.value = [], this.maxPoint = -1, this.setMaxPoint = -1, this.nextLayer = null;
  }
  /**
  Add a range. Ranges should be added in sorted (by `from` and
  `value.startSide`) order.
  */
  add(e, n, r) {
    this.addInner(e, n, r) || (this.nextLayer || (this.nextLayer = new ds())).add(e, n, r);
  }
  /**
  @internal
  */
  addInner(e, n, r) {
    let i = e - this.lastTo || r.startSide - this.last.endSide;
    if (i <= 0 && (e - this.lastFrom || r.startSide - this.last.startSide) < 0)
      throw new Error("Ranges must be added sorted by `from` position and `startSide`");
    return i < 0 ? !1 : (this.from.length == 250 && this.finishChunk(!0), this.chunkStart < 0 && (this.chunkStart = e), this.from.push(e - this.chunkStart), this.to.push(n - this.chunkStart), this.last = r, this.lastFrom = e, this.lastTo = n, this.value.push(r), r.point && (this.maxPoint = Math.max(this.maxPoint, n - e)), !0);
  }
  /**
  @internal
  */
  addChunk(e, n) {
    if ((e - this.lastTo || n.value[0].startSide - this.last.endSide) < 0)
      return !1;
    this.from.length && this.finishChunk(!0), this.setMaxPoint = Math.max(this.setMaxPoint, n.maxPoint), this.chunks.push(n), this.chunkPos.push(e);
    let r = n.value.length - 1;
    return this.last = n.value[r], this.lastFrom = n.from[r] + e, this.lastTo = n.to[r] + e, !0;
  }
  /**
  Finish the range set. Returns the new set. The builder can't be
  used anymore after this has been called.
  */
  finish() {
    return this.finishInner(Be.empty);
  }
  /**
  @internal
  */
  finishInner(e) {
    if (this.from.length && this.finishChunk(!1), this.chunks.length == 0)
      return e;
    let n = Be.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(e) : e, this.setMaxPoint);
    return this.from = null, n;
  }
}
function O2(t, e, n) {
  let r = /* @__PURE__ */ new Map();
  for (let s of t)
    for (let o = 0; o < s.chunk.length; o++)
      s.chunk[o].maxPoint <= 0 && r.set(s.chunk[o], s.chunkPos[o]);
  let i = /* @__PURE__ */ new Set();
  for (let s of e)
    for (let o = 0; o < s.chunk.length; o++) {
      let a = r.get(s.chunk[o]);
      a != null && (n ? n.mapPos(a) : a) == s.chunkPos[o] && !(n != null && n.touchesRange(a, a + s.chunk[o].length)) && i.add(s.chunk[o]);
    }
  return i;
}
class I8 {
  constructor(e, n, r, i = 0) {
    this.layer = e, this.skip = n, this.minPoint = r, this.rank = i;
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  get endSide() {
    return this.value ? this.value.endSide : 0;
  }
  goto(e, n = -1e9) {
    return this.chunkIndex = this.rangeIndex = 0, this.gotoInner(e, n, !1), this;
  }
  gotoInner(e, n, r) {
    for (; this.chunkIndex < this.layer.chunk.length; ) {
      let i = this.layer.chunk[this.chunkIndex];
      if (!(this.skip && this.skip.has(i) || this.layer.chunkEnd(this.chunkIndex) < e || i.maxPoint < this.minPoint))
        break;
      this.chunkIndex++, r = !1;
    }
    if (this.chunkIndex < this.layer.chunk.length) {
      let i = this.layer.chunk[this.chunkIndex].findIndex(e - this.layer.chunkPos[this.chunkIndex], n, !0);
      (!r || this.rangeIndex < i) && this.setRangeIndex(i);
    }
    this.next();
  }
  forward(e, n) {
    (this.to - e || this.endSide - n) < 0 && this.gotoInner(e, n, !0);
  }
  next() {
    for (; ; )
      if (this.chunkIndex == this.layer.chunk.length) {
        this.from = this.to = 1e9, this.value = null;
        break;
      } else {
        let e = this.layer.chunkPos[this.chunkIndex], n = this.layer.chunk[this.chunkIndex], r = e + n.from[this.rangeIndex];
        if (this.from = r, this.to = e + n.to[this.rangeIndex], this.value = n.value[this.rangeIndex], this.setRangeIndex(this.rangeIndex + 1), this.minPoint < 0 || this.value.point && this.to - this.from >= this.minPoint)
          break;
      }
  }
  setRangeIndex(e) {
    if (e == this.layer.chunk[this.chunkIndex].value.length) {
      if (this.chunkIndex++, this.skip)
        for (; this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]); )
          this.chunkIndex++;
      this.rangeIndex = 0;
    } else
      this.rangeIndex = e;
  }
  nextChunk() {
    this.chunkIndex++, this.rangeIndex = 0, this.next();
  }
  compare(e) {
    return this.from - e.from || this.startSide - e.startSide || this.rank - e.rank || this.to - e.to || this.endSide - e.endSide;
  }
}
class $c {
  constructor(e) {
    this.heap = e;
  }
  static from(e, n = null, r = -1) {
    let i = [];
    for (let s = 0; s < e.length; s++)
      for (let o = e[s]; !o.isEmpty; o = o.nextLayer)
        o.maxPoint >= r && i.push(new I8(o, n, r, s));
    return i.length == 1 ? i[0] : new $c(i);
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  goto(e, n = -1e9) {
    for (let r of this.heap)
      r.goto(e, n);
    for (let r = this.heap.length >> 1; r >= 0; r--)
      ym(this.heap, r);
    return this.next(), this;
  }
  forward(e, n) {
    for (let r of this.heap)
      r.forward(e, n);
    for (let r = this.heap.length >> 1; r >= 0; r--)
      ym(this.heap, r);
    (this.to - e || this.value.endSide - n) < 0 && this.next();
  }
  next() {
    if (this.heap.length == 0)
      this.from = this.to = 1e9, this.value = null, this.rank = -1;
    else {
      let e = this.heap[0];
      this.from = e.from, this.to = e.to, this.value = e.value, this.rank = e.rank, e.value && e.next(), ym(this.heap, 0);
    }
  }
}
function ym(t, e) {
  for (let n = t[e]; ; ) {
    let r = (e << 1) + 1;
    if (r >= t.length)
      break;
    let i = t[r];
    if (r + 1 < t.length && i.compare(t[r + 1]) >= 0 && (i = t[r + 1], r++), n.compare(i) < 0)
      break;
    t[r] = n, t[e] = i, e = r;
  }
}
class ml {
  constructor(e, n, r) {
    this.minPoint = r, this.active = [], this.activeTo = [], this.activeRank = [], this.minActive = -1, this.point = null, this.pointFrom = 0, this.pointRank = 0, this.to = -1e9, this.endSide = 0, this.openStart = -1, this.cursor = $c.from(e, n, r);
  }
  goto(e, n = -1e9) {
    return this.cursor.goto(e, n), this.active.length = this.activeTo.length = this.activeRank.length = 0, this.minActive = -1, this.to = e, this.endSide = n, this.openStart = -1, this.next(), this;
  }
  forward(e, n) {
    for (; this.minActive > -1 && (this.activeTo[this.minActive] - e || this.active[this.minActive].endSide - n) < 0; )
      this.removeActive(this.minActive);
    this.cursor.forward(e, n);
  }
  removeActive(e) {
    Ju(this.active, e), Ju(this.activeTo, e), Ju(this.activeRank, e), this.minActive = P2(this.active, this.activeTo);
  }
  addActive(e) {
    let n = 0, { value: r, to: i, rank: s } = this.cursor;
    for (; n < this.activeRank.length && (s - this.activeRank[n] || i - this.activeTo[n]) > 0; )
      n++;
    Qu(this.active, n, r), Qu(this.activeTo, n, i), Qu(this.activeRank, n, s), e && Qu(e, n, this.cursor.from), this.minActive = P2(this.active, this.activeTo);
  }
  // After calling this, if `this.point` != null, the next range is a
  // point. Otherwise, it's a regular range, covered by `this.active`.
  next() {
    let e = this.to, n = this.point;
    this.point = null;
    let r = this.openStart < 0 ? [] : null;
    for (; ; ) {
      let i = this.minActive;
      if (i > -1 && (this.activeTo[i] - this.cursor.from || this.active[i].endSide - this.cursor.startSide) < 0) {
        if (this.activeTo[i] > e) {
          this.to = this.activeTo[i], this.endSide = this.active[i].endSide;
          break;
        }
        this.removeActive(i), r && Ju(r, i);
      } else if (this.cursor.value)
        if (this.cursor.from > e) {
          this.to = this.cursor.from, this.endSide = this.cursor.startSide;
          break;
        } else {
          let s = this.cursor.value;
          if (!s.point)
            this.addActive(r), this.cursor.next();
          else if (n && this.cursor.to == this.to && this.cursor.from < this.cursor.to)
            this.cursor.next();
          else {
            this.point = s, this.pointFrom = this.cursor.from, this.pointRank = this.cursor.rank, this.to = this.cursor.to, this.endSide = s.endSide, this.cursor.next(), this.forward(this.to, this.endSide);
            break;
          }
        }
      else {
        this.to = this.endSide = 1e9;
        break;
      }
    }
    if (r) {
      this.openStart = 0;
      for (let i = r.length - 1; i >= 0 && r[i] < e; i--)
        this.openStart++;
    }
  }
  activeForPoint(e) {
    if (!this.active.length)
      return this.active;
    let n = [];
    for (let r = this.active.length - 1; r >= 0 && !(this.activeRank[r] < this.pointRank); r--)
      (this.activeTo[r] > e || this.activeTo[r] == e && this.active[r].endSide >= this.point.endSide) && n.push(this.active[r]);
    return n.reverse();
  }
  openEnd(e) {
    let n = 0;
    for (let r = this.activeTo.length - 1; r >= 0 && this.activeTo[r] > e; r--)
      n++;
    return n;
  }
}
function E2(t, e, n, r, i, s) {
  t.goto(e), n.goto(r);
  let o = r + i, a = r, l = r - e;
  for (; ; ) {
    let c = t.to + l - n.to || t.endSide - n.endSide, u = c < 0 ? t.to + l : n.to, h = Math.min(u, o);
    if (t.point || n.point ? t.point && n.point && (t.point == n.point || t.point.eq(n.point)) && w0(t.activeForPoint(t.to), n.activeForPoint(n.to)) || s.comparePoint(a, h, t.point, n.point) : h > a && !w0(t.active, n.active) && s.compareRange(a, h, t.active, n.active), u > o)
      break;
    a = u, c <= 0 && t.next(), c >= 0 && n.next();
  }
}
function w0(t, e) {
  if (t.length != e.length)
    return !1;
  for (let n = 0; n < t.length; n++)
    if (t[n] != e[n] && !t[n].eq(e[n]))
      return !1;
  return !0;
}
function Ju(t, e) {
  for (let n = e, r = t.length - 1; n < r; n++)
    t[n] = t[n + 1];
  t.pop();
}
function Qu(t, e, n) {
  for (let r = t.length - 1; r >= e; r--)
    t[r + 1] = t[r];
  t[e] = n;
}
function P2(t, e) {
  let n = -1, r = 1e9;
  for (let i = 0; i < e.length; i++)
    (e[i] - r || t[i].endSide - t[n].endSide) < 0 && (n = i, r = e[i]);
  return n;
}
function Ua(t, e, n = t.length) {
  let r = 0;
  for (let i = 0; i < n; )
    t.charCodeAt(i) == 9 ? (r += e - r % e, i++) : (r++, i = Pt(t, i));
  return r;
}
function k0(t, e, n, r) {
  for (let i = 0, s = 0; ; ) {
    if (s >= e)
      return i;
    if (i == t.length)
      break;
    s += t.charCodeAt(i) == 9 ? n - s % n : 1, i = Pt(t, i);
  }
  return r === !0 ? -1 : t.length;
}
const _0 = "ͼ", L2 = typeof Symbol == "undefined" ? "__" + _0 : Symbol.for(_0), S0 = typeof Symbol == "undefined" ? "__styleSet" + Math.floor(Math.random() * 1e8) : Symbol("styleSet"), N2 = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : {};
class ps {
  // :: (Object<Style>, ?{finish: ?(string) → string})
  // Create a style module from the given spec.
  //
  // When `finish` is given, it is called on regular (non-`@`)
  // selectors (after `&` expansion) to compute the final selector.
  constructor(e, n) {
    this.rules = [];
    let { finish: r } = n || {};
    function i(o) {
      return /^@/.test(o) ? [o] : o.split(/,\s*/);
    }
    function s(o, a, l, c) {
      let u = [], h = /^@(\w+)\b/.exec(o[0]), f = h && h[1] == "keyframes";
      if (h && a == null) return l.push(o[0] + ";");
      for (let d in a) {
        let p = a[d];
        if (/&/.test(d))
          s(
            d.split(/,\s*/).map((m) => o.map((v) => m.replace(/&/, v))).reduce((m, v) => m.concat(v)),
            p,
            l
          );
        else if (p && typeof p == "object") {
          if (!h) throw new RangeError("The value of a property (" + d + ") should be a primitive value.");
          s(i(d), p, u, f);
        } else p != null && u.push(d.replace(/_.*/, "").replace(/[A-Z]/g, (m) => "-" + m.toLowerCase()) + ": " + p + ";");
      }
      (u.length || f) && l.push((r && !h && !c ? o.map(r) : o).join(", ") + " {" + u.join(" ") + "}");
    }
    for (let o in e) s(i(o), e[o], this.rules);
  }
  // :: () → string
  // Returns a string containing the module's CSS rules.
  getRules() {
    return this.rules.join(`
`);
  }
  // :: () → string
  // Generate a new unique CSS class name.
  static newName() {
    let e = N2[L2] || 1;
    return N2[L2] = e + 1, _0 + e.toString(36);
  }
  // :: (union<Document, ShadowRoot>, union<[StyleModule], StyleModule>, ?{nonce: ?string})
  //
  // Mount the given set of modules in the given DOM root, which ensures
  // that the CSS rules defined by the module are available in that
  // context.
  //
  // Rules are only added to the document once per root.
  //
  // Rule order will follow the order of the modules, so that rules from
  // modules later in the array take precedence of those from earlier
  // modules. If you call this function multiple times for the same root
  // in a way that changes the order of already mounted modules, the old
  // order will be changed.
  //
  // If a Content Security Policy nonce is provided, it is added to
  // the `<style>` tag generated by the library.
  static mount(e, n, r) {
    let i = e[S0], s = r && r.nonce;
    i ? s && i.setNonce(s) : i = new AW(e, s), i.mount(Array.isArray(n) ? n : [n], e);
  }
}
let I2 = /* @__PURE__ */ new Map();
class AW {
  constructor(e, n) {
    let r = e.ownerDocument || e, i = r.defaultView;
    if (!e.head && e.adoptedStyleSheets && i.CSSStyleSheet) {
      let s = I2.get(r);
      if (s) return e[S0] = s;
      this.sheet = new i.CSSStyleSheet(), I2.set(r, this);
    } else
      this.styleTag = r.createElement("style"), n && this.styleTag.setAttribute("nonce", n);
    this.modules = [], e[S0] = this;
  }
  mount(e, n) {
    let r = this.sheet, i = 0, s = 0;
    for (let o = 0; o < e.length; o++) {
      let a = e[o], l = this.modules.indexOf(a);
      if (l < s && l > -1 && (this.modules.splice(l, 1), s--, l = -1), l == -1) {
        if (this.modules.splice(s++, 0, a), r) for (let c = 0; c < a.rules.length; c++)
          r.insertRule(a.rules[c], i++);
      } else {
        for (; s < l; ) i += this.modules[s++].rules.length;
        i += a.rules.length, s++;
      }
    }
    if (r)
      n.adoptedStyleSheets.indexOf(this.sheet) < 0 && (n.adoptedStyleSheets = [this.sheet, ...n.adoptedStyleSheets]);
    else {
      let o = "";
      for (let l = 0; l < this.modules.length; l++)
        o += this.modules[l].getRules() + `
`;
      this.styleTag.textContent = o;
      let a = n.head || n;
      this.styleTag.parentNode != a && a.insertBefore(this.styleTag, a.firstChild);
    }
  }
  setNonce(e) {
    this.styleTag && this.styleTag.getAttribute("nonce") != e && this.styleTag.setAttribute("nonce", e);
  }
}
var ms = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, Ac = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, DW = typeof navigator != "undefined" && /Mac/.test(navigator.platform), TW = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var Tt = 0; Tt < 10; Tt++) ms[48 + Tt] = ms[96 + Tt] = String(Tt);
for (var Tt = 1; Tt <= 24; Tt++) ms[Tt + 111] = "F" + Tt;
for (var Tt = 65; Tt <= 90; Tt++)
  ms[Tt] = String.fromCharCode(Tt + 32), Ac[Tt] = String.fromCharCode(Tt);
for (var bm in ms) Ac.hasOwnProperty(bm) || (Ac[bm] = ms[bm]);
function OW(t) {
  var e = DW && t.metaKey && t.shiftKey && !t.ctrlKey && !t.altKey || TW && t.shiftKey && t.key && t.key.length == 1 || t.key == "Unidentified", n = !e && t.key || (t.shiftKey ? Ac : ms)[t.keyCode] || t.key || "Unidentified";
  return n == "Esc" && (n = "Escape"), n == "Del" && (n = "Delete"), n == "Left" && (n = "ArrowLeft"), n == "Up" && (n = "ArrowUp"), n == "Right" && (n = "ArrowRight"), n == "Down" && (n = "ArrowDown"), n;
}
function Dc(t) {
  let e;
  return t.nodeType == 11 ? e = t.getSelection ? t : t.ownerDocument : e = t, e.getSelection();
}
function M0(t, e) {
  return e ? t == e || t.contains(e.nodeType != 1 ? e.parentNode : e) : !1;
}
function EW(t) {
  let e = t.activeElement;
  for (; e && e.shadowRoot; )
    e = e.shadowRoot.activeElement;
  return e;
}
function Rf(t, e) {
  if (!e.anchorNode)
    return !1;
  try {
    return M0(t, e.anchorNode);
  } catch (n) {
    return !1;
  }
}
function Ca(t) {
  return t.nodeType == 3 ? go(t, 0, t.nodeValue.length).getClientRects() : t.nodeType == 1 ? t.getClientRects() : [];
}
function rc(t, e, n, r) {
  return n ? R2(t, e, n, r, -1) || R2(t, e, n, r, 1) : !1;
}
function mo(t) {
  for (var e = 0; ; e++)
    if (t = t.previousSibling, !t)
      return e;
}
function Fh(t) {
  return t.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(t.nodeName);
}
function R2(t, e, n, r, i) {
  for (; ; ) {
    if (t == n && e == r)
      return !0;
    if (e == (i < 0 ? 0 : ki(t))) {
      if (t.nodeName == "DIV")
        return !1;
      let s = t.parentNode;
      if (!s || s.nodeType != 1)
        return !1;
      e = mo(t) + (i < 0 ? 0 : 1), t = s;
    } else if (t.nodeType == 1) {
      if (t = t.childNodes[e + (i < 0 ? -1 : 0)], t.nodeType == 1 && t.contentEditable == "false")
        return !1;
      e = i < 0 ? ki(t) : 0;
    } else
      return !1;
  }
}
function ki(t) {
  return t.nodeType == 3 ? t.nodeValue.length : t.childNodes.length;
}
function sp(t, e) {
  let n = e ? t.left : t.right;
  return { left: n, right: n, top: t.top, bottom: t.bottom };
}
function PW(t) {
  let e = t.visualViewport;
  return e ? {
    left: 0,
    right: e.width,
    top: 0,
    bottom: e.height
  } : {
    left: 0,
    right: t.innerWidth,
    top: 0,
    bottom: t.innerHeight
  };
}
function R8(t, e) {
  let n = e.width / t.offsetWidth, r = e.height / t.offsetHeight;
  return (n > 0.995 && n < 1.005 || !isFinite(n) || Math.abs(e.width - t.offsetWidth) < 1) && (n = 1), (r > 0.995 && r < 1.005 || !isFinite(r) || Math.abs(e.height - t.offsetHeight) < 1) && (r = 1), { scaleX: n, scaleY: r };
}
function LW(t, e, n, r, i, s, o, a) {
  let l = t.ownerDocument, c = l.defaultView || window;
  for (let u = t, h = !1; u && !h; )
    if (u.nodeType == 1) {
      let f, d = u == l.body, p = 1, m = 1;
      if (d)
        f = PW(c);
      else {
        if (/^(fixed|sticky)$/.test(getComputedStyle(u).position) && (h = !0), u.scrollHeight <= u.clientHeight && u.scrollWidth <= u.clientWidth) {
          u = u.assignedSlot || u.parentNode;
          continue;
        }
        let y = u.getBoundingClientRect();
        ({ scaleX: p, scaleY: m } = R8(u, y)), f = {
          left: y.left,
          right: y.left + u.clientWidth * p,
          top: y.top,
          bottom: y.top + u.clientHeight * m
        };
      }
      let v = 0, g = 0;
      if (i == "nearest")
        e.top < f.top ? (g = -(f.top - e.top + o), n > 0 && e.bottom > f.bottom + g && (g = e.bottom - f.bottom + g + o)) : e.bottom > f.bottom && (g = e.bottom - f.bottom + o, n < 0 && e.top - g < f.top && (g = -(f.top + g - e.top + o)));
      else {
        let y = e.bottom - e.top, x = f.bottom - f.top;
        g = (i == "center" && y <= x ? e.top + y / 2 - x / 2 : i == "start" || i == "center" && n < 0 ? e.top - o : e.bottom - x + o) - f.top;
      }
      if (r == "nearest" ? e.left < f.left ? (v = -(f.left - e.left + s), n > 0 && e.right > f.right + v && (v = e.right - f.right + v + s)) : e.right > f.right && (v = e.right - f.right + s, n < 0 && e.left < f.left + v && (v = -(f.left + v - e.left + s))) : v = (r == "center" ? e.left + (e.right - e.left) / 2 - (f.right - f.left) / 2 : r == "start" == a ? e.left - s : e.right - (f.right - f.left) + s) - f.left, v || g)
        if (d)
          c.scrollBy(v, g);
        else {
          let y = 0, x = 0;
          if (g) {
            let b = u.scrollTop;
            u.scrollTop += g / m, x = (u.scrollTop - b) * m;
          }
          if (v) {
            let b = u.scrollLeft;
            u.scrollLeft += v / p, y = (u.scrollLeft - b) * p;
          }
          e = {
            left: e.left - y,
            top: e.top - x,
            right: e.right - y,
            bottom: e.bottom - x
          }, y && Math.abs(y - v) < 1 && (r = "nearest"), x && Math.abs(x - g) < 1 && (i = "nearest");
        }
      if (d)
        break;
      u = u.assignedSlot || u.parentNode;
    } else if (u.nodeType == 11)
      u = u.host;
    else
      break;
}
function NW(t) {
  let e = t.ownerDocument, n, r;
  for (let i = t.parentNode; i && !(i == e.body || n && r); )
    if (i.nodeType == 1)
      !r && i.scrollHeight > i.clientHeight && (r = i), !n && i.scrollWidth > i.clientWidth && (n = i), i = i.assignedSlot || i.parentNode;
    else if (i.nodeType == 11)
      i = i.host;
    else
      break;
  return { x: n, y: r };
}
class IW {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  eq(e) {
    return this.anchorNode == e.anchorNode && this.anchorOffset == e.anchorOffset && this.focusNode == e.focusNode && this.focusOffset == e.focusOffset;
  }
  setRange(e) {
    let { anchorNode: n, focusNode: r } = e;
    this.set(n, Math.min(e.anchorOffset, n ? ki(n) : 0), r, Math.min(e.focusOffset, r ? ki(r) : 0));
  }
  set(e, n, r, i) {
    this.anchorNode = e, this.anchorOffset = n, this.focusNode = r, this.focusOffset = i;
  }
}
let Ro = null;
function B8(t) {
  if (t.setActive)
    return t.setActive();
  if (Ro)
    return t.focus(Ro);
  let e = [];
  for (let n = t; n && (e.push(n, n.scrollTop, n.scrollLeft), n != n.ownerDocument); n = n.parentNode)
    ;
  if (t.focus(Ro == null ? {
    get preventScroll() {
      return Ro = { preventScroll: !0 }, !0;
    }
  } : void 0), !Ro) {
    Ro = !1;
    for (let n = 0; n < e.length; ) {
      let r = e[n++], i = e[n++], s = e[n++];
      r.scrollTop != i && (r.scrollTop = i), r.scrollLeft != s && (r.scrollLeft = s);
    }
  }
}
let B2;
function go(t, e, n = e) {
  let r = B2 || (B2 = document.createRange());
  return r.setEnd(t, n), r.setStart(t, e), r;
}
function na(t, e, n, r) {
  let i = { key: e, code: e, keyCode: n, which: n, cancelable: !0 };
  r && ({ altKey: i.altKey, ctrlKey: i.ctrlKey, shiftKey: i.shiftKey, metaKey: i.metaKey } = r);
  let s = new KeyboardEvent("keydown", i);
  s.synthetic = !0, t.dispatchEvent(s);
  let o = new KeyboardEvent("keyup", i);
  return o.synthetic = !0, t.dispatchEvent(o), s.defaultPrevented || o.defaultPrevented;
}
function RW(t) {
  for (; t; ) {
    if (t && (t.nodeType == 9 || t.nodeType == 11 && t.host))
      return t;
    t = t.assignedSlot || t.parentNode;
  }
  return null;
}
function F8(t) {
  for (; t.attributes.length; )
    t.removeAttributeNode(t.attributes[0]);
}
function BW(t, e) {
  let n = e.focusNode, r = e.focusOffset;
  if (!n || e.anchorNode != n || e.anchorOffset != r)
    return !1;
  for (r = Math.min(r, ki(n)); ; )
    if (r) {
      if (n.nodeType != 1)
        return !1;
      let i = n.childNodes[r - 1];
      i.contentEditable == "false" ? r-- : (n = i, r = ki(n));
    } else {
      if (n == t)
        return !0;
      r = mo(n), n = n.parentNode;
    }
}
function z8(t) {
  return t.scrollTop > Math.max(1, t.scrollHeight - t.clientHeight - 4);
}
function V8(t, e) {
  for (let n = t, r = e; ; ) {
    if (n.nodeType == 3 && r > 0)
      return { node: n, offset: r };
    if (n.nodeType == 1 && r > 0) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[r - 1], r = ki(n);
    } else if (n.parentNode && !Fh(n))
      r = mo(n), n = n.parentNode;
    else
      return null;
  }
}
function H8(t, e) {
  for (let n = t, r = e; ; ) {
    if (n.nodeType == 3 && r < n.nodeValue.length)
      return { node: n, offset: r };
    if (n.nodeType == 1 && r < n.childNodes.length) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[r], r = 0;
    } else if (n.parentNode && !Fh(n))
      r = mo(n) + 1, n = n.parentNode;
    else
      return null;
  }
}
class zt {
  constructor(e, n, r = !0) {
    this.node = e, this.offset = n, this.precise = r;
  }
  static before(e, n) {
    return new zt(e.parentNode, mo(e), n);
  }
  static after(e, n) {
    return new zt(e.parentNode, mo(e) + 1, n);
  }
}
const W1 = [];
class qe {
  constructor() {
    this.parent = null, this.dom = null, this.flags = 2;
  }
  get overrideDOMText() {
    return null;
  }
  get posAtStart() {
    return this.parent ? this.parent.posBefore(this) : 0;
  }
  get posAtEnd() {
    return this.posAtStart + this.length;
  }
  posBefore(e) {
    let n = this.posAtStart;
    for (let r of this.children) {
      if (r == e)
        return n;
      n += r.length + r.breakAfter;
    }
    throw new RangeError("Invalid child in posBefore");
  }
  posAfter(e) {
    return this.posBefore(e) + e.length;
  }
  sync(e, n) {
    if (this.flags & 2) {
      let r = this.dom, i = null, s;
      for (let o of this.children) {
        if (o.flags & 7) {
          if (!o.dom && (s = i ? i.nextSibling : r.firstChild)) {
            let a = qe.get(s);
            (!a || !a.parent && a.canReuseDOM(o)) && o.reuseDOM(s);
          }
          o.sync(e, n), o.flags &= -8;
        }
        if (s = i ? i.nextSibling : r.firstChild, n && !n.written && n.node == r && s != o.dom && (n.written = !0), o.dom.parentNode == r)
          for (; s && s != o.dom; )
            s = F2(s);
        else
          r.insertBefore(o.dom, s);
        i = o.dom;
      }
      for (s = i ? i.nextSibling : r.firstChild, s && n && n.node == r && (n.written = !0); s; )
        s = F2(s);
    } else if (this.flags & 1)
      for (let r of this.children)
        r.flags & 7 && (r.sync(e, n), r.flags &= -8);
  }
  reuseDOM(e) {
  }
  localPosFromDOM(e, n) {
    let r;
    if (e == this.dom)
      r = this.dom.childNodes[n];
    else {
      let i = ki(e) == 0 ? 0 : n == 0 ? -1 : 1;
      for (; ; ) {
        let s = e.parentNode;
        if (s == this.dom)
          break;
        i == 0 && s.firstChild != s.lastChild && (e == s.firstChild ? i = -1 : i = 1), e = s;
      }
      i < 0 ? r = e : r = e.nextSibling;
    }
    if (r == this.dom.firstChild)
      return 0;
    for (; r && !qe.get(r); )
      r = r.nextSibling;
    if (!r)
      return this.length;
    for (let i = 0, s = 0; ; i++) {
      let o = this.children[i];
      if (o.dom == r)
        return s;
      s += o.length + o.breakAfter;
    }
  }
  domBoundsAround(e, n, r = 0) {
    let i = -1, s = -1, o = -1, a = -1;
    for (let l = 0, c = r, u = r; l < this.children.length; l++) {
      let h = this.children[l], f = c + h.length;
      if (c < e && f > n)
        return h.domBoundsAround(e, n, c);
      if (f >= e && i == -1 && (i = l, s = c), c > n && h.dom.parentNode == this.dom) {
        o = l, a = u;
        break;
      }
      u = f, c = f + h.breakAfter;
    }
    return {
      from: s,
      to: a < 0 ? r + this.length : a,
      startDOM: (i ? this.children[i - 1].dom.nextSibling : null) || this.dom.firstChild,
      endDOM: o < this.children.length && o >= 0 ? this.children[o].dom : null
    };
  }
  markDirty(e = !1) {
    this.flags |= 2, this.markParentsDirty(e);
  }
  markParentsDirty(e) {
    for (let n = this.parent; n; n = n.parent) {
      if (e && (n.flags |= 2), n.flags & 1)
        return;
      n.flags |= 1, e = !1;
    }
  }
  setParent(e) {
    this.parent != e && (this.parent = e, this.flags & 7 && this.markParentsDirty(!0));
  }
  setDOM(e) {
    this.dom != e && (this.dom && (this.dom.cmView = null), this.dom = e, e.cmView = this);
  }
  get rootView() {
    for (let e = this; ; ) {
      let n = e.parent;
      if (!n)
        return e;
      e = n;
    }
  }
  replaceChildren(e, n, r = W1) {
    this.markDirty();
    for (let i = e; i < n; i++) {
      let s = this.children[i];
      s.parent == this && r.indexOf(s) < 0 && s.destroy();
    }
    this.children.splice(e, n - e, ...r);
    for (let i = 0; i < r.length; i++)
      r[i].setParent(this);
  }
  ignoreMutation(e) {
    return !1;
  }
  ignoreEvent(e) {
    return !1;
  }
  childCursor(e = this.length) {
    return new Y8(this.children, e, this.children.length);
  }
  childPos(e, n = 1) {
    return this.childCursor().findPos(e, n);
  }
  toString() {
    let e = this.constructor.name.replace("View", "");
    return e + (this.children.length ? "(" + this.children.join() + ")" : this.length ? "[" + (e == "Text" ? this.text : this.length) + "]" : "") + (this.breakAfter ? "#" : "");
  }
  static get(e) {
    return e.cmView;
  }
  get isEditable() {
    return !0;
  }
  get isWidget() {
    return !1;
  }
  get isHidden() {
    return !1;
  }
  merge(e, n, r, i, s, o) {
    return !1;
  }
  become(e) {
    return !1;
  }
  canReuseDOM(e) {
    return e.constructor == this.constructor && !((this.flags | e.flags) & 8);
  }
  // When this is a zero-length view with a side, this should return a
  // number <= 0 to indicate it is before its position, or a
  // number > 0 when after its position.
  getSide() {
    return 0;
  }
  destroy() {
    for (let e of this.children)
      e.parent == this && e.destroy();
    this.parent = null;
  }
}
qe.prototype.breakAfter = 0;
function F2(t) {
  let e = t.nextSibling;
  return t.parentNode.removeChild(t), e;
}
class Y8 {
  constructor(e, n, r) {
    this.children = e, this.pos = n, this.i = r, this.off = 0;
  }
  findPos(e, n = 1) {
    for (; ; ) {
      if (e > this.pos || e == this.pos && (n > 0 || this.i == 0 || this.children[this.i - 1].breakAfter))
        return this.off = e - this.pos, this;
      let r = this.children[--this.i];
      this.pos -= r.length + r.breakAfter;
    }
  }
}
function W8(t, e, n, r, i, s, o, a, l) {
  let { children: c } = t, u = c.length ? c[e] : null, h = s.length ? s[s.length - 1] : null, f = h ? h.breakAfter : o;
  if (!(e == r && u && !o && !f && s.length < 2 && u.merge(n, i, s.length ? h : null, n == 0, a, l))) {
    if (r < c.length) {
      let d = c[r];
      d && (i < d.length || d.breakAfter && (h != null && h.breakAfter)) ? (e == r && (d = d.split(i), i = 0), !f && h && d.merge(0, i, h, !0, 0, l) ? s[s.length - 1] = d : ((i || d.children.length && !d.children[0].length) && d.merge(0, i, null, !1, 0, l), s.push(d))) : d != null && d.breakAfter && (h ? h.breakAfter = 1 : o = 1), r++;
    }
    for (u && (u.breakAfter = o, n > 0 && (!o && s.length && u.merge(n, u.length, s[0], !1, a, 0) ? u.breakAfter = s.shift().breakAfter : (n < u.length || u.children.length && u.children[u.children.length - 1].length == 0) && u.merge(n, u.length, null, !1, a, 0), e++)); e < r && s.length; )
      if (c[r - 1].become(s[s.length - 1]))
        r--, s.pop(), l = s.length ? 0 : a;
      else if (c[e].become(s[0]))
        e++, s.shift(), a = s.length ? 0 : l;
      else
        break;
    !s.length && e && r < c.length && !c[e - 1].breakAfter && c[r].merge(0, 0, c[e - 1], !1, a, l) && e--, (e < r || s.length) && t.replaceChildren(e, r, s);
  }
}
function j8(t, e, n, r, i, s) {
  let o = t.childCursor(), { i: a, off: l } = o.findPos(n, 1), { i: c, off: u } = o.findPos(e, -1), h = e - n;
  for (let f of r)
    h += f.length;
  t.length += h, W8(t, c, u, a, l, r, 0, i, s);
}
let an = typeof navigator != "undefined" ? navigator : { userAgent: "", vendor: "", platform: "" }, C0 = typeof document != "undefined" ? document : { documentElement: { style: {} } };
const $0 = /* @__PURE__ */ /Edge\/(\d+)/.exec(an.userAgent), q8 = /* @__PURE__ */ /MSIE \d/.test(an.userAgent), A0 = /* @__PURE__ */ /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(an.userAgent), op = !!(q8 || A0 || $0), z2 = !op && /* @__PURE__ */ /gecko\/(\d+)/i.test(an.userAgent), xm = !op && /* @__PURE__ */ /Chrome\/(\d+)/.exec(an.userAgent), V2 = "webkitFontSmoothing" in C0.documentElement.style, U8 = !op && /* @__PURE__ */ /Apple Computer/.test(an.vendor), H2 = U8 && (/* @__PURE__ */ /Mobile\/\w+/.test(an.userAgent) || an.maxTouchPoints > 2);
var me = {
  mac: H2 || /* @__PURE__ */ /Mac/.test(an.platform),
  windows: /* @__PURE__ */ /Win/.test(an.platform),
  linux: /* @__PURE__ */ /Linux|X11/.test(an.platform),
  ie: op,
  ie_version: q8 ? C0.documentMode || 6 : A0 ? +A0[1] : $0 ? +$0[1] : 0,
  gecko: z2,
  gecko_version: z2 ? +(/* @__PURE__ */ /Firefox\/(\d+)/.exec(an.userAgent) || [0, 0])[1] : 0,
  chrome: !!xm,
  chrome_version: xm ? +xm[1] : 0,
  ios: H2,
  android: /* @__PURE__ */ /Android\b/.test(an.userAgent),
  webkit: V2,
  safari: U8,
  webkit_version: V2 ? +(/* @__PURE__ */ /\bAppleWebKit\/(\d+)/.exec(an.userAgent) || [0, 0])[1] : 0,
  tabSize: C0.documentElement.style.tabSize != null ? "tab-size" : "-moz-tab-size"
};
const FW = 256;
class pr extends qe {
  constructor(e) {
    super(), this.text = e;
  }
  get length() {
    return this.text.length;
  }
  createDOM(e) {
    this.setDOM(e || document.createTextNode(this.text));
  }
  sync(e, n) {
    this.dom || this.createDOM(), this.dom.nodeValue != this.text && (n && n.node == this.dom && (n.written = !0), this.dom.nodeValue = this.text);
  }
  reuseDOM(e) {
    e.nodeType == 3 && this.createDOM(e);
  }
  merge(e, n, r) {
    return this.flags & 8 || r && (!(r instanceof pr) || this.length - (n - e) + r.length > FW || r.flags & 8) ? !1 : (this.text = this.text.slice(0, e) + (r ? r.text : "") + this.text.slice(n), this.markDirty(), !0);
  }
  split(e) {
    let n = new pr(this.text.slice(e));
    return this.text = this.text.slice(0, e), this.markDirty(), n.flags |= this.flags & 8, n;
  }
  localPosFromDOM(e, n) {
    return e == this.dom ? n : n ? this.text.length : 0;
  }
  domAtPos(e) {
    return new zt(this.dom, e);
  }
  domBoundsAround(e, n, r) {
    return { from: r, to: r + this.length, startDOM: this.dom, endDOM: this.dom.nextSibling };
  }
  coordsAt(e, n) {
    return zW(this.dom, e, n);
  }
}
class _i extends qe {
  constructor(e, n = [], r = 0) {
    super(), this.mark = e, this.children = n, this.length = r;
    for (let i of n)
      i.setParent(this);
  }
  setAttrs(e) {
    if (F8(e), this.mark.class && (e.className = this.mark.class), this.mark.attrs)
      for (let n in this.mark.attrs)
        e.setAttribute(n, this.mark.attrs[n]);
    return e;
  }
  canReuseDOM(e) {
    return super.canReuseDOM(e) && !((this.flags | e.flags) & 8);
  }
  reuseDOM(e) {
    e.nodeName == this.mark.tagName.toUpperCase() && (this.setDOM(e), this.flags |= 6);
  }
  sync(e, n) {
    this.dom ? this.flags & 4 && this.setAttrs(this.dom) : this.setDOM(this.setAttrs(document.createElement(this.mark.tagName))), super.sync(e, n);
  }
  merge(e, n, r, i, s, o) {
    return r && (!(r instanceof _i && r.mark.eq(this.mark)) || e && s <= 0 || n < this.length && o <= 0) ? !1 : (j8(this, e, n, r ? r.children.slice() : [], s - 1, o - 1), this.markDirty(), !0);
  }
  split(e) {
    let n = [], r = 0, i = -1, s = 0;
    for (let a of this.children) {
      let l = r + a.length;
      l > e && n.push(r < e ? a.split(e - r) : a), i < 0 && r >= e && (i = s), r = l, s++;
    }
    let o = this.length - e;
    return this.length = e, i > -1 && (this.children.length = i, this.markDirty()), new _i(this.mark, n, o);
  }
  domAtPos(e) {
    return K8(this, e);
  }
  coordsAt(e, n) {
    return X8(this, e, n);
  }
}
function zW(t, e, n) {
  let r = t.nodeValue.length;
  e > r && (e = r);
  let i = e, s = e, o = 0;
  e == 0 && n < 0 || e == r && n >= 0 ? me.chrome || me.gecko || (e ? (i--, o = 1) : s < r && (s++, o = -1)) : n < 0 ? i-- : s < r && s++;
  let a = go(t, i, s).getClientRects();
  if (!a.length)
    return null;
  let l = a[(o ? o < 0 : n >= 0) ? 0 : a.length - 1];
  return me.safari && !o && l.width == 0 && (l = Array.prototype.find.call(a, (c) => c.width) || l), o ? sp(l, o < 0) : l || null;
}
class Qi extends qe {
  static create(e, n, r) {
    return new Qi(e, n, r);
  }
  constructor(e, n, r) {
    super(), this.widget = e, this.length = n, this.side = r, this.prevWidget = null;
  }
  split(e) {
    let n = Qi.create(this.widget, this.length - e, this.side);
    return this.length -= e, n;
  }
  sync(e) {
    (!this.dom || !this.widget.updateDOM(this.dom, e)) && (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(e)), this.widget.editable || (this.dom.contentEditable = "false"));
  }
  getSide() {
    return this.side;
  }
  merge(e, n, r, i, s, o) {
    return r && (!(r instanceof Qi) || !this.widget.compare(r.widget) || e > 0 && s <= 0 || n < this.length && o <= 0) ? !1 : (this.length = e + (r ? r.length : 0) + (this.length - n), !0);
  }
  become(e) {
    return e instanceof Qi && e.side == this.side && this.widget.constructor == e.widget.constructor ? (this.widget.compare(e.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = e.widget, this.length = e.length, !0) : !1;
  }
  ignoreMutation() {
    return !0;
  }
  ignoreEvent(e) {
    return this.widget.ignoreEvent(e);
  }
  get overrideDOMText() {
    if (this.length == 0)
      return ze.empty;
    let e = this;
    for (; e.parent; )
      e = e.parent;
    let { view: n } = e, r = n && n.state.doc, i = this.posAtStart;
    return r ? r.slice(i, i + this.length) : ze.empty;
  }
  domAtPos(e) {
    return (this.length ? e == 0 : this.side > 0) ? zt.before(this.dom) : zt.after(this.dom, e == this.length);
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(e, n) {
    let r = this.widget.coordsAt(this.dom, e, n);
    if (r)
      return r;
    let i = this.dom.getClientRects(), s = null;
    if (!i.length)
      return null;
    let o = this.side ? this.side < 0 : e > 0;
    for (let a = o ? i.length - 1 : 0; s = i[a], !(e > 0 ? a == 0 : a == i.length - 1 || s.top < s.bottom); a += o ? -1 : 1)
      ;
    return sp(s, !o);
  }
  get isEditable() {
    return !1;
  }
  get isWidget() {
    return !0;
  }
  get isHidden() {
    return this.widget.isHidden;
  }
  destroy() {
    super.destroy(), this.dom && this.widget.destroy(this.dom);
  }
}
class $a extends qe {
  constructor(e) {
    super(), this.side = e;
  }
  get length() {
    return 0;
  }
  merge() {
    return !1;
  }
  become(e) {
    return e instanceof $a && e.side == this.side;
  }
  split() {
    return new $a(this.side);
  }
  sync() {
    if (!this.dom) {
      let e = document.createElement("img");
      e.className = "cm-widgetBuffer", e.setAttribute("aria-hidden", "true"), this.setDOM(e);
    }
  }
  getSide() {
    return this.side;
  }
  domAtPos(e) {
    return this.side > 0 ? zt.before(this.dom) : zt.after(this.dom);
  }
  localPosFromDOM() {
    return 0;
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(e) {
    return this.dom.getBoundingClientRect();
  }
  get overrideDOMText() {
    return ze.empty;
  }
  get isHidden() {
    return !0;
  }
}
pr.prototype.children = Qi.prototype.children = $a.prototype.children = W1;
function K8(t, e) {
  let n = t.dom, { children: r } = t, i = 0;
  for (let s = 0; i < r.length; i++) {
    let o = r[i], a = s + o.length;
    if (!(a == s && o.getSide() <= 0)) {
      if (e > s && e < a && o.dom.parentNode == n)
        return o.domAtPos(e - s);
      if (e <= s)
        break;
      s = a;
    }
  }
  for (let s = i; s > 0; s--) {
    let o = r[s - 1];
    if (o.dom.parentNode == n)
      return o.domAtPos(o.length);
  }
  for (let s = i; s < r.length; s++) {
    let o = r[s];
    if (o.dom.parentNode == n)
      return o.domAtPos(0);
  }
  return new zt(n, 0);
}
function G8(t, e, n) {
  let r, { children: i } = t;
  n > 0 && e instanceof _i && i.length && (r = i[i.length - 1]) instanceof _i && r.mark.eq(e.mark) ? G8(r, e.children[0], n - 1) : (i.push(e), e.setParent(t)), t.length += e.length;
}
function X8(t, e, n) {
  let r = null, i = -1, s = null, o = -1;
  function a(c, u) {
    for (let h = 0, f = 0; h < c.children.length && f <= u; h++) {
      let d = c.children[h], p = f + d.length;
      p >= u && (d.children.length ? a(d, u - f) : (!s || s.isHidden && n > 0) && (p > u || f == p && d.getSide() > 0) ? (s = d, o = u - f) : (f < u || f == p && d.getSide() < 0 && !d.isHidden) && (r = d, i = u - f)), f = p;
    }
  }
  a(t, e);
  let l = (n < 0 ? r : s) || r || s;
  return l ? l.coordsAt(Math.max(0, l == r ? i : o), n) : VW(t);
}
function VW(t) {
  let e = t.dom.lastChild;
  if (!e)
    return t.dom.getBoundingClientRect();
  let n = Ca(e);
  return n[n.length - 1] || null;
}
function D0(t, e) {
  for (let n in t)
    n == "class" && e.class ? e.class += " " + t.class : n == "style" && e.style ? e.style += ";" + t.style : e[n] = t[n];
  return e;
}
const Y2 = /* @__PURE__ */ Object.create(null);
function zh(t, e, n) {
  if (t == e)
    return !0;
  t || (t = Y2), e || (e = Y2);
  let r = Object.keys(t), i = Object.keys(e);
  if (r.length - (n && r.indexOf(n) > -1 ? 1 : 0) != i.length - (n && i.indexOf(n) > -1 ? 1 : 0))
    return !1;
  for (let s of r)
    if (s != n && (i.indexOf(s) == -1 || t[s] !== e[s]))
      return !1;
  return !0;
}
function T0(t, e, n) {
  let r = !1;
  if (e)
    for (let i in e)
      n && i in n || (r = !0, i == "style" ? t.style.cssText = "" : t.removeAttribute(i));
  if (n)
    for (let i in n)
      e && e[i] == n[i] || (r = !0, i == "style" ? t.style.cssText = n[i] : t.setAttribute(i, n[i]));
  return r;
}
function HW(t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let n = 0; n < t.attributes.length; n++) {
    let r = t.attributes[n];
    e[r.name] = r.value;
  }
  return e;
}
class pt extends qe {
  constructor() {
    super(...arguments), this.children = [], this.length = 0, this.prevAttrs = void 0, this.attrs = null, this.breakAfter = 0;
  }
  // Consumes source
  merge(e, n, r, i, s, o) {
    if (r) {
      if (!(r instanceof pt))
        return !1;
      this.dom || r.transferDOM(this);
    }
    return i && this.setDeco(r ? r.attrs : null), j8(this, e, n, r ? r.children.slice() : [], s, o), !0;
  }
  split(e) {
    let n = new pt();
    if (n.breakAfter = this.breakAfter, this.length == 0)
      return n;
    let { i: r, off: i } = this.childPos(e);
    i && (n.append(this.children[r].split(i), 0), this.children[r].merge(i, this.children[r].length, null, !1, 0, 0), r++);
    for (let s = r; s < this.children.length; s++)
      n.append(this.children[s], 0);
    for (; r > 0 && this.children[r - 1].length == 0; )
      this.children[--r].destroy();
    return this.children.length = r, this.markDirty(), this.length = e, n;
  }
  transferDOM(e) {
    this.dom && (this.markDirty(), e.setDOM(this.dom), e.prevAttrs = this.prevAttrs === void 0 ? this.attrs : this.prevAttrs, this.prevAttrs = void 0, this.dom = null);
  }
  setDeco(e) {
    zh(this.attrs, e) || (this.dom && (this.prevAttrs = this.attrs, this.markDirty()), this.attrs = e);
  }
  append(e, n) {
    G8(this, e, n);
  }
  // Only called when building a line view in ContentBuilder
  addLineDeco(e) {
    let n = e.spec.attributes, r = e.spec.class;
    n && (this.attrs = D0(n, this.attrs || {})), r && (this.attrs = D0({ class: r }, this.attrs || {}));
  }
  domAtPos(e) {
    return K8(this, e);
  }
  reuseDOM(e) {
    e.nodeName == "DIV" && (this.setDOM(e), this.flags |= 6);
  }
  sync(e, n) {
    var r;
    this.dom ? this.flags & 4 && (F8(this.dom), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0) : (this.setDOM(document.createElement("div")), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0), this.prevAttrs !== void 0 && (T0(this.dom, this.prevAttrs, this.attrs), this.dom.classList.add("cm-line"), this.prevAttrs = void 0), super.sync(e, n);
    let i = this.dom.lastChild;
    for (; i && qe.get(i) instanceof _i; )
      i = i.lastChild;
    if (!i || !this.length || i.nodeName != "BR" && ((r = qe.get(i)) === null || r === void 0 ? void 0 : r.isEditable) == !1 && (!me.ios || !this.children.some((s) => s instanceof pr))) {
      let s = document.createElement("BR");
      s.cmIgnore = !0, this.dom.appendChild(s);
    }
  }
  measureTextSize() {
    if (this.children.length == 0 || this.length > 20)
      return null;
    let e = 0, n;
    for (let r of this.children) {
      if (!(r instanceof pr) || /[^ -~]/.test(r.text))
        return null;
      let i = Ca(r.dom);
      if (i.length != 1)
        return null;
      e += i[0].width, n = i[0].height;
    }
    return e ? {
      lineHeight: this.dom.getBoundingClientRect().height,
      charWidth: e / this.length,
      textHeight: n
    } : null;
  }
  coordsAt(e, n) {
    let r = X8(this, e, n);
    if (!this.children.length && r && this.parent) {
      let { heightOracle: i } = this.parent.view.viewState, s = r.bottom - r.top;
      if (Math.abs(s - i.lineHeight) < 2 && i.textHeight < s) {
        let o = (s - i.textHeight) / 2;
        return { top: r.top + o, bottom: r.bottom - o, left: r.left, right: r.left };
      }
    }
    return r;
  }
  become(e) {
    return e instanceof pt && this.children.length == 0 && e.children.length == 0 && zh(this.attrs, e.attrs) && this.breakAfter == e.breakAfter;
  }
  covers() {
    return !0;
  }
  static find(e, n) {
    for (let r = 0, i = 0; r < e.children.length; r++) {
      let s = e.children[r], o = i + s.length;
      if (o >= n) {
        if (s instanceof pt)
          return s;
        if (o > n)
          break;
      }
      i = o + s.breakAfter;
    }
    return null;
  }
}
class mi extends qe {
  constructor(e, n, r) {
    super(), this.widget = e, this.length = n, this.deco = r, this.breakAfter = 0, this.prevWidget = null;
  }
  merge(e, n, r, i, s, o) {
    return r && (!(r instanceof mi) || !this.widget.compare(r.widget) || e > 0 && s <= 0 || n < this.length && o <= 0) ? !1 : (this.length = e + (r ? r.length : 0) + (this.length - n), !0);
  }
  domAtPos(e) {
    return e == 0 ? zt.before(this.dom) : zt.after(this.dom, e == this.length);
  }
  split(e) {
    let n = this.length - e;
    this.length = e;
    let r = new mi(this.widget, n, this.deco);
    return r.breakAfter = this.breakAfter, r;
  }
  get children() {
    return W1;
  }
  sync(e) {
    (!this.dom || !this.widget.updateDOM(this.dom, e)) && (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(e)), this.widget.editable || (this.dom.contentEditable = "false"));
  }
  get overrideDOMText() {
    return this.parent ? this.parent.view.state.doc.slice(this.posAtStart, this.posAtEnd) : ze.empty;
  }
  domBoundsAround() {
    return null;
  }
  become(e) {
    return e instanceof mi && e.widget.constructor == this.widget.constructor ? (e.widget.compare(this.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = e.widget, this.length = e.length, this.deco = e.deco, this.breakAfter = e.breakAfter, !0) : !1;
  }
  ignoreMutation() {
    return !0;
  }
  ignoreEvent(e) {
    return this.widget.ignoreEvent(e);
  }
  get isEditable() {
    return !1;
  }
  get isWidget() {
    return !0;
  }
  coordsAt(e, n) {
    return this.widget.coordsAt(this.dom, e, n);
  }
  destroy() {
    super.destroy(), this.dom && this.widget.destroy(this.dom);
  }
  covers(e) {
    let { startSide: n, endSide: r } = this.deco;
    return n == r ? !1 : e < 0 ? n < 0 : r > 0;
  }
}
class Oi {
  /**
  Compare this instance to another instance of the same type.
  (TypeScript can't express this, but only instances of the same
  specific class will be passed to this method.) This is used to
  avoid redrawing widgets when they are replaced by a new
  decoration of the same type. The default implementation just
  returns `false`, which will cause new instances of the widget to
  always be redrawn.
  */
  eq(e) {
    return !1;
  }
  /**
  Update a DOM element created by a widget of the same type (but
  different, non-`eq` content) to reflect this widget. May return
  true to indicate that it could update, false to indicate it
  couldn't (in which case the widget will be redrawn). The default
  implementation just returns false.
  */
  updateDOM(e, n) {
    return !1;
  }
  /**
  @internal
  */
  compare(e) {
    return this == e || this.constructor == e.constructor && this.eq(e);
  }
  /**
  The estimated height this widget will have, to be used when
  estimating the height of content that hasn't been drawn. May
  return -1 to indicate you don't know. The default implementation
  returns -1.
  */
  get estimatedHeight() {
    return -1;
  }
  /**
  For inline widgets that are displayed inline (as opposed to
  `inline-block`) and introduce line breaks (through `<br>` tags
  or textual newlines), this must indicate the amount of line
  breaks they introduce. Defaults to 0.
  */
  get lineBreaks() {
    return 0;
  }
  /**
  Can be used to configure which kinds of events inside the widget
  should be ignored by the editor. The default is to ignore all
  events.
  */
  ignoreEvent(e) {
    return !0;
  }
  /**
  Override the way screen coordinates for positions at/in the
  widget are found. `pos` will be the offset into the widget, and
  `side` the side of the position that is being queried—less than
  zero for before, greater than zero for after, and zero for
  directly at that position.
  */
  coordsAt(e, n, r) {
    return null;
  }
  /**
  @internal
  */
  get isHidden() {
    return !1;
  }
  /**
  @internal
  */
  get editable() {
    return !1;
  }
  /**
  This is called when the an instance of the widget is removed
  from the editor view.
  */
  destroy(e) {
  }
}
var tn = /* @__PURE__ */ function(t) {
  return t[t.Text = 0] = "Text", t[t.WidgetBefore = 1] = "WidgetBefore", t[t.WidgetAfter = 2] = "WidgetAfter", t[t.WidgetRange = 3] = "WidgetRange", t;
}(tn || (tn = {}));
class we extends po {
  constructor(e, n, r, i) {
    super(), this.startSide = e, this.endSide = n, this.widget = r, this.spec = i;
  }
  /**
  @internal
  */
  get heightRelevant() {
    return !1;
  }
  /**
  Create a mark decoration, which influences the styling of the
  content in its range. Nested mark decorations will cause nested
  DOM elements to be created. Nesting order is determined by
  precedence of the [facet](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), with
  the higher-precedence decorations creating the inner DOM nodes.
  Such elements are split on line boundaries and on the boundaries
  of lower-precedence decorations.
  */
  static mark(e) {
    return new bu(e);
  }
  /**
  Create a widget decoration, which displays a DOM element at the
  given position.
  */
  static widget(e) {
    let n = Math.max(-1e4, Math.min(1e4, e.side || 0)), r = !!e.block;
    return n += r && !e.inlineOrder ? n > 0 ? 3e8 : -4e8 : n > 0 ? 1e8 : -1e8, new gs(e, n, n, r, e.widget || null, !1);
  }
  /**
  Create a replace decoration which replaces the given range with
  a widget, or simply hides it.
  */
  static replace(e) {
    let n = !!e.block, r, i;
    if (e.isBlockGap)
      r = -5e8, i = 4e8;
    else {
      let { start: s, end: o } = Z8(e, n);
      r = (s ? n ? -3e8 : -1 : 5e8) - 1, i = (o ? n ? 2e8 : 1 : -6e8) + 1;
    }
    return new gs(e, r, i, n, e.widget || null, !0);
  }
  /**
  Create a line decoration, which can add DOM attributes to the
  line starting at the given position.
  */
  static line(e) {
    return new xu(e);
  }
  /**
  Build a [`DecorationSet`](https://codemirror.net/6/docs/ref/#view.DecorationSet) from the given
  decorated range or ranges. If the ranges aren't already sorted,
  pass `true` for `sort` to make the library sort them for you.
  */
  static set(e, n = !1) {
    return Be.of(e, n);
  }
  /**
  @internal
  */
  hasHeight() {
    return this.widget ? this.widget.estimatedHeight > -1 : !1;
  }
}
we.none = Be.empty;
class bu extends we {
  constructor(e) {
    let { start: n, end: r } = Z8(e);
    super(n ? -1 : 5e8, r ? 1 : -6e8, null, e), this.tagName = e.tagName || "span", this.class = e.class || "", this.attrs = e.attributes || null;
  }
  eq(e) {
    var n, r;
    return this == e || e instanceof bu && this.tagName == e.tagName && (this.class || ((n = this.attrs) === null || n === void 0 ? void 0 : n.class)) == (e.class || ((r = e.attrs) === null || r === void 0 ? void 0 : r.class)) && zh(this.attrs, e.attrs, "class");
  }
  range(e, n = e) {
    if (e >= n)
      throw new RangeError("Mark decorations may not be empty");
    return super.range(e, n);
  }
}
bu.prototype.point = !1;
class xu extends we {
  constructor(e) {
    super(-2e8, -2e8, null, e);
  }
  eq(e) {
    return e instanceof xu && this.spec.class == e.spec.class && zh(this.spec.attributes, e.spec.attributes);
  }
  range(e, n = e) {
    if (n != e)
      throw new RangeError("Line decoration ranges must be zero-length");
    return super.range(e, n);
  }
}
xu.prototype.mapMode = Qt.TrackBefore;
xu.prototype.point = !0;
class gs extends we {
  constructor(e, n, r, i, s, o) {
    super(n, r, s, e), this.block = i, this.isReplace = o, this.mapMode = i ? n <= 0 ? Qt.TrackBefore : Qt.TrackAfter : Qt.TrackDel;
  }
  // Only relevant when this.block == true
  get type() {
    return this.startSide != this.endSide ? tn.WidgetRange : this.startSide <= 0 ? tn.WidgetBefore : tn.WidgetAfter;
  }
  get heightRelevant() {
    return this.block || !!this.widget && (this.widget.estimatedHeight >= 5 || this.widget.lineBreaks > 0);
  }
  eq(e) {
    return e instanceof gs && YW(this.widget, e.widget) && this.block == e.block && this.startSide == e.startSide && this.endSide == e.endSide;
  }
  range(e, n = e) {
    if (this.isReplace && (e > n || e == n && this.startSide > 0 && this.endSide <= 0))
      throw new RangeError("Invalid range for replacement decoration");
    if (!this.isReplace && n != e)
      throw new RangeError("Widget decorations can only have zero-length ranges");
    return super.range(e, n);
  }
}
gs.prototype.point = !0;
function Z8(t, e = !1) {
  let { inclusiveStart: n, inclusiveEnd: r } = t;
  return n == null && (n = t.inclusive), r == null && (r = t.inclusive), { start: n != null ? n : e, end: r != null ? r : e };
}
function YW(t, e) {
  return t == e || !!(t && e && t.compare(e));
}
function O0(t, e, n, r = 0) {
  let i = n.length - 1;
  i >= 0 && n[i] + r >= t ? n[i] = Math.max(n[i], e) : n.push(t, e);
}
class ic {
  constructor(e, n, r, i) {
    this.doc = e, this.pos = n, this.end = r, this.disallowBlockEffectsFor = i, this.content = [], this.curLine = null, this.breakAtStart = 0, this.pendingBuffer = 0, this.bufferMarks = [], this.atCursorPos = !0, this.openStart = -1, this.openEnd = -1, this.text = "", this.textOff = 0, this.cursor = e.iter(), this.skip = n;
  }
  posCovered() {
    if (this.content.length == 0)
      return !this.breakAtStart && this.doc.lineAt(this.pos).from != this.pos;
    let e = this.content[this.content.length - 1];
    return !(e.breakAfter || e instanceof mi && e.deco.endSide < 0);
  }
  getLine() {
    return this.curLine || (this.content.push(this.curLine = new pt()), this.atCursorPos = !0), this.curLine;
  }
  flushBuffer(e = this.bufferMarks) {
    this.pendingBuffer && (this.curLine.append(ef(new $a(-1), e), e.length), this.pendingBuffer = 0);
  }
  addBlockWidget(e) {
    this.flushBuffer(), this.curLine = null, this.content.push(e);
  }
  finish(e) {
    this.pendingBuffer && e <= this.bufferMarks.length ? this.flushBuffer() : this.pendingBuffer = 0, !this.posCovered() && !(e && this.content.length && this.content[this.content.length - 1] instanceof mi) && this.getLine();
  }
  buildText(e, n, r) {
    for (; e > 0; ) {
      if (this.textOff == this.text.length) {
        let { value: s, lineBreak: o, done: a } = this.cursor.next(this.skip);
        if (this.skip = 0, a)
          throw new Error("Ran out of text content when drawing inline views");
        if (o) {
          this.posCovered() || this.getLine(), this.content.length ? this.content[this.content.length - 1].breakAfter = 1 : this.breakAtStart = 1, this.flushBuffer(), this.curLine = null, this.atCursorPos = !0, e--;
          continue;
        } else
          this.text = s, this.textOff = 0;
      }
      let i = Math.min(
        this.text.length - this.textOff,
        e,
        512
        /* T.Chunk */
      );
      this.flushBuffer(n.slice(n.length - r)), this.getLine().append(ef(new pr(this.text.slice(this.textOff, this.textOff + i)), n), r), this.atCursorPos = !0, this.textOff += i, e -= i, r = 0;
    }
  }
  span(e, n, r, i) {
    this.buildText(n - e, r, i), this.pos = n, this.openStart < 0 && (this.openStart = i);
  }
  point(e, n, r, i, s, o) {
    if (this.disallowBlockEffectsFor[o] && r instanceof gs) {
      if (r.block)
        throw new RangeError("Block decorations may not be specified via plugins");
      if (n > this.doc.lineAt(this.pos).to)
        throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
    }
    let a = n - e;
    if (r instanceof gs)
      if (r.block)
        r.startSide > 0 && !this.posCovered() && this.getLine(), this.addBlockWidget(new mi(r.widget || Aa.block, a, r));
      else {
        let l = Qi.create(r.widget || Aa.inline, a, a ? 0 : r.startSide), c = this.atCursorPos && !l.isEditable && s <= i.length && (e < n || r.startSide > 0), u = !l.isEditable && (e < n || s > i.length || r.startSide <= 0), h = this.getLine();
        this.pendingBuffer == 2 && !c && !l.isEditable && (this.pendingBuffer = 0), this.flushBuffer(i), c && (h.append(ef(new $a(1), i), s), s = i.length + Math.max(0, s - i.length)), h.append(ef(l, i), s), this.atCursorPos = u, this.pendingBuffer = u ? e < n || s > i.length ? 1 : 2 : 0, this.pendingBuffer && (this.bufferMarks = i.slice());
      }
    else this.doc.lineAt(this.pos).from == this.pos && this.getLine().addLineDeco(r);
    a && (this.textOff + a <= this.text.length ? this.textOff += a : (this.skip += a - (this.text.length - this.textOff), this.text = "", this.textOff = 0), this.pos = n), this.openStart < 0 && (this.openStart = s);
  }
  static build(e, n, r, i, s) {
    let o = new ic(e, n, r, s);
    return o.openEnd = Be.spans(i, n, r, o), o.openStart < 0 && (o.openStart = o.openEnd), o.finish(o.openEnd), o;
  }
}
function ef(t, e) {
  for (let n of e)
    t = new _i(n, [t], t.length);
  return t;
}
class Aa extends Oi {
  constructor(e) {
    super(), this.tag = e;
  }
  eq(e) {
    return e.tag == this.tag;
  }
  toDOM() {
    return document.createElement(this.tag);
  }
  updateDOM(e) {
    return e.nodeName.toLowerCase() == this.tag;
  }
  get isHidden() {
    return !0;
  }
}
Aa.inline = /* @__PURE__ */ new Aa("span");
Aa.block = /* @__PURE__ */ new Aa("div");
var Qe = /* @__PURE__ */ function(t) {
  return t[t.LTR = 0] = "LTR", t[t.RTL = 1] = "RTL", t;
}(Qe || (Qe = {}));
const vo = Qe.LTR, j1 = Qe.RTL;
function J8(t) {
  let e = [];
  for (let n = 0; n < t.length; n++)
    e.push(1 << +t[n]);
  return e;
}
const WW = /* @__PURE__ */ J8("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008"), jW = /* @__PURE__ */ J8("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333"), E0 = /* @__PURE__ */ Object.create(null), _r = [];
for (let t of ["()", "[]", "{}"]) {
  let e = /* @__PURE__ */ t.charCodeAt(0), n = /* @__PURE__ */ t.charCodeAt(1);
  E0[e] = n, E0[n] = -e;
}
function Q8(t) {
  return t <= 247 ? WW[t] : 1424 <= t && t <= 1524 ? 2 : 1536 <= t && t <= 1785 ? jW[t - 1536] : 1774 <= t && t <= 2220 ? 4 : 8192 <= t && t <= 8204 ? 256 : 64336 <= t && t <= 65023 ? 4 : 1;
}
const qW = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/;
class es {
  /**
  The direction of this span.
  */
  get dir() {
    return this.level % 2 ? j1 : vo;
  }
  /**
  @internal
  */
  constructor(e, n, r) {
    this.from = e, this.to = n, this.level = r;
  }
  /**
  @internal
  */
  side(e, n) {
    return this.dir == n == e ? this.to : this.from;
  }
  /**
  @internal
  */
  forward(e, n) {
    return e == (this.dir == n);
  }
  /**
  @internal
  */
  static find(e, n, r, i) {
    let s = -1;
    for (let o = 0; o < e.length; o++) {
      let a = e[o];
      if (a.from <= n && a.to >= n) {
        if (a.level == r)
          return o;
        (s < 0 || (i != 0 ? i < 0 ? a.from < n : a.to > n : e[s].level > a.level)) && (s = o);
      }
    }
    if (s < 0)
      throw new RangeError("Index out of range");
    return s;
  }
}
function e6(t, e) {
  if (t.length != e.length)
    return !1;
  for (let n = 0; n < t.length; n++) {
    let r = t[n], i = e[n];
    if (r.from != i.from || r.to != i.to || r.direction != i.direction || !e6(r.inner, i.inner))
      return !1;
  }
  return !0;
}
const je = [];
function UW(t, e, n, r, i) {
  for (let s = 0; s <= r.length; s++) {
    let o = s ? r[s - 1].to : e, a = s < r.length ? r[s].from : n, l = s ? 256 : i;
    for (let c = o, u = l, h = l; c < a; c++) {
      let f = Q8(t.charCodeAt(c));
      f == 512 ? f = u : f == 8 && h == 4 && (f = 16), je[c] = f == 4 ? 2 : f, f & 7 && (h = f), u = f;
    }
    for (let c = o, u = l, h = l; c < a; c++) {
      let f = je[c];
      if (f == 128)
        c < a - 1 && u == je[c + 1] && u & 24 ? f = je[c] = u : je[c] = 256;
      else if (f == 64) {
        let d = c + 1;
        for (; d < a && je[d] == 64; )
          d++;
        let p = c && u == 8 || d < n && je[d] == 8 ? h == 1 ? 1 : 8 : 256;
        for (let m = c; m < d; m++)
          je[m] = p;
        c = d - 1;
      } else f == 8 && h == 1 && (je[c] = 1);
      u = f, f & 7 && (h = f);
    }
  }
}
function KW(t, e, n, r, i) {
  let s = i == 1 ? 2 : 1;
  for (let o = 0, a = 0, l = 0; o <= r.length; o++) {
    let c = o ? r[o - 1].to : e, u = o < r.length ? r[o].from : n;
    for (let h = c, f, d, p; h < u; h++)
      if (d = E0[f = t.charCodeAt(h)])
        if (d < 0) {
          for (let m = a - 3; m >= 0; m -= 3)
            if (_r[m + 1] == -d) {
              let v = _r[m + 2], g = v & 2 ? i : v & 4 ? v & 1 ? s : i : 0;
              g && (je[h] = je[_r[m]] = g), a = m;
              break;
            }
        } else {
          if (_r.length == 189)
            break;
          _r[a++] = h, _r[a++] = f, _r[a++] = l;
        }
      else if ((p = je[h]) == 2 || p == 1) {
        let m = p == i;
        l = m ? 0 : 1;
        for (let v = a - 3; v >= 0; v -= 3) {
          let g = _r[v + 2];
          if (g & 2)
            break;
          if (m)
            _r[v + 2] |= 2;
          else {
            if (g & 4)
              break;
            _r[v + 2] |= 4;
          }
        }
      }
  }
}
function GW(t, e, n, r) {
  for (let i = 0, s = r; i <= n.length; i++) {
    let o = i ? n[i - 1].to : t, a = i < n.length ? n[i].from : e;
    for (let l = o; l < a; ) {
      let c = je[l];
      if (c == 256) {
        let u = l + 1;
        for (; ; )
          if (u == a) {
            if (i == n.length)
              break;
            u = n[i++].to, a = i < n.length ? n[i].from : e;
          } else if (je[u] == 256)
            u++;
          else
            break;
        let h = s == 1, f = (u < e ? je[u] : r) == 1, d = h == f ? h ? 1 : 2 : r;
        for (let p = u, m = i, v = m ? n[m - 1].to : t; p > l; )
          p == v && (p = n[--m].from, v = m ? n[m - 1].to : t), je[--p] = d;
        l = u;
      } else
        s = c, l++;
    }
  }
}
function P0(t, e, n, r, i, s, o) {
  let a = r % 2 ? 2 : 1;
  if (r % 2 == i % 2)
    for (let l = e, c = 0; l < n; ) {
      let u = !0, h = !1;
      if (c == s.length || l < s[c].from) {
        let m = je[l];
        m != a && (u = !1, h = m == 16);
      }
      let f = !u && a == 1 ? [] : null, d = u ? r : r + 1, p = l;
      e: for (; ; )
        if (c < s.length && p == s[c].from) {
          if (h)
            break e;
          let m = s[c];
          if (!u)
            for (let v = m.to, g = c + 1; ; ) {
              if (v == n)
                break e;
              if (g < s.length && s[g].from == v)
                v = s[g++].to;
              else {
                if (je[v] == a)
                  break e;
                break;
              }
            }
          if (c++, f)
            f.push(m);
          else {
            m.from > l && o.push(new es(l, m.from, d));
            let v = m.direction == vo != !(d % 2);
            L0(t, v ? r + 1 : r, i, m.inner, m.from, m.to, o), l = m.to;
          }
          p = m.to;
        } else {
          if (p == n || (u ? je[p] != a : je[p] == a))
            break;
          p++;
        }
      f ? P0(t, l, p, r + 1, i, f, o) : l < p && o.push(new es(l, p, d)), l = p;
    }
  else
    for (let l = n, c = s.length; l > e; ) {
      let u = !0, h = !1;
      if (!c || l > s[c - 1].to) {
        let m = je[l - 1];
        m != a && (u = !1, h = m == 16);
      }
      let f = !u && a == 1 ? [] : null, d = u ? r : r + 1, p = l;
      e: for (; ; )
        if (c && p == s[c - 1].to) {
          if (h)
            break e;
          let m = s[--c];
          if (!u)
            for (let v = m.from, g = c; ; ) {
              if (v == e)
                break e;
              if (g && s[g - 1].to == v)
                v = s[--g].from;
              else {
                if (je[v - 1] == a)
                  break e;
                break;
              }
            }
          if (f)
            f.push(m);
          else {
            m.to < l && o.push(new es(m.to, l, d));
            let v = m.direction == vo != !(d % 2);
            L0(t, v ? r + 1 : r, i, m.inner, m.from, m.to, o), l = m.from;
          }
          p = m.from;
        } else {
          if (p == e || (u ? je[p - 1] != a : je[p - 1] == a))
            break;
          p--;
        }
      f ? P0(t, p, l, r + 1, i, f, o) : p < l && o.push(new es(p, l, d)), l = p;
    }
}
function L0(t, e, n, r, i, s, o) {
  let a = e % 2 ? 2 : 1;
  UW(t, i, s, r, a), KW(t, i, s, r, a), GW(i, s, r, a), P0(t, i, s, e, n, r, o);
}
function XW(t, e, n) {
  if (!t)
    return [new es(0, 0, e == j1 ? 1 : 0)];
  if (e == vo && !n.length && !qW.test(t))
    return t6(t.length);
  if (n.length)
    for (; t.length > je.length; )
      je[je.length] = 256;
  let r = [], i = e == vo ? 0 : 1;
  return L0(t, i, i, n, 0, t.length, r), r;
}
function t6(t) {
  return [new es(0, t, 0)];
}
let n6 = "";
function ZW(t, e, n, r, i) {
  var s;
  let o = r.head - t.from, a = es.find(e, o, (s = r.bidiLevel) !== null && s !== void 0 ? s : -1, r.assoc), l = e[a], c = l.side(i, n);
  if (o == c) {
    let f = a += i ? 1 : -1;
    if (f < 0 || f >= e.length)
      return null;
    l = e[a = f], o = l.side(!i, n), c = l.side(i, n);
  }
  let u = Pt(t.text, o, l.forward(i, n));
  (u < l.from || u > l.to) && (u = c), n6 = t.text.slice(Math.min(o, u), Math.max(o, u));
  let h = a == (i ? e.length - 1 : 0) ? null : e[a + (i ? 1 : -1)];
  return h && u == c && h.level + (i ? 0 : 1) < l.level ? W.cursor(h.side(!i, n) + t.from, h.forward(i, n) ? 1 : -1, h.level) : W.cursor(u + t.from, l.forward(i, n) ? -1 : 1, l.level);
}
function JW(t, e, n) {
  for (let r = e; r < n; r++) {
    let i = Q8(t.charCodeAt(r));
    if (i == 1)
      return vo;
    if (i == 2 || i == 4)
      return j1;
  }
  return vo;
}
const r6 = /* @__PURE__ */ ve.define(), i6 = /* @__PURE__ */ ve.define(), s6 = /* @__PURE__ */ ve.define(), o6 = /* @__PURE__ */ ve.define(), N0 = /* @__PURE__ */ ve.define(), a6 = /* @__PURE__ */ ve.define(), l6 = /* @__PURE__ */ ve.define(), c6 = /* @__PURE__ */ ve.define({
  combine: (t) => t.some((e) => e)
}), u6 = /* @__PURE__ */ ve.define({
  combine: (t) => t.some((e) => e)
}), f6 = /* @__PURE__ */ ve.define();
class ra {
  constructor(e, n = "nearest", r = "nearest", i = 5, s = 5, o = !1) {
    this.range = e, this.y = n, this.x = r, this.yMargin = i, this.xMargin = s, this.isSnapshot = o;
  }
  map(e) {
    return e.empty ? this : new ra(this.range.map(e), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
  }
  clip(e) {
    return this.range.to <= e.doc.length ? this : new ra(W.cursor(e.doc.length), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
  }
}
const tf = /* @__PURE__ */ De.define({ map: (t, e) => t.map(e) }), h6 = /* @__PURE__ */ De.define();
function un(t, e, n) {
  let r = t.facet(o6);
  r.length ? r[0](e) : window.onerror ? window.onerror(String(e), n, void 0, void 0, e) : n ? console.error(n + ":", e) : console.error(e);
}
const ji = /* @__PURE__ */ ve.define({ combine: (t) => t.length ? t[0] : !0 });
let QW = 0;
const Rl = /* @__PURE__ */ ve.define();
class dt {
  constructor(e, n, r, i, s) {
    this.id = e, this.create = n, this.domEventHandlers = r, this.domEventObservers = i, this.extension = s(this);
  }
  /**
  Define a plugin from a constructor function that creates the
  plugin's value, given an editor view.
  */
  static define(e, n) {
    const { eventHandlers: r, eventObservers: i, provide: s, decorations: o } = n || {};
    return new dt(QW++, e, r, i, (a) => {
      let l = [Rl.of(a)];
      return o && l.push(Tc.of((c) => {
        let u = c.plugin(a);
        return u ? o(u) : we.none;
      })), s && l.push(s(a)), l;
    });
  }
  /**
  Create a plugin for a class whose constructor takes a single
  editor view as argument.
  */
  static fromClass(e, n) {
    return dt.define((r) => new e(r), n);
  }
}
class wm {
  constructor(e) {
    this.spec = e, this.mustUpdate = null, this.value = null;
  }
  update(e) {
    if (this.value) {
      if (this.mustUpdate) {
        let n = this.mustUpdate;
        if (this.mustUpdate = null, this.value.update)
          try {
            this.value.update(n);
          } catch (r) {
            if (un(n.state, r, "CodeMirror plugin crashed"), this.value.destroy)
              try {
                this.value.destroy();
              } catch (i) {
              }
            this.deactivate();
          }
      }
    } else if (this.spec)
      try {
        this.value = this.spec.create(e);
      } catch (n) {
        un(e.state, n, "CodeMirror plugin crashed"), this.deactivate();
      }
    return this;
  }
  destroy(e) {
    var n;
    if (!((n = this.value) === null || n === void 0) && n.destroy)
      try {
        this.value.destroy();
      } catch (r) {
        un(e.state, r, "CodeMirror plugin crashed");
      }
  }
  deactivate() {
    this.spec = this.value = null;
  }
}
const d6 = /* @__PURE__ */ ve.define(), q1 = /* @__PURE__ */ ve.define(), Tc = /* @__PURE__ */ ve.define(), p6 = /* @__PURE__ */ ve.define(), U1 = /* @__PURE__ */ ve.define(), m6 = /* @__PURE__ */ ve.define();
function W2(t, e) {
  let n = t.state.facet(m6);
  if (!n.length)
    return n;
  let r = n.map((s) => s instanceof Function ? s(t) : s), i = [];
  return Be.spans(r, e.from, e.to, {
    point() {
    },
    span(s, o, a, l) {
      let c = s - e.from, u = o - e.from, h = i;
      for (let f = a.length - 1; f >= 0; f--, l--) {
        let d = a[f].spec.bidiIsolate, p;
        if (d == null && (d = JW(e.text, c, u)), l > 0 && h.length && (p = h[h.length - 1]).to == c && p.direction == d)
          p.to = u, h = p.inner;
        else {
          let m = { from: c, to: u, direction: d, inner: [] };
          h.push(m), h = m.inner;
        }
      }
    }
  }), i;
}
const g6 = /* @__PURE__ */ ve.define();
function v6(t) {
  let e = 0, n = 0, r = 0, i = 0;
  for (let s of t.state.facet(g6)) {
    let o = s(t);
    o && (o.left != null && (e = Math.max(e, o.left)), o.right != null && (n = Math.max(n, o.right)), o.top != null && (r = Math.max(r, o.top)), o.bottom != null && (i = Math.max(i, o.bottom)));
  }
  return { left: e, right: n, top: r, bottom: i };
}
const Bl = /* @__PURE__ */ ve.define();
class jn {
  constructor(e, n, r, i) {
    this.fromA = e, this.toA = n, this.fromB = r, this.toB = i;
  }
  join(e) {
    return new jn(Math.min(this.fromA, e.fromA), Math.max(this.toA, e.toA), Math.min(this.fromB, e.fromB), Math.max(this.toB, e.toB));
  }
  addToSet(e) {
    let n = e.length, r = this;
    for (; n > 0; n--) {
      let i = e[n - 1];
      if (!(i.fromA > r.toA)) {
        if (i.toA < r.fromA)
          break;
        r = r.join(i), e.splice(n - 1, 1);
      }
    }
    return e.splice(n, 0, r), e;
  }
  static extendWithRanges(e, n) {
    if (n.length == 0)
      return e;
    let r = [];
    for (let i = 0, s = 0, o = 0, a = 0; ; i++) {
      let l = i == e.length ? null : e[i], c = o - a, u = l ? l.fromB : 1e9;
      for (; s < n.length && n[s] < u; ) {
        let h = n[s], f = n[s + 1], d = Math.max(a, h), p = Math.min(u, f);
        if (d <= p && new jn(d + c, p + c, d, p).addToSet(r), f > u)
          break;
        s += 2;
      }
      if (!l)
        return r;
      new jn(l.fromA, l.toA, l.fromB, l.toB).addToSet(r), o = l.toA, a = l.toB;
    }
  }
}
class Vh {
  constructor(e, n, r) {
    this.view = e, this.state = n, this.transactions = r, this.flags = 0, this.startState = e.state, this.changes = mt.empty(this.startState.doc.length);
    for (let s of r)
      this.changes = this.changes.compose(s.changes);
    let i = [];
    this.changes.iterChangedRanges((s, o, a, l) => i.push(new jn(s, o, a, l))), this.changedRanges = i;
  }
  /**
  @internal
  */
  static create(e, n, r) {
    return new Vh(e, n, r);
  }
  /**
  Tells you whether the [viewport](https://codemirror.net/6/docs/ref/#view.EditorView.viewport) or
  [visible ranges](https://codemirror.net/6/docs/ref/#view.EditorView.visibleRanges) changed in this
  update.
  */
  get viewportChanged() {
    return (this.flags & 4) > 0;
  }
  /**
  Indicates whether the height of a block element in the editor
  changed in this update.
  */
  get heightChanged() {
    return (this.flags & 2) > 0;
  }
  /**
  Returns true when the document was modified or the size of the
  editor, or elements within the editor, changed.
  */
  get geometryChanged() {
    return this.docChanged || (this.flags & 10) > 0;
  }
  /**
  True when this update indicates a focus change.
  */
  get focusChanged() {
    return (this.flags & 1) > 0;
  }
  /**
  Whether the document changed in this update.
  */
  get docChanged() {
    return !this.changes.empty;
  }
  /**
  Whether the selection was explicitly set in this update.
  */
  get selectionSet() {
    return this.transactions.some((e) => e.selection);
  }
  /**
  @internal
  */
  get empty() {
    return this.flags == 0 && this.transactions.length == 0;
  }
}
class j2 extends qe {
  get length() {
    return this.view.state.doc.length;
  }
  constructor(e) {
    super(), this.view = e, this.decorations = [], this.dynamicDecorationMap = [!1], this.domChanged = null, this.hasComposition = null, this.markedForComposition = /* @__PURE__ */ new Set(), this.editContextFormatting = we.none, this.lastCompositionAfterCursor = !1, this.minWidth = 0, this.minWidthFrom = 0, this.minWidthTo = 0, this.impreciseAnchor = null, this.impreciseHead = null, this.forceSelection = !1, this.lastUpdate = Date.now(), this.setDOM(e.contentDOM), this.children = [new pt()], this.children[0].setParent(this), this.updateDeco(), this.updateInner([new jn(0, 0, 0, e.state.doc.length)], 0, null);
  }
  // Update the document view to a given state.
  update(e) {
    var n;
    let r = e.changedRanges;
    this.minWidth > 0 && r.length && (r.every(({ fromA: c, toA: u }) => u < this.minWidthFrom || c > this.minWidthTo) ? (this.minWidthFrom = e.changes.mapPos(this.minWidthFrom, 1), this.minWidthTo = e.changes.mapPos(this.minWidthTo, 1)) : this.minWidth = this.minWidthFrom = this.minWidthTo = 0), this.updateEditContextFormatting(e);
    let i = -1;
    this.view.inputState.composing >= 0 && !this.view.observer.editContext && (!((n = this.domChanged) === null || n === void 0) && n.newSel ? i = this.domChanged.newSel.head : !oj(e.changes, this.hasComposition) && !e.selectionSet && (i = e.state.selection.main.head));
    let s = i > -1 ? tj(this.view, e.changes, i) : null;
    if (this.domChanged = null, this.hasComposition) {
      this.markedForComposition.clear();
      let { from: c, to: u } = this.hasComposition;
      r = new jn(c, u, e.changes.mapPos(c, -1), e.changes.mapPos(u, 1)).addToSet(r.slice());
    }
    this.hasComposition = s ? { from: s.range.fromB, to: s.range.toB } : null, (me.ie || me.chrome) && !s && e && e.state.doc.lines != e.startState.doc.lines && (this.forceSelection = !0);
    let o = this.decorations, a = this.updateDeco(), l = ij(o, a, e.changes);
    return r = jn.extendWithRanges(r, l), !(this.flags & 7) && r.length == 0 ? !1 : (this.updateInner(r, e.startState.doc.length, s), e.transactions.length && (this.lastUpdate = Date.now()), !0);
  }
  // Used by update and the constructor do perform the actual DOM
  // update
  updateInner(e, n, r) {
    this.view.viewState.mustMeasureContent = !0, this.updateChildren(e, n, r);
    let { observer: i } = this.view;
    i.ignore(() => {
      this.dom.style.height = this.view.viewState.contentHeight / this.view.scaleY + "px", this.dom.style.flexBasis = this.minWidth ? this.minWidth + "px" : "";
      let o = me.chrome || me.ios ? { node: i.selectionRange.focusNode, written: !1 } : void 0;
      this.sync(this.view, o), this.flags &= -8, o && (o.written || i.selectionRange.focusNode != o.node) && (this.forceSelection = !0), this.dom.style.height = "";
    }), this.markedForComposition.forEach(
      (o) => o.flags &= -9
      /* ViewFlag.Composition */
    );
    let s = [];
    if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length)
      for (let o of this.children)
        o instanceof mi && o.widget instanceof q2 && s.push(o.dom);
    i.updateGaps(s);
  }
  updateChildren(e, n, r) {
    let i = r ? r.range.addToSet(e.slice()) : e, s = this.childCursor(n);
    for (let o = i.length - 1; ; o--) {
      let a = o >= 0 ? i[o] : null;
      if (!a)
        break;
      let { fromA: l, toA: c, fromB: u, toB: h } = a, f, d, p, m;
      if (r && r.range.fromB < h && r.range.toB > u) {
        let b = ic.build(this.view.state.doc, u, r.range.fromB, this.decorations, this.dynamicDecorationMap), w = ic.build(this.view.state.doc, r.range.toB, h, this.decorations, this.dynamicDecorationMap);
        d = b.breakAtStart, p = b.openStart, m = w.openEnd;
        let k = this.compositionView(r);
        w.breakAtStart ? k.breakAfter = 1 : w.content.length && k.merge(k.length, k.length, w.content[0], !1, w.openStart, 0) && (k.breakAfter = w.content[0].breakAfter, w.content.shift()), b.content.length && k.merge(0, 0, b.content[b.content.length - 1], !0, 0, b.openEnd) && b.content.pop(), f = b.content.concat(k).concat(w.content);
      } else
        ({ content: f, breakAtStart: d, openStart: p, openEnd: m } = ic.build(this.view.state.doc, u, h, this.decorations, this.dynamicDecorationMap));
      let { i: v, off: g } = s.findPos(c, 1), { i: y, off: x } = s.findPos(l, -1);
      W8(this, y, x, v, g, f, d, p, m);
    }
    r && this.fixCompositionDOM(r);
  }
  updateEditContextFormatting(e) {
    this.editContextFormatting = this.editContextFormatting.map(e.changes);
    for (let n of e.transactions)
      for (let r of n.effects)
        r.is(h6) && (this.editContextFormatting = r.value);
  }
  compositionView(e) {
    let n = new pr(e.text.nodeValue);
    n.flags |= 8;
    for (let { deco: i } of e.marks)
      n = new _i(i, [n], n.length);
    let r = new pt();
    return r.append(n, 0), r;
  }
  fixCompositionDOM(e) {
    let n = (s, o) => {
      o.flags |= 8 | (o.children.some(
        (l) => l.flags & 7
        /* ViewFlag.Dirty */
      ) ? 1 : 0), this.markedForComposition.add(o);
      let a = qe.get(s);
      a && a != o && (a.dom = null), o.setDOM(s);
    }, r = this.childPos(e.range.fromB, 1), i = this.children[r.i];
    n(e.line, i);
    for (let s = e.marks.length - 1; s >= -1; s--)
      r = i.childPos(r.off, 1), i = i.children[r.i], n(s >= 0 ? e.marks[s].node : e.text, i);
  }
  // Sync the DOM selection to this.state.selection
  updateSelection(e = !1, n = !1) {
    (e || !this.view.observer.selectionRange.focusNode) && this.view.observer.readSelectionRange();
    let r = this.view.root.activeElement, i = r == this.dom, s = !i && Rf(this.dom, this.view.observer.selectionRange) && !(r && this.dom.contains(r));
    if (!(i || n || s))
      return;
    let o = this.forceSelection;
    this.forceSelection = !1;
    let a = this.view.state.selection.main, l = this.moveToLine(this.domAtPos(a.anchor)), c = a.empty ? l : this.moveToLine(this.domAtPos(a.head));
    if (me.gecko && a.empty && !this.hasComposition && ej(l)) {
      let h = document.createTextNode("");
      this.view.observer.ignore(() => l.node.insertBefore(h, l.node.childNodes[l.offset] || null)), l = c = new zt(h, 0), o = !0;
    }
    let u = this.view.observer.selectionRange;
    (o || !u.focusNode || (!rc(l.node, l.offset, u.anchorNode, u.anchorOffset) || !rc(c.node, c.offset, u.focusNode, u.focusOffset)) && !this.suppressWidgetCursorChange(u, a)) && (this.view.observer.ignore(() => {
      me.android && me.chrome && this.dom.contains(u.focusNode) && sj(u.focusNode, this.dom) && (this.dom.blur(), this.dom.focus({ preventScroll: !0 }));
      let h = Dc(this.view.root);
      if (h) if (a.empty) {
        if (me.gecko) {
          let f = nj(l.node, l.offset);
          if (f && f != 3) {
            let d = (f == 1 ? V8 : H8)(l.node, l.offset);
            d && (l = new zt(d.node, d.offset));
          }
        }
        h.collapse(l.node, l.offset), a.bidiLevel != null && h.caretBidiLevel !== void 0 && (h.caretBidiLevel = a.bidiLevel);
      } else if (h.extend) {
        h.collapse(l.node, l.offset);
        try {
          h.extend(c.node, c.offset);
        } catch (f) {
        }
      } else {
        let f = document.createRange();
        a.anchor > a.head && ([l, c] = [c, l]), f.setEnd(c.node, c.offset), f.setStart(l.node, l.offset), h.removeAllRanges(), h.addRange(f);
      }
      s && this.view.root.activeElement == this.dom && (this.dom.blur(), r && r.focus());
    }), this.view.observer.setSelectionRange(l, c)), this.impreciseAnchor = l.precise ? null : new zt(u.anchorNode, u.anchorOffset), this.impreciseHead = c.precise ? null : new zt(u.focusNode, u.focusOffset);
  }
  // If a zero-length widget is inserted next to the cursor during
  // composition, avoid moving it across it and disrupting the
  // composition.
  suppressWidgetCursorChange(e, n) {
    return this.hasComposition && n.empty && rc(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset) && this.posFromDOM(e.focusNode, e.focusOffset) == n.head;
  }
  enforceCursorAssoc() {
    if (this.hasComposition)
      return;
    let { view: e } = this, n = e.state.selection.main, r = Dc(e.root), { anchorNode: i, anchorOffset: s } = e.observer.selectionRange;
    if (!r || !n.empty || !n.assoc || !r.modify)
      return;
    let o = pt.find(this, n.head);
    if (!o)
      return;
    let a = o.posAtStart;
    if (n.head == a || n.head == a + o.length)
      return;
    let l = this.coordsAt(n.head, -1), c = this.coordsAt(n.head, 1);
    if (!l || !c || l.bottom > c.top)
      return;
    let u = this.domAtPos(n.head + n.assoc);
    r.collapse(u.node, u.offset), r.modify("move", n.assoc < 0 ? "forward" : "backward", "lineboundary"), e.observer.readSelectionRange();
    let h = e.observer.selectionRange;
    e.docView.posFromDOM(h.anchorNode, h.anchorOffset) != n.from && r.collapse(i, s);
  }
  // If a position is in/near a block widget, move it to a nearby text
  // line, since we don't want the cursor inside a block widget.
  moveToLine(e) {
    let n = this.dom, r;
    if (e.node != n)
      return e;
    for (let i = e.offset; !r && i < n.childNodes.length; i++) {
      let s = qe.get(n.childNodes[i]);
      s instanceof pt && (r = s.domAtPos(0));
    }
    for (let i = e.offset - 1; !r && i >= 0; i--) {
      let s = qe.get(n.childNodes[i]);
      s instanceof pt && (r = s.domAtPos(s.length));
    }
    return r ? new zt(r.node, r.offset, !0) : e;
  }
  nearest(e) {
    for (let n = e; n; ) {
      let r = qe.get(n);
      if (r && r.rootView == this)
        return r;
      n = n.parentNode;
    }
    return null;
  }
  posFromDOM(e, n) {
    let r = this.nearest(e);
    if (!r)
      throw new RangeError("Trying to find position for a DOM position outside of the document");
    return r.localPosFromDOM(e, n) + r.posAtStart;
  }
  domAtPos(e) {
    let { i: n, off: r } = this.childCursor().findPos(e, -1);
    for (; n < this.children.length - 1; ) {
      let i = this.children[n];
      if (r < i.length || i instanceof pt)
        break;
      n++, r = 0;
    }
    return this.children[n].domAtPos(r);
  }
  coordsAt(e, n) {
    let r = null, i = 0;
    for (let s = this.length, o = this.children.length - 1; o >= 0; o--) {
      let a = this.children[o], l = s - a.breakAfter, c = l - a.length;
      if (l < e)
        break;
      if (c <= e && (c < e || a.covers(-1)) && (l > e || a.covers(1)) && (!r || a instanceof pt && !(r instanceof pt && n >= 0)))
        r = a, i = c;
      else if (r && c == e && l == e && a instanceof mi && Math.abs(n) < 2) {
        if (a.deco.startSide < 0)
          break;
        o && (r = null);
      }
      s = c;
    }
    return r ? r.coordsAt(e - i, n) : null;
  }
  coordsForChar(e) {
    let { i: n, off: r } = this.childPos(e, 1), i = this.children[n];
    if (!(i instanceof pt))
      return null;
    for (; i.children.length; ) {
      let { i: a, off: l } = i.childPos(r, 1);
      for (; ; a++) {
        if (a == i.children.length)
          return null;
        if ((i = i.children[a]).length)
          break;
      }
      r = l;
    }
    if (!(i instanceof pr))
      return null;
    let s = Pt(i.text, r);
    if (s == r)
      return null;
    let o = go(i.dom, r, s).getClientRects();
    for (let a = 0; a < o.length; a++) {
      let l = o[a];
      if (a == o.length - 1 || l.top < l.bottom && l.left < l.right)
        return l;
    }
    return null;
  }
  measureVisibleLineHeights(e) {
    let n = [], { from: r, to: i } = e, s = this.view.contentDOM.clientWidth, o = s > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1, a = -1, l = this.view.textDirection == Qe.LTR;
    for (let c = 0, u = 0; u < this.children.length; u++) {
      let h = this.children[u], f = c + h.length;
      if (f > i)
        break;
      if (c >= r) {
        let d = h.dom.getBoundingClientRect();
        if (n.push(d.height), o) {
          let p = h.dom.lastChild, m = p ? Ca(p) : [];
          if (m.length) {
            let v = m[m.length - 1], g = l ? v.right - d.left : d.right - v.left;
            g > a && (a = g, this.minWidth = s, this.minWidthFrom = c, this.minWidthTo = f);
          }
        }
      }
      c = f + h.breakAfter;
    }
    return n;
  }
  textDirectionAt(e) {
    let { i: n } = this.childPos(e, 1);
    return getComputedStyle(this.children[n].dom).direction == "rtl" ? Qe.RTL : Qe.LTR;
  }
  measureTextSize() {
    for (let s of this.children)
      if (s instanceof pt) {
        let o = s.measureTextSize();
        if (o)
          return o;
      }
    let e = document.createElement("div"), n, r, i;
    return e.className = "cm-line", e.style.width = "99999px", e.style.position = "absolute", e.textContent = "abc def ghi jkl mno pqr stu", this.view.observer.ignore(() => {
      this.dom.appendChild(e);
      let s = Ca(e.firstChild)[0];
      n = e.getBoundingClientRect().height, r = s ? s.width / 27 : 7, i = s ? s.height : n, e.remove();
    }), { lineHeight: n, charWidth: r, textHeight: i };
  }
  childCursor(e = this.length) {
    let n = this.children.length;
    return n && (e -= this.children[--n].length), new Y8(this.children, e, n);
  }
  computeBlockGapDeco() {
    let e = [], n = this.view.viewState;
    for (let r = 0, i = 0; ; i++) {
      let s = i == n.viewports.length ? null : n.viewports[i], o = s ? s.from - 1 : this.length;
      if (o > r) {
        let a = (n.lineBlockAt(o).bottom - n.lineBlockAt(r).top) / this.view.scaleY;
        e.push(we.replace({
          widget: new q2(a),
          block: !0,
          inclusive: !0,
          isBlockGap: !0
        }).range(r, o));
      }
      if (!s)
        break;
      r = s.to + 1;
    }
    return we.set(e);
  }
  updateDeco() {
    let e = 1, n = this.view.state.facet(Tc).map((s) => (this.dynamicDecorationMap[e++] = typeof s == "function") ? s(this.view) : s), r = !1, i = this.view.state.facet(p6).map((s, o) => {
      let a = typeof s == "function";
      return a && (r = !0), a ? s(this.view) : s;
    });
    for (i.length && (this.dynamicDecorationMap[e++] = r, n.push(Be.join(i))), this.decorations = [
      this.editContextFormatting,
      ...n,
      this.computeBlockGapDeco(),
      this.view.viewState.lineGapDeco
    ]; e < this.decorations.length; )
      this.dynamicDecorationMap[e++] = !1;
    return this.decorations;
  }
  scrollIntoView(e) {
    if (e.isSnapshot) {
      let c = this.view.viewState.lineBlockAt(e.range.head);
      this.view.scrollDOM.scrollTop = c.top - e.yMargin, this.view.scrollDOM.scrollLeft = e.xMargin;
      return;
    }
    for (let c of this.view.state.facet(f6))
      try {
        if (c(this.view, e.range, e))
          return !0;
      } catch (u) {
        un(this.view.state, u, "scroll handler");
      }
    let { range: n } = e, r = this.coordsAt(n.head, n.empty ? n.assoc : n.head > n.anchor ? -1 : 1), i;
    if (!r)
      return;
    !n.empty && (i = this.coordsAt(n.anchor, n.anchor > n.head ? -1 : 1)) && (r = {
      left: Math.min(r.left, i.left),
      top: Math.min(r.top, i.top),
      right: Math.max(r.right, i.right),
      bottom: Math.max(r.bottom, i.bottom)
    });
    let s = v6(this.view), o = {
      left: r.left - s.left,
      top: r.top - s.top,
      right: r.right + s.right,
      bottom: r.bottom + s.bottom
    }, { offsetWidth: a, offsetHeight: l } = this.view.scrollDOM;
    LW(this.view.scrollDOM, o, n.head < n.anchor ? -1 : 1, e.x, e.y, Math.max(Math.min(e.xMargin, a), -a), Math.max(Math.min(e.yMargin, l), -l), this.view.textDirection == Qe.LTR);
  }
}
function ej(t) {
  return t.node.nodeType == 1 && t.node.firstChild && (t.offset == 0 || t.node.childNodes[t.offset - 1].contentEditable == "false") && (t.offset == t.node.childNodes.length || t.node.childNodes[t.offset].contentEditable == "false");
}
class q2 extends Oi {
  constructor(e) {
    super(), this.height = e;
  }
  toDOM() {
    let e = document.createElement("div");
    return e.className = "cm-gap", this.updateDOM(e), e;
  }
  eq(e) {
    return e.height == this.height;
  }
  updateDOM(e) {
    return e.style.height = this.height + "px", !0;
  }
  get editable() {
    return !0;
  }
  get estimatedHeight() {
    return this.height;
  }
  ignoreEvent() {
    return !1;
  }
}
function y6(t, e) {
  let n = t.observer.selectionRange;
  if (!n.focusNode)
    return null;
  let r = V8(n.focusNode, n.focusOffset), i = H8(n.focusNode, n.focusOffset), s = r || i;
  if (i && r && i.node != r.node) {
    let a = qe.get(i.node);
    if (!a || a instanceof pr && a.text != i.node.nodeValue)
      s = i;
    else if (t.docView.lastCompositionAfterCursor) {
      let l = qe.get(r.node);
      !l || l instanceof pr && l.text != r.node.nodeValue || (s = i);
    }
  }
  if (t.docView.lastCompositionAfterCursor = s != r, !s)
    return null;
  let o = e - s.offset;
  return { from: o, to: o + s.node.nodeValue.length, node: s.node };
}
function tj(t, e, n) {
  let r = y6(t, n);
  if (!r)
    return null;
  let { node: i, from: s, to: o } = r, a = i.nodeValue;
  if (/[\n\r]/.test(a) || t.state.doc.sliceString(r.from, r.to) != a)
    return null;
  let l = e.invertedDesc, c = new jn(l.mapPos(s), l.mapPos(o), s, o), u = [];
  for (let h = i.parentNode; ; h = h.parentNode) {
    let f = qe.get(h);
    if (f instanceof _i)
      u.push({ node: h, deco: f.mark });
    else {
      if (f instanceof pt || h.nodeName == "DIV" && h.parentNode == t.contentDOM)
        return { range: c, text: i, marks: u, line: h };
      if (h != t.contentDOM)
        u.push({ node: h, deco: new bu({
          inclusive: !0,
          attributes: HW(h),
          tagName: h.tagName.toLowerCase()
        }) });
      else
        return null;
    }
  }
}
function nj(t, e) {
  return t.nodeType != 1 ? 0 : (e && t.childNodes[e - 1].contentEditable == "false" ? 1 : 0) | (e < t.childNodes.length && t.childNodes[e].contentEditable == "false" ? 2 : 0);
}
let rj = class {
  constructor() {
    this.changes = [];
  }
  compareRange(e, n) {
    O0(e, n, this.changes);
  }
  comparePoint(e, n) {
    O0(e, n, this.changes);
  }
};
function ij(t, e, n) {
  let r = new rj();
  return Be.compare(t, e, n, r), r.changes;
}
function sj(t, e) {
  for (let n = t; n && n != e; n = n.assignedSlot || n.parentNode)
    if (n.nodeType == 1 && n.contentEditable == "false")
      return !0;
  return !1;
}
function oj(t, e) {
  let n = !1;
  return e && t.iterChangedRanges((r, i) => {
    r < e.to && i > e.from && (n = !0);
  }), n;
}
function aj(t, e, n = 1) {
  let r = t.charCategorizer(e), i = t.doc.lineAt(e), s = e - i.from;
  if (i.length == 0)
    return W.cursor(e);
  s == 0 ? n = 1 : s == i.length && (n = -1);
  let o = s, a = s;
  n < 0 ? o = Pt(i.text, s, !1) : a = Pt(i.text, s);
  let l = r(i.text.slice(o, a));
  for (; o > 0; ) {
    let c = Pt(i.text, o, !1);
    if (r(i.text.slice(c, o)) != l)
      break;
    o = c;
  }
  for (; a < i.length; ) {
    let c = Pt(i.text, a);
    if (r(i.text.slice(a, c)) != l)
      break;
    a = c;
  }
  return W.range(o + i.from, a + i.from);
}
function lj(t, e) {
  return e.left > t ? e.left - t : Math.max(0, t - e.right);
}
function cj(t, e) {
  return e.top > t ? e.top - t : Math.max(0, t - e.bottom);
}
function km(t, e) {
  return t.top < e.bottom - 1 && t.bottom > e.top + 1;
}
function U2(t, e) {
  return e < t.top ? { top: e, left: t.left, right: t.right, bottom: t.bottom } : t;
}
function K2(t, e) {
  return e > t.bottom ? { top: t.top, left: t.left, right: t.right, bottom: e } : t;
}
function I0(t, e, n) {
  let r, i, s, o, a = !1, l, c, u, h;
  for (let p = t.firstChild; p; p = p.nextSibling) {
    let m = Ca(p);
    for (let v = 0; v < m.length; v++) {
      let g = m[v];
      i && km(i, g) && (g = U2(K2(g, i.bottom), i.top));
      let y = lj(e, g), x = cj(n, g);
      if (y == 0 && x == 0)
        return p.nodeType == 3 ? G2(p, e, n) : I0(p, e, n);
      if (!r || o > x || o == x && s > y) {
        r = p, i = g, s = y, o = x;
        let b = x ? n < g.top ? -1 : 1 : y ? e < g.left ? -1 : 1 : 0;
        a = !b || (b > 0 ? v < m.length - 1 : v > 0);
      }
      y == 0 ? n > g.bottom && (!u || u.bottom < g.bottom) ? (l = p, u = g) : n < g.top && (!h || h.top > g.top) && (c = p, h = g) : u && km(u, g) ? u = K2(u, g.bottom) : h && km(h, g) && (h = U2(h, g.top));
    }
  }
  if (u && u.bottom >= n ? (r = l, i = u) : h && h.top <= n && (r = c, i = h), !r)
    return { node: t, offset: 0 };
  let f = Math.max(i.left, Math.min(i.right, e));
  if (r.nodeType == 3)
    return G2(r, f, n);
  if (a && r.contentEditable != "false")
    return I0(r, f, n);
  let d = Array.prototype.indexOf.call(t.childNodes, r) + (e >= (i.left + i.right) / 2 ? 1 : 0);
  return { node: t, offset: d };
}
function G2(t, e, n) {
  let r = t.nodeValue.length, i = -1, s = 1e9, o = 0;
  for (let a = 0; a < r; a++) {
    let l = go(t, a, a + 1).getClientRects();
    for (let c = 0; c < l.length; c++) {
      let u = l[c];
      if (u.top == u.bottom)
        continue;
      o || (o = e - u.left);
      let h = (u.top > n ? u.top - n : n - u.bottom) - 1;
      if (u.left - 1 <= e && u.right + 1 >= e && h < s) {
        let f = e >= (u.left + u.right) / 2, d = f;
        if ((me.chrome || me.gecko) && go(t, a).getBoundingClientRect().left == u.right && (d = !f), h <= 0)
          return { node: t, offset: a + (d ? 1 : 0) };
        i = a + (d ? 1 : 0), s = h;
      }
    }
  }
  return { node: t, offset: i > -1 ? i : o > 0 ? t.nodeValue.length : 0 };
}
function b6(t, e, n, r = -1) {
  var i, s;
  let o = t.contentDOM.getBoundingClientRect(), a = o.top + t.viewState.paddingTop, l, { docHeight: c } = t.viewState, { x: u, y: h } = e, f = h - a;
  if (f < 0)
    return 0;
  if (f > c)
    return t.state.doc.length;
  for (let b = t.viewState.heightOracle.textHeight / 2, w = !1; l = t.elementAtHeight(f), l.type != tn.Text; )
    for (; f = r > 0 ? l.bottom + b : l.top - b, !(f >= 0 && f <= c); ) {
      if (w)
        return n ? null : 0;
      w = !0, r = -r;
    }
  h = a + f;
  let d = l.from;
  if (d < t.viewport.from)
    return t.viewport.from == 0 ? 0 : n ? null : X2(t, o, l, u, h);
  if (d > t.viewport.to)
    return t.viewport.to == t.state.doc.length ? t.state.doc.length : n ? null : X2(t, o, l, u, h);
  let p = t.dom.ownerDocument, m = t.root.elementFromPoint ? t.root : p, v = m.elementFromPoint(u, h);
  v && !t.contentDOM.contains(v) && (v = null), v || (u = Math.max(o.left + 1, Math.min(o.right - 1, u)), v = m.elementFromPoint(u, h), v && !t.contentDOM.contains(v) && (v = null));
  let g, y = -1;
  if (v && ((i = t.docView.nearest(v)) === null || i === void 0 ? void 0 : i.isEditable) != !1) {
    if (p.caretPositionFromPoint) {
      let b = p.caretPositionFromPoint(u, h);
      b && ({ offsetNode: g, offset: y } = b);
    } else if (p.caretRangeFromPoint) {
      let b = p.caretRangeFromPoint(u, h);
      b && ({ startContainer: g, startOffset: y } = b, (!t.contentDOM.contains(g) || me.safari && uj(g, y, u) || me.chrome && fj(g, y, u)) && (g = void 0));
    }
  }
  if (!g || !t.docView.dom.contains(g)) {
    let b = pt.find(t.docView, d);
    if (!b)
      return f > l.top + l.height / 2 ? l.to : l.from;
    ({ node: g, offset: y } = I0(b.dom, u, h));
  }
  let x = t.docView.nearest(g);
  if (!x)
    return null;
  if (x.isWidget && ((s = x.dom) === null || s === void 0 ? void 0 : s.nodeType) == 1) {
    let b = x.dom.getBoundingClientRect();
    return e.y < b.top || e.y <= b.bottom && e.x <= (b.left + b.right) / 2 ? x.posAtStart : x.posAtEnd;
  } else
    return x.localPosFromDOM(g, y) + x.posAtStart;
}
function X2(t, e, n, r, i) {
  let s = Math.round((r - e.left) * t.defaultCharacterWidth);
  if (t.lineWrapping && n.height > t.defaultLineHeight * 1.5) {
    let a = t.viewState.heightOracle.textHeight, l = Math.floor((i - n.top - (t.defaultLineHeight - a) * 0.5) / a);
    s += l * t.viewState.heightOracle.lineLength;
  }
  let o = t.state.sliceDoc(n.from, n.to);
  return n.from + k0(o, s, t.state.tabSize);
}
function uj(t, e, n) {
  let r;
  if (t.nodeType != 3 || e != (r = t.nodeValue.length))
    return !1;
  for (let i = t.nextSibling; i; i = i.nextSibling)
    if (i.nodeType != 1 || i.nodeName != "BR")
      return !1;
  return go(t, r - 1, r).getBoundingClientRect().left > n;
}
function fj(t, e, n) {
  if (e != 0)
    return !1;
  for (let i = t; ; ) {
    let s = i.parentNode;
    if (!s || s.nodeType != 1 || s.firstChild != i)
      return !1;
    if (s.classList.contains("cm-line"))
      break;
    i = s;
  }
  let r = t.nodeType == 1 ? t.getBoundingClientRect() : go(t, 0, Math.max(t.nodeValue.length, 1)).getBoundingClientRect();
  return n - r.left > 5;
}
function R0(t, e) {
  let n = t.lineBlockAt(e);
  if (Array.isArray(n.type)) {
    for (let r of n.type)
      if (r.to > e || r.to == e && (r.to == n.to || r.type == tn.Text))
        return r;
  }
  return n;
}
function hj(t, e, n, r) {
  let i = R0(t, e.head), s = !r || i.type != tn.Text || !(t.lineWrapping || i.widgetLineBreaks) ? null : t.coordsAtPos(e.assoc < 0 && e.head > i.from ? e.head - 1 : e.head);
  if (s) {
    let o = t.dom.getBoundingClientRect(), a = t.textDirectionAt(i.from), l = t.posAtCoords({
      x: n == (a == Qe.LTR) ? o.right - 1 : o.left + 1,
      y: (s.top + s.bottom) / 2
    });
    if (l != null)
      return W.cursor(l, n ? -1 : 1);
  }
  return W.cursor(n ? i.to : i.from, n ? -1 : 1);
}
function Z2(t, e, n, r) {
  let i = t.state.doc.lineAt(e.head), s = t.bidiSpans(i), o = t.textDirectionAt(i.from);
  for (let a = e, l = null; ; ) {
    let c = ZW(i, s, o, a, n), u = n6;
    if (!c) {
      if (i.number == (n ? t.state.doc.lines : 1))
        return a;
      u = `
`, i = t.state.doc.line(i.number + (n ? 1 : -1)), s = t.bidiSpans(i), c = t.visualLineSide(i, !n);
    }
    if (l) {
      if (!l(u))
        return a;
    } else {
      if (!r)
        return c;
      l = r(u);
    }
    a = c;
  }
}
function dj(t, e, n) {
  let r = t.state.charCategorizer(e), i = r(n);
  return (s) => {
    let o = r(s);
    return i == tt.Space && (i = o), i == o;
  };
}
function pj(t, e, n, r) {
  let i = e.head, s = n ? 1 : -1;
  if (i == (n ? t.state.doc.length : 0))
    return W.cursor(i, e.assoc);
  let o = e.goalColumn, a, l = t.contentDOM.getBoundingClientRect(), c = t.coordsAtPos(i, e.assoc || -1), u = t.documentTop;
  if (c)
    o == null && (o = c.left - l.left), a = s < 0 ? c.top : c.bottom;
  else {
    let d = t.viewState.lineBlockAt(i);
    o == null && (o = Math.min(l.right - l.left, t.defaultCharacterWidth * (i - d.from))), a = (s < 0 ? d.top : d.bottom) + u;
  }
  let h = l.left + o, f = r != null ? r : t.viewState.heightOracle.textHeight >> 1;
  for (let d = 0; ; d += 10) {
    let p = a + (f + d) * s, m = b6(t, { x: h, y: p }, !1, s);
    if (p < l.top || p > l.bottom || (s < 0 ? m < i : m > i)) {
      let v = t.docView.coordsForChar(m), g = !v || p < v.top ? -1 : 1;
      return W.cursor(m, g, void 0, o);
    }
  }
}
function Bf(t, e, n) {
  for (; ; ) {
    let r = 0;
    for (let i of t)
      i.between(e - 1, e + 1, (s, o, a) => {
        if (e > s && e < o) {
          let l = r || n || (e - s < o - e ? -1 : 1);
          e = l < 0 ? s : o, r = l;
        }
      });
    if (!r)
      return e;
  }
}
function _m(t, e, n) {
  let r = Bf(t.state.facet(U1).map((i) => i(t)), n.from, e.head > n.from ? -1 : 1);
  return r == n.from ? n : W.cursor(r, r < n.from ? 1 : -1);
}
class mj {
  setSelectionOrigin(e) {
    this.lastSelectionOrigin = e, this.lastSelectionTime = Date.now();
  }
  constructor(e) {
    this.view = e, this.lastKeyCode = 0, this.lastKeyTime = 0, this.lastTouchTime = 0, this.lastFocusTime = 0, this.lastScrollTop = 0, this.lastScrollLeft = 0, this.pendingIOSKey = void 0, this.tabFocusMode = -1, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastContextMenu = 0, this.scrollHandlers = [], this.handlers = /* @__PURE__ */ Object.create(null), this.composing = -1, this.compositionFirstChange = null, this.compositionEndedAt = 0, this.compositionPendingKey = !1, this.compositionPendingChange = !1, this.mouseSelection = null, this.draggedContent = null, this.handleEvent = this.handleEvent.bind(this), this.notifiedFocused = e.hasFocus, me.safari && e.contentDOM.addEventListener("input", () => null), me.gecko && Oj(e.contentDOM.ownerDocument);
  }
  handleEvent(e) {
    !_j(this.view, e) || this.ignoreDuringComposition(e) || e.type == "keydown" && this.keydown(e) || this.runHandlers(e.type, e);
  }
  runHandlers(e, n) {
    let r = this.handlers[e];
    if (r) {
      for (let i of r.observers)
        i(this.view, n);
      for (let i of r.handlers) {
        if (n.defaultPrevented)
          break;
        if (i(this.view, n)) {
          n.preventDefault();
          break;
        }
      }
    }
  }
  ensureHandlers(e) {
    let n = gj(e), r = this.handlers, i = this.view.contentDOM;
    for (let s in n)
      if (s != "scroll") {
        let o = !n[s].handlers.length, a = r[s];
        a && o != !a.handlers.length && (i.removeEventListener(s, this.handleEvent), a = null), a || i.addEventListener(s, this.handleEvent, { passive: o });
      }
    for (let s in r)
      s != "scroll" && !n[s] && i.removeEventListener(s, this.handleEvent);
    this.handlers = n;
  }
  keydown(e) {
    if (this.lastKeyCode = e.keyCode, this.lastKeyTime = Date.now(), e.keyCode == 9 && this.tabFocusMode > -1 && (!this.tabFocusMode || Date.now() <= this.tabFocusMode))
      return !0;
    if (this.tabFocusMode > 0 && e.keyCode != 27 && w6.indexOf(e.keyCode) < 0 && (this.tabFocusMode = -1), me.android && me.chrome && !e.synthetic && (e.keyCode == 13 || e.keyCode == 8))
      return this.view.observer.delayAndroidKey(e.key, e.keyCode), !0;
    let n;
    return me.ios && !e.synthetic && !e.altKey && !e.metaKey && ((n = x6.find((r) => r.keyCode == e.keyCode)) && !e.ctrlKey || vj.indexOf(e.key) > -1 && e.ctrlKey && !e.shiftKey) ? (this.pendingIOSKey = n || e, setTimeout(() => this.flushIOSKey(), 250), !0) : (e.keyCode != 229 && this.view.observer.forceFlush(), !1);
  }
  flushIOSKey(e) {
    let n = this.pendingIOSKey;
    return !n || n.key == "Enter" && e && e.from < e.to && /^\S+$/.test(e.insert.toString()) ? !1 : (this.pendingIOSKey = void 0, na(this.view.contentDOM, n.key, n.keyCode, n instanceof KeyboardEvent ? n : void 0));
  }
  ignoreDuringComposition(e) {
    return /^key/.test(e.type) ? this.composing > 0 ? !0 : me.safari && !me.ios && this.compositionPendingKey && Date.now() - this.compositionEndedAt < 100 ? (this.compositionPendingKey = !1, !0) : !1 : !1;
  }
  startMouseSelection(e) {
    this.mouseSelection && this.mouseSelection.destroy(), this.mouseSelection = e;
  }
  update(e) {
    this.view.observer.update(e), this.mouseSelection && this.mouseSelection.update(e), this.draggedContent && e.docChanged && (this.draggedContent = this.draggedContent.map(e.changes)), e.transactions.length && (this.lastKeyCode = this.lastSelectionTime = 0);
  }
  destroy() {
    this.mouseSelection && this.mouseSelection.destroy();
  }
}
function J2(t, e) {
  return (n, r) => {
    try {
      return e.call(t, r, n);
    } catch (i) {
      un(n.state, i);
    }
  };
}
function gj(t) {
  let e = /* @__PURE__ */ Object.create(null);
  function n(r) {
    return e[r] || (e[r] = { observers: [], handlers: [] });
  }
  for (let r of t) {
    let i = r.spec;
    if (i && i.domEventHandlers)
      for (let s in i.domEventHandlers) {
        let o = i.domEventHandlers[s];
        o && n(s).handlers.push(J2(r.value, o));
      }
    if (i && i.domEventObservers)
      for (let s in i.domEventObservers) {
        let o = i.domEventObservers[s];
        o && n(s).observers.push(J2(r.value, o));
      }
  }
  for (let r in mr)
    n(r).handlers.push(mr[r]);
  for (let r in Jn)
    n(r).observers.push(Jn[r]);
  return e;
}
const x6 = [
  { key: "Backspace", keyCode: 8, inputType: "deleteContentBackward" },
  { key: "Enter", keyCode: 13, inputType: "insertParagraph" },
  { key: "Enter", keyCode: 13, inputType: "insertLineBreak" },
  { key: "Delete", keyCode: 46, inputType: "deleteContentForward" }
], vj = "dthko", w6 = [16, 17, 18, 20, 91, 92, 224, 225], nf = 6;
function rf(t) {
  return Math.max(0, t) * 0.7 + 8;
}
function yj(t, e) {
  return Math.max(Math.abs(t.clientX - e.clientX), Math.abs(t.clientY - e.clientY));
}
class bj {
  constructor(e, n, r, i) {
    this.view = e, this.startEvent = n, this.style = r, this.mustSelect = i, this.scrollSpeed = { x: 0, y: 0 }, this.scrolling = -1, this.lastEvent = n, this.scrollParents = NW(e.contentDOM), this.atoms = e.state.facet(U1).map((o) => o(e));
    let s = e.contentDOM.ownerDocument;
    s.addEventListener("mousemove", this.move = this.move.bind(this)), s.addEventListener("mouseup", this.up = this.up.bind(this)), this.extend = n.shiftKey, this.multiple = e.state.facet(Le.allowMultipleSelections) && xj(e, n), this.dragging = kj(e, n) && M6(n) == 1 ? null : !1;
  }
  start(e) {
    this.dragging === !1 && this.select(e);
  }
  move(e) {
    if (e.buttons == 0)
      return this.destroy();
    if (this.dragging || this.dragging == null && yj(this.startEvent, e) < 10)
      return;
    this.select(this.lastEvent = e);
    let n = 0, r = 0, i = 0, s = 0, o = this.view.win.innerWidth, a = this.view.win.innerHeight;
    this.scrollParents.x && ({ left: i, right: o } = this.scrollParents.x.getBoundingClientRect()), this.scrollParents.y && ({ top: s, bottom: a } = this.scrollParents.y.getBoundingClientRect());
    let l = v6(this.view);
    e.clientX - l.left <= i + nf ? n = -rf(i - e.clientX) : e.clientX + l.right >= o - nf && (n = rf(e.clientX - o)), e.clientY - l.top <= s + nf ? r = -rf(s - e.clientY) : e.clientY + l.bottom >= a - nf && (r = rf(e.clientY - a)), this.setScrollSpeed(n, r);
  }
  up(e) {
    this.dragging == null && this.select(this.lastEvent), this.dragging || e.preventDefault(), this.destroy();
  }
  destroy() {
    this.setScrollSpeed(0, 0);
    let e = this.view.contentDOM.ownerDocument;
    e.removeEventListener("mousemove", this.move), e.removeEventListener("mouseup", this.up), this.view.inputState.mouseSelection = this.view.inputState.draggedContent = null;
  }
  setScrollSpeed(e, n) {
    this.scrollSpeed = { x: e, y: n }, e || n ? this.scrolling < 0 && (this.scrolling = setInterval(() => this.scroll(), 50)) : this.scrolling > -1 && (clearInterval(this.scrolling), this.scrolling = -1);
  }
  scroll() {
    let { x: e, y: n } = this.scrollSpeed;
    e && this.scrollParents.x && (this.scrollParents.x.scrollLeft += e, e = 0), n && this.scrollParents.y && (this.scrollParents.y.scrollTop += n, n = 0), (e || n) && this.view.win.scrollBy(e, n), this.dragging === !1 && this.select(this.lastEvent);
  }
  skipAtoms(e) {
    let n = null;
    for (let r = 0; r < e.ranges.length; r++) {
      let i = e.ranges[r], s = null;
      if (i.empty) {
        let o = Bf(this.atoms, i.from, 0);
        o != i.from && (s = W.cursor(o, -1));
      } else {
        let o = Bf(this.atoms, i.from, -1), a = Bf(this.atoms, i.to, 1);
        (o != i.from || a != i.to) && (s = W.range(i.from == i.anchor ? o : a, i.from == i.head ? o : a));
      }
      s && (n || (n = e.ranges.slice()), n[r] = s);
    }
    return n ? W.create(n, e.mainIndex) : e;
  }
  select(e) {
    let { view: n } = this, r = this.skipAtoms(this.style.get(e, this.extend, this.multiple));
    (this.mustSelect || !r.eq(n.state.selection, this.dragging === !1)) && this.view.dispatch({
      selection: r,
      userEvent: "select.pointer"
    }), this.mustSelect = !1;
  }
  update(e) {
    e.transactions.some((n) => n.isUserEvent("input.type")) ? this.destroy() : this.style.update(e) && setTimeout(() => this.select(this.lastEvent), 20);
  }
}
function xj(t, e) {
  let n = t.state.facet(r6);
  return n.length ? n[0](e) : me.mac ? e.metaKey : e.ctrlKey;
}
function wj(t, e) {
  let n = t.state.facet(i6);
  return n.length ? n[0](e) : me.mac ? !e.altKey : !e.ctrlKey;
}
function kj(t, e) {
  let { main: n } = t.state.selection;
  if (n.empty)
    return !1;
  let r = Dc(t.root);
  if (!r || r.rangeCount == 0)
    return !0;
  let i = r.getRangeAt(0).getClientRects();
  for (let s = 0; s < i.length; s++) {
    let o = i[s];
    if (o.left <= e.clientX && o.right >= e.clientX && o.top <= e.clientY && o.bottom >= e.clientY)
      return !0;
  }
  return !1;
}
function _j(t, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (let n = e.target, r; n != t.contentDOM; n = n.parentNode)
    if (!n || n.nodeType == 11 || (r = qe.get(n)) && r.ignoreEvent(e))
      return !1;
  return !0;
}
const mr = /* @__PURE__ */ Object.create(null), Jn = /* @__PURE__ */ Object.create(null), k6 = me.ie && me.ie_version < 15 || me.ios && me.webkit_version < 604;
function Sj(t) {
  let e = t.dom.parentNode;
  if (!e)
    return;
  let n = e.appendChild(document.createElement("textarea"));
  n.style.cssText = "position: fixed; left: -10000px; top: 10px", n.focus(), setTimeout(() => {
    t.focus(), n.remove(), _6(t, n.value);
  }, 50);
}
function _6(t, e) {
  let { state: n } = t, r, i = 1, s = n.toText(e), o = s.lines == n.selection.ranges.length;
  if (B0 != null && n.selection.ranges.every((l) => l.empty) && B0 == s.toString()) {
    let l = -1;
    r = n.changeByRange((c) => {
      let u = n.doc.lineAt(c.from);
      if (u.from == l)
        return { range: c };
      l = u.from;
      let h = n.toText((o ? s.line(i++).text : e) + n.lineBreak);
      return {
        changes: { from: u.from, insert: h },
        range: W.cursor(c.from + h.length)
      };
    });
  } else o ? r = n.changeByRange((l) => {
    let c = s.line(i++);
    return {
      changes: { from: l.from, to: l.to, insert: c.text },
      range: W.cursor(l.from + c.length)
    };
  }) : r = n.replaceSelection(s);
  t.dispatch(r, {
    userEvent: "input.paste",
    scrollIntoView: !0
  });
}
Jn.scroll = (t) => {
  t.inputState.lastScrollTop = t.scrollDOM.scrollTop, t.inputState.lastScrollLeft = t.scrollDOM.scrollLeft;
};
mr.keydown = (t, e) => (t.inputState.setSelectionOrigin("select"), e.keyCode == 27 && t.inputState.tabFocusMode != 0 && (t.inputState.tabFocusMode = Date.now() + 2e3), !1);
Jn.touchstart = (t, e) => {
  t.inputState.lastTouchTime = Date.now(), t.inputState.setSelectionOrigin("select.pointer");
};
Jn.touchmove = (t) => {
  t.inputState.setSelectionOrigin("select.pointer");
};
mr.mousedown = (t, e) => {
  if (t.observer.flush(), t.inputState.lastTouchTime > Date.now() - 2e3)
    return !1;
  let n = null;
  for (let r of t.state.facet(s6))
    if (n = r(t, e), n)
      break;
  if (!n && e.button == 0 && (n = $j(t, e)), n) {
    let r = !t.hasFocus;
    t.inputState.startMouseSelection(new bj(t, e, n, r)), r && t.observer.ignore(() => {
      B8(t.contentDOM);
      let s = t.root.activeElement;
      s && !s.contains(t.contentDOM) && s.blur();
    });
    let i = t.inputState.mouseSelection;
    if (i)
      return i.start(e), i.dragging === !1;
  }
  return !1;
};
function Q2(t, e, n, r) {
  if (r == 1)
    return W.cursor(e, n);
  if (r == 2)
    return aj(t.state, e, n);
  {
    let i = pt.find(t.docView, e), s = t.state.doc.lineAt(i ? i.posAtEnd : e), o = i ? i.posAtStart : s.from, a = i ? i.posAtEnd : s.to;
    return a < t.state.doc.length && a == s.to && a++, W.range(o, a);
  }
}
let S6 = (t, e) => t >= e.top && t <= e.bottom, ew = (t, e, n) => S6(e, n) && t >= n.left && t <= n.right;
function Mj(t, e, n, r) {
  let i = pt.find(t.docView, e);
  if (!i)
    return 1;
  let s = e - i.posAtStart;
  if (s == 0)
    return 1;
  if (s == i.length)
    return -1;
  let o = i.coordsAt(s, -1);
  if (o && ew(n, r, o))
    return -1;
  let a = i.coordsAt(s, 1);
  return a && ew(n, r, a) ? 1 : o && S6(r, o) ? -1 : 1;
}
function tw(t, e) {
  let n = t.posAtCoords({ x: e.clientX, y: e.clientY }, !1);
  return { pos: n, bias: Mj(t, n, e.clientX, e.clientY) };
}
const Cj = me.ie && me.ie_version <= 11;
let nw = null, rw = 0, iw = 0;
function M6(t) {
  if (!Cj)
    return t.detail;
  let e = nw, n = iw;
  return nw = t, iw = Date.now(), rw = !e || n > Date.now() - 400 && Math.abs(e.clientX - t.clientX) < 2 && Math.abs(e.clientY - t.clientY) < 2 ? (rw + 1) % 3 : 1;
}
function $j(t, e) {
  let n = tw(t, e), r = M6(e), i = t.state.selection;
  return {
    update(s) {
      s.docChanged && (n.pos = s.changes.mapPos(n.pos), i = i.map(s.changes));
    },
    get(s, o, a) {
      let l = tw(t, s), c, u = Q2(t, l.pos, l.bias, r);
      if (n.pos != l.pos && !o) {
        let h = Q2(t, n.pos, n.bias, r), f = Math.min(h.from, u.from), d = Math.max(h.to, u.to);
        u = f < u.from ? W.range(f, d) : W.range(d, f);
      }
      return o ? i.replaceRange(i.main.extend(u.from, u.to)) : a && r == 1 && i.ranges.length > 1 && (c = Aj(i, l.pos)) ? c : a ? i.addRange(u) : W.create([u]);
    }
  };
}
function Aj(t, e) {
  for (let n = 0; n < t.ranges.length; n++) {
    let { from: r, to: i } = t.ranges[n];
    if (r <= e && i >= e)
      return W.create(t.ranges.slice(0, n).concat(t.ranges.slice(n + 1)), t.mainIndex == n ? 0 : t.mainIndex - (t.mainIndex > n ? 1 : 0));
  }
  return null;
}
mr.dragstart = (t, e) => {
  let { selection: { main: n } } = t.state;
  if (e.target.draggable) {
    let i = t.docView.nearest(e.target);
    if (i && i.isWidget) {
      let s = i.posAtStart, o = s + i.length;
      (s >= n.to || o <= n.from) && (n = W.range(s, o));
    }
  }
  let { inputState: r } = t;
  return r.mouseSelection && (r.mouseSelection.dragging = !0), r.draggedContent = n, e.dataTransfer && (e.dataTransfer.setData("Text", t.state.sliceDoc(n.from, n.to)), e.dataTransfer.effectAllowed = "copyMove"), !1;
};
mr.dragend = (t) => (t.inputState.draggedContent = null, !1);
function sw(t, e, n, r) {
  if (!n)
    return;
  let i = t.posAtCoords({ x: e.clientX, y: e.clientY }, !1), { draggedContent: s } = t.inputState, o = r && s && wj(t, e) ? { from: s.from, to: s.to } : null, a = { from: i, insert: n }, l = t.state.changes(o ? [o, a] : a);
  t.focus(), t.dispatch({
    changes: l,
    selection: { anchor: l.mapPos(i, -1), head: l.mapPos(i, 1) },
    userEvent: o ? "move.drop" : "input.drop"
  }), t.inputState.draggedContent = null;
}
mr.drop = (t, e) => {
  if (!e.dataTransfer)
    return !1;
  if (t.state.readOnly)
    return !0;
  let n = e.dataTransfer.files;
  if (n && n.length) {
    let r = Array(n.length), i = 0, s = () => {
      ++i == n.length && sw(t, e, r.filter((o) => o != null).join(t.state.lineBreak), !1);
    };
    for (let o = 0; o < n.length; o++) {
      let a = new FileReader();
      a.onerror = s, a.onload = () => {
        /[\x00-\x08\x0e-\x1f]{2}/.test(a.result) || (r[o] = a.result), s();
      }, a.readAsText(n[o]);
    }
    return !0;
  } else {
    let r = e.dataTransfer.getData("Text");
    if (r)
      return sw(t, e, r, !0), !0;
  }
  return !1;
};
mr.paste = (t, e) => {
  if (t.state.readOnly)
    return !0;
  t.observer.flush();
  let n = k6 ? null : e.clipboardData;
  return n ? (_6(t, n.getData("text/plain") || n.getData("text/uri-list")), !0) : (Sj(t), !1);
};
function Dj(t, e) {
  let n = t.dom.parentNode;
  if (!n)
    return;
  let r = n.appendChild(document.createElement("textarea"));
  r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.value = e, r.focus(), r.selectionEnd = e.length, r.selectionStart = 0, setTimeout(() => {
    r.remove(), t.focus();
  }, 50);
}
function Tj(t) {
  let e = [], n = [], r = !1;
  for (let i of t.selection.ranges)
    i.empty || (e.push(t.sliceDoc(i.from, i.to)), n.push(i));
  if (!e.length) {
    let i = -1;
    for (let { from: s } of t.selection.ranges) {
      let o = t.doc.lineAt(s);
      o.number > i && (e.push(o.text), n.push({ from: o.from, to: Math.min(t.doc.length, o.to + 1) })), i = o.number;
    }
    r = !0;
  }
  return { text: e.join(t.lineBreak), ranges: n, linewise: r };
}
let B0 = null;
mr.copy = mr.cut = (t, e) => {
  let { text: n, ranges: r, linewise: i } = Tj(t.state);
  if (!n && !i)
    return !1;
  B0 = i ? n : null, e.type == "cut" && !t.state.readOnly && t.dispatch({
    changes: r,
    scrollIntoView: !0,
    userEvent: "delete.cut"
  });
  let s = k6 ? null : e.clipboardData;
  return s ? (s.clearData(), s.setData("text/plain", n), !0) : (Dj(t, n), !1);
};
const C6 = /* @__PURE__ */ Ti.define();
function $6(t, e) {
  let n = [];
  for (let r of t.facet(l6)) {
    let i = r(t, e);
    i && n.push(i);
  }
  return n ? t.update({ effects: n, annotations: C6.of(!0) }) : null;
}
function A6(t) {
  setTimeout(() => {
    let e = t.hasFocus;
    if (e != t.inputState.notifiedFocused) {
      let n = $6(t.state, e);
      n ? t.dispatch(n) : t.update([]);
    }
  }, 10);
}
Jn.focus = (t) => {
  t.inputState.lastFocusTime = Date.now(), !t.scrollDOM.scrollTop && (t.inputState.lastScrollTop || t.inputState.lastScrollLeft) && (t.scrollDOM.scrollTop = t.inputState.lastScrollTop, t.scrollDOM.scrollLeft = t.inputState.lastScrollLeft), A6(t);
};
Jn.blur = (t) => {
  t.observer.clearSelectionRange(), A6(t);
};
Jn.compositionstart = Jn.compositionupdate = (t) => {
  t.observer.editContext || (t.inputState.compositionFirstChange == null && (t.inputState.compositionFirstChange = !0), t.inputState.composing < 0 && (t.inputState.composing = 0));
};
Jn.compositionend = (t) => {
  t.observer.editContext || (t.inputState.composing = -1, t.inputState.compositionEndedAt = Date.now(), t.inputState.compositionPendingKey = !0, t.inputState.compositionPendingChange = t.observer.pendingRecords().length > 0, t.inputState.compositionFirstChange = null, me.chrome && me.android ? t.observer.flushSoon() : t.inputState.compositionPendingChange ? Promise.resolve().then(() => t.observer.flush()) : setTimeout(() => {
    t.inputState.composing < 0 && t.docView.hasComposition && t.update([]);
  }, 50));
};
Jn.contextmenu = (t) => {
  t.inputState.lastContextMenu = Date.now();
};
mr.beforeinput = (t, e) => {
  var n;
  let r;
  if (me.chrome && me.android && (r = x6.find((i) => i.inputType == e.inputType)) && (t.observer.delayAndroidKey(r.key, r.keyCode), r.key == "Backspace" || r.key == "Delete")) {
    let i = ((n = window.visualViewport) === null || n === void 0 ? void 0 : n.height) || 0;
    setTimeout(() => {
      var s;
      (((s = window.visualViewport) === null || s === void 0 ? void 0 : s.height) || 0) > i + 10 && t.hasFocus && (t.contentDOM.blur(), t.focus());
    }, 100);
  }
  return me.ios && e.inputType == "deleteContentForward" && t.observer.flushSoon(), me.safari && e.inputType == "insertText" && t.inputState.composing >= 0 && setTimeout(() => Jn.compositionend(t, e), 20), !1;
};
const ow = /* @__PURE__ */ new Set();
function Oj(t) {
  ow.has(t) || (ow.add(t), t.addEventListener("copy", () => {
  }), t.addEventListener("cut", () => {
  }));
}
const aw = ["pre-wrap", "normal", "pre-line", "break-spaces"];
class Ej {
  constructor(e) {
    this.lineWrapping = e, this.doc = ze.empty, this.heightSamples = {}, this.lineHeight = 14, this.charWidth = 7, this.textHeight = 14, this.lineLength = 30, this.heightChanged = !1;
  }
  heightForGap(e, n) {
    let r = this.doc.lineAt(n).number - this.doc.lineAt(e).number + 1;
    return this.lineWrapping && (r += Math.max(0, Math.ceil((n - e - r * this.lineLength * 0.5) / this.lineLength))), this.lineHeight * r;
  }
  heightForLine(e) {
    return this.lineWrapping ? (1 + Math.max(0, Math.ceil((e - this.lineLength) / (this.lineLength - 5)))) * this.lineHeight : this.lineHeight;
  }
  setDoc(e) {
    return this.doc = e, this;
  }
  mustRefreshForWrapping(e) {
    return aw.indexOf(e) > -1 != this.lineWrapping;
  }
  mustRefreshForHeights(e) {
    let n = !1;
    for (let r = 0; r < e.length; r++) {
      let i = e[r];
      i < 0 ? r++ : this.heightSamples[Math.floor(i * 10)] || (n = !0, this.heightSamples[Math.floor(i * 10)] = !0);
    }
    return n;
  }
  refresh(e, n, r, i, s, o) {
    let a = aw.indexOf(e) > -1, l = Math.round(n) != Math.round(this.lineHeight) || this.lineWrapping != a;
    if (this.lineWrapping = a, this.lineHeight = n, this.charWidth = r, this.textHeight = i, this.lineLength = s, l) {
      this.heightSamples = {};
      for (let c = 0; c < o.length; c++) {
        let u = o[c];
        u < 0 ? c++ : this.heightSamples[Math.floor(u * 10)] = !0;
      }
    }
    return l;
  }
}
class Pj {
  constructor(e, n) {
    this.from = e, this.heights = n, this.index = 0;
  }
  get more() {
    return this.index < this.heights.length;
  }
}
class Er {
  /**
  @internal
  */
  constructor(e, n, r, i, s) {
    this.from = e, this.length = n, this.top = r, this.height = i, this._content = s;
  }
  /**
  The type of element this is. When querying lines, this may be
  an array of all the blocks that make up the line.
  */
  get type() {
    return typeof this._content == "number" ? tn.Text : Array.isArray(this._content) ? this._content : this._content.type;
  }
  /**
  The end of the element as a document position.
  */
  get to() {
    return this.from + this.length;
  }
  /**
  The bottom position of the element.
  */
  get bottom() {
    return this.top + this.height;
  }
  /**
  If this is a widget block, this will return the widget
  associated with it.
  */
  get widget() {
    return this._content instanceof gs ? this._content.widget : null;
  }
  /**
  If this is a textblock, this holds the number of line breaks
  that appear in widgets inside the block.
  */
  get widgetLineBreaks() {
    return typeof this._content == "number" ? this._content : 0;
  }
  /**
  @internal
  */
  join(e) {
    let n = (Array.isArray(this._content) ? this._content : [this]).concat(Array.isArray(e._content) ? e._content : [e]);
    return new Er(this.from, this.length + e.length, this.top, this.height + e.height, n);
  }
}
var Ze = /* @__PURE__ */ function(t) {
  return t[t.ByPos = 0] = "ByPos", t[t.ByHeight = 1] = "ByHeight", t[t.ByPosNoHeight = 2] = "ByPosNoHeight", t;
}(Ze || (Ze = {}));
const Ff = 1e-3;
class nn {
  constructor(e, n, r = 2) {
    this.length = e, this.height = n, this.flags = r;
  }
  get outdated() {
    return (this.flags & 2) > 0;
  }
  set outdated(e) {
    this.flags = (e ? 2 : 0) | this.flags & -3;
  }
  setHeight(e, n) {
    this.height != n && (Math.abs(this.height - n) > Ff && (e.heightChanged = !0), this.height = n);
  }
  // Base case is to replace a leaf node, which simply builds a tree
  // from the new nodes and returns that (HeightMapBranch and
  // HeightMapGap override this to actually use from/to)
  replace(e, n, r) {
    return nn.of(r);
  }
  // Again, these are base cases, and are overridden for branch and gap nodes.
  decomposeLeft(e, n) {
    n.push(this);
  }
  decomposeRight(e, n) {
    n.push(this);
  }
  applyChanges(e, n, r, i) {
    let s = this, o = r.doc;
    for (let a = i.length - 1; a >= 0; a--) {
      let { fromA: l, toA: c, fromB: u, toB: h } = i[a], f = s.lineAt(l, Ze.ByPosNoHeight, r.setDoc(n), 0, 0), d = f.to >= c ? f : s.lineAt(c, Ze.ByPosNoHeight, r, 0, 0);
      for (h += d.to - c, c = d.to; a > 0 && f.from <= i[a - 1].toA; )
        l = i[a - 1].fromA, u = i[a - 1].fromB, a--, l < f.from && (f = s.lineAt(l, Ze.ByPosNoHeight, r, 0, 0));
      u += f.from - l, l = f.from;
      let p = K1.build(r.setDoc(o), e, u, h);
      s = s.replace(l, c, p);
    }
    return s.updateHeight(r, 0);
  }
  static empty() {
    return new wn(0, 0);
  }
  // nodes uses null values to indicate the position of line breaks.
  // There are never line breaks at the start or end of the array, or
  // two line breaks next to each other, and the array isn't allowed
  // to be empty (same restrictions as return value from the builder).
  static of(e) {
    if (e.length == 1)
      return e[0];
    let n = 0, r = e.length, i = 0, s = 0;
    for (; ; )
      if (n == r)
        if (i > s * 2) {
          let a = e[n - 1];
          a.break ? e.splice(--n, 1, a.left, null, a.right) : e.splice(--n, 1, a.left, a.right), r += 1 + a.break, i -= a.size;
        } else if (s > i * 2) {
          let a = e[r];
          a.break ? e.splice(r, 1, a.left, null, a.right) : e.splice(r, 1, a.left, a.right), r += 2 + a.break, s -= a.size;
        } else
          break;
      else if (i < s) {
        let a = e[n++];
        a && (i += a.size);
      } else {
        let a = e[--r];
        a && (s += a.size);
      }
    let o = 0;
    return e[n - 1] == null ? (o = 1, n--) : e[n] == null && (o = 1, r++), new Lj(nn.of(e.slice(0, n)), o, nn.of(e.slice(r)));
  }
}
nn.prototype.size = 1;
class D6 extends nn {
  constructor(e, n, r) {
    super(e, n), this.deco = r;
  }
  blockAt(e, n, r, i) {
    return new Er(i, this.length, r, this.height, this.deco || 0);
  }
  lineAt(e, n, r, i, s) {
    return this.blockAt(0, r, i, s);
  }
  forEachLine(e, n, r, i, s, o) {
    e <= s + this.length && n >= s && o(this.blockAt(0, r, i, s));
  }
  updateHeight(e, n = 0, r = !1, i) {
    return i && i.from <= n && i.more && this.setHeight(e, i.heights[i.index++]), this.outdated = !1, this;
  }
  toString() {
    return `block(${this.length})`;
  }
}
class wn extends D6 {
  constructor(e, n) {
    super(e, n, null), this.collapsed = 0, this.widgetHeight = 0, this.breaks = 0;
  }
  blockAt(e, n, r, i) {
    return new Er(i, this.length, r, this.height, this.breaks);
  }
  replace(e, n, r) {
    let i = r[0];
    return r.length == 1 && (i instanceof wn || i instanceof At && i.flags & 4) && Math.abs(this.length - i.length) < 10 ? (i instanceof At ? i = new wn(i.length, this.height) : i.height = this.height, this.outdated || (i.outdated = !1), i) : nn.of(r);
  }
  updateHeight(e, n = 0, r = !1, i) {
    return i && i.from <= n && i.more ? this.setHeight(e, i.heights[i.index++]) : (r || this.outdated) && this.setHeight(e, Math.max(this.widgetHeight, e.heightForLine(this.length - this.collapsed)) + this.breaks * e.lineHeight), this.outdated = !1, this;
  }
  toString() {
    return `line(${this.length}${this.collapsed ? -this.collapsed : ""}${this.widgetHeight ? ":" + this.widgetHeight : ""})`;
  }
}
class At extends nn {
  constructor(e) {
    super(e, 0);
  }
  heightMetrics(e, n) {
    let r = e.doc.lineAt(n).number, i = e.doc.lineAt(n + this.length).number, s = i - r + 1, o, a = 0;
    if (e.lineWrapping) {
      let l = Math.min(this.height, e.lineHeight * s);
      o = l / s, this.length > s + 1 && (a = (this.height - l) / (this.length - s - 1));
    } else
      o = this.height / s;
    return { firstLine: r, lastLine: i, perLine: o, perChar: a };
  }
  blockAt(e, n, r, i) {
    let { firstLine: s, lastLine: o, perLine: a, perChar: l } = this.heightMetrics(n, i);
    if (n.lineWrapping) {
      let c = i + (e < n.lineHeight ? 0 : Math.round(Math.max(0, Math.min(1, (e - r) / this.height)) * this.length)), u = n.doc.lineAt(c), h = a + u.length * l, f = Math.max(r, e - h / 2);
      return new Er(u.from, u.length, f, h, 0);
    } else {
      let c = Math.max(0, Math.min(o - s, Math.floor((e - r) / a))), { from: u, length: h } = n.doc.line(s + c);
      return new Er(u, h, r + a * c, a, 0);
    }
  }
  lineAt(e, n, r, i, s) {
    if (n == Ze.ByHeight)
      return this.blockAt(e, r, i, s);
    if (n == Ze.ByPosNoHeight) {
      let { from: d, to: p } = r.doc.lineAt(e);
      return new Er(d, p - d, 0, 0, 0);
    }
    let { firstLine: o, perLine: a, perChar: l } = this.heightMetrics(r, s), c = r.doc.lineAt(e), u = a + c.length * l, h = c.number - o, f = i + a * h + l * (c.from - s - h);
    return new Er(c.from, c.length, Math.max(i, Math.min(f, i + this.height - u)), u, 0);
  }
  forEachLine(e, n, r, i, s, o) {
    e = Math.max(e, s), n = Math.min(n, s + this.length);
    let { firstLine: a, perLine: l, perChar: c } = this.heightMetrics(r, s);
    for (let u = e, h = i; u <= n; ) {
      let f = r.doc.lineAt(u);
      if (u == e) {
        let p = f.number - a;
        h += l * p + c * (e - s - p);
      }
      let d = l + c * f.length;
      o(new Er(f.from, f.length, h, d, 0)), h += d, u = f.to + 1;
    }
  }
  replace(e, n, r) {
    let i = this.length - n;
    if (i > 0) {
      let s = r[r.length - 1];
      s instanceof At ? r[r.length - 1] = new At(s.length + i) : r.push(null, new At(i - 1));
    }
    if (e > 0) {
      let s = r[0];
      s instanceof At ? r[0] = new At(e + s.length) : r.unshift(new At(e - 1), null);
    }
    return nn.of(r);
  }
  decomposeLeft(e, n) {
    n.push(new At(e - 1), null);
  }
  decomposeRight(e, n) {
    n.push(null, new At(this.length - e - 1));
  }
  updateHeight(e, n = 0, r = !1, i) {
    let s = n + this.length;
    if (i && i.from <= n + this.length && i.more) {
      let o = [], a = Math.max(n, i.from), l = -1;
      for (i.from > n && o.push(new At(i.from - n - 1).updateHeight(e, n)); a <= s && i.more; ) {
        let u = e.doc.lineAt(a).length;
        o.length && o.push(null);
        let h = i.heights[i.index++];
        l == -1 ? l = h : Math.abs(h - l) >= Ff && (l = -2);
        let f = new wn(u, h);
        f.outdated = !1, o.push(f), a += u + 1;
      }
      a <= s && o.push(null, new At(s - a).updateHeight(e, a));
      let c = nn.of(o);
      return (l < 0 || Math.abs(c.height - this.height) >= Ff || Math.abs(l - this.heightMetrics(e, n).perLine) >= Ff) && (e.heightChanged = !0), c;
    } else (r || this.outdated) && (this.setHeight(e, e.heightForGap(n, n + this.length)), this.outdated = !1);
    return this;
  }
  toString() {
    return `gap(${this.length})`;
  }
}
class Lj extends nn {
  constructor(e, n, r) {
    super(e.length + n + r.length, e.height + r.height, n | (e.outdated || r.outdated ? 2 : 0)), this.left = e, this.right = r, this.size = e.size + r.size;
  }
  get break() {
    return this.flags & 1;
  }
  blockAt(e, n, r, i) {
    let s = r + this.left.height;
    return e < s ? this.left.blockAt(e, n, r, i) : this.right.blockAt(e, n, s, i + this.left.length + this.break);
  }
  lineAt(e, n, r, i, s) {
    let o = i + this.left.height, a = s + this.left.length + this.break, l = n == Ze.ByHeight ? e < o : e < a, c = l ? this.left.lineAt(e, n, r, i, s) : this.right.lineAt(e, n, r, o, a);
    if (this.break || (l ? c.to < a : c.from > a))
      return c;
    let u = n == Ze.ByPosNoHeight ? Ze.ByPosNoHeight : Ze.ByPos;
    return l ? c.join(this.right.lineAt(a, u, r, o, a)) : this.left.lineAt(a, u, r, i, s).join(c);
  }
  forEachLine(e, n, r, i, s, o) {
    let a = i + this.left.height, l = s + this.left.length + this.break;
    if (this.break)
      e < l && this.left.forEachLine(e, n, r, i, s, o), n >= l && this.right.forEachLine(e, n, r, a, l, o);
    else {
      let c = this.lineAt(l, Ze.ByPos, r, i, s);
      e < c.from && this.left.forEachLine(e, c.from - 1, r, i, s, o), c.to >= e && c.from <= n && o(c), n > c.to && this.right.forEachLine(c.to + 1, n, r, a, l, o);
    }
  }
  replace(e, n, r) {
    let i = this.left.length + this.break;
    if (n < i)
      return this.balanced(this.left.replace(e, n, r), this.right);
    if (e > this.left.length)
      return this.balanced(this.left, this.right.replace(e - i, n - i, r));
    let s = [];
    e > 0 && this.decomposeLeft(e, s);
    let o = s.length;
    for (let a of r)
      s.push(a);
    if (e > 0 && lw(s, o - 1), n < this.length) {
      let a = s.length;
      this.decomposeRight(n, s), lw(s, a);
    }
    return nn.of(s);
  }
  decomposeLeft(e, n) {
    let r = this.left.length;
    if (e <= r)
      return this.left.decomposeLeft(e, n);
    n.push(this.left), this.break && (r++, e >= r && n.push(null)), e > r && this.right.decomposeLeft(e - r, n);
  }
  decomposeRight(e, n) {
    let r = this.left.length, i = r + this.break;
    if (e >= i)
      return this.right.decomposeRight(e - i, n);
    e < r && this.left.decomposeRight(e, n), this.break && e < i && n.push(null), n.push(this.right);
  }
  balanced(e, n) {
    return e.size > 2 * n.size || n.size > 2 * e.size ? nn.of(this.break ? [e, null, n] : [e, n]) : (this.left = e, this.right = n, this.height = e.height + n.height, this.outdated = e.outdated || n.outdated, this.size = e.size + n.size, this.length = e.length + this.break + n.length, this);
  }
  updateHeight(e, n = 0, r = !1, i) {
    let { left: s, right: o } = this, a = n + s.length + this.break, l = null;
    return i && i.from <= n + s.length && i.more ? l = s = s.updateHeight(e, n, r, i) : s.updateHeight(e, n, r), i && i.from <= a + o.length && i.more ? l = o = o.updateHeight(e, a, r, i) : o.updateHeight(e, a, r), l ? this.balanced(s, o) : (this.height = this.left.height + this.right.height, this.outdated = !1, this);
  }
  toString() {
    return this.left + (this.break ? " " : "-") + this.right;
  }
}
function lw(t, e) {
  let n, r;
  t[e] == null && (n = t[e - 1]) instanceof At && (r = t[e + 1]) instanceof At && t.splice(e - 1, 3, new At(n.length + 1 + r.length));
}
const Nj = 5;
class K1 {
  constructor(e, n) {
    this.pos = e, this.oracle = n, this.nodes = [], this.lineStart = -1, this.lineEnd = -1, this.covering = null, this.writtenTo = e;
  }
  get isCovered() {
    return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
  }
  span(e, n) {
    if (this.lineStart > -1) {
      let r = Math.min(n, this.lineEnd), i = this.nodes[this.nodes.length - 1];
      i instanceof wn ? i.length += r - this.pos : (r > this.pos || !this.isCovered) && this.nodes.push(new wn(r - this.pos, -1)), this.writtenTo = r, n > r && (this.nodes.push(null), this.writtenTo++, this.lineStart = -1);
    }
    this.pos = n;
  }
  point(e, n, r) {
    if (e < n || r.heightRelevant) {
      let i = r.widget ? r.widget.estimatedHeight : 0, s = r.widget ? r.widget.lineBreaks : 0;
      i < 0 && (i = this.oracle.lineHeight);
      let o = n - e;
      r.block ? this.addBlock(new D6(o, i, r)) : (o || s || i >= Nj) && this.addLineDeco(i, s, o);
    } else n > e && this.span(e, n);
    this.lineEnd > -1 && this.lineEnd < this.pos && (this.lineEnd = this.oracle.doc.lineAt(this.pos).to);
  }
  enterLine() {
    if (this.lineStart > -1)
      return;
    let { from: e, to: n } = this.oracle.doc.lineAt(this.pos);
    this.lineStart = e, this.lineEnd = n, this.writtenTo < e && ((this.writtenTo < e - 1 || this.nodes[this.nodes.length - 1] == null) && this.nodes.push(this.blankContent(this.writtenTo, e - 1)), this.nodes.push(null)), this.pos > e && this.nodes.push(new wn(this.pos - e, -1)), this.writtenTo = this.pos;
  }
  blankContent(e, n) {
    let r = new At(n - e);
    return this.oracle.doc.lineAt(e).to == n && (r.flags |= 4), r;
  }
  ensureLine() {
    this.enterLine();
    let e = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
    if (e instanceof wn)
      return e;
    let n = new wn(0, -1);
    return this.nodes.push(n), n;
  }
  addBlock(e) {
    this.enterLine();
    let n = e.deco;
    n && n.startSide > 0 && !this.isCovered && this.ensureLine(), this.nodes.push(e), this.writtenTo = this.pos = this.pos + e.length, n && n.endSide > 0 && (this.covering = e);
  }
  addLineDeco(e, n, r) {
    let i = this.ensureLine();
    i.length += r, i.collapsed += r, i.widgetHeight = Math.max(i.widgetHeight, e), i.breaks += n, this.writtenTo = this.pos = this.pos + r;
  }
  finish(e) {
    let n = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
    this.lineStart > -1 && !(n instanceof wn) && !this.isCovered ? this.nodes.push(new wn(0, -1)) : (this.writtenTo < this.pos || n == null) && this.nodes.push(this.blankContent(this.writtenTo, this.pos));
    let r = e;
    for (let i of this.nodes)
      i instanceof wn && i.updateHeight(this.oracle, r), r += i ? i.length : 1;
    return this.nodes;
  }
  // Always called with a region that on both sides either stretches
  // to a line break or the end of the document.
  // The returned array uses null to indicate line breaks, but never
  // starts or ends in a line break, or has multiple line breaks next
  // to each other.
  static build(e, n, r, i) {
    let s = new K1(r, e);
    return Be.spans(n, r, i, s, 0), s.finish(r);
  }
}
function Ij(t, e, n) {
  let r = new Rj();
  return Be.compare(t, e, n, r, 0), r.changes;
}
class Rj {
  constructor() {
    this.changes = [];
  }
  compareRange() {
  }
  comparePoint(e, n, r, i) {
    (e < n || r && r.heightRelevant || i && i.heightRelevant) && O0(e, n, this.changes, 5);
  }
}
function Bj(t, e) {
  let n = t.getBoundingClientRect(), r = t.ownerDocument, i = r.defaultView || window, s = Math.max(0, n.left), o = Math.min(i.innerWidth, n.right), a = Math.max(0, n.top), l = Math.min(i.innerHeight, n.bottom);
  for (let c = t.parentNode; c && c != r.body; )
    if (c.nodeType == 1) {
      let u = c, h = window.getComputedStyle(u);
      if ((u.scrollHeight > u.clientHeight || u.scrollWidth > u.clientWidth) && h.overflow != "visible") {
        let f = u.getBoundingClientRect();
        s = Math.max(s, f.left), o = Math.min(o, f.right), a = Math.max(a, f.top), l = c == t.parentNode ? f.bottom : Math.min(l, f.bottom);
      }
      c = h.position == "absolute" || h.position == "fixed" ? u.offsetParent : u.parentNode;
    } else if (c.nodeType == 11)
      c = c.host;
    else
      break;
  return {
    left: s - n.left,
    right: Math.max(s, o) - n.left,
    top: a - (n.top + e),
    bottom: Math.max(a, l) - (n.top + e)
  };
}
function Fj(t, e) {
  let n = t.getBoundingClientRect();
  return {
    left: 0,
    right: n.right - n.left,
    top: e,
    bottom: n.bottom - (n.top + e)
  };
}
class Sm {
  constructor(e, n, r) {
    this.from = e, this.to = n, this.size = r;
  }
  static same(e, n) {
    if (e.length != n.length)
      return !1;
    for (let r = 0; r < e.length; r++) {
      let i = e[r], s = n[r];
      if (i.from != s.from || i.to != s.to || i.size != s.size)
        return !1;
    }
    return !0;
  }
  draw(e, n) {
    return we.replace({
      widget: new zj(this.size * (n ? e.scaleY : e.scaleX), n)
    }).range(this.from, this.to);
  }
}
class zj extends Oi {
  constructor(e, n) {
    super(), this.size = e, this.vertical = n;
  }
  eq(e) {
    return e.size == this.size && e.vertical == this.vertical;
  }
  toDOM() {
    let e = document.createElement("div");
    return this.vertical ? e.style.height = this.size + "px" : (e.style.width = this.size + "px", e.style.height = "2px", e.style.display = "inline-block"), e;
  }
  get estimatedHeight() {
    return this.vertical ? this.size : -1;
  }
}
class cw {
  constructor(e) {
    this.state = e, this.pixelViewport = { left: 0, right: window.innerWidth, top: 0, bottom: 0 }, this.inView = !0, this.paddingTop = 0, this.paddingBottom = 0, this.contentDOMWidth = 0, this.contentDOMHeight = 0, this.editorHeight = 0, this.editorWidth = 0, this.scrollTop = 0, this.scrolledToBottom = !1, this.scaleX = 1, this.scaleY = 1, this.scrollAnchorPos = 0, this.scrollAnchorHeight = -1, this.scaler = uw, this.scrollTarget = null, this.printing = !1, this.mustMeasureContent = !0, this.defaultTextDirection = Qe.LTR, this.visibleRanges = [], this.mustEnforceCursorAssoc = !1;
    let n = e.facet(q1).some((r) => typeof r != "function" && r.class == "cm-lineWrapping");
    this.heightOracle = new Ej(n), this.stateDeco = e.facet(Tc).filter((r) => typeof r != "function"), this.heightMap = nn.empty().applyChanges(this.stateDeco, ze.empty, this.heightOracle.setDoc(e.doc), [new jn(0, 0, 0, e.doc.length)]);
    for (let r = 0; r < 2 && (this.viewport = this.getViewport(0, null), !!this.updateForViewport()); r++)
      ;
    this.updateViewportLines(), this.lineGaps = this.ensureLineGaps([]), this.lineGapDeco = we.set(this.lineGaps.map((r) => r.draw(this, !1))), this.computeVisibleRanges();
  }
  updateForViewport() {
    let e = [this.viewport], { main: n } = this.state.selection;
    for (let r = 0; r <= 1; r++) {
      let i = r ? n.head : n.anchor;
      if (!e.some(({ from: s, to: o }) => i >= s && i <= o)) {
        let { from: s, to: o } = this.lineBlockAt(i);
        e.push(new sf(s, o));
      }
    }
    return this.viewports = e.sort((r, i) => r.from - i.from), this.updateScaler();
  }
  updateScaler() {
    let e = this.scaler;
    return this.scaler = this.heightMap.height <= 7e6 ? uw : new G1(this.heightOracle, this.heightMap, this.viewports), e.eq(this.scaler) ? 0 : 2;
  }
  updateViewportLines() {
    this.viewportLines = [], this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.heightOracle.setDoc(this.state.doc), 0, 0, (e) => {
      this.viewportLines.push(Fl(e, this.scaler));
    });
  }
  update(e, n = null) {
    this.state = e.state;
    let r = this.stateDeco;
    this.stateDeco = this.state.facet(Tc).filter((u) => typeof u != "function");
    let i = e.changedRanges, s = jn.extendWithRanges(i, Ij(r, this.stateDeco, e ? e.changes : mt.empty(this.state.doc.length))), o = this.heightMap.height, a = this.scrolledToBottom ? null : this.scrollAnchorAt(this.scrollTop);
    this.heightMap = this.heightMap.applyChanges(this.stateDeco, e.startState.doc, this.heightOracle.setDoc(this.state.doc), s), this.heightMap.height != o && (e.flags |= 2), a ? (this.scrollAnchorPos = e.changes.mapPos(a.from, -1), this.scrollAnchorHeight = a.top) : (this.scrollAnchorPos = -1, this.scrollAnchorHeight = this.heightMap.height);
    let l = s.length ? this.mapViewport(this.viewport, e.changes) : this.viewport;
    (n && (n.range.head < l.from || n.range.head > l.to) || !this.viewportIsAppropriate(l)) && (l = this.getViewport(0, n));
    let c = l.from != this.viewport.from || l.to != this.viewport.to;
    this.viewport = l, e.flags |= this.updateForViewport(), (c || !e.changes.empty || e.flags & 2) && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, e.changes))), e.flags |= this.computeVisibleRanges(), n && (this.scrollTarget = n), !this.mustEnforceCursorAssoc && e.selectionSet && e.view.lineWrapping && e.state.selection.main.empty && e.state.selection.main.assoc && !e.state.facet(u6) && (this.mustEnforceCursorAssoc = !0);
  }
  measure(e) {
    let n = e.contentDOM, r = window.getComputedStyle(n), i = this.heightOracle, s = r.whiteSpace;
    this.defaultTextDirection = r.direction == "rtl" ? Qe.RTL : Qe.LTR;
    let o = this.heightOracle.mustRefreshForWrapping(s), a = n.getBoundingClientRect(), l = o || this.mustMeasureContent || this.contentDOMHeight != a.height;
    this.contentDOMHeight = a.height, this.mustMeasureContent = !1;
    let c = 0, u = 0;
    if (a.width && a.height) {
      let { scaleX: b, scaleY: w } = R8(n, a);
      (b > 5e-3 && Math.abs(this.scaleX - b) > 5e-3 || w > 5e-3 && Math.abs(this.scaleY - w) > 5e-3) && (this.scaleX = b, this.scaleY = w, c |= 8, o = l = !0);
    }
    let h = (parseInt(r.paddingTop) || 0) * this.scaleY, f = (parseInt(r.paddingBottom) || 0) * this.scaleY;
    (this.paddingTop != h || this.paddingBottom != f) && (this.paddingTop = h, this.paddingBottom = f, c |= 10), this.editorWidth != e.scrollDOM.clientWidth && (i.lineWrapping && (l = !0), this.editorWidth = e.scrollDOM.clientWidth, c |= 8);
    let d = e.scrollDOM.scrollTop * this.scaleY;
    this.scrollTop != d && (this.scrollAnchorHeight = -1, this.scrollTop = d), this.scrolledToBottom = z8(e.scrollDOM);
    let p = (this.printing ? Fj : Bj)(n, this.paddingTop), m = p.top - this.pixelViewport.top, v = p.bottom - this.pixelViewport.bottom;
    this.pixelViewport = p;
    let g = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
    if (g != this.inView && (this.inView = g, g && (l = !0)), !this.inView && !this.scrollTarget)
      return 0;
    let y = a.width;
    if ((this.contentDOMWidth != y || this.editorHeight != e.scrollDOM.clientHeight) && (this.contentDOMWidth = a.width, this.editorHeight = e.scrollDOM.clientHeight, c |= 8), l) {
      let b = e.docView.measureVisibleLineHeights(this.viewport);
      if (i.mustRefreshForHeights(b) && (o = !0), o || i.lineWrapping && Math.abs(y - this.contentDOMWidth) > i.charWidth) {
        let { lineHeight: w, charWidth: k, textHeight: _ } = e.docView.measureTextSize();
        o = w > 0 && i.refresh(s, w, k, _, y / k, b), o && (e.docView.minWidth = 0, c |= 8);
      }
      m > 0 && v > 0 ? u = Math.max(m, v) : m < 0 && v < 0 && (u = Math.min(m, v)), i.heightChanged = !1;
      for (let w of this.viewports) {
        let k = w.from == this.viewport.from ? b : e.docView.measureVisibleLineHeights(w);
        this.heightMap = (o ? nn.empty().applyChanges(this.stateDeco, ze.empty, this.heightOracle, [new jn(0, 0, 0, e.state.doc.length)]) : this.heightMap).updateHeight(i, 0, o, new Pj(w.from, k));
      }
      i.heightChanged && (c |= 2);
    }
    let x = !this.viewportIsAppropriate(this.viewport, u) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
    return x && (c & 2 && (c |= this.updateScaler()), this.viewport = this.getViewport(u, this.scrollTarget), c |= this.updateForViewport()), (c & 2 || x) && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(o ? [] : this.lineGaps, e)), c |= this.computeVisibleRanges(), this.mustEnforceCursorAssoc && (this.mustEnforceCursorAssoc = !1, e.docView.enforceCursorAssoc()), c;
  }
  get visibleTop() {
    return this.scaler.fromDOM(this.pixelViewport.top);
  }
  get visibleBottom() {
    return this.scaler.fromDOM(this.pixelViewport.bottom);
  }
  getViewport(e, n) {
    let r = 0.5 - Math.max(-0.5, Math.min(0.5, e / 1e3 / 2)), i = this.heightMap, s = this.heightOracle, { visibleTop: o, visibleBottom: a } = this, l = new sf(i.lineAt(o - r * 1e3, Ze.ByHeight, s, 0, 0).from, i.lineAt(a + (1 - r) * 1e3, Ze.ByHeight, s, 0, 0).to);
    if (n) {
      let { head: c } = n.range;
      if (c < l.from || c > l.to) {
        let u = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top), h = i.lineAt(c, Ze.ByPos, s, 0, 0), f;
        n.y == "center" ? f = (h.top + h.bottom) / 2 - u / 2 : n.y == "start" || n.y == "nearest" && c < l.from ? f = h.top : f = h.bottom - u, l = new sf(i.lineAt(f - 1e3 / 2, Ze.ByHeight, s, 0, 0).from, i.lineAt(f + u + 1e3 / 2, Ze.ByHeight, s, 0, 0).to);
      }
    }
    return l;
  }
  mapViewport(e, n) {
    let r = n.mapPos(e.from, -1), i = n.mapPos(e.to, 1);
    return new sf(this.heightMap.lineAt(r, Ze.ByPos, this.heightOracle, 0, 0).from, this.heightMap.lineAt(i, Ze.ByPos, this.heightOracle, 0, 0).to);
  }
  // Checks if a given viewport covers the visible part of the
  // document and not too much beyond that.
  viewportIsAppropriate({ from: e, to: n }, r = 0) {
    if (!this.inView)
      return !0;
    let { top: i } = this.heightMap.lineAt(e, Ze.ByPos, this.heightOracle, 0, 0), { bottom: s } = this.heightMap.lineAt(n, Ze.ByPos, this.heightOracle, 0, 0), { visibleTop: o, visibleBottom: a } = this;
    return (e == 0 || i <= o - Math.max(10, Math.min(
      -r,
      250
      /* VP.MaxCoverMargin */
    ))) && (n == this.state.doc.length || s >= a + Math.max(10, Math.min(
      r,
      250
      /* VP.MaxCoverMargin */
    ))) && i > o - 2 * 1e3 && s < a + 2 * 1e3;
  }
  mapLineGaps(e, n) {
    if (!e.length || n.empty)
      return e;
    let r = [];
    for (let i of e)
      n.touchesRange(i.from, i.to) || r.push(new Sm(n.mapPos(i.from), n.mapPos(i.to), i.size));
    return r;
  }
  // Computes positions in the viewport where the start or end of a
  // line should be hidden, trying to reuse existing line gaps when
  // appropriate to avoid unneccesary redraws.
  // Uses crude character-counting for the positioning and sizing,
  // since actual DOM coordinates aren't always available and
  // predictable. Relies on generous margins (see LG.Margin) to hide
  // the artifacts this might produce from the user.
  ensureLineGaps(e, n) {
    let r = this.heightOracle.lineWrapping, i = r ? 1e4 : 2e3, s = i >> 1, o = i << 1;
    if (this.defaultTextDirection != Qe.LTR && !r)
      return [];
    let a = [], l = (u, h, f, d) => {
      if (h - u < s)
        return;
      let p = this.state.selection.main, m = [p.from];
      p.empty || m.push(p.to);
      for (let g of m)
        if (g > u && g < h) {
          l(u, g - 10, f, d), l(g + 10, h, f, d);
          return;
        }
      let v = Hj(e, (g) => g.from >= f.from && g.to <= f.to && Math.abs(g.from - u) < s && Math.abs(g.to - h) < s && !m.some((y) => g.from < y && g.to > y));
      if (!v) {
        if (h < f.to && n && r && n.visibleRanges.some((g) => g.from <= h && g.to >= h)) {
          let g = n.moveToLineBoundary(W.cursor(h), !1, !0).head;
          g > u && (h = g);
        }
        v = new Sm(u, h, this.gapSize(f, u, h, d));
      }
      a.push(v);
    }, c = (u) => {
      if (u.length < o || u.type != tn.Text)
        return;
      let h = Vj(u.from, u.to, this.stateDeco);
      if (h.total < o)
        return;
      let f = this.scrollTarget ? this.scrollTarget.range.head : null, d, p;
      if (r) {
        let m = i / this.heightOracle.lineLength * this.heightOracle.lineHeight, v, g;
        if (f != null) {
          let y = af(h, f), x = ((this.visibleBottom - this.visibleTop) / 2 + m) / u.height;
          v = y - x, g = y + x;
        } else
          v = (this.visibleTop - u.top - m) / u.height, g = (this.visibleBottom - u.top + m) / u.height;
        d = of(h, v), p = of(h, g);
      } else {
        let m = h.total * this.heightOracle.charWidth, v = i * this.heightOracle.charWidth, g, y;
        if (f != null) {
          let x = af(h, f), b = ((this.pixelViewport.right - this.pixelViewport.left) / 2 + v) / m;
          g = x - b, y = x + b;
        } else
          g = (this.pixelViewport.left - v) / m, y = (this.pixelViewport.right + v) / m;
        d = of(h, g), p = of(h, y);
      }
      d > u.from && l(u.from, d, u, h), p < u.to && l(p, u.to, u, h);
    };
    for (let u of this.viewportLines)
      Array.isArray(u.type) ? u.type.forEach(c) : c(u);
    return a;
  }
  gapSize(e, n, r, i) {
    let s = af(i, r) - af(i, n);
    return this.heightOracle.lineWrapping ? e.height * s : i.total * this.heightOracle.charWidth * s;
  }
  updateLineGaps(e) {
    Sm.same(e, this.lineGaps) || (this.lineGaps = e, this.lineGapDeco = we.set(e.map((n) => n.draw(this, this.heightOracle.lineWrapping))));
  }
  computeVisibleRanges() {
    let e = this.stateDeco;
    this.lineGaps.length && (e = e.concat(this.lineGapDeco));
    let n = [];
    Be.spans(e, this.viewport.from, this.viewport.to, {
      span(i, s) {
        n.push({ from: i, to: s });
      },
      point() {
      }
    }, 20);
    let r = n.length != this.visibleRanges.length || this.visibleRanges.some((i, s) => i.from != n[s].from || i.to != n[s].to);
    return this.visibleRanges = n, r ? 4 : 0;
  }
  lineBlockAt(e) {
    return e >= this.viewport.from && e <= this.viewport.to && this.viewportLines.find((n) => n.from <= e && n.to >= e) || Fl(this.heightMap.lineAt(e, Ze.ByPos, this.heightOracle, 0, 0), this.scaler);
  }
  lineBlockAtHeight(e) {
    return e >= this.viewportLines[0].top && e <= this.viewportLines[this.viewportLines.length - 1].bottom && this.viewportLines.find((n) => n.top <= e && n.bottom >= e) || Fl(this.heightMap.lineAt(this.scaler.fromDOM(e), Ze.ByHeight, this.heightOracle, 0, 0), this.scaler);
  }
  scrollAnchorAt(e) {
    let n = this.lineBlockAtHeight(e + 8);
    return n.from >= this.viewport.from || this.viewportLines[0].top - e > 200 ? n : this.viewportLines[0];
  }
  elementAtHeight(e) {
    return Fl(this.heightMap.blockAt(this.scaler.fromDOM(e), this.heightOracle, 0, 0), this.scaler);
  }
  get docHeight() {
    return this.scaler.toDOM(this.heightMap.height);
  }
  get contentHeight() {
    return this.docHeight + this.paddingTop + this.paddingBottom;
  }
}
class sf {
  constructor(e, n) {
    this.from = e, this.to = n;
  }
}
function Vj(t, e, n) {
  let r = [], i = t, s = 0;
  return Be.spans(n, t, e, {
    span() {
    },
    point(o, a) {
      o > i && (r.push({ from: i, to: o }), s += o - i), i = a;
    }
  }, 20), i < e && (r.push({ from: i, to: e }), s += e - i), { total: s, ranges: r };
}
function of({ total: t, ranges: e }, n) {
  if (n <= 0)
    return e[0].from;
  if (n >= 1)
    return e[e.length - 1].to;
  let r = Math.floor(t * n);
  for (let i = 0; ; i++) {
    let { from: s, to: o } = e[i], a = o - s;
    if (r <= a)
      return s + r;
    r -= a;
  }
}
function af(t, e) {
  let n = 0;
  for (let { from: r, to: i } of t.ranges) {
    if (e <= i) {
      n += e - r;
      break;
    }
    n += i - r;
  }
  return n / t.total;
}
function Hj(t, e) {
  for (let n of t)
    if (e(n))
      return n;
}
const uw = {
  toDOM(t) {
    return t;
  },
  fromDOM(t) {
    return t;
  },
  scale: 1,
  eq(t) {
    return t == this;
  }
};
class G1 {
  constructor(e, n, r) {
    let i = 0, s = 0, o = 0;
    this.viewports = r.map(({ from: a, to: l }) => {
      let c = n.lineAt(a, Ze.ByPos, e, 0, 0).top, u = n.lineAt(l, Ze.ByPos, e, 0, 0).bottom;
      return i += u - c, { from: a, to: l, top: c, bottom: u, domTop: 0, domBottom: 0 };
    }), this.scale = (7e6 - i) / (n.height - i);
    for (let a of this.viewports)
      a.domTop = o + (a.top - s) * this.scale, o = a.domBottom = a.domTop + (a.bottom - a.top), s = a.bottom;
  }
  toDOM(e) {
    for (let n = 0, r = 0, i = 0; ; n++) {
      let s = n < this.viewports.length ? this.viewports[n] : null;
      if (!s || e < s.top)
        return i + (e - r) * this.scale;
      if (e <= s.bottom)
        return s.domTop + (e - s.top);
      r = s.bottom, i = s.domBottom;
    }
  }
  fromDOM(e) {
    for (let n = 0, r = 0, i = 0; ; n++) {
      let s = n < this.viewports.length ? this.viewports[n] : null;
      if (!s || e < s.domTop)
        return r + (e - i) / this.scale;
      if (e <= s.domBottom)
        return s.top + (e - s.domTop);
      r = s.bottom, i = s.domBottom;
    }
  }
  eq(e) {
    return e instanceof G1 ? this.scale == e.scale && this.viewports.length == e.viewports.length && this.viewports.every((n, r) => n.from == e.viewports[r].from && n.to == e.viewports[r].to) : !1;
  }
}
function Fl(t, e) {
  if (e.scale == 1)
    return t;
  let n = e.toDOM(t.top), r = e.toDOM(t.bottom);
  return new Er(t.from, t.length, n, r - n, Array.isArray(t._content) ? t._content.map((i) => Fl(i, e)) : t._content);
}
const lf = /* @__PURE__ */ ve.define({ combine: (t) => t.join(" ") }), F0 = /* @__PURE__ */ ve.define({ combine: (t) => t.indexOf(!0) > -1 }), z0 = /* @__PURE__ */ ps.newName(), T6 = /* @__PURE__ */ ps.newName(), O6 = /* @__PURE__ */ ps.newName(), E6 = { "&light": "." + T6, "&dark": "." + O6 };
function V0(t, e, n) {
  return new ps(e, {
    finish(r) {
      return /&/.test(r) ? r.replace(/&\w*/, (i) => {
        if (i == "&")
          return t;
        if (!n || !n[i])
          throw new RangeError(`Unsupported selector: ${i}`);
        return n[i];
      }) : t + " " + r;
    }
  });
}
const Yj = /* @__PURE__ */ V0("." + z0, {
  "&": {
    position: "relative !important",
    boxSizing: "border-box",
    "&.cm-focused": {
      // Provide a simple default outline to make sure a focused
      // editor is visually distinct. Can't leave the default behavior
      // because that will apply to the content element, which is
      // inside the scrollable container and doesn't include the
      // gutters. We also can't use an 'auto' outline, since those
      // are, for some reason, drawn behind the element content, which
      // will cause things like the active line background to cover
      // the outline (#297).
      outline: "1px dotted #212121"
    },
    display: "flex !important",
    flexDirection: "column"
  },
  ".cm-scroller": {
    display: "flex !important",
    alignItems: "flex-start !important",
    fontFamily: "monospace",
    lineHeight: 1.4,
    height: "100%",
    overflowX: "auto",
    position: "relative",
    zIndex: 0
  },
  ".cm-content": {
    margin: 0,
    flexGrow: 2,
    flexShrink: 0,
    display: "block",
    whiteSpace: "pre",
    wordWrap: "normal",
    // https://github.com/codemirror/dev/issues/456
    boxSizing: "border-box",
    minHeight: "100%",
    padding: "4px 0",
    outline: "none",
    "&[contenteditable=true]": {
      WebkitUserModify: "read-write-plaintext-only"
    }
  },
  ".cm-lineWrapping": {
    whiteSpace_fallback: "pre-wrap",
    // For IE
    whiteSpace: "break-spaces",
    wordBreak: "break-word",
    // For Safari, which doesn't support overflow-wrap: anywhere
    overflowWrap: "anywhere",
    flexShrink: 1
  },
  "&light .cm-content": { caretColor: "black" },
  "&dark .cm-content": { caretColor: "white" },
  ".cm-line": {
    display: "block",
    padding: "0 2px 0 6px"
  },
  ".cm-layer": {
    position: "absolute",
    left: 0,
    top: 0,
    contain: "size style",
    "& > *": {
      position: "absolute"
    }
  },
  "&light .cm-selectionBackground": {
    background: "#d9d9d9"
  },
  "&dark .cm-selectionBackground": {
    background: "#222"
  },
  "&light.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#d7d4f0"
  },
  "&dark.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#233"
  },
  ".cm-cursorLayer": {
    pointerEvents: "none"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer": {
    animation: "steps(1) cm-blink 1.2s infinite"
  },
  // Two animations defined so that we can switch between them to
  // restart the animation without forcing another style
  // recomputation.
  "@keyframes cm-blink": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  "@keyframes cm-blink2": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  ".cm-cursor, .cm-dropCursor": {
    borderLeft: "1.2px solid black",
    marginLeft: "-0.6px",
    pointerEvents: "none"
  },
  ".cm-cursor": {
    display: "none"
  },
  "&dark .cm-cursor": {
    borderLeftColor: "#444"
  },
  ".cm-dropCursor": {
    position: "absolute"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer .cm-cursor": {
    display: "block"
  },
  ".cm-iso": {
    unicodeBidi: "isolate"
  },
  ".cm-announced": {
    position: "fixed",
    top: "-10000px"
  },
  "@media print": {
    ".cm-announced": { display: "none" }
  },
  "&light .cm-activeLine": { backgroundColor: "#cceeff44" },
  "&dark .cm-activeLine": { backgroundColor: "#99eeff33" },
  "&light .cm-specialChar": { color: "red" },
  "&dark .cm-specialChar": { color: "#f78" },
  ".cm-gutters": {
    flexShrink: 0,
    display: "flex",
    height: "100%",
    boxSizing: "border-box",
    insetInlineStart: 0,
    zIndex: 200
  },
  "&light .cm-gutters": {
    backgroundColor: "#f5f5f5",
    color: "#6c6c6c",
    borderRight: "1px solid #ddd"
  },
  "&dark .cm-gutters": {
    backgroundColor: "#333338",
    color: "#ccc"
  },
  ".cm-gutter": {
    display: "flex !important",
    // Necessary -- prevents margin collapsing
    flexDirection: "column",
    flexShrink: 0,
    boxSizing: "border-box",
    minHeight: "100%",
    overflow: "hidden"
  },
  ".cm-gutterElement": {
    boxSizing: "border-box"
  },
  ".cm-lineNumbers .cm-gutterElement": {
    padding: "0 3px 0 5px",
    minWidth: "20px",
    textAlign: "right",
    whiteSpace: "nowrap"
  },
  "&light .cm-activeLineGutter": {
    backgroundColor: "#e2f2ff"
  },
  "&dark .cm-activeLineGutter": {
    backgroundColor: "#222227"
  },
  ".cm-panels": {
    boxSizing: "border-box",
    position: "sticky",
    left: 0,
    right: 0
  },
  "&light .cm-panels": {
    backgroundColor: "#f5f5f5",
    color: "black"
  },
  "&light .cm-panels-top": {
    borderBottom: "1px solid #ddd"
  },
  "&light .cm-panels-bottom": {
    borderTop: "1px solid #ddd"
  },
  "&dark .cm-panels": {
    backgroundColor: "#333338",
    color: "white"
  },
  ".cm-tab": {
    display: "inline-block",
    overflow: "hidden",
    verticalAlign: "bottom"
  },
  ".cm-widgetBuffer": {
    verticalAlign: "text-top",
    height: "1em",
    width: 0,
    display: "inline"
  },
  ".cm-placeholder": {
    color: "#888",
    display: "inline-block",
    verticalAlign: "top"
  },
  ".cm-highlightSpace:before": {
    content: "attr(data-display)",
    position: "absolute",
    pointerEvents: "none",
    color: "#888"
  },
  ".cm-highlightTab": {
    backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="20"><path stroke="%23888" stroke-width="1" fill="none" d="M1 10H196L190 5M190 15L196 10M197 4L197 16"/></svg>')`,
    backgroundSize: "auto 100%",
    backgroundPosition: "right 90%",
    backgroundRepeat: "no-repeat"
  },
  ".cm-trailingSpace": {
    backgroundColor: "#ff332255"
  },
  ".cm-button": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    padding: ".2em 1em",
    borderRadius: "1px"
  },
  "&light .cm-button": {
    backgroundImage: "linear-gradient(#eff1f5, #d9d9df)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)"
    }
  },
  "&dark .cm-button": {
    backgroundImage: "linear-gradient(#393939, #111)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#111, #333)"
    }
  },
  ".cm-textfield": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    border: "1px solid silver",
    padding: ".2em .5em"
  },
  "&light .cm-textfield": {
    backgroundColor: "white"
  },
  "&dark .cm-textfield": {
    border: "1px solid #555",
    backgroundColor: "inherit"
  }
}, E6), zl = "￿";
class Wj {
  constructor(e, n) {
    this.points = e, this.text = "", this.lineSeparator = n.facet(Le.lineSeparator);
  }
  append(e) {
    this.text += e;
  }
  lineBreak() {
    this.text += zl;
  }
  readRange(e, n) {
    if (!e)
      return this;
    let r = e.parentNode;
    for (let i = e; ; ) {
      this.findPointBefore(r, i);
      let s = this.text.length;
      this.readNode(i);
      let o = i.nextSibling;
      if (o == n)
        break;
      let a = qe.get(i), l = qe.get(o);
      (a && l ? a.breakAfter : (a ? a.breakAfter : Fh(i)) || Fh(o) && (i.nodeName != "BR" || i.cmIgnore) && this.text.length > s) && this.lineBreak(), i = o;
    }
    return this.findPointBefore(r, n), this;
  }
  readTextNode(e) {
    let n = e.nodeValue;
    for (let r of this.points)
      r.node == e && (r.pos = this.text.length + Math.min(r.offset, n.length));
    for (let r = 0, i = this.lineSeparator ? null : /\r\n?|\n/g; ; ) {
      let s = -1, o = 1, a;
      if (this.lineSeparator ? (s = n.indexOf(this.lineSeparator, r), o = this.lineSeparator.length) : (a = i.exec(n)) && (s = a.index, o = a[0].length), this.append(n.slice(r, s < 0 ? n.length : s)), s < 0)
        break;
      if (this.lineBreak(), o > 1)
        for (let l of this.points)
          l.node == e && l.pos > this.text.length && (l.pos -= o - 1);
      r = s + o;
    }
  }
  readNode(e) {
    if (e.cmIgnore)
      return;
    let n = qe.get(e), r = n && n.overrideDOMText;
    if (r != null) {
      this.findPointInside(e, r.length);
      for (let i = r.iter(); !i.next().done; )
        i.lineBreak ? this.lineBreak() : this.append(i.value);
    } else e.nodeType == 3 ? this.readTextNode(e) : e.nodeName == "BR" ? e.nextSibling && this.lineBreak() : e.nodeType == 1 && this.readRange(e.firstChild, null);
  }
  findPointBefore(e, n) {
    for (let r of this.points)
      r.node == e && e.childNodes[r.offset] == n && (r.pos = this.text.length);
  }
  findPointInside(e, n) {
    for (let r of this.points)
      (e.nodeType == 3 ? r.node == e : e.contains(r.node)) && (r.pos = this.text.length + (jj(e, r.node, r.offset) ? n : 0));
  }
}
function jj(t, e, n) {
  for (; ; ) {
    if (!e || n < ki(e))
      return !1;
    if (e == t)
      return !0;
    n = mo(e) + 1, e = e.parentNode;
  }
}
class fw {
  constructor(e, n) {
    this.node = e, this.offset = n, this.pos = -1;
  }
}
class qj {
  constructor(e, n, r, i) {
    this.typeOver = i, this.bounds = null, this.text = "", this.domChanged = n > -1;
    let { impreciseHead: s, impreciseAnchor: o } = e.docView;
    if (e.state.readOnly && n > -1)
      this.newSel = null;
    else if (n > -1 && (this.bounds = e.docView.domBoundsAround(n, r, 0))) {
      let a = s || o ? [] : Gj(e), l = new Wj(a, e.state);
      l.readRange(this.bounds.startDOM, this.bounds.endDOM), this.text = l.text, this.newSel = Xj(a, this.bounds.from);
    } else {
      let a = e.observer.selectionRange, l = s && s.node == a.focusNode && s.offset == a.focusOffset || !M0(e.contentDOM, a.focusNode) ? e.state.selection.main.head : e.docView.posFromDOM(a.focusNode, a.focusOffset), c = o && o.node == a.anchorNode && o.offset == a.anchorOffset || !M0(e.contentDOM, a.anchorNode) ? e.state.selection.main.anchor : e.docView.posFromDOM(a.anchorNode, a.anchorOffset), u = e.viewport;
      if ((me.ios || me.chrome) && e.state.selection.main.empty && l != c && (u.from > 0 || u.to < e.state.doc.length)) {
        let h = Math.min(l, c), f = Math.max(l, c), d = u.from - h, p = u.to - f;
        (d == 0 || d == 1 || h == 0) && (p == 0 || p == -1 || f == e.state.doc.length) && (l = 0, c = e.state.doc.length);
      }
      this.newSel = W.single(c, l);
    }
  }
}
function P6(t, e) {
  let n, { newSel: r } = e, i = t.state.selection.main, s = t.inputState.lastKeyTime > Date.now() - 100 ? t.inputState.lastKeyCode : -1;
  if (e.bounds) {
    let { from: o, to: a } = e.bounds, l = i.from, c = null;
    (s === 8 || me.android && e.text.length < a - o) && (l = i.to, c = "end");
    let u = Kj(t.state.doc.sliceString(o, a, zl), e.text, l - o, c);
    u && (me.chrome && s == 13 && u.toB == u.from + 2 && e.text.slice(u.from, u.toB) == zl + zl && u.toB--, n = {
      from: o + u.from,
      to: o + u.toA,
      insert: ze.of(e.text.slice(u.from, u.toB).split(zl))
    });
  } else r && (!t.hasFocus && t.state.facet(ji) || r.main.eq(i)) && (r = null);
  if (!n && !r)
    return !1;
  if (!n && e.typeOver && !i.empty && r && r.main.empty ? n = { from: i.from, to: i.to, insert: t.state.doc.slice(i.from, i.to) } : n && n.from >= i.from && n.to <= i.to && (n.from != i.from || n.to != i.to) && i.to - i.from - (n.to - n.from) <= 4 ? n = {
    from: i.from,
    to: i.to,
    insert: t.state.doc.slice(i.from, n.from).append(n.insert).append(t.state.doc.slice(n.to, i.to))
  } : (me.mac || me.android) && n && n.from == n.to && n.from == i.head - 1 && /^\. ?$/.test(n.insert.toString()) && t.contentDOM.getAttribute("autocorrect") == "off" ? (r && n.insert.length == 2 && (r = W.single(r.main.anchor - 1, r.main.head - 1)), n = { from: i.from, to: i.to, insert: ze.of([" "]) }) : me.chrome && n && n.from == n.to && n.from == i.head && n.insert.toString() == `
 ` && t.lineWrapping && (r && (r = W.single(r.main.anchor - 1, r.main.head - 1)), n = { from: i.from, to: i.to, insert: ze.of([" "]) }), n)
    return L6(t, n, r, s);
  if (r && !r.main.eq(i)) {
    let o = !1, a = "select";
    return t.inputState.lastSelectionTime > Date.now() - 50 && (t.inputState.lastSelectionOrigin == "select" && (o = !0), a = t.inputState.lastSelectionOrigin), t.dispatch({ selection: r, scrollIntoView: o, userEvent: a }), !0;
  } else
    return !1;
}
function L6(t, e, n, r = -1) {
  if (me.ios && t.inputState.flushIOSKey(e))
    return !0;
  let i = t.state.selection.main;
  if (me.android && (e.to == i.to && // GBoard will sometimes remove a space it just inserted
  // after a completion when you press enter
  (e.from == i.from || e.from == i.from - 1 && t.state.sliceDoc(e.from, i.from) == " ") && e.insert.length == 1 && e.insert.lines == 2 && na(t.contentDOM, "Enter", 13) || (e.from == i.from - 1 && e.to == i.to && e.insert.length == 0 || r == 8 && e.insert.length < e.to - e.from && e.to > i.head) && na(t.contentDOM, "Backspace", 8) || e.from == i.from && e.to == i.to + 1 && e.insert.length == 0 && na(t.contentDOM, "Delete", 46)))
    return !0;
  let s = e.insert.toString();
  t.inputState.composing >= 0 && t.inputState.composing++;
  let o, a = () => o || (o = Uj(t, e, n));
  return t.state.facet(a6).some((l) => l(t, e.from, e.to, s, a)) || t.dispatch(a()), !0;
}
function Uj(t, e, n) {
  let r, i = t.state, s = i.selection.main;
  if (e.from >= s.from && e.to <= s.to && e.to - e.from >= (s.to - s.from) / 3 && (!n || n.main.empty && n.main.from == e.from + e.insert.length) && t.inputState.composing < 0) {
    let a = s.from < e.from ? i.sliceDoc(s.from, e.from) : "", l = s.to > e.to ? i.sliceDoc(e.to, s.to) : "";
    r = i.replaceSelection(t.state.toText(a + e.insert.sliceString(0, void 0, t.state.lineBreak) + l));
  } else {
    let a = i.changes(e), l = n && n.main.to <= a.newLength ? n.main : void 0;
    if (i.selection.ranges.length > 1 && t.inputState.composing >= 0 && e.to <= s.to && e.to >= s.to - 10) {
      let c = t.state.sliceDoc(e.from, e.to), u, h = n && y6(t, n.main.head);
      if (h) {
        let p = e.insert.length - (e.to - e.from);
        u = { from: h.from, to: h.to - p };
      } else
        u = t.state.doc.lineAt(s.head);
      let f = s.to - e.to, d = s.to - s.from;
      r = i.changeByRange((p) => {
        if (p.from == s.from && p.to == s.to)
          return { changes: a, range: l || p.map(a) };
        let m = p.to - f, v = m - c.length;
        if (p.to - p.from != d || t.state.sliceDoc(v, m) != c || // Unfortunately, there's no way to make multiple
        // changes in the same node work without aborting
        // composition, so cursors in the composition range are
        // ignored.
        p.to >= u.from && p.from <= u.to)
          return { range: p };
        let g = i.changes({ from: v, to: m, insert: e.insert }), y = p.to - s.to;
        return {
          changes: g,
          range: l ? W.range(Math.max(0, l.anchor + y), Math.max(0, l.head + y)) : p.map(g)
        };
      });
    } else
      r = {
        changes: a,
        selection: l && i.selection.replaceRange(l)
      };
  }
  let o = "input.type";
  return (t.composing || t.inputState.compositionPendingChange && t.inputState.compositionEndedAt > Date.now() - 50) && (t.inputState.compositionPendingChange = !1, o += ".compose", t.inputState.compositionFirstChange && (o += ".start", t.inputState.compositionFirstChange = !1)), i.update(r, { userEvent: o, scrollIntoView: !0 });
}
function Kj(t, e, n, r) {
  let i = Math.min(t.length, e.length), s = 0;
  for (; s < i && t.charCodeAt(s) == e.charCodeAt(s); )
    s++;
  if (s == i && t.length == e.length)
    return null;
  let o = t.length, a = e.length;
  for (; o > 0 && a > 0 && t.charCodeAt(o - 1) == e.charCodeAt(a - 1); )
    o--, a--;
  if (r == "end") {
    let l = Math.max(0, s - Math.min(o, a));
    n -= o + l - s;
  }
  if (o < s && t.length < e.length) {
    let l = n <= s && n >= o ? s - n : 0;
    s -= l, a = s + (a - o), o = s;
  } else if (a < s) {
    let l = n <= s && n >= a ? s - n : 0;
    s -= l, o = s + (o - a), a = s;
  }
  return { from: s, toA: o, toB: a };
}
function Gj(t) {
  let e = [];
  if (t.root.activeElement != t.contentDOM)
    return e;
  let { anchorNode: n, anchorOffset: r, focusNode: i, focusOffset: s } = t.observer.selectionRange;
  return n && (e.push(new fw(n, r)), (i != n || s != r) && e.push(new fw(i, s))), e;
}
function Xj(t, e) {
  if (t.length == 0)
    return null;
  let n = t[0].pos, r = t.length == 2 ? t[1].pos : n;
  return n > -1 && r > -1 ? W.single(n + e, r + e) : null;
}
const Zj = {
  childList: !0,
  characterData: !0,
  subtree: !0,
  attributes: !0,
  characterDataOldValue: !0
}, Mm = me.ie && me.ie_version <= 11;
class Jj {
  constructor(e) {
    this.view = e, this.active = !1, this.editContext = null, this.selectionRange = new IW(), this.selectionChanged = !1, this.delayedFlush = -1, this.resizeTimeout = -1, this.queue = [], this.delayedAndroidKey = null, this.flushingAndroidKey = -1, this.lastChange = 0, this.scrollTargets = [], this.intersection = null, this.resizeScroll = null, this.intersecting = !1, this.gapIntersection = null, this.gaps = [], this.printQuery = null, this.parentCheck = -1, this.dom = e.contentDOM, this.observer = new MutationObserver((n) => {
      for (let r of n)
        this.queue.push(r);
      (me.ie && me.ie_version <= 11 || me.ios && e.composing) && n.some((r) => r.type == "childList" && r.removedNodes.length || r.type == "characterData" && r.oldValue.length > r.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), window.EditContext && e.constructor.EDIT_CONTEXT !== !1 && // Chrome <126 doesn't support inverted selections in edit context (#1392)
    !(me.chrome && me.chrome_version < 126) && (this.editContext = new eq(e), e.state.facet(ji) && (e.contentDOM.editContext = this.editContext.editContext)), Mm && (this.onCharData = (n) => {
      this.queue.push({
        target: n.target,
        type: "characterData",
        oldValue: n.prevValue
      }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this), this.onResize = this.onResize.bind(this), this.onPrint = this.onPrint.bind(this), this.onScroll = this.onScroll.bind(this), window.matchMedia && (this.printQuery = window.matchMedia("print")), typeof ResizeObserver == "function" && (this.resizeScroll = new ResizeObserver(() => {
      var n;
      ((n = this.view.docView) === null || n === void 0 ? void 0 : n.lastUpdate) < Date.now() - 75 && this.onResize();
    }), this.resizeScroll.observe(e.scrollDOM)), this.addWindowListeners(this.win = e.win), this.start(), typeof IntersectionObserver == "function" && (this.intersection = new IntersectionObserver((n) => {
      this.parentCheck < 0 && (this.parentCheck = setTimeout(this.listenForScroll.bind(this), 1e3)), n.length > 0 && n[n.length - 1].intersectionRatio > 0 != this.intersecting && (this.intersecting = !this.intersecting, this.intersecting != this.view.inView && this.onScrollChanged(document.createEvent("Event")));
    }, { threshold: [0, 1e-3] }), this.intersection.observe(this.dom), this.gapIntersection = new IntersectionObserver((n) => {
      n.length > 0 && n[n.length - 1].intersectionRatio > 0 && this.onScrollChanged(document.createEvent("Event"));
    }, {})), this.listenForScroll(), this.readSelectionRange();
  }
  onScrollChanged(e) {
    this.view.inputState.runHandlers("scroll", e), this.intersecting && this.view.measure();
  }
  onScroll(e) {
    this.intersecting && this.flush(!1), this.editContext && this.view.requestMeasure(this.editContext.measureReq), this.onScrollChanged(e);
  }
  onResize() {
    this.resizeTimeout < 0 && (this.resizeTimeout = setTimeout(() => {
      this.resizeTimeout = -1, this.view.requestMeasure();
    }, 50));
  }
  onPrint(e) {
    e.type == "change" && !e.matches || (this.view.viewState.printing = !0, this.view.measure(), setTimeout(() => {
      this.view.viewState.printing = !1, this.view.requestMeasure();
    }, 500));
  }
  updateGaps(e) {
    if (this.gapIntersection && (e.length != this.gaps.length || this.gaps.some((n, r) => n != e[r]))) {
      this.gapIntersection.disconnect();
      for (let n of e)
        this.gapIntersection.observe(n);
      this.gaps = e;
    }
  }
  onSelectionChange(e) {
    let n = this.selectionChanged;
    if (!this.readSelectionRange() || this.delayedAndroidKey)
      return;
    let { view: r } = this, i = this.selectionRange;
    if (r.state.facet(ji) ? r.root.activeElement != this.dom : !Rf(r.dom, i))
      return;
    let s = i.anchorNode && r.docView.nearest(i.anchorNode);
    if (s && s.ignoreEvent(e)) {
      n || (this.selectionChanged = !1);
      return;
    }
    (me.ie && me.ie_version <= 11 || me.android && me.chrome) && !r.state.selection.main.empty && // (Selection.isCollapsed isn't reliable on IE)
    i.focusNode && rc(i.focusNode, i.focusOffset, i.anchorNode, i.anchorOffset) ? this.flushSoon() : this.flush(!1);
  }
  readSelectionRange() {
    let { view: e } = this, n = Dc(e.root);
    if (!n)
      return !1;
    let r = me.safari && e.root.nodeType == 11 && EW(this.dom.ownerDocument) == this.dom && Qj(this.view, n) || n;
    if (!r || this.selectionRange.eq(r))
      return !1;
    let i = Rf(this.dom, r);
    return i && !this.selectionChanged && e.inputState.lastFocusTime > Date.now() - 200 && e.inputState.lastTouchTime < Date.now() - 300 && BW(this.dom, r) ? (this.view.inputState.lastFocusTime = 0, e.docView.updateSelection(), !1) : (this.selectionRange.setRange(r), i && (this.selectionChanged = !0), !0);
  }
  setSelectionRange(e, n) {
    this.selectionRange.set(e.node, e.offset, n.node, n.offset), this.selectionChanged = !1;
  }
  clearSelectionRange() {
    this.selectionRange.set(null, 0, null, 0);
  }
  listenForScroll() {
    this.parentCheck = -1;
    let e = 0, n = null;
    for (let r = this.dom; r; )
      if (r.nodeType == 1)
        !n && e < this.scrollTargets.length && this.scrollTargets[e] == r ? e++ : n || (n = this.scrollTargets.slice(0, e)), n && n.push(r), r = r.assignedSlot || r.parentNode;
      else if (r.nodeType == 11)
        r = r.host;
      else
        break;
    if (e < this.scrollTargets.length && !n && (n = this.scrollTargets.slice(0, e)), n) {
      for (let r of this.scrollTargets)
        r.removeEventListener("scroll", this.onScroll);
      for (let r of this.scrollTargets = n)
        r.addEventListener("scroll", this.onScroll);
    }
  }
  ignore(e) {
    if (!this.active)
      return e();
    try {
      return this.stop(), e();
    } finally {
      this.start(), this.clear();
    }
  }
  start() {
    this.active || (this.observer.observe(this.dom, Zj), Mm && this.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.active = !0);
  }
  stop() {
    this.active && (this.active = !1, this.observer.disconnect(), Mm && this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData));
  }
  // Throw away any pending changes
  clear() {
    this.processRecords(), this.queue.length = 0, this.selectionChanged = !1;
  }
  // Chrome Android, especially in combination with GBoard, not only
  // doesn't reliably fire regular key events, but also often
  // surrounds the effect of enter or backspace with a bunch of
  // composition events that, when interrupted, cause text duplication
  // or other kinds of corruption. This hack makes the editor back off
  // from handling DOM changes for a moment when such a key is
  // detected (via beforeinput or keydown), and then tries to flush
  // them or, if that has no effect, dispatches the given key.
  delayAndroidKey(e, n) {
    var r;
    if (!this.delayedAndroidKey) {
      let i = () => {
        let s = this.delayedAndroidKey;
        s && (this.clearDelayedAndroidKey(), this.view.inputState.lastKeyCode = s.keyCode, this.view.inputState.lastKeyTime = Date.now(), !this.flush() && s.force && na(this.dom, s.key, s.keyCode));
      };
      this.flushingAndroidKey = this.view.win.requestAnimationFrame(i);
    }
    (!this.delayedAndroidKey || e == "Enter") && (this.delayedAndroidKey = {
      key: e,
      keyCode: n,
      // Only run the key handler when no changes are detected if
      // this isn't coming right after another change, in which case
      // it is probably part of a weird chain of updates, and should
      // be ignored if it returns the DOM to its previous state.
      force: this.lastChange < Date.now() - 50 || !!(!((r = this.delayedAndroidKey) === null || r === void 0) && r.force)
    });
  }
  clearDelayedAndroidKey() {
    this.win.cancelAnimationFrame(this.flushingAndroidKey), this.delayedAndroidKey = null, this.flushingAndroidKey = -1;
  }
  flushSoon() {
    this.delayedFlush < 0 && (this.delayedFlush = this.view.win.requestAnimationFrame(() => {
      this.delayedFlush = -1, this.flush();
    }));
  }
  forceFlush() {
    this.delayedFlush >= 0 && (this.view.win.cancelAnimationFrame(this.delayedFlush), this.delayedFlush = -1), this.flush();
  }
  pendingRecords() {
    for (let e of this.observer.takeRecords())
      this.queue.push(e);
    return this.queue;
  }
  processRecords() {
    let e = this.pendingRecords();
    e.length && (this.queue = []);
    let n = -1, r = -1, i = !1;
    for (let s of e) {
      let o = this.readMutation(s);
      o && (o.typeOver && (i = !0), n == -1 ? { from: n, to: r } = o : (n = Math.min(o.from, n), r = Math.max(o.to, r)));
    }
    return { from: n, to: r, typeOver: i };
  }
  readChange() {
    let { from: e, to: n, typeOver: r } = this.processRecords(), i = this.selectionChanged && Rf(this.dom, this.selectionRange);
    if (e < 0 && !i)
      return null;
    e > -1 && (this.lastChange = Date.now()), this.view.inputState.lastFocusTime = 0, this.selectionChanged = !1;
    let s = new qj(this.view, e, n, r);
    return this.view.docView.domChanged = { newSel: s.newSel ? s.newSel.main : null }, s;
  }
  // Apply pending changes, if any
  flush(e = !0) {
    if (this.delayedFlush >= 0 || this.delayedAndroidKey)
      return !1;
    e && this.readSelectionRange();
    let n = this.readChange();
    if (!n)
      return this.view.requestMeasure(), !1;
    let r = this.view.state, i = P6(this.view, n);
    return this.view.state == r && (n.domChanged || n.newSel && !n.newSel.main.eq(this.view.state.selection.main)) && this.view.update([]), i;
  }
  readMutation(e) {
    let n = this.view.docView.nearest(e.target);
    if (!n || n.ignoreMutation(e))
      return null;
    if (n.markDirty(e.type == "attributes"), e.type == "attributes" && (n.flags |= 4), e.type == "childList") {
      let r = hw(n, e.previousSibling || e.target.previousSibling, -1), i = hw(n, e.nextSibling || e.target.nextSibling, 1);
      return {
        from: r ? n.posAfter(r) : n.posAtStart,
        to: i ? n.posBefore(i) : n.posAtEnd,
        typeOver: !1
      };
    } else return e.type == "characterData" ? { from: n.posAtStart, to: n.posAtEnd, typeOver: e.target.nodeValue == e.oldValue } : null;
  }
  setWindow(e) {
    e != this.win && (this.removeWindowListeners(this.win), this.win = e, this.addWindowListeners(this.win));
  }
  addWindowListeners(e) {
    e.addEventListener("resize", this.onResize), this.printQuery ? this.printQuery.addEventListener("change", this.onPrint) : e.addEventListener("beforeprint", this.onPrint), e.addEventListener("scroll", this.onScroll), e.document.addEventListener("selectionchange", this.onSelectionChange);
  }
  removeWindowListeners(e) {
    e.removeEventListener("scroll", this.onScroll), e.removeEventListener("resize", this.onResize), this.printQuery ? this.printQuery.removeEventListener("change", this.onPrint) : e.removeEventListener("beforeprint", this.onPrint), e.document.removeEventListener("selectionchange", this.onSelectionChange);
  }
  update(e) {
    this.editContext && (this.editContext.update(e), e.startState.facet(ji) != e.state.facet(ji) && (e.view.contentDOM.editContext = e.state.facet(ji) ? this.editContext.editContext : null));
  }
  destroy() {
    var e, n, r;
    this.stop(), (e = this.intersection) === null || e === void 0 || e.disconnect(), (n = this.gapIntersection) === null || n === void 0 || n.disconnect(), (r = this.resizeScroll) === null || r === void 0 || r.disconnect();
    for (let i of this.scrollTargets)
      i.removeEventListener("scroll", this.onScroll);
    this.removeWindowListeners(this.win), clearTimeout(this.parentCheck), clearTimeout(this.resizeTimeout), this.win.cancelAnimationFrame(this.delayedFlush), this.win.cancelAnimationFrame(this.flushingAndroidKey), this.editContext && (this.view.contentDOM.editContext = null, this.editContext.destroy());
  }
}
function hw(t, e, n) {
  for (; e; ) {
    let r = qe.get(e);
    if (r && r.parent == t)
      return r;
    let i = e.parentNode;
    e = i != t.dom ? i : n > 0 ? e.nextSibling : e.previousSibling;
  }
  return null;
}
function dw(t, e) {
  let n = e.startContainer, r = e.startOffset, i = e.endContainer, s = e.endOffset, o = t.docView.domAtPos(t.state.selection.main.anchor);
  return rc(o.node, o.offset, i, s) && ([n, r, i, s] = [i, s, n, r]), { anchorNode: n, anchorOffset: r, focusNode: i, focusOffset: s };
}
function Qj(t, e) {
  if (e.getComposedRanges) {
    let i = e.getComposedRanges(t.root)[0];
    if (i)
      return dw(t, i);
  }
  let n = null;
  function r(i) {
    i.preventDefault(), i.stopImmediatePropagation(), n = i.getTargetRanges()[0];
  }
  return t.contentDOM.addEventListener("beforeinput", r, !0), t.dom.ownerDocument.execCommand("indent"), t.contentDOM.removeEventListener("beforeinput", r, !0), n ? dw(t, n) : null;
}
class eq {
  constructor(e) {
    this.from = 0, this.to = 0, this.pendingContextChange = null, this.handlers = /* @__PURE__ */ Object.create(null), this.resetRange(e.state);
    let n = this.editContext = new window.EditContext({
      text: e.state.doc.sliceString(this.from, this.to),
      selectionStart: this.toContextPos(Math.max(this.from, Math.min(this.to, e.state.selection.main.anchor))),
      selectionEnd: this.toContextPos(e.state.selection.main.head)
    });
    this.handlers.textupdate = (r) => {
      let { anchor: i } = e.state.selection.main, s = {
        from: this.toEditorPos(r.updateRangeStart),
        to: this.toEditorPos(r.updateRangeEnd),
        insert: ze.of(r.text.split(`
`))
      };
      s.from == this.from && i < this.from ? s.from = i : s.to == this.to && i > this.to && (s.to = i), !(s.from == s.to && !s.insert.length) && (this.pendingContextChange = s, L6(e, s, W.single(this.toEditorPos(r.selectionStart), this.toEditorPos(r.selectionEnd))), this.pendingContextChange && (this.revertPending(e.state), this.setSelection(e.state)));
    }, this.handlers.characterboundsupdate = (r) => {
      let i = [], s = null;
      for (let o = this.toEditorPos(r.rangeStart), a = this.toEditorPos(r.rangeEnd); o < a; o++) {
        let l = e.coordsForChar(o);
        s = l && new DOMRect(l.left, l.top, l.right - l.left, l.bottom - l.top) || s || new DOMRect(), i.push(s);
      }
      n.updateCharacterBounds(r.rangeStart, i);
    }, this.handlers.textformatupdate = (r) => {
      let i = [];
      for (let s of r.getTextFormats()) {
        let o = s.underlineStyle, a = s.underlineThickness;
        if (o != "None" && a != "None") {
          let l = `text-decoration: underline ${o == "Dashed" ? "dashed " : o == "Squiggle" ? "wavy " : ""}${a == "Thin" ? 1 : 2}px`;
          i.push(we.mark({ attributes: { style: l } }).range(this.toEditorPos(s.rangeStart), this.toEditorPos(s.rangeEnd)));
        }
      }
      e.dispatch({ effects: h6.of(we.set(i)) });
    }, this.handlers.compositionstart = () => {
      e.inputState.composing < 0 && (e.inputState.composing = 0, e.inputState.compositionFirstChange = !0);
    }, this.handlers.compositionend = () => {
      e.inputState.composing = -1, e.inputState.compositionFirstChange = null;
    };
    for (let r in this.handlers)
      n.addEventListener(r, this.handlers[r]);
    this.measureReq = { read: (r) => {
      this.editContext.updateControlBounds(r.contentDOM.getBoundingClientRect());
      let i = Dc(r.root);
      i && i.rangeCount && this.editContext.updateSelectionBounds(i.getRangeAt(0).getBoundingClientRect());
    } };
  }
  applyEdits(e) {
    let n = 0, r = !1, i = this.pendingContextChange;
    return e.changes.iterChanges((s, o, a, l, c) => {
      if (r)
        return;
      let u = c.length - (o - s);
      if (i && o >= i.to)
        if (i.from == s && i.to == o && i.insert.eq(c)) {
          i = this.pendingContextChange = null, n += u, this.to += u;
          return;
        } else
          i = null, this.revertPending(e.state);
      if (s += n, o += n, o <= this.from)
        this.from += u, this.to += u;
      else if (s < this.to) {
        if (s < this.from || o > this.to || this.to - this.from + c.length > 3e4) {
          r = !0;
          return;
        }
        this.editContext.updateText(this.toContextPos(s), this.toContextPos(o), c.toString()), this.to += u;
      }
      n += u;
    }), i && !r && this.revertPending(e.state), !r;
  }
  update(e) {
    let n = this.pendingContextChange;
    !this.applyEdits(e) || !this.rangeIsValid(e.state) ? (this.pendingContextChange = null, this.resetRange(e.state), this.editContext.updateText(0, this.editContext.text.length, e.state.doc.sliceString(this.from, this.to)), this.setSelection(e.state)) : (e.docChanged || e.selectionSet || n) && this.setSelection(e.state), (e.geometryChanged || e.docChanged || e.selectionSet) && e.view.requestMeasure(this.measureReq);
  }
  resetRange(e) {
    let { head: n } = e.selection.main;
    this.from = Math.max(
      0,
      n - 1e4
      /* CxVp.Margin */
    ), this.to = Math.min(
      e.doc.length,
      n + 1e4
      /* CxVp.Margin */
    );
  }
  revertPending(e) {
    let n = this.pendingContextChange;
    this.pendingContextChange = null, this.editContext.updateText(this.toContextPos(n.from), this.toContextPos(n.from + n.insert.length), e.doc.sliceString(n.from, n.to));
  }
  setSelection(e) {
    let { main: n } = e.selection, r = this.toContextPos(Math.max(this.from, Math.min(this.to, n.anchor))), i = this.toContextPos(n.head);
    (this.editContext.selectionStart != r || this.editContext.selectionEnd != i) && this.editContext.updateSelection(r, i);
  }
  rangeIsValid(e) {
    let { head: n } = e.selection.main;
    return !(this.from > 0 && n - this.from < 500 || this.to < e.doc.length && this.to - n < 500 || this.to - this.from > 1e4 * 3);
  }
  toEditorPos(e) {
    return e + this.from;
  }
  toContextPos(e) {
    return e - this.from;
  }
  destroy() {
    for (let e in this.handlers)
      this.editContext.removeEventListener(e, this.handlers[e]);
  }
}
class de {
  /**
  The current editor state.
  */
  get state() {
    return this.viewState.state;
  }
  /**
  To be able to display large documents without consuming too much
  memory or overloading the browser, CodeMirror only draws the
  code that is visible (plus a margin around it) to the DOM. This
  property tells you the extent of the current drawn viewport, in
  document positions.
  */
  get viewport() {
    return this.viewState.viewport;
  }
  /**
  When there are, for example, large collapsed ranges in the
  viewport, its size can be a lot bigger than the actual visible
  content. Thus, if you are doing something like styling the
  content in the viewport, it is preferable to only do so for
  these ranges, which are the subset of the viewport that is
  actually drawn.
  */
  get visibleRanges() {
    return this.viewState.visibleRanges;
  }
  /**
  Returns false when the editor is entirely scrolled out of view
  or otherwise hidden.
  */
  get inView() {
    return this.viewState.inView;
  }
  /**
  Indicates whether the user is currently composing text via
  [IME](https://en.wikipedia.org/wiki/Input_method), and at least
  one change has been made in the current composition.
  */
  get composing() {
    return this.inputState.composing > 0;
  }
  /**
  Indicates whether the user is currently in composing state. Note
  that on some platforms, like Android, this will be the case a
  lot, since just putting the cursor on a word starts a
  composition there.
  */
  get compositionStarted() {
    return this.inputState.composing >= 0;
  }
  /**
  The document or shadow root that the view lives in.
  */
  get root() {
    return this._root;
  }
  /**
  @internal
  */
  get win() {
    return this.dom.ownerDocument.defaultView || window;
  }
  /**
  Construct a new view. You'll want to either provide a `parent`
  option, or put `view.dom` into your document after creating a
  view, so that the user can see the editor.
  */
  constructor(e = {}) {
    this.plugins = [], this.pluginMap = /* @__PURE__ */ new Map(), this.editorAttrs = {}, this.contentAttrs = {}, this.bidiCache = [], this.destroyed = !1, this.updateState = 2, this.measureScheduled = -1, this.measureRequests = [], this.contentDOM = document.createElement("div"), this.scrollDOM = document.createElement("div"), this.scrollDOM.tabIndex = -1, this.scrollDOM.className = "cm-scroller", this.scrollDOM.appendChild(this.contentDOM), this.announceDOM = document.createElement("div"), this.announceDOM.className = "cm-announced", this.announceDOM.setAttribute("aria-live", "polite"), this.dom = document.createElement("div"), this.dom.appendChild(this.announceDOM), this.dom.appendChild(this.scrollDOM), e.parent && e.parent.appendChild(this.dom);
    let { dispatch: n } = e;
    this.dispatchTransactions = e.dispatchTransactions || n && ((r) => r.forEach((i) => n(i, this))) || ((r) => this.update(r)), this.dispatch = this.dispatch.bind(this), this._root = e.root || RW(e.parent) || document, this.viewState = new cw(e.state || Le.create(e)), e.scrollTo && e.scrollTo.is(tf) && (this.viewState.scrollTarget = e.scrollTo.value.clip(this.viewState.state)), this.plugins = this.state.facet(Rl).map((r) => new wm(r));
    for (let r of this.plugins)
      r.update(this);
    this.observer = new Jj(this), this.inputState = new mj(this), this.inputState.ensureHandlers(this.plugins), this.docView = new j2(this), this.mountStyles(), this.updateAttrs(), this.updateState = 0, this.requestMeasure();
  }
  dispatch(...e) {
    let n = e.length == 1 && e[0] instanceof vt ? e : e.length == 1 && Array.isArray(e[0]) ? e[0] : [this.state.update(...e)];
    this.dispatchTransactions(n, this);
  }
  /**
  Update the view for the given array of transactions. This will
  update the visible document and selection to match the state
  produced by the transactions, and notify view plugins of the
  change. You should usually call
  [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead, which uses this
  as a primitive.
  */
  update(e) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.update are not allowed while an update is in progress");
    let n = !1, r = !1, i, s = this.state;
    for (let f of e) {
      if (f.startState != s)
        throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
      s = f.state;
    }
    if (this.destroyed) {
      this.viewState.state = s;
      return;
    }
    let o = this.hasFocus, a = 0, l = null;
    e.some((f) => f.annotation(C6)) ? (this.inputState.notifiedFocused = o, a = 1) : o != this.inputState.notifiedFocused && (this.inputState.notifiedFocused = o, l = $6(s, o), l || (a = 1));
    let c = this.observer.delayedAndroidKey, u = null;
    if (c ? (this.observer.clearDelayedAndroidKey(), u = this.observer.readChange(), (u && !this.state.doc.eq(s.doc) || !this.state.selection.eq(s.selection)) && (u = null)) : this.observer.clear(), s.facet(Le.phrases) != this.state.facet(Le.phrases))
      return this.setState(s);
    i = Vh.create(this, s, e), i.flags |= a;
    let h = this.viewState.scrollTarget;
    try {
      this.updateState = 2;
      for (let f of e) {
        if (h && (h = h.map(f.changes)), f.scrollIntoView) {
          let { main: d } = f.state.selection;
          h = new ra(d.empty ? d : W.cursor(d.head, d.head > d.anchor ? -1 : 1));
        }
        for (let d of f.effects)
          d.is(tf) && (h = d.value.clip(this.state));
      }
      this.viewState.update(i, h), this.bidiCache = Hh.update(this.bidiCache, i.changes), i.empty || (this.updatePlugins(i), this.inputState.update(i)), n = this.docView.update(i), this.state.facet(Bl) != this.styleModules && this.mountStyles(), r = this.updateAttrs(), this.showAnnouncements(e), this.docView.updateSelection(n, e.some((f) => f.isUserEvent("select.pointer")));
    } finally {
      this.updateState = 0;
    }
    if (i.startState.facet(lf) != i.state.facet(lf) && (this.viewState.mustMeasureContent = !0), (n || r || h || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent) && this.requestMeasure(), n && this.docViewUpdate(), !i.empty)
      for (let f of this.state.facet(N0))
        try {
          f(i);
        } catch (d) {
          un(this.state, d, "update listener");
        }
    (l || u) && Promise.resolve().then(() => {
      l && this.state == l.startState && this.dispatch(l), u && !P6(this, u) && c.force && na(this.contentDOM, c.key, c.keyCode);
    });
  }
  /**
  Reset the view to the given state. (This will cause the entire
  document to be redrawn and all view plugins to be reinitialized,
  so you should probably only use it when the new state isn't
  derived from the old state. Otherwise, use
  [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead.)
  */
  setState(e) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.setState are not allowed while an update is in progress");
    if (this.destroyed) {
      this.viewState.state = e;
      return;
    }
    this.updateState = 2;
    let n = this.hasFocus;
    try {
      for (let r of this.plugins)
        r.destroy(this);
      this.viewState = new cw(e), this.plugins = e.facet(Rl).map((r) => new wm(r)), this.pluginMap.clear();
      for (let r of this.plugins)
        r.update(this);
      this.docView.destroy(), this.docView = new j2(this), this.inputState.ensureHandlers(this.plugins), this.mountStyles(), this.updateAttrs(), this.bidiCache = [];
    } finally {
      this.updateState = 0;
    }
    n && this.focus(), this.requestMeasure();
  }
  updatePlugins(e) {
    let n = e.startState.facet(Rl), r = e.state.facet(Rl);
    if (n != r) {
      let i = [];
      for (let s of r) {
        let o = n.indexOf(s);
        if (o < 0)
          i.push(new wm(s));
        else {
          let a = this.plugins[o];
          a.mustUpdate = e, i.push(a);
        }
      }
      for (let s of this.plugins)
        s.mustUpdate != e && s.destroy(this);
      this.plugins = i, this.pluginMap.clear();
    } else
      for (let i of this.plugins)
        i.mustUpdate = e;
    for (let i = 0; i < this.plugins.length; i++)
      this.plugins[i].update(this);
    n != r && this.inputState.ensureHandlers(this.plugins);
  }
  docViewUpdate() {
    for (let e of this.plugins) {
      let n = e.value;
      if (n && n.docViewUpdate)
        try {
          n.docViewUpdate(this);
        } catch (r) {
          un(this.state, r, "doc view update listener");
        }
    }
  }
  /**
  @internal
  */
  measure(e = !0) {
    if (this.destroyed)
      return;
    if (this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.observer.delayedAndroidKey) {
      this.measureScheduled = -1, this.requestMeasure();
      return;
    }
    this.measureScheduled = 0, e && this.observer.forceFlush();
    let n = null, r = this.scrollDOM, i = r.scrollTop * this.scaleY, { scrollAnchorPos: s, scrollAnchorHeight: o } = this.viewState;
    Math.abs(i - this.viewState.scrollTop) > 1 && (o = -1), this.viewState.scrollAnchorHeight = -1;
    try {
      for (let a = 0; ; a++) {
        if (o < 0)
          if (z8(r))
            s = -1, o = this.viewState.heightMap.height;
          else {
            let d = this.viewState.scrollAnchorAt(i);
            s = d.from, o = d.top;
          }
        this.updateState = 1;
        let l = this.viewState.measure(this);
        if (!l && !this.measureRequests.length && this.viewState.scrollTarget == null)
          break;
        if (a > 5) {
          console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
          break;
        }
        let c = [];
        l & 4 || ([this.measureRequests, c] = [c, this.measureRequests]);
        let u = c.map((d) => {
          try {
            return d.read(this);
          } catch (p) {
            return un(this.state, p), pw;
          }
        }), h = Vh.create(this, this.state, []), f = !1;
        h.flags |= l, n ? n.flags |= l : n = h, this.updateState = 2, h.empty || (this.updatePlugins(h), this.inputState.update(h), this.updateAttrs(), f = this.docView.update(h), f && this.docViewUpdate());
        for (let d = 0; d < c.length; d++)
          if (u[d] != pw)
            try {
              let p = c[d];
              p.write && p.write(u[d], this);
            } catch (p) {
              un(this.state, p);
            }
        if (f && this.docView.updateSelection(!0), !h.viewportChanged && this.measureRequests.length == 0) {
          if (this.viewState.editorHeight)
            if (this.viewState.scrollTarget) {
              this.docView.scrollIntoView(this.viewState.scrollTarget), this.viewState.scrollTarget = null, o = -1;
              continue;
            } else {
              let p = (s < 0 ? this.viewState.heightMap.height : this.viewState.lineBlockAt(s).top) - o;
              if (p > 1 || p < -1) {
                i = i + p, r.scrollTop = i / this.scaleY, o = -1;
                continue;
              }
            }
          break;
        }
      }
    } finally {
      this.updateState = 0, this.measureScheduled = -1;
    }
    if (n && !n.empty)
      for (let a of this.state.facet(N0))
        a(n);
  }
  /**
  Get the CSS classes for the currently active editor themes.
  */
  get themeClasses() {
    return z0 + " " + (this.state.facet(F0) ? O6 : T6) + " " + this.state.facet(lf);
  }
  updateAttrs() {
    let e = mw(this, d6, {
      class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses
    }), n = {
      spellcheck: "false",
      autocorrect: "off",
      autocapitalize: "off",
      translate: "no",
      contenteditable: this.state.facet(ji) ? "true" : "false",
      class: "cm-content",
      style: `${me.tabSize}: ${this.state.tabSize}`,
      role: "textbox",
      "aria-multiline": "true"
    };
    this.state.readOnly && (n["aria-readonly"] = "true"), mw(this, q1, n);
    let r = this.observer.ignore(() => {
      let i = T0(this.contentDOM, this.contentAttrs, n), s = T0(this.dom, this.editorAttrs, e);
      return i || s;
    });
    return this.editorAttrs = e, this.contentAttrs = n, r;
  }
  showAnnouncements(e) {
    let n = !0;
    for (let r of e)
      for (let i of r.effects)
        if (i.is(de.announce)) {
          n && (this.announceDOM.textContent = ""), n = !1;
          let s = this.announceDOM.appendChild(document.createElement("div"));
          s.textContent = i.value;
        }
  }
  mountStyles() {
    this.styleModules = this.state.facet(Bl);
    let e = this.state.facet(de.cspNonce);
    ps.mount(this.root, this.styleModules.concat(Yj).reverse(), e ? { nonce: e } : void 0);
  }
  readMeasured() {
    if (this.updateState == 2)
      throw new Error("Reading the editor layout isn't allowed during an update");
    this.updateState == 0 && this.measureScheduled > -1 && this.measure(!1);
  }
  /**
  Schedule a layout measurement, optionally providing callbacks to
  do custom DOM measuring followed by a DOM write phase. Using
  this is preferable reading DOM layout directly from, for
  example, an event handler, because it'll make sure measuring and
  drawing done by other components is synchronized, avoiding
  unnecessary DOM layout computations.
  */
  requestMeasure(e) {
    if (this.measureScheduled < 0 && (this.measureScheduled = this.win.requestAnimationFrame(() => this.measure())), e) {
      if (this.measureRequests.indexOf(e) > -1)
        return;
      if (e.key != null) {
        for (let n = 0; n < this.measureRequests.length; n++)
          if (this.measureRequests[n].key === e.key) {
            this.measureRequests[n] = e;
            return;
          }
      }
      this.measureRequests.push(e);
    }
  }
  /**
  Get the value of a specific plugin, if present. Note that
  plugins that crash can be dropped from a view, so even when you
  know you registered a given plugin, it is recommended to check
  the return value of this method.
  */
  plugin(e) {
    let n = this.pluginMap.get(e);
    return (n === void 0 || n && n.spec != e) && this.pluginMap.set(e, n = this.plugins.find((r) => r.spec == e) || null), n && n.update(this).value;
  }
  /**
  The top position of the document, in screen coordinates. This
  may be negative when the editor is scrolled down. Points
  directly to the top of the first line, not above the padding.
  */
  get documentTop() {
    return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
  }
  /**
  Reports the padding above and below the document.
  */
  get documentPadding() {
    return { top: this.viewState.paddingTop, bottom: this.viewState.paddingBottom };
  }
  /**
  If the editor is transformed with CSS, this provides the scale
  along the X axis. Otherwise, it will just be 1. Note that
  transforms other than translation and scaling are not supported.
  */
  get scaleX() {
    return this.viewState.scaleX;
  }
  /**
  Provide the CSS transformed scale along the Y axis.
  */
  get scaleY() {
    return this.viewState.scaleY;
  }
  /**
  Find the text line or block widget at the given vertical
  position (which is interpreted as relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop)).
  */
  elementAtHeight(e) {
    return this.readMeasured(), this.viewState.elementAtHeight(e);
  }
  /**
  Find the line block (see
  [`lineBlockAt`](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) at the given
  height, again interpreted relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop).
  */
  lineBlockAtHeight(e) {
    return this.readMeasured(), this.viewState.lineBlockAtHeight(e);
  }
  /**
  Get the extent and vertical position of all [line
  blocks](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) in the viewport. Positions
  are relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop);
  */
  get viewportLineBlocks() {
    return this.viewState.viewportLines;
  }
  /**
  Find the line block around the given document position. A line
  block is a range delimited on both sides by either a
  non-[hidden](https://codemirror.net/6/docs/ref/#view.Decoration^replace) line breaks, or the
  start/end of the document. It will usually just hold a line of
  text, but may be broken into multiple textblocks by block
  widgets.
  */
  lineBlockAt(e) {
    return this.viewState.lineBlockAt(e);
  }
  /**
  The editor's total content height.
  */
  get contentHeight() {
    return this.viewState.contentHeight;
  }
  /**
  Move a cursor position by [grapheme
  cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak). `forward` determines whether
  the motion is away from the line start, or towards it. In
  bidirectional text, the line is traversed in visual order, using
  the editor's [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
  When the start position was the last one on the line, the
  returned position will be across the line break. If there is no
  further line, the original position is returned.
  
  By default, this method moves over a single cluster. The
  optional `by` argument can be used to move across more. It will
  be called with the first cluster as argument, and should return
  a predicate that determines, for each subsequent cluster,
  whether it should also be moved over.
  */
  moveByChar(e, n, r) {
    return _m(this, e, Z2(this, e, n, r));
  }
  /**
  Move a cursor position across the next group of either
  [letters](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) or non-letter
  non-whitespace characters.
  */
  moveByGroup(e, n) {
    return _m(this, e, Z2(this, e, n, (r) => dj(this, e.head, r)));
  }
  /**
  Get the cursor position visually at the start or end of a line.
  Note that this may differ from the _logical_ position at its
  start or end (which is simply at `line.from`/`line.to`) if text
  at the start or end goes against the line's base text direction.
  */
  visualLineSide(e, n) {
    let r = this.bidiSpans(e), i = this.textDirectionAt(e.from), s = r[n ? r.length - 1 : 0];
    return W.cursor(s.side(n, i) + e.from, s.forward(!n, i) ? 1 : -1);
  }
  /**
  Move to the next line boundary in the given direction. If
  `includeWrap` is true, line wrapping is on, and there is a
  further wrap point on the current line, the wrap point will be
  returned. Otherwise this function will return the start or end
  of the line.
  */
  moveToLineBoundary(e, n, r = !0) {
    return hj(this, e, n, r);
  }
  /**
  Move a cursor position vertically. When `distance` isn't given,
  it defaults to moving to the next line (including wrapped
  lines). Otherwise, `distance` should provide a positive distance
  in pixels.
  
  When `start` has a
  [`goalColumn`](https://codemirror.net/6/docs/ref/#state.SelectionRange.goalColumn), the vertical
  motion will use that as a target horizontal position. Otherwise,
  the cursor's own horizontal position is used. The returned
  cursor will have its goal column set to whichever column was
  used.
  */
  moveVertically(e, n, r) {
    return _m(this, e, pj(this, e, n, r));
  }
  /**
  Find the DOM parent node and offset (child offset if `node` is
  an element, character offset when it is a text node) at the
  given document position.
  
  Note that for positions that aren't currently in
  `visibleRanges`, the resulting DOM position isn't necessarily
  meaningful (it may just point before or after a placeholder
  element).
  */
  domAtPos(e) {
    return this.docView.domAtPos(e);
  }
  /**
  Find the document position at the given DOM node. Can be useful
  for associating positions with DOM events. Will raise an error
  when `node` isn't part of the editor content.
  */
  posAtDOM(e, n = 0) {
    return this.docView.posFromDOM(e, n);
  }
  posAtCoords(e, n = !0) {
    return this.readMeasured(), b6(this, e, n);
  }
  /**
  Get the screen coordinates at the given document position.
  `side` determines whether the coordinates are based on the
  element before (-1) or after (1) the position (if no element is
  available on the given side, the method will transparently use
  another strategy to get reasonable coordinates).
  */
  coordsAtPos(e, n = 1) {
    this.readMeasured();
    let r = this.docView.coordsAt(e, n);
    if (!r || r.left == r.right)
      return r;
    let i = this.state.doc.lineAt(e), s = this.bidiSpans(i), o = s[es.find(s, e - i.from, -1, n)];
    return sp(r, o.dir == Qe.LTR == n > 0);
  }
  /**
  Return the rectangle around a given character. If `pos` does not
  point in front of a character that is in the viewport and
  rendered (i.e. not replaced, not a line break), this will return
  null. For space characters that are a line wrap point, this will
  return the position before the line break.
  */
  coordsForChar(e) {
    return this.readMeasured(), this.docView.coordsForChar(e);
  }
  /**
  The default width of a character in the editor. May not
  accurately reflect the width of all characters (given variable
  width fonts or styling of invididual ranges).
  */
  get defaultCharacterWidth() {
    return this.viewState.heightOracle.charWidth;
  }
  /**
  The default height of a line in the editor. May not be accurate
  for all lines.
  */
  get defaultLineHeight() {
    return this.viewState.heightOracle.lineHeight;
  }
  /**
  The text direction
  ([`direction`](https://developer.mozilla.org/en-US/docs/Web/CSS/direction)
  CSS property) of the editor's content element.
  */
  get textDirection() {
    return this.viewState.defaultTextDirection;
  }
  /**
  Find the text direction of the block at the given position, as
  assigned by CSS. If
  [`perLineTextDirection`](https://codemirror.net/6/docs/ref/#view.EditorView^perLineTextDirection)
  isn't enabled, or the given position is outside of the viewport,
  this will always return the same as
  [`textDirection`](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection). Note that
  this may trigger a DOM layout.
  */
  textDirectionAt(e) {
    return !this.state.facet(c6) || e < this.viewport.from || e > this.viewport.to ? this.textDirection : (this.readMeasured(), this.docView.textDirectionAt(e));
  }
  /**
  Whether this editor [wraps lines](https://codemirror.net/6/docs/ref/#view.EditorView.lineWrapping)
  (as determined by the
  [`white-space`](https://developer.mozilla.org/en-US/docs/Web/CSS/white-space)
  CSS property of its content element).
  */
  get lineWrapping() {
    return this.viewState.heightOracle.lineWrapping;
  }
  /**
  Returns the bidirectional text structure of the given line
  (which should be in the current document) as an array of span
  objects. The order of these spans matches the [text
  direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection)—if that is
  left-to-right, the leftmost spans come first, otherwise the
  rightmost spans come first.
  */
  bidiSpans(e) {
    if (e.length > tq)
      return t6(e.length);
    let n = this.textDirectionAt(e.from), r;
    for (let s of this.bidiCache)
      if (s.from == e.from && s.dir == n && (s.fresh || e6(s.isolates, r = W2(this, e))))
        return s.order;
    r || (r = W2(this, e));
    let i = XW(e.text, n, r);
    return this.bidiCache.push(new Hh(e.from, e.to, n, r, !0, i)), i;
  }
  /**
  Check whether the editor has focus.
  */
  get hasFocus() {
    var e;
    return (this.dom.ownerDocument.hasFocus() || me.safari && ((e = this.inputState) === null || e === void 0 ? void 0 : e.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
  }
  /**
  Put focus on the editor.
  */
  focus() {
    this.observer.ignore(() => {
      B8(this.contentDOM), this.docView.updateSelection();
    });
  }
  /**
  Update the [root](https://codemirror.net/6/docs/ref/##view.EditorViewConfig.root) in which the editor lives. This is only
  necessary when moving the editor's existing DOM to a new window or shadow root.
  */
  setRoot(e) {
    this._root != e && (this._root = e, this.observer.setWindow((e.nodeType == 9 ? e : e.ownerDocument).defaultView || window), this.mountStyles());
  }
  /**
  Clean up this editor view, removing its element from the
  document, unregistering event handlers, and notifying
  plugins. The view instance can no longer be used after
  calling this.
  */
  destroy() {
    this.root.activeElement == this.contentDOM && this.contentDOM.blur();
    for (let e of this.plugins)
      e.destroy(this);
    this.plugins = [], this.inputState.destroy(), this.docView.destroy(), this.dom.remove(), this.observer.destroy(), this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.destroyed = !0;
  }
  /**
  Returns an effect that can be
  [added](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) to a transaction to
  cause it to scroll the given position or range into view.
  */
  static scrollIntoView(e, n = {}) {
    return tf.of(new ra(typeof e == "number" ? W.cursor(e) : e, n.y, n.x, n.yMargin, n.xMargin));
  }
  /**
  Return an effect that resets the editor to its current (at the
  time this method was called) scroll position. Note that this
  only affects the editor's own scrollable element, not parents.
  See also
  [`EditorViewConfig.scrollTo`](https://codemirror.net/6/docs/ref/#view.EditorViewConfig.scrollTo).
  
  The effect should be used with a document identical to the one
  it was created for. Failing to do so is not an error, but may
  not scroll to the expected position. You can
  [map](https://codemirror.net/6/docs/ref/#state.StateEffect.map) the effect to account for changes.
  */
  scrollSnapshot() {
    let { scrollTop: e, scrollLeft: n } = this.scrollDOM, r = this.viewState.scrollAnchorAt(e);
    return tf.of(new ra(W.cursor(r.from), "start", "start", r.top - e, n, !0));
  }
  /**
  Enable or disable tab-focus mode, which disables key bindings
  for Tab and Shift-Tab, letting the browser's default
  focus-changing behavior go through instead. This is useful to
  prevent trapping keyboard users in your editor.
  
  Without argument, this toggles the mode. With a boolean, it
  enables (true) or disables it (false). Given a number, it
  temporarily enables the mode until that number of milliseconds
  have passed or another non-Tab key is pressed.
  */
  setTabFocusMode(e) {
    e == null ? this.inputState.tabFocusMode = this.inputState.tabFocusMode < 0 ? 0 : -1 : typeof e == "boolean" ? this.inputState.tabFocusMode = e ? 0 : -1 : this.inputState.tabFocusMode != 0 && (this.inputState.tabFocusMode = Date.now() + e);
  }
  /**
  Returns an extension that can be used to add DOM event handlers.
  The value should be an object mapping event names to handler
  functions. For any given event, such functions are ordered by
  extension precedence, and the first handler to return true will
  be assumed to have handled that event, and no other handlers or
  built-in behavior will be activated for it. These are registered
  on the [content element](https://codemirror.net/6/docs/ref/#view.EditorView.contentDOM), except
  for `scroll` handlers, which will be called any time the
  editor's [scroll element](https://codemirror.net/6/docs/ref/#view.EditorView.scrollDOM) or one of
  its parent nodes is scrolled.
  */
  static domEventHandlers(e) {
    return dt.define(() => ({}), { eventHandlers: e });
  }
  /**
  Create an extension that registers DOM event observers. Contrary
  to event [handlers](https://codemirror.net/6/docs/ref/#view.EditorView^domEventHandlers),
  observers can't be prevented from running by a higher-precedence
  handler returning true. They also don't prevent other handlers
  and observers from running when they return true, and should not
  call `preventDefault`.
  */
  static domEventObservers(e) {
    return dt.define(() => ({}), { eventObservers: e });
  }
  /**
  Create a theme extension. The first argument can be a
  [`style-mod`](https://github.com/marijnh/style-mod#documentation)
  style spec providing the styles for the theme. These will be
  prefixed with a generated class for the style.
  
  Because the selectors will be prefixed with a scope class, rule
  that directly match the editor's [wrapper
  element](https://codemirror.net/6/docs/ref/#view.EditorView.dom)—to which the scope class will be
  added—need to be explicitly differentiated by adding an `&` to
  the selector for that element—for example
  `&.cm-focused`.
  
  When `dark` is set to true, the theme will be marked as dark,
  which will cause the `&dark` rules from [base
  themes](https://codemirror.net/6/docs/ref/#view.EditorView^baseTheme) to be used (as opposed to
  `&light` when a light theme is active).
  */
  static theme(e, n) {
    let r = ps.newName(), i = [lf.of(r), Bl.of(V0(`.${r}`, e))];
    return n && n.dark && i.push(F0.of(!0)), i;
  }
  /**
  Create an extension that adds styles to the base theme. Like
  with [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme), use `&` to indicate the
  place of the editor wrapper element when directly targeting
  that. You can also use `&dark` or `&light` instead to only
  target editors with a dark or light theme.
  */
  static baseTheme(e) {
    return $o.lowest(Bl.of(V0("." + z0, e, E6)));
  }
  /**
  Retrieve an editor view instance from the view's DOM
  representation.
  */
  static findFromDOM(e) {
    var n;
    let r = e.querySelector(".cm-content"), i = r && qe.get(r) || qe.get(e);
    return ((n = i == null ? void 0 : i.rootView) === null || n === void 0 ? void 0 : n.view) || null;
  }
}
de.styleModule = Bl;
de.inputHandler = a6;
de.scrollHandler = f6;
de.focusChangeEffect = l6;
de.perLineTextDirection = c6;
de.exceptionSink = o6;
de.updateListener = N0;
de.editable = ji;
de.mouseSelectionStyle = s6;
de.dragMovesSelection = i6;
de.clickAddsSelectionRange = r6;
de.decorations = Tc;
de.outerDecorations = p6;
de.atomicRanges = U1;
de.bidiIsolatedRanges = m6;
de.scrollMargins = g6;
de.darkTheme = F0;
de.cspNonce = /* @__PURE__ */ ve.define({ combine: (t) => t.length ? t[0] : "" });
de.contentAttributes = q1;
de.editorAttributes = d6;
de.lineWrapping = /* @__PURE__ */ de.contentAttributes.of({ class: "cm-lineWrapping" });
de.announce = /* @__PURE__ */ De.define();
const tq = 4096, pw = {};
class Hh {
  constructor(e, n, r, i, s, o) {
    this.from = e, this.to = n, this.dir = r, this.isolates = i, this.fresh = s, this.order = o;
  }
  static update(e, n) {
    if (n.empty && !e.some((s) => s.fresh))
      return e;
    let r = [], i = e.length ? e[e.length - 1].dir : Qe.LTR;
    for (let s = Math.max(0, e.length - 10); s < e.length; s++) {
      let o = e[s];
      o.dir == i && !n.touchesRange(o.from, o.to) && r.push(new Hh(n.mapPos(o.from, 1), n.mapPos(o.to, -1), o.dir, o.isolates, !1, o.order));
    }
    return r;
  }
}
function mw(t, e, n) {
  for (let r = t.state.facet(e), i = r.length - 1; i >= 0; i--) {
    let s = r[i], o = typeof s == "function" ? s(t) : s;
    o && D0(o, n);
  }
  return n;
}
const nq = me.mac ? "mac" : me.windows ? "win" : me.linux ? "linux" : "key";
function rq(t, e) {
  const n = t.split(/-(?!$)/);
  let r = n[n.length - 1];
  r == "Space" && (r = " ");
  let i, s, o, a;
  for (let l = 0; l < n.length - 1; ++l) {
    const c = n[l];
    if (/^(cmd|meta|m)$/i.test(c))
      a = !0;
    else if (/^a(lt)?$/i.test(c))
      i = !0;
    else if (/^(c|ctrl|control)$/i.test(c))
      s = !0;
    else if (/^s(hift)?$/i.test(c))
      o = !0;
    else if (/^mod$/i.test(c))
      e == "mac" ? a = !0 : s = !0;
    else
      throw new Error("Unrecognized modifier name: " + c);
  }
  return i && (r = "Alt-" + r), s && (r = "Ctrl-" + r), a && (r = "Meta-" + r), o && (r = "Shift-" + r), r;
}
function cf(t, e, n) {
  return e.altKey && (t = "Alt-" + t), e.ctrlKey && (t = "Ctrl-" + t), e.metaKey && (t = "Meta-" + t), n !== !1 && e.shiftKey && (t = "Shift-" + t), t;
}
const iq = /* @__PURE__ */ $o.default(/* @__PURE__ */ de.domEventHandlers({
  keydown(t, e) {
    return I6(N6(e.state), t, e, "editor");
  }
})), ap = /* @__PURE__ */ ve.define({ enables: iq }), gw = /* @__PURE__ */ new WeakMap();
function N6(t) {
  let e = t.facet(ap), n = gw.get(e);
  return n || gw.set(e, n = aq(e.reduce((r, i) => r.concat(i), []))), n;
}
function sq(t, e, n) {
  return I6(N6(t.state), e, t, n);
}
let qi = null;
const oq = 4e3;
function aq(t, e = nq) {
  let n = /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null), i = (o, a) => {
    let l = r[o];
    if (l == null)
      r[o] = a;
    else if (l != a)
      throw new Error("Key binding " + o + " is used both as a regular binding and as a multi-stroke prefix");
  }, s = (o, a, l, c, u) => {
    var h, f;
    let d = n[o] || (n[o] = /* @__PURE__ */ Object.create(null)), p = a.split(/ (?!$)/).map((g) => rq(g, e));
    for (let g = 1; g < p.length; g++) {
      let y = p.slice(0, g).join(" ");
      i(y, !0), d[y] || (d[y] = {
        preventDefault: !0,
        stopPropagation: !1,
        run: [(x) => {
          let b = qi = { view: x, prefix: y, scope: o };
          return setTimeout(() => {
            qi == b && (qi = null);
          }, oq), !0;
        }]
      });
    }
    let m = p.join(" ");
    i(m, !1);
    let v = d[m] || (d[m] = {
      preventDefault: !1,
      stopPropagation: !1,
      run: ((f = (h = d._any) === null || h === void 0 ? void 0 : h.run) === null || f === void 0 ? void 0 : f.slice()) || []
    });
    l && v.run.push(l), c && (v.preventDefault = !0), u && (v.stopPropagation = !0);
  };
  for (let o of t) {
    let a = o.scope ? o.scope.split(" ") : ["editor"];
    if (o.any)
      for (let c of a) {
        let u = n[c] || (n[c] = /* @__PURE__ */ Object.create(null));
        u._any || (u._any = { preventDefault: !1, stopPropagation: !1, run: [] });
        let { any: h } = o;
        for (let f in u)
          u[f].run.push((d) => h(d, H0));
      }
    let l = o[e] || o.key;
    if (l)
      for (let c of a)
        s(c, l, o.run, o.preventDefault, o.stopPropagation), o.shift && s(c, "Shift-" + l, o.shift, o.preventDefault, o.stopPropagation);
  }
  return n;
}
let H0 = null;
function I6(t, e, n, r) {
  H0 = e;
  let i = OW(e), s = Dt(i, 0), o = In(s) == i.length && i != " ", a = "", l = !1, c = !1, u = !1;
  qi && qi.view == n && qi.scope == r && (a = qi.prefix + " ", w6.indexOf(e.keyCode) < 0 && (c = !0, qi = null));
  let h = /* @__PURE__ */ new Set(), f = (v) => {
    if (v) {
      for (let g of v.run)
        if (!h.has(g) && (h.add(g), g(n)))
          return v.stopPropagation && (u = !0), !0;
      v.preventDefault && (v.stopPropagation && (u = !0), c = !0);
    }
    return !1;
  }, d = t[r], p, m;
  return d && (f(d[a + cf(i, e, !o)]) ? l = !0 : o && (e.altKey || e.metaKey || e.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
  !(me.windows && e.ctrlKey && e.altKey) && (p = ms[e.keyCode]) && p != i ? (f(d[a + cf(p, e, !0)]) || e.shiftKey && (m = Ac[e.keyCode]) != i && m != p && f(d[a + cf(m, e, !1)])) && (l = !0) : o && e.shiftKey && f(d[a + cf(i, e, !0)]) && (l = !0), !l && f(d._any) && (l = !0)), c && (l = !0), l && u && e.stopPropagation(), H0 = null, l;
}
class wu {
  /**
  Create a marker with the given class and dimensions. If `width`
  is null, the DOM element will get no width style.
  */
  constructor(e, n, r, i, s) {
    this.className = e, this.left = n, this.top = r, this.width = i, this.height = s;
  }
  draw() {
    let e = document.createElement("div");
    return e.className = this.className, this.adjust(e), e;
  }
  update(e, n) {
    return n.className != this.className ? !1 : (this.adjust(e), !0);
  }
  adjust(e) {
    e.style.left = this.left + "px", e.style.top = this.top + "px", this.width != null && (e.style.width = this.width + "px"), e.style.height = this.height + "px";
  }
  eq(e) {
    return this.left == e.left && this.top == e.top && this.width == e.width && this.height == e.height && this.className == e.className;
  }
  /**
  Create a set of rectangles for the given selection range,
  assigning them theclass`className`. Will create a single
  rectangle for empty ranges, and a set of selection-style
  rectangles covering the range's content (in a bidi-aware
  way) for non-empty ones.
  */
  static forRange(e, n, r) {
    if (r.empty) {
      let i = e.coordsAtPos(r.head, r.assoc || 1);
      if (!i)
        return [];
      let s = R6(e);
      return [new wu(n, i.left - s.left, i.top - s.top, null, i.bottom - i.top)];
    } else
      return lq(e, n, r);
  }
}
function R6(t) {
  let e = t.scrollDOM.getBoundingClientRect();
  return { left: (t.textDirection == Qe.LTR ? e.left : e.right - t.scrollDOM.clientWidth * t.scaleX) - t.scrollDOM.scrollLeft * t.scaleX, top: e.top - t.scrollDOM.scrollTop * t.scaleY };
}
function vw(t, e, n, r) {
  let i = t.coordsAtPos(e, n * 2);
  if (!i)
    return r;
  let s = t.dom.getBoundingClientRect(), o = (i.top + i.bottom) / 2, a = t.posAtCoords({ x: s.left + 1, y: o }), l = t.posAtCoords({ x: s.right - 1, y: o });
  return a == null || l == null ? r : { from: Math.max(r.from, Math.min(a, l)), to: Math.min(r.to, Math.max(a, l)) };
}
function lq(t, e, n) {
  if (n.to <= t.viewport.from || n.from >= t.viewport.to)
    return [];
  let r = Math.max(n.from, t.viewport.from), i = Math.min(n.to, t.viewport.to), s = t.textDirection == Qe.LTR, o = t.contentDOM, a = o.getBoundingClientRect(), l = R6(t), c = o.querySelector(".cm-line"), u = c && window.getComputedStyle(c), h = a.left + (u ? parseInt(u.paddingLeft) + Math.min(0, parseInt(u.textIndent)) : 0), f = a.right - (u ? parseInt(u.paddingRight) : 0), d = R0(t, r), p = R0(t, i), m = d.type == tn.Text ? d : null, v = p.type == tn.Text ? p : null;
  if (m && (t.lineWrapping || d.widgetLineBreaks) && (m = vw(t, r, 1, m)), v && (t.lineWrapping || p.widgetLineBreaks) && (v = vw(t, i, -1, v)), m && v && m.from == v.from && m.to == v.to)
    return y(x(n.from, n.to, m));
  {
    let w = m ? x(n.from, null, m) : b(d, !1), k = v ? x(null, n.to, v) : b(p, !0), _ = [];
    return (m || d).to < (v || p).from - (m && v ? 1 : 0) || d.widgetLineBreaks > 1 && w.bottom + t.defaultLineHeight / 2 < k.top ? _.push(g(h, w.bottom, f, k.top)) : w.bottom < k.top && t.elementAtHeight((w.bottom + k.top) / 2).type == tn.Text && (w.bottom = k.top = (w.bottom + k.top) / 2), y(w).concat(_).concat(y(k));
  }
  function g(w, k, _, C) {
    return new wu(
      e,
      w - l.left,
      k - l.top - 0.01,
      _ - w,
      C - k + 0.01
      /* C.Epsilon */
    );
  }
  function y({ top: w, bottom: k, horizontal: _ }) {
    let C = [];
    for (let E = 0; E < _.length; E += 2)
      C.push(g(_[E], w, _[E + 1], k));
    return C;
  }
  function x(w, k, _) {
    let C = 1e9, E = -1e9, L = [];
    function M(R, $, F, U, ee) {
      let ie = t.coordsAtPos(R, R == _.to ? -2 : 2), z = t.coordsAtPos(F, F == _.from ? 2 : -2);
      !ie || !z || (C = Math.min(ie.top, z.top, C), E = Math.max(ie.bottom, z.bottom, E), ee == Qe.LTR ? L.push(s && $ ? h : ie.left, s && U ? f : z.right) : L.push(!s && U ? h : z.left, !s && $ ? f : ie.right));
    }
    let O = w != null ? w : _.from, N = k != null ? k : _.to;
    for (let R of t.visibleRanges)
      if (R.to > O && R.from < N)
        for (let $ = Math.max(R.from, O), F = Math.min(R.to, N); ; ) {
          let U = t.state.doc.lineAt($);
          for (let ee of t.bidiSpans(U)) {
            let ie = ee.from + U.from, z = ee.to + U.from;
            if (ie >= F)
              break;
            z > $ && M(Math.max(ie, $), w == null && ie <= O, Math.min(z, F), k == null && z >= N, ee.dir);
          }
          if ($ = U.to + 1, $ >= F)
            break;
        }
    return L.length == 0 && M(O, w == null, N, k == null, t.textDirection), { top: C, bottom: E, horizontal: L };
  }
  function b(w, k) {
    let _ = a.top + (k ? w.top : w.bottom);
    return { top: _, bottom: _, horizontal: [] };
  }
}
function cq(t, e) {
  return t.constructor == e.constructor && t.eq(e);
}
class uq {
  constructor(e, n) {
    this.view = e, this.layer = n, this.drawn = [], this.scaleX = 1, this.scaleY = 1, this.measureReq = { read: this.measure.bind(this), write: this.draw.bind(this) }, this.dom = e.scrollDOM.appendChild(document.createElement("div")), this.dom.classList.add("cm-layer"), n.above && this.dom.classList.add("cm-layer-above"), n.class && this.dom.classList.add(n.class), this.scale(), this.dom.setAttribute("aria-hidden", "true"), this.setOrder(e.state), e.requestMeasure(this.measureReq), n.mount && n.mount(this.dom, e);
  }
  update(e) {
    e.startState.facet(zf) != e.state.facet(zf) && this.setOrder(e.state), (this.layer.update(e, this.dom) || e.geometryChanged) && (this.scale(), e.view.requestMeasure(this.measureReq));
  }
  docViewUpdate(e) {
    this.layer.updateOnDocViewUpdate !== !1 && e.requestMeasure(this.measureReq);
  }
  setOrder(e) {
    let n = 0, r = e.facet(zf);
    for (; n < r.length && r[n] != this.layer; )
      n++;
    this.dom.style.zIndex = String((this.layer.above ? 150 : -1) - n);
  }
  measure() {
    return this.layer.markers(this.view);
  }
  scale() {
    let { scaleX: e, scaleY: n } = this.view;
    (e != this.scaleX || n != this.scaleY) && (this.scaleX = e, this.scaleY = n, this.dom.style.transform = `scale(${1 / e}, ${1 / n})`);
  }
  draw(e) {
    if (e.length != this.drawn.length || e.some((n, r) => !cq(n, this.drawn[r]))) {
      let n = this.dom.firstChild, r = 0;
      for (let i of e)
        i.update && n && i.constructor && this.drawn[r].constructor && i.update(n, this.drawn[r]) ? (n = n.nextSibling, r++) : this.dom.insertBefore(i.draw(), n);
      for (; n; ) {
        let i = n.nextSibling;
        n.remove(), n = i;
      }
      this.drawn = e;
    }
  }
  destroy() {
    this.layer.destroy && this.layer.destroy(this.dom, this.view), this.dom.remove();
  }
}
const zf = /* @__PURE__ */ ve.define();
function B6(t) {
  return [
    dt.define((e) => new uq(e, t)),
    zf.of(t)
  ];
}
const F6 = !me.ios, Oc = /* @__PURE__ */ ve.define({
  combine(t) {
    return Jr(t, {
      cursorBlinkRate: 1200,
      drawRangeCursor: !0
    }, {
      cursorBlinkRate: (e, n) => Math.min(e, n),
      drawRangeCursor: (e, n) => e || n
    });
  }
});
function fq(t = {}) {
  return [
    Oc.of(t),
    hq,
    dq,
    pq,
    u6.of(!0)
  ];
}
function z6(t) {
  return t.startState.facet(Oc) != t.state.facet(Oc);
}
const hq = /* @__PURE__ */ B6({
  above: !0,
  markers(t) {
    let { state: e } = t, n = e.facet(Oc), r = [];
    for (let i of e.selection.ranges) {
      let s = i == e.selection.main;
      if (i.empty ? !s || F6 : n.drawRangeCursor) {
        let o = s ? "cm-cursor cm-cursor-primary" : "cm-cursor cm-cursor-secondary", a = i.empty ? i : W.cursor(i.head, i.head > i.anchor ? -1 : 1);
        for (let l of wu.forRange(t, o, a))
          r.push(l);
      }
    }
    return r;
  },
  update(t, e) {
    t.transactions.some((r) => r.selection) && (e.style.animationName = e.style.animationName == "cm-blink" ? "cm-blink2" : "cm-blink");
    let n = z6(t);
    return n && yw(t.state, e), t.docChanged || t.selectionSet || n;
  },
  mount(t, e) {
    yw(e.state, t);
  },
  class: "cm-cursorLayer"
});
function yw(t, e) {
  e.style.animationDuration = t.facet(Oc).cursorBlinkRate + "ms";
}
const dq = /* @__PURE__ */ B6({
  above: !1,
  markers(t) {
    return t.state.selection.ranges.map((e) => e.empty ? [] : wu.forRange(t, "cm-selectionBackground", e)).reduce((e, n) => e.concat(n));
  },
  update(t, e) {
    return t.docChanged || t.selectionSet || t.viewportChanged || z6(t);
  },
  class: "cm-selectionLayer"
}), Y0 = {
  ".cm-line": {
    "& ::selection, &::selection": { backgroundColor: "transparent !important" }
  },
  ".cm-content": {
    "& :focus": {
      caretColor: "initial !important",
      "&::selection, & ::selection": {
        backgroundColor: "Highlight !important"
      }
    }
  }
};
F6 && (Y0[".cm-line"].caretColor = Y0[".cm-content"].caretColor = "transparent !important");
const pq = /* @__PURE__ */ $o.highest(/* @__PURE__ */ de.theme(Y0)), V6 = /* @__PURE__ */ De.define({
  map(t, e) {
    return t == null ? null : e.mapPos(t);
  }
}), Vl = /* @__PURE__ */ It.define({
  create() {
    return null;
  },
  update(t, e) {
    return t != null && (t = e.changes.mapPos(t)), e.effects.reduce((n, r) => r.is(V6) ? r.value : n, t);
  }
}), mq = /* @__PURE__ */ dt.fromClass(class {
  constructor(t) {
    this.view = t, this.cursor = null, this.measureReq = { read: this.readPos.bind(this), write: this.drawCursor.bind(this) };
  }
  update(t) {
    var e;
    let n = t.state.field(Vl);
    n == null ? this.cursor != null && ((e = this.cursor) === null || e === void 0 || e.remove(), this.cursor = null) : (this.cursor || (this.cursor = this.view.scrollDOM.appendChild(document.createElement("div")), this.cursor.className = "cm-dropCursor"), (t.startState.field(Vl) != n || t.docChanged || t.geometryChanged) && this.view.requestMeasure(this.measureReq));
  }
  readPos() {
    let { view: t } = this, e = t.state.field(Vl), n = e != null && t.coordsAtPos(e);
    if (!n)
      return null;
    let r = t.scrollDOM.getBoundingClientRect();
    return {
      left: n.left - r.left + t.scrollDOM.scrollLeft * t.scaleX,
      top: n.top - r.top + t.scrollDOM.scrollTop * t.scaleY,
      height: n.bottom - n.top
    };
  }
  drawCursor(t) {
    if (this.cursor) {
      let { scaleX: e, scaleY: n } = this.view;
      t ? (this.cursor.style.left = t.left / e + "px", this.cursor.style.top = t.top / n + "px", this.cursor.style.height = t.height / n + "px") : this.cursor.style.left = "-100000px";
    }
  }
  destroy() {
    this.cursor && this.cursor.remove();
  }
  setDropPos(t) {
    this.view.state.field(Vl) != t && this.view.dispatch({ effects: V6.of(t) });
  }
}, {
  eventObservers: {
    dragover(t) {
      this.setDropPos(this.view.posAtCoords({ x: t.clientX, y: t.clientY }));
    },
    dragleave(t) {
      (t.target == this.view.contentDOM || !this.view.contentDOM.contains(t.relatedTarget)) && this.setDropPos(null);
    },
    dragend() {
      this.setDropPos(null);
    },
    drop() {
      this.setDropPos(null);
    }
  }
});
function gq() {
  return [Vl, mq];
}
function bw(t, e, n, r, i) {
  e.lastIndex = 0;
  for (let s = t.iterRange(n, r), o = n, a; !s.next().done; o += s.value.length)
    if (!s.lineBreak)
      for (; a = e.exec(s.value); )
        i(o + a.index, a);
}
function vq(t, e) {
  let n = t.visibleRanges;
  if (n.length == 1 && n[0].from == t.viewport.from && n[0].to == t.viewport.to)
    return n;
  let r = [];
  for (let { from: i, to: s } of n)
    i = Math.max(t.state.doc.lineAt(i).from, i - e), s = Math.min(t.state.doc.lineAt(s).to, s + e), r.length && r[r.length - 1].to >= i ? r[r.length - 1].to = s : r.push({ from: i, to: s });
  return r;
}
class yq {
  /**
  Create a decorator.
  */
  constructor(e) {
    const { regexp: n, decoration: r, decorate: i, boundary: s, maxLength: o = 1e3 } = e;
    if (!n.global)
      throw new RangeError("The regular expression given to MatchDecorator should have its 'g' flag set");
    if (this.regexp = n, i)
      this.addMatch = (a, l, c, u) => i(u, c, c + a[0].length, a, l);
    else if (typeof r == "function")
      this.addMatch = (a, l, c, u) => {
        let h = r(a, l, c);
        h && u(c, c + a[0].length, h);
      };
    else if (r)
      this.addMatch = (a, l, c, u) => u(c, c + a[0].length, r);
    else
      throw new RangeError("Either 'decorate' or 'decoration' should be provided to MatchDecorator");
    this.boundary = s, this.maxLength = o;
  }
  /**
  Compute the full set of decorations for matches in the given
  view's viewport. You'll want to call this when initializing your
  plugin.
  */
  createDeco(e) {
    let n = new ds(), r = n.add.bind(n);
    for (let { from: i, to: s } of vq(e, this.maxLength))
      bw(e.state.doc, this.regexp, i, s, (o, a) => this.addMatch(a, e, o, r));
    return n.finish();
  }
  /**
  Update a set of decorations for a view update. `deco` _must_ be
  the set of decorations produced by _this_ `MatchDecorator` for
  the view state before the update.
  */
  updateDeco(e, n) {
    let r = 1e9, i = -1;
    return e.docChanged && e.changes.iterChanges((s, o, a, l) => {
      l > e.view.viewport.from && a < e.view.viewport.to && (r = Math.min(a, r), i = Math.max(l, i));
    }), e.viewportChanged || i - r > 1e3 ? this.createDeco(e.view) : i > -1 ? this.updateRange(e.view, n.map(e.changes), r, i) : n;
  }
  updateRange(e, n, r, i) {
    for (let s of e.visibleRanges) {
      let o = Math.max(s.from, r), a = Math.min(s.to, i);
      if (a > o) {
        let l = e.state.doc.lineAt(o), c = l.to < a ? e.state.doc.lineAt(a) : l, u = Math.max(s.from, l.from), h = Math.min(s.to, c.to);
        if (this.boundary) {
          for (; o > l.from; o--)
            if (this.boundary.test(l.text[o - 1 - l.from])) {
              u = o;
              break;
            }
          for (; a < c.to; a++)
            if (this.boundary.test(c.text[a - c.from])) {
              h = a;
              break;
            }
        }
        let f = [], d, p = (m, v, g) => f.push(g.range(m, v));
        if (l == c)
          for (this.regexp.lastIndex = u - l.from; (d = this.regexp.exec(l.text)) && d.index < h - l.from; )
            this.addMatch(d, e, d.index + l.from, p);
        else
          bw(e.state.doc, this.regexp, u, h, (m, v) => this.addMatch(v, e, m, p));
        n = n.update({ filterFrom: u, filterTo: h, filter: (m, v) => m < u || v > h, add: f });
      }
    }
    return n;
  }
}
const W0 = /x/.unicode != null ? "gu" : "g", bq = /* @__PURE__ */ new RegExp(`[\0-\b
--­؜​‎‏\u2028\u2029‭‮⁦⁧⁩\uFEFF￹-￼]`, W0), xq = {
  0: "null",
  7: "bell",
  8: "backspace",
  10: "newline",
  11: "vertical tab",
  13: "carriage return",
  27: "escape",
  8203: "zero width space",
  8204: "zero width non-joiner",
  8205: "zero width joiner",
  8206: "left-to-right mark",
  8207: "right-to-left mark",
  8232: "line separator",
  8237: "left-to-right override",
  8238: "right-to-left override",
  8294: "left-to-right isolate",
  8295: "right-to-left isolate",
  8297: "pop directional isolate",
  8233: "paragraph separator",
  65279: "zero width no-break space",
  65532: "object replacement"
};
let Cm = null;
function wq() {
  var t;
  if (Cm == null && typeof document != "undefined" && document.body) {
    let e = document.body.style;
    Cm = ((t = e.tabSize) !== null && t !== void 0 ? t : e.MozTabSize) != null;
  }
  return Cm || !1;
}
const Vf = /* @__PURE__ */ ve.define({
  combine(t) {
    let e = Jr(t, {
      render: null,
      specialChars: bq,
      addSpecialChars: null
    });
    return (e.replaceTabs = !wq()) && (e.specialChars = new RegExp("	|" + e.specialChars.source, W0)), e.addSpecialChars && (e.specialChars = new RegExp(e.specialChars.source + "|" + e.addSpecialChars.source, W0)), e;
  }
});
function kq(t = {}) {
  return [Vf.of(t), _q()];
}
let xw = null;
function _q() {
  return xw || (xw = dt.fromClass(class {
    constructor(t) {
      this.view = t, this.decorations = we.none, this.decorationCache = /* @__PURE__ */ Object.create(null), this.decorator = this.makeDecorator(t.state.facet(Vf)), this.decorations = this.decorator.createDeco(t);
    }
    makeDecorator(t) {
      return new yq({
        regexp: t.specialChars,
        decoration: (e, n, r) => {
          let { doc: i } = n.state, s = Dt(e[0], 0);
          if (s == 9) {
            let o = i.lineAt(r), a = n.state.tabSize, l = Ua(o.text, a, r - o.from);
            return we.replace({
              widget: new $q((a - l % a) * this.view.defaultCharacterWidth / this.view.scaleX)
            });
          }
          return this.decorationCache[s] || (this.decorationCache[s] = we.replace({ widget: new Cq(t, s) }));
        },
        boundary: t.replaceTabs ? void 0 : /[^]/
      });
    }
    update(t) {
      let e = t.state.facet(Vf);
      t.startState.facet(Vf) != e ? (this.decorator = this.makeDecorator(e), this.decorations = this.decorator.createDeco(t.view)) : this.decorations = this.decorator.updateDeco(t, this.decorations);
    }
  }, {
    decorations: (t) => t.decorations
  }));
}
const Sq = "•";
function Mq(t) {
  return t >= 32 ? Sq : t == 10 ? "␤" : String.fromCharCode(9216 + t);
}
class Cq extends Oi {
  constructor(e, n) {
    super(), this.options = e, this.code = n;
  }
  eq(e) {
    return e.code == this.code;
  }
  toDOM(e) {
    let n = Mq(this.code), r = e.state.phrase("Control character") + " " + (xq[this.code] || "0x" + this.code.toString(16)), i = this.options.render && this.options.render(this.code, r, n);
    if (i)
      return i;
    let s = document.createElement("span");
    return s.textContent = n, s.title = r, s.setAttribute("aria-label", r), s.className = "cm-specialChar", s;
  }
  ignoreEvent() {
    return !1;
  }
}
class $q extends Oi {
  constructor(e) {
    super(), this.width = e;
  }
  eq(e) {
    return e.width == this.width;
  }
  toDOM() {
    let e = document.createElement("span");
    return e.textContent = "	", e.className = "cm-tab", e.style.width = this.width + "px", e;
  }
  ignoreEvent() {
    return !1;
  }
}
function Aq() {
  return Tq;
}
const Dq = /* @__PURE__ */ we.line({ class: "cm-activeLine" }), Tq = /* @__PURE__ */ dt.fromClass(class {
  constructor(t) {
    this.decorations = this.getDeco(t);
  }
  update(t) {
    (t.docChanged || t.selectionSet) && (this.decorations = this.getDeco(t.view));
  }
  getDeco(t) {
    let e = -1, n = [];
    for (let r of t.state.selection.ranges) {
      let i = t.lineBlockAt(r.head);
      i.from > e && (n.push(Dq.range(i.from)), e = i.from);
    }
    return we.set(n);
  }
}, {
  decorations: (t) => t.decorations
});
class Oq extends Oi {
  constructor(e) {
    super(), this.content = e;
  }
  toDOM() {
    let e = document.createElement("span");
    return e.className = "cm-placeholder", e.style.pointerEvents = "none", e.appendChild(typeof this.content == "string" ? document.createTextNode(this.content) : this.content), typeof this.content == "string" ? e.setAttribute("aria-label", "placeholder " + this.content) : e.setAttribute("aria-hidden", "true"), e;
  }
  coordsAt(e) {
    let n = e.firstChild ? Ca(e.firstChild) : [];
    if (!n.length)
      return null;
    let r = window.getComputedStyle(e.parentNode), i = sp(n[0], r.direction != "rtl"), s = parseInt(r.lineHeight);
    return i.bottom - i.top > s * 1.5 ? { left: i.left, right: i.right, top: i.top, bottom: i.top + s } : i;
  }
  ignoreEvent() {
    return !1;
  }
}
function Eq(t) {
  return dt.fromClass(class {
    constructor(e) {
      this.view = e, this.placeholder = t ? we.set([we.widget({ widget: new Oq(t), side: 1 }).range(0)]) : we.none;
    }
    get decorations() {
      return this.view.state.doc.length ? we.none : this.placeholder;
    }
  }, { decorations: (e) => e.decorations });
}
const j0 = 2e3;
function Pq(t, e, n) {
  let r = Math.min(e.line, n.line), i = Math.max(e.line, n.line), s = [];
  if (e.off > j0 || n.off > j0 || e.col < 0 || n.col < 0) {
    let o = Math.min(e.off, n.off), a = Math.max(e.off, n.off);
    for (let l = r; l <= i; l++) {
      let c = t.doc.line(l);
      c.length <= a && s.push(W.range(c.from + o, c.to + a));
    }
  } else {
    let o = Math.min(e.col, n.col), a = Math.max(e.col, n.col);
    for (let l = r; l <= i; l++) {
      let c = t.doc.line(l), u = k0(c.text, o, t.tabSize, !0);
      if (u < 0)
        s.push(W.cursor(c.to));
      else {
        let h = k0(c.text, a, t.tabSize);
        s.push(W.range(c.from + u, c.from + h));
      }
    }
  }
  return s;
}
function Lq(t, e) {
  let n = t.coordsAtPos(t.viewport.from);
  return n ? Math.round(Math.abs((n.left - e) / t.defaultCharacterWidth)) : -1;
}
function ww(t, e) {
  let n = t.posAtCoords({ x: e.clientX, y: e.clientY }, !1), r = t.state.doc.lineAt(n), i = n - r.from, s = i > j0 ? -1 : i == r.length ? Lq(t, e.clientX) : Ua(r.text, t.state.tabSize, n - r.from);
  return { line: r.number, col: s, off: i };
}
function Nq(t, e) {
  let n = ww(t, e), r = t.state.selection;
  return n ? {
    update(i) {
      if (i.docChanged) {
        let s = i.changes.mapPos(i.startState.doc.line(n.line).from), o = i.state.doc.lineAt(s);
        n = { line: o.number, col: n.col, off: Math.min(n.off, o.length) }, r = r.map(i.changes);
      }
    },
    get(i, s, o) {
      let a = ww(t, i);
      if (!a)
        return r;
      let l = Pq(t.state, n, a);
      return l.length ? o ? W.create(l.concat(r.ranges)) : W.create(l) : r;
    }
  } : null;
}
function Iq(t) {
  let e = (n) => n.altKey && n.button == 0;
  return de.mouseSelectionStyle.of((n, r) => e(r) ? Nq(n, r) : null);
}
const Rq = {
  Alt: [18, (t) => !!t.altKey],
  Control: [17, (t) => !!t.ctrlKey],
  Shift: [16, (t) => !!t.shiftKey],
  Meta: [91, (t) => !!t.metaKey]
}, Bq = { style: "cursor: crosshair" };
function Fq(t = {}) {
  let [e, n] = Rq[t.key || "Alt"], r = dt.fromClass(class {
    constructor(i) {
      this.view = i, this.isDown = !1;
    }
    set(i) {
      this.isDown != i && (this.isDown = i, this.view.update([]));
    }
  }, {
    eventObservers: {
      keydown(i) {
        this.set(i.keyCode == e || n(i));
      },
      keyup(i) {
        (i.keyCode == e || !n(i)) && this.set(!1);
      },
      mousemove(i) {
        this.set(n(i));
      }
    }
  });
  return [
    r,
    de.contentAttributes.of((i) => {
      var s;
      return !((s = i.plugin(r)) === null || s === void 0) && s.isDown ? Bq : null;
    })
  ];
}
const gl = "-10000px";
class H6 {
  constructor(e, n, r, i) {
    this.facet = n, this.createTooltipView = r, this.removeTooltipView = i, this.input = e.state.facet(n), this.tooltips = this.input.filter((o) => o);
    let s = null;
    this.tooltipViews = this.tooltips.map((o) => s = r(o, s));
  }
  update(e, n) {
    var r;
    let i = e.state.facet(this.facet), s = i.filter((l) => l);
    if (i === this.input) {
      for (let l of this.tooltipViews)
        l.update && l.update(e);
      return !1;
    }
    let o = [], a = n ? [] : null;
    for (let l = 0; l < s.length; l++) {
      let c = s[l], u = -1;
      if (c) {
        for (let h = 0; h < this.tooltips.length; h++) {
          let f = this.tooltips[h];
          f && f.create == c.create && (u = h);
        }
        if (u < 0)
          o[l] = this.createTooltipView(c, l ? o[l - 1] : null), a && (a[l] = !!c.above);
        else {
          let h = o[l] = this.tooltipViews[u];
          a && (a[l] = n[u]), h.update && h.update(e);
        }
      }
    }
    for (let l of this.tooltipViews)
      o.indexOf(l) < 0 && (this.removeTooltipView(l), (r = l.destroy) === null || r === void 0 || r.call(l));
    return n && (a.forEach((l, c) => n[c] = l), n.length = a.length), this.input = i, this.tooltips = s, this.tooltipViews = o, !0;
  }
}
function zq(t) {
  let { win: e } = t;
  return { top: 0, left: 0, bottom: e.innerHeight, right: e.innerWidth };
}
const $m = /* @__PURE__ */ ve.define({
  combine: (t) => {
    var e, n, r;
    return {
      position: me.ios ? "absolute" : ((e = t.find((i) => i.position)) === null || e === void 0 ? void 0 : e.position) || "fixed",
      parent: ((n = t.find((i) => i.parent)) === null || n === void 0 ? void 0 : n.parent) || null,
      tooltipSpace: ((r = t.find((i) => i.tooltipSpace)) === null || r === void 0 ? void 0 : r.tooltipSpace) || zq
    };
  }
}), kw = /* @__PURE__ */ new WeakMap(), X1 = /* @__PURE__ */ dt.fromClass(class {
  constructor(t) {
    this.view = t, this.above = [], this.inView = !0, this.madeAbsolute = !1, this.lastTransaction = 0, this.measureTimeout = -1;
    let e = t.state.facet($m);
    this.position = e.position, this.parent = e.parent, this.classes = t.themeClasses, this.createContainer(), this.measureReq = { read: this.readMeasure.bind(this), write: this.writeMeasure.bind(this), key: this }, this.resizeObserver = typeof ResizeObserver == "function" ? new ResizeObserver(() => this.measureSoon()) : null, this.manager = new H6(t, Z1, (n, r) => this.createTooltip(n, r), (n) => {
      this.resizeObserver && this.resizeObserver.unobserve(n.dom), n.dom.remove();
    }), this.above = this.manager.tooltips.map((n) => !!n.above), this.intersectionObserver = typeof IntersectionObserver == "function" ? new IntersectionObserver((n) => {
      Date.now() > this.lastTransaction - 50 && n.length > 0 && n[n.length - 1].intersectionRatio < 1 && this.measureSoon();
    }, { threshold: [1] }) : null, this.observeIntersection(), t.win.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this)), this.maybeMeasure();
  }
  createContainer() {
    this.parent ? (this.container = document.createElement("div"), this.container.style.position = "relative", this.container.className = this.view.themeClasses, this.parent.appendChild(this.container)) : this.container = this.view.dom;
  }
  observeIntersection() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      for (let t of this.manager.tooltipViews)
        this.intersectionObserver.observe(t.dom);
    }
  }
  measureSoon() {
    this.measureTimeout < 0 && (this.measureTimeout = setTimeout(() => {
      this.measureTimeout = -1, this.maybeMeasure();
    }, 50));
  }
  update(t) {
    t.transactions.length && (this.lastTransaction = Date.now());
    let e = this.manager.update(t, this.above);
    e && this.observeIntersection();
    let n = e || t.geometryChanged, r = t.state.facet($m);
    if (r.position != this.position && !this.madeAbsolute) {
      this.position = r.position;
      for (let i of this.manager.tooltipViews)
        i.dom.style.position = this.position;
      n = !0;
    }
    if (r.parent != this.parent) {
      this.parent && this.container.remove(), this.parent = r.parent, this.createContainer();
      for (let i of this.manager.tooltipViews)
        this.container.appendChild(i.dom);
      n = !0;
    } else this.parent && this.view.themeClasses != this.classes && (this.classes = this.container.className = this.view.themeClasses);
    n && this.maybeMeasure();
  }
  createTooltip(t, e) {
    let n = t.create(this.view), r = e ? e.dom : null;
    if (n.dom.classList.add("cm-tooltip"), t.arrow && !n.dom.querySelector(".cm-tooltip > .cm-tooltip-arrow")) {
      let i = document.createElement("div");
      i.className = "cm-tooltip-arrow", n.dom.appendChild(i);
    }
    return n.dom.style.position = this.position, n.dom.style.top = gl, n.dom.style.left = "0px", this.container.insertBefore(n.dom, r), n.mount && n.mount(this.view), this.resizeObserver && this.resizeObserver.observe(n.dom), n;
  }
  destroy() {
    var t, e, n;
    this.view.win.removeEventListener("resize", this.measureSoon);
    for (let r of this.manager.tooltipViews)
      r.dom.remove(), (t = r.destroy) === null || t === void 0 || t.call(r);
    this.parent && this.container.remove(), (e = this.resizeObserver) === null || e === void 0 || e.disconnect(), (n = this.intersectionObserver) === null || n === void 0 || n.disconnect(), clearTimeout(this.measureTimeout);
  }
  readMeasure() {
    let t = this.view.dom.getBoundingClientRect(), e = 1, n = 1, r = !1;
    if (this.position == "fixed" && this.manager.tooltipViews.length) {
      let { dom: i } = this.manager.tooltipViews[0];
      if (me.gecko)
        r = i.offsetParent != this.container.ownerDocument.body;
      else if (i.style.top == gl && i.style.left == "0px") {
        let s = i.getBoundingClientRect();
        r = Math.abs(s.top + 1e4) > 1 || Math.abs(s.left) > 1;
      }
    }
    if (r || this.position == "absolute")
      if (this.parent) {
        let i = this.parent.getBoundingClientRect();
        i.width && i.height && (e = i.width / this.parent.offsetWidth, n = i.height / this.parent.offsetHeight);
      } else
        ({ scaleX: e, scaleY: n } = this.view.viewState);
    return {
      editor: t,
      parent: this.parent ? this.container.getBoundingClientRect() : t,
      pos: this.manager.tooltips.map((i, s) => {
        let o = this.manager.tooltipViews[s];
        return o.getCoords ? o.getCoords(i.pos) : this.view.coordsAtPos(i.pos);
      }),
      size: this.manager.tooltipViews.map(({ dom: i }) => i.getBoundingClientRect()),
      space: this.view.state.facet($m).tooltipSpace(this.view),
      scaleX: e,
      scaleY: n,
      makeAbsolute: r
    };
  }
  writeMeasure(t) {
    var e;
    if (t.makeAbsolute) {
      this.madeAbsolute = !0, this.position = "absolute";
      for (let a of this.manager.tooltipViews)
        a.dom.style.position = "absolute";
    }
    let { editor: n, space: r, scaleX: i, scaleY: s } = t, o = [];
    for (let a = 0; a < this.manager.tooltips.length; a++) {
      let l = this.manager.tooltips[a], c = this.manager.tooltipViews[a], { dom: u } = c, h = t.pos[a], f = t.size[a];
      if (!h || h.bottom <= Math.max(n.top, r.top) || h.top >= Math.min(n.bottom, r.bottom) || h.right < Math.max(n.left, r.left) - 0.1 || h.left > Math.min(n.right, r.right) + 0.1) {
        u.style.top = gl;
        continue;
      }
      let d = l.arrow ? c.dom.querySelector(".cm-tooltip-arrow") : null, p = d ? 7 : 0, m = f.right - f.left, v = (e = kw.get(c)) !== null && e !== void 0 ? e : f.bottom - f.top, g = c.offset || Hq, y = this.view.textDirection == Qe.LTR, x = f.width > r.right - r.left ? y ? r.left : r.right - f.width : y ? Math.min(h.left - (d ? 14 : 0) + g.x, r.right - m) : Math.max(r.left, h.left - m + (d ? 14 : 0) - g.x), b = this.above[a];
      !l.strictSide && (b ? h.top - (f.bottom - f.top) - g.y < r.top : h.bottom + (f.bottom - f.top) + g.y > r.bottom) && b == r.bottom - h.bottom > h.top - r.top && (b = this.above[a] = !b);
      let w = (b ? h.top - r.top : r.bottom - h.bottom) - p;
      if (w < v && c.resize !== !1) {
        if (w < this.view.defaultLineHeight) {
          u.style.top = gl;
          continue;
        }
        kw.set(c, v), u.style.height = (v = w) / s + "px";
      } else u.style.height && (u.style.height = "");
      let k = b ? h.top - v - p - g.y : h.bottom + p + g.y, _ = x + m;
      if (c.overlap !== !0)
        for (let C of o)
          C.left < _ && C.right > x && C.top < k + v && C.bottom > k && (k = b ? C.top - v - 2 - p : C.bottom + p + 2);
      if (this.position == "absolute" ? (u.style.top = (k - t.parent.top) / s + "px", u.style.left = (x - t.parent.left) / i + "px") : (u.style.top = k / s + "px", u.style.left = x / i + "px"), d) {
        let C = h.left + (y ? g.x : -g.x) - (x + 14 - 7);
        d.style.left = C / i + "px";
      }
      c.overlap !== !0 && o.push({ left: x, top: k, right: _, bottom: k + v }), u.classList.toggle("cm-tooltip-above", b), u.classList.toggle("cm-tooltip-below", !b), c.positioned && c.positioned(t.space);
    }
  }
  maybeMeasure() {
    if (this.manager.tooltips.length && (this.view.inView && this.view.requestMeasure(this.measureReq), this.inView != this.view.inView && (this.inView = this.view.inView, !this.inView)))
      for (let t of this.manager.tooltipViews)
        t.dom.style.top = gl;
  }
}, {
  eventObservers: {
    scroll() {
      this.maybeMeasure();
    }
  }
}), Vq = /* @__PURE__ */ de.baseTheme({
  ".cm-tooltip": {
    zIndex: 100,
    boxSizing: "border-box"
  },
  "&light .cm-tooltip": {
    border: "1px solid #bbb",
    backgroundColor: "#f5f5f5"
  },
  "&light .cm-tooltip-section:not(:first-child)": {
    borderTop: "1px solid #bbb"
  },
  "&dark .cm-tooltip": {
    backgroundColor: "#333338",
    color: "white"
  },
  ".cm-tooltip-arrow": {
    height: "7px",
    width: `${7 * 2}px`,
    position: "absolute",
    zIndex: -1,
    overflow: "hidden",
    "&:before, &:after": {
      content: "''",
      position: "absolute",
      width: 0,
      height: 0,
      borderLeft: "7px solid transparent",
      borderRight: "7px solid transparent"
    },
    ".cm-tooltip-above &": {
      bottom: "-7px",
      "&:before": {
        borderTop: "7px solid #bbb"
      },
      "&:after": {
        borderTop: "7px solid #f5f5f5",
        bottom: "1px"
      }
    },
    ".cm-tooltip-below &": {
      top: "-7px",
      "&:before": {
        borderBottom: "7px solid #bbb"
      },
      "&:after": {
        borderBottom: "7px solid #f5f5f5",
        top: "1px"
      }
    }
  },
  "&dark .cm-tooltip .cm-tooltip-arrow": {
    "&:before": {
      borderTopColor: "#333338",
      borderBottomColor: "#333338"
    },
    "&:after": {
      borderTopColor: "transparent",
      borderBottomColor: "transparent"
    }
  }
}), Hq = { x: 0, y: 0 }, Z1 = /* @__PURE__ */ ve.define({
  enables: [X1, Vq]
}), Yh = /* @__PURE__ */ ve.define({
  combine: (t) => t.reduce((e, n) => e.concat(n), [])
});
class lp {
  // Needs to be static so that host tooltip instances always match
  static create(e) {
    return new lp(e);
  }
  constructor(e) {
    this.view = e, this.mounted = !1, this.dom = document.createElement("div"), this.dom.classList.add("cm-tooltip-hover"), this.manager = new H6(e, Yh, (n, r) => this.createHostedView(n, r), (n) => n.dom.remove());
  }
  createHostedView(e, n) {
    let r = e.create(this.view);
    return r.dom.classList.add("cm-tooltip-section"), this.dom.insertBefore(r.dom, n ? n.dom.nextSibling : this.dom.firstChild), this.mounted && r.mount && r.mount(this.view), r;
  }
  mount(e) {
    for (let n of this.manager.tooltipViews)
      n.mount && n.mount(e);
    this.mounted = !0;
  }
  positioned(e) {
    for (let n of this.manager.tooltipViews)
      n.positioned && n.positioned(e);
  }
  update(e) {
    this.manager.update(e);
  }
  destroy() {
    var e;
    for (let n of this.manager.tooltipViews)
      (e = n.destroy) === null || e === void 0 || e.call(n);
  }
  passProp(e) {
    let n;
    for (let r of this.manager.tooltipViews) {
      let i = r[e];
      if (i !== void 0) {
        if (n === void 0)
          n = i;
        else if (n !== i)
          return;
      }
    }
    return n;
  }
  get offset() {
    return this.passProp("offset");
  }
  get getCoords() {
    return this.passProp("getCoords");
  }
  get overlap() {
    return this.passProp("overlap");
  }
  get resize() {
    return this.passProp("resize");
  }
}
const Yq = /* @__PURE__ */ Z1.compute([Yh], (t) => {
  let e = t.facet(Yh);
  return e.length === 0 ? null : {
    pos: Math.min(...e.map((n) => n.pos)),
    end: Math.max(...e.map((n) => {
      var r;
      return (r = n.end) !== null && r !== void 0 ? r : n.pos;
    })),
    create: lp.create,
    above: e[0].above,
    arrow: e.some((n) => n.arrow)
  };
});
class Wq {
  constructor(e, n, r, i, s) {
    this.view = e, this.source = n, this.field = r, this.setHover = i, this.hoverTime = s, this.hoverTimeout = -1, this.restartTimeout = -1, this.pending = null, this.lastMove = { x: 0, y: 0, target: e.dom, time: 0 }, this.checkHover = this.checkHover.bind(this), e.dom.addEventListener("mouseleave", this.mouseleave = this.mouseleave.bind(this)), e.dom.addEventListener("mousemove", this.mousemove = this.mousemove.bind(this));
  }
  update() {
    this.pending && (this.pending = null, clearTimeout(this.restartTimeout), this.restartTimeout = setTimeout(() => this.startHover(), 20));
  }
  get active() {
    return this.view.state.field(this.field);
  }
  checkHover() {
    if (this.hoverTimeout = -1, this.active.length)
      return;
    let e = Date.now() - this.lastMove.time;
    e < this.hoverTime ? this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime - e) : this.startHover();
  }
  startHover() {
    clearTimeout(this.restartTimeout);
    let { view: e, lastMove: n } = this, r = e.docView.nearest(n.target);
    if (!r)
      return;
    let i, s = 1;
    if (r instanceof Qi)
      i = r.posAtStart;
    else {
      if (i = e.posAtCoords(n), i == null)
        return;
      let a = e.coordsAtPos(i);
      if (!a || n.y < a.top || n.y > a.bottom || n.x < a.left - e.defaultCharacterWidth || n.x > a.right + e.defaultCharacterWidth)
        return;
      let l = e.bidiSpans(e.state.doc.lineAt(i)).find((u) => u.from <= i && u.to >= i), c = l && l.dir == Qe.RTL ? -1 : 1;
      s = n.x < a.left ? -c : c;
    }
    let o = this.source(e, i, s);
    if (o != null && o.then) {
      let a = this.pending = { pos: i };
      o.then((l) => {
        this.pending == a && (this.pending = null, l && !(Array.isArray(l) && !l.length) && e.dispatch({ effects: this.setHover.of(Array.isArray(l) ? l : [l]) }));
      }, (l) => un(e.state, l, "hover tooltip"));
    } else o && !(Array.isArray(o) && !o.length) && e.dispatch({ effects: this.setHover.of(Array.isArray(o) ? o : [o]) });
  }
  get tooltip() {
    let e = this.view.plugin(X1), n = e ? e.manager.tooltips.findIndex((r) => r.create == lp.create) : -1;
    return n > -1 ? e.manager.tooltipViews[n] : null;
  }
  mousemove(e) {
    var n, r;
    this.lastMove = { x: e.clientX, y: e.clientY, target: e.target, time: Date.now() }, this.hoverTimeout < 0 && (this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime));
    let { active: i, tooltip: s } = this;
    if (i.length && s && !jq(s.dom, e) || this.pending) {
      let { pos: o } = i[0] || this.pending, a = (r = (n = i[0]) === null || n === void 0 ? void 0 : n.end) !== null && r !== void 0 ? r : o;
      (o == a ? this.view.posAtCoords(this.lastMove) != o : !qq(this.view, o, a, e.clientX, e.clientY)) && (this.view.dispatch({ effects: this.setHover.of([]) }), this.pending = null);
    }
  }
  mouseleave(e) {
    clearTimeout(this.hoverTimeout), this.hoverTimeout = -1;
    let { active: n } = this;
    if (n.length) {
      let { tooltip: r } = this;
      r && r.dom.contains(e.relatedTarget) ? this.watchTooltipLeave(r.dom) : this.view.dispatch({ effects: this.setHover.of([]) });
    }
  }
  watchTooltipLeave(e) {
    let n = (r) => {
      e.removeEventListener("mouseleave", n), this.active.length && !this.view.dom.contains(r.relatedTarget) && this.view.dispatch({ effects: this.setHover.of([]) });
    };
    e.addEventListener("mouseleave", n);
  }
  destroy() {
    clearTimeout(this.hoverTimeout), this.view.dom.removeEventListener("mouseleave", this.mouseleave), this.view.dom.removeEventListener("mousemove", this.mousemove);
  }
}
const uf = 4;
function jq(t, e) {
  let n = t.getBoundingClientRect();
  return e.clientX >= n.left - uf && e.clientX <= n.right + uf && e.clientY >= n.top - uf && e.clientY <= n.bottom + uf;
}
function qq(t, e, n, r, i, s) {
  let o = t.scrollDOM.getBoundingClientRect(), a = t.documentTop + t.documentPadding.top + t.contentHeight;
  if (o.left > r || o.right < r || o.top > i || Math.min(o.bottom, a) < i)
    return !1;
  let l = t.posAtCoords({ x: r, y: i }, !1);
  return l >= e && l <= n;
}
function Uq(t, e = {}) {
  let n = De.define(), r = It.define({
    create() {
      return [];
    },
    update(i, s) {
      if (i.length && (e.hideOnChange && (s.docChanged || s.selection) ? i = [] : e.hideOn && (i = i.filter((o) => !e.hideOn(s, o))), s.docChanged)) {
        let o = [];
        for (let a of i) {
          let l = s.changes.mapPos(a.pos, -1, Qt.TrackDel);
          if (l != null) {
            let c = Object.assign(/* @__PURE__ */ Object.create(null), a);
            c.pos = l, c.end != null && (c.end = s.changes.mapPos(c.end)), o.push(c);
          }
        }
        i = o;
      }
      for (let o of s.effects)
        o.is(n) && (i = o.value), o.is(Kq) && (i = []);
      return i;
    },
    provide: (i) => Yh.from(i)
  });
  return [
    r,
    dt.define((i) => new Wq(
      i,
      t,
      r,
      n,
      e.hoverTime || 300
      /* Hover.Time */
    )),
    Yq
  ];
}
function Y6(t, e) {
  let n = t.plugin(X1);
  if (!n)
    return null;
  let r = n.manager.tooltips.indexOf(e);
  return r < 0 ? null : n.manager.tooltipViews[r];
}
const Kq = /* @__PURE__ */ De.define(), _w = /* @__PURE__ */ ve.define({
  combine(t) {
    let e, n;
    for (let r of t)
      e = e || r.topContainer, n = n || r.bottomContainer;
    return { topContainer: e, bottomContainer: n };
  }
});
function Ec(t, e) {
  let n = t.plugin(W6), r = n ? n.specs.indexOf(e) : -1;
  return r > -1 ? n.panels[r] : null;
}
const W6 = /* @__PURE__ */ dt.fromClass(class {
  constructor(t) {
    this.input = t.state.facet(Pc), this.specs = this.input.filter((n) => n), this.panels = this.specs.map((n) => n(t));
    let e = t.state.facet(_w);
    this.top = new ff(t, !0, e.topContainer), this.bottom = new ff(t, !1, e.bottomContainer), this.top.sync(this.panels.filter((n) => n.top)), this.bottom.sync(this.panels.filter((n) => !n.top));
    for (let n of this.panels)
      n.dom.classList.add("cm-panel"), n.mount && n.mount();
  }
  update(t) {
    let e = t.state.facet(_w);
    this.top.container != e.topContainer && (this.top.sync([]), this.top = new ff(t.view, !0, e.topContainer)), this.bottom.container != e.bottomContainer && (this.bottom.sync([]), this.bottom = new ff(t.view, !1, e.bottomContainer)), this.top.syncClasses(), this.bottom.syncClasses();
    let n = t.state.facet(Pc);
    if (n != this.input) {
      let r = n.filter((l) => l), i = [], s = [], o = [], a = [];
      for (let l of r) {
        let c = this.specs.indexOf(l), u;
        c < 0 ? (u = l(t.view), a.push(u)) : (u = this.panels[c], u.update && u.update(t)), i.push(u), (u.top ? s : o).push(u);
      }
      this.specs = r, this.panels = i, this.top.sync(s), this.bottom.sync(o);
      for (let l of a)
        l.dom.classList.add("cm-panel"), l.mount && l.mount();
    } else
      for (let r of this.panels)
        r.update && r.update(t);
  }
  destroy() {
    this.top.sync([]), this.bottom.sync([]);
  }
}, {
  provide: (t) => de.scrollMargins.of((e) => {
    let n = e.plugin(t);
    return n && { top: n.top.scrollMargin(), bottom: n.bottom.scrollMargin() };
  })
});
class ff {
  constructor(e, n, r) {
    this.view = e, this.top = n, this.container = r, this.dom = void 0, this.classes = "", this.panels = [], this.syncClasses();
  }
  sync(e) {
    for (let n of this.panels)
      n.destroy && e.indexOf(n) < 0 && n.destroy();
    this.panels = e, this.syncDOM();
  }
  syncDOM() {
    if (this.panels.length == 0) {
      this.dom && (this.dom.remove(), this.dom = void 0);
      return;
    }
    if (!this.dom) {
      this.dom = document.createElement("div"), this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom", this.dom.style[this.top ? "top" : "bottom"] = "0";
      let n = this.container || this.view.dom;
      n.insertBefore(this.dom, this.top ? n.firstChild : null);
    }
    let e = this.dom.firstChild;
    for (let n of this.panels)
      if (n.dom.parentNode == this.dom) {
        for (; e != n.dom; )
          e = Sw(e);
        e = e.nextSibling;
      } else
        this.dom.insertBefore(n.dom, e);
    for (; e; )
      e = Sw(e);
  }
  scrollMargin() {
    return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
  }
  syncClasses() {
    if (!(!this.container || this.classes == this.view.themeClasses)) {
      for (let e of this.classes.split(" "))
        e && this.container.classList.remove(e);
      for (let e of (this.classes = this.view.themeClasses).split(" "))
        e && this.container.classList.add(e);
    }
  }
}
function Sw(t) {
  let e = t.nextSibling;
  return t.remove(), e;
}
const Pc = /* @__PURE__ */ ve.define({
  enables: W6
});
class Si extends po {
  /**
  @internal
  */
  compare(e) {
    return this == e || this.constructor == e.constructor && this.eq(e);
  }
  /**
  Compare this marker to another marker of the same type.
  */
  eq(e) {
    return !1;
  }
  /**
  Called if the marker has a `toDOM` method and its representation
  was removed from a gutter.
  */
  destroy(e) {
  }
}
Si.prototype.elementClass = "";
Si.prototype.toDOM = void 0;
Si.prototype.mapMode = Qt.TrackBefore;
Si.prototype.startSide = Si.prototype.endSide = -1;
Si.prototype.point = !0;
const Hf = /* @__PURE__ */ ve.define(), Gq = {
  class: "",
  renderEmptyElements: !1,
  elementStyle: "",
  markers: () => Be.empty,
  lineMarker: () => null,
  widgetMarker: () => null,
  lineMarkerChange: null,
  initialSpacer: null,
  updateSpacer: null,
  domEventHandlers: {}
}, sc = /* @__PURE__ */ ve.define();
function Xq(t) {
  return [j6(), sc.of(Object.assign(Object.assign({}, Gq), t))];
}
const Mw = /* @__PURE__ */ ve.define({
  combine: (t) => t.some((e) => e)
});
function j6(t) {
  return [
    Zq
  ];
}
const Zq = /* @__PURE__ */ dt.fromClass(class {
  constructor(t) {
    this.view = t, this.prevViewport = t.viewport, this.dom = document.createElement("div"), this.dom.className = "cm-gutters", this.dom.setAttribute("aria-hidden", "true"), this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px", this.gutters = t.state.facet(sc).map((e) => new $w(t, e));
    for (let e of this.gutters)
      this.dom.appendChild(e.dom);
    this.fixed = !t.state.facet(Mw), this.fixed && (this.dom.style.position = "sticky"), this.syncGutters(!1), t.scrollDOM.insertBefore(this.dom, t.contentDOM);
  }
  update(t) {
    if (this.updateGutters(t)) {
      let e = this.prevViewport, n = t.view.viewport, r = Math.min(e.to, n.to) - Math.max(e.from, n.from);
      this.syncGutters(r < (n.to - n.from) * 0.8);
    }
    t.geometryChanged && (this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px"), this.view.state.facet(Mw) != !this.fixed && (this.fixed = !this.fixed, this.dom.style.position = this.fixed ? "sticky" : ""), this.prevViewport = t.view.viewport;
  }
  syncGutters(t) {
    let e = this.dom.nextSibling;
    t && this.dom.remove();
    let n = Be.iter(this.view.state.facet(Hf), this.view.viewport.from), r = [], i = this.gutters.map((s) => new Jq(s, this.view.viewport, -this.view.documentPadding.top));
    for (let s of this.view.viewportLineBlocks)
      if (r.length && (r = []), Array.isArray(s.type)) {
        let o = !0;
        for (let a of s.type)
          if (a.type == tn.Text && o) {
            q0(n, r, a.from);
            for (let l of i)
              l.line(this.view, a, r);
            o = !1;
          } else if (a.widget)
            for (let l of i)
              l.widget(this.view, a);
      } else if (s.type == tn.Text) {
        q0(n, r, s.from);
        for (let o of i)
          o.line(this.view, s, r);
      } else if (s.widget)
        for (let o of i)
          o.widget(this.view, s);
    for (let s of i)
      s.finish();
    t && this.view.scrollDOM.insertBefore(this.dom, e);
  }
  updateGutters(t) {
    let e = t.startState.facet(sc), n = t.state.facet(sc), r = t.docChanged || t.heightChanged || t.viewportChanged || !Be.eq(t.startState.facet(Hf), t.state.facet(Hf), t.view.viewport.from, t.view.viewport.to);
    if (e == n)
      for (let i of this.gutters)
        i.update(t) && (r = !0);
    else {
      r = !0;
      let i = [];
      for (let s of n) {
        let o = e.indexOf(s);
        o < 0 ? i.push(new $w(this.view, s)) : (this.gutters[o].update(t), i.push(this.gutters[o]));
      }
      for (let s of this.gutters)
        s.dom.remove(), i.indexOf(s) < 0 && s.destroy();
      for (let s of i)
        this.dom.appendChild(s.dom);
      this.gutters = i;
    }
    return r;
  }
  destroy() {
    for (let t of this.gutters)
      t.destroy();
    this.dom.remove();
  }
}, {
  provide: (t) => de.scrollMargins.of((e) => {
    let n = e.plugin(t);
    return !n || n.gutters.length == 0 || !n.fixed ? null : e.textDirection == Qe.LTR ? { left: n.dom.offsetWidth * e.scaleX } : { right: n.dom.offsetWidth * e.scaleX };
  })
});
function Cw(t) {
  return Array.isArray(t) ? t : [t];
}
function q0(t, e, n) {
  for (; t.value && t.from <= n; )
    t.from == n && e.push(t.value), t.next();
}
class Jq {
  constructor(e, n, r) {
    this.gutter = e, this.height = r, this.i = 0, this.cursor = Be.iter(e.markers, n.from);
  }
  addElement(e, n, r) {
    let { gutter: i } = this, s = (n.top - this.height) / e.scaleY, o = n.height / e.scaleY;
    if (this.i == i.elements.length) {
      let a = new q6(e, o, s, r);
      i.elements.push(a), i.dom.appendChild(a.dom);
    } else
      i.elements[this.i].update(e, o, s, r);
    this.height = n.bottom, this.i++;
  }
  line(e, n, r) {
    let i = [];
    q0(this.cursor, i, n.from), r.length && (i = i.concat(r));
    let s = this.gutter.config.lineMarker(e, n, i);
    s && i.unshift(s);
    let o = this.gutter;
    i.length == 0 && !o.config.renderEmptyElements || this.addElement(e, n, i);
  }
  widget(e, n) {
    let r = this.gutter.config.widgetMarker(e, n.widget, n);
    r && this.addElement(e, n, [r]);
  }
  finish() {
    let e = this.gutter;
    for (; e.elements.length > this.i; ) {
      let n = e.elements.pop();
      e.dom.removeChild(n.dom), n.destroy();
    }
  }
}
class $w {
  constructor(e, n) {
    this.view = e, this.config = n, this.elements = [], this.spacer = null, this.dom = document.createElement("div"), this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
    for (let r in n.domEventHandlers)
      this.dom.addEventListener(r, (i) => {
        let s = i.target, o;
        if (s != this.dom && this.dom.contains(s)) {
          for (; s.parentNode != this.dom; )
            s = s.parentNode;
          let l = s.getBoundingClientRect();
          o = (l.top + l.bottom) / 2;
        } else
          o = i.clientY;
        let a = e.lineBlockAtHeight(o - e.documentTop);
        n.domEventHandlers[r](e, a, i) && i.preventDefault();
      });
    this.markers = Cw(n.markers(e)), n.initialSpacer && (this.spacer = new q6(e, 0, 0, [n.initialSpacer(e)]), this.dom.appendChild(this.spacer.dom), this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none");
  }
  update(e) {
    let n = this.markers;
    if (this.markers = Cw(this.config.markers(e.view)), this.spacer && this.config.updateSpacer) {
      let i = this.config.updateSpacer(this.spacer.markers[0], e);
      i != this.spacer.markers[0] && this.spacer.update(e.view, 0, 0, [i]);
    }
    let r = e.view.viewport;
    return !Be.eq(this.markers, n, r.from, r.to) || (this.config.lineMarkerChange ? this.config.lineMarkerChange(e) : !1);
  }
  destroy() {
    for (let e of this.elements)
      e.destroy();
  }
}
class q6 {
  constructor(e, n, r, i) {
    this.height = -1, this.above = 0, this.markers = [], this.dom = document.createElement("div"), this.dom.className = "cm-gutterElement", this.update(e, n, r, i);
  }
  update(e, n, r, i) {
    this.height != n && (this.height = n, this.dom.style.height = n + "px"), this.above != r && (this.dom.style.marginTop = (this.above = r) ? r + "px" : ""), Qq(this.markers, i) || this.setMarkers(e, i);
  }
  setMarkers(e, n) {
    let r = "cm-gutterElement", i = this.dom.firstChild;
    for (let s = 0, o = 0; ; ) {
      let a = o, l = s < n.length ? n[s++] : null, c = !1;
      if (l) {
        let u = l.elementClass;
        u && (r += " " + u);
        for (let h = o; h < this.markers.length; h++)
          if (this.markers[h].compare(l)) {
            a = h, c = !0;
            break;
          }
      } else
        a = this.markers.length;
      for (; o < a; ) {
        let u = this.markers[o++];
        if (u.toDOM) {
          u.destroy(i);
          let h = i.nextSibling;
          i.remove(), i = h;
        }
      }
      if (!l)
        break;
      l.toDOM && (c ? i = i.nextSibling : this.dom.insertBefore(l.toDOM(e), i)), c && o++;
    }
    this.dom.className = r, this.markers = n;
  }
  destroy() {
    this.setMarkers(null, []);
  }
}
function Qq(t, e) {
  if (t.length != e.length)
    return !1;
  for (let n = 0; n < t.length; n++)
    if (!t[n].compare(e[n]))
      return !1;
  return !0;
}
const eU = /* @__PURE__ */ ve.define(), qo = /* @__PURE__ */ ve.define({
  combine(t) {
    return Jr(t, { formatNumber: String, domEventHandlers: {} }, {
      domEventHandlers(e, n) {
        let r = Object.assign({}, e);
        for (let i in n) {
          let s = r[i], o = n[i];
          r[i] = s ? (a, l, c) => s(a, l, c) || o(a, l, c) : o;
        }
        return r;
      }
    });
  }
});
class Am extends Si {
  constructor(e) {
    super(), this.number = e;
  }
  eq(e) {
    return this.number == e.number;
  }
  toDOM() {
    return document.createTextNode(this.number);
  }
}
function Dm(t, e) {
  return t.state.facet(qo).formatNumber(e, t.state);
}
const tU = /* @__PURE__ */ sc.compute([qo], (t) => ({
  class: "cm-lineNumbers",
  renderEmptyElements: !1,
  markers(e) {
    return e.state.facet(eU);
  },
  lineMarker(e, n, r) {
    return r.some((i) => i.toDOM) ? null : new Am(Dm(e, e.state.doc.lineAt(n.from).number));
  },
  widgetMarker: () => null,
  lineMarkerChange: (e) => e.startState.facet(qo) != e.state.facet(qo),
  initialSpacer(e) {
    return new Am(Dm(e, Aw(e.state.doc.lines)));
  },
  updateSpacer(e, n) {
    let r = Dm(n.view, Aw(n.view.state.doc.lines));
    return r == e.number ? e : new Am(r);
  },
  domEventHandlers: t.facet(qo).domEventHandlers
}));
function nU(t = {}) {
  return [
    qo.of(t),
    j6(),
    tU
  ];
}
function Aw(t) {
  let e = 9;
  for (; e < t; )
    e = e * 10 + 9;
  return e;
}
const rU = /* @__PURE__ */ new class extends Si {
  constructor() {
    super(...arguments), this.elementClass = "cm-activeLineGutter";
  }
}(), iU = /* @__PURE__ */ Hf.compute(["selection"], (t) => {
  let e = [], n = -1;
  for (let r of t.selection.ranges) {
    let i = t.doc.lineAt(r.head).from;
    i > n && (n = i, e.push(rU.range(i)));
  }
  return Be.of(e);
});
function sU() {
  return iU;
}
const oU = 1024;
let aU = 0;
class Tm {
  constructor(e, n) {
    this.from = e, this.to = n;
  }
}
class Ne {
  /**
  Create a new node prop type.
  */
  constructor(e = {}) {
    this.id = aU++, this.perNode = !!e.perNode, this.deserialize = e.deserialize || (() => {
      throw new Error("This node type doesn't define a deserialize function");
    });
  }
  /**
  This is meant to be used with
  [`NodeSet.extend`](#common.NodeSet.extend) or
  [`LRParser.configure`](#lr.ParserConfig.props) to compute
  prop values for each node type in the set. Takes a [match
  object](#common.NodeType^match) or function that returns undefined
  if the node type doesn't get this prop, and the prop's value if
  it does.
  */
  add(e) {
    if (this.perNode)
      throw new RangeError("Can't add per-node props to node types");
    return typeof e != "function" && (e = Qn.match(e)), (n) => {
      let r = e(n);
      return r === void 0 ? null : [this, r];
    };
  }
}
Ne.closedBy = new Ne({ deserialize: (t) => t.split(" ") });
Ne.openedBy = new Ne({ deserialize: (t) => t.split(" ") });
Ne.group = new Ne({ deserialize: (t) => t.split(" ") });
Ne.isolate = new Ne({ deserialize: (t) => {
  if (t && t != "rtl" && t != "ltr" && t != "auto")
    throw new RangeError("Invalid value for isolate: " + t);
  return t || "auto";
} });
Ne.contextHash = new Ne({ perNode: !0 });
Ne.lookAhead = new Ne({ perNode: !0 });
Ne.mounted = new Ne({ perNode: !0 });
class Wh {
  constructor(e, n, r) {
    this.tree = e, this.overlay = n, this.parser = r;
  }
  /**
  @internal
  */
  static get(e) {
    return e && e.props && e.props[Ne.mounted.id];
  }
}
const lU = /* @__PURE__ */ Object.create(null);
class Qn {
  /**
  @internal
  */
  constructor(e, n, r, i = 0) {
    this.name = e, this.props = n, this.id = r, this.flags = i;
  }
  /**
  Define a node type.
  */
  static define(e) {
    let n = e.props && e.props.length ? /* @__PURE__ */ Object.create(null) : lU, r = (e.top ? 1 : 0) | (e.skipped ? 2 : 0) | (e.error ? 4 : 0) | (e.name == null ? 8 : 0), i = new Qn(e.name || "", n, e.id, r);
    if (e.props) {
      for (let s of e.props)
        if (Array.isArray(s) || (s = s(i)), s) {
          if (s[0].perNode)
            throw new RangeError("Can't store a per-node prop on a node type");
          n[s[0].id] = s[1];
        }
    }
    return i;
  }
  /**
  Retrieves a node prop for this type. Will return `undefined` if
  the prop isn't present on this node.
  */
  prop(e) {
    return this.props[e.id];
  }
  /**
  True when this is the top node of a grammar.
  */
  get isTop() {
    return (this.flags & 1) > 0;
  }
  /**
  True when this node is produced by a skip rule.
  */
  get isSkipped() {
    return (this.flags & 2) > 0;
  }
  /**
  Indicates whether this is an error node.
  */
  get isError() {
    return (this.flags & 4) > 0;
  }
  /**
  When true, this node type doesn't correspond to a user-declared
  named node, for example because it is used to cache repetition.
  */
  get isAnonymous() {
    return (this.flags & 8) > 0;
  }
  /**
  Returns true when this node's name or one of its
  [groups](#common.NodeProp^group) matches the given string.
  */
  is(e) {
    if (typeof e == "string") {
      if (this.name == e)
        return !0;
      let n = this.prop(Ne.group);
      return n ? n.indexOf(e) > -1 : !1;
    }
    return this.id == e;
  }
  /**
  Create a function from node types to arbitrary values by
  specifying an object whose property names are node or
  [group](#common.NodeProp^group) names. Often useful with
  [`NodeProp.add`](#common.NodeProp.add). You can put multiple
  names, separated by spaces, in a single property name to map
  multiple node names to a single value.
  */
  static match(e) {
    let n = /* @__PURE__ */ Object.create(null);
    for (let r in e)
      for (let i of r.split(" "))
        n[i] = e[r];
    return (r) => {
      for (let i = r.prop(Ne.group), s = -1; s < (i ? i.length : 0); s++) {
        let o = n[s < 0 ? r.name : i[s]];
        if (o)
          return o;
      }
    };
  }
}
Qn.none = new Qn(
  "",
  /* @__PURE__ */ Object.create(null),
  0,
  8
  /* NodeFlag.Anonymous */
);
const hf = /* @__PURE__ */ new WeakMap(), Dw = /* @__PURE__ */ new WeakMap();
var Ot;
(function(t) {
  t[t.ExcludeBuffers = 1] = "ExcludeBuffers", t[t.IncludeAnonymous = 2] = "IncludeAnonymous", t[t.IgnoreMounts = 4] = "IgnoreMounts", t[t.IgnoreOverlays = 8] = "IgnoreOverlays";
})(Ot || (Ot = {}));
class Ht {
  /**
  Construct a new tree. See also [`Tree.build`](#common.Tree^build).
  */
  constructor(e, n, r, i, s) {
    if (this.type = e, this.children = n, this.positions = r, this.length = i, this.props = null, s && s.length) {
      this.props = /* @__PURE__ */ Object.create(null);
      for (let [o, a] of s)
        this.props[typeof o == "number" ? o : o.id] = a;
    }
  }
  /**
  @internal
  */
  toString() {
    let e = Wh.get(this);
    if (e && !e.overlay)
      return e.tree.toString();
    let n = "";
    for (let r of this.children) {
      let i = r.toString();
      i && (n && (n += ","), n += i);
    }
    return this.type.name ? (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (n.length ? "(" + n + ")" : "") : n;
  }
  /**
  Get a [tree cursor](#common.TreeCursor) positioned at the top of
  the tree. Mode can be used to [control](#common.IterMode) which
  nodes the cursor visits.
  */
  cursor(e = 0) {
    return new K0(this.topNode, e);
  }
  /**
  Get a [tree cursor](#common.TreeCursor) pointing into this tree
  at the given position and side (see
  [`moveTo`](#common.TreeCursor.moveTo).
  */
  cursorAt(e, n = 0, r = 0) {
    let i = hf.get(this) || this.topNode, s = new K0(i);
    return s.moveTo(e, n), hf.set(this, s._tree), s;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) object for the top of the
  tree.
  */
  get topNode() {
    return new qn(this, 0, 0, null);
  }
  /**
  Get the [syntax node](#common.SyntaxNode) at the given position.
  If `side` is -1, this will move into nodes that end at the
  position. If 1, it'll move into nodes that start at the
  position. With 0, it'll only enter nodes that cover the position
  from both sides.
  
  Note that this will not enter
  [overlays](#common.MountedTree.overlay), and you often want
  [`resolveInner`](#common.Tree.resolveInner) instead.
  */
  resolve(e, n = 0) {
    let r = Lc(hf.get(this) || this.topNode, e, n, !1);
    return hf.set(this, r), r;
  }
  /**
  Like [`resolve`](#common.Tree.resolve), but will enter
  [overlaid](#common.MountedTree.overlay) nodes, producing a syntax node
  pointing into the innermost overlaid tree at the given position
  (with parent links going through all parent structure, including
  the host trees).
  */
  resolveInner(e, n = 0) {
    let r = Lc(Dw.get(this) || this.topNode, e, n, !0);
    return Dw.set(this, r), r;
  }
  /**
  In some situations, it can be useful to iterate through all
  nodes around a position, including those in overlays that don't
  directly cover the position. This method gives you an iterator
  that will produce all nodes, from small to big, around the given
  position.
  */
  resolveStack(e, n = 0) {
    return fU(this, e, n);
  }
  /**
  Iterate over the tree and its children, calling `enter` for any
  node that touches the `from`/`to` region (if given) before
  running over such a node's children, and `leave` (if given) when
  leaving the node. When `enter` returns `false`, that node will
  not have its children iterated over (or `leave` called).
  */
  iterate(e) {
    let { enter: n, leave: r, from: i = 0, to: s = this.length } = e, o = e.mode || 0, a = (o & Ot.IncludeAnonymous) > 0;
    for (let l = this.cursor(o | Ot.IncludeAnonymous); ; ) {
      let c = !1;
      if (l.from <= s && l.to >= i && (!a && l.type.isAnonymous || n(l) !== !1)) {
        if (l.firstChild())
          continue;
        c = !0;
      }
      for (; c && r && (a || !l.type.isAnonymous) && r(l), !l.nextSibling(); ) {
        if (!l.parent())
          return;
        c = !0;
      }
    }
  }
  /**
  Get the value of the given [node prop](#common.NodeProp) for this
  node. Works with both per-node and per-type props.
  */
  prop(e) {
    return e.perNode ? this.props ? this.props[e.id] : void 0 : this.type.prop(e);
  }
  /**
  Returns the node's [per-node props](#common.NodeProp.perNode) in a
  format that can be passed to the [`Tree`](#common.Tree)
  constructor.
  */
  get propValues() {
    let e = [];
    if (this.props)
      for (let n in this.props)
        e.push([+n, this.props[n]]);
    return e;
  }
  /**
  Balance the direct children of this tree, producing a copy of
  which may have children grouped into subtrees with type
  [`NodeType.none`](#common.NodeType^none).
  */
  balance(e = {}) {
    return this.children.length <= 8 ? this : ey(Qn.none, this.children, this.positions, 0, this.children.length, 0, this.length, (n, r, i) => new Ht(this.type, n, r, i, this.propValues), e.makeTree || ((n, r, i) => new Ht(Qn.none, n, r, i)));
  }
  /**
  Build a tree from a postfix-ordered buffer of node information,
  or a cursor over such a buffer.
  */
  static build(e) {
    return hU(e);
  }
}
Ht.empty = new Ht(Qn.none, [], [], 0);
class J1 {
  constructor(e, n) {
    this.buffer = e, this.index = n;
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  get pos() {
    return this.index;
  }
  next() {
    this.index -= 4;
  }
  fork() {
    return new J1(this.buffer, this.index);
  }
}
class vs {
  /**
  Create a tree buffer.
  */
  constructor(e, n, r) {
    this.buffer = e, this.length = n, this.set = r;
  }
  /**
  @internal
  */
  get type() {
    return Qn.none;
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    for (let n = 0; n < this.buffer.length; )
      e.push(this.childString(n)), n = this.buffer[n + 3];
    return e.join(",");
  }
  /**
  @internal
  */
  childString(e) {
    let n = this.buffer[e], r = this.buffer[e + 3], i = this.set.types[n], s = i.name;
    if (/\W/.test(s) && !i.isError && (s = JSON.stringify(s)), e += 4, r == e)
      return s;
    let o = [];
    for (; e < r; )
      o.push(this.childString(e)), e = this.buffer[e + 3];
    return s + "(" + o.join(",") + ")";
  }
  /**
  @internal
  */
  findChild(e, n, r, i, s) {
    let { buffer: o } = this, a = -1;
    for (let l = e; l != n && !(U6(s, i, o[l + 1], o[l + 2]) && (a = l, r > 0)); l = o[l + 3])
      ;
    return a;
  }
  /**
  @internal
  */
  slice(e, n, r) {
    let i = this.buffer, s = new Uint16Array(n - e), o = 0;
    for (let a = e, l = 0; a < n; ) {
      s[l++] = i[a++], s[l++] = i[a++] - r;
      let c = s[l++] = i[a++] - r;
      s[l++] = i[a++] - e, o = Math.max(o, c);
    }
    return new vs(s, o, this.set);
  }
}
function U6(t, e, n, r) {
  switch (t) {
    case -2:
      return n < e;
    case -1:
      return r >= e && n < e;
    case 0:
      return n < e && r > e;
    case 1:
      return n <= e && r > e;
    case 2:
      return r > e;
    case 4:
      return !0;
  }
}
function Lc(t, e, n, r) {
  for (var i; t.from == t.to || (n < 1 ? t.from >= e : t.from > e) || (n > -1 ? t.to <= e : t.to < e); ) {
    let o = !r && t instanceof qn && t.index < 0 ? null : t.parent;
    if (!o)
      return t;
    t = o;
  }
  let s = r ? 0 : Ot.IgnoreOverlays;
  if (r)
    for (let o = t, a = o.parent; a; o = a, a = o.parent)
      o instanceof qn && o.index < 0 && ((i = a.enter(e, n, s)) === null || i === void 0 ? void 0 : i.from) != o.from && (t = a);
  for (; ; ) {
    let o = t.enter(e, n, s);
    if (!o)
      return t;
    t = o;
  }
}
class K6 {
  cursor(e = 0) {
    return new K0(this, e);
  }
  getChild(e, n = null, r = null) {
    let i = Tw(this, e, n, r);
    return i.length ? i[0] : null;
  }
  getChildren(e, n = null, r = null) {
    return Tw(this, e, n, r);
  }
  resolve(e, n = 0) {
    return Lc(this, e, n, !1);
  }
  resolveInner(e, n = 0) {
    return Lc(this, e, n, !0);
  }
  matchContext(e) {
    return U0(this, e);
  }
  enterUnfinishedNodesBefore(e) {
    let n = this.childBefore(e), r = this;
    for (; n; ) {
      let i = n.lastChild;
      if (!i || i.to != n.to)
        break;
      i.type.isError && i.from == i.to ? (r = n, n = i.prevSibling) : n = i;
    }
    return r;
  }
  get node() {
    return this;
  }
  get next() {
    return this.parent;
  }
}
class qn extends K6 {
  constructor(e, n, r, i) {
    super(), this._tree = e, this.from = n, this.index = r, this._parent = i;
  }
  get type() {
    return this._tree.type;
  }
  get name() {
    return this._tree.type.name;
  }
  get to() {
    return this.from + this._tree.length;
  }
  nextChild(e, n, r, i, s = 0) {
    for (let o = this; ; ) {
      for (let { children: a, positions: l } = o._tree, c = n > 0 ? a.length : -1; e != c; e += n) {
        let u = a[e], h = l[e] + o.from;
        if (U6(i, r, h, h + u.length)) {
          if (u instanceof vs) {
            if (s & Ot.ExcludeBuffers)
              continue;
            let f = u.findChild(0, u.buffer.length, n, r - h, i);
            if (f > -1)
              return new ts(new cU(o, u, e, h), null, f);
          } else if (s & Ot.IncludeAnonymous || !u.type.isAnonymous || Q1(u)) {
            let f;
            if (!(s & Ot.IgnoreMounts) && (f = Wh.get(u)) && !f.overlay)
              return new qn(f.tree, h, e, o);
            let d = new qn(u, h, e, o);
            return s & Ot.IncludeAnonymous || !d.type.isAnonymous ? d : d.nextChild(n < 0 ? u.children.length - 1 : 0, n, r, i);
          }
        }
      }
      if (s & Ot.IncludeAnonymous || !o.type.isAnonymous || (o.index >= 0 ? e = o.index + n : e = n < 0 ? -1 : o._parent._tree.children.length, o = o._parent, !o))
        return null;
    }
  }
  get firstChild() {
    return this.nextChild(
      0,
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(e) {
    return this.nextChild(
      0,
      1,
      e,
      2
      /* Side.After */
    );
  }
  childBefore(e) {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      e,
      -2
      /* Side.Before */
    );
  }
  enter(e, n, r = 0) {
    let i;
    if (!(r & Ot.IgnoreOverlays) && (i = Wh.get(this._tree)) && i.overlay) {
      let s = e - this.from;
      for (let { from: o, to: a } of i.overlay)
        if ((n > 0 ? o <= s : o < s) && (n < 0 ? a >= s : a > s))
          return new qn(i.tree, i.overlay[0].from + this.from, -1, this);
    }
    return this.nextChild(0, 1, e, n, r);
  }
  nextSignificantParent() {
    let e = this;
    for (; e.type.isAnonymous && e._parent; )
      e = e._parent;
    return e;
  }
  get parent() {
    return this._parent ? this._parent.nextSignificantParent() : null;
  }
  get nextSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index + 1,
      1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get prevSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get tree() {
    return this._tree;
  }
  toTree() {
    return this._tree;
  }
  /**
  @internal
  */
  toString() {
    return this._tree.toString();
  }
}
function Tw(t, e, n, r) {
  let i = t.cursor(), s = [];
  if (!i.firstChild())
    return s;
  if (n != null) {
    for (let o = !1; !o; )
      if (o = i.type.is(n), !i.nextSibling())
        return s;
  }
  for (; ; ) {
    if (r != null && i.type.is(r))
      return s;
    if (i.type.is(e) && s.push(i.node), !i.nextSibling())
      return r == null ? s : [];
  }
}
function U0(t, e, n = e.length - 1) {
  for (let r = t.parent; n >= 0; r = r.parent) {
    if (!r)
      return !1;
    if (!r.type.isAnonymous) {
      if (e[n] && e[n] != r.name)
        return !1;
      n--;
    }
  }
  return !0;
}
class cU {
  constructor(e, n, r, i) {
    this.parent = e, this.buffer = n, this.index = r, this.start = i;
  }
}
class ts extends K6 {
  get name() {
    return this.type.name;
  }
  get from() {
    return this.context.start + this.context.buffer.buffer[this.index + 1];
  }
  get to() {
    return this.context.start + this.context.buffer.buffer[this.index + 2];
  }
  constructor(e, n, r) {
    super(), this.context = e, this._parent = n, this.index = r, this.type = e.buffer.set.types[e.buffer.buffer[r]];
  }
  child(e, n, r) {
    let { buffer: i } = this.context, s = i.findChild(this.index + 4, i.buffer[this.index + 3], e, n - this.context.start, r);
    return s < 0 ? null : new ts(this.context, this, s);
  }
  get firstChild() {
    return this.child(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.child(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(e) {
    return this.child(
      1,
      e,
      2
      /* Side.After */
    );
  }
  childBefore(e) {
    return this.child(
      -1,
      e,
      -2
      /* Side.Before */
    );
  }
  enter(e, n, r = 0) {
    if (r & Ot.ExcludeBuffers)
      return null;
    let { buffer: i } = this.context, s = i.findChild(this.index + 4, i.buffer[this.index + 3], n > 0 ? 1 : -1, e - this.context.start, n);
    return s < 0 ? null : new ts(this.context, this, s);
  }
  get parent() {
    return this._parent || this.context.parent.nextSignificantParent();
  }
  externalSibling(e) {
    return this._parent ? null : this.context.parent.nextChild(
      this.context.index + e,
      e,
      0,
      4
      /* Side.DontCare */
    );
  }
  get nextSibling() {
    let { buffer: e } = this.context, n = e.buffer[this.index + 3];
    return n < (this._parent ? e.buffer[this._parent.index + 3] : e.buffer.length) ? new ts(this.context, this._parent, n) : this.externalSibling(1);
  }
  get prevSibling() {
    let { buffer: e } = this.context, n = this._parent ? this._parent.index + 4 : 0;
    return this.index == n ? this.externalSibling(-1) : new ts(this.context, this._parent, e.findChild(
      n,
      this.index,
      -1,
      0,
      4
      /* Side.DontCare */
    ));
  }
  get tree() {
    return null;
  }
  toTree() {
    let e = [], n = [], { buffer: r } = this.context, i = this.index + 4, s = r.buffer[this.index + 3];
    if (s > i) {
      let o = r.buffer[this.index + 1];
      e.push(r.slice(i, s, o)), n.push(0);
    }
    return new Ht(this.type, e, n, this.to - this.from);
  }
  /**
  @internal
  */
  toString() {
    return this.context.buffer.childString(this.index);
  }
}
function G6(t) {
  if (!t.length)
    return null;
  let e = 0, n = t[0];
  for (let s = 1; s < t.length; s++) {
    let o = t[s];
    (o.from > n.from || o.to < n.to) && (n = o, e = s);
  }
  let r = n instanceof qn && n.index < 0 ? null : n.parent, i = t.slice();
  return r ? i[e] = r : i.splice(e, 1), new uU(i, n);
}
class uU {
  constructor(e, n) {
    this.heads = e, this.node = n;
  }
  get next() {
    return G6(this.heads);
  }
}
function fU(t, e, n) {
  let r = t.resolveInner(e, n), i = null;
  for (let s = r instanceof qn ? r : r.context.parent; s; s = s.parent)
    if (s.index < 0) {
      let o = s.parent;
      (i || (i = [r])).push(o.resolve(e, n)), s = o;
    } else {
      let o = Wh.get(s.tree);
      if (o && o.overlay && o.overlay[0].from <= e && o.overlay[o.overlay.length - 1].to >= e) {
        let a = new qn(o.tree, o.overlay[0].from + s.from, -1, s);
        (i || (i = [r])).push(Lc(a, e, n, !1));
      }
    }
  return i ? G6(i) : r;
}
class K0 {
  /**
  Shorthand for `.type.name`.
  */
  get name() {
    return this.type.name;
  }
  /**
  @internal
  */
  constructor(e, n = 0) {
    if (this.mode = n, this.buffer = null, this.stack = [], this.index = 0, this.bufferNode = null, e instanceof qn)
      this.yieldNode(e);
    else {
      this._tree = e.context.parent, this.buffer = e.context;
      for (let r = e._parent; r; r = r._parent)
        this.stack.unshift(r.index);
      this.bufferNode = e, this.yieldBuf(e.index);
    }
  }
  yieldNode(e) {
    return e ? (this._tree = e, this.type = e.type, this.from = e.from, this.to = e.to, !0) : !1;
  }
  yieldBuf(e, n) {
    this.index = e;
    let { start: r, buffer: i } = this.buffer;
    return this.type = n || i.set.types[i.buffer[e]], this.from = r + i.buffer[e + 1], this.to = r + i.buffer[e + 2], !0;
  }
  /**
  @internal
  */
  yield(e) {
    return e ? e instanceof qn ? (this.buffer = null, this.yieldNode(e)) : (this.buffer = e.context, this.yieldBuf(e.index, e.type)) : !1;
  }
  /**
  @internal
  */
  toString() {
    return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
  }
  /**
  @internal
  */
  enterChild(e, n, r) {
    if (!this.buffer)
      return this.yield(this._tree.nextChild(e < 0 ? this._tree._tree.children.length - 1 : 0, e, n, r, this.mode));
    let { buffer: i } = this.buffer, s = i.findChild(this.index + 4, i.buffer[this.index + 3], e, n - this.buffer.start, r);
    return s < 0 ? !1 : (this.stack.push(this.index), this.yieldBuf(s));
  }
  /**
  Move the cursor to this node's first child. When this returns
  false, the node has no child, and the cursor has not been moved.
  */
  firstChild() {
    return this.enterChild(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to this node's last child.
  */
  lastChild() {
    return this.enterChild(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to the first child that ends after `pos`.
  */
  childAfter(e) {
    return this.enterChild(
      1,
      e,
      2
      /* Side.After */
    );
  }
  /**
  Move to the last child that starts before `pos`.
  */
  childBefore(e) {
    return this.enterChild(
      -1,
      e,
      -2
      /* Side.Before */
    );
  }
  /**
  Move the cursor to the child around `pos`. If side is -1 the
  child may end at that position, when 1 it may start there. This
  will also enter [overlaid](#common.MountedTree.overlay)
  [mounted](#common.NodeProp^mounted) trees unless `overlays` is
  set to false.
  */
  enter(e, n, r = this.mode) {
    return this.buffer ? r & Ot.ExcludeBuffers ? !1 : this.enterChild(1, e, n) : this.yield(this._tree.enter(e, n, r));
  }
  /**
  Move to the node's parent node, if this isn't the top node.
  */
  parent() {
    if (!this.buffer)
      return this.yieldNode(this.mode & Ot.IncludeAnonymous ? this._tree._parent : this._tree.parent);
    if (this.stack.length)
      return this.yieldBuf(this.stack.pop());
    let e = this.mode & Ot.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
    return this.buffer = null, this.yieldNode(e);
  }
  /**
  @internal
  */
  sibling(e) {
    if (!this.buffer)
      return this._tree._parent ? this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + e, e, 0, 4, this.mode)) : !1;
    let { buffer: n } = this.buffer, r = this.stack.length - 1;
    if (e < 0) {
      let i = r < 0 ? 0 : this.stack[r] + 4;
      if (this.index != i)
        return this.yieldBuf(n.findChild(
          i,
          this.index,
          -1,
          0,
          4
          /* Side.DontCare */
        ));
    } else {
      let i = n.buffer[this.index + 3];
      if (i < (r < 0 ? n.buffer.length : n.buffer[this.stack[r] + 3]))
        return this.yieldBuf(i);
    }
    return r < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + e, e, 0, 4, this.mode)) : !1;
  }
  /**
  Move to this node's next sibling, if any.
  */
  nextSibling() {
    return this.sibling(1);
  }
  /**
  Move to this node's previous sibling, if any.
  */
  prevSibling() {
    return this.sibling(-1);
  }
  atLastNode(e) {
    let n, r, { buffer: i } = this;
    if (i) {
      if (e > 0) {
        if (this.index < i.buffer.buffer.length)
          return !1;
      } else
        for (let s = 0; s < this.index; s++)
          if (i.buffer.buffer[s + 3] < this.index)
            return !1;
      ({ index: n, parent: r } = i);
    } else
      ({ index: n, _parent: r } = this._tree);
    for (; r; { index: n, _parent: r } = r)
      if (n > -1)
        for (let s = n + e, o = e < 0 ? -1 : r._tree.children.length; s != o; s += e) {
          let a = r._tree.children[s];
          if (this.mode & Ot.IncludeAnonymous || a instanceof vs || !a.type.isAnonymous || Q1(a))
            return !1;
        }
    return !0;
  }
  move(e, n) {
    if (n && this.enterChild(
      e,
      0,
      4
      /* Side.DontCare */
    ))
      return !0;
    for (; ; ) {
      if (this.sibling(e))
        return !0;
      if (this.atLastNode(e) || !this.parent())
        return !1;
    }
  }
  /**
  Move to the next node in a
  [pre-order](https://en.wikipedia.org/wiki/Tree_traversal#Pre-order,_NLR)
  traversal, going from a node to its first child or, if the
  current node is empty or `enter` is false, its next sibling or
  the next sibling of the first parent node that has one.
  */
  next(e = !0) {
    return this.move(1, e);
  }
  /**
  Move to the next node in a last-to-first pre-order traveral. A
  node is followed by its last child or, if it has none, its
  previous sibling or the previous sibling of the first parent
  node that has one.
  */
  prev(e = !0) {
    return this.move(-1, e);
  }
  /**
  Move the cursor to the innermost node that covers `pos`. If
  `side` is -1, it will enter nodes that end at `pos`. If it is 1,
  it will enter nodes that start at `pos`.
  */
  moveTo(e, n = 0) {
    for (; (this.from == this.to || (n < 1 ? this.from >= e : this.from > e) || (n > -1 ? this.to <= e : this.to < e)) && this.parent(); )
      ;
    for (; this.enterChild(1, e, n); )
      ;
    return this;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) at the cursor's current
  position.
  */
  get node() {
    if (!this.buffer)
      return this._tree;
    let e = this.bufferNode, n = null, r = 0;
    if (e && e.context == this.buffer)
      e: for (let i = this.index, s = this.stack.length; s >= 0; ) {
        for (let o = e; o; o = o._parent)
          if (o.index == i) {
            if (i == this.index)
              return o;
            n = o, r = s + 1;
            break e;
          }
        i = this.stack[--s];
      }
    for (let i = r; i < this.stack.length; i++)
      n = new ts(this.buffer, n, this.stack[i]);
    return this.bufferNode = new ts(this.buffer, n, this.index);
  }
  /**
  Get the [tree](#common.Tree) that represents the current node, if
  any. Will return null when the node is in a [tree
  buffer](#common.TreeBuffer).
  */
  get tree() {
    return this.buffer ? null : this._tree._tree;
  }
  /**
  Iterate over the current node and all its descendants, calling
  `enter` when entering a node and `leave`, if given, when leaving
  one. When `enter` returns `false`, any children of that node are
  skipped, and `leave` isn't called for it.
  */
  iterate(e, n) {
    for (let r = 0; ; ) {
      let i = !1;
      if (this.type.isAnonymous || e(this) !== !1) {
        if (this.firstChild()) {
          r++;
          continue;
        }
        this.type.isAnonymous || (i = !0);
      }
      for (; i && n && n(this), i = this.type.isAnonymous, !this.nextSibling(); ) {
        if (!r)
          return;
        this.parent(), r--, i = !0;
      }
    }
  }
  /**
  Test whether the current node matches a given context—a sequence
  of direct parent node names. Empty strings in the context array
  are treated as wildcards.
  */
  matchContext(e) {
    if (!this.buffer)
      return U0(this.node, e);
    let { buffer: n } = this.buffer, { types: r } = n.set;
    for (let i = e.length - 1, s = this.stack.length - 1; i >= 0; s--) {
      if (s < 0)
        return U0(this.node, e, i);
      let o = r[n.buffer[this.stack[s]]];
      if (!o.isAnonymous) {
        if (e[i] && e[i] != o.name)
          return !1;
        i--;
      }
    }
    return !0;
  }
}
function Q1(t) {
  return t.children.some((e) => e instanceof vs || !e.type.isAnonymous || Q1(e));
}
function hU(t) {
  var e;
  let { buffer: n, nodeSet: r, maxBufferLength: i = oU, reused: s = [], minRepeatType: o = r.types.length } = t, a = Array.isArray(n) ? new J1(n, n.length) : n, l = r.types, c = 0, u = 0;
  function h(w, k, _, C, E, L) {
    let { id: M, start: O, end: N, size: R } = a, $ = u;
    for (; R < 0; )
      if (a.next(), R == -1) {
        let z = s[M];
        _.push(z), C.push(O - w);
        return;
      } else if (R == -3) {
        c = M;
        return;
      } else if (R == -4) {
        u = M;
        return;
      } else
        throw new RangeError(`Unrecognized record size: ${R}`);
    let F = l[M], U, ee, ie = O - w;
    if (N - O <= i && (ee = v(a.pos - k, E))) {
      let z = new Uint16Array(ee.size - ee.skip), te = a.pos - ee.size, I = z.length;
      for (; a.pos > te; )
        I = g(ee.start, z, I);
      U = new vs(z, N - ee.start, r), ie = ee.start - w;
    } else {
      let z = a.pos - R;
      a.next();
      let te = [], I = [], X = M >= o ? M : -1, Q = 0, ce = N;
      for (; a.pos > z; )
        X >= 0 && a.id == X && a.size >= 0 ? (a.end <= ce - i && (p(te, I, O, Q, a.end, ce, X, $), Q = te.length, ce = a.end), a.next()) : L > 2500 ? f(O, z, te, I) : h(O, z, te, I, X, L + 1);
      if (X >= 0 && Q > 0 && Q < te.length && p(te, I, O, Q, O, ce, X, $), te.reverse(), I.reverse(), X > -1 && Q > 0) {
        let he = d(F);
        U = ey(F, te, I, 0, te.length, 0, N - O, he, he);
      } else
        U = m(F, te, I, N - O, $ - N);
    }
    _.push(U), C.push(ie);
  }
  function f(w, k, _, C) {
    let E = [], L = 0, M = -1;
    for (; a.pos > k; ) {
      let { id: O, start: N, end: R, size: $ } = a;
      if ($ > 4)
        a.next();
      else {
        if (M > -1 && N < M)
          break;
        M < 0 && (M = R - i), E.push(O, N, R), L++, a.next();
      }
    }
    if (L) {
      let O = new Uint16Array(L * 4), N = E[E.length - 2];
      for (let R = E.length - 3, $ = 0; R >= 0; R -= 3)
        O[$++] = E[R], O[$++] = E[R + 1] - N, O[$++] = E[R + 2] - N, O[$++] = $;
      _.push(new vs(O, E[2] - N, r)), C.push(N - w);
    }
  }
  function d(w) {
    return (k, _, C) => {
      let E = 0, L = k.length - 1, M, O;
      if (L >= 0 && (M = k[L]) instanceof Ht) {
        if (!L && M.type == w && M.length == C)
          return M;
        (O = M.prop(Ne.lookAhead)) && (E = _[L] + M.length + O);
      }
      return m(w, k, _, C, E);
    };
  }
  function p(w, k, _, C, E, L, M, O) {
    let N = [], R = [];
    for (; w.length > C; )
      N.push(w.pop()), R.push(k.pop() + _ - E);
    w.push(m(r.types[M], N, R, L - E, O - L)), k.push(E - _);
  }
  function m(w, k, _, C, E = 0, L) {
    if (c) {
      let M = [Ne.contextHash, c];
      L = L ? [M].concat(L) : [M];
    }
    if (E > 25) {
      let M = [Ne.lookAhead, E];
      L = L ? [M].concat(L) : [M];
    }
    return new Ht(w, k, _, C, L);
  }
  function v(w, k) {
    let _ = a.fork(), C = 0, E = 0, L = 0, M = _.end - i, O = { size: 0, start: 0, skip: 0 };
    e: for (let N = _.pos - w; _.pos > N; ) {
      let R = _.size;
      if (_.id == k && R >= 0) {
        O.size = C, O.start = E, O.skip = L, L += 4, C += 4, _.next();
        continue;
      }
      let $ = _.pos - R;
      if (R < 0 || $ < N || _.start < M)
        break;
      let F = _.id >= o ? 4 : 0, U = _.start;
      for (_.next(); _.pos > $; ) {
        if (_.size < 0)
          if (_.size == -3)
            F += 4;
          else
            break e;
        else _.id >= o && (F += 4);
        _.next();
      }
      E = U, C += R, L += F;
    }
    return (k < 0 || C == w) && (O.size = C, O.start = E, O.skip = L), O.size > 4 ? O : void 0;
  }
  function g(w, k, _) {
    let { id: C, start: E, end: L, size: M } = a;
    if (a.next(), M >= 0 && C < o) {
      let O = _;
      if (M > 4) {
        let N = a.pos - (M - 4);
        for (; a.pos > N; )
          _ = g(w, k, _);
      }
      k[--_] = O, k[--_] = L - w, k[--_] = E - w, k[--_] = C;
    } else M == -3 ? c = C : M == -4 && (u = C);
    return _;
  }
  let y = [], x = [];
  for (; a.pos > 0; )
    h(t.start || 0, t.bufferStart || 0, y, x, -1, 0);
  let b = (e = t.length) !== null && e !== void 0 ? e : y.length ? x[0] + y[0].length : 0;
  return new Ht(l[t.topID], y.reverse(), x.reverse(), b);
}
const Ow = /* @__PURE__ */ new WeakMap();
function Yf(t, e) {
  if (!t.isAnonymous || e instanceof vs || e.type != t)
    return 1;
  let n = Ow.get(e);
  if (n == null) {
    n = 1;
    for (let r of e.children) {
      if (r.type != t || !(r instanceof Ht)) {
        n = 1;
        break;
      }
      n += Yf(t, r);
    }
    Ow.set(e, n);
  }
  return n;
}
function ey(t, e, n, r, i, s, o, a, l) {
  let c = 0;
  for (let p = r; p < i; p++)
    c += Yf(t, e[p]);
  let u = Math.ceil(
    c * 1.5 / 8
    /* Balance.BranchFactor */
  ), h = [], f = [];
  function d(p, m, v, g, y) {
    for (let x = v; x < g; ) {
      let b = x, w = m[x], k = Yf(t, p[x]);
      for (x++; x < g; x++) {
        let _ = Yf(t, p[x]);
        if (k + _ >= u)
          break;
        k += _;
      }
      if (x == b + 1) {
        if (k > u) {
          let _ = p[b];
          d(_.children, _.positions, 0, _.children.length, m[b] + y);
          continue;
        }
        h.push(p[b]);
      } else {
        let _ = m[x - 1] + p[x - 1].length - w;
        h.push(ey(t, p, m, b, x, w, _, null, l));
      }
      f.push(w + y - s);
    }
  }
  return d(e, n, r, i, 0), (a || l)(h, f, o);
}
class Js {
  /**
  Construct a tree fragment. You'll usually want to use
  [`addTree`](#common.TreeFragment^addTree) and
  [`applyChanges`](#common.TreeFragment^applyChanges) instead of
  calling this directly.
  */
  constructor(e, n, r, i, s = !1, o = !1) {
    this.from = e, this.to = n, this.tree = r, this.offset = i, this.open = (s ? 1 : 0) | (o ? 2 : 0);
  }
  /**
  Whether the start of the fragment represents the start of a
  parse, or the end of a change. (In the second case, it may not
  be safe to reuse some nodes at the start, depending on the
  parsing algorithm.)
  */
  get openStart() {
    return (this.open & 1) > 0;
  }
  /**
  Whether the end of the fragment represents the end of a
  full-document parse, or the start of a change.
  */
  get openEnd() {
    return (this.open & 2) > 0;
  }
  /**
  Create a set of fragments from a freshly parsed tree, or update
  an existing set of fragments by replacing the ones that overlap
  with a tree with content from the new tree. When `partial` is
  true, the parse is treated as incomplete, and the resulting
  fragment has [`openEnd`](#common.TreeFragment.openEnd) set to
  true.
  */
  static addTree(e, n = [], r = !1) {
    let i = [new Js(0, e.length, e, 0, !1, r)];
    for (let s of n)
      s.to > e.length && i.push(s);
    return i;
  }
  /**
  Apply a set of edits to an array of fragments, removing or
  splitting fragments as necessary to remove edited ranges, and
  adjusting offsets for fragments that moved.
  */
  static applyChanges(e, n, r = 128) {
    if (!n.length)
      return e;
    let i = [], s = 1, o = e.length ? e[0] : null;
    for (let a = 0, l = 0, c = 0; ; a++) {
      let u = a < n.length ? n[a] : null, h = u ? u.fromA : 1e9;
      if (h - l >= r)
        for (; o && o.from < h; ) {
          let f = o;
          if (l >= f.from || h <= f.to || c) {
            let d = Math.max(f.from, l) - c, p = Math.min(f.to, h) - c;
            f = d >= p ? null : new Js(d, p, f.tree, f.offset + c, a > 0, !!u);
          }
          if (f && i.push(f), o.to > h)
            break;
          o = s < e.length ? e[s++] : null;
        }
      if (!u)
        break;
      l = u.toA, c = u.toA - u.toB;
    }
    return i;
  }
}
class dU {
  /**
  Start a parse, returning a [partial parse](#common.PartialParse)
  object. [`fragments`](#common.TreeFragment) can be passed in to
  make the parse incremental.
  
  By default, the entire input is parsed. You can pass `ranges`,
  which should be a sorted array of non-empty, non-overlapping
  ranges, to parse only those ranges. The tree returned in that
  case will start at `ranges[0].from`.
  */
  startParse(e, n, r) {
    return typeof e == "string" && (e = new pU(e)), r = r ? r.length ? r.map((i) => new Tm(i.from, i.to)) : [new Tm(0, 0)] : [new Tm(0, e.length)], this.createParse(e, n || [], r);
  }
  /**
  Run a full parse, returning the resulting tree.
  */
  parse(e, n, r) {
    let i = this.startParse(e, n, r);
    for (; ; ) {
      let s = i.advance();
      if (s)
        return s;
    }
  }
}
class pU {
  constructor(e) {
    this.string = e;
  }
  get length() {
    return this.string.length;
  }
  chunk(e) {
    return this.string.slice(e);
  }
  get lineChunks() {
    return !1;
  }
  read(e, n) {
    return this.string.slice(e, n);
  }
}
new Ne({ perNode: !0 });
let mU = 0;
class Ar {
  /**
  @internal
  */
  constructor(e, n, r) {
    this.set = e, this.base = n, this.modified = r, this.id = mU++;
  }
  /**
  Define a new tag. If `parent` is given, the tag is treated as a
  sub-tag of that parent, and
  [highlighters](#highlight.tagHighlighter) that don't mention
  this tag will try to fall back to the parent tag (or grandparent
  tag, etc).
  */
  static define(e) {
    if (e != null && e.base)
      throw new Error("Can not derive from a modified tag");
    let n = new Ar([], null, []);
    if (n.set.push(n), e)
      for (let r of e.set)
        n.set.push(r);
    return n;
  }
  /**
  Define a tag _modifier_, which is a function that, given a tag,
  will return a tag that is a subtag of the original. Applying the
  same modifier to a twice tag will return the same value (`m1(t1)
  == m1(t1)`) and applying multiple modifiers will, regardless or
  order, produce the same tag (`m1(m2(t1)) == m2(m1(t1))`).
  
  When multiple modifiers are applied to a given base tag, each
  smaller set of modifiers is registered as a parent, so that for
  example `m1(m2(m3(t1)))` is a subtype of `m1(m2(t1))`,
  `m1(m3(t1)`, and so on.
  */
  static defineModifier() {
    let e = new jh();
    return (n) => n.modified.indexOf(e) > -1 ? n : jh.get(n.base || n, n.modified.concat(e).sort((r, i) => r.id - i.id));
  }
}
let gU = 0;
class jh {
  constructor() {
    this.instances = [], this.id = gU++;
  }
  static get(e, n) {
    if (!n.length)
      return e;
    let r = n[0].instances.find((a) => a.base == e && vU(n, a.modified));
    if (r)
      return r;
    let i = [], s = new Ar(i, e, n);
    for (let a of n)
      a.instances.push(s);
    let o = yU(n);
    for (let a of e.set)
      if (!a.modified.length)
        for (let l of o)
          i.push(jh.get(a, l));
    return s;
  }
}
function vU(t, e) {
  return t.length == e.length && t.every((n, r) => n == e[r]);
}
function yU(t) {
  let e = [[]];
  for (let n = 0; n < t.length; n++)
    for (let r = 0, i = e.length; r < i; r++)
      e.push(e[r].concat(t[n]));
  return e.sort((n, r) => r.length - n.length);
}
function bU(t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let n in t) {
    let r = t[n];
    Array.isArray(r) || (r = [r]);
    for (let i of n.split(" "))
      if (i) {
        let s = [], o = 2, a = i;
        for (let h = 0; ; ) {
          if (a == "..." && h > 0 && h + 3 == i.length) {
            o = 1;
            break;
          }
          let f = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(a);
          if (!f)
            throw new RangeError("Invalid path: " + i);
          if (s.push(f[0] == "*" ? "" : f[0][0] == '"' ? JSON.parse(f[0]) : f[0]), h += f[0].length, h == i.length)
            break;
          let d = i[h++];
          if (h == i.length && d == "!") {
            o = 0;
            break;
          }
          if (d != "/")
            throw new RangeError("Invalid path: " + i);
          a = i.slice(h);
        }
        let l = s.length - 1, c = s[l];
        if (!c)
          throw new RangeError("Invalid path: " + i);
        let u = new qh(r, o, l > 0 ? s.slice(0, l) : null);
        e[c] = u.sort(e[c]);
      }
  }
  return X6.add(e);
}
const X6 = new Ne();
class qh {
  constructor(e, n, r, i) {
    this.tags = e, this.mode = n, this.context = r, this.next = i;
  }
  get opaque() {
    return this.mode == 0;
  }
  get inherit() {
    return this.mode == 1;
  }
  sort(e) {
    return !e || e.depth < this.depth ? (this.next = e, this) : (e.next = this.sort(e.next), e);
  }
  get depth() {
    return this.context ? this.context.length : 0;
  }
}
qh.empty = new qh([], 2, null);
function Z6(t, e) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let s of t)
    if (!Array.isArray(s.tag))
      n[s.tag.id] = s.class;
    else
      for (let o of s.tag)
        n[o.id] = s.class;
  let { scope: r, all: i = null } = e || {};
  return {
    style: (s) => {
      let o = i;
      for (let a of s)
        for (let l of a.set) {
          let c = n[l.id];
          if (c) {
            o = o ? o + " " + c : c;
            break;
          }
        }
      return o;
    },
    scope: r
  };
}
function xU(t, e) {
  let n = null;
  for (let r of t) {
    let i = r.style(e);
    i && (n = n ? n + " " + i : i);
  }
  return n;
}
function wU(t, e, n, r = 0, i = t.length) {
  let s = new kU(r, Array.isArray(e) ? e : [e], n);
  s.highlightRange(t.cursor(), r, i, "", s.highlighters), s.flush(i);
}
class kU {
  constructor(e, n, r) {
    this.at = e, this.highlighters = n, this.span = r, this.class = "";
  }
  startSpan(e, n) {
    n != this.class && (this.flush(e), e > this.at && (this.at = e), this.class = n);
  }
  flush(e) {
    e > this.at && this.class && this.span(this.at, e, this.class);
  }
  highlightRange(e, n, r, i, s) {
    let { type: o, from: a, to: l } = e;
    if (a >= r || l <= n)
      return;
    o.isTop && (s = this.highlighters.filter((d) => !d.scope || d.scope(o)));
    let c = i, u = _U(e) || qh.empty, h = xU(s, u.tags);
    if (h && (c && (c += " "), c += h, u.mode == 1 && (i += (i ? " " : "") + h)), this.startSpan(Math.max(n, a), c), u.opaque)
      return;
    let f = e.tree && e.tree.prop(Ne.mounted);
    if (f && f.overlay) {
      let d = e.node.enter(f.overlay[0].from + a, 1), p = this.highlighters.filter((v) => !v.scope || v.scope(f.tree.type)), m = e.firstChild();
      for (let v = 0, g = a; ; v++) {
        let y = v < f.overlay.length ? f.overlay[v] : null, x = y ? y.from + a : l, b = Math.max(n, g), w = Math.min(r, x);
        if (b < w && m)
          for (; e.from < w && (this.highlightRange(e, b, w, i, s), this.startSpan(Math.min(w, e.to), c), !(e.to >= x || !e.nextSibling())); )
            ;
        if (!y || x > r)
          break;
        g = y.to + a, g > n && (this.highlightRange(d.cursor(), Math.max(n, y.from + a), Math.min(r, g), "", p), this.startSpan(Math.min(r, g), c));
      }
      m && e.parent();
    } else if (e.firstChild()) {
      f && (i = "");
      do
        if (!(e.to <= n)) {
          if (e.from >= r)
            break;
          this.highlightRange(e, n, r, i, s), this.startSpan(Math.min(r, e.to), c);
        }
      while (e.nextSibling());
      e.parent();
    }
  }
}
function _U(t) {
  let e = t.type.prop(X6);
  for (; e && e.context && !t.matchContext(e.context); )
    e = e.next;
  return e || null;
}
const ae = Ar.define, df = ae(), Yi = ae(), Ew = ae(Yi), Pw = ae(Yi), Wi = ae(), pf = ae(Wi), Om = ae(Wi), Cr = ae(), Ps = ae(Cr), Sr = ae(), Mr = ae(), G0 = ae(), vl = ae(G0), mf = ae(), fe = {
  /**
  A comment.
  */
  comment: df,
  /**
  A line [comment](#highlight.tags.comment).
  */
  lineComment: ae(df),
  /**
  A block [comment](#highlight.tags.comment).
  */
  blockComment: ae(df),
  /**
  A documentation [comment](#highlight.tags.comment).
  */
  docComment: ae(df),
  /**
  Any kind of identifier.
  */
  name: Yi,
  /**
  The [name](#highlight.tags.name) of a variable.
  */
  variableName: ae(Yi),
  /**
  A type [name](#highlight.tags.name).
  */
  typeName: Ew,
  /**
  A tag name (subtag of [`typeName`](#highlight.tags.typeName)).
  */
  tagName: ae(Ew),
  /**
  A property or field [name](#highlight.tags.name).
  */
  propertyName: Pw,
  /**
  An attribute name (subtag of [`propertyName`](#highlight.tags.propertyName)).
  */
  attributeName: ae(Pw),
  /**
  The [name](#highlight.tags.name) of a class.
  */
  className: ae(Yi),
  /**
  A label [name](#highlight.tags.name).
  */
  labelName: ae(Yi),
  /**
  A namespace [name](#highlight.tags.name).
  */
  namespace: ae(Yi),
  /**
  The [name](#highlight.tags.name) of a macro.
  */
  macroName: ae(Yi),
  /**
  A literal value.
  */
  literal: Wi,
  /**
  A string [literal](#highlight.tags.literal).
  */
  string: pf,
  /**
  A documentation [string](#highlight.tags.string).
  */
  docString: ae(pf),
  /**
  A character literal (subtag of [string](#highlight.tags.string)).
  */
  character: ae(pf),
  /**
  An attribute value (subtag of [string](#highlight.tags.string)).
  */
  attributeValue: ae(pf),
  /**
  A number [literal](#highlight.tags.literal).
  */
  number: Om,
  /**
  An integer [number](#highlight.tags.number) literal.
  */
  integer: ae(Om),
  /**
  A floating-point [number](#highlight.tags.number) literal.
  */
  float: ae(Om),
  /**
  A boolean [literal](#highlight.tags.literal).
  */
  bool: ae(Wi),
  /**
  Regular expression [literal](#highlight.tags.literal).
  */
  regexp: ae(Wi),
  /**
  An escape [literal](#highlight.tags.literal), for example a
  backslash escape in a string.
  */
  escape: ae(Wi),
  /**
  A color [literal](#highlight.tags.literal).
  */
  color: ae(Wi),
  /**
  A URL [literal](#highlight.tags.literal).
  */
  url: ae(Wi),
  /**
  A language keyword.
  */
  keyword: Sr,
  /**
  The [keyword](#highlight.tags.keyword) for the self or this
  object.
  */
  self: ae(Sr),
  /**
  The [keyword](#highlight.tags.keyword) for null.
  */
  null: ae(Sr),
  /**
  A [keyword](#highlight.tags.keyword) denoting some atomic value.
  */
  atom: ae(Sr),
  /**
  A [keyword](#highlight.tags.keyword) that represents a unit.
  */
  unit: ae(Sr),
  /**
  A modifier [keyword](#highlight.tags.keyword).
  */
  modifier: ae(Sr),
  /**
  A [keyword](#highlight.tags.keyword) that acts as an operator.
  */
  operatorKeyword: ae(Sr),
  /**
  A control-flow related [keyword](#highlight.tags.keyword).
  */
  controlKeyword: ae(Sr),
  /**
  A [keyword](#highlight.tags.keyword) that defines something.
  */
  definitionKeyword: ae(Sr),
  /**
  A [keyword](#highlight.tags.keyword) related to defining or
  interfacing with modules.
  */
  moduleKeyword: ae(Sr),
  /**
  An operator.
  */
  operator: Mr,
  /**
  An [operator](#highlight.tags.operator) that dereferences something.
  */
  derefOperator: ae(Mr),
  /**
  Arithmetic-related [operator](#highlight.tags.operator).
  */
  arithmeticOperator: ae(Mr),
  /**
  Logical [operator](#highlight.tags.operator).
  */
  logicOperator: ae(Mr),
  /**
  Bit [operator](#highlight.tags.operator).
  */
  bitwiseOperator: ae(Mr),
  /**
  Comparison [operator](#highlight.tags.operator).
  */
  compareOperator: ae(Mr),
  /**
  [Operator](#highlight.tags.operator) that updates its operand.
  */
  updateOperator: ae(Mr),
  /**
  [Operator](#highlight.tags.operator) that defines something.
  */
  definitionOperator: ae(Mr),
  /**
  Type-related [operator](#highlight.tags.operator).
  */
  typeOperator: ae(Mr),
  /**
  Control-flow [operator](#highlight.tags.operator).
  */
  controlOperator: ae(Mr),
  /**
  Program or markup punctuation.
  */
  punctuation: G0,
  /**
  [Punctuation](#highlight.tags.punctuation) that separates
  things.
  */
  separator: ae(G0),
  /**
  Bracket-style [punctuation](#highlight.tags.punctuation).
  */
  bracket: vl,
  /**
  Angle [brackets](#highlight.tags.bracket) (usually `<` and `>`
  tokens).
  */
  angleBracket: ae(vl),
  /**
  Square [brackets](#highlight.tags.bracket) (usually `[` and `]`
  tokens).
  */
  squareBracket: ae(vl),
  /**
  Parentheses (usually `(` and `)` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  paren: ae(vl),
  /**
  Braces (usually `{` and `}` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  brace: ae(vl),
  /**
  Content, for example plain text in XML or markup documents.
  */
  content: Cr,
  /**
  [Content](#highlight.tags.content) that represents a heading.
  */
  heading: Ps,
  /**
  A level 1 [heading](#highlight.tags.heading).
  */
  heading1: ae(Ps),
  /**
  A level 2 [heading](#highlight.tags.heading).
  */
  heading2: ae(Ps),
  /**
  A level 3 [heading](#highlight.tags.heading).
  */
  heading3: ae(Ps),
  /**
  A level 4 [heading](#highlight.tags.heading).
  */
  heading4: ae(Ps),
  /**
  A level 5 [heading](#highlight.tags.heading).
  */
  heading5: ae(Ps),
  /**
  A level 6 [heading](#highlight.tags.heading).
  */
  heading6: ae(Ps),
  /**
  A prose separator (such as a horizontal rule).
  */
  contentSeparator: ae(Cr),
  /**
  [Content](#highlight.tags.content) that represents a list.
  */
  list: ae(Cr),
  /**
  [Content](#highlight.tags.content) that represents a quote.
  */
  quote: ae(Cr),
  /**
  [Content](#highlight.tags.content) that is emphasized.
  */
  emphasis: ae(Cr),
  /**
  [Content](#highlight.tags.content) that is styled strong.
  */
  strong: ae(Cr),
  /**
  [Content](#highlight.tags.content) that is part of a link.
  */
  link: ae(Cr),
  /**
  [Content](#highlight.tags.content) that is styled as code or
  monospace.
  */
  monospace: ae(Cr),
  /**
  [Content](#highlight.tags.content) that has a strike-through
  style.
  */
  strikethrough: ae(Cr),
  /**
  Inserted text in a change-tracking format.
  */
  inserted: ae(),
  /**
  Deleted text.
  */
  deleted: ae(),
  /**
  Changed text.
  */
  changed: ae(),
  /**
  An invalid or unsyntactic element.
  */
  invalid: ae(),
  /**
  Metadata or meta-instruction.
  */
  meta: mf,
  /**
  [Metadata](#highlight.tags.meta) that applies to the entire
  document.
  */
  documentMeta: ae(mf),
  /**
  [Metadata](#highlight.tags.meta) that annotates or adds
  attributes to a given syntactic element.
  */
  annotation: ae(mf),
  /**
  Processing instruction or preprocessor directive. Subtag of
  [meta](#highlight.tags.meta).
  */
  processingInstruction: ae(mf),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that a
  given element is being defined. Expected to be used with the
  various [name](#highlight.tags.name) tags.
  */
  definition: Ar.defineModifier(),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that
  something is constant. Mostly expected to be used with
  [variable names](#highlight.tags.variableName).
  */
  constant: Ar.defineModifier(),
  /**
  [Modifier](#highlight.Tag^defineModifier) used to indicate that
  a [variable](#highlight.tags.variableName) or [property
  name](#highlight.tags.propertyName) is being called or defined
  as a function.
  */
  function: Ar.defineModifier(),
  /**
  [Modifier](#highlight.Tag^defineModifier) that can be applied to
  [names](#highlight.tags.name) to indicate that they belong to
  the language's standard environment.
  */
  standard: Ar.defineModifier(),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates a given
  [names](#highlight.tags.name) is local to some scope.
  */
  local: Ar.defineModifier(),
  /**
  A generic variant [modifier](#highlight.Tag^defineModifier) that
  can be used to tag language-specific alternative variants of
  some common tag. It is recommended for themes to define special
  forms of at least the [string](#highlight.tags.string) and
  [variable name](#highlight.tags.variableName) tags, since those
  come up a lot.
  */
  special: Ar.defineModifier()
};
Z6([
  { tag: fe.link, class: "tok-link" },
  { tag: fe.heading, class: "tok-heading" },
  { tag: fe.emphasis, class: "tok-emphasis" },
  { tag: fe.strong, class: "tok-strong" },
  { tag: fe.keyword, class: "tok-keyword" },
  { tag: fe.atom, class: "tok-atom" },
  { tag: fe.bool, class: "tok-bool" },
  { tag: fe.url, class: "tok-url" },
  { tag: fe.labelName, class: "tok-labelName" },
  { tag: fe.inserted, class: "tok-inserted" },
  { tag: fe.deleted, class: "tok-deleted" },
  { tag: fe.literal, class: "tok-literal" },
  { tag: fe.string, class: "tok-string" },
  { tag: fe.number, class: "tok-number" },
  { tag: [fe.regexp, fe.escape, fe.special(fe.string)], class: "tok-string2" },
  { tag: fe.variableName, class: "tok-variableName" },
  { tag: fe.local(fe.variableName), class: "tok-variableName tok-local" },
  { tag: fe.definition(fe.variableName), class: "tok-variableName tok-definition" },
  { tag: fe.special(fe.variableName), class: "tok-variableName2" },
  { tag: fe.definition(fe.propertyName), class: "tok-propertyName tok-definition" },
  { tag: fe.typeName, class: "tok-typeName" },
  { tag: fe.namespace, class: "tok-namespace" },
  { tag: fe.className, class: "tok-className" },
  { tag: fe.macroName, class: "tok-macroName" },
  { tag: fe.propertyName, class: "tok-propertyName" },
  { tag: fe.operator, class: "tok-operator" },
  { tag: fe.comment, class: "tok-comment" },
  { tag: fe.meta, class: "tok-meta" },
  { tag: fe.invalid, class: "tok-invalid" },
  { tag: fe.punctuation, class: "tok-punctuation" }
]);
var Em;
const Hl = /* @__PURE__ */ new Ne(), SU = /* @__PURE__ */ new Ne();
class Ir {
  /**
  Construct a language object. If you need to invoke this
  directly, first define a data facet with
  [`defineLanguageFacet`](https://codemirror.net/6/docs/ref/#language.defineLanguageFacet), and then
  configure your parser to [attach](https://codemirror.net/6/docs/ref/#language.languageDataProp) it
  to the language's outer syntax node.
  */
  constructor(e, n, r = [], i = "") {
    this.data = e, this.name = i, Le.prototype.hasOwnProperty("tree") || Object.defineProperty(Le.prototype, "tree", { get() {
      return Wt(this);
    } }), this.parser = n, this.extension = [
      ys.of(this),
      Le.languageData.of((s, o, a) => {
        let l = Lw(s, o, a), c = l.type.prop(Hl);
        if (!c)
          return [];
        let u = s.facet(c), h = l.type.prop(SU);
        if (h) {
          let f = l.resolve(o - l.from, a);
          for (let d of h)
            if (d.test(f, s)) {
              let p = s.facet(d.facet);
              return d.type == "replace" ? p : p.concat(u);
            }
        }
        return u;
      })
    ].concat(r);
  }
  /**
  Query whether this language is active at the given position.
  */
  isActiveAt(e, n, r = -1) {
    return Lw(e, n, r).type.prop(Hl) == this.data;
  }
  /**
  Find the document regions that were parsed using this language.
  The returned regions will _include_ any nested languages rooted
  in this language, when those exist.
  */
  findRegions(e) {
    let n = e.facet(ys);
    if ((n == null ? void 0 : n.data) == this.data)
      return [{ from: 0, to: e.doc.length }];
    if (!n || !n.allowsNesting)
      return [];
    let r = [], i = (s, o) => {
      if (s.prop(Hl) == this.data) {
        r.push({ from: o, to: o + s.length });
        return;
      }
      let a = s.prop(Ne.mounted);
      if (a) {
        if (a.tree.prop(Hl) == this.data) {
          if (a.overlay)
            for (let l of a.overlay)
              r.push({ from: l.from + o, to: l.to + o });
          else
            r.push({ from: o, to: o + s.length });
          return;
        } else if (a.overlay) {
          let l = r.length;
          if (i(a.tree, a.overlay[0].from + o), r.length > l)
            return;
        }
      }
      for (let l = 0; l < s.children.length; l++) {
        let c = s.children[l];
        c instanceof Ht && i(c, s.positions[l] + o);
      }
    };
    return i(Wt(e), 0), r;
  }
  /**
  Indicates whether this language allows nested languages. The
  default implementation returns true.
  */
  get allowsNesting() {
    return !0;
  }
}
Ir.setState = /* @__PURE__ */ De.define();
function Lw(t, e, n) {
  let r = t.facet(ys), i = Wt(t).topNode;
  if (!r || r.allowsNesting)
    for (let s = i; s; s = s.enter(e, n, Ot.ExcludeBuffers))
      s.type.isTop && (i = s);
  return i;
}
function Wt(t) {
  let e = t.field(Ir.state, !1);
  return e ? e.tree : Ht.empty;
}
class MU {
  /**
  Create an input object for the given document.
  */
  constructor(e) {
    this.doc = e, this.cursorPos = 0, this.string = "", this.cursor = e.iter();
  }
  get length() {
    return this.doc.length;
  }
  syncTo(e) {
    return this.string = this.cursor.next(e - this.cursorPos).value, this.cursorPos = e + this.string.length, this.cursorPos - this.string.length;
  }
  chunk(e) {
    return this.syncTo(e), this.string;
  }
  get lineChunks() {
    return !0;
  }
  read(e, n) {
    let r = this.cursorPos - this.string.length;
    return e < r || n >= this.cursorPos ? this.doc.sliceString(e, n) : this.string.slice(e - r, n - r);
  }
}
let yl = null;
class Uh {
  constructor(e, n, r = [], i, s, o, a, l) {
    this.parser = e, this.state = n, this.fragments = r, this.tree = i, this.treeLen = s, this.viewport = o, this.skipped = a, this.scheduleOn = l, this.parse = null, this.tempSkipped = [];
  }
  /**
  @internal
  */
  static create(e, n, r) {
    return new Uh(e, n, [], Ht.empty, 0, r, [], null);
  }
  startParse() {
    return this.parser.startParse(new MU(this.state.doc), this.fragments);
  }
  /**
  @internal
  */
  work(e, n) {
    return n != null && n >= this.state.doc.length && (n = void 0), this.tree != Ht.empty && this.isDone(n != null ? n : this.state.doc.length) ? (this.takeTree(), !0) : this.withContext(() => {
      var r;
      if (typeof e == "number") {
        let i = Date.now() + e;
        e = () => Date.now() > i;
      }
      for (this.parse || (this.parse = this.startParse()), n != null && (this.parse.stoppedAt == null || this.parse.stoppedAt > n) && n < this.state.doc.length && this.parse.stopAt(n); ; ) {
        let i = this.parse.advance();
        if (i)
          if (this.fragments = this.withoutTempSkipped(Js.addTree(i, this.fragments, this.parse.stoppedAt != null)), this.treeLen = (r = this.parse.stoppedAt) !== null && r !== void 0 ? r : this.state.doc.length, this.tree = i, this.parse = null, this.treeLen < (n != null ? n : this.state.doc.length))
            this.parse = this.startParse();
          else
            return !0;
        if (e())
          return !1;
      }
    });
  }
  /**
  @internal
  */
  takeTree() {
    let e, n;
    this.parse && (e = this.parse.parsedPos) >= this.treeLen && ((this.parse.stoppedAt == null || this.parse.stoppedAt > e) && this.parse.stopAt(e), this.withContext(() => {
      for (; !(n = this.parse.advance()); )
        ;
    }), this.treeLen = e, this.tree = n, this.fragments = this.withoutTempSkipped(Js.addTree(this.tree, this.fragments, !0)), this.parse = null);
  }
  withContext(e) {
    let n = yl;
    yl = this;
    try {
      return e();
    } finally {
      yl = n;
    }
  }
  withoutTempSkipped(e) {
    for (let n; n = this.tempSkipped.pop(); )
      e = Nw(e, n.from, n.to);
    return e;
  }
  /**
  @internal
  */
  changes(e, n) {
    let { fragments: r, tree: i, treeLen: s, viewport: o, skipped: a } = this;
    if (this.takeTree(), !e.empty) {
      let l = [];
      if (e.iterChangedRanges((c, u, h, f) => l.push({ fromA: c, toA: u, fromB: h, toB: f })), r = Js.applyChanges(r, l), i = Ht.empty, s = 0, o = { from: e.mapPos(o.from, -1), to: e.mapPos(o.to, 1) }, this.skipped.length) {
        a = [];
        for (let c of this.skipped) {
          let u = e.mapPos(c.from, 1), h = e.mapPos(c.to, -1);
          u < h && a.push({ from: u, to: h });
        }
      }
    }
    return new Uh(this.parser, n, r, i, s, o, a, this.scheduleOn);
  }
  /**
  @internal
  */
  updateViewport(e) {
    if (this.viewport.from == e.from && this.viewport.to == e.to)
      return !1;
    this.viewport = e;
    let n = this.skipped.length;
    for (let r = 0; r < this.skipped.length; r++) {
      let { from: i, to: s } = this.skipped[r];
      i < e.to && s > e.from && (this.fragments = Nw(this.fragments, i, s), this.skipped.splice(r--, 1));
    }
    return this.skipped.length >= n ? !1 : (this.reset(), !0);
  }
  /**
  @internal
  */
  reset() {
    this.parse && (this.takeTree(), this.parse = null);
  }
  /**
  Notify the parse scheduler that the given region was skipped
  because it wasn't in view, and the parse should be restarted
  when it comes into view.
  */
  skipUntilInView(e, n) {
    this.skipped.push({ from: e, to: n });
  }
  /**
  Returns a parser intended to be used as placeholder when
  asynchronously loading a nested parser. It'll skip its input and
  mark it as not-really-parsed, so that the next update will parse
  it again.
  
  When `until` is given, a reparse will be scheduled when that
  promise resolves.
  */
  static getSkippingParser(e) {
    return new class extends dU {
      createParse(n, r, i) {
        let s = i[0].from, o = i[i.length - 1].to;
        return {
          parsedPos: s,
          advance() {
            let l = yl;
            if (l) {
              for (let c of i)
                l.tempSkipped.push(c);
              e && (l.scheduleOn = l.scheduleOn ? Promise.all([l.scheduleOn, e]) : e);
            }
            return this.parsedPos = o, new Ht(Qn.none, [], [], o - s);
          },
          stoppedAt: null,
          stopAt() {
          }
        };
      }
    }();
  }
  /**
  @internal
  */
  isDone(e) {
    e = Math.min(e, this.state.doc.length);
    let n = this.fragments;
    return this.treeLen >= e && n.length && n[0].from == 0 && n[0].to >= e;
  }
  /**
  Get the context for the current parse, or `null` if no editor
  parse is in progress.
  */
  static get() {
    return yl;
  }
}
function Nw(t, e, n) {
  return Js.applyChanges(t, [{ fromA: e, toA: n, fromB: e, toB: n }]);
}
class Da {
  constructor(e) {
    this.context = e, this.tree = e.tree;
  }
  apply(e) {
    if (!e.docChanged && this.tree == this.context.tree)
      return this;
    let n = this.context.changes(e.changes, e.state), r = this.context.treeLen == e.startState.doc.length ? void 0 : Math.max(e.changes.mapPos(this.context.treeLen), n.viewport.to);
    return n.work(20, r) || n.takeTree(), new Da(n);
  }
  static init(e) {
    let n = Math.min(3e3, e.doc.length), r = Uh.create(e.facet(ys).parser, e, { from: 0, to: n });
    return r.work(20, n) || r.takeTree(), new Da(r);
  }
}
Ir.state = /* @__PURE__ */ It.define({
  create: Da.init,
  update(t, e) {
    for (let n of e.effects)
      if (n.is(Ir.setState))
        return n.value;
    return e.startState.facet(ys) != e.state.facet(ys) ? Da.init(e.state) : t.apply(e);
  }
});
let J6 = (t) => {
  let e = setTimeout(
    () => t(),
    500
    /* Work.MaxPause */
  );
  return () => clearTimeout(e);
};
typeof requestIdleCallback != "undefined" && (J6 = (t) => {
  let e = -1, n = setTimeout(
    () => {
      e = requestIdleCallback(t, {
        timeout: 400
        /* Work.MinPause */
      });
    },
    100
    /* Work.MinPause */
  );
  return () => e < 0 ? clearTimeout(n) : cancelIdleCallback(e);
});
const Pm = typeof navigator != "undefined" && (!((Em = navigator.scheduling) === null || Em === void 0) && Em.isInputPending) ? () => navigator.scheduling.isInputPending() : null, CU = /* @__PURE__ */ dt.fromClass(class {
  constructor(e) {
    this.view = e, this.working = null, this.workScheduled = 0, this.chunkEnd = -1, this.chunkBudget = -1, this.work = this.work.bind(this), this.scheduleWork();
  }
  update(e) {
    let n = this.view.state.field(Ir.state).context;
    (n.updateViewport(e.view.viewport) || this.view.viewport.to > n.treeLen) && this.scheduleWork(), (e.docChanged || e.selectionSet) && (this.view.hasFocus && (this.chunkBudget += 50), this.scheduleWork()), this.checkAsyncSchedule(n);
  }
  scheduleWork() {
    if (this.working)
      return;
    let { state: e } = this.view, n = e.field(Ir.state);
    (n.tree != n.context.tree || !n.context.isDone(e.doc.length)) && (this.working = J6(this.work));
  }
  work(e) {
    this.working = null;
    let n = Date.now();
    if (this.chunkEnd < n && (this.chunkEnd < 0 || this.view.hasFocus) && (this.chunkEnd = n + 3e4, this.chunkBudget = 3e3), this.chunkBudget <= 0)
      return;
    let { state: r, viewport: { to: i } } = this.view, s = r.field(Ir.state);
    if (s.tree == s.context.tree && s.context.isDone(
      i + 1e5
      /* Work.MaxParseAhead */
    ))
      return;
    let o = Date.now() + Math.min(this.chunkBudget, 100, e && !Pm ? Math.max(25, e.timeRemaining() - 5) : 1e9), a = s.context.treeLen < i && r.doc.length > i + 1e3, l = s.context.work(() => Pm && Pm() || Date.now() > o, i + (a ? 0 : 1e5));
    this.chunkBudget -= Date.now() - n, (l || this.chunkBudget <= 0) && (s.context.takeTree(), this.view.dispatch({ effects: Ir.setState.of(new Da(s.context)) })), this.chunkBudget > 0 && !(l && !a) && this.scheduleWork(), this.checkAsyncSchedule(s.context);
  }
  checkAsyncSchedule(e) {
    e.scheduleOn && (this.workScheduled++, e.scheduleOn.then(() => this.scheduleWork()).catch((n) => un(this.view.state, n)).then(() => this.workScheduled--), e.scheduleOn = null);
  }
  destroy() {
    this.working && this.working();
  }
  isWorking() {
    return !!(this.working || this.workScheduled > 0);
  }
}, {
  eventHandlers: { focus() {
    this.scheduleWork();
  } }
}), ys = /* @__PURE__ */ ve.define({
  combine(t) {
    return t.length ? t[0] : null;
  },
  enables: (t) => [
    Ir.state,
    CU,
    de.contentAttributes.compute([t], (e) => {
      let n = e.facet(t);
      return n && n.name ? { "data-language": n.name } : {};
    })
  ]
}), $U = /* @__PURE__ */ ve.define(), cp = /* @__PURE__ */ ve.define({
  combine: (t) => {
    if (!t.length)
      return "  ";
    let e = t[0];
    if (!e || /\S/.test(e) || Array.from(e).some((n) => n != e[0]))
      throw new Error("Invalid indent unit: " + JSON.stringify(t[0]));
    return e;
  }
});
function Kh(t) {
  let e = t.facet(cp);
  return e.charCodeAt(0) == 9 ? t.tabSize * e.length : e.length;
}
function Nc(t, e) {
  let n = "", r = t.tabSize, i = t.facet(cp)[0];
  if (i == "	") {
    for (; e >= r; )
      n += "	", e -= r;
    i = " ";
  }
  for (let s = 0; s < e; s++)
    n += i;
  return n;
}
function ty(t, e) {
  t instanceof Le && (t = new up(t));
  for (let r of t.state.facet($U)) {
    let i = r(t, e);
    if (i !== void 0)
      return i;
  }
  let n = Wt(t.state);
  return n.length >= e ? DU(t, n, e) : null;
}
class up {
  /**
  Create an indent context.
  */
  constructor(e, n = {}) {
    this.state = e, this.options = n, this.unit = Kh(e);
  }
  /**
  Get a description of the line at the given position, taking
  [simulated line
  breaks](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
  into account. If there is such a break at `pos`, the `bias`
  argument determines whether the part of the line line before or
  after the break is used.
  */
  lineAt(e, n = 1) {
    let r = this.state.doc.lineAt(e), { simulateBreak: i, simulateDoubleBreak: s } = this.options;
    return i != null && i >= r.from && i <= r.to ? s && i == e ? { text: "", from: e } : (n < 0 ? i < e : i <= e) ? { text: r.text.slice(i - r.from), from: i } : { text: r.text.slice(0, i - r.from), from: r.from } : r;
  }
  /**
  Get the text directly after `pos`, either the entire line
  or the next 100 characters, whichever is shorter.
  */
  textAfterPos(e, n = 1) {
    if (this.options.simulateDoubleBreak && e == this.options.simulateBreak)
      return "";
    let { text: r, from: i } = this.lineAt(e, n);
    return r.slice(e - i, Math.min(r.length, e + 100 - i));
  }
  /**
  Find the column for the given position.
  */
  column(e, n = 1) {
    let { text: r, from: i } = this.lineAt(e, n), s = this.countColumn(r, e - i), o = this.options.overrideIndentation ? this.options.overrideIndentation(i) : -1;
    return o > -1 && (s += o - this.countColumn(r, r.search(/\S|$/))), s;
  }
  /**
  Find the column position (taking tabs into account) of the given
  position in the given string.
  */
  countColumn(e, n = e.length) {
    return Ua(e, this.state.tabSize, n);
  }
  /**
  Find the indentation column of the line at the given point.
  */
  lineIndent(e, n = 1) {
    let { text: r, from: i } = this.lineAt(e, n), s = this.options.overrideIndentation;
    if (s) {
      let o = s(i);
      if (o > -1)
        return o;
    }
    return this.countColumn(r, r.search(/\S|$/));
  }
  /**
  Returns the [simulated line
  break](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
  for this context, if any.
  */
  get simulatedBreak() {
    return this.options.simulateBreak || null;
  }
}
const AU = /* @__PURE__ */ new Ne();
function DU(t, e, n) {
  let r = e.resolveStack(n), i = r.node.enterUnfinishedNodesBefore(n);
  if (i != r.node) {
    let s = [];
    for (let o = i; o != r.node; o = o.parent)
      s.push(o);
    for (let o = s.length - 1; o >= 0; o--)
      r = { node: s[o], next: r };
  }
  return Q6(r, t, n);
}
function Q6(t, e, n) {
  for (let r = t; r; r = r.next) {
    let i = OU(r.node);
    if (i)
      return i(ny.create(e, n, r));
  }
  return 0;
}
function TU(t) {
  return t.pos == t.options.simulateBreak && t.options.simulateDoubleBreak;
}
function OU(t) {
  let e = t.type.prop(AU);
  if (e)
    return e;
  let n = t.firstChild, r;
  if (n && (r = n.type.prop(Ne.closedBy))) {
    let i = t.lastChild, s = i && r.indexOf(i.name) > -1;
    return (o) => NU(o, !0, 1, void 0, s && !TU(o) ? i.from : void 0);
  }
  return t.parent == null ? EU : null;
}
function EU() {
  return 0;
}
class ny extends up {
  constructor(e, n, r) {
    super(e.state, e.options), this.base = e, this.pos = n, this.context = r;
  }
  /**
  The syntax tree node to which the indentation strategy
  applies.
  */
  get node() {
    return this.context.node;
  }
  /**
  @internal
  */
  static create(e, n, r) {
    return new ny(e, n, r);
  }
  /**
  Get the text directly after `this.pos`, either the entire line
  or the next 100 characters, whichever is shorter.
  */
  get textAfter() {
    return this.textAfterPos(this.pos);
  }
  /**
  Get the indentation at the reference line for `this.node`, which
  is the line on which it starts, unless there is a node that is
  _not_ a parent of this node covering the start of that line. If
  so, the line at the start of that node is tried, again skipping
  on if it is covered by another such node.
  */
  get baseIndent() {
    return this.baseIndentFor(this.node);
  }
  /**
  Get the indentation for the reference line of the given node
  (see [`baseIndent`](https://codemirror.net/6/docs/ref/#language.TreeIndentContext.baseIndent)).
  */
  baseIndentFor(e) {
    let n = this.state.doc.lineAt(e.from);
    for (; ; ) {
      let r = e.resolve(n.from);
      for (; r.parent && r.parent.from == r.from; )
        r = r.parent;
      if (PU(r, e))
        break;
      n = this.state.doc.lineAt(r.from);
    }
    return this.lineIndent(n.from);
  }
  /**
  Continue looking for indentations in the node's parent nodes,
  and return the result of that.
  */
  continue() {
    return Q6(this.context.next, this.base, this.pos);
  }
}
function PU(t, e) {
  for (let n = e; n; n = n.parent)
    if (t == n)
      return !0;
  return !1;
}
function LU(t) {
  let e = t.node, n = e.childAfter(e.from), r = e.lastChild;
  if (!n)
    return null;
  let i = t.options.simulateBreak, s = t.state.doc.lineAt(n.from), o = i == null || i <= s.from ? s.to : Math.min(s.to, i);
  for (let a = n.to; ; ) {
    let l = e.childAfter(a);
    if (!l || l == r)
      return null;
    if (!l.type.isSkipped)
      return l.from < o ? n : null;
    a = l.to;
  }
}
function NU(t, e, n, r, i) {
  let s = t.textAfter, o = s.match(/^\s*/)[0].length, a = i == t.pos + o, l = LU(t);
  return l ? a ? t.column(l.from) : t.column(l.to) : t.baseIndent + (a ? 0 : t.unit * n);
}
const IU = 200;
function RU() {
  return Le.transactionFilter.of((t) => {
    if (!t.docChanged || !t.isUserEvent("input.type") && !t.isUserEvent("input.complete"))
      return t;
    let e = t.startState.languageDataAt("indentOnInput", t.startState.selection.main.head);
    if (!e.length)
      return t;
    let n = t.newDoc, { head: r } = t.newSelection.main, i = n.lineAt(r);
    if (r > i.from + IU)
      return t;
    let s = n.sliceString(i.from, r);
    if (!e.some((c) => c.test(s)))
      return t;
    let { state: o } = t, a = -1, l = [];
    for (let { head: c } of o.selection.ranges) {
      let u = o.doc.lineAt(c);
      if (u.from == a)
        continue;
      a = u.from;
      let h = ty(o, u.from);
      if (h == null)
        continue;
      let f = /^\s*/.exec(u.text)[0], d = Nc(o, h);
      f != d && l.push({ from: u.from, to: u.from + f.length, insert: d });
    }
    return l.length ? [t, { changes: l, sequential: !0 }] : t;
  });
}
const BU = /* @__PURE__ */ ve.define(), FU = /* @__PURE__ */ new Ne();
function zU(t, e, n) {
  let r = Wt(t);
  if (r.length < n)
    return null;
  let i = r.resolveStack(n, 1), s = null;
  for (let o = i; o; o = o.next) {
    let a = o.node;
    if (a.to <= n || a.from > n)
      continue;
    if (s && a.from < e)
      break;
    let l = a.type.prop(FU);
    if (l && (a.to < r.length - 50 || r.length == t.doc.length || !VU(a))) {
      let c = l(a, t);
      c && c.from <= n && c.from >= e && c.to > n && (s = c);
    }
  }
  return s;
}
function VU(t) {
  let e = t.lastChild;
  return e && e.to == t.to && e.type.isError;
}
function Gh(t, e, n) {
  for (let r of t.facet(BU)) {
    let i = r(t, e, n);
    if (i)
      return i;
  }
  return zU(t, e, n);
}
function e$(t, e) {
  let n = e.mapPos(t.from, 1), r = e.mapPos(t.to, -1);
  return n >= r ? void 0 : { from: n, to: r };
}
const fp = /* @__PURE__ */ De.define({ map: e$ }), ku = /* @__PURE__ */ De.define({ map: e$ });
function t$(t) {
  let e = [];
  for (let { head: n } of t.state.selection.ranges)
    e.some((r) => r.from <= n && r.to >= n) || e.push(t.lineBlockAt(n));
  return e;
}
const yo = /* @__PURE__ */ It.define({
  create() {
    return we.none;
  },
  update(t, e) {
    t = t.map(e.changes);
    for (let n of e.effects)
      if (n.is(fp) && !HU(t, n.value.from, n.value.to)) {
        let { preparePlaceholder: r } = e.state.facet(i$), i = r ? we.replace({ widget: new GU(r(e.state, n.value)) }) : Iw;
        t = t.update({ add: [i.range(n.value.from, n.value.to)] });
      } else n.is(ku) && (t = t.update({
        filter: (r, i) => n.value.from != r || n.value.to != i,
        filterFrom: n.value.from,
        filterTo: n.value.to
      }));
    if (e.selection) {
      let n = !1, { head: r } = e.selection.main;
      t.between(r, r, (i, s) => {
        i < r && s > r && (n = !0);
      }), n && (t = t.update({
        filterFrom: r,
        filterTo: r,
        filter: (i, s) => s <= r || i >= r
      }));
    }
    return t;
  },
  provide: (t) => de.decorations.from(t),
  toJSON(t, e) {
    let n = [];
    return t.between(0, e.doc.length, (r, i) => {
      n.push(r, i);
    }), n;
  },
  fromJSON(t) {
    if (!Array.isArray(t) || t.length % 2)
      throw new RangeError("Invalid JSON for fold state");
    let e = [];
    for (let n = 0; n < t.length; ) {
      let r = t[n++], i = t[n++];
      if (typeof r != "number" || typeof i != "number")
        throw new RangeError("Invalid JSON for fold state");
      e.push(Iw.range(r, i));
    }
    return we.set(e, !0);
  }
});
function Xh(t, e, n) {
  var r;
  let i = null;
  return (r = t.field(yo, !1)) === null || r === void 0 || r.between(e, n, (s, o) => {
    (!i || i.from > s) && (i = { from: s, to: o });
  }), i;
}
function HU(t, e, n) {
  let r = !1;
  return t.between(e, e, (i, s) => {
    i == e && s == n && (r = !0);
  }), r;
}
function n$(t, e) {
  return t.field(yo, !1) ? e : e.concat(De.appendConfig.of(s$()));
}
const YU = (t) => {
  for (let e of t$(t)) {
    let n = Gh(t.state, e.from, e.to);
    if (n)
      return t.dispatch({ effects: n$(t.state, [fp.of(n), r$(t, n)]) }), !0;
  }
  return !1;
}, WU = (t) => {
  if (!t.state.field(yo, !1))
    return !1;
  let e = [];
  for (let n of t$(t)) {
    let r = Xh(t.state, n.from, n.to);
    r && e.push(ku.of(r), r$(t, r, !1));
  }
  return e.length && t.dispatch({ effects: e }), e.length > 0;
};
function r$(t, e, n = !0) {
  let r = t.state.doc.lineAt(e.from).number, i = t.state.doc.lineAt(e.to).number;
  return de.announce.of(`${t.state.phrase(n ? "Folded lines" : "Unfolded lines")} ${r} ${t.state.phrase("to")} ${i}.`);
}
const jU = (t) => {
  let { state: e } = t, n = [];
  for (let r = 0; r < e.doc.length; ) {
    let i = t.lineBlockAt(r), s = Gh(e, i.from, i.to);
    s && n.push(fp.of(s)), r = (s ? t.lineBlockAt(s.to) : i).to + 1;
  }
  return n.length && t.dispatch({ effects: n$(t.state, n) }), !!n.length;
}, qU = (t) => {
  let e = t.state.field(yo, !1);
  if (!e || !e.size)
    return !1;
  let n = [];
  return e.between(0, t.state.doc.length, (r, i) => {
    n.push(ku.of({ from: r, to: i }));
  }), t.dispatch({ effects: n }), !0;
}, UU = [
  { key: "Ctrl-Shift-[", mac: "Cmd-Alt-[", run: YU },
  { key: "Ctrl-Shift-]", mac: "Cmd-Alt-]", run: WU },
  { key: "Ctrl-Alt-[", run: jU },
  { key: "Ctrl-Alt-]", run: qU }
], KU = {
  placeholderDOM: null,
  preparePlaceholder: null,
  placeholderText: "…"
}, i$ = /* @__PURE__ */ ve.define({
  combine(t) {
    return Jr(t, KU);
  }
});
function s$(t) {
  return [yo, JU];
}
function o$(t, e) {
  let { state: n } = t, r = n.facet(i$), i = (o) => {
    let a = t.lineBlockAt(t.posAtDOM(o.target)), l = Xh(t.state, a.from, a.to);
    l && t.dispatch({ effects: ku.of(l) }), o.preventDefault();
  };
  if (r.placeholderDOM)
    return r.placeholderDOM(t, i, e);
  let s = document.createElement("span");
  return s.textContent = r.placeholderText, s.setAttribute("aria-label", n.phrase("folded code")), s.title = n.phrase("unfold"), s.className = "cm-foldPlaceholder", s.onclick = i, s;
}
const Iw = /* @__PURE__ */ we.replace({ widget: /* @__PURE__ */ new class extends Oi {
  toDOM(t) {
    return o$(t, null);
  }
}() });
class GU extends Oi {
  constructor(e) {
    super(), this.value = e;
  }
  eq(e) {
    return this.value == e.value;
  }
  toDOM(e) {
    return o$(e, this.value);
  }
}
const XU = {
  openText: "⌄",
  closedText: "›",
  markerDOM: null,
  domEventHandlers: {},
  foldingChanged: () => !1
};
class Lm extends Si {
  constructor(e, n) {
    super(), this.config = e, this.open = n;
  }
  eq(e) {
    return this.config == e.config && this.open == e.open;
  }
  toDOM(e) {
    if (this.config.markerDOM)
      return this.config.markerDOM(this.open);
    let n = document.createElement("span");
    return n.textContent = this.open ? this.config.openText : this.config.closedText, n.title = e.state.phrase(this.open ? "Fold line" : "Unfold line"), n;
  }
}
function ZU(t = {}) {
  let e = Object.assign(Object.assign({}, XU), t), n = new Lm(e, !0), r = new Lm(e, !1), i = dt.fromClass(class {
    constructor(o) {
      this.from = o.viewport.from, this.markers = this.buildMarkers(o);
    }
    update(o) {
      (o.docChanged || o.viewportChanged || o.startState.facet(ys) != o.state.facet(ys) || o.startState.field(yo, !1) != o.state.field(yo, !1) || Wt(o.startState) != Wt(o.state) || e.foldingChanged(o)) && (this.markers = this.buildMarkers(o.view));
    }
    buildMarkers(o) {
      let a = new ds();
      for (let l of o.viewportLineBlocks) {
        let c = Xh(o.state, l.from, l.to) ? r : Gh(o.state, l.from, l.to) ? n : null;
        c && a.add(l.from, l.from, c);
      }
      return a.finish();
    }
  }), { domEventHandlers: s } = e;
  return [
    i,
    Xq({
      class: "cm-foldGutter",
      markers(o) {
        var a;
        return ((a = o.plugin(i)) === null || a === void 0 ? void 0 : a.markers) || Be.empty;
      },
      initialSpacer() {
        return new Lm(e, !1);
      },
      domEventHandlers: Object.assign(Object.assign({}, s), { click: (o, a, l) => {
        if (s.click && s.click(o, a, l))
          return !0;
        let c = Xh(o.state, a.from, a.to);
        if (c)
          return o.dispatch({ effects: ku.of(c) }), !0;
        let u = Gh(o.state, a.from, a.to);
        return u ? (o.dispatch({ effects: fp.of(u) }), !0) : !1;
      } })
    }),
    s$()
  ];
}
const JU = /* @__PURE__ */ de.baseTheme({
  ".cm-foldPlaceholder": {
    backgroundColor: "#eee",
    border: "1px solid #ddd",
    color: "#888",
    borderRadius: ".2em",
    margin: "0 1px",
    padding: "0 1px",
    cursor: "pointer"
  },
  ".cm-foldGutter span": {
    padding: "0 1px",
    cursor: "pointer"
  }
});
class hp {
  constructor(e, n) {
    this.specs = e;
    let r;
    function i(a) {
      let l = ps.newName();
      return (r || (r = /* @__PURE__ */ Object.create(null)))["." + l] = a, l;
    }
    const s = typeof n.all == "string" ? n.all : n.all ? i(n.all) : void 0, o = n.scope;
    this.scope = o instanceof Ir ? (a) => a.prop(Hl) == o.data : o ? (a) => a == o : void 0, this.style = Z6(e.map((a) => ({
      tag: a.tag,
      class: a.class || i(Object.assign({}, a, { tag: null }))
    })), {
      all: s
    }).style, this.module = r ? new ps(r) : null, this.themeType = n.themeType;
  }
  /**
  Create a highlighter style that associates the given styles to
  the given tags. The specs must be objects that hold a style tag
  or array of tags in their `tag` property, and either a single
  `class` property providing a static CSS class (for highlighter
  that rely on external styling), or a
  [`style-mod`](https://github.com/marijnh/style-mod#documentation)-style
  set of CSS properties (which define the styling for those tags).
  
  The CSS rules created for a highlighter will be emitted in the
  order of the spec's properties. That means that for elements that
  have multiple tags associated with them, styles defined further
  down in the list will have a higher CSS precedence than styles
  defined earlier.
  */
  static define(e, n) {
    return new hp(e, n || {});
  }
}
const X0 = /* @__PURE__ */ ve.define(), a$ = /* @__PURE__ */ ve.define({
  combine(t) {
    return t.length ? [t[0]] : null;
  }
});
function Nm(t) {
  let e = t.facet(X0);
  return e.length ? e : t.facet(a$);
}
function QU(t, e) {
  let n = [tK], r;
  return t instanceof hp && (t.module && n.push(de.styleModule.of(t.module)), r = t.themeType), e != null && e.fallback ? n.push(a$.of(t)) : r ? n.push(X0.computeN([de.darkTheme], (i) => i.facet(de.darkTheme) == (r == "dark") ? [t] : [])) : n.push(X0.of(t)), n;
}
class eK {
  constructor(e) {
    this.markCache = /* @__PURE__ */ Object.create(null), this.tree = Wt(e.state), this.decorations = this.buildDeco(e, Nm(e.state)), this.decoratedTo = e.viewport.to;
  }
  update(e) {
    let n = Wt(e.state), r = Nm(e.state), i = r != Nm(e.startState), { viewport: s } = e.view, o = e.changes.mapPos(this.decoratedTo, 1);
    n.length < s.to && !i && n.type == this.tree.type && o >= s.to ? (this.decorations = this.decorations.map(e.changes), this.decoratedTo = o) : (n != this.tree || e.viewportChanged || i) && (this.tree = n, this.decorations = this.buildDeco(e.view, r), this.decoratedTo = s.to);
  }
  buildDeco(e, n) {
    if (!n || !this.tree.length)
      return we.none;
    let r = new ds();
    for (let { from: i, to: s } of e.visibleRanges)
      wU(this.tree, n, (o, a, l) => {
        r.add(o, a, this.markCache[l] || (this.markCache[l] = we.mark({ class: l })));
      }, i, s);
    return r.finish();
  }
}
const tK = /* @__PURE__ */ $o.high(/* @__PURE__ */ dt.fromClass(eK, {
  decorations: (t) => t.decorations
})), nK = /* @__PURE__ */ hp.define([
  {
    tag: fe.meta,
    color: "#404740"
  },
  {
    tag: fe.link,
    textDecoration: "underline"
  },
  {
    tag: fe.heading,
    textDecoration: "underline",
    fontWeight: "bold"
  },
  {
    tag: fe.emphasis,
    fontStyle: "italic"
  },
  {
    tag: fe.strong,
    fontWeight: "bold"
  },
  {
    tag: fe.strikethrough,
    textDecoration: "line-through"
  },
  {
    tag: fe.keyword,
    color: "#708"
  },
  {
    tag: [fe.atom, fe.bool, fe.url, fe.contentSeparator, fe.labelName],
    color: "#219"
  },
  {
    tag: [fe.literal, fe.inserted],
    color: "#164"
  },
  {
    tag: [fe.string, fe.deleted],
    color: "#a11"
  },
  {
    tag: [fe.regexp, fe.escape, /* @__PURE__ */ fe.special(fe.string)],
    color: "#e40"
  },
  {
    tag: /* @__PURE__ */ fe.definition(fe.variableName),
    color: "#00f"
  },
  {
    tag: /* @__PURE__ */ fe.local(fe.variableName),
    color: "#30a"
  },
  {
    tag: [fe.typeName, fe.namespace],
    color: "#085"
  },
  {
    tag: fe.className,
    color: "#167"
  },
  {
    tag: [/* @__PURE__ */ fe.special(fe.variableName), fe.macroName],
    color: "#256"
  },
  {
    tag: /* @__PURE__ */ fe.definition(fe.propertyName),
    color: "#00c"
  },
  {
    tag: fe.comment,
    color: "#940"
  },
  {
    tag: fe.invalid,
    color: "#f00"
  }
]), rK = /* @__PURE__ */ de.baseTheme({
  "&.cm-focused .cm-matchingBracket": { backgroundColor: "#328c8252" },
  "&.cm-focused .cm-nonmatchingBracket": { backgroundColor: "#bb555544" }
}), l$ = 1e4, c$ = "()[]{}", u$ = /* @__PURE__ */ ve.define({
  combine(t) {
    return Jr(t, {
      afterCursor: !0,
      brackets: c$,
      maxScanDistance: l$,
      renderMatch: oK
    });
  }
}), iK = /* @__PURE__ */ we.mark({ class: "cm-matchingBracket" }), sK = /* @__PURE__ */ we.mark({ class: "cm-nonmatchingBracket" });
function oK(t) {
  let e = [], n = t.matched ? iK : sK;
  return e.push(n.range(t.start.from, t.start.to)), t.end && e.push(n.range(t.end.from, t.end.to)), e;
}
const aK = /* @__PURE__ */ It.define({
  create() {
    return we.none;
  },
  update(t, e) {
    if (!e.docChanged && !e.selection)
      return t;
    let n = [], r = e.state.facet(u$);
    for (let i of e.state.selection.ranges) {
      if (!i.empty)
        continue;
      let s = Rr(e.state, i.head, -1, r) || i.head > 0 && Rr(e.state, i.head - 1, 1, r) || r.afterCursor && (Rr(e.state, i.head, 1, r) || i.head < e.state.doc.length && Rr(e.state, i.head + 1, -1, r));
      s && (n = n.concat(r.renderMatch(s, e.state)));
    }
    return we.set(n, !0);
  },
  provide: (t) => de.decorations.from(t)
}), lK = [
  aK,
  rK
];
function cK(t = {}) {
  return [u$.of(t), lK];
}
const uK = /* @__PURE__ */ new Ne();
function Z0(t, e, n) {
  let r = t.prop(e < 0 ? Ne.openedBy : Ne.closedBy);
  if (r)
    return r;
  if (t.name.length == 1) {
    let i = n.indexOf(t.name);
    if (i > -1 && i % 2 == (e < 0 ? 1 : 0))
      return [n[i + e]];
  }
  return null;
}
function J0(t) {
  let e = t.type.prop(uK);
  return e ? e(t.node) : t;
}
function Rr(t, e, n, r = {}) {
  let i = r.maxScanDistance || l$, s = r.brackets || c$, o = Wt(t), a = o.resolveInner(e, n);
  for (let l = a; l; l = l.parent) {
    let c = Z0(l.type, n, s);
    if (c && l.from < l.to) {
      let u = J0(l);
      if (u && (n > 0 ? e >= u.from && e < u.to : e > u.from && e <= u.to))
        return fK(t, e, n, l, u, c, s);
    }
  }
  return hK(t, e, n, o, a.type, i, s);
}
function fK(t, e, n, r, i, s, o) {
  let a = r.parent, l = { from: i.from, to: i.to }, c = 0, u = a == null ? void 0 : a.cursor();
  if (u && (n < 0 ? u.childBefore(r.from) : u.childAfter(r.to)))
    do
      if (n < 0 ? u.to <= r.from : u.from >= r.to) {
        if (c == 0 && s.indexOf(u.type.name) > -1 && u.from < u.to) {
          let h = J0(u);
          return { start: l, end: h ? { from: h.from, to: h.to } : void 0, matched: !0 };
        } else if (Z0(u.type, n, o))
          c++;
        else if (Z0(u.type, -n, o)) {
          if (c == 0) {
            let h = J0(u);
            return {
              start: l,
              end: h && h.from < h.to ? { from: h.from, to: h.to } : void 0,
              matched: !1
            };
          }
          c--;
        }
      }
    while (n < 0 ? u.prevSibling() : u.nextSibling());
  return { start: l, matched: !1 };
}
function hK(t, e, n, r, i, s, o) {
  let a = n < 0 ? t.sliceDoc(e - 1, e) : t.sliceDoc(e, e + 1), l = o.indexOf(a);
  if (l < 0 || l % 2 == 0 != n > 0)
    return null;
  let c = { from: n < 0 ? e - 1 : e, to: n > 0 ? e + 1 : e }, u = t.doc.iterRange(e, n > 0 ? t.doc.length : 0), h = 0;
  for (let f = 0; !u.next().done && f <= s; ) {
    let d = u.value;
    n < 0 && (f += d.length);
    let p = e + f * n;
    for (let m = n > 0 ? 0 : d.length - 1, v = n > 0 ? d.length : -1; m != v; m += n) {
      let g = o.indexOf(d[m]);
      if (!(g < 0 || r.resolveInner(p + m, 1).type != i))
        if (g % 2 == 0 == n > 0)
          h++;
        else {
          if (h == 1)
            return { start: c, end: { from: p + m, to: p + m + 1 }, matched: g >> 1 == l >> 1 };
          h--;
        }
    }
    n > 0 && (f += d.length);
  }
  return u.done ? { start: c, matched: !1 } : null;
}
const dK = /* @__PURE__ */ Object.create(null), Rw = [Qn.none], Bw = [], Fw = /* @__PURE__ */ Object.create(null), pK = /* @__PURE__ */ Object.create(null);
for (let [t, e] of [
  ["variable", "variableName"],
  ["variable-2", "variableName.special"],
  ["string-2", "string.special"],
  ["def", "variableName.definition"],
  ["tag", "tagName"],
  ["attribute", "attributeName"],
  ["type", "typeName"],
  ["builtin", "variableName.standard"],
  ["qualifier", "modifier"],
  ["error", "invalid"],
  ["header", "heading"],
  ["property", "propertyName"]
])
  pK[t] = /* @__PURE__ */ mK(dK, e);
function Im(t, e) {
  Bw.indexOf(t) > -1 || (Bw.push(t), console.warn(e));
}
function mK(t, e) {
  let n = [];
  for (let a of e.split(" ")) {
    let l = [];
    for (let c of a.split(".")) {
      let u = t[c] || fe[c];
      u ? typeof u == "function" ? l.length ? l = l.map(u) : Im(c, `Modifier ${c} used at start of tag`) : l.length ? Im(c, `Tag ${c} used as modifier`) : l = Array.isArray(u) ? u : [u] : Im(c, `Unknown highlighting tag ${c}`);
    }
    for (let c of l)
      n.push(c);
  }
  if (!n.length)
    return 0;
  let r = e.replace(/ /g, "_"), i = r + " " + n.map((a) => a.id), s = Fw[i];
  if (s)
    return s.id;
  let o = Fw[i] = Qn.define({
    id: Rw.length,
    name: r,
    props: [bU({ [r]: n })]
  });
  return Rw.push(o), o.id;
}
Qe.RTL, Qe.LTR;
const gK = (t) => {
  let { state: e } = t, n = e.doc.lineAt(e.selection.main.from), r = iy(t.state, n.from);
  return r.line ? vK(t) : r.block ? bK(t) : !1;
};
function ry(t, e) {
  return ({ state: n, dispatch: r }) => {
    if (n.readOnly)
      return !1;
    let i = t(e, n);
    return i ? (r(n.update(i)), !0) : !1;
  };
}
const vK = /* @__PURE__ */ ry(
  kK,
  0
  /* CommentOption.Toggle */
), yK = /* @__PURE__ */ ry(
  f$,
  0
  /* CommentOption.Toggle */
), bK = /* @__PURE__ */ ry(
  (t, e) => f$(t, e, wK(e)),
  0
  /* CommentOption.Toggle */
);
function iy(t, e) {
  let n = t.languageDataAt("commentTokens", e);
  return n.length ? n[0] : {};
}
const bl = 50;
function xK(t, { open: e, close: n }, r, i) {
  let s = t.sliceDoc(r - bl, r), o = t.sliceDoc(i, i + bl), a = /\s*$/.exec(s)[0].length, l = /^\s*/.exec(o)[0].length, c = s.length - a;
  if (s.slice(c - e.length, c) == e && o.slice(l, l + n.length) == n)
    return {
      open: { pos: r - a, margin: a && 1 },
      close: { pos: i + l, margin: l && 1 }
    };
  let u, h;
  i - r <= 2 * bl ? u = h = t.sliceDoc(r, i) : (u = t.sliceDoc(r, r + bl), h = t.sliceDoc(i - bl, i));
  let f = /^\s*/.exec(u)[0].length, d = /\s*$/.exec(h)[0].length, p = h.length - d - n.length;
  return u.slice(f, f + e.length) == e && h.slice(p, p + n.length) == n ? {
    open: {
      pos: r + f + e.length,
      margin: /\s/.test(u.charAt(f + e.length)) ? 1 : 0
    },
    close: {
      pos: i - d - n.length,
      margin: /\s/.test(h.charAt(p - 1)) ? 1 : 0
    }
  } : null;
}
function wK(t) {
  let e = [];
  for (let n of t.selection.ranges) {
    let r = t.doc.lineAt(n.from), i = n.to <= r.to ? r : t.doc.lineAt(n.to), s = e.length - 1;
    s >= 0 && e[s].to > r.from ? e[s].to = i.to : e.push({ from: r.from + /^\s*/.exec(r.text)[0].length, to: i.to });
  }
  return e;
}
function f$(t, e, n = e.selection.ranges) {
  let r = n.map((s) => iy(e, s.from).block);
  if (!r.every((s) => s))
    return null;
  let i = n.map((s, o) => xK(e, r[o], s.from, s.to));
  if (t != 2 && !i.every((s) => s))
    return { changes: e.changes(n.map((s, o) => i[o] ? [] : [{ from: s.from, insert: r[o].open + " " }, { from: s.to, insert: " " + r[o].close }])) };
  if (t != 1 && i.some((s) => s)) {
    let s = [];
    for (let o = 0, a; o < i.length; o++)
      if (a = i[o]) {
        let l = r[o], { open: c, close: u } = a;
        s.push({ from: c.pos - l.open.length, to: c.pos + c.margin }, { from: u.pos - u.margin, to: u.pos + l.close.length });
      }
    return { changes: s };
  }
  return null;
}
function kK(t, e, n = e.selection.ranges) {
  let r = [], i = -1;
  for (let { from: s, to: o } of n) {
    let a = r.length, l = 1e9, c = iy(e, s).line;
    if (c) {
      for (let u = s; u <= o; ) {
        let h = e.doc.lineAt(u);
        if (h.from > i && (s == o || o > h.from)) {
          i = h.from;
          let f = /^\s*/.exec(h.text)[0].length, d = f == h.length, p = h.text.slice(f, f + c.length) == c ? f : -1;
          f < h.text.length && f < l && (l = f), r.push({ line: h, comment: p, token: c, indent: f, empty: d, single: !1 });
        }
        u = h.to + 1;
      }
      if (l < 1e9)
        for (let u = a; u < r.length; u++)
          r[u].indent < r[u].line.text.length && (r[u].indent = l);
      r.length == a + 1 && (r[a].single = !0);
    }
  }
  if (t != 2 && r.some((s) => s.comment < 0 && (!s.empty || s.single))) {
    let s = [];
    for (let { line: a, token: l, indent: c, empty: u, single: h } of r)
      (h || !u) && s.push({ from: a.from + c, insert: l + " " });
    let o = e.changes(s);
    return { changes: o, selection: e.selection.map(o, 1) };
  } else if (t != 1 && r.some((s) => s.comment >= 0)) {
    let s = [];
    for (let { line: o, comment: a, token: l } of r)
      if (a >= 0) {
        let c = o.from + a, u = c + l.length;
        o.text[u - o.from] == " " && u++, s.push({ from: c, to: u });
      }
    return { changes: s };
  }
  return null;
}
const Q0 = /* @__PURE__ */ Ti.define(), _K = /* @__PURE__ */ Ti.define(), SK = /* @__PURE__ */ ve.define(), h$ = /* @__PURE__ */ ve.define({
  combine(t) {
    return Jr(t, {
      minDepth: 100,
      newGroupDelay: 500,
      joinToEvent: (e, n) => n
    }, {
      minDepth: Math.max,
      newGroupDelay: Math.min,
      joinToEvent: (e, n) => (r, i) => e(r, i) || n(r, i)
    });
  }
}), d$ = /* @__PURE__ */ It.define({
  create() {
    return Br.empty;
  },
  update(t, e) {
    let n = e.state.facet(h$), r = e.annotation(Q0);
    if (r) {
      let l = fn.fromTransaction(e, r.selection), c = r.side, u = c == 0 ? t.undone : t.done;
      return l ? u = Zh(u, u.length, n.minDepth, l) : u = g$(u, e.startState.selection), new Br(c == 0 ? r.rest : u, c == 0 ? u : r.rest);
    }
    let i = e.annotation(_K);
    if ((i == "full" || i == "before") && (t = t.isolate()), e.annotation(vt.addToHistory) === !1)
      return e.changes.empty ? t : t.addMapping(e.changes.desc);
    let s = fn.fromTransaction(e), o = e.annotation(vt.time), a = e.annotation(vt.userEvent);
    return s ? t = t.addChanges(s, o, a, n, e) : e.selection && (t = t.addSelection(e.startState.selection, o, a, n.newGroupDelay)), (i == "full" || i == "after") && (t = t.isolate()), t;
  },
  toJSON(t) {
    return { done: t.done.map((e) => e.toJSON()), undone: t.undone.map((e) => e.toJSON()) };
  },
  fromJSON(t) {
    return new Br(t.done.map(fn.fromJSON), t.undone.map(fn.fromJSON));
  }
});
function MK(t = {}) {
  return [
    d$,
    h$.of(t),
    de.domEventHandlers({
      beforeinput(e, n) {
        let r = e.inputType == "historyUndo" ? p$ : e.inputType == "historyRedo" ? ev : null;
        return r ? (e.preventDefault(), r(n)) : !1;
      }
    })
  ];
}
function dp(t, e) {
  return function({ state: n, dispatch: r }) {
    if (!e && n.readOnly)
      return !1;
    let i = n.field(d$, !1);
    if (!i)
      return !1;
    let s = i.pop(t, n, e);
    return s ? (r(s), !0) : !1;
  };
}
const p$ = /* @__PURE__ */ dp(0, !1), ev = /* @__PURE__ */ dp(1, !1), CK = /* @__PURE__ */ dp(0, !0), $K = /* @__PURE__ */ dp(1, !0);
class fn {
  constructor(e, n, r, i, s) {
    this.changes = e, this.effects = n, this.mapped = r, this.startSelection = i, this.selectionsAfter = s;
  }
  setSelAfter(e) {
    return new fn(this.changes, this.effects, this.mapped, this.startSelection, e);
  }
  toJSON() {
    var e, n, r;
    return {
      changes: (e = this.changes) === null || e === void 0 ? void 0 : e.toJSON(),
      mapped: (n = this.mapped) === null || n === void 0 ? void 0 : n.toJSON(),
      startSelection: (r = this.startSelection) === null || r === void 0 ? void 0 : r.toJSON(),
      selectionsAfter: this.selectionsAfter.map((i) => i.toJSON())
    };
  }
  static fromJSON(e) {
    return new fn(e.changes && mt.fromJSON(e.changes), [], e.mapped && Yr.fromJSON(e.mapped), e.startSelection && W.fromJSON(e.startSelection), e.selectionsAfter.map(W.fromJSON));
  }
  // This does not check `addToHistory` and such, it assumes the
  // transaction needs to be converted to an item. Returns null when
  // there are no changes or effects in the transaction.
  static fromTransaction(e, n) {
    let r = Vn;
    for (let i of e.startState.facet(SK)) {
      let s = i(e);
      s.length && (r = r.concat(s));
    }
    return !r.length && e.changes.empty ? null : new fn(e.changes.invert(e.startState.doc), r, void 0, n || e.startState.selection, Vn);
  }
  static selection(e) {
    return new fn(void 0, Vn, void 0, void 0, e);
  }
}
function Zh(t, e, n, r) {
  let i = e + 1 > n + 20 ? e - n - 1 : 0, s = t.slice(i, e);
  return s.push(r), s;
}
function AK(t, e) {
  let n = [], r = !1;
  return t.iterChangedRanges((i, s) => n.push(i, s)), e.iterChangedRanges((i, s, o, a) => {
    for (let l = 0; l < n.length; ) {
      let c = n[l++], u = n[l++];
      a >= c && o <= u && (r = !0);
    }
  }), r;
}
function DK(t, e) {
  return t.ranges.length == e.ranges.length && t.ranges.filter((n, r) => n.empty != e.ranges[r].empty).length === 0;
}
function m$(t, e) {
  return t.length ? e.length ? t.concat(e) : t : e;
}
const Vn = [], TK = 200;
function g$(t, e) {
  if (t.length) {
    let n = t[t.length - 1], r = n.selectionsAfter.slice(Math.max(0, n.selectionsAfter.length - TK));
    return r.length && r[r.length - 1].eq(e) ? t : (r.push(e), Zh(t, t.length - 1, 1e9, n.setSelAfter(r)));
  } else
    return [fn.selection([e])];
}
function OK(t) {
  let e = t[t.length - 1], n = t.slice();
  return n[t.length - 1] = e.setSelAfter(e.selectionsAfter.slice(0, e.selectionsAfter.length - 1)), n;
}
function Rm(t, e) {
  if (!t.length)
    return t;
  let n = t.length, r = Vn;
  for (; n; ) {
    let i = EK(t[n - 1], e, r);
    if (i.changes && !i.changes.empty || i.effects.length) {
      let s = t.slice(0, n);
      return s[n - 1] = i, s;
    } else
      e = i.mapped, n--, r = i.selectionsAfter;
  }
  return r.length ? [fn.selection(r)] : Vn;
}
function EK(t, e, n) {
  let r = m$(t.selectionsAfter.length ? t.selectionsAfter.map((a) => a.map(e)) : Vn, n);
  if (!t.changes)
    return fn.selection(r);
  let i = t.changes.map(e), s = e.mapDesc(t.changes, !0), o = t.mapped ? t.mapped.composeDesc(s) : s;
  return new fn(i, De.mapEffects(t.effects, e), o, t.startSelection.map(s), r);
}
const PK = /^(input\.type|delete)($|\.)/;
class Br {
  constructor(e, n, r = 0, i = void 0) {
    this.done = e, this.undone = n, this.prevTime = r, this.prevUserEvent = i;
  }
  isolate() {
    return this.prevTime ? new Br(this.done, this.undone) : this;
  }
  addChanges(e, n, r, i, s) {
    let o = this.done, a = o[o.length - 1];
    return a && a.changes && !a.changes.empty && e.changes && (!r || PK.test(r)) && (!a.selectionsAfter.length && n - this.prevTime < i.newGroupDelay && i.joinToEvent(s, AK(a.changes, e.changes)) || // For compose (but not compose.start) events, always join with previous event
    r == "input.type.compose") ? o = Zh(o, o.length - 1, i.minDepth, new fn(e.changes.compose(a.changes), m$(e.effects, a.effects), a.mapped, a.startSelection, Vn)) : o = Zh(o, o.length, i.minDepth, e), new Br(o, Vn, n, r);
  }
  addSelection(e, n, r, i) {
    let s = this.done.length ? this.done[this.done.length - 1].selectionsAfter : Vn;
    return s.length > 0 && n - this.prevTime < i && r == this.prevUserEvent && r && /^select($|\.)/.test(r) && DK(s[s.length - 1], e) ? this : new Br(g$(this.done, e), this.undone, n, r);
  }
  addMapping(e) {
    return new Br(Rm(this.done, e), Rm(this.undone, e), this.prevTime, this.prevUserEvent);
  }
  pop(e, n, r) {
    let i = e == 0 ? this.done : this.undone;
    if (i.length == 0)
      return null;
    let s = i[i.length - 1], o = s.selectionsAfter[0] || n.selection;
    if (r && s.selectionsAfter.length)
      return n.update({
        selection: s.selectionsAfter[s.selectionsAfter.length - 1],
        annotations: Q0.of({ side: e, rest: OK(i), selection: o }),
        userEvent: e == 0 ? "select.undo" : "select.redo",
        scrollIntoView: !0
      });
    if (s.changes) {
      let a = i.length == 1 ? Vn : i.slice(0, i.length - 1);
      return s.mapped && (a = Rm(a, s.mapped)), n.update({
        changes: s.changes,
        selection: s.startSelection,
        effects: s.effects,
        annotations: Q0.of({ side: e, rest: a, selection: o }),
        filter: !1,
        userEvent: e == 0 ? "undo" : "redo",
        scrollIntoView: !0
      });
    } else
      return null;
  }
}
Br.empty = /* @__PURE__ */ new Br(Vn, Vn);
const LK = [
  { key: "Mod-z", run: p$, preventDefault: !0 },
  { key: "Mod-y", mac: "Mod-Shift-z", run: ev, preventDefault: !0 },
  { linux: "Ctrl-Shift-z", run: ev, preventDefault: !0 },
  { key: "Mod-u", run: CK, preventDefault: !0 },
  { key: "Alt-u", mac: "Mod-Shift-u", run: $K, preventDefault: !0 }
];
function Ka(t, e) {
  return W.create(t.ranges.map(e), t.mainIndex);
}
function Qr(t, e) {
  return t.update({ selection: e, scrollIntoView: !0, userEvent: "select" });
}
function xr({ state: t, dispatch: e }, n) {
  let r = Ka(t.selection, n);
  return r.eq(t.selection, !0) ? !1 : (e(Qr(t, r)), !0);
}
function pp(t, e) {
  return W.cursor(e ? t.to : t.from);
}
function v$(t, e) {
  return xr(t, (n) => n.empty ? t.moveByChar(n, e) : pp(n, e));
}
function Ut(t) {
  return t.textDirectionAt(t.state.selection.main.head) == Qe.LTR;
}
const y$ = (t) => v$(t, !Ut(t)), b$ = (t) => v$(t, Ut(t));
function x$(t, e) {
  return xr(t, (n) => n.empty ? t.moveByGroup(n, e) : pp(n, e));
}
const NK = (t) => x$(t, !Ut(t)), IK = (t) => x$(t, Ut(t));
function RK(t, e, n) {
  if (e.type.prop(n))
    return !0;
  let r = e.to - e.from;
  return r && (r > 2 || /[^\s,.;:]/.test(t.sliceDoc(e.from, e.to))) || e.firstChild;
}
function mp(t, e, n) {
  let r = Wt(t).resolveInner(e.head), i = n ? Ne.closedBy : Ne.openedBy;
  for (let l = e.head; ; ) {
    let c = n ? r.childAfter(l) : r.childBefore(l);
    if (!c)
      break;
    RK(t, c, i) ? r = c : l = n ? c.to : c.from;
  }
  let s = r.type.prop(i), o, a;
  return s && (o = n ? Rr(t, r.from, 1) : Rr(t, r.to, -1)) && o.matched ? a = n ? o.end.to : o.end.from : a = n ? r.to : r.from, W.cursor(a, n ? -1 : 1);
}
const BK = (t) => xr(t, (e) => mp(t.state, e, !Ut(t))), FK = (t) => xr(t, (e) => mp(t.state, e, Ut(t)));
function w$(t, e) {
  return xr(t, (n) => {
    if (!n.empty)
      return pp(n, e);
    let r = t.moveVertically(n, e);
    return r.head != n.head ? r : t.moveToLineBoundary(n, e);
  });
}
const k$ = (t) => w$(t, !1), _$ = (t) => w$(t, !0);
function S$(t) {
  let e = t.scrollDOM.clientHeight < t.scrollDOM.scrollHeight - 2, n = 0, r = 0, i;
  if (e) {
    for (let s of t.state.facet(de.scrollMargins)) {
      let o = s(t);
      o != null && o.top && (n = Math.max(o == null ? void 0 : o.top, n)), o != null && o.bottom && (r = Math.max(o == null ? void 0 : o.bottom, r));
    }
    i = t.scrollDOM.clientHeight - n - r;
  } else
    i = (t.dom.ownerDocument.defaultView || window).innerHeight;
  return {
    marginTop: n,
    marginBottom: r,
    selfScroll: e,
    height: Math.max(t.defaultLineHeight, i - 5)
  };
}
function M$(t, e) {
  let n = S$(t), { state: r } = t, i = Ka(r.selection, (o) => o.empty ? t.moveVertically(o, e, n.height) : pp(o, e));
  if (i.eq(r.selection))
    return !1;
  let s;
  if (n.selfScroll) {
    let o = t.coordsAtPos(r.selection.main.head), a = t.scrollDOM.getBoundingClientRect(), l = a.top + n.marginTop, c = a.bottom - n.marginBottom;
    o && o.top > l && o.bottom < c && (s = de.scrollIntoView(i.main.head, { y: "start", yMargin: o.top - l }));
  }
  return t.dispatch(Qr(r, i), { effects: s }), !0;
}
const zw = (t) => M$(t, !1), tv = (t) => M$(t, !0);
function Ds(t, e, n) {
  let r = t.lineBlockAt(e.head), i = t.moveToLineBoundary(e, n);
  if (i.head == e.head && i.head != (n ? r.to : r.from) && (i = t.moveToLineBoundary(e, n, !1)), !n && i.head == r.from && r.length) {
    let s = /^\s*/.exec(t.state.sliceDoc(r.from, Math.min(r.from + 100, r.to)))[0].length;
    s && e.head != r.from + s && (i = W.cursor(r.from + s));
  }
  return i;
}
const zK = (t) => xr(t, (e) => Ds(t, e, !0)), VK = (t) => xr(t, (e) => Ds(t, e, !1)), HK = (t) => xr(t, (e) => Ds(t, e, !Ut(t))), YK = (t) => xr(t, (e) => Ds(t, e, Ut(t))), WK = (t) => xr(t, (e) => W.cursor(t.lineBlockAt(e.head).from, 1)), jK = (t) => xr(t, (e) => W.cursor(t.lineBlockAt(e.head).to, -1));
function qK(t, e, n) {
  let r = !1, i = Ka(t.selection, (s) => {
    let o = Rr(t, s.head, -1) || Rr(t, s.head, 1) || s.head > 0 && Rr(t, s.head - 1, 1) || s.head < t.doc.length && Rr(t, s.head + 1, -1);
    if (!o || !o.end)
      return s;
    r = !0;
    let a = o.start.from == s.head ? o.end.to : o.end.from;
    return W.cursor(a);
  });
  return r ? (e(Qr(t, i)), !0) : !1;
}
const UK = ({ state: t, dispatch: e }) => qK(t, e);
function rr(t, e) {
  let n = Ka(t.state.selection, (r) => {
    let i = e(r);
    return W.range(r.anchor, i.head, i.goalColumn, i.bidiLevel || void 0);
  });
  return n.eq(t.state.selection) ? !1 : (t.dispatch(Qr(t.state, n)), !0);
}
function C$(t, e) {
  return rr(t, (n) => t.moveByChar(n, e));
}
const $$ = (t) => C$(t, !Ut(t)), A$ = (t) => C$(t, Ut(t));
function D$(t, e) {
  return rr(t, (n) => t.moveByGroup(n, e));
}
const KK = (t) => D$(t, !Ut(t)), GK = (t) => D$(t, Ut(t)), XK = (t) => rr(t, (e) => mp(t.state, e, !Ut(t))), ZK = (t) => rr(t, (e) => mp(t.state, e, Ut(t)));
function T$(t, e) {
  return rr(t, (n) => t.moveVertically(n, e));
}
const O$ = (t) => T$(t, !1), E$ = (t) => T$(t, !0);
function P$(t, e) {
  return rr(t, (n) => t.moveVertically(n, e, S$(t).height));
}
const Vw = (t) => P$(t, !1), Hw = (t) => P$(t, !0), JK = (t) => rr(t, (e) => Ds(t, e, !0)), QK = (t) => rr(t, (e) => Ds(t, e, !1)), eG = (t) => rr(t, (e) => Ds(t, e, !Ut(t))), tG = (t) => rr(t, (e) => Ds(t, e, Ut(t))), nG = (t) => rr(t, (e) => W.cursor(t.lineBlockAt(e.head).from)), rG = (t) => rr(t, (e) => W.cursor(t.lineBlockAt(e.head).to)), Yw = ({ state: t, dispatch: e }) => (e(Qr(t, { anchor: 0 })), !0), Ww = ({ state: t, dispatch: e }) => (e(Qr(t, { anchor: t.doc.length })), !0), jw = ({ state: t, dispatch: e }) => (e(Qr(t, { anchor: t.selection.main.anchor, head: 0 })), !0), qw = ({ state: t, dispatch: e }) => (e(Qr(t, { anchor: t.selection.main.anchor, head: t.doc.length })), !0), iG = ({ state: t, dispatch: e }) => (e(t.update({ selection: { anchor: 0, head: t.doc.length }, userEvent: "select" })), !0), sG = ({ state: t, dispatch: e }) => {
  let n = gp(t).map(({ from: r, to: i }) => W.range(r, Math.min(i + 1, t.doc.length)));
  return e(t.update({ selection: W.create(n), userEvent: "select" })), !0;
}, oG = ({ state: t, dispatch: e }) => {
  let n = Ka(t.selection, (r) => {
    var i;
    let s = Wt(t).resolveStack(r.from, 1);
    for (let o = s; o; o = o.next) {
      let { node: a } = o;
      if ((a.from < r.from && a.to >= r.to || a.to > r.to && a.from <= r.from) && (!((i = a.parent) === null || i === void 0) && i.parent))
        return W.range(a.to, a.from);
    }
    return r;
  });
  return e(Qr(t, n)), !0;
}, aG = ({ state: t, dispatch: e }) => {
  let n = t.selection, r = null;
  return n.ranges.length > 1 ? r = W.create([n.main]) : n.main.empty || (r = W.create([W.cursor(n.main.head)])), r ? (e(Qr(t, r)), !0) : !1;
};
function _u(t, e) {
  if (t.state.readOnly)
    return !1;
  let n = "delete.selection", { state: r } = t, i = r.changeByRange((s) => {
    let { from: o, to: a } = s;
    if (o == a) {
      let l = e(s);
      l < o ? (n = "delete.backward", l = gf(t, l, !1)) : l > o && (n = "delete.forward", l = gf(t, l, !0)), o = Math.min(o, l), a = Math.max(a, l);
    } else
      o = gf(t, o, !1), a = gf(t, a, !0);
    return o == a ? { range: s } : { changes: { from: o, to: a }, range: W.cursor(o, o < s.head ? -1 : 1) };
  });
  return i.changes.empty ? !1 : (t.dispatch(r.update(i, {
    scrollIntoView: !0,
    userEvent: n,
    effects: n == "delete.selection" ? de.announce.of(r.phrase("Selection deleted")) : void 0
  })), !0);
}
function gf(t, e, n) {
  if (t instanceof de)
    for (let r of t.state.facet(de.atomicRanges).map((i) => i(t)))
      r.between(e, e, (i, s) => {
        i < e && s > e && (e = n ? s : i);
      });
  return e;
}
const L$ = (t, e, n) => _u(t, (r) => {
  let i = r.from, { state: s } = t, o = s.doc.lineAt(i), a, l;
  if (n && !e && i > o.from && i < o.from + 200 && !/[^ \t]/.test(a = o.text.slice(0, i - o.from))) {
    if (a[a.length - 1] == "	")
      return i - 1;
    let c = Ua(a, s.tabSize), u = c % Kh(s) || Kh(s);
    for (let h = 0; h < u && a[a.length - 1 - h] == " "; h++)
      i--;
    l = i;
  } else
    l = Pt(o.text, i - o.from, e, e) + o.from, l == i && o.number != (e ? s.doc.lines : 1) ? l += e ? 1 : -1 : !e && /[\ufe00-\ufe0f]/.test(o.text.slice(l - o.from, i - o.from)) && (l = Pt(o.text, l - o.from, !1, !1) + o.from);
  return l;
}), nv = (t) => L$(t, !1, !0), N$ = (t) => L$(t, !0, !1), I$ = (t, e) => _u(t, (n) => {
  let r = n.head, { state: i } = t, s = i.doc.lineAt(r), o = i.charCategorizer(r);
  for (let a = null; ; ) {
    if (r == (e ? s.to : s.from)) {
      r == n.head && s.number != (e ? i.doc.lines : 1) && (r += e ? 1 : -1);
      break;
    }
    let l = Pt(s.text, r - s.from, e) + s.from, c = s.text.slice(Math.min(r, l) - s.from, Math.max(r, l) - s.from), u = o(c);
    if (a != null && u != a)
      break;
    (c != " " || r != n.head) && (a = u), r = l;
  }
  return r;
}), R$ = (t) => I$(t, !1), lG = (t) => I$(t, !0), cG = (t) => _u(t, (e) => {
  let n = t.lineBlockAt(e.head).to;
  return e.head < n ? n : Math.min(t.state.doc.length, e.head + 1);
}), uG = (t) => _u(t, (e) => {
  let n = t.moveToLineBoundary(e, !1).head;
  return e.head > n ? n : Math.max(0, e.head - 1);
}), fG = (t) => _u(t, (e) => {
  let n = t.moveToLineBoundary(e, !0).head;
  return e.head < n ? n : Math.min(t.state.doc.length, e.head + 1);
}), hG = ({ state: t, dispatch: e }) => {
  if (t.readOnly)
    return !1;
  let n = t.changeByRange((r) => ({
    changes: { from: r.from, to: r.to, insert: ze.of(["", ""]) },
    range: W.cursor(r.from)
  }));
  return e(t.update(n, { scrollIntoView: !0, userEvent: "input" })), !0;
}, dG = ({ state: t, dispatch: e }) => {
  if (t.readOnly)
    return !1;
  let n = t.changeByRange((r) => {
    if (!r.empty || r.from == 0 || r.from == t.doc.length)
      return { range: r };
    let i = r.from, s = t.doc.lineAt(i), o = i == s.from ? i - 1 : Pt(s.text, i - s.from, !1) + s.from, a = i == s.to ? i + 1 : Pt(s.text, i - s.from, !0) + s.from;
    return {
      changes: { from: o, to: a, insert: t.doc.slice(i, a).append(t.doc.slice(o, i)) },
      range: W.cursor(a)
    };
  });
  return n.changes.empty ? !1 : (e(t.update(n, { scrollIntoView: !0, userEvent: "move.character" })), !0);
};
function gp(t) {
  let e = [], n = -1;
  for (let r of t.selection.ranges) {
    let i = t.doc.lineAt(r.from), s = t.doc.lineAt(r.to);
    if (!r.empty && r.to == s.from && (s = t.doc.lineAt(r.to - 1)), n >= i.number) {
      let o = e[e.length - 1];
      o.to = s.to, o.ranges.push(r);
    } else
      e.push({ from: i.from, to: s.to, ranges: [r] });
    n = s.number + 1;
  }
  return e;
}
function B$(t, e, n) {
  if (t.readOnly)
    return !1;
  let r = [], i = [];
  for (let s of gp(t)) {
    if (n ? s.to == t.doc.length : s.from == 0)
      continue;
    let o = t.doc.lineAt(n ? s.to + 1 : s.from - 1), a = o.length + 1;
    if (n) {
      r.push({ from: s.to, to: o.to }, { from: s.from, insert: o.text + t.lineBreak });
      for (let l of s.ranges)
        i.push(W.range(Math.min(t.doc.length, l.anchor + a), Math.min(t.doc.length, l.head + a)));
    } else {
      r.push({ from: o.from, to: s.from }, { from: s.to, insert: t.lineBreak + o.text });
      for (let l of s.ranges)
        i.push(W.range(l.anchor - a, l.head - a));
    }
  }
  return r.length ? (e(t.update({
    changes: r,
    scrollIntoView: !0,
    selection: W.create(i, t.selection.mainIndex),
    userEvent: "move.line"
  })), !0) : !1;
}
const pG = ({ state: t, dispatch: e }) => B$(t, e, !1), mG = ({ state: t, dispatch: e }) => B$(t, e, !0);
function F$(t, e, n) {
  if (t.readOnly)
    return !1;
  let r = [];
  for (let i of gp(t))
    n ? r.push({ from: i.from, insert: t.doc.slice(i.from, i.to) + t.lineBreak }) : r.push({ from: i.to, insert: t.lineBreak + t.doc.slice(i.from, i.to) });
  return e(t.update({ changes: r, scrollIntoView: !0, userEvent: "input.copyline" })), !0;
}
const gG = ({ state: t, dispatch: e }) => F$(t, e, !1), vG = ({ state: t, dispatch: e }) => F$(t, e, !0), yG = (t) => {
  if (t.state.readOnly)
    return !1;
  let { state: e } = t, n = e.changes(gp(e).map(({ from: i, to: s }) => (i > 0 ? i-- : s < e.doc.length && s++, { from: i, to: s }))), r = Ka(e.selection, (i) => {
    let s;
    if (t.lineWrapping) {
      let o = t.lineBlockAt(i.head), a = t.coordsAtPos(i.head, i.assoc || 1);
      a && (s = o.bottom + t.documentTop - a.bottom + t.defaultLineHeight / 2);
    }
    return t.moveVertically(i, !0, s);
  }).map(n);
  return t.dispatch({ changes: n, selection: r, scrollIntoView: !0, userEvent: "delete.line" }), !0;
};
function bG(t, e) {
  if (/\(\)|\[\]|\{\}/.test(t.sliceDoc(e - 1, e + 1)))
    return { from: e, to: e };
  let n = Wt(t).resolveInner(e), r = n.childBefore(e), i = n.childAfter(e), s;
  return r && i && r.to <= e && i.from >= e && (s = r.type.prop(Ne.closedBy)) && s.indexOf(i.name) > -1 && t.doc.lineAt(r.to).from == t.doc.lineAt(i.from).from && !/\S/.test(t.sliceDoc(r.to, i.from)) ? { from: r.to, to: i.from } : null;
}
const xG = /* @__PURE__ */ z$(!1), wG = /* @__PURE__ */ z$(!0);
function z$(t) {
  return ({ state: e, dispatch: n }) => {
    if (e.readOnly)
      return !1;
    let r = e.changeByRange((i) => {
      let { from: s, to: o } = i, a = e.doc.lineAt(s), l = !t && s == o && bG(e, s);
      t && (s = o = (o <= a.to ? a : e.doc.lineAt(o)).to);
      let c = new up(e, { simulateBreak: s, simulateDoubleBreak: !!l }), u = ty(c, s);
      for (u == null && (u = Ua(/^\s*/.exec(e.doc.lineAt(s).text)[0], e.tabSize)); o < a.to && /\s/.test(a.text[o - a.from]); )
        o++;
      l ? { from: s, to: o } = l : s > a.from && s < a.from + 100 && !/\S/.test(a.text.slice(0, s)) && (s = a.from);
      let h = ["", Nc(e, u)];
      return l && h.push(Nc(e, c.lineIndent(a.from, -1))), {
        changes: { from: s, to: o, insert: ze.of(h) },
        range: W.cursor(s + 1 + h[1].length)
      };
    });
    return n(e.update(r, { scrollIntoView: !0, userEvent: "input" })), !0;
  };
}
function sy(t, e) {
  let n = -1;
  return t.changeByRange((r) => {
    let i = [];
    for (let o = r.from; o <= r.to; ) {
      let a = t.doc.lineAt(o);
      a.number > n && (r.empty || r.to > a.from) && (e(a, i, r), n = a.number), o = a.to + 1;
    }
    let s = t.changes(i);
    return {
      changes: i,
      range: W.range(s.mapPos(r.anchor, 1), s.mapPos(r.head, 1))
    };
  });
}
const kG = ({ state: t, dispatch: e }) => {
  if (t.readOnly)
    return !1;
  let n = /* @__PURE__ */ Object.create(null), r = new up(t, { overrideIndentation: (s) => {
    let o = n[s];
    return o == null ? -1 : o;
  } }), i = sy(t, (s, o, a) => {
    let l = ty(r, s.from);
    if (l == null)
      return;
    /\S/.test(s.text) || (l = 0);
    let c = /^\s*/.exec(s.text)[0], u = Nc(t, l);
    (c != u || a.from < s.from + c.length) && (n[s.from] = l, o.push({ from: s.from, to: s.from + c.length, insert: u }));
  });
  return i.changes.empty || e(t.update(i, { userEvent: "indent" })), !0;
}, V$ = ({ state: t, dispatch: e }) => t.readOnly ? !1 : (e(t.update(sy(t, (n, r) => {
  r.push({ from: n.from, insert: t.facet(cp) });
}), { userEvent: "input.indent" })), !0), H$ = ({ state: t, dispatch: e }) => t.readOnly ? !1 : (e(t.update(sy(t, (n, r) => {
  let i = /^\s*/.exec(n.text)[0];
  if (!i)
    return;
  let s = Ua(i, t.tabSize), o = 0, a = Nc(t, Math.max(0, s - Kh(t)));
  for (; o < i.length && o < a.length && i.charCodeAt(o) == a.charCodeAt(o); )
    o++;
  r.push({ from: n.from + o, to: n.from + i.length, insert: a.slice(o) });
}), { userEvent: "delete.dedent" })), !0), _G = (t) => (t.setTabFocusMode(), !0), SG = [
  { key: "Ctrl-b", run: y$, shift: $$, preventDefault: !0 },
  { key: "Ctrl-f", run: b$, shift: A$ },
  { key: "Ctrl-p", run: k$, shift: O$ },
  { key: "Ctrl-n", run: _$, shift: E$ },
  { key: "Ctrl-a", run: WK, shift: nG },
  { key: "Ctrl-e", run: jK, shift: rG },
  { key: "Ctrl-d", run: N$ },
  { key: "Ctrl-h", run: nv },
  { key: "Ctrl-k", run: cG },
  { key: "Ctrl-Alt-h", run: R$ },
  { key: "Ctrl-o", run: hG },
  { key: "Ctrl-t", run: dG },
  { key: "Ctrl-v", run: tv }
], MG = /* @__PURE__ */ [
  { key: "ArrowLeft", run: y$, shift: $$, preventDefault: !0 },
  { key: "Mod-ArrowLeft", mac: "Alt-ArrowLeft", run: NK, shift: KK, preventDefault: !0 },
  { mac: "Cmd-ArrowLeft", run: HK, shift: eG, preventDefault: !0 },
  { key: "ArrowRight", run: b$, shift: A$, preventDefault: !0 },
  { key: "Mod-ArrowRight", mac: "Alt-ArrowRight", run: IK, shift: GK, preventDefault: !0 },
  { mac: "Cmd-ArrowRight", run: YK, shift: tG, preventDefault: !0 },
  { key: "ArrowUp", run: k$, shift: O$, preventDefault: !0 },
  { mac: "Cmd-ArrowUp", run: Yw, shift: jw },
  { mac: "Ctrl-ArrowUp", run: zw, shift: Vw },
  { key: "ArrowDown", run: _$, shift: E$, preventDefault: !0 },
  { mac: "Cmd-ArrowDown", run: Ww, shift: qw },
  { mac: "Ctrl-ArrowDown", run: tv, shift: Hw },
  { key: "PageUp", run: zw, shift: Vw },
  { key: "PageDown", run: tv, shift: Hw },
  { key: "Home", run: VK, shift: QK, preventDefault: !0 },
  { key: "Mod-Home", run: Yw, shift: jw },
  { key: "End", run: zK, shift: JK, preventDefault: !0 },
  { key: "Mod-End", run: Ww, shift: qw },
  { key: "Enter", run: xG },
  { key: "Mod-a", run: iG },
  { key: "Backspace", run: nv, shift: nv },
  { key: "Delete", run: N$ },
  { key: "Mod-Backspace", mac: "Alt-Backspace", run: R$ },
  { key: "Mod-Delete", mac: "Alt-Delete", run: lG },
  { mac: "Mod-Backspace", run: uG },
  { mac: "Mod-Delete", run: fG }
].concat(/* @__PURE__ */ SG.map((t) => ({ mac: t.key, run: t.run, shift: t.shift }))), CG = /* @__PURE__ */ [
  { key: "Alt-ArrowLeft", mac: "Ctrl-ArrowLeft", run: BK, shift: XK },
  { key: "Alt-ArrowRight", mac: "Ctrl-ArrowRight", run: FK, shift: ZK },
  { key: "Alt-ArrowUp", run: pG },
  { key: "Shift-Alt-ArrowUp", run: gG },
  { key: "Alt-ArrowDown", run: mG },
  { key: "Shift-Alt-ArrowDown", run: vG },
  { key: "Escape", run: aG },
  { key: "Mod-Enter", run: wG },
  { key: "Alt-l", mac: "Ctrl-l", run: sG },
  { key: "Mod-i", run: oG, preventDefault: !0 },
  { key: "Mod-[", run: H$ },
  { key: "Mod-]", run: V$ },
  { key: "Mod-Alt-\\", run: kG },
  { key: "Shift-Mod-k", run: yG },
  { key: "Shift-Mod-\\", run: UK },
  { key: "Mod-/", run: gK },
  { key: "Alt-A", run: yK },
  { key: "Ctrl-m", mac: "Shift-Alt-m", run: _G }
].concat(MG), $G = { key: "Tab", run: V$, shift: H$ };
function Ge() {
  var t = arguments[0];
  typeof t == "string" && (t = document.createElement(t));
  var e = 1, n = arguments[1];
  if (n && typeof n == "object" && n.nodeType == null && !Array.isArray(n)) {
    for (var r in n) if (Object.prototype.hasOwnProperty.call(n, r)) {
      var i = n[r];
      typeof i == "string" ? t.setAttribute(r, i) : i != null && (t[r] = i);
    }
    e++;
  }
  for (; e < arguments.length; e++) Y$(t, arguments[e]);
  return t;
}
function Y$(t, e) {
  if (typeof e == "string")
    t.appendChild(document.createTextNode(e));
  else if (e != null) if (e.nodeType != null)
    t.appendChild(e);
  else if (Array.isArray(e))
    for (var n = 0; n < e.length; n++) Y$(t, e[n]);
  else
    throw new RangeError("Unsupported child node: " + e);
}
const Uw = typeof String.prototype.normalize == "function" ? (t) => t.normalize("NFKD") : (t) => t;
class Ta {
  /**
  Create a text cursor. The query is the search string, `from` to
  `to` provides the region to search.
  
  When `normalize` is given, it will be called, on both the query
  string and the content it is matched against, before comparing.
  You can, for example, create a case-insensitive search by
  passing `s => s.toLowerCase()`.
  
  Text is always normalized with
  [`.normalize("NFKD")`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/normalize)
  (when supported).
  */
  constructor(e, n, r = 0, i = e.length, s, o) {
    this.test = o, this.value = { from: 0, to: 0 }, this.done = !1, this.matches = [], this.buffer = "", this.bufferPos = 0, this.iter = e.iterRange(r, i), this.bufferStart = r, this.normalize = s ? (a) => s(Uw(a)) : Uw, this.query = this.normalize(n);
  }
  peek() {
    if (this.bufferPos == this.buffer.length) {
      if (this.bufferStart += this.buffer.length, this.iter.next(), this.iter.done)
        return -1;
      this.bufferPos = 0, this.buffer = this.iter.value;
    }
    return Dt(this.buffer, this.bufferPos);
  }
  /**
  Look for the next match. Updates the iterator's
  [`value`](https://codemirror.net/6/docs/ref/#search.SearchCursor.value) and
  [`done`](https://codemirror.net/6/docs/ref/#search.SearchCursor.done) properties. Should be called
  at least once before using the cursor.
  */
  next() {
    for (; this.matches.length; )
      this.matches.pop();
    return this.nextOverlapping();
  }
  /**
  The `next` method will ignore matches that partially overlap a
  previous match. This method behaves like `next`, but includes
  such matches.
  */
  nextOverlapping() {
    for (; ; ) {
      let e = this.peek();
      if (e < 0)
        return this.done = !0, this;
      let n = z1(e), r = this.bufferStart + this.bufferPos;
      this.bufferPos += In(e);
      let i = this.normalize(n);
      for (let s = 0, o = r; ; s++) {
        let a = i.charCodeAt(s), l = this.match(a, o, this.bufferPos + this.bufferStart);
        if (s == i.length - 1) {
          if (l)
            return this.value = l, this;
          break;
        }
        o == r && s < n.length && n.charCodeAt(s) == a && o++;
      }
    }
  }
  match(e, n, r) {
    let i = null;
    for (let s = 0; s < this.matches.length; s += 2) {
      let o = this.matches[s], a = !1;
      this.query.charCodeAt(o) == e && (o == this.query.length - 1 ? i = { from: this.matches[s + 1], to: r } : (this.matches[s]++, a = !0)), a || (this.matches.splice(s, 2), s -= 2);
    }
    return this.query.charCodeAt(0) == e && (this.query.length == 1 ? i = { from: n, to: r } : this.matches.push(1, n)), i && this.test && !this.test(i.from, i.to, this.buffer, this.bufferStart) && (i = null), i;
  }
}
typeof Symbol != "undefined" && (Ta.prototype[Symbol.iterator] = function() {
  return this;
});
const W$ = { from: -1, to: -1, match: /* @__PURE__ */ /.*/.exec("") }, oy = "gm" + (/x/.unicode == null ? "" : "u");
class j$ {
  /**
  Create a cursor that will search the given range in the given
  document. `query` should be the raw pattern (as you'd pass it to
  `new RegExp`).
  */
  constructor(e, n, r, i = 0, s = e.length) {
    if (this.text = e, this.to = s, this.curLine = "", this.done = !1, this.value = W$, /\\[sWDnr]|\n|\r|\[\^/.test(n))
      return new q$(e, n, r, i, s);
    this.re = new RegExp(n, oy + (r != null && r.ignoreCase ? "i" : "")), this.test = r == null ? void 0 : r.test, this.iter = e.iter();
    let o = e.lineAt(i);
    this.curLineStart = o.from, this.matchPos = Jh(e, i), this.getLine(this.curLineStart);
  }
  getLine(e) {
    this.iter.next(e), this.iter.lineBreak ? this.curLine = "" : (this.curLine = this.iter.value, this.curLineStart + this.curLine.length > this.to && (this.curLine = this.curLine.slice(0, this.to - this.curLineStart)), this.iter.next());
  }
  nextLine() {
    this.curLineStart = this.curLineStart + this.curLine.length + 1, this.curLineStart > this.to ? this.curLine = "" : this.getLine(0);
  }
  /**
  Move to the next match, if there is one.
  */
  next() {
    for (let e = this.matchPos - this.curLineStart; ; ) {
      this.re.lastIndex = e;
      let n = this.matchPos <= this.to && this.re.exec(this.curLine);
      if (n) {
        let r = this.curLineStart + n.index, i = r + n[0].length;
        if (this.matchPos = Jh(this.text, i + (r == i ? 1 : 0)), r == this.curLineStart + this.curLine.length && this.nextLine(), (r < i || r > this.value.to) && (!this.test || this.test(r, i, n)))
          return this.value = { from: r, to: i, match: n }, this;
        e = this.matchPos - this.curLineStart;
      } else if (this.curLineStart + this.curLine.length < this.to)
        this.nextLine(), e = 0;
      else
        return this.done = !0, this;
    }
  }
}
const Bm = /* @__PURE__ */ new WeakMap();
class ia {
  constructor(e, n) {
    this.from = e, this.text = n;
  }
  get to() {
    return this.from + this.text.length;
  }
  static get(e, n, r) {
    let i = Bm.get(e);
    if (!i || i.from >= r || i.to <= n) {
      let a = new ia(n, e.sliceString(n, r));
      return Bm.set(e, a), a;
    }
    if (i.from == n && i.to == r)
      return i;
    let { text: s, from: o } = i;
    return o > n && (s = e.sliceString(n, o) + s, o = n), i.to < r && (s += e.sliceString(i.to, r)), Bm.set(e, new ia(o, s)), new ia(n, s.slice(n - o, r - o));
  }
}
class q$ {
  constructor(e, n, r, i, s) {
    this.text = e, this.to = s, this.done = !1, this.value = W$, this.matchPos = Jh(e, i), this.re = new RegExp(n, oy + (r != null && r.ignoreCase ? "i" : "")), this.test = r == null ? void 0 : r.test, this.flat = ia.get(e, i, this.chunkEnd(
      i + 5e3
      /* Chunk.Base */
    ));
  }
  chunkEnd(e) {
    return e >= this.to ? this.to : this.text.lineAt(e).to;
  }
  next() {
    for (; ; ) {
      let e = this.re.lastIndex = this.matchPos - this.flat.from, n = this.re.exec(this.flat.text);
      if (n && !n[0] && n.index == e && (this.re.lastIndex = e + 1, n = this.re.exec(this.flat.text)), n) {
        let r = this.flat.from + n.index, i = r + n[0].length;
        if ((this.flat.to >= this.to || n.index + n[0].length <= this.flat.text.length - 10) && (!this.test || this.test(r, i, n)))
          return this.value = { from: r, to: i, match: n }, this.matchPos = Jh(this.text, i + (r == i ? 1 : 0)), this;
      }
      if (this.flat.to == this.to)
        return this.done = !0, this;
      this.flat = ia.get(this.text, this.flat.from, this.chunkEnd(this.flat.from + this.flat.text.length * 2));
    }
  }
}
typeof Symbol != "undefined" && (j$.prototype[Symbol.iterator] = q$.prototype[Symbol.iterator] = function() {
  return this;
});
function AG(t) {
  try {
    return new RegExp(t, oy), !0;
  } catch (e) {
    return !1;
  }
}
function Jh(t, e) {
  if (e >= t.length)
    return e;
  let n = t.lineAt(e), r;
  for (; e < n.to && (r = n.text.charCodeAt(e - n.from)) >= 56320 && r < 57344; )
    e++;
  return e;
}
function rv(t) {
  let e = String(t.state.doc.lineAt(t.state.selection.main.head).number), n = Ge("input", { class: "cm-textfield", name: "line", value: e }), r = Ge("form", {
    class: "cm-gotoLine",
    onkeydown: (s) => {
      s.keyCode == 27 ? (s.preventDefault(), t.dispatch({ effects: Qh.of(!1) }), t.focus()) : s.keyCode == 13 && (s.preventDefault(), i());
    },
    onsubmit: (s) => {
      s.preventDefault(), i();
    }
  }, Ge("label", t.state.phrase("Go to line"), ": ", n), " ", Ge("button", { class: "cm-button", type: "submit" }, t.state.phrase("go")));
  function i() {
    let s = /^([+-])?(\d+)?(:\d+)?(%)?$/.exec(n.value);
    if (!s)
      return;
    let { state: o } = t, a = o.doc.lineAt(o.selection.main.head), [, l, c, u, h] = s, f = u ? +u.slice(1) : 0, d = c ? +c : a.number;
    if (c && h) {
      let v = d / 100;
      l && (v = v * (l == "-" ? -1 : 1) + a.number / o.doc.lines), d = Math.round(o.doc.lines * v);
    } else c && l && (d = d * (l == "-" ? -1 : 1) + a.number);
    let p = o.doc.line(Math.max(1, Math.min(o.doc.lines, d))), m = W.cursor(p.from + Math.max(0, Math.min(f, p.length)));
    t.dispatch({
      effects: [Qh.of(!1), de.scrollIntoView(m.from, { y: "center" })],
      selection: m
    }), t.focus();
  }
  return { dom: r };
}
const Qh = /* @__PURE__ */ De.define(), Kw = /* @__PURE__ */ It.define({
  create() {
    return !0;
  },
  update(t, e) {
    for (let n of e.effects)
      n.is(Qh) && (t = n.value);
    return t;
  },
  provide: (t) => Pc.from(t, (e) => e ? rv : null)
}), DG = (t) => {
  let e = Ec(t, rv);
  if (!e) {
    let n = [Qh.of(!0)];
    t.state.field(Kw, !1) == null && n.push(De.appendConfig.of([Kw, TG])), t.dispatch({ effects: n }), e = Ec(t, rv);
  }
  return e && e.dom.querySelector("input").select(), !0;
}, TG = /* @__PURE__ */ de.baseTheme({
  ".cm-panel.cm-gotoLine": {
    padding: "2px 6px 4px",
    "& label": { fontSize: "80%" }
  }
}), OG = {
  highlightWordAroundCursor: !1,
  minSelectionLength: 1,
  maxMatches: 100,
  wholeWords: !1
}, EG = /* @__PURE__ */ ve.define({
  combine(t) {
    return Jr(t, OG, {
      highlightWordAroundCursor: (e, n) => e || n,
      minSelectionLength: Math.min,
      maxMatches: Math.min
    });
  }
});
function PG(t) {
  return [BG, RG];
}
const LG = /* @__PURE__ */ we.mark({ class: "cm-selectionMatch" }), NG = /* @__PURE__ */ we.mark({ class: "cm-selectionMatch cm-selectionMatch-main" });
function Gw(t, e, n, r) {
  return (n == 0 || t(e.sliceDoc(n - 1, n)) != tt.Word) && (r == e.doc.length || t(e.sliceDoc(r, r + 1)) != tt.Word);
}
function IG(t, e, n, r) {
  return t(e.sliceDoc(n, n + 1)) == tt.Word && t(e.sliceDoc(r - 1, r)) == tt.Word;
}
const RG = /* @__PURE__ */ dt.fromClass(class {
  constructor(t) {
    this.decorations = this.getDeco(t);
  }
  update(t) {
    (t.selectionSet || t.docChanged || t.viewportChanged) && (this.decorations = this.getDeco(t.view));
  }
  getDeco(t) {
    let e = t.state.facet(EG), { state: n } = t, r = n.selection;
    if (r.ranges.length > 1)
      return we.none;
    let i = r.main, s, o = null;
    if (i.empty) {
      if (!e.highlightWordAroundCursor)
        return we.none;
      let l = n.wordAt(i.head);
      if (!l)
        return we.none;
      o = n.charCategorizer(i.head), s = n.sliceDoc(l.from, l.to);
    } else {
      let l = i.to - i.from;
      if (l < e.minSelectionLength || l > 200)
        return we.none;
      if (e.wholeWords) {
        if (s = n.sliceDoc(i.from, i.to), o = n.charCategorizer(i.head), !(Gw(o, n, i.from, i.to) && IG(o, n, i.from, i.to)))
          return we.none;
      } else if (s = n.sliceDoc(i.from, i.to), !s)
        return we.none;
    }
    let a = [];
    for (let l of t.visibleRanges) {
      let c = new Ta(n.doc, s, l.from, l.to);
      for (; !c.next().done; ) {
        let { from: u, to: h } = c.value;
        if ((!o || Gw(o, n, u, h)) && (i.empty && u <= i.from && h >= i.to ? a.push(NG.range(u, h)) : (u >= i.to || h <= i.from) && a.push(LG.range(u, h)), a.length > e.maxMatches))
          return we.none;
      }
    }
    return we.set(a);
  }
}, {
  decorations: (t) => t.decorations
}), BG = /* @__PURE__ */ de.baseTheme({
  ".cm-selectionMatch": { backgroundColor: "#99ff7780" },
  ".cm-searchMatch .cm-selectionMatch": { backgroundColor: "transparent" }
}), FG = ({ state: t, dispatch: e }) => {
  let { selection: n } = t, r = W.create(n.ranges.map((i) => t.wordAt(i.head) || W.cursor(i.head)), n.mainIndex);
  return r.eq(n) ? !1 : (e(t.update({ selection: r })), !0);
};
function zG(t, e) {
  let { main: n, ranges: r } = t.selection, i = t.wordAt(n.head), s = i && i.from == n.from && i.to == n.to;
  for (let o = !1, a = new Ta(t.doc, e, r[r.length - 1].to); ; )
    if (a.next(), a.done) {
      if (o)
        return null;
      a = new Ta(t.doc, e, 0, Math.max(0, r[r.length - 1].from - 1)), o = !0;
    } else {
      if (o && r.some((l) => l.from == a.value.from))
        continue;
      if (s) {
        let l = t.wordAt(a.value.from);
        if (!l || l.from != a.value.from || l.to != a.value.to)
          continue;
      }
      return a.value;
    }
}
const VG = ({ state: t, dispatch: e }) => {
  let { ranges: n } = t.selection;
  if (n.some((s) => s.from === s.to))
    return FG({ state: t, dispatch: e });
  let r = t.sliceDoc(n[0].from, n[0].to);
  if (t.selection.ranges.some((s) => t.sliceDoc(s.from, s.to) != r))
    return !1;
  let i = zG(t, r);
  return i ? (e(t.update({
    selection: t.selection.addRange(W.range(i.from, i.to), !1),
    effects: de.scrollIntoView(i.to)
  })), !0) : !1;
}, Ga = /* @__PURE__ */ ve.define({
  combine(t) {
    return Jr(t, {
      top: !1,
      caseSensitive: !1,
      literal: !1,
      regexp: !1,
      wholeWord: !1,
      createPanel: (e) => new QG(e),
      scrollToMatch: (e) => de.scrollIntoView(e)
    });
  }
});
class U$ {
  /**
  Create a query object.
  */
  constructor(e) {
    this.search = e.search, this.caseSensitive = !!e.caseSensitive, this.literal = !!e.literal, this.regexp = !!e.regexp, this.replace = e.replace || "", this.valid = !!this.search && (!this.regexp || AG(this.search)), this.unquoted = this.unquote(this.search), this.wholeWord = !!e.wholeWord;
  }
  /**
  @internal
  */
  unquote(e) {
    return this.literal ? e : e.replace(/\\([nrt\\])/g, (n, r) => r == "n" ? `
` : r == "r" ? "\r" : r == "t" ? "	" : "\\");
  }
  /**
  Compare this query to another query.
  */
  eq(e) {
    return this.search == e.search && this.replace == e.replace && this.caseSensitive == e.caseSensitive && this.regexp == e.regexp && this.wholeWord == e.wholeWord;
  }
  /**
  @internal
  */
  create() {
    return this.regexp ? new jG(this) : new YG(this);
  }
  /**
  Get a search cursor for this query, searching through the given
  range in the given state.
  */
  getCursor(e, n = 0, r) {
    let i = e.doc ? e : Le.create({ doc: e });
    return r == null && (r = i.doc.length), this.regexp ? zo(this, i, n, r) : Fo(this, i, n, r);
  }
}
class K$ {
  constructor(e) {
    this.spec = e;
  }
}
function Fo(t, e, n, r) {
  return new Ta(e.doc, t.unquoted, n, r, t.caseSensitive ? void 0 : (i) => i.toLowerCase(), t.wholeWord ? HG(e.doc, e.charCategorizer(e.selection.main.head)) : void 0);
}
function HG(t, e) {
  return (n, r, i, s) => ((s > n || s + i.length < r) && (s = Math.max(0, n - 2), i = t.sliceString(s, Math.min(t.length, r + 2))), (e(ed(i, n - s)) != tt.Word || e(td(i, n - s)) != tt.Word) && (e(td(i, r - s)) != tt.Word || e(ed(i, r - s)) != tt.Word));
}
class YG extends K$ {
  constructor(e) {
    super(e);
  }
  nextMatch(e, n, r) {
    let i = Fo(this.spec, e, r, e.doc.length).nextOverlapping();
    return i.done && (i = Fo(this.spec, e, 0, n).nextOverlapping()), i.done ? null : i.value;
  }
  // Searching in reverse is, rather than implementing an inverted search
  // cursor, done by scanning chunk after chunk forward.
  prevMatchInRange(e, n, r) {
    for (let i = r; ; ) {
      let s = Math.max(n, i - 1e4 - this.spec.unquoted.length), o = Fo(this.spec, e, s, i), a = null;
      for (; !o.nextOverlapping().done; )
        a = o.value;
      if (a)
        return a;
      if (s == n)
        return null;
      i -= 1e4;
    }
  }
  prevMatch(e, n, r) {
    return this.prevMatchInRange(e, 0, n) || this.prevMatchInRange(e, r, e.doc.length);
  }
  getReplacement(e) {
    return this.spec.unquote(this.spec.replace);
  }
  matchAll(e, n) {
    let r = Fo(this.spec, e, 0, e.doc.length), i = [];
    for (; !r.next().done; ) {
      if (i.length >= n)
        return null;
      i.push(r.value);
    }
    return i;
  }
  highlight(e, n, r, i) {
    let s = Fo(this.spec, e, Math.max(0, n - this.spec.unquoted.length), Math.min(r + this.spec.unquoted.length, e.doc.length));
    for (; !s.next().done; )
      i(s.value.from, s.value.to);
  }
}
function zo(t, e, n, r) {
  return new j$(e.doc, t.search, {
    ignoreCase: !t.caseSensitive,
    test: t.wholeWord ? WG(e.charCategorizer(e.selection.main.head)) : void 0
  }, n, r);
}
function ed(t, e) {
  return t.slice(Pt(t, e, !1), e);
}
function td(t, e) {
  return t.slice(e, Pt(t, e));
}
function WG(t) {
  return (e, n, r) => !r[0].length || (t(ed(r.input, r.index)) != tt.Word || t(td(r.input, r.index)) != tt.Word) && (t(td(r.input, r.index + r[0].length)) != tt.Word || t(ed(r.input, r.index + r[0].length)) != tt.Word);
}
class jG extends K$ {
  nextMatch(e, n, r) {
    let i = zo(this.spec, e, r, e.doc.length).next();
    return i.done && (i = zo(this.spec, e, 0, n).next()), i.done ? null : i.value;
  }
  prevMatchInRange(e, n, r) {
    for (let i = 1; ; i++) {
      let s = Math.max(
        n,
        r - i * 1e4
        /* FindPrev.ChunkSize */
      ), o = zo(this.spec, e, s, r), a = null;
      for (; !o.next().done; )
        a = o.value;
      if (a && (s == n || a.from > s + 10))
        return a;
      if (s == n)
        return null;
    }
  }
  prevMatch(e, n, r) {
    return this.prevMatchInRange(e, 0, n) || this.prevMatchInRange(e, r, e.doc.length);
  }
  getReplacement(e) {
    return this.spec.unquote(this.spec.replace).replace(/\$([$&\d+])/g, (n, r) => r == "$" ? "$" : r == "&" ? e.match[0] : r != "0" && +r < e.match.length ? e.match[r] : n);
  }
  matchAll(e, n) {
    let r = zo(this.spec, e, 0, e.doc.length), i = [];
    for (; !r.next().done; ) {
      if (i.length >= n)
        return null;
      i.push(r.value);
    }
    return i;
  }
  highlight(e, n, r, i) {
    let s = zo(this.spec, e, Math.max(
      0,
      n - 250
      /* RegExp.HighlightMargin */
    ), Math.min(r + 250, e.doc.length));
    for (; !s.next().done; )
      i(s.value.from, s.value.to);
  }
}
const Ic = /* @__PURE__ */ De.define(), ay = /* @__PURE__ */ De.define(), is = /* @__PURE__ */ It.define({
  create(t) {
    return new Fm(iv(t).create(), null);
  },
  update(t, e) {
    for (let n of e.effects)
      n.is(Ic) ? t = new Fm(n.value.create(), t.panel) : n.is(ay) && (t = new Fm(t.query, n.value ? ly : null));
    return t;
  },
  provide: (t) => Pc.from(t, (e) => e.panel)
});
class Fm {
  constructor(e, n) {
    this.query = e, this.panel = n;
  }
}
const qG = /* @__PURE__ */ we.mark({ class: "cm-searchMatch" }), UG = /* @__PURE__ */ we.mark({ class: "cm-searchMatch cm-searchMatch-selected" }), KG = /* @__PURE__ */ dt.fromClass(class {
  constructor(t) {
    this.view = t, this.decorations = this.highlight(t.state.field(is));
  }
  update(t) {
    let e = t.state.field(is);
    (e != t.startState.field(is) || t.docChanged || t.selectionSet || t.viewportChanged) && (this.decorations = this.highlight(e));
  }
  highlight({ query: t, panel: e }) {
    if (!e || !t.spec.valid)
      return we.none;
    let { view: n } = this, r = new ds();
    for (let i = 0, s = n.visibleRanges, o = s.length; i < o; i++) {
      let { from: a, to: l } = s[i];
      for (; i < o - 1 && l > s[i + 1].from - 2 * 250; )
        l = s[++i].to;
      t.highlight(n.state, a, l, (c, u) => {
        let h = n.state.selection.ranges.some((f) => f.from == c && f.to == u);
        r.add(c, u, h ? UG : qG);
      });
    }
    return r.finish();
  }
}, {
  decorations: (t) => t.decorations
});
function Su(t) {
  return (e) => {
    let n = e.state.field(is, !1);
    return n && n.query.spec.valid ? t(e, n) : Z$(e);
  };
}
const nd = /* @__PURE__ */ Su((t, { query: e }) => {
  let { to: n } = t.state.selection.main, r = e.nextMatch(t.state, n, n);
  if (!r)
    return !1;
  let i = W.single(r.from, r.to), s = t.state.facet(Ga);
  return t.dispatch({
    selection: i,
    effects: [cy(t, r), s.scrollToMatch(i.main, t)],
    userEvent: "select.search"
  }), X$(t), !0;
}), rd = /* @__PURE__ */ Su((t, { query: e }) => {
  let { state: n } = t, { from: r } = n.selection.main, i = e.prevMatch(n, r, r);
  if (!i)
    return !1;
  let s = W.single(i.from, i.to), o = t.state.facet(Ga);
  return t.dispatch({
    selection: s,
    effects: [cy(t, i), o.scrollToMatch(s.main, t)],
    userEvent: "select.search"
  }), X$(t), !0;
}), GG = /* @__PURE__ */ Su((t, { query: e }) => {
  let n = e.matchAll(t.state, 1e3);
  return !n || !n.length ? !1 : (t.dispatch({
    selection: W.create(n.map((r) => W.range(r.from, r.to))),
    userEvent: "select.search.matches"
  }), !0);
}), XG = ({ state: t, dispatch: e }) => {
  let n = t.selection;
  if (n.ranges.length > 1 || n.main.empty)
    return !1;
  let { from: r, to: i } = n.main, s = [], o = 0;
  for (let a = new Ta(t.doc, t.sliceDoc(r, i)); !a.next().done; ) {
    if (s.length > 1e3)
      return !1;
    a.value.from == r && (o = s.length), s.push(W.range(a.value.from, a.value.to));
  }
  return e(t.update({
    selection: W.create(s, o),
    userEvent: "select.search.matches"
  })), !0;
}, Xw = /* @__PURE__ */ Su((t, { query: e }) => {
  let { state: n } = t, { from: r, to: i } = n.selection.main;
  if (n.readOnly)
    return !1;
  let s = e.nextMatch(n, r, r);
  if (!s)
    return !1;
  let o = [], a, l, c = [];
  if (s.from == r && s.to == i && (l = n.toText(e.getReplacement(s)), o.push({ from: s.from, to: s.to, insert: l }), s = e.nextMatch(n, s.from, s.to), c.push(de.announce.of(n.phrase("replaced match on line $", n.doc.lineAt(r).number) + "."))), s) {
    let u = o.length == 0 || o[0].from >= s.to ? 0 : s.to - s.from - l.length;
    a = W.single(s.from - u, s.to - u), c.push(cy(t, s)), c.push(n.facet(Ga).scrollToMatch(a.main, t));
  }
  return t.dispatch({
    changes: o,
    selection: a,
    effects: c,
    userEvent: "input.replace"
  }), !0;
}), ZG = /* @__PURE__ */ Su((t, { query: e }) => {
  if (t.state.readOnly)
    return !1;
  let n = e.matchAll(t.state, 1e9).map((i) => {
    let { from: s, to: o } = i;
    return { from: s, to: o, insert: e.getReplacement(i) };
  });
  if (!n.length)
    return !1;
  let r = t.state.phrase("replaced $ matches", n.length) + ".";
  return t.dispatch({
    changes: n,
    effects: de.announce.of(r),
    userEvent: "input.replace.all"
  }), !0;
});
function ly(t) {
  return t.state.facet(Ga).createPanel(t);
}
function iv(t, e) {
  var n, r, i, s, o;
  let a = t.selection.main, l = a.empty || a.to > a.from + 100 ? "" : t.sliceDoc(a.from, a.to);
  if (e && !l)
    return e;
  let c = t.facet(Ga);
  return new U$({
    search: ((n = e == null ? void 0 : e.literal) !== null && n !== void 0 ? n : c.literal) ? l : l.replace(/\n/g, "\\n"),
    caseSensitive: (r = e == null ? void 0 : e.caseSensitive) !== null && r !== void 0 ? r : c.caseSensitive,
    literal: (i = e == null ? void 0 : e.literal) !== null && i !== void 0 ? i : c.literal,
    regexp: (s = e == null ? void 0 : e.regexp) !== null && s !== void 0 ? s : c.regexp,
    wholeWord: (o = e == null ? void 0 : e.wholeWord) !== null && o !== void 0 ? o : c.wholeWord
  });
}
function G$(t) {
  let e = Ec(t, ly);
  return e && e.dom.querySelector("[main-field]");
}
function X$(t) {
  let e = G$(t);
  e && e == t.root.activeElement && e.select();
}
const Z$ = (t) => {
  let e = t.state.field(is, !1);
  if (e && e.panel) {
    let n = G$(t);
    if (n && n != t.root.activeElement) {
      let r = iv(t.state, e.query.spec);
      r.valid && t.dispatch({ effects: Ic.of(r) }), n.focus(), n.select();
    }
  } else
    t.dispatch({ effects: [
      ay.of(!0),
      e ? Ic.of(iv(t.state, e.query.spec)) : De.appendConfig.of(tX)
    ] });
  return !0;
}, J$ = (t) => {
  let e = t.state.field(is, !1);
  if (!e || !e.panel)
    return !1;
  let n = Ec(t, ly);
  return n && n.dom.contains(t.root.activeElement) && t.focus(), t.dispatch({ effects: ay.of(!1) }), !0;
}, JG = [
  { key: "Mod-f", run: Z$, scope: "editor search-panel" },
  { key: "F3", run: nd, shift: rd, scope: "editor search-panel", preventDefault: !0 },
  { key: "Mod-g", run: nd, shift: rd, scope: "editor search-panel", preventDefault: !0 },
  { key: "Escape", run: J$, scope: "editor search-panel" },
  { key: "Mod-Shift-l", run: XG },
  { key: "Mod-Alt-g", run: DG },
  { key: "Mod-d", run: VG, preventDefault: !0 }
];
class QG {
  constructor(e) {
    this.view = e;
    let n = this.query = e.state.field(is).query.spec;
    this.commit = this.commit.bind(this), this.searchField = Ge("input", {
      value: n.search,
      placeholder: xn(e, "Find"),
      "aria-label": xn(e, "Find"),
      class: "cm-textfield",
      name: "search",
      form: "",
      "main-field": "true",
      onchange: this.commit,
      onkeyup: this.commit
    }), this.replaceField = Ge("input", {
      value: n.replace,
      placeholder: xn(e, "Replace"),
      "aria-label": xn(e, "Replace"),
      class: "cm-textfield",
      name: "replace",
      form: "",
      onchange: this.commit,
      onkeyup: this.commit
    }), this.caseField = Ge("input", {
      type: "checkbox",
      name: "case",
      form: "",
      checked: n.caseSensitive,
      onchange: this.commit
    }), this.reField = Ge("input", {
      type: "checkbox",
      name: "re",
      form: "",
      checked: n.regexp,
      onchange: this.commit
    }), this.wordField = Ge("input", {
      type: "checkbox",
      name: "word",
      form: "",
      checked: n.wholeWord,
      onchange: this.commit
    });
    function r(i, s, o) {
      return Ge("button", { class: "cm-button", name: i, onclick: s, type: "button" }, o);
    }
    this.dom = Ge("div", { onkeydown: (i) => this.keydown(i), class: "cm-search" }, [
      this.searchField,
      r("next", () => nd(e), [xn(e, "next")]),
      r("prev", () => rd(e), [xn(e, "previous")]),
      r("select", () => GG(e), [xn(e, "all")]),
      Ge("label", null, [this.caseField, xn(e, "match case")]),
      Ge("label", null, [this.reField, xn(e, "regexp")]),
      Ge("label", null, [this.wordField, xn(e, "by word")]),
      ...e.state.readOnly ? [] : [
        Ge("br"),
        this.replaceField,
        r("replace", () => Xw(e), [xn(e, "replace")]),
        r("replaceAll", () => ZG(e), [xn(e, "replace all")])
      ],
      Ge("button", {
        name: "close",
        onclick: () => J$(e),
        "aria-label": xn(e, "close"),
        type: "button"
      }, ["×"])
    ]);
  }
  commit() {
    let e = new U$({
      search: this.searchField.value,
      caseSensitive: this.caseField.checked,
      regexp: this.reField.checked,
      wholeWord: this.wordField.checked,
      replace: this.replaceField.value
    });
    e.eq(this.query) || (this.query = e, this.view.dispatch({ effects: Ic.of(e) }));
  }
  keydown(e) {
    sq(this.view, e, "search-panel") ? e.preventDefault() : e.keyCode == 13 && e.target == this.searchField ? (e.preventDefault(), (e.shiftKey ? rd : nd)(this.view)) : e.keyCode == 13 && e.target == this.replaceField && (e.preventDefault(), Xw(this.view));
  }
  update(e) {
    for (let n of e.transactions)
      for (let r of n.effects)
        r.is(Ic) && !r.value.eq(this.query) && this.setQuery(r.value);
  }
  setQuery(e) {
    this.query = e, this.searchField.value = e.search, this.replaceField.value = e.replace, this.caseField.checked = e.caseSensitive, this.reField.checked = e.regexp, this.wordField.checked = e.wholeWord;
  }
  mount() {
    this.searchField.select();
  }
  get pos() {
    return 80;
  }
  get top() {
    return this.view.state.facet(Ga).top;
  }
}
function xn(t, e) {
  return t.state.phrase(e);
}
const vf = 30, yf = /[\s\.,:;?!]/;
function cy(t, { from: e, to: n }) {
  let r = t.state.doc.lineAt(e), i = t.state.doc.lineAt(n).to, s = Math.max(r.from, e - vf), o = Math.min(i, n + vf), a = t.state.sliceDoc(s, o);
  if (s != r.from) {
    for (let l = 0; l < vf; l++)
      if (!yf.test(a[l + 1]) && yf.test(a[l])) {
        a = a.slice(l);
        break;
      }
  }
  if (o != i) {
    for (let l = a.length - 1; l > a.length - vf; l--)
      if (!yf.test(a[l - 1]) && yf.test(a[l])) {
        a = a.slice(0, l);
        break;
      }
  }
  return de.announce.of(`${t.state.phrase("current match")}. ${a} ${t.state.phrase("on line")} ${r.number}.`);
}
const eX = /* @__PURE__ */ de.baseTheme({
  ".cm-panel.cm-search": {
    padding: "2px 6px 4px",
    position: "relative",
    "& [name=close]": {
      position: "absolute",
      top: "0",
      right: "4px",
      backgroundColor: "inherit",
      border: "none",
      font: "inherit",
      padding: 0,
      margin: 0
    },
    "& input, & button, & label": {
      margin: ".2em .6em .2em 0"
    },
    "& input[type=checkbox]": {
      marginRight: ".2em"
    },
    "& label": {
      fontSize: "80%",
      whiteSpace: "pre"
    }
  },
  "&light .cm-searchMatch": { backgroundColor: "#ffff0054" },
  "&dark .cm-searchMatch": { backgroundColor: "#00ffff8a" },
  "&light .cm-searchMatch-selected": { backgroundColor: "#ff6a0054" },
  "&dark .cm-searchMatch-selected": { backgroundColor: "#ff00ff8a" }
}), tX = [
  is,
  /* @__PURE__ */ $o.low(KG),
  eX
];
class Q$ {
  /**
  Create a new completion context. (Mostly useful for testing
  completion sources—in the editor, the extension will create
  these for you.)
  */
  constructor(e, n, r, i) {
    this.state = e, this.pos = n, this.explicit = r, this.view = i, this.abortListeners = [];
  }
  /**
  Get the extent, content, and (if there is a token) type of the
  token before `this.pos`.
  */
  tokenBefore(e) {
    let n = Wt(this.state).resolveInner(this.pos, -1);
    for (; n && e.indexOf(n.name) < 0; )
      n = n.parent;
    return n ? {
      from: n.from,
      to: this.pos,
      text: this.state.sliceDoc(n.from, this.pos),
      type: n.type
    } : null;
  }
  /**
  Get the match of the given expression directly before the
  cursor.
  */
  matchBefore(e) {
    let n = this.state.doc.lineAt(this.pos), r = Math.max(n.from, this.pos - 250), i = n.text.slice(r - n.from, this.pos - n.from), s = i.search(eA(e, !1));
    return s < 0 ? null : { from: r + s, to: this.pos, text: i.slice(s) };
  }
  /**
  Yields true when the query has been aborted. Can be useful in
  asynchronous queries to avoid doing work that will be ignored.
  */
  get aborted() {
    return this.abortListeners == null;
  }
  /**
  Allows you to register abort handlers, which will be called when
  the query is
  [aborted](https://codemirror.net/6/docs/ref/#autocomplete.CompletionContext.aborted).
  */
  addEventListener(e, n) {
    e == "abort" && this.abortListeners && this.abortListeners.push(n);
  }
}
function Zw(t) {
  let e = Object.keys(t).join(""), n = /\w/.test(e);
  return n && (e = e.replace(/\w/g, "")), `[${n ? "\\w" : ""}${e.replace(/[^\w\s]/g, "\\$&")}]`;
}
function nX(t) {
  let e = /* @__PURE__ */ Object.create(null), n = /* @__PURE__ */ Object.create(null);
  for (let { label: i } of t) {
    e[i[0]] = !0;
    for (let s = 1; s < i.length; s++)
      n[i[s]] = !0;
  }
  let r = Zw(e) + Zw(n) + "*$";
  return [new RegExp("^" + r), new RegExp(r)];
}
function rX(t) {
  let e = t.map((i) => typeof i == "string" ? { label: i } : i), [n, r] = e.every((i) => /^\w+$/.test(i.label)) ? [/\w*$/, /\w+$/] : nX(e);
  return (i) => {
    let s = i.matchBefore(r);
    return s || i.explicit ? { from: s ? s.from : i.pos, options: e, validFor: n } : null;
  };
}
class Jw {
  constructor(e, n, r, i) {
    this.completion = e, this.source = n, this.match = r, this.score = i;
  }
}
function ss(t) {
  return t.selection.main.from;
}
function eA(t, e) {
  var n;
  let { source: r } = t, i = e && r[0] != "^", s = r[r.length - 1] != "$";
  return !i && !s ? t : new RegExp(`${i ? "^" : ""}(?:${r})${s ? "$" : ""}`, (n = t.flags) !== null && n !== void 0 ? n : t.ignoreCase ? "i" : "");
}
const tA = /* @__PURE__ */ Ti.define();
function iX(t, e, n, r) {
  let { main: i } = t.selection, s = n - i.from, o = r - i.from;
  return Object.assign(Object.assign({}, t.changeByRange((a) => a != i && n != r && t.sliceDoc(a.from + s, a.from + o) != t.sliceDoc(n, r) ? { range: a } : {
    changes: { from: a.from + s, to: r == i.from ? a.to : a.from + o, insert: e },
    range: W.cursor(a.from + s + e.length)
  })), { scrollIntoView: !0, userEvent: "input.complete" });
}
const Qw = /* @__PURE__ */ new WeakMap();
function sX(t) {
  if (!Array.isArray(t))
    return t;
  let e = Qw.get(t);
  return e || Qw.set(t, e = rX(t)), e;
}
const id = /* @__PURE__ */ De.define(), Rc = /* @__PURE__ */ De.define();
class oX {
  constructor(e) {
    this.pattern = e, this.chars = [], this.folded = [], this.any = [], this.precise = [], this.byWord = [], this.score = 0, this.matched = [];
    for (let n = 0; n < e.length; ) {
      let r = Dt(e, n), i = In(r);
      this.chars.push(r);
      let s = e.slice(n, n + i), o = s.toUpperCase();
      this.folded.push(Dt(o == s ? s.toLowerCase() : o, 0)), n += i;
    }
    this.astral = e.length != this.chars.length;
  }
  ret(e, n) {
    return this.score = e, this.matched = n, this;
  }
  // Matches a given word (completion) against the pattern (input).
  // Will return a boolean indicating whether there was a match and,
  // on success, set `this.score` to the score, `this.matched` to an
  // array of `from, to` pairs indicating the matched parts of `word`.
  //
  // The score is a number that is more negative the worse the match
  // is. See `Penalty` above.
  match(e) {
    if (this.pattern.length == 0)
      return this.ret(-100, []);
    if (e.length < this.pattern.length)
      return null;
    let { chars: n, folded: r, any: i, precise: s, byWord: o } = this;
    if (n.length == 1) {
      let y = Dt(e, 0), x = In(y), b = x == e.length ? 0 : -100;
      if (y != n[0]) if (y == r[0])
        b += -200;
      else
        return null;
      return this.ret(b, [0, x]);
    }
    let a = e.indexOf(this.pattern);
    if (a == 0)
      return this.ret(e.length == this.pattern.length ? 0 : -100, [0, this.pattern.length]);
    let l = n.length, c = 0;
    if (a < 0) {
      for (let y = 0, x = Math.min(e.length, 200); y < x && c < l; ) {
        let b = Dt(e, y);
        (b == n[c] || b == r[c]) && (i[c++] = y), y += In(b);
      }
      if (c < l)
        return null;
    }
    let u = 0, h = 0, f = !1, d = 0, p = -1, m = -1, v = /[a-z]/.test(e), g = !0;
    for (let y = 0, x = Math.min(e.length, 200), b = 0; y < x && h < l; ) {
      let w = Dt(e, y);
      a < 0 && (u < l && w == n[u] && (s[u++] = y), d < l && (w == n[d] || w == r[d] ? (d == 0 && (p = y), m = y + 1, d++) : d = 0));
      let k, _ = w < 255 ? w >= 48 && w <= 57 || w >= 97 && w <= 122 ? 2 : w >= 65 && w <= 90 ? 1 : 0 : (k = z1(w)) != k.toLowerCase() ? 1 : k != k.toUpperCase() ? 2 : 0;
      (!y || _ == 1 && v || b == 0 && _ != 0) && (n[h] == w || r[h] == w && (f = !0) ? o[h++] = y : o.length && (g = !1)), b = _, y += In(w);
    }
    return h == l && o[0] == 0 && g ? this.result(-100 + (f ? -200 : 0), o, e) : d == l && p == 0 ? this.ret(-200 - e.length + (m == e.length ? 0 : -100), [0, m]) : a > -1 ? this.ret(-700 - e.length, [a, a + this.pattern.length]) : d == l ? this.ret(-900 - e.length, [p, m]) : h == l ? this.result(-100 + (f ? -200 : 0) + -700 + (g ? 0 : -1100), o, e) : n.length == 2 ? null : this.result((i[0] ? -700 : 0) + -200 + -1100, i, e);
  }
  result(e, n, r) {
    let i = [], s = 0;
    for (let o of n) {
      let a = o + (this.astral ? In(Dt(r, o)) : 1);
      s && i[s - 1] == o ? i[s - 1] = a : (i[s++] = o, i[s++] = a);
    }
    return this.ret(e - r.length, i);
  }
}
class aX {
  constructor(e) {
    this.pattern = e, this.matched = [], this.score = 0, this.folded = e.toLowerCase();
  }
  match(e) {
    if (e.length < this.pattern.length)
      return null;
    let n = e.slice(0, this.pattern.length), r = n == this.pattern ? 0 : n.toLowerCase() == this.folded ? -200 : null;
    return r == null ? null : (this.matched = [0, n.length], this.score = r + (e.length == this.pattern.length ? 0 : -100), this);
  }
}
const Et = /* @__PURE__ */ ve.define({
  combine(t) {
    return Jr(t, {
      activateOnTyping: !0,
      activateOnCompletion: () => !1,
      activateOnTypingDelay: 100,
      selectOnOpen: !0,
      override: null,
      closeOnBlur: !0,
      maxRenderedOptions: 100,
      defaultKeymap: !0,
      tooltipClass: () => "",
      optionClass: () => "",
      aboveCursor: !1,
      icons: !0,
      addToOptions: [],
      positionInfo: lX,
      filterStrict: !1,
      compareCompletions: (e, n) => e.label.localeCompare(n.label),
      interactionDelay: 75,
      updateSyncTime: 100
    }, {
      defaultKeymap: (e, n) => e && n,
      closeOnBlur: (e, n) => e && n,
      icons: (e, n) => e && n,
      tooltipClass: (e, n) => (r) => ek(e(r), n(r)),
      optionClass: (e, n) => (r) => ek(e(r), n(r)),
      addToOptions: (e, n) => e.concat(n),
      filterStrict: (e, n) => e || n
    });
  }
});
function ek(t, e) {
  return t ? e ? t + " " + e : t : e;
}
function lX(t, e, n, r, i, s) {
  let o = t.textDirection == Qe.RTL, a = o, l = !1, c = "top", u, h, f = e.left - i.left, d = i.right - e.right, p = r.right - r.left, m = r.bottom - r.top;
  if (a && f < Math.min(p, d) ? a = !1 : !a && d < Math.min(p, f) && (a = !0), p <= (a ? f : d))
    u = Math.max(i.top, Math.min(n.top, i.bottom - m)) - e.top, h = Math.min(400, a ? f : d);
  else {
    l = !0, h = Math.min(
      400,
      (o ? e.right : i.right - e.left) - 30
      /* Info.Margin */
    );
    let y = i.bottom - e.bottom;
    y >= m || y > e.top ? u = n.bottom - e.top : (c = "bottom", u = e.bottom - n.top);
  }
  let v = (e.bottom - e.top) / s.offsetHeight, g = (e.right - e.left) / s.offsetWidth;
  return {
    style: `${c}: ${u / v}px; max-width: ${h / g}px`,
    class: "cm-completionInfo-" + (l ? o ? "left-narrow" : "right-narrow" : a ? "left" : "right")
  };
}
function cX(t) {
  let e = t.addToOptions.slice();
  return t.icons && e.push({
    render(n) {
      let r = document.createElement("div");
      return r.classList.add("cm-completionIcon"), n.type && r.classList.add(...n.type.split(/\s+/g).map((i) => "cm-completionIcon-" + i)), r.setAttribute("aria-hidden", "true"), r;
    },
    position: 20
  }), e.push({
    render(n, r, i, s) {
      let o = document.createElement("span");
      o.className = "cm-completionLabel";
      let a = n.displayLabel || n.label, l = 0;
      for (let c = 0; c < s.length; ) {
        let u = s[c++], h = s[c++];
        u > l && o.appendChild(document.createTextNode(a.slice(l, u)));
        let f = o.appendChild(document.createElement("span"));
        f.appendChild(document.createTextNode(a.slice(u, h))), f.className = "cm-completionMatchedText", l = h;
      }
      return l < a.length && o.appendChild(document.createTextNode(a.slice(l))), o;
    },
    position: 50
  }, {
    render(n) {
      if (!n.detail)
        return null;
      let r = document.createElement("span");
      return r.className = "cm-completionDetail", r.textContent = n.detail, r;
    },
    position: 80
  }), e.sort((n, r) => n.position - r.position).map((n) => n.render);
}
function zm(t, e, n) {
  if (t <= n)
    return { from: 0, to: t };
  if (e < 0 && (e = 0), e <= t >> 1) {
    let i = Math.floor(e / n);
    return { from: i * n, to: (i + 1) * n };
  }
  let r = Math.floor((t - e) / n);
  return { from: t - (r + 1) * n, to: t - r * n };
}
class uX {
  constructor(e, n, r) {
    this.view = e, this.stateField = n, this.applyCompletion = r, this.info = null, this.infoDestroy = null, this.placeInfoReq = {
      read: () => this.measureInfo(),
      write: (l) => this.placeInfo(l),
      key: this
    }, this.space = null, this.currentClass = "";
    let i = e.state.field(n), { options: s, selected: o } = i.open, a = e.state.facet(Et);
    this.optionContent = cX(a), this.optionClass = a.optionClass, this.tooltipClass = a.tooltipClass, this.range = zm(s.length, o, a.maxRenderedOptions), this.dom = document.createElement("div"), this.dom.className = "cm-tooltip-autocomplete", this.updateTooltipClass(e.state), this.dom.addEventListener("mousedown", (l) => {
      let { options: c } = e.state.field(n).open;
      for (let u = l.target, h; u && u != this.dom; u = u.parentNode)
        if (u.nodeName == "LI" && (h = /-(\d+)$/.exec(u.id)) && +h[1] < c.length) {
          this.applyCompletion(e, c[+h[1]]), l.preventDefault();
          return;
        }
    }), this.dom.addEventListener("focusout", (l) => {
      let c = e.state.field(this.stateField, !1);
      c && c.tooltip && e.state.facet(Et).closeOnBlur && l.relatedTarget != e.contentDOM && e.dispatch({ effects: Rc.of(null) });
    }), this.showOptions(s, i.id);
  }
  mount() {
    this.updateSel();
  }
  showOptions(e, n) {
    this.list && this.list.remove(), this.list = this.dom.appendChild(this.createListBox(e, n, this.range)), this.list.addEventListener("scroll", () => {
      this.info && this.view.requestMeasure(this.placeInfoReq);
    });
  }
  update(e) {
    var n;
    let r = e.state.field(this.stateField), i = e.startState.field(this.stateField);
    if (this.updateTooltipClass(e.state), r != i) {
      let { options: s, selected: o, disabled: a } = r.open;
      (!i.open || i.open.options != s) && (this.range = zm(s.length, o, e.state.facet(Et).maxRenderedOptions), this.showOptions(s, r.id)), this.updateSel(), a != ((n = i.open) === null || n === void 0 ? void 0 : n.disabled) && this.dom.classList.toggle("cm-tooltip-autocomplete-disabled", !!a);
    }
  }
  updateTooltipClass(e) {
    let n = this.tooltipClass(e);
    if (n != this.currentClass) {
      for (let r of this.currentClass.split(" "))
        r && this.dom.classList.remove(r);
      for (let r of n.split(" "))
        r && this.dom.classList.add(r);
      this.currentClass = n;
    }
  }
  positioned(e) {
    this.space = e, this.info && this.view.requestMeasure(this.placeInfoReq);
  }
  updateSel() {
    let e = this.view.state.field(this.stateField), n = e.open;
    if ((n.selected > -1 && n.selected < this.range.from || n.selected >= this.range.to) && (this.range = zm(n.options.length, n.selected, this.view.state.facet(Et).maxRenderedOptions), this.showOptions(n.options, e.id)), this.updateSelectedOption(n.selected)) {
      this.destroyInfo();
      let { completion: r } = n.options[n.selected], { info: i } = r;
      if (!i)
        return;
      let s = typeof i == "string" ? document.createTextNode(i) : i(r);
      if (!s)
        return;
      "then" in s ? s.then((o) => {
        o && this.view.state.field(this.stateField, !1) == e && this.addInfoPane(o, r);
      }).catch((o) => un(this.view.state, o, "completion info")) : this.addInfoPane(s, r);
    }
  }
  addInfoPane(e, n) {
    this.destroyInfo();
    let r = this.info = document.createElement("div");
    if (r.className = "cm-tooltip cm-completionInfo", e.nodeType != null)
      r.appendChild(e), this.infoDestroy = null;
    else {
      let { dom: i, destroy: s } = e;
      r.appendChild(i), this.infoDestroy = s || null;
    }
    this.dom.appendChild(r), this.view.requestMeasure(this.placeInfoReq);
  }
  updateSelectedOption(e) {
    let n = null;
    for (let r = this.list.firstChild, i = this.range.from; r; r = r.nextSibling, i++)
      r.nodeName != "LI" || !r.id ? i-- : i == e ? r.hasAttribute("aria-selected") || (r.setAttribute("aria-selected", "true"), n = r) : r.hasAttribute("aria-selected") && r.removeAttribute("aria-selected");
    return n && hX(this.list, n), n;
  }
  measureInfo() {
    let e = this.dom.querySelector("[aria-selected]");
    if (!e || !this.info)
      return null;
    let n = this.dom.getBoundingClientRect(), r = this.info.getBoundingClientRect(), i = e.getBoundingClientRect(), s = this.space;
    if (!s) {
      let o = this.dom.ownerDocument.defaultView || window;
      s = { left: 0, top: 0, right: o.innerWidth, bottom: o.innerHeight };
    }
    return i.top > Math.min(s.bottom, n.bottom) - 10 || i.bottom < Math.max(s.top, n.top) + 10 ? null : this.view.state.facet(Et).positionInfo(this.view, n, i, r, s, this.dom);
  }
  placeInfo(e) {
    this.info && (e ? (e.style && (this.info.style.cssText = e.style), this.info.className = "cm-tooltip cm-completionInfo " + (e.class || "")) : this.info.style.cssText = "top: -1e6px");
  }
  createListBox(e, n, r) {
    const i = document.createElement("ul");
    i.id = n, i.setAttribute("role", "listbox"), i.setAttribute("aria-expanded", "true"), i.setAttribute("aria-label", this.view.state.phrase("Completions"));
    let s = null;
    for (let o = r.from; o < r.to; o++) {
      let { completion: a, match: l } = e[o], { section: c } = a;
      if (c) {
        let f = typeof c == "string" ? c : c.name;
        if (f != s && (o > r.from || r.from == 0))
          if (s = f, typeof c != "string" && c.header)
            i.appendChild(c.header(c));
          else {
            let d = i.appendChild(document.createElement("completion-section"));
            d.textContent = f;
          }
      }
      const u = i.appendChild(document.createElement("li"));
      u.id = n + "-" + o, u.setAttribute("role", "option");
      let h = this.optionClass(a);
      h && (u.className = h);
      for (let f of this.optionContent) {
        let d = f(a, this.view.state, this.view, l);
        d && u.appendChild(d);
      }
    }
    return r.from && i.classList.add("cm-completionListIncompleteTop"), r.to < e.length && i.classList.add("cm-completionListIncompleteBottom"), i;
  }
  destroyInfo() {
    this.info && (this.infoDestroy && this.infoDestroy(), this.info.remove(), this.info = null);
  }
  destroy() {
    this.destroyInfo();
  }
}
function fX(t, e) {
  return (n) => new uX(n, t, e);
}
function hX(t, e) {
  let n = t.getBoundingClientRect(), r = e.getBoundingClientRect(), i = n.height / t.offsetHeight;
  r.top < n.top ? t.scrollTop -= (n.top - r.top) / i : r.bottom > n.bottom && (t.scrollTop += (r.bottom - n.bottom) / i);
}
function tk(t) {
  return (t.boost || 0) * 100 + (t.apply ? 10 : 0) + (t.info ? 5 : 0) + (t.type ? 1 : 0);
}
function dX(t, e) {
  let n = [], r = null, i = (c) => {
    n.push(c);
    let { section: u } = c.completion;
    if (u) {
      r || (r = []);
      let h = typeof u == "string" ? u : u.name;
      r.some((f) => f.name == h) || r.push(typeof u == "string" ? { name: h } : u);
    }
  }, s = e.facet(Et);
  for (let c of t)
    if (c.hasResult()) {
      let u = c.result.getMatch;
      if (c.result.filter === !1)
        for (let h of c.result.options)
          i(new Jw(h, c.source, u ? u(h) : [], 1e9 - n.length));
      else {
        let h = e.sliceDoc(c.from, c.to), f, d = s.filterStrict ? new aX(h) : new oX(h);
        for (let p of c.result.options)
          if (f = d.match(p.label)) {
            let m = p.displayLabel ? u ? u(p, f.matched) : [] : f.matched;
            i(new Jw(p, c.source, m, f.score + (p.boost || 0)));
          }
      }
    }
  if (r) {
    let c = /* @__PURE__ */ Object.create(null), u = 0, h = (f, d) => {
      var p, m;
      return ((p = f.rank) !== null && p !== void 0 ? p : 1e9) - ((m = d.rank) !== null && m !== void 0 ? m : 1e9) || (f.name < d.name ? -1 : 1);
    };
    for (let f of r.sort(h))
      u -= 1e5, c[f.name] = u;
    for (let f of n) {
      let { section: d } = f.completion;
      d && (f.score += c[typeof d == "string" ? d : d.name]);
    }
  }
  let o = [], a = null, l = s.compareCompletions;
  for (let c of n.sort((u, h) => h.score - u.score || l(u.completion, h.completion))) {
    let u = c.completion;
    !a || a.label != u.label || a.detail != u.detail || a.type != null && u.type != null && a.type != u.type || a.apply != u.apply || a.boost != u.boost ? o.push(c) : tk(c.completion) > tk(a) && (o[o.length - 1] = c), a = c.completion;
  }
  return o;
}
class Uo {
  constructor(e, n, r, i, s, o) {
    this.options = e, this.attrs = n, this.tooltip = r, this.timestamp = i, this.selected = s, this.disabled = o;
  }
  setSelected(e, n) {
    return e == this.selected || e >= this.options.length ? this : new Uo(this.options, nk(n, e), this.tooltip, this.timestamp, e, this.disabled);
  }
  static build(e, n, r, i, s) {
    let o = dX(e, n);
    if (!o.length)
      return i && e.some(
        (l) => l.state == 1
        /* State.Pending */
      ) ? new Uo(i.options, i.attrs, i.tooltip, i.timestamp, i.selected, !0) : null;
    let a = n.facet(Et).selectOnOpen ? 0 : -1;
    if (i && i.selected != a && i.selected != -1) {
      let l = i.options[i.selected].completion;
      for (let c = 0; c < o.length; c++)
        if (o[c].completion == l) {
          a = c;
          break;
        }
    }
    return new Uo(o, nk(r, a), {
      pos: e.reduce((l, c) => c.hasResult() ? Math.min(l, c.from) : l, 1e8),
      create: bX,
      above: s.aboveCursor
    }, i ? i.timestamp : Date.now(), a, !1);
  }
  map(e) {
    return new Uo(this.options, this.attrs, Object.assign(Object.assign({}, this.tooltip), { pos: e.mapPos(this.tooltip.pos) }), this.timestamp, this.selected, this.disabled);
  }
}
class sd {
  constructor(e, n, r) {
    this.active = e, this.id = n, this.open = r;
  }
  static start() {
    return new sd(vX, "cm-ac-" + Math.floor(Math.random() * 2e6).toString(36), null);
  }
  update(e) {
    let { state: n } = e, r = n.facet(Et), s = (r.override || n.languageDataAt("autocomplete", ss(n)).map(sX)).map((a) => (this.active.find((c) => c.source == a) || new kn(
      a,
      this.active.some(
        (c) => c.state != 0
        /* State.Inactive */
      ) ? 1 : 0
      /* State.Inactive */
    )).update(e, r));
    s.length == this.active.length && s.every((a, l) => a == this.active[l]) && (s = this.active);
    let o = this.open;
    o && e.docChanged && (o = o.map(e.changes)), e.selection || s.some((a) => a.hasResult() && e.changes.touchesRange(a.from, a.to)) || !pX(s, this.active) ? o = Uo.build(s, n, this.id, o, r) : o && o.disabled && !s.some(
      (a) => a.state == 1
      /* State.Pending */
    ) && (o = null), !o && s.every(
      (a) => a.state != 1
      /* State.Pending */
    ) && s.some((a) => a.hasResult()) && (s = s.map((a) => a.hasResult() ? new kn(
      a.source,
      0
      /* State.Inactive */
    ) : a));
    for (let a of e.effects)
      a.is(iA) && (o = o && o.setSelected(a.value, this.id));
    return s == this.active && o == this.open ? this : new sd(s, this.id, o);
  }
  get tooltip() {
    return this.open ? this.open.tooltip : null;
  }
  get attrs() {
    return this.open ? this.open.attrs : this.active.length ? mX : gX;
  }
}
function pX(t, e) {
  if (t == e)
    return !0;
  for (let n = 0, r = 0; ; ) {
    for (; n < t.length && !t[n].hasResult; )
      n++;
    for (; r < e.length && !e[r].hasResult; )
      r++;
    let i = n == t.length, s = r == e.length;
    if (i || s)
      return i == s;
    if (t[n++].result != e[r++].result)
      return !1;
  }
}
const mX = {
  "aria-autocomplete": "list"
}, gX = {};
function nk(t, e) {
  let n = {
    "aria-autocomplete": "list",
    "aria-haspopup": "listbox",
    "aria-controls": t
  };
  return e > -1 && (n["aria-activedescendant"] = t + "-" + e), n;
}
const vX = [];
function nA(t, e) {
  if (t.isUserEvent("input.complete")) {
    let r = t.annotation(tA);
    if (r && e.activateOnCompletion(r))
      return 12;
  }
  let n = t.isUserEvent("input.type");
  return n && e.activateOnTyping ? 5 : n ? 1 : t.isUserEvent("delete.backward") ? 2 : t.selection ? 8 : t.docChanged ? 16 : 0;
}
class kn {
  constructor(e, n, r = -1) {
    this.source = e, this.state = n, this.explicitPos = r;
  }
  hasResult() {
    return !1;
  }
  update(e, n) {
    let r = nA(e, n), i = this;
    (r & 8 || r & 16 && this.touches(e)) && (i = new kn(
      i.source,
      0
      /* State.Inactive */
    )), r & 4 && i.state == 0 && (i = new kn(
      this.source,
      1
      /* State.Pending */
    )), i = i.updateFor(e, r);
    for (let s of e.effects)
      if (s.is(id))
        i = new kn(i.source, 1, s.value ? ss(e.state) : -1);
      else if (s.is(Rc))
        i = new kn(
          i.source,
          0
          /* State.Inactive */
        );
      else if (s.is(rA))
        for (let o of s.value)
          o.source == i.source && (i = o);
    return i;
  }
  updateFor(e, n) {
    return this.map(e.changes);
  }
  map(e) {
    return e.empty || this.explicitPos < 0 ? this : new kn(this.source, this.state, e.mapPos(this.explicitPos));
  }
  touches(e) {
    return e.changes.touchesRange(ss(e.state));
  }
}
class sa extends kn {
  constructor(e, n, r, i, s) {
    super(e, 2, n), this.result = r, this.from = i, this.to = s;
  }
  hasResult() {
    return !0;
  }
  updateFor(e, n) {
    var r;
    if (!(n & 3))
      return this.map(e.changes);
    let i = this.result;
    i.map && !e.changes.empty && (i = i.map(i, e.changes));
    let s = e.changes.mapPos(this.from), o = e.changes.mapPos(this.to, 1), a = ss(e.state);
    if ((this.explicitPos < 0 ? a <= s : a < this.from) || a > o || !i || n & 2 && ss(e.startState) == this.from)
      return new kn(
        this.source,
        n & 4 ? 1 : 0
        /* State.Inactive */
      );
    let l = this.explicitPos < 0 ? -1 : e.changes.mapPos(this.explicitPos);
    return yX(i.validFor, e.state, s, o) ? new sa(this.source, l, i, s, o) : i.update && (i = i.update(i, s, o, new Q$(e.state, a, l >= 0))) ? new sa(this.source, l, i, i.from, (r = i.to) !== null && r !== void 0 ? r : ss(e.state)) : new kn(this.source, 1, l);
  }
  map(e) {
    return e.empty ? this : (this.result.map ? this.result.map(this.result, e) : this.result) ? new sa(this.source, this.explicitPos < 0 ? -1 : e.mapPos(this.explicitPos), this.result, e.mapPos(this.from), e.mapPos(this.to, 1)) : new kn(
      this.source,
      0
      /* State.Inactive */
    );
  }
  touches(e) {
    return e.changes.touchesRange(this.from, this.to);
  }
}
function yX(t, e, n, r) {
  if (!t)
    return !1;
  let i = e.sliceDoc(n, r);
  return typeof t == "function" ? t(i, n, r, e) : eA(t, !0).test(i);
}
const rA = /* @__PURE__ */ De.define({
  map(t, e) {
    return t.map((n) => n.map(e));
  }
}), iA = /* @__PURE__ */ De.define(), ln = /* @__PURE__ */ It.define({
  create() {
    return sd.start();
  },
  update(t, e) {
    return t.update(e);
  },
  provide: (t) => [
    Z1.from(t, (e) => e.tooltip),
    de.contentAttributes.from(t, (e) => e.attrs)
  ]
});
function uy(t, e) {
  const n = e.completion.apply || e.completion.label;
  let r = t.state.field(ln).active.find((i) => i.source == e.source);
  return r instanceof sa ? (typeof n == "string" ? t.dispatch(Object.assign(Object.assign({}, iX(t.state, n, r.from, r.to)), { annotations: tA.of(e.completion) })) : n(t, e.completion, r.from, r.to), !0) : !1;
}
const bX = /* @__PURE__ */ fX(ln, uy);
function bf(t, e = "option") {
  return (n) => {
    let r = n.state.field(ln, !1);
    if (!r || !r.open || r.open.disabled || Date.now() - r.open.timestamp < n.state.facet(Et).interactionDelay)
      return !1;
    let i = 1, s;
    e == "page" && (s = Y6(n, r.open.tooltip)) && (i = Math.max(2, Math.floor(s.dom.offsetHeight / s.dom.querySelector("li").offsetHeight) - 1));
    let { length: o } = r.open.options, a = r.open.selected > -1 ? r.open.selected + i * (t ? 1 : -1) : t ? 0 : o - 1;
    return a < 0 ? a = e == "page" ? 0 : o - 1 : a >= o && (a = e == "page" ? o - 1 : 0), n.dispatch({ effects: iA.of(a) }), !0;
  };
}
const xX = (t) => {
  let e = t.state.field(ln, !1);
  return t.state.readOnly || !e || !e.open || e.open.selected < 0 || e.open.disabled || Date.now() - e.open.timestamp < t.state.facet(Et).interactionDelay ? !1 : uy(t, e.open.options[e.open.selected]);
}, wX = (t) => t.state.field(ln, !1) ? (t.dispatch({ effects: id.of(!0) }), !0) : !1, kX = (t) => {
  let e = t.state.field(ln, !1);
  return !e || !e.active.some(
    (n) => n.state != 0
    /* State.Inactive */
  ) ? !1 : (t.dispatch({ effects: Rc.of(null) }), !0);
};
class _X {
  constructor(e, n) {
    this.active = e, this.context = n, this.time = Date.now(), this.updates = [], this.done = void 0;
  }
}
const SX = 50, MX = 1e3, CX = /* @__PURE__ */ dt.fromClass(class {
  constructor(t) {
    this.view = t, this.debounceUpdate = -1, this.running = [], this.debounceAccept = -1, this.pendingStart = !1, this.composing = 0;
    for (let e of t.state.field(ln).active)
      e.state == 1 && this.startQuery(e);
  }
  update(t) {
    let e = t.state.field(ln), n = t.state.facet(Et);
    if (!t.selectionSet && !t.docChanged && t.startState.field(ln) == e)
      return;
    let r = t.transactions.some((s) => {
      let o = nA(s, n);
      return o & 8 || (s.selection || s.docChanged) && !(o & 3);
    });
    for (let s = 0; s < this.running.length; s++) {
      let o = this.running[s];
      if (r || o.updates.length + t.transactions.length > SX && Date.now() - o.time > MX) {
        for (let a of o.context.abortListeners)
          try {
            a();
          } catch (l) {
            un(this.view.state, l);
          }
        o.context.abortListeners = null, this.running.splice(s--, 1);
      } else
        o.updates.push(...t.transactions);
    }
    this.debounceUpdate > -1 && clearTimeout(this.debounceUpdate), t.transactions.some((s) => s.effects.some((o) => o.is(id))) && (this.pendingStart = !0);
    let i = this.pendingStart ? 50 : n.activateOnTypingDelay;
    if (this.debounceUpdate = e.active.some((s) => s.state == 1 && !this.running.some((o) => o.active.source == s.source)) ? setTimeout(() => this.startUpdate(), i) : -1, this.composing != 0)
      for (let s of t.transactions)
        s.isUserEvent("input.type") ? this.composing = 2 : this.composing == 2 && s.selection && (this.composing = 3);
  }
  startUpdate() {
    this.debounceUpdate = -1, this.pendingStart = !1;
    let { state: t } = this.view, e = t.field(ln);
    for (let n of e.active)
      n.state == 1 && !this.running.some((r) => r.active.source == n.source) && this.startQuery(n);
  }
  startQuery(t) {
    let { state: e } = this.view, n = ss(e), r = new Q$(e, n, t.explicitPos == n, this.view), i = new _X(t, r);
    this.running.push(i), Promise.resolve(t.source(r)).then((s) => {
      i.context.aborted || (i.done = s || null, this.scheduleAccept());
    }, (s) => {
      this.view.dispatch({ effects: Rc.of(null) }), un(this.view.state, s);
    });
  }
  scheduleAccept() {
    this.running.every((t) => t.done !== void 0) ? this.accept() : this.debounceAccept < 0 && (this.debounceAccept = setTimeout(() => this.accept(), this.view.state.facet(Et).updateSyncTime));
  }
  // For each finished query in this.running, try to create a result
  // or, if appropriate, restart the query.
  accept() {
    var t;
    this.debounceAccept > -1 && clearTimeout(this.debounceAccept), this.debounceAccept = -1;
    let e = [], n = this.view.state.facet(Et);
    for (let r = 0; r < this.running.length; r++) {
      let i = this.running[r];
      if (i.done === void 0)
        continue;
      if (this.running.splice(r--, 1), i.done) {
        let o = new sa(i.active.source, i.active.explicitPos, i.done, i.done.from, (t = i.done.to) !== null && t !== void 0 ? t : ss(i.updates.length ? i.updates[0].startState : this.view.state));
        for (let a of i.updates)
          o = o.update(a, n);
        if (o.hasResult()) {
          e.push(o);
          continue;
        }
      }
      let s = this.view.state.field(ln).active.find((o) => o.source == i.active.source);
      if (s && s.state == 1)
        if (i.done == null) {
          let o = new kn(
            i.active.source,
            0
            /* State.Inactive */
          );
          for (let a of i.updates)
            o = o.update(a, n);
          o.state != 1 && e.push(o);
        } else
          this.startQuery(s);
    }
    e.length && this.view.dispatch({ effects: rA.of(e) });
  }
}, {
  eventHandlers: {
    blur(t) {
      let e = this.view.state.field(ln, !1);
      if (e && e.tooltip && this.view.state.facet(Et).closeOnBlur) {
        let n = e.open && Y6(this.view, e.open.tooltip);
        (!n || !n.dom.contains(t.relatedTarget)) && setTimeout(() => this.view.dispatch({ effects: Rc.of(null) }), 10);
      }
    },
    compositionstart() {
      this.composing = 1;
    },
    compositionend() {
      this.composing == 3 && setTimeout(() => this.view.dispatch({ effects: id.of(!1) }), 20), this.composing = 0;
    }
  }
}), $X = typeof navigator == "object" && /* @__PURE__ */ /Win/.test(navigator.platform), AX = /* @__PURE__ */ $o.highest(/* @__PURE__ */ de.domEventHandlers({
  keydown(t, e) {
    let n = e.state.field(ln, !1);
    if (!n || !n.open || n.open.disabled || n.open.selected < 0 || t.key.length > 1 || t.ctrlKey && !($X && t.altKey) || t.metaKey)
      return !1;
    let r = n.open.options[n.open.selected], i = n.active.find((o) => o.source == r.source), s = r.completion.commitCharacters || i.result.commitCharacters;
    return s && s.indexOf(t.key) > -1 && uy(e, r), !1;
  }
})), DX = /* @__PURE__ */ de.baseTheme({
  ".cm-tooltip.cm-tooltip-autocomplete": {
    "& > ul": {
      fontFamily: "monospace",
      whiteSpace: "nowrap",
      overflow: "hidden auto",
      maxWidth_fallback: "700px",
      maxWidth: "min(700px, 95vw)",
      minWidth: "250px",
      maxHeight: "10em",
      height: "100%",
      listStyle: "none",
      margin: 0,
      padding: 0,
      "& > li, & > completion-section": {
        padding: "1px 3px",
        lineHeight: 1.2
      },
      "& > li": {
        overflowX: "hidden",
        textOverflow: "ellipsis",
        cursor: "pointer"
      },
      "& > completion-section": {
        display: "list-item",
        borderBottom: "1px solid silver",
        paddingLeft: "0.5em",
        opacity: 0.7
      }
    }
  },
  "&light .cm-tooltip-autocomplete ul li[aria-selected]": {
    background: "#17c",
    color: "white"
  },
  "&light .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
    background: "#777"
  },
  "&dark .cm-tooltip-autocomplete ul li[aria-selected]": {
    background: "#347",
    color: "white"
  },
  "&dark .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
    background: "#444"
  },
  ".cm-completionListIncompleteTop:before, .cm-completionListIncompleteBottom:after": {
    content: '"···"',
    opacity: 0.5,
    display: "block",
    textAlign: "center"
  },
  ".cm-tooltip.cm-completionInfo": {
    position: "absolute",
    padding: "3px 9px",
    width: "max-content",
    maxWidth: "400px",
    boxSizing: "border-box"
  },
  ".cm-completionInfo.cm-completionInfo-left": { right: "100%" },
  ".cm-completionInfo.cm-completionInfo-right": { left: "100%" },
  ".cm-completionInfo.cm-completionInfo-left-narrow": { right: "30px" },
  ".cm-completionInfo.cm-completionInfo-right-narrow": { left: "30px" },
  "&light .cm-snippetField": { backgroundColor: "#00000022" },
  "&dark .cm-snippetField": { backgroundColor: "#ffffff22" },
  ".cm-snippetFieldPosition": {
    verticalAlign: "text-top",
    width: 0,
    height: "1.15em",
    display: "inline-block",
    margin: "0 -0.7px -.7em",
    borderLeft: "1.4px dotted #888"
  },
  ".cm-completionMatchedText": {
    textDecoration: "underline"
  },
  ".cm-completionDetail": {
    marginLeft: "0.5em",
    fontStyle: "italic"
  },
  ".cm-completionIcon": {
    fontSize: "90%",
    width: ".8em",
    display: "inline-block",
    textAlign: "center",
    paddingRight: ".6em",
    opacity: "0.6",
    boxSizing: "content-box"
  },
  ".cm-completionIcon-function, .cm-completionIcon-method": {
    "&:after": { content: "'ƒ'" }
  },
  ".cm-completionIcon-class": {
    "&:after": { content: "'○'" }
  },
  ".cm-completionIcon-interface": {
    "&:after": { content: "'◌'" }
  },
  ".cm-completionIcon-variable": {
    "&:after": { content: "'𝑥'" }
  },
  ".cm-completionIcon-constant": {
    "&:after": { content: "'𝐶'" }
  },
  ".cm-completionIcon-type": {
    "&:after": { content: "'𝑡'" }
  },
  ".cm-completionIcon-enum": {
    "&:after": { content: "'∪'" }
  },
  ".cm-completionIcon-property": {
    "&:after": { content: "'□'" }
  },
  ".cm-completionIcon-keyword": {
    "&:after": { content: "'🔑︎'" }
    // Disable emoji rendering
  },
  ".cm-completionIcon-namespace": {
    "&:after": { content: "'▢'" }
  },
  ".cm-completionIcon-text": {
    "&:after": { content: "'abc'", fontSize: "50%", verticalAlign: "middle" }
  }
}), Bc = {
  brackets: ["(", "[", "{", "'", '"'],
  before: ")]}:;>",
  stringPrefixes: []
}, Ws = /* @__PURE__ */ De.define({
  map(t, e) {
    let n = e.mapPos(t, -1, Qt.TrackAfter);
    return n == null ? void 0 : n;
  }
}), fy = /* @__PURE__ */ new class extends po {
}();
fy.startSide = 1;
fy.endSide = -1;
const sA = /* @__PURE__ */ It.define({
  create() {
    return Be.empty;
  },
  update(t, e) {
    if (t = t.map(e.changes), e.selection) {
      let n = e.state.doc.lineAt(e.selection.main.head);
      t = t.update({ filter: (r) => r >= n.from && r <= n.to });
    }
    for (let n of e.effects)
      n.is(Ws) && (t = t.update({ add: [fy.range(n.value, n.value + 1)] }));
    return t;
  }
});
function TX() {
  return [EX, sA];
}
const Vm = "()[]{}<>";
function oA(t) {
  for (let e = 0; e < Vm.length; e += 2)
    if (Vm.charCodeAt(e) == t)
      return Vm.charAt(e + 1);
  return z1(t < 128 ? t : t + 1);
}
function aA(t, e) {
  return t.languageDataAt("closeBrackets", e)[0] || Bc;
}
const OX = typeof navigator == "object" && /* @__PURE__ */ /Android\b/.test(navigator.userAgent), EX = /* @__PURE__ */ de.inputHandler.of((t, e, n, r) => {
  if ((OX ? t.composing : t.compositionStarted) || t.state.readOnly)
    return !1;
  let i = t.state.selection.main;
  if (r.length > 2 || r.length == 2 && In(Dt(r, 0)) == 1 || e != i.from || n != i.to)
    return !1;
  let s = NX(t.state, r);
  return s ? (t.dispatch(s), !0) : !1;
}), PX = ({ state: t, dispatch: e }) => {
  if (t.readOnly)
    return !1;
  let r = aA(t, t.selection.main.head).brackets || Bc.brackets, i = null, s = t.changeByRange((o) => {
    if (o.empty) {
      let a = IX(t.doc, o.head);
      for (let l of r)
        if (l == a && vp(t.doc, o.head) == oA(Dt(l, 0)))
          return {
            changes: { from: o.head - l.length, to: o.head + l.length },
            range: W.cursor(o.head - l.length)
          };
    }
    return { range: i = o };
  });
  return i || e(t.update(s, { scrollIntoView: !0, userEvent: "delete.backward" })), !i;
}, LX = [
  { key: "Backspace", run: PX }
];
function NX(t, e) {
  let n = aA(t, t.selection.main.head), r = n.brackets || Bc.brackets;
  for (let i of r) {
    let s = oA(Dt(i, 0));
    if (e == i)
      return s == i ? FX(t, i, r.indexOf(i + i + i) > -1, n) : RX(t, i, s, n.before || Bc.before);
    if (e == s && lA(t, t.selection.main.from))
      return BX(t, i, s);
  }
  return null;
}
function lA(t, e) {
  let n = !1;
  return t.field(sA).between(0, t.doc.length, (r) => {
    r == e && (n = !0);
  }), n;
}
function vp(t, e) {
  let n = t.sliceString(e, e + 2);
  return n.slice(0, In(Dt(n, 0)));
}
function IX(t, e) {
  let n = t.sliceString(e - 2, e);
  return In(Dt(n, 0)) == n.length ? n : n.slice(1);
}
function RX(t, e, n, r) {
  let i = null, s = t.changeByRange((o) => {
    if (!o.empty)
      return {
        changes: [{ insert: e, from: o.from }, { insert: n, from: o.to }],
        effects: Ws.of(o.to + e.length),
        range: W.range(o.anchor + e.length, o.head + e.length)
      };
    let a = vp(t.doc, o.head);
    return !a || /\s/.test(a) || r.indexOf(a) > -1 ? {
      changes: { insert: e + n, from: o.head },
      effects: Ws.of(o.head + e.length),
      range: W.cursor(o.head + e.length)
    } : { range: i = o };
  });
  return i ? null : t.update(s, {
    scrollIntoView: !0,
    userEvent: "input.type"
  });
}
function BX(t, e, n) {
  let r = null, i = t.changeByRange((s) => s.empty && vp(t.doc, s.head) == n ? {
    changes: { from: s.head, to: s.head + n.length, insert: n },
    range: W.cursor(s.head + n.length)
  } : r = { range: s });
  return r ? null : t.update(i, {
    scrollIntoView: !0,
    userEvent: "input.type"
  });
}
function FX(t, e, n, r) {
  let i = r.stringPrefixes || Bc.stringPrefixes, s = null, o = t.changeByRange((a) => {
    if (!a.empty)
      return {
        changes: [{ insert: e, from: a.from }, { insert: e, from: a.to }],
        effects: Ws.of(a.to + e.length),
        range: W.range(a.anchor + e.length, a.head + e.length)
      };
    let l = a.head, c = vp(t.doc, l), u;
    if (c == e) {
      if (rk(t, l))
        return {
          changes: { insert: e + e, from: l },
          effects: Ws.of(l + e.length),
          range: W.cursor(l + e.length)
        };
      if (lA(t, l)) {
        let f = n && t.sliceDoc(l, l + e.length * 3) == e + e + e ? e + e + e : e;
        return {
          changes: { from: l, to: l + f.length, insert: f },
          range: W.cursor(l + f.length)
        };
      }
    } else {
      if (n && t.sliceDoc(l - 2 * e.length, l) == e + e && (u = ik(t, l - 2 * e.length, i)) > -1 && rk(t, u))
        return {
          changes: { insert: e + e + e + e, from: l },
          effects: Ws.of(l + e.length),
          range: W.cursor(l + e.length)
        };
      if (t.charCategorizer(l)(c) != tt.Word && ik(t, l, i) > -1 && !zX(t, l, e, i))
        return {
          changes: { insert: e + e, from: l },
          effects: Ws.of(l + e.length),
          range: W.cursor(l + e.length)
        };
    }
    return { range: s = a };
  });
  return s ? null : t.update(o, {
    scrollIntoView: !0,
    userEvent: "input.type"
  });
}
function rk(t, e) {
  let n = Wt(t).resolveInner(e + 1);
  return n.parent && n.from == e;
}
function zX(t, e, n, r) {
  let i = Wt(t).resolveInner(e, -1), s = r.reduce((o, a) => Math.max(o, a.length), 0);
  for (let o = 0; o < 5; o++) {
    let a = t.sliceDoc(i.from, Math.min(i.to, i.from + n.length + s)), l = a.indexOf(n);
    if (!l || l > -1 && r.indexOf(a.slice(0, l)) > -1) {
      let u = i.firstChild;
      for (; u && u.from == i.from && u.to - u.from > n.length + l; ) {
        if (t.sliceDoc(u.to - n.length, u.to) == n)
          return !1;
        u = u.firstChild;
      }
      return !0;
    }
    let c = i.to == e && i.parent;
    if (!c)
      break;
    i = c;
  }
  return !1;
}
function ik(t, e, n) {
  let r = t.charCategorizer(e);
  if (r(t.sliceDoc(e - 1, e)) != tt.Word)
    return e;
  for (let i of n) {
    let s = e - i.length;
    if (t.sliceDoc(s, e) == i && r(t.sliceDoc(s - 1, s)) != tt.Word)
      return s;
  }
  return -1;
}
function VX(t = {}) {
  return [
    AX,
    ln,
    Et.of(t),
    CX,
    HX,
    DX
  ];
}
const cA = [
  { key: "Ctrl-Space", run: wX },
  { key: "Escape", run: kX },
  { key: "ArrowDown", run: /* @__PURE__ */ bf(!0) },
  { key: "ArrowUp", run: /* @__PURE__ */ bf(!1) },
  { key: "PageDown", run: /* @__PURE__ */ bf(!0, "page") },
  { key: "PageUp", run: /* @__PURE__ */ bf(!1, "page") },
  { key: "Enter", run: xX }
], HX = /* @__PURE__ */ $o.highest(/* @__PURE__ */ ap.computeN([Et], (t) => t.facet(Et).defaultKeymap ? [cA] : []));
class YX {
  constructor(e, n, r) {
    this.from = e, this.to = n, this.diagnostic = r;
  }
}
class Fs {
  constructor(e, n, r) {
    this.diagnostics = e, this.panel = n, this.selected = r;
  }
  static init(e, n, r) {
    let i = e, s = r.facet(Fc).markerFilter;
    s && (i = s(i, r));
    let o = we.set(i.map((a) => a.from == a.to || a.from == a.to - 1 && r.doc.lineAt(a.from).to == a.from ? we.widget({
      widget: new JX(a),
      diagnostic: a
    }).range(a.from) : we.mark({
      attributes: { class: "cm-lintRange cm-lintRange-" + a.severity + (a.markClass ? " " + a.markClass : "") },
      diagnostic: a
    }).range(a.from, a.to)), !0);
    return new Fs(o, n, Oa(o));
  }
}
function Oa(t, e = null, n = 0) {
  let r = null;
  return t.between(n, 1e9, (i, s, { spec: o }) => {
    if (!(e && o.diagnostic != e))
      return r = new YX(i, s, o.diagnostic), !1;
  }), r;
}
function WX(t, e) {
  let n = e.pos, r = e.end || n, i = t.state.facet(Fc).hideOn(t, n, r);
  if (i != null)
    return i;
  let s = t.startState.doc.lineAt(e.pos);
  return !!(t.effects.some((o) => o.is(uA)) || t.changes.touchesRange(s.from, Math.max(s.to, r)));
}
function jX(t, e) {
  return t.field(Mn, !1) ? e : e.concat(De.appendConfig.of(tZ));
}
const uA = /* @__PURE__ */ De.define(), hy = /* @__PURE__ */ De.define(), fA = /* @__PURE__ */ De.define(), Mn = /* @__PURE__ */ It.define({
  create() {
    return new Fs(we.none, null, null);
  },
  update(t, e) {
    if (e.docChanged && t.diagnostics.size) {
      let n = t.diagnostics.map(e.changes), r = null, i = t.panel;
      if (t.selected) {
        let s = e.changes.mapPos(t.selected.from, 1);
        r = Oa(n, t.selected.diagnostic, s) || Oa(n, null, s);
      }
      !n.size && i && e.state.facet(Fc).autoPanel && (i = null), t = new Fs(n, i, r);
    }
    for (let n of e.effects)
      if (n.is(uA)) {
        let r = e.state.facet(Fc).autoPanel ? n.value.length ? zc.open : null : t.panel;
        t = Fs.init(n.value, r, e.state);
      } else n.is(hy) ? t = new Fs(t.diagnostics, n.value ? zc.open : null, t.selected) : n.is(fA) && (t = new Fs(t.diagnostics, t.panel, n.value));
    return t;
  },
  provide: (t) => [
    Pc.from(t, (e) => e.panel),
    de.decorations.from(t, (e) => e.diagnostics)
  ]
}), qX = /* @__PURE__ */ we.mark({ class: "cm-lintRange cm-lintRange-active" });
function UX(t, e, n) {
  let { diagnostics: r } = t.state.field(Mn), i = [], s = 2e8, o = 0;
  r.between(e - (n < 0 ? 1 : 0), e + (n > 0 ? 1 : 0), (l, c, { spec: u }) => {
    e >= l && e <= c && (l == c || (e > l || n > 0) && (e < c || n < 0)) && (i.push(u.diagnostic), s = Math.min(l, s), o = Math.max(c, o));
  });
  let a = t.state.facet(Fc).tooltipFilter;
  return a && (i = a(i, t.state)), i.length ? {
    pos: s,
    end: o,
    above: t.state.doc.lineAt(s).to < o,
    create() {
      return { dom: KX(t, i) };
    }
  } : null;
}
function KX(t, e) {
  return Ge("ul", { class: "cm-tooltip-lint" }, e.map((n) => dA(t, n, !1)));
}
const GX = (t) => {
  let e = t.state.field(Mn, !1);
  (!e || !e.panel) && t.dispatch({ effects: jX(t.state, [hy.of(!0)]) });
  let n = Ec(t, zc.open);
  return n && n.dom.querySelector(".cm-panel-lint ul").focus(), !0;
}, sk = (t) => {
  let e = t.state.field(Mn, !1);
  return !e || !e.panel ? !1 : (t.dispatch({ effects: hy.of(!1) }), !0);
}, XX = (t) => {
  let e = t.state.field(Mn, !1);
  if (!e)
    return !1;
  let n = t.state.selection.main, r = e.diagnostics.iter(n.to + 1);
  return !r.value && (r = e.diagnostics.iter(0), !r.value || r.from == n.from && r.to == n.to) ? !1 : (t.dispatch({ selection: { anchor: r.from, head: r.to }, scrollIntoView: !0 }), !0);
}, ZX = [
  { key: "Mod-Shift-m", run: GX, preventDefault: !0 },
  { key: "F8", run: XX }
], Fc = /* @__PURE__ */ ve.define({
  combine(t) {
    return Object.assign({ sources: t.map((e) => e.source).filter((e) => e != null) }, Jr(t.map((e) => e.config), {
      delay: 750,
      markerFilter: null,
      tooltipFilter: null,
      needsRefresh: null,
      hideOn: () => null
    }, {
      needsRefresh: (e, n) => e ? n ? (r) => e(r) || n(r) : e : n
    }));
  }
});
function hA(t) {
  let e = [];
  if (t)
    e: for (let { name: n } of t) {
      for (let r = 0; r < n.length; r++) {
        let i = n[r];
        if (/[a-zA-Z]/.test(i) && !e.some((s) => s.toLowerCase() == i.toLowerCase())) {
          e.push(i);
          continue e;
        }
      }
      e.push("");
    }
  return e;
}
function dA(t, e, n) {
  var r;
  let i = n ? hA(e.actions) : [];
  return Ge("li", { class: "cm-diagnostic cm-diagnostic-" + e.severity }, Ge("span", { class: "cm-diagnosticText" }, e.renderMessage ? e.renderMessage(t) : e.message), (r = e.actions) === null || r === void 0 ? void 0 : r.map((s, o) => {
    let a = !1, l = (f) => {
      if (f.preventDefault(), a)
        return;
      a = !0;
      let d = Oa(t.state.field(Mn).diagnostics, e);
      d && s.apply(t, d.from, d.to);
    }, { name: c } = s, u = i[o] ? c.indexOf(i[o]) : -1, h = u < 0 ? c : [
      c.slice(0, u),
      Ge("u", c.slice(u, u + 1)),
      c.slice(u + 1)
    ];
    return Ge("button", {
      type: "button",
      class: "cm-diagnosticAction",
      onclick: l,
      onmousedown: l,
      "aria-label": ` Action: ${c}${u < 0 ? "" : ` (access key "${i[o]})"`}.`
    }, h);
  }), e.source && Ge("div", { class: "cm-diagnosticSource" }, e.source));
}
class JX extends Oi {
  constructor(e) {
    super(), this.diagnostic = e;
  }
  eq(e) {
    return e.diagnostic == this.diagnostic;
  }
  toDOM() {
    return Ge("span", { class: "cm-lintPoint cm-lintPoint-" + this.diagnostic.severity });
  }
}
class ok {
  constructor(e, n) {
    this.diagnostic = n, this.id = "item_" + Math.floor(Math.random() * 4294967295).toString(16), this.dom = dA(e, n, !0), this.dom.id = this.id, this.dom.setAttribute("role", "option");
  }
}
class zc {
  constructor(e) {
    this.view = e, this.items = [];
    let n = (i) => {
      if (i.keyCode == 27)
        sk(this.view), this.view.focus();
      else if (i.keyCode == 38 || i.keyCode == 33)
        this.moveSelection((this.selectedIndex - 1 + this.items.length) % this.items.length);
      else if (i.keyCode == 40 || i.keyCode == 34)
        this.moveSelection((this.selectedIndex + 1) % this.items.length);
      else if (i.keyCode == 36)
        this.moveSelection(0);
      else if (i.keyCode == 35)
        this.moveSelection(this.items.length - 1);
      else if (i.keyCode == 13)
        this.view.focus();
      else if (i.keyCode >= 65 && i.keyCode <= 90 && this.selectedIndex >= 0) {
        let { diagnostic: s } = this.items[this.selectedIndex], o = hA(s.actions);
        for (let a = 0; a < o.length; a++)
          if (o[a].toUpperCase().charCodeAt(0) == i.keyCode) {
            let l = Oa(this.view.state.field(Mn).diagnostics, s);
            l && s.actions[a].apply(e, l.from, l.to);
          }
      } else
        return;
      i.preventDefault();
    }, r = (i) => {
      for (let s = 0; s < this.items.length; s++)
        this.items[s].dom.contains(i.target) && this.moveSelection(s);
    };
    this.list = Ge("ul", {
      tabIndex: 0,
      role: "listbox",
      "aria-label": this.view.state.phrase("Diagnostics"),
      onkeydown: n,
      onclick: r
    }), this.dom = Ge("div", { class: "cm-panel-lint" }, this.list, Ge("button", {
      type: "button",
      name: "close",
      "aria-label": this.view.state.phrase("close"),
      onclick: () => sk(this.view)
    }, "×")), this.update();
  }
  get selectedIndex() {
    let e = this.view.state.field(Mn).selected;
    if (!e)
      return -1;
    for (let n = 0; n < this.items.length; n++)
      if (this.items[n].diagnostic == e.diagnostic)
        return n;
    return -1;
  }
  update() {
    let { diagnostics: e, selected: n } = this.view.state.field(Mn), r = 0, i = !1, s = null;
    for (e.between(0, this.view.state.doc.length, (o, a, { spec: l }) => {
      let c = -1, u;
      for (let h = r; h < this.items.length; h++)
        if (this.items[h].diagnostic == l.diagnostic) {
          c = h;
          break;
        }
      c < 0 ? (u = new ok(this.view, l.diagnostic), this.items.splice(r, 0, u), i = !0) : (u = this.items[c], c > r && (this.items.splice(r, c - r), i = !0)), n && u.diagnostic == n.diagnostic ? u.dom.hasAttribute("aria-selected") || (u.dom.setAttribute("aria-selected", "true"), s = u) : u.dom.hasAttribute("aria-selected") && u.dom.removeAttribute("aria-selected"), r++;
    }); r < this.items.length && !(this.items.length == 1 && this.items[0].diagnostic.from < 0); )
      i = !0, this.items.pop();
    this.items.length == 0 && (this.items.push(new ok(this.view, {
      from: -1,
      to: -1,
      severity: "info",
      message: this.view.state.phrase("No diagnostics")
    })), i = !0), s ? (this.list.setAttribute("aria-activedescendant", s.id), this.view.requestMeasure({
      key: this,
      read: () => ({ sel: s.dom.getBoundingClientRect(), panel: this.list.getBoundingClientRect() }),
      write: ({ sel: o, panel: a }) => {
        let l = a.height / this.list.offsetHeight;
        o.top < a.top ? this.list.scrollTop -= (a.top - o.top) / l : o.bottom > a.bottom && (this.list.scrollTop += (o.bottom - a.bottom) / l);
      }
    })) : this.selectedIndex < 0 && this.list.removeAttribute("aria-activedescendant"), i && this.sync();
  }
  sync() {
    let e = this.list.firstChild;
    function n() {
      let r = e;
      e = r.nextSibling, r.remove();
    }
    for (let r of this.items)
      if (r.dom.parentNode == this.list) {
        for (; e != r.dom; )
          n();
        e = r.dom.nextSibling;
      } else
        this.list.insertBefore(r.dom, e);
    for (; e; )
      n();
  }
  moveSelection(e) {
    if (this.selectedIndex < 0)
      return;
    let n = this.view.state.field(Mn), r = Oa(n.diagnostics, this.items[e].diagnostic);
    r && this.view.dispatch({
      selection: { anchor: r.from, head: r.to },
      scrollIntoView: !0,
      effects: fA.of(r)
    });
  }
  static open(e) {
    return new zc(e);
  }
}
function QX(t, e = 'viewBox="0 0 40 40"') {
  return `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" ${e}>${encodeURIComponent(t)}</svg>')`;
}
function xf(t) {
  return QX(`<path d="m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0" stroke="${t}" fill="none" stroke-width=".7"/>`, 'width="6" height="3"');
}
const eZ = /* @__PURE__ */ de.baseTheme({
  ".cm-diagnostic": {
    padding: "3px 6px 3px 8px",
    marginLeft: "-1px",
    display: "block",
    whiteSpace: "pre-wrap"
  },
  ".cm-diagnostic-error": { borderLeft: "5px solid #d11" },
  ".cm-diagnostic-warning": { borderLeft: "5px solid orange" },
  ".cm-diagnostic-info": { borderLeft: "5px solid #999" },
  ".cm-diagnostic-hint": { borderLeft: "5px solid #66d" },
  ".cm-diagnosticAction": {
    font: "inherit",
    border: "none",
    padding: "2px 4px",
    backgroundColor: "#444",
    color: "white",
    borderRadius: "3px",
    marginLeft: "8px",
    cursor: "pointer"
  },
  ".cm-diagnosticSource": {
    fontSize: "70%",
    opacity: 0.7
  },
  ".cm-lintRange": {
    backgroundPosition: "left bottom",
    backgroundRepeat: "repeat-x",
    paddingBottom: "0.7px"
  },
  ".cm-lintRange-error": { backgroundImage: /* @__PURE__ */ xf("#d11") },
  ".cm-lintRange-warning": { backgroundImage: /* @__PURE__ */ xf("orange") },
  ".cm-lintRange-info": { backgroundImage: /* @__PURE__ */ xf("#999") },
  ".cm-lintRange-hint": { backgroundImage: /* @__PURE__ */ xf("#66d") },
  ".cm-lintRange-active": { backgroundColor: "#ffdd9980" },
  ".cm-tooltip-lint": {
    padding: 0,
    margin: 0
  },
  ".cm-lintPoint": {
    position: "relative",
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: "-2px",
      borderLeft: "3px solid transparent",
      borderRight: "3px solid transparent",
      borderBottom: "4px solid #d11"
    }
  },
  ".cm-lintPoint-warning": {
    "&:after": { borderBottomColor: "orange" }
  },
  ".cm-lintPoint-info": {
    "&:after": { borderBottomColor: "#999" }
  },
  ".cm-lintPoint-hint": {
    "&:after": { borderBottomColor: "#66d" }
  },
  ".cm-panel.cm-panel-lint": {
    position: "relative",
    "& ul": {
      maxHeight: "100px",
      overflowY: "auto",
      "& [aria-selected]": {
        backgroundColor: "#ddd",
        "& u": { textDecoration: "underline" }
      },
      "&:focus [aria-selected]": {
        background_fallback: "#bdf",
        backgroundColor: "Highlight",
        color_fallback: "white",
        color: "HighlightText"
      },
      "& u": { textDecoration: "none" },
      padding: 0,
      margin: 0
    },
    "& [name=close]": {
      position: "absolute",
      top: "0",
      right: "2px",
      background: "inherit",
      border: "none",
      font: "inherit",
      padding: 0,
      margin: 0
    }
  }
}), tZ = [
  Mn,
  /* @__PURE__ */ de.decorations.compute([Mn], (t) => {
    let { selected: e, panel: n } = t.field(Mn);
    return !e || !n || e.from == e.to ? we.none : we.set([
      qX.range(e.from, e.to)
    ]);
  }),
  /* @__PURE__ */ Uq(UX, { hideOn: WX }),
  eZ
], nZ = [
  nU(),
  sU(),
  kq(),
  MK(),
  ZU(),
  fq(),
  gq(),
  Le.allowMultipleSelections.of(!0),
  RU(),
  QU(nK, { fallback: !0 }),
  cK(),
  TX(),
  VX(),
  Iq(),
  Fq(),
  Aq(),
  PG(),
  ap.of([
    ...LX,
    ...CG,
    ...JG,
    ...LK,
    ...UU,
    ...cA,
    ...ZX
  ])
];
/*!
* VueCodemirror v6.1.1
* Copyright (c) Surmon. All rights reserved.
* Released under the MIT License.
* Surmon
*/
var rZ = Object.freeze({ autofocus: !1, disabled: !1, indentWithTab: !0, tabSize: 2, placeholder: "", autoDestroy: !0, extensions: [nZ] }), iZ = Symbol("vue-codemirror-global-config"), Xt, sZ = function(t) {
  var e = t.onUpdate, n = t.onChange, r = t.onFocus, i = t.onBlur, s = function(o, a) {
    var l = {};
    for (var c in o) Object.prototype.hasOwnProperty.call(o, c) && a.indexOf(c) < 0 && (l[c] = o[c]);
    if (o != null && typeof Object.getOwnPropertySymbols == "function") {
      var u = 0;
      for (c = Object.getOwnPropertySymbols(o); u < c.length; u++) a.indexOf(c[u]) < 0 && Object.prototype.propertyIsEnumerable.call(o, c[u]) && (l[c[u]] = o[c[u]]);
    }
    return l;
  }(t, ["onUpdate", "onChange", "onFocus", "onBlur"]);
  return Le.create({ doc: s.doc, selection: s.selection, extensions: (Array.isArray(s.extensions) ? s.extensions : [s.extensions]).concat([de.updateListener.of(function(o) {
    e(o), o.docChanged && n(o.state.doc.toString(), o), o.focusChanged && (o.view.hasFocus ? r(o) : i(o));
  })]) });
}, Vo = function(t) {
  var e = new yu();
  return { compartment: e, run: function(n) {
    e.get(t.state) ? t.dispatch({ effects: e.reconfigure(n) }) : t.dispatch({ effects: De.appendConfig.of(e.of(n)) });
  } };
}, ak = function(t, e) {
  var n = Vo(t), r = n.compartment, i = n.run;
  return function(s) {
    var o = r.get(t.state);
    i((s != null ? s : o !== e) ? e : []);
  };
}, wf = { type: Boolean, default: void 0 }, oZ = { autofocus: wf, disabled: wf, indentWithTab: wf, tabSize: Number, placeholder: String, style: Object, autoDestroy: wf, phrases: Object, root: Object, extensions: Array, selection: Object }, aZ = { modelValue: { type: String, default: "" } }, lZ = Object.assign(Object.assign({}, oZ), aZ);
(function(t) {
  t.Change = "change", t.Update = "update", t.Focus = "focus", t.Blur = "blur", t.Ready = "ready", t.ModelUpdate = "update:modelValue";
})(Xt || (Xt = {}));
var zs = {};
zs[Xt.Change] = function(t, e) {
  return !0;
}, zs[Xt.Update] = function(t) {
  return !0;
}, zs[Xt.Focus] = function(t) {
  return !0;
}, zs[Xt.Blur] = function(t) {
  return !0;
}, zs[Xt.Ready] = function(t) {
  return !0;
};
var pA = {};
pA[Xt.ModelUpdate] = zs[Xt.Change];
var cZ = Object.assign(Object.assign({}, zs), pA), uZ = oe({ name: "VueCodemirror", props: Object.assign({}, lZ), emits: Object.assign({}, cZ), setup: function(t, e) {
  var n = Tp(), r = Tp(), i = Tp(), s = Object.assign(Object.assign({}, rZ), Fa(iZ, {})), o = T(function() {
    var a = {};
    return Object.keys(c7(t)).forEach(function(l) {
      var c;
      l !== "modelValue" && (a[l] = (c = t[l]) !== null && c !== void 0 ? c : s[l]);
    }), a;
  });
  return rn(function() {
    var a;
    r.value = sZ({ doc: t.modelValue, selection: o.value.selection, extensions: (a = s.extensions) !== null && a !== void 0 ? a : [], onFocus: function(c) {
      return e.emit(Xt.Focus, c);
    }, onBlur: function(c) {
      return e.emit(Xt.Blur, c);
    }, onUpdate: function(c) {
      return e.emit(Xt.Update, c);
    }, onChange: function(c, u) {
      c !== t.modelValue && (e.emit(Xt.Change, c, u), e.emit(Xt.ModelUpdate, c, u));
    } }), i.value = function(c) {
      return new de(Object.assign({}, c));
    }({ state: r.value, parent: n.value, root: o.value.root });
    var l = function(c) {
      var u = function() {
        return c.state.doc.toString();
      }, h = Vo(c).run, f = ak(c, [de.editable.of(!1), Le.readOnly.of(!0)]), d = ak(c, ap.of([$G])), p = Vo(c).run, m = Vo(c).run, v = Vo(c).run, g = Vo(c).run;
      return { focus: function() {
        return c.focus();
      }, getDoc: u, setDoc: function(y) {
        y !== u() && c.dispatch({ changes: { from: 0, to: c.state.doc.length, insert: y } });
      }, reExtensions: h, toggleDisabled: f, toggleIndentWithTab: d, setTabSize: function(y) {
        p([Le.tabSize.of(y), cp.of(" ".repeat(y))]);
      }, setPhrases: function(y) {
        m([Le.phrases.of(y)]);
      }, setPlaceholder: function(y) {
        v(Eq(y));
      }, setStyle: function(y) {
        y === void 0 && (y = {}), g(de.theme({ "&": Object.assign({}, y) }));
      } };
    }(i.value);
    Se(function() {
      return t.modelValue;
    }, function(c) {
      c !== l.getDoc() && l.setDoc(c);
    }), Se(function() {
      return t.extensions;
    }, function(c) {
      return l.reExtensions(c || []);
    }, { immediate: !0 }), Se(function() {
      return o.value.disabled;
    }, function(c) {
      return l.toggleDisabled(c);
    }, { immediate: !0 }), Se(function() {
      return o.value.indentWithTab;
    }, function(c) {
      return l.toggleIndentWithTab(c);
    }, { immediate: !0 }), Se(function() {
      return o.value.tabSize;
    }, function(c) {
      return l.setTabSize(c);
    }, { immediate: !0 }), Se(function() {
      return o.value.phrases;
    }, function(c) {
      return l.setPhrases(c || {});
    }, { immediate: !0 }), Se(function() {
      return o.value.placeholder;
    }, function(c) {
      return l.setPlaceholder(c);
    }, { immediate: !0 }), Se(function() {
      return o.value.style;
    }, function(c) {
      return l.setStyle(c);
    }, { immediate: !0 }), o.value.autofocus && l.focus(), e.emit(Xt.Ready, { state: r.value, view: i.value, container: n.value });
  }), Ba(function() {
    o.value.autoDestroy && i.value && function(a) {
      a.destroy();
    }(i.value);
  }), function() {
    return la("div", { class: "v-codemirror", style: { display: "contents" }, ref: n });
  };
} }), fZ = uZ;
const hZ = {
  key: 0,
  class: "vx-mt-1 vx-pl-0.5 vx-text-xs vx-text-rose-800"
}, dZ = {
  inheritAttrs: !1
}, pZ = /* @__PURE__ */ oe({
  ...dZ,
  __name: "vx-code-editor",
  props: {
    modelValue: {
      type: String,
      required: !0
    },
    error: {
      type: String,
      default: void 0
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, r = e;
    return (i, s) => (S(), D("div", {
      class: j(["vx-code-editor", {
        "vx-code-editor--invalid": n.error
      }])
    }, [
      re(P(fZ), Nt(i.$attrs, {
        modelValue: n.modelValue,
        "onUpdate:modelValue": s[0] || (s[0] = (o) => r("update:modelValue", o))
      }), null, 16, ["modelValue"]),
      n.error ? (S(), D("div", hZ, Pe(n.error), 1)) : Z("", !0)
    ], 2));
  }
}), jge = /* @__PURE__ */ jt(pZ, [["__scopeId", "data-v-18602662"]]);
var dn = "top", er = "bottom", tr = "right", pn = "left", dy = "auto", Mu = [dn, er, tr, pn], Ea = "start", Vc = "end", mZ = "clippingParents", mA = "viewport", xl = "popper", gZ = "reference", lk = /* @__PURE__ */ Mu.reduce(function(t, e) {
  return t.concat([e + "-" + Ea, e + "-" + Vc]);
}, []), gA = /* @__PURE__ */ [].concat(Mu, [dy]).reduce(function(t, e) {
  return t.concat([e, e + "-" + Ea, e + "-" + Vc]);
}, []), vZ = "beforeRead", yZ = "read", bZ = "afterRead", xZ = "beforeMain", wZ = "main", kZ = "afterMain", _Z = "beforeWrite", SZ = "write", MZ = "afterWrite", CZ = [vZ, yZ, bZ, xZ, wZ, kZ, _Z, SZ, MZ];
function Gr(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function On(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function bo(t) {
  var e = On(t).Element;
  return t instanceof e || t instanceof Element;
}
function Un(t) {
  var e = On(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function py(t) {
  if (typeof ShadowRoot == "undefined")
    return !1;
  var e = On(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function $Z(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(n) {
    var r = e.styles[n] || {}, i = e.attributes[n] || {}, s = e.elements[n];
    !Un(s) || !Gr(s) || (Object.assign(s.style, r), Object.keys(i).forEach(function(o) {
      var a = i[o];
      a === !1 ? s.removeAttribute(o) : s.setAttribute(o, a === !0 ? "" : a);
    }));
  });
}
function AZ(t) {
  var e = t.state, n = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, n.popper), e.styles = n, e.elements.arrow && Object.assign(e.elements.arrow.style, n.arrow), function() {
    Object.keys(e.elements).forEach(function(r) {
      var i = e.elements[r], s = e.attributes[r] || {}, o = Object.keys(e.styles.hasOwnProperty(r) ? e.styles[r] : n[r]), a = o.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !Un(i) || !Gr(i) || (Object.assign(i.style, a), Object.keys(s).forEach(function(l) {
        i.removeAttribute(l);
      }));
    });
  };
}
const vA = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: $Z,
  effect: AZ,
  requires: ["computeStyles"]
};
function Wr(t) {
  return t.split("-")[0];
}
var Qs = Math.max, od = Math.min, Pa = Math.round;
function sv() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function yA() {
  return !/^((?!chrome|android).)*safari/i.test(sv());
}
function La(t, e, n) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  var r = t.getBoundingClientRect(), i = 1, s = 1;
  e && Un(t) && (i = t.offsetWidth > 0 && Pa(r.width) / t.offsetWidth || 1, s = t.offsetHeight > 0 && Pa(r.height) / t.offsetHeight || 1);
  var o = bo(t) ? On(t) : window, a = o.visualViewport, l = !yA() && n, c = (r.left + (l && a ? a.offsetLeft : 0)) / i, u = (r.top + (l && a ? a.offsetTop : 0)) / s, h = r.width / i, f = r.height / s;
  return {
    width: h,
    height: f,
    top: u,
    right: c + h,
    bottom: u + f,
    left: c,
    x: c,
    y: u
  };
}
function my(t) {
  var e = La(t), n = t.offsetWidth, r = t.offsetHeight;
  return Math.abs(e.width - n) <= 1 && (n = e.width), Math.abs(e.height - r) <= 1 && (r = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: n,
    height: r
  };
}
function bA(t, e) {
  var n = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (n && py(n)) {
    var r = e;
    do {
      if (r && t.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function Mi(t) {
  return On(t).getComputedStyle(t);
}
function DZ(t) {
  return ["table", "td", "th"].indexOf(Gr(t)) >= 0;
}
function Ts(t) {
  return ((bo(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function yp(t) {
  return Gr(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (py(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Ts(t)
  );
}
function ck(t) {
  return !Un(t) || // https://github.com/popperjs/popper-core/issues/837
  Mi(t).position === "fixed" ? null : t.offsetParent;
}
function TZ(t) {
  var e = /firefox/i.test(sv()), n = /Trident/i.test(sv());
  if (n && Un(t)) {
    var r = Mi(t);
    if (r.position === "fixed")
      return null;
  }
  var i = yp(t);
  for (py(i) && (i = i.host); Un(i) && ["html", "body"].indexOf(Gr(i)) < 0; ) {
    var s = Mi(i);
    if (s.transform !== "none" || s.perspective !== "none" || s.contain === "paint" || ["transform", "perspective"].indexOf(s.willChange) !== -1 || e && s.willChange === "filter" || e && s.filter && s.filter !== "none")
      return i;
    i = i.parentNode;
  }
  return null;
}
function Cu(t) {
  for (var e = On(t), n = ck(t); n && DZ(n) && Mi(n).position === "static"; )
    n = ck(n);
  return n && (Gr(n) === "html" || Gr(n) === "body" && Mi(n).position === "static") ? e : n || TZ(t) || e;
}
function gy(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function oc(t, e, n) {
  return Qs(t, od(e, n));
}
function OZ(t, e, n) {
  var r = oc(t, e, n);
  return r > n ? n : r;
}
function xA() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function wA(t) {
  return Object.assign({}, xA(), t);
}
function kA(t, e) {
  return e.reduce(function(n, r) {
    return n[r] = t, n;
  }, {});
}
var EZ = function(e, n) {
  return e = typeof e == "function" ? e(Object.assign({}, n.rects, {
    placement: n.placement
  })) : e, wA(typeof e != "number" ? e : kA(e, Mu));
};
function PZ(t) {
  var e, n = t.state, r = t.name, i = t.options, s = n.elements.arrow, o = n.modifiersData.popperOffsets, a = Wr(n.placement), l = gy(a), c = [pn, tr].indexOf(a) >= 0, u = c ? "height" : "width";
  if (!(!s || !o)) {
    var h = EZ(i.padding, n), f = my(s), d = l === "y" ? dn : pn, p = l === "y" ? er : tr, m = n.rects.reference[u] + n.rects.reference[l] - o[l] - n.rects.popper[u], v = o[l] - n.rects.reference[l], g = Cu(s), y = g ? l === "y" ? g.clientHeight || 0 : g.clientWidth || 0 : 0, x = m / 2 - v / 2, b = h[d], w = y - f[u] - h[p], k = y / 2 - f[u] / 2 + x, _ = oc(b, k, w), C = l;
    n.modifiersData[r] = (e = {}, e[C] = _, e.centerOffset = _ - k, e);
  }
}
function LZ(t) {
  var e = t.state, n = t.options, r = n.element, i = r === void 0 ? "[data-popper-arrow]" : r;
  i != null && (typeof i == "string" && (i = e.elements.popper.querySelector(i), !i) || bA(e.elements.popper, i) && (e.elements.arrow = i));
}
const _A = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: PZ,
  effect: LZ,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Na(t) {
  return t.split("-")[1];
}
var NZ = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function IZ(t, e) {
  var n = t.x, r = t.y, i = e.devicePixelRatio || 1;
  return {
    x: Pa(n * i) / i || 0,
    y: Pa(r * i) / i || 0
  };
}
function uk(t) {
  var e, n = t.popper, r = t.popperRect, i = t.placement, s = t.variation, o = t.offsets, a = t.position, l = t.gpuAcceleration, c = t.adaptive, u = t.roundOffsets, h = t.isFixed, f = o.x, d = f === void 0 ? 0 : f, p = o.y, m = p === void 0 ? 0 : p, v = typeof u == "function" ? u({
    x: d,
    y: m
  }) : {
    x: d,
    y: m
  };
  d = v.x, m = v.y;
  var g = o.hasOwnProperty("x"), y = o.hasOwnProperty("y"), x = pn, b = dn, w = window;
  if (c) {
    var k = Cu(n), _ = "clientHeight", C = "clientWidth";
    if (k === On(n) && (k = Ts(n), Mi(k).position !== "static" && a === "absolute" && (_ = "scrollHeight", C = "scrollWidth")), k = k, i === dn || (i === pn || i === tr) && s === Vc) {
      b = er;
      var E = h && k === w && w.visualViewport ? w.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        k[_]
      );
      m -= E - r.height, m *= l ? 1 : -1;
    }
    if (i === pn || (i === dn || i === er) && s === Vc) {
      x = tr;
      var L = h && k === w && w.visualViewport ? w.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        k[C]
      );
      d -= L - r.width, d *= l ? 1 : -1;
    }
  }
  var M = Object.assign({
    position: a
  }, c && NZ), O = u === !0 ? IZ({
    x: d,
    y: m
  }, On(n)) : {
    x: d,
    y: m
  };
  if (d = O.x, m = O.y, l) {
    var N;
    return Object.assign({}, M, (N = {}, N[b] = y ? "0" : "", N[x] = g ? "0" : "", N.transform = (w.devicePixelRatio || 1) <= 1 ? "translate(" + d + "px, " + m + "px)" : "translate3d(" + d + "px, " + m + "px, 0)", N));
  }
  return Object.assign({}, M, (e = {}, e[b] = y ? m + "px" : "", e[x] = g ? d + "px" : "", e.transform = "", e));
}
function RZ(t) {
  var e = t.state, n = t.options, r = n.gpuAcceleration, i = r === void 0 ? !0 : r, s = n.adaptive, o = s === void 0 ? !0 : s, a = n.roundOffsets, l = a === void 0 ? !0 : a, c = {
    placement: Wr(e.placement),
    variation: Na(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: i,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, uk(Object.assign({}, c, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: o,
    roundOffsets: l
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, uk(Object.assign({}, c, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const SA = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: RZ,
  data: {}
};
var kf = {
  passive: !0
};
function BZ(t) {
  var e = t.state, n = t.instance, r = t.options, i = r.scroll, s = i === void 0 ? !0 : i, o = r.resize, a = o === void 0 ? !0 : o, l = On(e.elements.popper), c = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return s && c.forEach(function(u) {
    u.addEventListener("scroll", n.update, kf);
  }), a && l.addEventListener("resize", n.update, kf), function() {
    s && c.forEach(function(u) {
      u.removeEventListener("scroll", n.update, kf);
    }), a && l.removeEventListener("resize", n.update, kf);
  };
}
const MA = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: BZ,
  data: {}
};
var FZ = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Wf(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return FZ[e];
  });
}
var zZ = {
  start: "end",
  end: "start"
};
function fk(t) {
  return t.replace(/start|end/g, function(e) {
    return zZ[e];
  });
}
function vy(t) {
  var e = On(t), n = e.pageXOffset, r = e.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function yy(t) {
  return La(Ts(t)).left + vy(t).scrollLeft;
}
function VZ(t, e) {
  var n = On(t), r = Ts(t), i = n.visualViewport, s = r.clientWidth, o = r.clientHeight, a = 0, l = 0;
  if (i) {
    s = i.width, o = i.height;
    var c = yA();
    (c || !c && e === "fixed") && (a = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: s,
    height: o,
    x: a + yy(t),
    y: l
  };
}
function HZ(t) {
  var e, n = Ts(t), r = vy(t), i = (e = t.ownerDocument) == null ? void 0 : e.body, s = Qs(n.scrollWidth, n.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), o = Qs(n.scrollHeight, n.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0), a = -r.scrollLeft + yy(t), l = -r.scrollTop;
  return Mi(i || n).direction === "rtl" && (a += Qs(n.clientWidth, i ? i.clientWidth : 0) - s), {
    width: s,
    height: o,
    x: a,
    y: l
  };
}
function by(t) {
  var e = Mi(t), n = e.overflow, r = e.overflowX, i = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + i + r);
}
function CA(t) {
  return ["html", "body", "#document"].indexOf(Gr(t)) >= 0 ? t.ownerDocument.body : Un(t) && by(t) ? t : CA(yp(t));
}
function ac(t, e) {
  var n;
  e === void 0 && (e = []);
  var r = CA(t), i = r === ((n = t.ownerDocument) == null ? void 0 : n.body), s = On(r), o = i ? [s].concat(s.visualViewport || [], by(r) ? r : []) : r, a = e.concat(o);
  return i ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(ac(yp(o)))
  );
}
function ov(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function YZ(t, e) {
  var n = La(t, !1, e === "fixed");
  return n.top = n.top + t.clientTop, n.left = n.left + t.clientLeft, n.bottom = n.top + t.clientHeight, n.right = n.left + t.clientWidth, n.width = t.clientWidth, n.height = t.clientHeight, n.x = n.left, n.y = n.top, n;
}
function hk(t, e, n) {
  return e === mA ? ov(VZ(t, n)) : bo(e) ? YZ(e, n) : ov(HZ(Ts(t)));
}
function WZ(t) {
  var e = ac(yp(t)), n = ["absolute", "fixed"].indexOf(Mi(t).position) >= 0, r = n && Un(t) ? Cu(t) : t;
  return bo(r) ? e.filter(function(i) {
    return bo(i) && bA(i, r) && Gr(i) !== "body";
  }) : [];
}
function jZ(t, e, n, r) {
  var i = e === "clippingParents" ? WZ(t) : [].concat(e), s = [].concat(i, [n]), o = s[0], a = s.reduce(function(l, c) {
    var u = hk(t, c, r);
    return l.top = Qs(u.top, l.top), l.right = od(u.right, l.right), l.bottom = od(u.bottom, l.bottom), l.left = Qs(u.left, l.left), l;
  }, hk(t, o, r));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function $A(t) {
  var e = t.reference, n = t.element, r = t.placement, i = r ? Wr(r) : null, s = r ? Na(r) : null, o = e.x + e.width / 2 - n.width / 2, a = e.y + e.height / 2 - n.height / 2, l;
  switch (i) {
    case dn:
      l = {
        x: o,
        y: e.y - n.height
      };
      break;
    case er:
      l = {
        x: o,
        y: e.y + e.height
      };
      break;
    case tr:
      l = {
        x: e.x + e.width,
        y: a
      };
      break;
    case pn:
      l = {
        x: e.x - n.width,
        y: a
      };
      break;
    default:
      l = {
        x: e.x,
        y: e.y
      };
  }
  var c = i ? gy(i) : null;
  if (c != null) {
    var u = c === "y" ? "height" : "width";
    switch (s) {
      case Ea:
        l[c] = l[c] - (e[u] / 2 - n[u] / 2);
        break;
      case Vc:
        l[c] = l[c] + (e[u] / 2 - n[u] / 2);
        break;
    }
  }
  return l;
}
function Hc(t, e) {
  e === void 0 && (e = {});
  var n = e, r = n.placement, i = r === void 0 ? t.placement : r, s = n.strategy, o = s === void 0 ? t.strategy : s, a = n.boundary, l = a === void 0 ? mZ : a, c = n.rootBoundary, u = c === void 0 ? mA : c, h = n.elementContext, f = h === void 0 ? xl : h, d = n.altBoundary, p = d === void 0 ? !1 : d, m = n.padding, v = m === void 0 ? 0 : m, g = wA(typeof v != "number" ? v : kA(v, Mu)), y = f === xl ? gZ : xl, x = t.rects.popper, b = t.elements[p ? y : f], w = jZ(bo(b) ? b : b.contextElement || Ts(t.elements.popper), l, u, o), k = La(t.elements.reference), _ = $A({
    reference: k,
    element: x,
    strategy: "absolute",
    placement: i
  }), C = ov(Object.assign({}, x, _)), E = f === xl ? C : k, L = {
    top: w.top - E.top + g.top,
    bottom: E.bottom - w.bottom + g.bottom,
    left: w.left - E.left + g.left,
    right: E.right - w.right + g.right
  }, M = t.modifiersData.offset;
  if (f === xl && M) {
    var O = M[i];
    Object.keys(L).forEach(function(N) {
      var R = [tr, er].indexOf(N) >= 0 ? 1 : -1, $ = [dn, er].indexOf(N) >= 0 ? "y" : "x";
      L[N] += O[$] * R;
    });
  }
  return L;
}
function qZ(t, e) {
  e === void 0 && (e = {});
  var n = e, r = n.placement, i = n.boundary, s = n.rootBoundary, o = n.padding, a = n.flipVariations, l = n.allowedAutoPlacements, c = l === void 0 ? gA : l, u = Na(r), h = u ? a ? lk : lk.filter(function(p) {
    return Na(p) === u;
  }) : Mu, f = h.filter(function(p) {
    return c.indexOf(p) >= 0;
  });
  f.length === 0 && (f = h);
  var d = f.reduce(function(p, m) {
    return p[m] = Hc(t, {
      placement: m,
      boundary: i,
      rootBoundary: s,
      padding: o
    })[Wr(m)], p;
  }, {});
  return Object.keys(d).sort(function(p, m) {
    return d[p] - d[m];
  });
}
function UZ(t) {
  if (Wr(t) === dy)
    return [];
  var e = Wf(t);
  return [fk(t), e, fk(e)];
}
function KZ(t) {
  var e = t.state, n = t.options, r = t.name;
  if (!e.modifiersData[r]._skip) {
    for (var i = n.mainAxis, s = i === void 0 ? !0 : i, o = n.altAxis, a = o === void 0 ? !0 : o, l = n.fallbackPlacements, c = n.padding, u = n.boundary, h = n.rootBoundary, f = n.altBoundary, d = n.flipVariations, p = d === void 0 ? !0 : d, m = n.allowedAutoPlacements, v = e.options.placement, g = Wr(v), y = g === v, x = l || (y || !p ? [Wf(v)] : UZ(v)), b = [v].concat(x).reduce(function(Q, ce) {
      return Q.concat(Wr(ce) === dy ? qZ(e, {
        placement: ce,
        boundary: u,
        rootBoundary: h,
        padding: c,
        flipVariations: p,
        allowedAutoPlacements: m
      }) : ce);
    }, []), w = e.rects.reference, k = e.rects.popper, _ = /* @__PURE__ */ new Map(), C = !0, E = b[0], L = 0; L < b.length; L++) {
      var M = b[L], O = Wr(M), N = Na(M) === Ea, R = [dn, er].indexOf(O) >= 0, $ = R ? "width" : "height", F = Hc(e, {
        placement: M,
        boundary: u,
        rootBoundary: h,
        altBoundary: f,
        padding: c
      }), U = R ? N ? tr : pn : N ? er : dn;
      w[$] > k[$] && (U = Wf(U));
      var ee = Wf(U), ie = [];
      if (s && ie.push(F[O] <= 0), a && ie.push(F[U] <= 0, F[ee] <= 0), ie.every(function(Q) {
        return Q;
      })) {
        E = M, C = !1;
        break;
      }
      _.set(M, ie);
    }
    if (C)
      for (var z = p ? 3 : 1, te = function(ce) {
        var he = b.find(function(J) {
          var pe = _.get(J);
          if (pe)
            return pe.slice(0, ce).every(function(Y) {
              return Y;
            });
        });
        if (he)
          return E = he, "break";
      }, I = z; I > 0; I--) {
        var X = te(I);
        if (X === "break") break;
      }
    e.placement !== E && (e.modifiersData[r]._skip = !0, e.placement = E, e.reset = !0);
  }
}
const AA = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: KZ,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function dk(t, e, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - n.y,
    right: t.right - e.width + n.x,
    bottom: t.bottom - e.height + n.y,
    left: t.left - e.width - n.x
  };
}
function pk(t) {
  return [dn, tr, er, pn].some(function(e) {
    return t[e] >= 0;
  });
}
function GZ(t) {
  var e = t.state, n = t.name, r = e.rects.reference, i = e.rects.popper, s = e.modifiersData.preventOverflow, o = Hc(e, {
    elementContext: "reference"
  }), a = Hc(e, {
    altBoundary: !0
  }), l = dk(o, r), c = dk(a, i, s), u = pk(l), h = pk(c);
  e.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: c,
    isReferenceHidden: u,
    hasPopperEscaped: h
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": h
  });
}
const XZ = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: GZ
};
function ZZ(t, e, n) {
  var r = Wr(t), i = [pn, dn].indexOf(r) >= 0 ? -1 : 1, s = typeof n == "function" ? n(Object.assign({}, e, {
    placement: t
  })) : n, o = s[0], a = s[1];
  return o = o || 0, a = (a || 0) * i, [pn, tr].indexOf(r) >= 0 ? {
    x: a,
    y: o
  } : {
    x: o,
    y: a
  };
}
function JZ(t) {
  var e = t.state, n = t.options, r = t.name, i = n.offset, s = i === void 0 ? [0, 0] : i, o = gA.reduce(function(u, h) {
    return u[h] = ZZ(h, e.rects, s), u;
  }, {}), a = o[e.placement], l = a.x, c = a.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += l, e.modifiersData.popperOffsets.y += c), e.modifiersData[r] = o;
}
const QZ = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: JZ
};
function eJ(t) {
  var e = t.state, n = t.name;
  e.modifiersData[n] = $A({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const DA = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: eJ,
  data: {}
};
function tJ(t) {
  return t === "x" ? "y" : "x";
}
function nJ(t) {
  var e = t.state, n = t.options, r = t.name, i = n.mainAxis, s = i === void 0 ? !0 : i, o = n.altAxis, a = o === void 0 ? !1 : o, l = n.boundary, c = n.rootBoundary, u = n.altBoundary, h = n.padding, f = n.tether, d = f === void 0 ? !0 : f, p = n.tetherOffset, m = p === void 0 ? 0 : p, v = Hc(e, {
    boundary: l,
    rootBoundary: c,
    padding: h,
    altBoundary: u
  }), g = Wr(e.placement), y = Na(e.placement), x = !y, b = gy(g), w = tJ(b), k = e.modifiersData.popperOffsets, _ = e.rects.reference, C = e.rects.popper, E = typeof m == "function" ? m(Object.assign({}, e.rects, {
    placement: e.placement
  })) : m, L = typeof E == "number" ? {
    mainAxis: E,
    altAxis: E
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, E), M = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, O = {
    x: 0,
    y: 0
  };
  if (k) {
    if (s) {
      var N, R = b === "y" ? dn : pn, $ = b === "y" ? er : tr, F = b === "y" ? "height" : "width", U = k[b], ee = U + v[R], ie = U - v[$], z = d ? -C[F] / 2 : 0, te = y === Ea ? _[F] : C[F], I = y === Ea ? -C[F] : -_[F], X = e.elements.arrow, Q = d && X ? my(X) : {
        width: 0,
        height: 0
      }, ce = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : xA(), he = ce[R], J = ce[$], pe = oc(0, _[F], Q[F]), Y = x ? _[F] / 2 - z - pe - he - L.mainAxis : te - pe - he - L.mainAxis, se = x ? -_[F] / 2 + z + pe + J + L.mainAxis : I + pe + J + L.mainAxis, ge = e.elements.arrow && Cu(e.elements.arrow), V = ge ? b === "y" ? ge.clientTop || 0 : ge.clientLeft || 0 : 0, Ee = (N = M == null ? void 0 : M[b]) != null ? N : 0, ke = U + Y - Ee - V, Ie = U + se - Ee, He = oc(d ? od(ee, ke) : ee, U, d ? Qs(ie, Ie) : ie);
      k[b] = He, O[b] = He - U;
    }
    if (a) {
      var st, gn = b === "x" ? dn : pn, ir = b === "x" ? er : tr, Mt = k[w], Li = w === "y" ? "height" : "width", Ni = Mt + v[gn], Ii = Mt - v[ir], Ri = [dn, pn].indexOf(g) !== -1, Bi = (st = M == null ? void 0 : M[w]) != null ? st : 0, Fi = Ri ? Ni : Mt - _[Li] - C[Li] - Bi + L.altAxis, Es = Ri ? Mt + _[Li] + C[Li] - Bi - L.altAxis : Ii, Oo = d && Ri ? OZ(Fi, Mt, Es) : oc(d ? Fi : Ni, Mt, d ? Es : Ii);
      k[w] = Oo, O[w] = Oo - Mt;
    }
    e.modifiersData[r] = O;
  }
}
const TA = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: nJ,
  requiresIfExists: ["offset"]
};
function rJ(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function iJ(t) {
  return t === On(t) || !Un(t) ? vy(t) : rJ(t);
}
function sJ(t) {
  var e = t.getBoundingClientRect(), n = Pa(e.width) / t.offsetWidth || 1, r = Pa(e.height) / t.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function oJ(t, e, n) {
  n === void 0 && (n = !1);
  var r = Un(e), i = Un(e) && sJ(e), s = Ts(e), o = La(t, i, n), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((Gr(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  by(s)) && (a = iJ(e)), Un(e) ? (l = La(e, !0), l.x += e.clientLeft, l.y += e.clientTop) : s && (l.x = yy(s))), {
    x: o.left + a.scrollLeft - l.x,
    y: o.top + a.scrollTop - l.y,
    width: o.width,
    height: o.height
  };
}
function aJ(t) {
  var e = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  t.forEach(function(s) {
    e.set(s.name, s);
  });
  function i(s) {
    n.add(s.name);
    var o = [].concat(s.requires || [], s.requiresIfExists || []);
    o.forEach(function(a) {
      if (!n.has(a)) {
        var l = e.get(a);
        l && i(l);
      }
    }), r.push(s);
  }
  return t.forEach(function(s) {
    n.has(s.name) || i(s);
  }), r;
}
function lJ(t) {
  var e = aJ(t);
  return CZ.reduce(function(n, r) {
    return n.concat(e.filter(function(i) {
      return i.phase === r;
    }));
  }, []);
}
function cJ(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(n) {
      Promise.resolve().then(function() {
        e = void 0, n(t());
      });
    })), e;
  };
}
function uJ(t) {
  var e = t.reduce(function(n, r) {
    var i = n[r.name];
    return n[r.name] = i ? Object.assign({}, i, r, {
      options: Object.assign({}, i.options, r.options),
      data: Object.assign({}, i.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(e).map(function(n) {
    return e[n];
  });
}
var mk = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function gk() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return !e.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function OA(t) {
  t === void 0 && (t = {});
  var e = t, n = e.defaultModifiers, r = n === void 0 ? [] : n, i = e.defaultOptions, s = i === void 0 ? mk : i;
  return function(a, l, c) {
    c === void 0 && (c = s);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, mk, s),
      modifiersData: {},
      elements: {
        reference: a,
        popper: l
      },
      attributes: {},
      styles: {}
    }, h = [], f = !1, d = {
      state: u,
      setOptions: function(g) {
        var y = typeof g == "function" ? g(u.options) : g;
        m(), u.options = Object.assign({}, s, u.options, y), u.scrollParents = {
          reference: bo(a) ? ac(a) : a.contextElement ? ac(a.contextElement) : [],
          popper: ac(l)
        };
        var x = lJ(uJ([].concat(r, u.options.modifiers)));
        return u.orderedModifiers = x.filter(function(b) {
          return b.enabled;
        }), p(), d.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var g = u.elements, y = g.reference, x = g.popper;
          if (gk(y, x)) {
            u.rects = {
              reference: oJ(y, Cu(x), u.options.strategy === "fixed"),
              popper: my(x)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(L) {
              return u.modifiersData[L.name] = Object.assign({}, L.data);
            });
            for (var b = 0; b < u.orderedModifiers.length; b++) {
              if (u.reset === !0) {
                u.reset = !1, b = -1;
                continue;
              }
              var w = u.orderedModifiers[b], k = w.fn, _ = w.options, C = _ === void 0 ? {} : _, E = w.name;
              typeof k == "function" && (u = k({
                state: u,
                options: C,
                name: E,
                instance: d
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: cJ(function() {
        return new Promise(function(v) {
          d.forceUpdate(), v(u);
        });
      }),
      destroy: function() {
        m(), f = !0;
      }
    };
    if (!gk(a, l))
      return d;
    d.setOptions(c).then(function(v) {
      !f && c.onFirstUpdate && c.onFirstUpdate(v);
    });
    function p() {
      u.orderedModifiers.forEach(function(v) {
        var g = v.name, y = v.options, x = y === void 0 ? {} : y, b = v.effect;
        if (typeof b == "function") {
          var w = b({
            state: u,
            name: g,
            instance: d,
            options: x
          }), k = function() {
          };
          h.push(w || k);
        }
      });
    }
    function m() {
      h.forEach(function(v) {
        return v();
      }), h = [];
    }
    return d;
  };
}
var fJ = [MA, DA, SA, vA], hJ = /* @__PURE__ */ OA({
  defaultModifiers: fJ
}), dJ = [MA, DA, SA, vA, QZ, AA, TA, _A, XZ], pJ = /* @__PURE__ */ OA({
  defaultModifiers: dJ
}), mJ = Object.defineProperty, gJ = (t, e, n) => e in t ? mJ(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, xe = (t, e, n) => (gJ(t, typeof e != "symbol" ? e + "" : e, n), n), _f = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function EA(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var vJ = Object.prototype, yJ = vJ.hasOwnProperty;
function bJ(t, e) {
  return t != null && yJ.call(t, e);
}
var xJ = bJ, wJ = Array.isArray, wr = wJ, kJ = typeof _f == "object" && _f && _f.Object === Object && _f, PA = kJ, _J = PA, SJ = typeof self == "object" && self && self.Object === Object && self, MJ = _J || SJ || Function("return this")(), ei = MJ, CJ = ei, $J = CJ.Symbol, bp = $J, vk = bp, LA = Object.prototype, AJ = LA.hasOwnProperty, DJ = LA.toString, wl = vk ? vk.toStringTag : void 0;
function TJ(t) {
  var e = AJ.call(t, wl), n = t[wl];
  try {
    t[wl] = void 0;
    var r = !0;
  } catch (s) {
  }
  var i = DJ.call(t);
  return r && (e ? t[wl] = n : delete t[wl]), i;
}
var OJ = TJ, EJ = Object.prototype, PJ = EJ.toString;
function LJ(t) {
  return PJ.call(t);
}
var NJ = LJ, yk = bp, IJ = OJ, RJ = NJ, BJ = "[object Null]", FJ = "[object Undefined]", bk = yk ? yk.toStringTag : void 0;
function zJ(t) {
  return t == null ? t === void 0 ? FJ : BJ : bk && bk in Object(t) ? IJ(t) : RJ(t);
}
var ti = zJ;
function VJ(t) {
  return t != null && typeof t == "object";
}
var kr = VJ, HJ = ti, YJ = kr, WJ = "[object Symbol]";
function jJ(t) {
  return typeof t == "symbol" || YJ(t) && HJ(t) == WJ;
}
var xy = jJ, qJ = wr, UJ = xy, KJ = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, GJ = /^\w*$/;
function XJ(t, e) {
  if (qJ(t))
    return !1;
  var n = typeof t;
  return n == "number" || n == "symbol" || n == "boolean" || t == null || UJ(t) ? !0 : GJ.test(t) || !KJ.test(t) || e != null && t in Object(e);
}
var wy = XJ;
function ZJ(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var Ei = ZJ, JJ = ti, QJ = Ei, eQ = "[object AsyncFunction]", tQ = "[object Function]", nQ = "[object GeneratorFunction]", rQ = "[object Proxy]";
function iQ(t) {
  if (!QJ(t))
    return !1;
  var e = JJ(t);
  return e == tQ || e == nQ || e == eQ || e == rQ;
}
var Ao = iQ, sQ = ei, oQ = sQ["__core-js_shared__"], aQ = oQ, Hm = aQ, xk = function() {
  var t = /[^.]+$/.exec(Hm && Hm.keys && Hm.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function lQ(t) {
  return !!xk && xk in t;
}
var cQ = lQ, uQ = Function.prototype, fQ = uQ.toString;
function hQ(t) {
  if (t != null) {
    try {
      return fQ.call(t);
    } catch (e) {
    }
    try {
      return t + "";
    } catch (e) {
    }
  }
  return "";
}
var NA = hQ, dQ = Ao, pQ = cQ, mQ = Ei, gQ = NA, vQ = /[\\^$.*+?()[\]{}|]/g, yQ = /^\[object .+?Constructor\]$/, bQ = Function.prototype, xQ = Object.prototype, wQ = bQ.toString, kQ = xQ.hasOwnProperty, _Q = RegExp(
  "^" + wQ.call(kQ).replace(vQ, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function SQ(t) {
  if (!mQ(t) || pQ(t))
    return !1;
  var e = dQ(t) ? _Q : yQ;
  return e.test(gQ(t));
}
var MQ = SQ;
function CQ(t, e) {
  return t == null ? void 0 : t[e];
}
var $Q = CQ, AQ = MQ, DQ = $Q;
function TQ(t, e) {
  var n = DQ(t, e);
  return AQ(n) ? n : void 0;
}
var Do = TQ, OQ = Do, EQ = OQ(Object, "create"), xp = EQ, wk = xp;
function PQ() {
  this.__data__ = wk ? wk(null) : {}, this.size = 0;
}
var LQ = PQ;
function NQ(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var IQ = NQ, RQ = xp, BQ = "__lodash_hash_undefined__", FQ = Object.prototype, zQ = FQ.hasOwnProperty;
function VQ(t) {
  var e = this.__data__;
  if (RQ) {
    var n = e[t];
    return n === BQ ? void 0 : n;
  }
  return zQ.call(e, t) ? e[t] : void 0;
}
var HQ = VQ, YQ = xp, WQ = Object.prototype, jQ = WQ.hasOwnProperty;
function qQ(t) {
  var e = this.__data__;
  return YQ ? e[t] !== void 0 : jQ.call(e, t);
}
var UQ = qQ, KQ = xp, GQ = "__lodash_hash_undefined__";
function XQ(t, e) {
  var n = this.__data__;
  return this.size += this.has(t) ? 0 : 1, n[t] = KQ && e === void 0 ? GQ : e, this;
}
var ZQ = XQ, JQ = LQ, QQ = IQ, eee = HQ, tee = UQ, nee = ZQ;
function Xa(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
Xa.prototype.clear = JQ;
Xa.prototype.delete = QQ;
Xa.prototype.get = eee;
Xa.prototype.has = tee;
Xa.prototype.set = nee;
var ree = Xa;
function iee() {
  this.__data__ = [], this.size = 0;
}
var see = iee;
function oee(t, e) {
  return t === e || t !== t && e !== e;
}
var Za = oee, aee = Za;
function lee(t, e) {
  for (var n = t.length; n--; )
    if (aee(t[n][0], e))
      return n;
  return -1;
}
var wp = lee, cee = wp, uee = Array.prototype, fee = uee.splice;
function hee(t) {
  var e = this.__data__, n = cee(e, t);
  if (n < 0)
    return !1;
  var r = e.length - 1;
  return n == r ? e.pop() : fee.call(e, n, 1), --this.size, !0;
}
var dee = hee, pee = wp;
function mee(t) {
  var e = this.__data__, n = pee(e, t);
  return n < 0 ? void 0 : e[n][1];
}
var gee = mee, vee = wp;
function yee(t) {
  return vee(this.__data__, t) > -1;
}
var bee = yee, xee = wp;
function wee(t, e) {
  var n = this.__data__, r = xee(n, t);
  return r < 0 ? (++this.size, n.push([t, e])) : n[r][1] = e, this;
}
var kee = wee, _ee = see, See = dee, Mee = gee, Cee = bee, $ee = kee;
function Ja(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
Ja.prototype.clear = _ee;
Ja.prototype.delete = See;
Ja.prototype.get = Mee;
Ja.prototype.has = Cee;
Ja.prototype.set = $ee;
var kp = Ja, Aee = Do, Dee = ei, Tee = Aee(Dee, "Map"), ky = Tee, kk = ree, Oee = kp, Eee = ky;
function Pee() {
  this.size = 0, this.__data__ = {
    hash: new kk(),
    map: new (Eee || Oee)(),
    string: new kk()
  };
}
var Lee = Pee;
function Nee(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
var Iee = Nee, Ree = Iee;
function Bee(t, e) {
  var n = t.__data__;
  return Ree(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
}
var _p = Bee, Fee = _p;
function zee(t) {
  var e = Fee(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
var Vee = zee, Hee = _p;
function Yee(t) {
  return Hee(this, t).get(t);
}
var Wee = Yee, jee = _p;
function qee(t) {
  return jee(this, t).has(t);
}
var Uee = qee, Kee = _p;
function Gee(t, e) {
  var n = Kee(this, t), r = n.size;
  return n.set(t, e), this.size += n.size == r ? 0 : 1, this;
}
var Xee = Gee, Zee = Lee, Jee = Vee, Qee = Wee, ete = Uee, tte = Xee;
function Qa(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
Qa.prototype.clear = Zee;
Qa.prototype.delete = Jee;
Qa.prototype.get = Qee;
Qa.prototype.has = ete;
Qa.prototype.set = tte;
var _y = Qa, IA = _y, nte = "Expected a function";
function Sy(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(nte);
  var n = function() {
    var r = arguments, i = e ? e.apply(this, r) : r[0], s = n.cache;
    if (s.has(i))
      return s.get(i);
    var o = t.apply(this, r);
    return n.cache = s.set(i, o) || s, o;
  };
  return n.cache = new (Sy.Cache || IA)(), n;
}
Sy.Cache = IA;
var rte = Sy, ite = rte, ste = 500;
function ote(t) {
  var e = ite(t, function(r) {
    return n.size === ste && n.clear(), r;
  }), n = e.cache;
  return e;
}
var ate = ote, lte = ate, cte = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ute = /\\(\\)?/g, fte = lte(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(cte, function(n, r, i, s) {
    e.push(i ? s.replace(ute, "$1") : r || n);
  }), e;
}), hte = fte;
function dte(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, i = Array(r); ++n < r; )
    i[n] = e(t[n], n, t);
  return i;
}
var pte = dte, _k = bp, mte = pte, gte = wr, vte = xy, yte = 1 / 0, Sk = _k ? _k.prototype : void 0, Mk = Sk ? Sk.toString : void 0;
function RA(t) {
  if (typeof t == "string")
    return t;
  if (gte(t))
    return mte(t, RA) + "";
  if (vte(t))
    return Mk ? Mk.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -yte ? "-0" : e;
}
var bte = RA, xte = bte;
function wte(t) {
  return t == null ? "" : xte(t);
}
var kte = wte, _te = wr, Ste = wy, Mte = hte, Cte = kte;
function $te(t, e) {
  return _te(t) ? t : Ste(t, e) ? [t] : Mte(Cte(t));
}
var BA = $te, Ate = ti, Dte = kr, Tte = "[object Arguments]";
function Ote(t) {
  return Dte(t) && Ate(t) == Tte;
}
var Ete = Ote, Ck = Ete, Pte = kr, FA = Object.prototype, Lte = FA.hasOwnProperty, Nte = FA.propertyIsEnumerable, Ite = Ck(/* @__PURE__ */ function() {
  return arguments;
}()) ? Ck : function(t) {
  return Pte(t) && Lte.call(t, "callee") && !Nte.call(t, "callee");
}, My = Ite, Rte = 9007199254740991, Bte = /^(?:0|[1-9]\d*)$/;
function Fte(t, e) {
  var n = typeof t;
  return e = e == null ? Rte : e, !!e && (n == "number" || n != "symbol" && Bte.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
var Cy = Fte, zte = 9007199254740991;
function Vte(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= zte;
}
var $y = Vte, Hte = xy, Yte = 1 / 0;
function Wte(t) {
  if (typeof t == "string" || Hte(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -Yte ? "-0" : e;
}
var Sp = Wte, jte = BA, qte = My, Ute = wr, Kte = Cy, Gte = $y, Xte = Sp;
function Zte(t, e, n) {
  e = jte(e, t);
  for (var r = -1, i = e.length, s = !1; ++r < i; ) {
    var o = Xte(e[r]);
    if (!(s = t != null && n(t, o)))
      break;
    t = t[o];
  }
  return s || ++r != i ? s : (i = t == null ? 0 : t.length, !!i && Gte(i) && Kte(o, i) && (Ute(t) || qte(t)));
}
var zA = Zte, Jte = xJ, Qte = zA;
function ene(t, e) {
  return t != null && Qte(t, e, Jte);
}
var VA = ene, tne = ti, nne = kr, rne = "[object Date]";
function ine(t) {
  return nne(t) && tne(t) == rne;
}
var sne = ine;
function one(t) {
  return function(e) {
    return t(e);
  };
}
var HA = one, Yc = {}, ane = {
  get exports() {
    return Yc;
  },
  set exports(t) {
    Yc = t;
  }
};
(function(t, e) {
  var n = PA, r = e && !e.nodeType && e, i = r && !0 && t && !t.nodeType && t, s = i && i.exports === r, o = s && n.process, a = function() {
    try {
      var l = i && i.require && i.require("util").types;
      return l || o && o.binding && o.binding("util");
    } catch (c) {
    }
  }();
  t.exports = a;
})(ane, Yc);
var lne = sne, cne = HA, $k = Yc, Ak = $k && $k.isDate, une = Ak ? cne(Ak) : lne, fne = une, hne = ti, dne = wr, pne = kr, mne = "[object String]";
function gne(t) {
  return typeof t == "string" || !dne(t) && pne(t) && hne(t) == mne;
}
var Fr = gne;
function vne(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r; )
    if (e(t[n], n, t))
      return !0;
  return !1;
}
var YA = vne, yne = kp;
function bne() {
  this.__data__ = new yne(), this.size = 0;
}
var xne = bne;
function wne(t) {
  var e = this.__data__, n = e.delete(t);
  return this.size = e.size, n;
}
var kne = wne;
function _ne(t) {
  return this.__data__.get(t);
}
var Sne = _ne;
function Mne(t) {
  return this.__data__.has(t);
}
var Cne = Mne, $ne = kp, Ane = ky, Dne = _y, Tne = 200;
function One(t, e) {
  var n = this.__data__;
  if (n instanceof $ne) {
    var r = n.__data__;
    if (!Ane || r.length < Tne - 1)
      return r.push([t, e]), this.size = ++n.size, this;
    n = this.__data__ = new Dne(r);
  }
  return n.set(t, e), this.size = n.size, this;
}
var Ene = One, Pne = kp, Lne = xne, Nne = kne, Ine = Sne, Rne = Cne, Bne = Ene;
function el(t) {
  var e = this.__data__ = new Pne(t);
  this.size = e.size;
}
el.prototype.clear = Lne;
el.prototype.delete = Nne;
el.prototype.get = Ine;
el.prototype.has = Rne;
el.prototype.set = Bne;
var Ay = el, Fne = "__lodash_hash_undefined__";
function zne(t) {
  return this.__data__.set(t, Fne), this;
}
var Vne = zne;
function Hne(t) {
  return this.__data__.has(t);
}
var Yne = Hne, Wne = _y, jne = Vne, qne = Yne;
function ad(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.__data__ = new Wne(); ++e < n; )
    this.add(t[e]);
}
ad.prototype.add = ad.prototype.push = jne;
ad.prototype.has = qne;
var Une = ad;
function Kne(t, e) {
  return t.has(e);
}
var Gne = Kne, Xne = Une, Zne = YA, Jne = Gne, Qne = 1, ere = 2;
function tre(t, e, n, r, i, s) {
  var o = n & Qne, a = t.length, l = e.length;
  if (a != l && !(o && l > a))
    return !1;
  var c = s.get(t), u = s.get(e);
  if (c && u)
    return c == e && u == t;
  var h = -1, f = !0, d = n & ere ? new Xne() : void 0;
  for (s.set(t, e), s.set(e, t); ++h < a; ) {
    var p = t[h], m = e[h];
    if (r)
      var v = o ? r(m, p, h, e, t, s) : r(p, m, h, t, e, s);
    if (v !== void 0) {
      if (v)
        continue;
      f = !1;
      break;
    }
    if (d) {
      if (!Zne(e, function(g, y) {
        if (!Jne(d, y) && (p === g || i(p, g, n, r, s)))
          return d.push(y);
      })) {
        f = !1;
        break;
      }
    } else if (!(p === m || i(p, m, n, r, s))) {
      f = !1;
      break;
    }
  }
  return s.delete(t), s.delete(e), f;
}
var WA = tre, nre = ei, rre = nre.Uint8Array, jA = rre;
function ire(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r, i) {
    n[++e] = [i, r];
  }), n;
}
var sre = ire;
function ore(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r) {
    n[++e] = r;
  }), n;
}
var are = ore, Dk = bp, Tk = jA, lre = Za, cre = WA, ure = sre, fre = are, hre = 1, dre = 2, pre = "[object Boolean]", mre = "[object Date]", gre = "[object Error]", vre = "[object Map]", yre = "[object Number]", bre = "[object RegExp]", xre = "[object Set]", wre = "[object String]", kre = "[object Symbol]", _re = "[object ArrayBuffer]", Sre = "[object DataView]", Ok = Dk ? Dk.prototype : void 0, Ym = Ok ? Ok.valueOf : void 0;
function Mre(t, e, n, r, i, s, o) {
  switch (n) {
    case Sre:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case _re:
      return !(t.byteLength != e.byteLength || !s(new Tk(t), new Tk(e)));
    case pre:
    case mre:
    case yre:
      return lre(+t, +e);
    case gre:
      return t.name == e.name && t.message == e.message;
    case bre:
    case wre:
      return t == e + "";
    case vre:
      var a = ure;
    case xre:
      var l = r & hre;
      if (a || (a = fre), t.size != e.size && !l)
        return !1;
      var c = o.get(t);
      if (c)
        return c == e;
      r |= dre, o.set(t, e);
      var u = cre(a(t), a(e), r, i, s, o);
      return o.delete(t), u;
    case kre:
      if (Ym)
        return Ym.call(t) == Ym.call(e);
  }
  return !1;
}
var Cre = Mre;
function $re(t, e) {
  for (var n = -1, r = e.length, i = t.length; ++n < r; )
    t[i + n] = e[n];
  return t;
}
var Are = $re, Dre = Are, Tre = wr;
function Ore(t, e, n) {
  var r = e(t);
  return Tre(t) ? r : Dre(r, n(t));
}
var Ere = Ore;
function Pre(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, i = 0, s = []; ++n < r; ) {
    var o = t[n];
    e(o, n, t) && (s[i++] = o);
  }
  return s;
}
var Lre = Pre;
function Nre() {
  return [];
}
var Ire = Nre, Rre = Lre, Bre = Ire, Fre = Object.prototype, zre = Fre.propertyIsEnumerable, Ek = Object.getOwnPropertySymbols, Vre = Ek ? function(t) {
  return t == null ? [] : (t = Object(t), Rre(Ek(t), function(e) {
    return zre.call(t, e);
  }));
} : Bre, Hre = Vre;
function Yre(t, e) {
  for (var n = -1, r = Array(t); ++n < t; )
    r[n] = e(n);
  return r;
}
var Wre = Yre, Ia = {}, jre = {
  get exports() {
    return Ia;
  },
  set exports(t) {
    Ia = t;
  }
};
function qre() {
  return !1;
}
var Ure = qre;
(function(t, e) {
  var n = ei, r = Ure, i = e && !e.nodeType && e, s = i && !0 && t && !t.nodeType && t, o = s && s.exports === i, a = o ? n.Buffer : void 0, l = a ? a.isBuffer : void 0, c = l || r;
  t.exports = c;
})(jre, Ia);
var Kre = ti, Gre = $y, Xre = kr, Zre = "[object Arguments]", Jre = "[object Array]", Qre = "[object Boolean]", eie = "[object Date]", tie = "[object Error]", nie = "[object Function]", rie = "[object Map]", iie = "[object Number]", sie = "[object Object]", oie = "[object RegExp]", aie = "[object Set]", lie = "[object String]", cie = "[object WeakMap]", uie = "[object ArrayBuffer]", fie = "[object DataView]", hie = "[object Float32Array]", die = "[object Float64Array]", pie = "[object Int8Array]", mie = "[object Int16Array]", gie = "[object Int32Array]", vie = "[object Uint8Array]", yie = "[object Uint8ClampedArray]", bie = "[object Uint16Array]", xie = "[object Uint32Array]", Xe = {};
Xe[hie] = Xe[die] = Xe[pie] = Xe[mie] = Xe[gie] = Xe[vie] = Xe[yie] = Xe[bie] = Xe[xie] = !0;
Xe[Zre] = Xe[Jre] = Xe[uie] = Xe[Qre] = Xe[fie] = Xe[eie] = Xe[tie] = Xe[nie] = Xe[rie] = Xe[iie] = Xe[sie] = Xe[oie] = Xe[aie] = Xe[lie] = Xe[cie] = !1;
function wie(t) {
  return Xre(t) && Gre(t.length) && !!Xe[Kre(t)];
}
var kie = wie, _ie = kie, Sie = HA, Pk = Yc, Lk = Pk && Pk.isTypedArray, Mie = Lk ? Sie(Lk) : _ie, Dy = Mie, Cie = Wre, $ie = My, Aie = wr, Die = Ia, Tie = Cy, Oie = Dy, Eie = Object.prototype, Pie = Eie.hasOwnProperty;
function Lie(t, e) {
  var n = Aie(t), r = !n && $ie(t), i = !n && !r && Die(t), s = !n && !r && !i && Oie(t), o = n || r || i || s, a = o ? Cie(t.length, String) : [], l = a.length;
  for (var c in t)
    (e || Pie.call(t, c)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    s && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    Tie(c, l))) && a.push(c);
  return a;
}
var qA = Lie, Nie = Object.prototype;
function Iie(t) {
  var e = t && t.constructor, n = typeof e == "function" && e.prototype || Nie;
  return t === n;
}
var Ty = Iie;
function Rie(t, e) {
  return function(n) {
    return t(e(n));
  };
}
var UA = Rie, Bie = UA, Fie = Bie(Object.keys, Object), zie = Fie, Vie = Ty, Hie = zie, Yie = Object.prototype, Wie = Yie.hasOwnProperty;
function jie(t) {
  if (!Vie(t))
    return Hie(t);
  var e = [];
  for (var n in Object(t))
    Wie.call(t, n) && n != "constructor" && e.push(n);
  return e;
}
var qie = jie, Uie = Ao, Kie = $y;
function Gie(t) {
  return t != null && Kie(t.length) && !Uie(t);
}
var $u = Gie, Xie = qA, Zie = qie, Jie = $u;
function Qie(t) {
  return Jie(t) ? Xie(t) : Zie(t);
}
var Oy = Qie, ese = Ere, tse = Hre, nse = Oy;
function rse(t) {
  return ese(t, nse, tse);
}
var ise = rse, Nk = ise, sse = 1, ose = Object.prototype, ase = ose.hasOwnProperty;
function lse(t, e, n, r, i, s) {
  var o = n & sse, a = Nk(t), l = a.length, c = Nk(e), u = c.length;
  if (l != u && !o)
    return !1;
  for (var h = l; h--; ) {
    var f = a[h];
    if (!(o ? f in e : ase.call(e, f)))
      return !1;
  }
  var d = s.get(t), p = s.get(e);
  if (d && p)
    return d == e && p == t;
  var m = !0;
  s.set(t, e), s.set(e, t);
  for (var v = o; ++h < l; ) {
    f = a[h];
    var g = t[f], y = e[f];
    if (r)
      var x = o ? r(y, g, f, e, t, s) : r(g, y, f, t, e, s);
    if (!(x === void 0 ? g === y || i(g, y, n, r, s) : x)) {
      m = !1;
      break;
    }
    v || (v = f == "constructor");
  }
  if (m && !v) {
    var b = t.constructor, w = e.constructor;
    b != w && "constructor" in t && "constructor" in e && !(typeof b == "function" && b instanceof b && typeof w == "function" && w instanceof w) && (m = !1);
  }
  return s.delete(t), s.delete(e), m;
}
var cse = lse, use = Do, fse = ei, hse = use(fse, "DataView"), dse = hse, pse = Do, mse = ei, gse = pse(mse, "Promise"), vse = gse, yse = Do, bse = ei, xse = yse(bse, "Set"), wse = xse, kse = Do, _se = ei, Sse = kse(_se, "WeakMap"), Mse = Sse, av = dse, lv = ky, cv = vse, uv = wse, fv = Mse, KA = ti, tl = NA, Ik = "[object Map]", Cse = "[object Object]", Rk = "[object Promise]", Bk = "[object Set]", Fk = "[object WeakMap]", zk = "[object DataView]", $se = tl(av), Ase = tl(lv), Dse = tl(cv), Tse = tl(uv), Ose = tl(fv), Ns = KA;
(av && Ns(new av(new ArrayBuffer(1))) != zk || lv && Ns(new lv()) != Ik || cv && Ns(cv.resolve()) != Rk || uv && Ns(new uv()) != Bk || fv && Ns(new fv()) != Fk) && (Ns = function(t) {
  var e = KA(t), n = e == Cse ? t.constructor : void 0, r = n ? tl(n) : "";
  if (r)
    switch (r) {
      case $se:
        return zk;
      case Ase:
        return Ik;
      case Dse:
        return Rk;
      case Tse:
        return Bk;
      case Ose:
        return Fk;
    }
  return e;
});
var Ese = Ns, Wm = Ay, Pse = WA, Lse = Cre, Nse = cse, Vk = Ese, Hk = wr, Yk = Ia, Ise = Dy, Rse = 1, Wk = "[object Arguments]", jk = "[object Array]", Sf = "[object Object]", Bse = Object.prototype, qk = Bse.hasOwnProperty;
function Fse(t, e, n, r, i, s) {
  var o = Hk(t), a = Hk(e), l = o ? jk : Vk(t), c = a ? jk : Vk(e);
  l = l == Wk ? Sf : l, c = c == Wk ? Sf : c;
  var u = l == Sf, h = c == Sf, f = l == c;
  if (f && Yk(t)) {
    if (!Yk(e))
      return !1;
    o = !0, u = !1;
  }
  if (f && !u)
    return s || (s = new Wm()), o || Ise(t) ? Pse(t, e, n, r, i, s) : Lse(t, e, l, n, r, i, s);
  if (!(n & Rse)) {
    var d = u && qk.call(t, "__wrapped__"), p = h && qk.call(e, "__wrapped__");
    if (d || p) {
      var m = d ? t.value() : t, v = p ? e.value() : e;
      return s || (s = new Wm()), i(m, v, n, r, s);
    }
  }
  return f ? (s || (s = new Wm()), Nse(t, e, n, r, i, s)) : !1;
}
var zse = Fse, Vse = zse, Uk = kr;
function GA(t, e, n, r, i) {
  return t === e ? !0 : t == null || e == null || !Uk(t) && !Uk(e) ? t !== t && e !== e : Vse(t, e, n, r, GA, i);
}
var XA = GA, Hse = Ay, Yse = XA, Wse = 1, jse = 2;
function qse(t, e, n, r) {
  var i = n.length, s = i, o = !r;
  if (t == null)
    return !s;
  for (t = Object(t); i--; ) {
    var a = n[i];
    if (o && a[2] ? a[1] !== t[a[0]] : !(a[0] in t))
      return !1;
  }
  for (; ++i < s; ) {
    a = n[i];
    var l = a[0], c = t[l], u = a[1];
    if (o && a[2]) {
      if (c === void 0 && !(l in t))
        return !1;
    } else {
      var h = new Hse();
      if (r)
        var f = r(c, u, l, t, e, h);
      if (!(f === void 0 ? Yse(u, c, Wse | jse, r, h) : f))
        return !1;
    }
  }
  return !0;
}
var Use = qse, Kse = Ei;
function Gse(t) {
  return t === t && !Kse(t);
}
var ZA = Gse, Xse = ZA, Zse = Oy;
function Jse(t) {
  for (var e = Zse(t), n = e.length; n--; ) {
    var r = e[n], i = t[r];
    e[n] = [r, i, Xse(i)];
  }
  return e;
}
var Qse = Jse;
function eoe(t, e) {
  return function(n) {
    return n == null ? !1 : n[t] === e && (e !== void 0 || t in Object(n));
  };
}
var JA = eoe, toe = Use, noe = Qse, roe = JA;
function ioe(t) {
  var e = noe(t);
  return e.length == 1 && e[0][2] ? roe(e[0][0], e[0][1]) : function(n) {
    return n === t || toe(n, t, e);
  };
}
var soe = ioe, ooe = BA, aoe = Sp;
function loe(t, e) {
  e = ooe(e, t);
  for (var n = 0, r = e.length; t != null && n < r; )
    t = t[aoe(e[n++])];
  return n && n == r ? t : void 0;
}
var QA = loe, coe = QA;
function uoe(t, e, n) {
  var r = t == null ? void 0 : coe(t, e);
  return r === void 0 ? n : r;
}
var js = uoe;
function foe(t, e) {
  return t != null && e in Object(t);
}
var hoe = foe, doe = hoe, poe = zA;
function moe(t, e) {
  return t != null && poe(t, e, doe);
}
var goe = moe, voe = XA, yoe = js, boe = goe, xoe = wy, woe = ZA, koe = JA, _oe = Sp, Soe = 1, Moe = 2;
function Coe(t, e) {
  return xoe(t) && woe(e) ? koe(_oe(t), e) : function(n) {
    var r = yoe(n, t);
    return r === void 0 && r === e ? boe(n, t) : voe(e, r, Soe | Moe);
  };
}
var $oe = Coe;
function Aoe(t) {
  return t;
}
var Ey = Aoe;
function Doe(t) {
  return function(e) {
    return e == null ? void 0 : e[t];
  };
}
var Toe = Doe, Ooe = QA;
function Eoe(t) {
  return function(e) {
    return Ooe(e, t);
  };
}
var Poe = Eoe, Loe = Toe, Noe = Poe, Ioe = wy, Roe = Sp;
function Boe(t) {
  return Ioe(t) ? Loe(Roe(t)) : Noe(t);
}
var Foe = Boe, zoe = soe, Voe = $oe, Hoe = Ey, Yoe = wr, Woe = Foe;
function joe(t) {
  return typeof t == "function" ? t : t == null ? Hoe : typeof t == "object" ? Yoe(t) ? Voe(t[0], t[1]) : zoe(t) : Woe(t);
}
var eD = joe;
function qoe(t) {
  return function(e, n, r) {
    for (var i = -1, s = Object(e), o = r(e), a = o.length; a--; ) {
      var l = o[t ? a : ++i];
      if (n(s[l], l, s) === !1)
        break;
    }
    return e;
  };
}
var Uoe = qoe, Koe = Uoe, Goe = Koe(), tD = Goe, Xoe = tD, Zoe = Oy;
function Joe(t, e) {
  return t && Xoe(t, e, Zoe);
}
var nD = Joe, Qoe = $u;
function eae(t, e) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!Qoe(n))
      return t(n, r);
    for (var i = n.length, s = e ? i : -1, o = Object(n); (e ? s-- : ++s < i) && r(o[s], s, o) !== !1; )
      ;
    return n;
  };
}
var tae = eae, nae = nD, rae = tae, iae = rae(nae), sae = iae, oae = sae;
function aae(t, e) {
  var n;
  return oae(t, function(r, i, s) {
    return n = e(r, i, s), !n;
  }), !!n;
}
var lae = aae, cae = Za, uae = $u, fae = Cy, hae = Ei;
function dae(t, e, n) {
  if (!hae(n))
    return !1;
  var r = typeof e;
  return (r == "number" ? uae(n) && fae(e, n.length) : r == "string" && e in n) ? cae(n[e], t) : !1;
}
var Py = dae, pae = YA, mae = eD, gae = lae, vae = wr, yae = Py;
function bae(t, e, n) {
  var r = vae(t) ? pae : gae;
  return n && yae(t, e, n) && (e = void 0), r(t, mae(e));
}
var xae = bae, wae = ti, kae = kr, _ae = "[object Boolean]";
function Sae(t) {
  return t === !0 || t === !1 || kae(t) && wae(t) == _ae;
}
var Mae = Sae, Cae = ti, $ae = kr, Aae = "[object Number]";
function Dae(t) {
  return typeof t == "number" || $ae(t) && Cae(t) == Aae;
}
var gr = Dae, Tae = Do, Oae = function() {
  try {
    var t = Tae(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch (e) {
  }
}(), rD = Oae, Kk = rD;
function Eae(t, e, n) {
  e == "__proto__" && Kk ? Kk(t, e, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : t[e] = n;
}
var Mp = Eae, Pae = Mp, Lae = Za, Nae = Object.prototype, Iae = Nae.hasOwnProperty;
function Rae(t, e, n) {
  var r = t[e];
  (!(Iae.call(t, e) && Lae(r, n)) || n === void 0 && !(e in t)) && Pae(t, e, n);
}
var Bae = Rae, Fae = Mp, zae = nD, Vae = eD;
function Hae(t, e) {
  var n = {};
  return e = Vae(e), zae(t, function(r, i, s) {
    Fae(n, i, e(r, i, s));
  }), n;
}
var Yae = Hae;
function Wae(t, e, n) {
  switch (n.length) {
    case 0:
      return t.call(e);
    case 1:
      return t.call(e, n[0]);
    case 2:
      return t.call(e, n[0], n[1]);
    case 3:
      return t.call(e, n[0], n[1], n[2]);
  }
  return t.apply(e, n);
}
var iD = Wae, jae = iD, Gk = Math.max;
function qae(t, e, n) {
  return e = Gk(e === void 0 ? t.length - 1 : e, 0), function() {
    for (var r = arguments, i = -1, s = Gk(r.length - e, 0), o = Array(s); ++i < s; )
      o[i] = r[e + i];
    i = -1;
    for (var a = Array(e + 1); ++i < e; )
      a[i] = r[i];
    return a[e] = n(o), jae(t, this, a);
  };
}
var Uae = qae;
function Kae(t) {
  return function() {
    return t;
  };
}
var Gae = Kae, Xae = Gae, Xk = rD, Zae = Ey, Jae = Xk ? function(t, e) {
  return Xk(t, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Xae(e),
    writable: !0
  });
} : Zae, Qae = Jae, ele = 800, tle = 16, nle = Date.now;
function rle(t) {
  var e = 0, n = 0;
  return function() {
    var r = nle(), i = tle - (r - n);
    if (n = r, i > 0) {
      if (++e >= ele)
        return arguments[0];
    } else
      e = 0;
    return t.apply(void 0, arguments);
  };
}
var ile = rle, sle = Qae, ole = ile, ale = ole(sle), lle = ale, cle = Ey, ule = Uae, fle = lle;
function hle(t, e) {
  return fle(ule(t, e, cle), t + "");
}
var Ly = hle;
function dle(t) {
  var e = [];
  if (t != null)
    for (var n in Object(t))
      e.push(n);
  return e;
}
var ple = dle, mle = Ei, gle = Ty, vle = ple, yle = Object.prototype, ble = yle.hasOwnProperty;
function xle(t) {
  if (!mle(t))
    return vle(t);
  var e = gle(t), n = [];
  for (var r in t)
    r == "constructor" && (e || !ble.call(t, r)) || n.push(r);
  return n;
}
var wle = xle, kle = qA, _le = wle, Sle = $u;
function Mle(t) {
  return Sle(t) ? kle(t, !0) : _le(t);
}
var Ny = Mle, Cle = Ly, $le = Za, Ale = Py, Dle = Ny, sD = Object.prototype, Tle = sD.hasOwnProperty, Ole = Cle(function(t, e) {
  t = Object(t);
  var n = -1, r = e.length, i = r > 2 ? e[2] : void 0;
  for (i && Ale(e[0], e[1], i) && (r = 1); ++n < r; )
    for (var s = e[n], o = Dle(s), a = -1, l = o.length; ++a < l; ) {
      var c = o[a], u = t[c];
      (u === void 0 || $le(u, sD[c]) && !Tle.call(t, c)) && (t[c] = s[c]);
    }
  return t;
}), Zk = Ole, Ele = Mp, Ple = Za;
function Lle(t, e, n) {
  (n !== void 0 && !Ple(t[e], n) || n === void 0 && !(e in t)) && Ele(t, e, n);
}
var oD = Lle, ld = {}, Nle = {
  get exports() {
    return ld;
  },
  set exports(t) {
    ld = t;
  }
};
(function(t, e) {
  var n = ei, r = e && !e.nodeType && e, i = r && !0 && t && !t.nodeType && t, s = i && i.exports === r, o = s ? n.Buffer : void 0, a = o ? o.allocUnsafe : void 0;
  function l(c, u) {
    if (u)
      return c.slice();
    var h = c.length, f = a ? a(h) : new c.constructor(h);
    return c.copy(f), f;
  }
  t.exports = l;
})(Nle, ld);
var Jk = jA;
function Ile(t) {
  var e = new t.constructor(t.byteLength);
  return new Jk(e).set(new Jk(t)), e;
}
var Rle = Ile, Ble = Rle;
function Fle(t, e) {
  var n = e ? Ble(t.buffer) : t.buffer;
  return new t.constructor(n, t.byteOffset, t.length);
}
var zle = Fle;
function Vle(t, e) {
  var n = -1, r = t.length;
  for (e || (e = Array(r)); ++n < r; )
    e[n] = t[n];
  return e;
}
var Hle = Vle, Yle = Ei, Qk = Object.create, Wle = /* @__PURE__ */ function() {
  function t() {
  }
  return function(e) {
    if (!Yle(e))
      return {};
    if (Qk)
      return Qk(e);
    t.prototype = e;
    var n = new t();
    return t.prototype = void 0, n;
  };
}(), jle = Wle, qle = UA, Ule = qle(Object.getPrototypeOf, Object), aD = Ule, Kle = jle, Gle = aD, Xle = Ty;
function Zle(t) {
  return typeof t.constructor == "function" && !Xle(t) ? Kle(Gle(t)) : {};
}
var Jle = Zle, Qle = $u, ece = kr;
function tce(t) {
  return ece(t) && Qle(t);
}
var nce = tce, rce = ti, ice = aD, sce = kr, oce = "[object Object]", ace = Function.prototype, lce = Object.prototype, lD = ace.toString, cce = lce.hasOwnProperty, uce = lD.call(Object);
function fce(t) {
  if (!sce(t) || rce(t) != oce)
    return !1;
  var e = ice(t);
  if (e === null)
    return !0;
  var n = cce.call(e, "constructor") && e.constructor;
  return typeof n == "function" && n instanceof n && lD.call(n) == uce;
}
var hce = fce;
function dce(t, e) {
  if (!(e === "constructor" && typeof t[e] == "function") && e != "__proto__")
    return t[e];
}
var cD = dce, pce = Bae, mce = Mp;
function gce(t, e, n, r) {
  var i = !n;
  n || (n = {});
  for (var s = -1, o = e.length; ++s < o; ) {
    var a = e[s], l = r ? r(n[a], t[a], a, n, t) : void 0;
    l === void 0 && (l = t[a]), i ? mce(n, a, l) : pce(n, a, l);
  }
  return n;
}
var vce = gce, yce = vce, bce = Ny;
function xce(t) {
  return yce(t, bce(t));
}
var wce = xce, e_ = oD, kce = ld, _ce = zle, Sce = Hle, Mce = Jle, t_ = My, n_ = wr, Cce = nce, $ce = Ia, Ace = Ao, Dce = Ei, Tce = hce, Oce = Dy, r_ = cD, Ece = wce;
function Pce(t, e, n, r, i, s, o) {
  var a = r_(t, n), l = r_(e, n), c = o.get(l);
  if (c) {
    e_(t, n, c);
    return;
  }
  var u = s ? s(a, l, n + "", t, e, o) : void 0, h = u === void 0;
  if (h) {
    var f = n_(l), d = !f && $ce(l), p = !f && !d && Oce(l);
    u = l, f || d || p ? n_(a) ? u = a : Cce(a) ? u = Sce(a) : d ? (h = !1, u = kce(l, !0)) : p ? (h = !1, u = _ce(l, !0)) : u = [] : Tce(l) || t_(l) ? (u = a, t_(a) ? u = Ece(a) : (!Dce(a) || Ace(a)) && (u = Mce(l))) : h = !1;
  }
  h && (o.set(l, u), i(u, l, r, s, o), o.delete(l)), e_(t, n, u);
}
var Lce = Pce, Nce = Ay, Ice = oD, Rce = tD, Bce = Lce, Fce = Ei, zce = Ny, Vce = cD;
function uD(t, e, n, r, i) {
  t !== e && Rce(e, function(s, o) {
    if (i || (i = new Nce()), Fce(s))
      Bce(t, e, o, n, uD, r, i);
    else {
      var a = r ? r(Vce(t, o), s, o + "", t, e, i) : void 0;
      a === void 0 && (a = s), Ice(t, o, a);
    }
  }, zce);
}
var fD = uD, Hce = fD, i_ = Ei;
function hD(t, e, n, r, i, s) {
  return i_(t) && i_(e) && (s.set(e, t), Hce(t, e, void 0, hD, s), s.delete(e)), t;
}
var Yce = hD, Wce = Ly, jce = Py;
function qce(t) {
  return Wce(function(e, n) {
    var r = -1, i = n.length, s = i > 1 ? n[i - 1] : void 0, o = i > 2 ? n[2] : void 0;
    for (s = t.length > 3 && typeof s == "function" ? (i--, s) : void 0, o && jce(n[0], n[1], o) && (s = i < 3 ? void 0 : s, i = 1), e = Object(e); ++r < i; ) {
      var a = n[r];
      a && t(e, a, r, s);
    }
    return e;
  });
}
var Uce = qce, Kce = fD, Gce = Uce, Xce = Gce(function(t, e, n, r) {
  Kce(t, e, n, r);
}), Zce = Xce, Jce = iD, Qce = Ly, eue = Yce, tue = Zce, nue = Qce(function(t) {
  return t.push(void 0, eue), Jce(tue, void 0, t);
}), Wc = nue;
function rue(t) {
  return t && t.length ? t[0] : void 0;
}
var dD = rue;
function iue(t) {
  var e = t == null ? 0 : t.length;
  return e ? t[e - 1] : void 0;
}
var Ko = iue;
const sue = (t) => Object.prototype.toString.call(t).slice(8, -1), oa = (t) => fne(t) && !isNaN(t.getTime()), Ci = (t) => sue(t) === "Object", pD = VA, s_ = (t, e) => xae(e, (n) => VA(t, n)), We = (t, e, n = "0") => {
  for (t = t != null ? String(t) : "", e = e || 2; t.length < e; )
    t = `${n}${t}`;
  return t;
}, Kn = (t) => Array.isArray(t), di = (t) => Kn(t) && t.length > 0, cd = (t) => {
  var e;
  return t == null ? null : document && Fr(t) ? document.querySelector(t) : (e = t.$el) != null ? e : t;
}, Ui = (t, e, n, r = void 0) => {
  t.removeEventListener(e, n, r);
}, Ki = (t, e, n, r = void 0) => (t.addEventListener(e, n, r), () => Ui(t, e, n, r)), jf = (t, e) => !!t && !!e && (t === e || t.contains(e)), Mf = (t, e) => {
  (t.key === " " || t.key === "Enter") && (e(t), t.preventDefault());
}, mD = (t, ...e) => {
  const n = {};
  let r;
  for (r in t)
    e.includes(r) || (n[r] = t[r]);
  return n;
}, gD = (t, e) => {
  const n = {};
  return e.forEach((r) => {
    r in t && (n[r] = t[r]);
  }), n;
};
function oue(t, e, n) {
  return Math.min(Math.max(t, e), n);
}
var ud = {}, aue = {
  get exports() {
    return ud;
  },
  set exports(t) {
    ud = t;
  }
};
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r) {
    if (r === null || r === !0 || r === !1)
      return NaN;
    var i = Number(r);
    return isNaN(i) ? i : i < 0 ? Math.ceil(i) : Math.floor(i);
  }
  t.exports = e.default;
})(aue, ud);
const lue = /* @__PURE__ */ EA(ud);
var fd = {}, cue = {
  get exports() {
    return fd;
  },
  set exports(t) {
    fd = t;
  }
};
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r) {
    var i = new Date(Date.UTC(r.getFullYear(), r.getMonth(), r.getDate(), r.getHours(), r.getMinutes(), r.getSeconds(), r.getMilliseconds()));
    return i.setUTCFullYear(r.getFullYear()), r.getTime() - i.getTime();
  }
  t.exports = e.default;
})(cue, fd);
const o_ = /* @__PURE__ */ EA(fd);
function uue(t, e) {
  var n = pue(e);
  return n.formatToParts ? hue(n, t) : due(n, t);
}
var fue = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function hue(t, e) {
  try {
    for (var n = t.formatToParts(e), r = [], i = 0; i < n.length; i++) {
      var s = fue[n[i].type];
      s >= 0 && (r[s] = parseInt(n[i].value, 10));
    }
    return r;
  } catch (o) {
    if (o instanceof RangeError)
      return [NaN];
    throw o;
  }
}
function due(t, e) {
  var n = t.format(e).replace(/\u200E/g, ""), r = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(n);
  return [r[3], r[1], r[2], r[4], r[5], r[6]];
}
var jm = {};
function pue(t) {
  if (!jm[t]) {
    var e = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), n = e === "06/25/2014, 00:00:00" || e === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    jm[t] = n ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: t,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: t,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return jm[t];
}
function vD(t, e, n, r, i, s, o) {
  var a = /* @__PURE__ */ new Date(0);
  return a.setUTCFullYear(t, e, n), a.setUTCHours(r, i, s, o), a;
}
var a_ = 36e5, mue = 6e4, qm = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function gue(t, e, n) {
  var r, i;
  if (!t || (r = qm.timezoneZ.exec(t), r))
    return 0;
  var s;
  if (r = qm.timezoneHH.exec(t), r)
    return s = parseInt(r[1], 10), l_(s) ? -(s * a_) : NaN;
  if (r = qm.timezoneHHMM.exec(t), r) {
    s = parseInt(r[1], 10);
    var o = parseInt(r[2], 10);
    return l_(s, o) ? (i = Math.abs(s) * a_ + o * mue, s > 0 ? -i : i) : NaN;
  }
  if (bue(t)) {
    e = new Date(e || Date.now());
    var a = vue(e), l = hv(a, t), c = yue(e, l, t);
    return -c;
  }
  return NaN;
}
function vue(t) {
  return vD(
    t.getFullYear(),
    t.getMonth(),
    t.getDate(),
    t.getHours(),
    t.getMinutes(),
    t.getSeconds(),
    t.getMilliseconds()
  );
}
function hv(t, e) {
  var n = uue(t, e), r = vD(
    n[0],
    n[1] - 1,
    n[2],
    n[3] % 24,
    n[4],
    n[5],
    0
  ).getTime(), i = t.getTime(), s = i % 1e3;
  return i -= s >= 0 ? s : 1e3 + s, r - i;
}
function yue(t, e, n) {
  var r = t.getTime(), i = r - e, s = hv(new Date(i), n);
  if (e === s)
    return e;
  i -= s - e;
  var o = hv(new Date(i), n);
  return s === o ? s : Math.max(s, o);
}
function l_(t, e) {
  return -23 <= t && t <= 23 && (e == null || 0 <= e && e <= 59);
}
var c_ = {};
function bue(t) {
  if (c_[t])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: t }), c_[t] = !0, !0;
  } catch (e) {
    return !1;
  }
}
var xue = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
const wue = xue;
var Um = 36e5, u_ = 6e4, kue = 2, en = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: wue
};
function _ue(t, e) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  var n = e || {}, r = n.additionalDigits == null ? kue : lue(n.additionalDigits);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]")
    return new Date(t.getTime());
  if (typeof t == "number" || Object.prototype.toString.call(t) === "[object Number]")
    return new Date(t);
  if (!(typeof t == "string" || Object.prototype.toString.call(t) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var i = Sue(t), s = Mue(i.date, r), o = s.year, a = s.restDateString, l = Cue(a, o);
  if (isNaN(l))
    return /* @__PURE__ */ new Date(NaN);
  if (l) {
    var c = l.getTime(), u = 0, h;
    if (i.time && (u = $ue(i.time), isNaN(u)))
      return /* @__PURE__ */ new Date(NaN);
    if (i.timeZone || n.timeZone) {
      if (h = gue(i.timeZone || n.timeZone, new Date(c + u)), isNaN(h))
        return /* @__PURE__ */ new Date(NaN);
    } else
      h = o_(new Date(c + u)), h = o_(new Date(c + u + h));
    return new Date(c + u + h);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function Sue(t) {
  var e = {}, n = en.dateTimePattern.exec(t), r;
  if (n ? (e.date = n[1], r = n[3]) : (n = en.datePattern.exec(t), n ? (e.date = n[1], r = n[2]) : (e.date = null, r = t)), r) {
    var i = en.timeZone.exec(r);
    i ? (e.time = r.replace(i[1], ""), e.timeZone = i[1].trim()) : e.time = r;
  }
  return e;
}
function Mue(t, e) {
  var n = en.YYY[e], r = en.YYYYY[e], i;
  if (i = en.YYYY.exec(t) || r.exec(t), i) {
    var s = i[1];
    return {
      year: parseInt(s, 10),
      restDateString: t.slice(s.length)
    };
  }
  if (i = en.YY.exec(t) || n.exec(t), i) {
    var o = i[1];
    return {
      year: parseInt(o, 10) * 100,
      restDateString: t.slice(o.length)
    };
  }
  return {
    year: null
  };
}
function Cue(t, e) {
  if (e === null)
    return null;
  var n, r, i, s;
  if (t.length === 0)
    return r = /* @__PURE__ */ new Date(0), r.setUTCFullYear(e), r;
  if (n = en.MM.exec(t), n)
    return r = /* @__PURE__ */ new Date(0), i = parseInt(n[1], 10) - 1, h_(e, i) ? (r.setUTCFullYear(e, i), r) : /* @__PURE__ */ new Date(NaN);
  if (n = en.DDD.exec(t), n) {
    r = /* @__PURE__ */ new Date(0);
    var o = parseInt(n[1], 10);
    return Tue(e, o) ? (r.setUTCFullYear(e, 0, o), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (n = en.MMDD.exec(t), n) {
    r = /* @__PURE__ */ new Date(0), i = parseInt(n[1], 10) - 1;
    var a = parseInt(n[2], 10);
    return h_(e, i, a) ? (r.setUTCFullYear(e, i, a), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (n = en.Www.exec(t), n)
    return s = parseInt(n[1], 10) - 1, d_(e, s) ? f_(e, s) : /* @__PURE__ */ new Date(NaN);
  if (n = en.WwwD.exec(t), n) {
    s = parseInt(n[1], 10) - 1;
    var l = parseInt(n[2], 10) - 1;
    return d_(e, s, l) ? f_(e, s, l) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function $ue(t) {
  var e, n, r;
  if (e = en.HH.exec(t), e)
    return n = parseFloat(e[1].replace(",", ".")), Km(n) ? n % 24 * Um : NaN;
  if (e = en.HHMM.exec(t), e)
    return n = parseInt(e[1], 10), r = parseFloat(e[2].replace(",", ".")), Km(n, r) ? n % 24 * Um + r * u_ : NaN;
  if (e = en.HHMMSS.exec(t), e) {
    n = parseInt(e[1], 10), r = parseInt(e[2], 10);
    var i = parseFloat(e[3].replace(",", "."));
    return Km(n, r, i) ? n % 24 * Um + r * u_ + i * 1e3 : NaN;
  }
  return null;
}
function f_(t, e, n) {
  e = e || 0, n = n || 0;
  var r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4);
  var i = r.getUTCDay() || 7, s = e * 7 + n + 1 - i;
  return r.setUTCDate(r.getUTCDate() + s), r;
}
var Aue = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Due = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function yD(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function h_(t, e, n) {
  if (e < 0 || e > 11)
    return !1;
  if (n != null) {
    if (n < 1)
      return !1;
    var r = yD(t);
    if (r && n > Due[e] || !r && n > Aue[e])
      return !1;
  }
  return !0;
}
function Tue(t, e) {
  if (e < 1)
    return !1;
  var n = yD(t);
  return !(n && e > 366 || !n && e > 365);
}
function d_(t, e, n) {
  return !(e < 0 || e > 52 || n != null && (n < 0 || n > 6));
}
function Km(t, e, n) {
  return !(t != null && (t < 0 || t >= 25) || e != null && (e < 0 || e >= 60) || n != null && (n < 0 || n >= 60));
}
function Kt(t, e) {
  if (e.length < t)
    throw new TypeError(t + " argument" + (t > 1 ? "s" : "") + " required, but only " + e.length + " present");
}
function qf(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? qf = function(n) {
    return typeof n;
  } : qf = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, qf(t);
}
function Pi(t) {
  Kt(1, arguments);
  var e = Object.prototype.toString.call(t);
  return t instanceof Date || qf(t) === "object" && e === "[object Date]" ? new Date(t.getTime()) : typeof t == "number" || e === "[object Number]" ? new Date(t) : ((typeof t == "string" || e === "[object String]") && typeof console != "undefined" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function nl(t) {
  if (t === null || t === !0 || t === !1)
    return NaN;
  var e = Number(t);
  return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
}
var Oue = {};
function Iy() {
  return Oue;
}
function xo(t, e) {
  var n, r, i, s, o, a, l, c;
  Kt(1, arguments);
  var u = Iy(), h = nl((n = (r = (i = (s = e == null ? void 0 : e.weekStartsOn) !== null && s !== void 0 ? s : e == null || (o = e.locale) === null || o === void 0 || (a = o.options) === null || a === void 0 ? void 0 : a.weekStartsOn) !== null && i !== void 0 ? i : u.weekStartsOn) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(h >= 0 && h <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = Pi(t), d = f.getDay(), p = (d < h ? 7 : 0) + d - h;
  return f.setDate(f.getDate() - p), f.setHours(0, 0, 0, 0), f;
}
function p_(t) {
  var e = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
  return e.setUTCFullYear(t.getFullYear()), t.getTime() - e.getTime();
}
var Eue = 6048e5;
function Pue(t, e, n) {
  Kt(2, arguments);
  var r = xo(t, n), i = xo(e, n), s = r.getTime() - p_(r), o = i.getTime() - p_(i);
  return Math.round((s - o) / Eue);
}
function Lue(t) {
  Kt(1, arguments);
  var e = Pi(t), n = e.getMonth();
  return e.setFullYear(e.getFullYear(), n + 1, 0), e.setHours(0, 0, 0, 0), e;
}
function Nue(t) {
  Kt(1, arguments);
  var e = Pi(t);
  return e.setDate(1), e.setHours(0, 0, 0, 0), e;
}
function Iue(t, e) {
  return Kt(1, arguments), Pue(Lue(t), Nue(t), e) + 1;
}
function Rue(t, e) {
  var n, r, i, s, o, a, l, c;
  Kt(1, arguments);
  var u = Pi(t), h = u.getFullYear(), f = Iy(), d = nl((n = (r = (i = (s = e == null ? void 0 : e.firstWeekContainsDate) !== null && s !== void 0 ? s : e == null || (o = e.locale) === null || o === void 0 || (a = o.options) === null || a === void 0 ? void 0 : a.firstWeekContainsDate) !== null && i !== void 0 ? i : f.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = f.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(d >= 1 && d <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var p = /* @__PURE__ */ new Date(0);
  p.setFullYear(h + 1, 0, d), p.setHours(0, 0, 0, 0);
  var m = xo(p, e), v = /* @__PURE__ */ new Date(0);
  v.setFullYear(h, 0, d), v.setHours(0, 0, 0, 0);
  var g = xo(v, e);
  return u.getTime() >= m.getTime() ? h + 1 : u.getTime() >= g.getTime() ? h : h - 1;
}
function Bue(t, e) {
  var n, r, i, s, o, a, l, c;
  Kt(1, arguments);
  var u = Iy(), h = nl((n = (r = (i = (s = e == null ? void 0 : e.firstWeekContainsDate) !== null && s !== void 0 ? s : e == null || (o = e.locale) === null || o === void 0 || (a = o.options) === null || a === void 0 ? void 0 : a.firstWeekContainsDate) !== null && i !== void 0 ? i : u.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), f = Rue(t, e), d = /* @__PURE__ */ new Date(0);
  d.setFullYear(f, 0, h), d.setHours(0, 0, 0, 0);
  var p = xo(d, e);
  return p;
}
var Fue = 6048e5;
function zue(t, e) {
  Kt(1, arguments);
  var n = Pi(t), r = xo(n, e).getTime() - Bue(n, e).getTime();
  return Math.round(r / Fue) + 1;
}
function hd(t) {
  return Kt(1, arguments), xo(t, {
    weekStartsOn: 1
  });
}
function Vue(t) {
  Kt(1, arguments);
  var e = Pi(t), n = e.getFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  var i = hd(r), s = /* @__PURE__ */ new Date(0);
  s.setFullYear(n, 0, 4), s.setHours(0, 0, 0, 0);
  var o = hd(s);
  return e.getTime() >= i.getTime() ? n + 1 : e.getTime() >= o.getTime() ? n : n - 1;
}
function Hue(t) {
  Kt(1, arguments);
  var e = Vue(t), n = /* @__PURE__ */ new Date(0);
  n.setFullYear(e, 0, 4), n.setHours(0, 0, 0, 0);
  var r = hd(n);
  return r;
}
var Yue = 6048e5;
function Wue(t) {
  Kt(1, arguments);
  var e = Pi(t), n = hd(e).getTime() - Hue(e).getTime();
  return Math.round(n / Yue) + 1;
}
function Zt(t, e) {
  Kt(2, arguments);
  var n = Pi(t), r = nl(e);
  return isNaN(r) ? /* @__PURE__ */ new Date(NaN) : (r && n.setDate(n.getDate() + r), n);
}
function dd(t, e) {
  Kt(2, arguments);
  var n = Pi(t), r = nl(e);
  if (isNaN(r))
    return /* @__PURE__ */ new Date(NaN);
  if (!r)
    return n;
  var i = n.getDate(), s = new Date(n.getTime());
  s.setMonth(n.getMonth() + r + 1, 0);
  var o = s.getDate();
  return i >= o ? s : (n.setFullYear(s.getFullYear(), s.getMonth(), i), n);
}
function m_(t, e) {
  Kt(2, arguments);
  var n = nl(e);
  return dd(t, n * 12);
}
const jue = {
  daily: ["year", "month", "day"],
  weekly: ["year", "month", "week"],
  monthly: ["year", "month"]
};
function que({
  monthComps: t,
  prevMonthComps: e,
  nextMonthComps: n
}, r) {
  const i = [], {
    firstDayOfWeek: s,
    firstWeekday: o,
    isoWeeknumbers: a,
    weeknumbers: l,
    numDays: c,
    numWeeks: u
  } = t, h = o + (o < s ? Rt : 0) - s;
  let f = !0, d = !1, p = !1, m = 0;
  const v = new Intl.DateTimeFormat(r.id, {
    weekday: "long",
    year: "numeric",
    month: "short",
    day: "numeric"
  });
  let g = e.numDays - h + 1, y = e.numDays - g + 1, x = Math.floor((g - 1) / Rt + 1), b = 1, w = e.numWeeks, k = 1, _ = e.month, C = e.year;
  const E = /* @__PURE__ */ new Date(), L = E.getDate(), M = E.getMonth() + 1, O = E.getFullYear();
  for (let N = 1; N <= Bfe; N++) {
    for (let R = 1, $ = s; R <= Rt; R++, $ += $ === Rt ? 1 - Rt : 1) {
      f && $ === o && (g = 1, y = t.numDays, x = Math.floor((g - 1) / Rt + 1), b = Math.floor((c - g) / Rt + 1), w = 1, k = u, _ = t.month, C = t.year, f = !1, d = !0);
      const F = r.getDateFromParams(C, _, g, 0, 0, 0, 0), U = r.getDateFromParams(C, _, g, 12, 0, 0, 0), ee = r.getDateFromParams(
        C,
        _,
        g,
        23,
        59,
        59,
        999
      ), ie = F, z = `${We(C, 4)}-${We(_, 2)}-${We(g, 2)}`, te = R, I = Rt - R, X = l[N - 1], Q = a[N - 1], ce = g === L && _ === M && C === O, he = d && g === 1, J = d && g === c, pe = N === 1, Y = N === u, se = R === 1, ge = R === Rt, V = TD(C, _, g);
      i.push({
        locale: r,
        id: z,
        position: ++m,
        label: g.toString(),
        ariaLabel: v.format(new Date(C, _ - 1, g)),
        day: g,
        dayFromEnd: y,
        weekday: $,
        weekdayPosition: te,
        weekdayPositionFromEnd: I,
        weekdayOrdinal: x,
        weekdayOrdinalFromEnd: b,
        week: w,
        weekFromEnd: k,
        weekPosition: N,
        weeknumber: X,
        isoWeeknumber: Q,
        month: _,
        year: C,
        date: ie,
        startDate: F,
        endDate: ee,
        noonDate: U,
        dayIndex: V,
        isToday: ce,
        isFirstDay: he,
        isLastDay: J,
        isDisabled: !d,
        isFocusable: !d,
        isFocused: !1,
        inMonth: d,
        inPrevMonth: f,
        inNextMonth: p,
        onTop: pe,
        onBottom: Y,
        onLeft: se,
        onRight: ge,
        classes: [
          `id-${z}`,
          `day-${g}`,
          `day-from-end-${y}`,
          `weekday-${$}`,
          `weekday-position-${te}`,
          `weekday-ordinal-${x}`,
          `weekday-ordinal-from-end-${b}`,
          `week-${w}`,
          `week-from-end-${k}`,
          {
            "is-today": ce,
            "is-first-day": he,
            "is-last-day": J,
            "in-month": d,
            "in-prev-month": f,
            "in-next-month": p,
            "on-top": pe,
            "on-bottom": Y,
            "on-left": se,
            "on-right": ge
          }
        ]
      }), d && J ? (d = !1, p = !0, g = 1, y = c, x = 1, b = Math.floor((c - g) / Rt + 1), w = 1, k = n.numWeeks, _ = n.month, C = n.year) : (g++, y--, x = Math.floor((g - 1) / Rt + 1), b = Math.floor((c - g) / Rt + 1));
    }
    w++, k--;
  }
  return i;
}
function Uue(t, e, n, r) {
  const i = t.reduce((s, o, a) => {
    const l = Math.floor(a / 7);
    let c = s[l];
    return c || (c = {
      id: `week-${l + 1}`,
      title: "",
      week: o.week,
      weekPosition: o.weekPosition,
      weeknumber: o.weeknumber,
      isoWeeknumber: o.isoWeeknumber,
      weeknumberDisplay: e ? o.weeknumber : n ? o.isoWeeknumber : void 0,
      days: []
    }, s[l] = c), c.days.push(o), s;
  }, Array(t.length / Rt));
  return i.forEach((s) => {
    const o = s.days[0], a = s.days[s.days.length - 1];
    o.month === a.month ? s.title = `${r.formatDate(o.date, "MMMM YYYY")}` : o.year === a.year ? s.title = `${r.formatDate(
      o.date,
      "MMM"
    )} - ${r.formatDate(a.date, "MMM YYYY")}` : s.title = `${r.formatDate(
      o.date,
      "MMM YYYY"
    )} - ${r.formatDate(a.date, "MMM YYYY")}`;
  }), i;
}
function Kue(t, e) {
  return t.days.map((n) => ({
    label: e.formatDate(n.date, e.masks.weekdays),
    weekday: n.weekday
  }));
}
function Gue(t, e) {
  return `${e}.${We(t, 2)}`;
}
function bD(t, e, n) {
  return gD(
    n.getDateParts(n.toDate(t)),
    jue[e]
  );
}
function xD({ day: t, week: e, month: n, year: r }, i, s, o) {
  if (s === "daily" && t) {
    const a = new Date(r, n - 1, t), l = Zt(a, i);
    return {
      day: l.getDate(),
      month: l.getMonth() + 1,
      year: l.getFullYear()
    };
  } else if (s === "weekly" && e) {
    const l = o.getMonthParts(n, r).firstDayOfMonth, c = Zt(l, (e - 1 + i) * 7), u = o.getDateParts(c);
    return {
      week: u.week,
      month: u.month,
      year: u.year
    };
  } else {
    const a = new Date(r, n - 1, 1), l = dd(a, i);
    return {
      month: l.getMonth() + 1,
      year: l.getFullYear()
    };
  }
}
function zr(t) {
  return t != null && t.month != null && t.year != null;
}
function dv(t, e) {
  return !zr(t) || !zr(e) ? !1 : (t = t, e = e, t.year !== e.year ? t.year < e.year : t.month && e.month && t.month !== e.month ? t.month < e.month : t.week && e.week && t.week !== e.week ? t.week < e.week : t.day && e.day && t.day !== e.day ? t.day < e.day : !1);
}
function pd(t, e) {
  return !zr(t) || !zr(e) ? !1 : (t = t, e = e, t.year !== e.year ? t.year > e.year : t.month && e.month && t.month !== e.month ? t.month > e.month : t.week && e.week && t.week !== e.week ? t.week > e.week : t.day && e.day && t.day !== e.day ? t.day > e.day : !1);
}
function Xue(t, e, n) {
  return (t || !1) && !dv(t, e) && !pd(t, n);
}
function Zue(t, e) {
  return !t && e || t && !e ? !1 : !t && !e ? !0 : (t = t, e = e, t.year === e.year && t.month === e.month && t.week === e.week && t.day === e.day);
}
function Jue(t, e, n, r) {
  if (!zr(t) || !zr(e))
    return [];
  const i = [];
  for (; !pd(t, e); )
    i.push(t), t = xD(t, 1, n, r);
  return i;
}
function wD(t) {
  const { day: e, week: n, month: r, year: i } = t;
  let s = `${i}-${We(r, 2)}`;
  return n && (s = `${s}-w${n}`), e && (s = `${s}-${We(e, 2)}`), s;
}
function Que(t, e) {
  const { month: n, year: r, showWeeknumbers: i, showIsoWeeknumbers: s } = t, o = new Date(r, n - 1, 15), a = e.getMonthParts(n, r), l = e.getPrevMonthParts(n, r), c = e.getNextMonthParts(n, r), u = que({ monthComps: a, prevMonthComps: l, nextMonthComps: c }, e), h = Uue(u, i, s, e), f = Kue(h[0], e);
  return {
    id: wD(t),
    month: n,
    year: r,
    monthTitle: e.formatDate(o, e.masks.title),
    shortMonthLabel: e.formatDate(o, "MMM"),
    monthLabel: e.formatDate(o, "MMMM"),
    shortYearLabel: r.toString().substring(2),
    yearLabel: r.toString(),
    monthComps: a,
    prevMonthComps: l,
    nextMonthComps: c,
    days: u,
    weeks: h,
    weekdays: f
  };
}
function efe(t, e) {
  const { day: n, week: r, view: i, trimWeeks: s } = t, o = {
    ...e,
    ...t,
    title: "",
    viewDays: [],
    viewWeeks: []
  };
  switch (i) {
    case "daily": {
      let a = o.days.find((c) => c.inMonth);
      n ? a = o.days.find((c) => c.day === n && c.inMonth) || a : r && (a = o.days.find((c) => c.week === r && c.inMonth));
      const l = o.weeks[a.week - 1];
      o.viewWeeks = [l], o.viewDays = [a], o.week = a.week, o.weekTitle = l.title, o.day = a.day, o.dayTitle = a.ariaLabel, o.title = o.dayTitle;
      break;
    }
    case "weekly": {
      o.week = r || 1;
      const a = o.weeks[o.week - 1];
      o.viewWeeks = [a], o.viewDays = a.days, o.weekTitle = a.title, o.title = o.weekTitle;
      break;
    }
    default: {
      o.title = o.monthTitle, o.viewWeeks = o.weeks.slice(
        0,
        s ? o.monthComps.numWeeks : void 0
      ), o.viewDays = o.days;
      break;
    }
  }
  return o;
}
class g_ {
  constructor(e, n, r) {
    xe(this, "keys", []), xe(this, "store", {}), this.size = e, this.createKey = n, this.createItem = r;
  }
  get(...e) {
    const n = this.createKey(...e);
    return this.store[n];
  }
  getOrSet(...e) {
    const n = this.createKey(...e);
    if (this.store[n])
      return this.store[n];
    const r = this.createItem(...e);
    if (this.keys.length >= this.size) {
      const i = this.keys.shift();
      i != null && delete this.store[i];
    }
    return this.keys.push(n), this.store[n] = r, r;
  }
}
class aa {
  constructor(e, n = new md()) {
    xe(this, "order"), xe(this, "locale"), xe(this, "start", null), xe(this, "end", null), xe(this, "repeat", null);
    var r;
    this.locale = n;
    const { start: i, end: s, span: o, order: a, repeat: l } = e;
    oa(i) && (this.start = n.getDateParts(i)), oa(s) ? this.end = n.getDateParts(s) : this.start != null && o && (this.end = n.getDateParts(Zt(this.start.date, o - 1))), this.order = a != null ? a : 0, l && (this.repeat = new gd(
      {
        from: (r = this.start) == null ? void 0 : r.date,
        ...l
      },
      {
        locale: this.locale
      }
    ));
  }
  static fromMany(e, n) {
    return (Kn(e) ? e : [e]).filter((r) => r).map((r) => aa.from(r, n));
  }
  static from(e, n) {
    var i, s;
    if (e instanceof aa)
      return e;
    const r = {
      start: null,
      end: null
    };
    return e != null && (Kn(e) ? (r.start = (i = e[0]) != null ? i : null, r.end = (s = e[1]) != null ? s : null) : Ci(e) ? Object.assign(r, e) : (r.start = e, r.end = e)), r.start != null && (r.start = new Date(r.start)), r.end != null && (r.end = new Date(r.end)), new aa(r, n);
  }
  get opts() {
    const { order: e, locale: n } = this;
    return { order: e, locale: n };
  }
  get hasRepeat() {
    return !!this.repeat;
  }
  get isSingleDay() {
    const { start: e, end: n } = this;
    return e && n && e.year === n.year && e.month === n.month && e.day === n.day;
  }
  get isMultiDay() {
    return !this.isSingleDay;
  }
  get daySpan() {
    return this.start == null || this.end == null ? this.hasRepeat ? 1 : 1 / 0 : this.end.dayIndex - this.start.dayIndex;
  }
  startsOnDay(e) {
    var n, r;
    return ((n = this.start) == null ? void 0 : n.dayIndex) === e.dayIndex || !!((r = this.repeat) != null && r.passes(e));
  }
  intersectsDay(e) {
    return this.intersectsDayRange(e, e);
  }
  intersectsRange(e) {
    var i, s;
    var n, r;
    return this.intersectsDayRange(
      (i = (n = e.start) == null ? void 0 : n.dayIndex) != null ? i : -1 / 0,
      (s = (r = e.end) == null ? void 0 : r.dayIndex) != null ? s : 1 / 0
    );
  }
  intersectsDayRange(e, n) {
    return !(this.start && this.start.dayIndex > n || this.end && this.end.dayIndex < e);
  }
}
class tfe {
  constructor() {
    xe(this, "records", {});
  }
  render(e, n, r) {
    var h, f, d, p;
    var i, s, o, a;
    let l = null;
    const c = r[0].dayIndex, u = r[r.length - 1].dayIndex;
    return n.hasRepeat ? r.forEach((m) => {
      var y, x;
      var v, g;
      if (n.startsOnDay(m)) {
        const b = n.daySpan < 1 / 0 ? n.daySpan : 1;
        l = {
          startDay: m.dayIndex,
          startTime: (y = (v = n.start) == null ? void 0 : v.time) != null ? y : 0,
          endDay: m.dayIndex + b - 1,
          endTime: (x = (g = n.end) == null ? void 0 : g.time) != null ? x : Uf
        }, this.getRangeRecords(e).push(l);
      }
    }) : n.intersectsDayRange(c, u) && (l = {
      startDay: (h = (i = n.start) == null ? void 0 : i.dayIndex) != null ? h : -1 / 0,
      startTime: (f = (s = n.start) == null ? void 0 : s.time) != null ? f : -1 / 0,
      endDay: (d = (o = n.end) == null ? void 0 : o.dayIndex) != null ? d : 1 / 0,
      endTime: (p = (a = n.end) == null ? void 0 : a.time) != null ? p : 1 / 0
    }, this.getRangeRecords(e).push(l)), l;
  }
  getRangeRecords(e) {
    let n = this.records[e.key];
    return n || (n = {
      ranges: [],
      data: e
    }, this.records[e.key] = n), n.ranges;
  }
  getCell(e, n) {
    return this.getCells(n).find((s) => s.data.key === e);
  }
  cellExists(e, n) {
    const r = this.records[e];
    return r == null ? !1 : r.ranges.some(
      (i) => i.startDay <= n && i.endDay >= n
    );
  }
  getCells(e) {
    const n = Object.values(this.records), r = [], { dayIndex: i } = e;
    return n.forEach(({ data: s, ranges: o }) => {
      o.filter((a) => a.startDay <= i && a.endDay >= i).forEach((a) => {
        const l = i === a.startDay, c = i === a.endDay, u = l ? a.startTime : 0, h = new Date(e.startDate.getTime() + u), f = c ? a.endTime : Uf, d = new Date(e.endDate.getTime() + f), p = u === 0 && f === Uf, m = s.order || 0;
        r.push({
          ...a,
          data: s,
          onStart: l,
          onEnd: c,
          startTime: u,
          startDate: h,
          endTime: f,
          endDate: d,
          allDay: p,
          order: m
        });
      });
    }), r.sort((s, o) => s.order - o.order), r;
  }
}
const $i = {
  // Arabic
  ar: { dow: 7, L: "D/‏M/‏YYYY" },
  // Bulgarian
  bg: { dow: 2, L: "D.MM.YYYY" },
  // Catalan
  ca: { dow: 2, L: "DD/MM/YYYY" },
  // Chinese (China)
  "zh-CN": { dow: 2, L: "YYYY/MM/DD" },
  // Chinese (Taiwan)
  "zh-TW": { dow: 1, L: "YYYY/MM/DD" },
  // Croatian
  hr: { dow: 2, L: "DD.MM.YYYY" },
  // Czech
  cs: { dow: 2, L: "DD.MM.YYYY" },
  // Danish
  da: { dow: 2, L: "DD.MM.YYYY" },
  // Dutch
  nl: { dow: 2, L: "DD-MM-YYYY" },
  // English (US)
  "en-US": { dow: 1, L: "MM/DD/YYYY" },
  // English (Australia)
  "en-AU": { dow: 2, L: "DD/MM/YYYY" },
  // English (Canada)
  "en-CA": { dow: 1, L: "YYYY-MM-DD" },
  // English (Great Britain)
  "en-GB": { dow: 2, L: "DD/MM/YYYY" },
  // English (Ireland)
  "en-IE": { dow: 2, L: "DD-MM-YYYY" },
  // English (New Zealand)
  "en-NZ": { dow: 2, L: "DD/MM/YYYY" },
  // English (South Africa)
  "en-ZA": { dow: 1, L: "YYYY/MM/DD" },
  // Esperanto
  eo: { dow: 2, L: "YYYY-MM-DD" },
  // Estonian
  et: { dow: 2, L: "DD.MM.YYYY" },
  // Finnish
  fi: { dow: 2, L: "DD.MM.YYYY" },
  // French
  fr: { dow: 2, L: "DD/MM/YYYY" },
  // French (Canada)
  "fr-CA": { dow: 1, L: "YYYY-MM-DD" },
  // French (Switzerland)
  "fr-CH": { dow: 2, L: "DD.MM.YYYY" },
  // German
  de: { dow: 2, L: "DD.MM.YYYY" },
  // Hebrew
  he: { dow: 1, L: "DD.MM.YYYY" },
  // Indonesian
  id: { dow: 2, L: "DD/MM/YYYY" },
  // Italian
  it: { dow: 2, L: "DD/MM/YYYY" },
  // Japanese
  ja: { dow: 1, L: "YYYY年M月D日" },
  // Korean
  ko: { dow: 1, L: "YYYY.MM.DD" },
  // Latvian
  lv: { dow: 2, L: "DD.MM.YYYY" },
  // Lithuanian
  lt: { dow: 2, L: "DD.MM.YYYY" },
  // Macedonian
  mk: { dow: 2, L: "D.MM.YYYY" },
  // Norwegian
  nb: { dow: 2, L: "D. MMMM YYYY" },
  nn: { dow: 2, L: "D. MMMM YYYY" },
  // Polish
  pl: { dow: 2, L: "DD.MM.YYYY" },
  // Portuguese
  pt: { dow: 2, L: "DD/MM/YYYY" },
  // Romanian
  ro: { dow: 2, L: "DD.MM.YYYY" },
  // Russian
  ru: { dow: 2, L: "DD.MM.YYYY" },
  // Slovak
  sk: { dow: 2, L: "DD.MM.YYYY" },
  // Spanish (Spain)
  "es-ES": { dow: 2, L: "DD/MM/YYYY" },
  // Spanish (Mexico)
  "es-MX": { dow: 2, L: "DD/MM/YYYY" },
  // Swedish
  sv: { dow: 2, L: "YYYY-MM-DD" },
  // Thai
  th: { dow: 1, L: "DD/MM/YYYY" },
  // Turkish
  tr: { dow: 2, L: "DD.MM.YYYY" },
  // Ukrainian
  uk: { dow: 2, L: "DD.MM.YYYY" },
  // Vietnam
  vi: { dow: 2, L: "DD/MM/YYYY" }
};
$i.en = $i["en-US"];
$i.es = $i["es-ES"];
$i.no = $i.nb;
$i.zh = $i["zh-CN"];
const nfe = Object.entries($i).reduce(
  (t, [e, { dow: n, L: r }]) => (t[e] = {
    id: e,
    firstDayOfWeek: n,
    masks: { L: r }
  }, t),
  {}
), rfe = "MMMM YYYY", ife = "W", sfe = "MMM", ofe = "h A", afe = [
  "L",
  "YYYY-MM-DD",
  "YYYY/MM/DD"
], lfe = [
  "L h:mm A",
  "YYYY-MM-DD h:mm A",
  "YYYY/MM/DD h:mm A"
], cfe = [
  "L HH:mm",
  "YYYY-MM-DD HH:mm",
  "YYYY/MM/DD HH:mm"
], ufe = [
  "h:mm A"
], ffe = [
  "HH:mm"
], hfe = "WWW, MMM D, YYYY", dfe = [
  "L",
  "YYYY-MM-DD",
  "YYYY/MM/DD"
], pfe = "iso", mfe = "YYYY-MM-DDTHH:mm:ss.SSSZ", gfe = {
  title: rfe,
  weekdays: ife,
  navMonths: sfe,
  hours: ofe,
  input: afe,
  inputDateTime: lfe,
  inputDateTime24hr: cfe,
  inputTime: ufe,
  inputTime24hr: ffe,
  dayPopover: hfe,
  data: dfe,
  model: pfe,
  iso: mfe
}, vfe = 300, yfe = 60, bfe = 80, xfe = {
  maxSwipeTime: vfe,
  minHorizontalSwipeDistance: yfe,
  maxVerticalSwipeDistance: bfe
}, wfe = {
  componentPrefix: "V",
  color: "blue",
  isDark: !1,
  navVisibility: "click",
  titlePosition: "center",
  transition: "slide-h",
  touch: xfe,
  masks: gfe,
  locales: nfe,
  datePicker: {
    updateOnInput: !0,
    inputDebounce: 1e3,
    popover: {
      visibility: "hover-focus",
      placement: "bottom-start",
      isInteractive: !0
    }
  }
}, pv = yd(wfe), kfe = T(() => Yae(pv.locales, (t) => (t.masks = Wc(t.masks, pv.masks), t))), bs = (t) => typeof window != "undefined" && pD(window.__vcalendar__, t) ? js(window.__vcalendar__, t) : js(pv, t), _fe = 12, Sfe = 5;
function Mfe(t, e) {
  const n = new Intl.DateTimeFormat().resolvedOptions().locale;
  let r;
  Fr(t) ? r = t : pD(t, "id") && (r = t.id), r = (r || n).toLowerCase();
  const i = Object.keys(e), s = (l) => i.find((c) => c.toLowerCase() === l);
  r = s(r) || s(r.substring(0, 2)) || n;
  const o = {
    ...e["en-IE"],
    ...e[r],
    id: r,
    monthCacheSize: _fe,
    pageCacheSize: Sfe
  };
  return Ci(t) ? Wc(t, o) : o;
}
class md {
  constructor(e = void 0, n) {
    xe(this, "id"), xe(this, "daysInWeek"), xe(this, "firstDayOfWeek"), xe(this, "masks"), xe(this, "timezone"), xe(this, "hourLabels"), xe(this, "dayNames"), xe(this, "dayNamesShort"), xe(this, "dayNamesShorter"), xe(this, "dayNamesNarrow"), xe(this, "monthNames"), xe(this, "monthNamesShort"), xe(this, "relativeTimeNames"), xe(this, "amPm", ["am", "pm"]), xe(this, "monthCache"), xe(this, "pageCache");
    const { id: r, firstDayOfWeek: i, masks: s, monthCacheSize: o, pageCacheSize: a } = Mfe(e, kfe.value);
    this.monthCache = new g_(
      o,
      Ufe,
      Kfe
    ), this.pageCache = new g_(a, wD, Que), this.id = r, this.daysInWeek = Rt, this.firstDayOfWeek = oue(i, 1, Rt), this.masks = s, this.timezone = n || void 0, this.hourLabels = this.getHourLabels(), this.dayNames = Gm("long", this.id), this.dayNamesShort = Gm("short", this.id), this.dayNamesShorter = this.dayNamesShort.map((l) => l.substring(0, 2)), this.dayNamesNarrow = Gm("narrow", this.id), this.monthNames = k_("long", this.id), this.monthNamesShort = k_("short", this.id), this.relativeTimeNames = Zfe(this.id);
  }
  formatDate(e, n) {
    return nhe(e, n, this);
  }
  parseDate(e, n) {
    return __(e, n, this);
  }
  toDate(e, n = {}) {
    const r = /* @__PURE__ */ new Date(NaN);
    let i = r;
    const { fillDate: s, mask: o, patch: a, rules: l } = n;
    if (gr(e) ? (n.type = "number", i = /* @__PURE__ */ new Date(+e)) : Fr(e) ? (n.type = "string", i = e ? __(e, o || "iso", this) : r) : oa(e) ? (n.type = "date", i = new Date(e.getTime())) : Ry(e) && (n.type = "object", i = this.getDateFromParts(e)), i && (a || l)) {
      let c = this.getDateParts(i);
      if (a && s != null) {
        const u = this.getDateParts(this.toDate(s));
        c = this.getDateParts(
          this.toDate({ ...u, ...gD(c, Rfe[a]) })
        );
      }
      l && (c = the(c, l)), i = this.getDateFromParts(c);
    }
    return i || r;
  }
  toDateOrNull(e, n = {}) {
    const r = this.toDate(e, n);
    return isNaN(r.getTime()) ? null : r;
  }
  fromDate(e, { type: n, mask: r } = {}) {
    switch (n) {
      case "number":
        return e ? e.getTime() : NaN;
      case "string":
        return e ? this.formatDate(e, r || "iso") : "";
      case "object":
        return e ? this.getDateParts(e) : null;
      default:
        return e ? new Date(e) : null;
    }
  }
  range(e) {
    return aa.from(e, this);
  }
  ranges(e) {
    return aa.fromMany(e, this);
  }
  getDateParts(e) {
    return qfe(e, this);
  }
  getDateFromParts(e) {
    return ED(e, this.timezone);
  }
  getDateFromParams(e, n, r, i, s, o, a) {
    return this.getDateFromParts({
      year: e,
      month: n,
      day: r,
      hours: i,
      minutes: s,
      seconds: o,
      milliseconds: a
    });
  }
  getPage(e) {
    const n = this.pageCache.getOrSet(e, this);
    return efe(e, n);
  }
  getMonthParts(e, n) {
    const { firstDayOfWeek: r } = this;
    return this.monthCache.getOrSet(e, n, r);
  }
  getThisMonthParts() {
    const e = /* @__PURE__ */ new Date();
    return this.getMonthParts(
      e.getMonth() + 1,
      e.getFullYear()
    );
  }
  getPrevMonthParts(e, n) {
    return e === 1 ? this.getMonthParts(12, n - 1) : this.getMonthParts(e - 1, n);
  }
  getNextMonthParts(e, n) {
    return e === 12 ? this.getMonthParts(1, n + 1) : this.getMonthParts(e + 1, n);
  }
  getHourLabels() {
    return Xfe().map((e) => this.formatDate(e, this.masks.hours));
  }
  getDayId(e) {
    return this.formatDate(e, "YYYY-MM-DD");
  }
}
var Ho = /* @__PURE__ */ ((t) => (t.Any = "any", t.All = "all", t))(Ho || {}), kD = /* @__PURE__ */ ((t) => (t.Days = "days", t.Weeks = "weeks", t.Months = "months", t.Years = "years", t))(kD || {}), _D = /* @__PURE__ */ ((t) => (t.Days = "days", t.Weekdays = "weekdays", t.Weeks = "weeks", t.Months = "months", t.Years = "years", t))(_D || {}), SD = /* @__PURE__ */ ((t) => (t.OrdinalWeekdays = "ordinalWeekdays", t))(SD || {});
class Cfe {
  constructor(e, n, r) {
    xe(this, "validated", !0), this.type = e, this.interval = n, this.from = r, this.from || (console.error(
      'A valid "from" date is required for date interval rule. This rule will be skipped.'
    ), this.validated = !1);
  }
  passes(e) {
    if (!this.validated)
      return !0;
    const { date: n } = e;
    switch (this.type) {
      case "days":
        return By(this.from.date, n) % this.interval === 0;
      case "weeks":
        return Wfe(this.from.date, n) % this.interval === 0;
      case "months":
        return jfe(this.from.date, n) % this.interval === 0;
      case "years":
        return OD(this.from.date, n) % this.interval === 0;
      default:
        return !1;
    }
  }
}
class rl {
  constructor(e, n, r, i) {
    xe(this, "components", []), this.type = e, this.validator = r, this.getter = i, this.components = this.normalizeComponents(n);
  }
  static create(e, n) {
    switch (e) {
      case "days":
        return new $fe(n);
      case "weekdays":
        return new Afe(n);
      case "weeks":
        return new Dfe(n);
      case "months":
        return new Tfe(n);
      case "years":
        return new Ofe(n);
    }
  }
  normalizeComponents(e) {
    if (this.validator(e))
      return [e];
    if (!Kn(e))
      return [];
    const n = [];
    return e.forEach((r) => {
      if (!this.validator(r)) {
        console.error(
          `Component value ${r} in invalid for "${this.type}" rule. This rule will be skipped.`
        );
        return;
      }
      n.push(r);
    }), n;
  }
  passes(e) {
    return this.getter(e).some((i) => this.components.includes(i));
  }
}
class $fe extends rl {
  constructor(e) {
    super(
      "days",
      e,
      Lfe,
      ({ day: n, dayFromEnd: r }) => [n, -r]
    );
  }
}
class Afe extends rl {
  constructor(e) {
    super(
      "weekdays",
      e,
      mv,
      ({ weekday: n }) => [n]
    );
  }
}
class Dfe extends rl {
  constructor(e) {
    super(
      "weeks",
      e,
      Nfe,
      ({ week: n, weekFromEnd: r }) => [n, -r]
    );
  }
}
class Tfe extends rl {
  constructor(e) {
    super("months", e, Ife, ({ month: n }) => [
      n
    ]);
  }
}
class Ofe extends rl {
  constructor(e) {
    super("years", e, gr, ({ year: n }) => [n]);
  }
}
class Efe {
  constructor(e, n) {
    xe(this, "components"), this.type = e, this.components = this.normalizeComponents(n);
  }
  normalizeArrayConfig(e) {
    const n = [];
    return e.forEach((r, i) => {
      if (gr(r)) {
        if (i === 0)
          return;
        if (!v_(e[0])) {
          console.error(
            `Ordinal range for "${this.type}" rule is from -5 to -1 or 1 to 5. This rule will be skipped.`
          );
          return;
        }
        if (!mv(r)) {
          console.error(
            `Acceptable range for "${this.type}" rule is from 1 to 5. This rule will be skipped`
          );
          return;
        }
        n.push([e[0], r]);
      } else Kn(r) && n.push(...this.normalizeArrayConfig(r));
    }), n;
  }
  normalizeComponents(e) {
    const n = [];
    return e.forEach((r, i) => {
      if (gr(r)) {
        if (i === 0)
          return;
        if (!v_(e[0])) {
          console.error(
            `Ordinal range for "${this.type}" rule is from -5 to -1 or 1 to 5. This rule will be skipped.`
          );
          return;
        }
        if (!mv(r)) {
          console.error(
            `Acceptable range for "${this.type}" rule is from 1 to 5. This rule will be skipped`
          );
          return;
        }
        n.push([e[0], r]);
      } else Kn(r) && n.push(...this.normalizeArrayConfig(r));
    }), n;
  }
  passes(e) {
    const { weekday: n, weekdayOrdinal: r, weekdayOrdinalFromEnd: i } = e;
    return this.components.some(
      ([s, o]) => (s === r || s === -i) && n === o
    );
  }
}
class Pfe {
  constructor(e) {
    xe(this, "type", "function"), xe(this, "validated", !0), this.fn = e, Ao(e) || (console.error(
      "The function rule requires a valid function. This rule will be skipped."
    ), this.validated = !1);
  }
  passes(e) {
    return this.validated ? this.fn(e) : !0;
  }
}
class gd {
  constructor(e, n = {}, r) {
    xe(this, "validated", !0), xe(this, "config"), xe(this, "type", Ho.Any), xe(this, "from"), xe(this, "until"), xe(this, "rules", []), xe(this, "locale", new md()), this.parent = r, n.locale && (this.locale = n.locale), this.config = e, Ao(e) ? (this.type = Ho.All, this.rules = [new Pfe(e)]) : Kn(e) ? (this.type = Ho.Any, this.rules = e.map((i) => new gd(i, n, this))) : Ci(e) ? (this.type = Ho.All, this.from = e.from ? this.locale.getDateParts(e.from) : r == null ? void 0 : r.from, this.until = e.until ? this.locale.getDateParts(e.until) : r == null ? void 0 : r.until, this.rules = this.getObjectRules(e)) : (console.error("Rule group configuration must be an object or an array."), this.validated = !1);
  }
  getObjectRules(e) {
    const n = [];
    if (e.every && (Fr(e.every) && (e.every = [1, `${e.every}s`]), Kn(e.every))) {
      const [r = 1, i = kD.Days] = e.every;
      n.push(new Cfe(i, r, this.from));
    }
    return Object.values(_D).forEach((r) => {
      r in e && n.push(rl.create(r, e[r]));
    }), Object.values(SD).forEach((r) => {
      r in e && n.push(new Efe(r, e[r]));
    }), e.on != null && (Kn(e.on) || (e.on = [e.on]), n.push(
      new gd(e.on, { locale: this.locale }, this.parent)
    )), n;
  }
  passes(e) {
    return this.validated ? this.from && e.dayIndex <= this.from.dayIndex || this.until && e.dayIndex >= this.until.dayIndex ? !1 : this.type === Ho.Any ? this.rules.some((n) => n.passes(e)) : this.rules.every((n) => n.passes(e)) : !0;
  }
}
function Lfe(t) {
  return gr(t) ? t >= 1 && t <= 31 : !1;
}
function mv(t) {
  return gr(t) ? t >= 1 && t <= 7 : !1;
}
function Nfe(t) {
  return gr(t) ? t >= -6 && t <= -1 || t >= 1 && t <= 6 : !1;
}
function Ife(t) {
  return gr(t) ? t >= 1 && t <= 12 : !1;
}
function v_(t) {
  return !(!gr(t) || t < -5 || t > 5 || t === 0);
}
const Rfe = {
  dateTime: [
    "year",
    "month",
    "day",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
  ],
  date: ["year", "month", "day"],
  time: ["hours", "minutes", "seconds", "milliseconds"]
}, Rt = 7, Bfe = 6, MD = 1e3, CD = MD * 60, $D = CD * 60, Uf = $D * 24, Ffe = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], zfe = ["L", "iso"], Yl = {
  milliseconds: [0, 999, 3],
  seconds: [0, 59, 2],
  minutes: [0, 59, 2],
  hours: [0, 23, 2]
}, AD = /d{1,2}|W{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|Z{1,4}|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g, Vfe = /\[([^]*?)\]/gm, y_ = {
  D(t) {
    return t.day;
  },
  DD(t) {
    return We(t.day, 2);
  },
  // Do(d: DateParts, l: Locale) {
  //   return l.DoFn(d.day);
  // },
  d(t) {
    return t.weekday - 1;
  },
  dd(t) {
    return We(t.weekday - 1, 2);
  },
  W(t, e) {
    return e.dayNamesNarrow[t.weekday - 1];
  },
  WW(t, e) {
    return e.dayNamesShorter[t.weekday - 1];
  },
  WWW(t, e) {
    return e.dayNamesShort[t.weekday - 1];
  },
  WWWW(t, e) {
    return e.dayNames[t.weekday - 1];
  },
  M(t) {
    return t.month;
  },
  MM(t) {
    return We(t.month, 2);
  },
  MMM(t, e) {
    return e.monthNamesShort[t.month - 1];
  },
  MMMM(t, e) {
    return e.monthNames[t.month - 1];
  },
  YY(t) {
    return String(t.year).substr(2);
  },
  YYYY(t) {
    return We(t.year, 4);
  },
  h(t) {
    return t.hours % 12 || 12;
  },
  hh(t) {
    return We(t.hours % 12 || 12, 2);
  },
  H(t) {
    return t.hours;
  },
  HH(t) {
    return We(t.hours, 2);
  },
  m(t) {
    return t.minutes;
  },
  mm(t) {
    return We(t.minutes, 2);
  },
  s(t) {
    return t.seconds;
  },
  ss(t) {
    return We(t.seconds, 2);
  },
  S(t) {
    return Math.round(t.milliseconds / 100);
  },
  SS(t) {
    return We(Math.round(t.milliseconds / 10), 2);
  },
  SSS(t) {
    return We(t.milliseconds, 3);
  },
  a(t, e) {
    return t.hours < 12 ? e.amPm[0] : e.amPm[1];
  },
  A(t, e) {
    return t.hours < 12 ? e.amPm[0].toUpperCase() : e.amPm[1].toUpperCase();
  },
  Z() {
    return "Z";
  },
  ZZ(t) {
    const e = t.timezoneOffset;
    return `${e > 0 ? "-" : "+"}${We(Math.floor(Math.abs(e) / 60), 2)}`;
  },
  ZZZ(t) {
    const e = t.timezoneOffset;
    return `${e > 0 ? "-" : "+"}${We(
      Math.floor(Math.abs(e) / 60) * 100 + Math.abs(e) % 60,
      4
    )}`;
  },
  ZZZZ(t) {
    const e = t.timezoneOffset;
    return `${e > 0 ? "-" : "+"}${We(Math.floor(Math.abs(e) / 60), 2)}:${We(
      Math.abs(e) % 60,
      2
    )}`;
  }
}, Vi = /\d\d?/, Hfe = /\d{3}/, Yfe = /\d{4}/, kl = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF/]+(\s*?[\u0600-\u06FF]+){1,2}/i, b_ = () => {
}, x_ = (t) => (e, n, r) => {
  const i = r[t].indexOf(
    n.charAt(0).toUpperCase() + n.substr(1).toLowerCase()
  );
  ~i && (e.month = i);
}, Ue = {
  D: [
    Vi,
    (t, e) => {
      t.day = e;
    }
  ],
  Do: [
    new RegExp(Vi.source + kl.source),
    (t, e) => {
      t.day = parseInt(e, 10);
    }
  ],
  d: [Vi, b_],
  W: [kl, b_],
  M: [
    Vi,
    (t, e) => {
      t.month = e - 1;
    }
  ],
  MMM: [kl, x_("monthNamesShort")],
  MMMM: [kl, x_("monthNames")],
  YY: [
    Vi,
    (t, e) => {
      const r = +(/* @__PURE__ */ new Date()).getFullYear().toString().substr(0, 2);
      t.year = +`${e > 68 ? r - 1 : r}${e}`;
    }
  ],
  YYYY: [
    Yfe,
    (t, e) => {
      t.year = e;
    }
  ],
  S: [
    /\d/,
    (t, e) => {
      t.milliseconds = e * 100;
    }
  ],
  SS: [
    /\d{2}/,
    (t, e) => {
      t.milliseconds = e * 10;
    }
  ],
  SSS: [
    Hfe,
    (t, e) => {
      t.milliseconds = e;
    }
  ],
  h: [
    Vi,
    (t, e) => {
      t.hours = e;
    }
  ],
  m: [
    Vi,
    (t, e) => {
      t.minutes = e;
    }
  ],
  s: [
    Vi,
    (t, e) => {
      t.seconds = e;
    }
  ],
  a: [
    kl,
    (t, e, n) => {
      const r = e.toLowerCase();
      r === n.amPm[0] ? t.isPm = !1 : r === n.amPm[1] && (t.isPm = !0);
    }
  ],
  Z: [
    /[^\s]*?[+-]\d\d:?\d\d|[^\s]*?Z?/,
    (t, e) => {
      e === "Z" && (e = "+00:00");
      const n = `${e}`.match(/([+-]|\d\d)/gi);
      if (n) {
        const r = +n[1] * 60 + parseInt(n[2], 10);
        t.timezoneOffset = n[0] === "+" ? r : -r;
      }
    }
  ]
};
Ue.DD = Ue.D;
Ue.dd = Ue.d;
Ue.WWWW = Ue.WWW = Ue.WW = Ue.W;
Ue.MM = Ue.M;
Ue.mm = Ue.m;
Ue.hh = Ue.H = Ue.HH = Ue.h;
Ue.ss = Ue.s;
Ue.A = Ue.a;
Ue.ZZZZ = Ue.ZZZ = Ue.ZZ = Ue.Z;
function DD(t, e) {
  return (di(t) && t || [
    Fr(t) && t || "YYYY-MM-DD"
  ]).map(
    (n) => zfe.reduce(
      (r, i) => r.replace(i, e.masks[i] || ""),
      n
    )
  );
}
function Ry(t) {
  return Ci(t) && "year" in t && "month" in t && "day" in t;
}
function w_(t, e = 1) {
  const n = t.getDay() + 1, r = n >= e ? e - n : -(7 - (e - n));
  return Zt(t, r);
}
function TD(t, e, n) {
  const r = Date.UTC(t, e - 1, n);
  return By(/* @__PURE__ */ new Date(0), new Date(r));
}
function By(t, e) {
  return Math.round((e.getTime() - t.getTime()) / Uf);
}
function Wfe(t, e) {
  return Math.ceil(By(w_(t), w_(e)) / 7);
}
function OD(t, e) {
  return e.getUTCFullYear() - t.getUTCFullYear();
}
function jfe(t, e) {
  return OD(t, e) * 12 + (e.getMonth() - t.getMonth());
}
function ED(t, e = "") {
  const n = /* @__PURE__ */ new Date(), {
    year: r = n.getFullYear(),
    month: i = n.getMonth() + 1,
    day: s = n.getDate(),
    hours: o = 0,
    minutes: a = 0,
    seconds: l = 0,
    milliseconds: c = 0
  } = t;
  if (e) {
    const u = `${We(r, 4)}-${We(i, 2)}-${We(s, 2)}T${We(
      o,
      2
    )}:${We(a, 2)}:${We(l, 2)}.${We(c, 3)}`;
    return _ue(u, { timeZone: e });
  }
  return new Date(r, i - 1, s, o, a, l, c);
}
function qfe(t, e) {
  let n = new Date(t.getTime());
  e.timezone && (n = new Date(
    t.toLocaleString("en-US", { timeZone: e.timezone })
  ), n.setMilliseconds(t.getMilliseconds()));
  const r = n.getMilliseconds(), i = n.getSeconds(), s = n.getMinutes(), o = n.getHours(), a = r + i * MD + s * CD + o * $D, l = n.getMonth() + 1, c = n.getFullYear(), u = e.getMonthParts(l, c), h = n.getDate(), f = u.numDays - h + 1, d = n.getDay() + 1, p = Math.floor((h - 1) / 7 + 1), m = Math.floor((u.numDays - h) / 7 + 1), v = Math.ceil(
    (h + Math.abs(u.firstWeekday - u.firstDayOfWeek)) / 7
  ), g = u.numWeeks - v + 1, y = u.weeknumbers[v], x = TD(c, l, h);
  return {
    milliseconds: r,
    seconds: i,
    minutes: s,
    hours: o,
    time: a,
    day: h,
    dayFromEnd: f,
    weekday: d,
    weekdayOrdinal: p,
    weekdayOrdinalFromEnd: m,
    week: v,
    weekFromEnd: g,
    weeknumber: y,
    month: l,
    year: c,
    date: n,
    dateTime: n.getTime(),
    dayIndex: x,
    timezoneOffset: 0,
    isValid: !0
  };
}
function Ufe(t, e, n) {
  return `${e}-${t}-${n}`;
}
function Kfe(t, e, n) {
  const r = e % 4 === 0 && e % 100 !== 0 || e % 400 === 0, i = new Date(e, t - 1, 1), s = i.getDay() + 1, o = t === 2 && r ? 29 : Ffe[t - 1], a = n - 1, l = Iue(i, {
    weekStartsOn: a
  }), c = [], u = [];
  for (let h = 0; h < l; h++) {
    const f = Zt(i, h * 7);
    c.push(zue(f, { weekStartsOn: a })), u.push(Wue(f));
  }
  return {
    firstDayOfWeek: n,
    firstDayOfMonth: i,
    inLeapYear: r,
    firstWeekday: s,
    numDays: o,
    numWeeks: l,
    month: t,
    year: e,
    weeknumbers: c,
    isoWeeknumbers: u
  };
}
function Gfe() {
  const t = [];
  for (let i = 0; i < Rt; i++)
    t.push(
      ED({
        year: 2020,
        month: 1,
        day: 5 + i,
        hours: 12
      })
    );
  return t;
}
function Gm(t, e = void 0) {
  const n = new Intl.DateTimeFormat(e, {
    weekday: t
  });
  return Gfe().map((r) => n.format(r));
}
function Xfe() {
  const t = [];
  for (let e = 0; e <= 24; e++)
    t.push(new Date(2e3, 0, 1, e));
  return t;
}
function Zfe(t = void 0) {
  const e = [
    "second",
    "minute",
    "hour",
    "day",
    "week",
    "month",
    "quarter",
    "year"
  ], n = new Intl.RelativeTimeFormat(t);
  return e.reduce((r, i) => {
    const s = n.formatToParts(100, i);
    return r[i] = s[1].unit, r;
  }, {});
}
function PD() {
  const t = [];
  for (let e = 0; e < 12; e++)
    t.push(new Date(2e3, e, 15));
  return t;
}
function k_(t, e = void 0) {
  const n = new Intl.DateTimeFormat(e, {
    month: t,
    timeZone: "UTC"
  });
  return PD().map((r) => n.format(r));
}
function Jfe(t, e, n) {
  return gr(e) ? e === t : Kn(e) ? e.includes(t) : Ao(e) ? e(t, n) : !(e.min != null && e.min > t || e.max != null && e.max < t || e.interval != null && t % e.interval !== 0);
}
function Wl(t, e, n) {
  const r = [], [i, s, o] = e;
  for (let a = i; a <= s; a++)
    (n == null || Jfe(a, n, t)) && r.push({
      value: a,
      label: We(a, o)
    });
  return r;
}
function Qfe(t, e) {
  return {
    milliseconds: Wl(
      t,
      Yl.milliseconds,
      e.milliseconds
    ),
    seconds: Wl(t, Yl.seconds, e.seconds),
    minutes: Wl(t, Yl.minutes, e.minutes),
    hours: Wl(t, Yl.hours, e.hours)
  };
}
function ehe(t, e, n, r) {
  const s = Wl(t, e, r).reduce((o, a) => {
    if (a.disabled)
      return o;
    if (isNaN(o))
      return a.value;
    const l = Math.abs(o - n);
    return Math.abs(a.value - n) < l ? a.value : o;
  }, NaN);
  return isNaN(s) ? n : s;
}
function the(t, e) {
  const n = { ...t };
  return Object.entries(e).forEach(([r, i]) => {
    const s = Yl[r], o = t[r];
    n[r] = ehe(
      t,
      s,
      o,
      i
    );
  }), n;
}
function __(t, e, n) {
  return DD(e, n).map((i) => {
    if (typeof i != "string")
      throw new Error("Invalid mask");
    let s = t;
    if (s.length > 1e3)
      return !1;
    let o = !0;
    const a = {};
    if (i.replace(AD, (u) => {
      if (Ue[u]) {
        const h = Ue[u], f = s.search(h[0]);
        ~f ? s.replace(h[0], (d) => (h[1](a, d, n), s = s.substr(f + d.length), d)) : o = !1;
      }
      return Ue[u] ? "" : u.slice(1, u.length - 1);
    }), !o)
      return !1;
    const l = /* @__PURE__ */ new Date();
    a.hours != null && (a.isPm === !0 && +a.hours != 12 ? a.hours = +a.hours + 12 : a.isPm === !1 && +a.hours == 12 && (a.hours = 0));
    let c;
    return a.timezoneOffset != null ? (a.minutes = +(a.minutes || 0) - +a.timezoneOffset, c = new Date(
      Date.UTC(
        a.year || l.getFullYear(),
        a.month || 0,
        a.day || 1,
        a.hours || 0,
        a.minutes || 0,
        a.seconds || 0,
        a.milliseconds || 0
      )
    )) : c = n.getDateFromParts({
      year: a.year || l.getFullYear(),
      month: (a.month || 0) + 1,
      day: a.day || 1,
      hours: a.hours || 0,
      minutes: a.minutes || 0,
      seconds: a.seconds || 0,
      milliseconds: a.milliseconds || 0
    }), c;
  }).find((i) => i) || new Date(t);
}
function nhe(t, e, n) {
  if (t == null)
    return "";
  let r = DD(e, n)[0];
  /Z$/.test(r) && (n.timezone = "utc");
  const i = [];
  r = r.replace(Vfe, (o, a) => (i.push(a), "??"));
  const s = n.getDateParts(t);
  return r = r.replace(
    AD,
    (o) => o in y_ ? y_[o](s, n) : o.slice(1, o.length - 1)
  ), r.replace(/\?\?/g, () => i.shift());
}
let rhe = 0;
class LD {
  constructor(e, n, r) {
    xe(this, "key", ""), xe(this, "hashcode", ""), xe(this, "highlight", null), xe(this, "content", null), xe(this, "dot", null), xe(this, "bar", null), xe(this, "event", null), xe(this, "popover", null), xe(this, "customData", null), xe(this, "ranges"), xe(this, "hasRanges", !1), xe(this, "order", 0), xe(this, "pinPage", !1), xe(this, "maxRepeatSpan", 0), xe(this, "locale");
    const { dates: i } = Object.assign(
      this,
      { hashcode: "", order: 0, pinPage: !1 },
      e
    );
    this.key || (this.key = ++rhe), this.locale = r, n.normalizeGlyphs(this), this.ranges = r.ranges(i != null ? i : []), this.hasRanges = !!di(this.ranges), this.maxRepeatSpan = this.ranges.filter((s) => s.hasRepeat).map((s) => s.daySpan).reduce((s, o) => Math.max(s, o), 0);
  }
  intersectsRange({ start: e, end: n }) {
    if (e == null || n == null)
      return !1;
    const r = this.ranges.filter((o) => !o.hasRepeat);
    for (const o of r)
      if (o.intersectsDayRange(e.dayIndex, n.dayIndex))
        return !0;
    const i = this.ranges.filter((o) => o.hasRepeat);
    if (!i.length)
      return !1;
    let s = e;
    for (this.maxRepeatSpan > 1 && (s = this.locale.getDateParts(Zt(s.date, -this.maxRepeatSpan))); s.dayIndex <= n.dayIndex; ) {
      for (const o of i)
        if (o.startsOnDay(s))
          return !0;
      s = this.locale.getDateParts(Zt(s.date, 1));
    }
    return !1;
  }
}
function gv(t) {
  document && document.dispatchEvent(
    new CustomEvent("show-popover", {
      detail: t
    })
  );
}
function jc(t) {
  document && document.dispatchEvent(
    new CustomEvent("hide-popover", {
      detail: t
    })
  );
}
function ND(t) {
  document && document.dispatchEvent(
    new CustomEvent("toggle-popover", {
      detail: t
    })
  );
}
function ID(t) {
  const { visibility: e } = t, n = e === "click", r = e === "hover", i = e === "hover-focus", s = e === "focus";
  t.autoHide = !n;
  let o = !1, a = !1;
  const l = (p) => {
    n && (ND({
      ...t,
      target: t.target || p.currentTarget
    }), p.stopPropagation());
  }, c = (p) => {
    o || (o = !0, (r || i) && gv({
      ...t,
      target: t.target || p.currentTarget
    }));
  }, u = () => {
    o && (o = !1, (r || i && !a) && jc(t));
  }, h = (p) => {
    a || (a = !0, (s || i) && gv({
      ...t,
      target: t.target || p.currentTarget
    }));
  }, f = (p) => {
    a && !jf(p.currentTarget, p.relatedTarget) && (a = !1, (s || i && !o) && jc(t));
  }, d = {};
  switch (t.visibility) {
    case "click":
      d.click = l;
      break;
    case "hover":
      d.mousemove = c, d.mouseleave = u;
      break;
    case "focus":
      d.focusin = h, d.focusout = f;
      break;
    case "hover-focus":
      d.mousemove = c, d.mouseleave = u, d.focusin = h, d.focusout = f;
      break;
  }
  return d;
}
const S_ = (t) => {
  const e = cd(t);
  if (e == null)
    return;
  const n = e.popoverHandlers;
  !n || !n.length || (n.forEach((r) => r()), delete e.popoverHandlers);
}, M_ = (t, e) => {
  const n = cd(t);
  if (n == null)
    return;
  const r = [], i = ID(e);
  Object.entries(i).forEach(([s, o]) => {
    r.push(Ki(n, s, o));
  }), n.popoverHandlers = r;
}, RD = {
  mounted(t, e) {
    const { value: n } = e;
    n && M_(t, n);
  },
  updated(t, e) {
    const { oldValue: n, value: r } = e, i = n == null ? void 0 : n.visibility, s = r == null ? void 0 : r.visibility;
    i !== s && (i && (S_(t), s || jc(n)), s && M_(t, r));
  },
  unmounted(t) {
    S_(t);
  }
}, ihe = (t, e, {
  maxSwipeTime: n,
  minHorizontalSwipeDistance: r,
  maxVerticalSwipeDistance: i
}) => {
  if (!t || !t.addEventListener || !Ao(e))
    return null;
  let s = 0, o = 0, a = null, l = !1;
  function c(h) {
    const f = h.changedTouches[0];
    s = f.screenX, o = f.screenY, a = (/* @__PURE__ */ new Date()).getTime(), l = !0;
  }
  function u(h) {
    if (!l || !a)
      return;
    l = !1;
    const f = h.changedTouches[0], d = f.screenX - s, p = f.screenY - o;
    if ((/* @__PURE__ */ new Date()).getTime() - a < n && Math.abs(d) >= r && Math.abs(p) <= i) {
      const v = { toLeft: !1, toRight: !1 };
      d < 0 ? v.toLeft = !0 : v.toRight = !0, e(v);
    }
  }
  return Ki(t, "touchstart", c, { passive: !0 }), Ki(t, "touchend", u, { passive: !0 }), () => {
    Ui(t, "touchstart", c), Ui(t, "touchend", u);
  };
}, Kf = {}, she = (t, e = 10) => {
  Kf[t] = Date.now() + e;
}, ohe = (t, e) => {
  if (t in Kf) {
    const n = Kf[t];
    if (Date.now() < n)
      return;
    delete Kf[t];
  }
  e();
};
function BD() {
  return typeof window != "undefined";
}
function ahe(t) {
  return BD() && t in window;
}
function lhe(t) {
  const e = le(!1), n = T(() => e.value ? "dark" : "light");
  let r, i;
  function s(d) {
    e.value = d.matches;
  }
  function o() {
    ahe("matchMedia") && (r = window.matchMedia("(prefers-color-scheme: dark)"), r.addEventListener("change", s), e.value = r.matches);
  }
  function a() {
    const { selector: d = ":root", darkClass: p = "dark" } = t.value, m = document.querySelector(d);
    e.value = m.classList.contains(p);
  }
  function l(d) {
    const { selector: p = ":root", darkClass: m = "dark" } = d;
    if (BD() && p && m) {
      const v = document.querySelector(p);
      v && (i = new MutationObserver(a), i.observe(v, {
        attributes: !0,
        attributeFilter: ["class"]
      }), e.value = v.classList.contains(m));
    }
  }
  function c() {
    h();
    const d = typeof t.value;
    d === "string" && t.value.toLowerCase() === "system" ? o() : d === "object" ? l(t.value) : e.value = !!t.value;
  }
  const u = Se(() => t.value, () => c(), {
    immediate: !0
  });
  function h() {
    r && (r.removeEventListener("change", s), r = void 0), i && (i.disconnect(), i = void 0);
  }
  function f() {
    h(), u();
  }
  return bd(() => f()), {
    isDark: e,
    displayMode: n,
    cleanup: f
  };
}
const che = ["base", "start", "end", "startEnd"], uhe = [
  "class",
  "wrapperClass",
  "contentClass",
  "style",
  "contentStyle",
  "color",
  "fillMode"
], fhe = { base: {}, start: {}, end: {} };
function Fy(t, e, n = fhe) {
  let r = t, i = {};
  e === !0 || Fr(e) ? (r = Fr(e) ? e : r, i = { ...n }) : Ci(e) && (s_(e, che) ? i = { ...e } : i = {
    base: { ...e },
    start: { ...e },
    end: { ...e }
  });
  const s = Wc(
    i,
    { start: i.startEnd, end: i.startEnd },
    n
  );
  return Object.entries(s).forEach(([o, a]) => {
    let l = r;
    a === !0 || Fr(a) ? (l = Fr(a) ? a : l, s[o] = { color: l }) : Ci(a) && (s_(a, uhe) ? s[o] = { ...a } : s[o] = {}), Wc(s[o], { color: l });
  }), s;
}
class hhe {
  constructor() {
    xe(this, "type", "highlight");
  }
  normalizeConfig(e, n) {
    return Fy(e, n, {
      base: { fillMode: "light" },
      start: { fillMode: "solid" },
      end: { fillMode: "solid" }
    });
  }
  prepareRender(e) {
    e.highlights = [], e.content || (e.content = []);
  }
  render({ data: e, onStart: n, onEnd: r }, i) {
    const { key: s, highlight: o } = e;
    if (!o)
      return;
    const { highlights: a } = i, { base: l, start: c, end: u } = o;
    n && r ? a.push({
      ...c,
      key: s,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${c.color}`,
      class: [`vc-highlight vc-highlight-bg-${c.fillMode}`, c.class],
      contentClass: [
        `vc-attr vc-highlight-content-${c.fillMode} vc-${c.color}`,
        c.contentClass
      ]
    }) : n ? (a.push({
      ...l,
      key: `${s}-base`,
      wrapperClass: `vc-day-layer vc-day-box-right-center vc-attr vc-${l.color}`,
      class: [
        `vc-highlight vc-highlight-base-start vc-highlight-bg-${l.fillMode}`,
        l.class
      ]
    }), a.push({
      ...c,
      key: s,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${c.color}`,
      class: [`vc-highlight vc-highlight-bg-${c.fillMode}`, c.class],
      contentClass: [
        `vc-attr vc-highlight-content-${c.fillMode} vc-${c.color}`,
        c.contentClass
      ]
    })) : r ? (a.push({
      ...l,
      key: `${s}-base`,
      wrapperClass: `vc-day-layer vc-day-box-left-center vc-attr vc-${l.color}`,
      class: [
        `vc-highlight vc-highlight-base-end vc-highlight-bg-${l.fillMode}`,
        l.class
      ]
    }), a.push({
      ...u,
      key: s,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${u.color}`,
      class: [`vc-highlight vc-highlight-bg-${u.fillMode}`, u.class],
      contentClass: [
        `vc-attr vc-highlight-content-${u.fillMode} vc-${u.color}`,
        u.contentClass
      ]
    })) : a.push({
      ...l,
      key: `${s}-middle`,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${l.color}`,
      class: [
        `vc-highlight vc-highlight-base-middle vc-highlight-bg-${l.fillMode}`,
        l.class
      ],
      contentClass: [
        `vc-attr vc-highlight-content-${l.fillMode} vc-${l.color}`,
        l.contentClass
      ]
    });
  }
}
class zy {
  constructor(e, n) {
    xe(this, "type", ""), xe(this, "collectionType", ""), this.type = e, this.collectionType = n;
  }
  normalizeConfig(e, n) {
    return Fy(e, n);
  }
  prepareRender(e) {
    e[this.collectionType] = [];
  }
  render({ data: e, onStart: n, onEnd: r }, i) {
    const { key: s } = e, o = e[this.type];
    if (!s || !o)
      return;
    const a = i[this.collectionType], { base: l, start: c, end: u } = o;
    n ? a.push({
      ...c,
      key: s,
      class: [
        `vc-${this.type} vc-${this.type}-start vc-${c.color} vc-attr`,
        c.class
      ]
    }) : r ? a.push({
      ...u,
      key: s,
      class: [
        `vc-${this.type} vc-${this.type}-end vc-${u.color} vc-attr`,
        u.class
      ]
    }) : a.push({
      ...l,
      key: s,
      class: [
        `vc-${this.type} vc-${this.type}-base vc-${l.color} vc-attr`,
        l.class
      ]
    });
  }
}
class dhe extends zy {
  constructor() {
    super("content", "content");
  }
  normalizeConfig(e, n) {
    return Fy("base", n);
  }
}
class phe extends zy {
  constructor() {
    super("dot", "dots");
  }
}
class mhe extends zy {
  constructor() {
    super("bar", "bars");
  }
}
class ghe {
  constructor(e) {
    xe(this, "color"), xe(this, "renderers", [
      new dhe(),
      new hhe(),
      new phe(),
      new mhe()
    ]), this.color = e;
  }
  normalizeGlyphs(e) {
    this.renderers.forEach((n) => {
      const r = n.type;
      e[r] != null && (e[r] = n.normalizeConfig(this.color, e[r]));
    });
  }
  prepareRender(e = {}) {
    return this.renderers.forEach((n) => {
      n.prepareRender(e);
    }), e;
  }
  render(e, n) {
    this.renderers.forEach((r) => {
      r.render(e, n);
    });
  }
}
const FD = Symbol("__vc_base_context__"), zD = {
  color: {
    type: String,
    default: () => bs("color")
  },
  isDark: {
    type: [Boolean, String, Object],
    default: () => bs("isDark")
  },
  firstDayOfWeek: Number,
  masks: Object,
  locale: [String, Object],
  timezone: String,
  minDate: null,
  maxDate: null,
  disabledDates: null
};
function VD(t) {
  const e = T(() => {
    var f;
    return (f = t.color) != null ? f : "";
  }), n = T(() => {
    var f;
    return (f = t.isDark) != null ? f : !1;
  }), { displayMode: r } = lhe(n), i = T(() => new ghe(e.value)), s = T(() => {
    if (t.locale instanceof md)
      return t.locale;
    const f = Ci(t.locale) ? t.locale : {
      id: t.locale,
      firstDayOfWeek: t.firstDayOfWeek,
      masks: t.masks
    };
    return new md(f, t.timezone);
  }), o = T(() => s.value.masks), a = T(() => t.minDate), l = T(() => t.maxDate), c = T(() => {
    const f = t.disabledDates ? [...t.disabledDates] : [];
    return a.value != null && f.push({
      start: null,
      end: Zt(s.value.toDate(a.value), -1)
    }), l.value != null && f.push({
      start: Zt(s.value.toDate(l.value), 1),
      end: null
    }), s.value.ranges(f);
  }), u = T(() => new LD(
    {
      key: "disabled",
      dates: c.value,
      order: 100
    },
    i.value,
    s.value
  )), h = {
    color: e,
    isDark: n,
    displayMode: r,
    theme: i,
    locale: s,
    masks: o,
    minDate: a,
    maxDate: l,
    disabledDates: c,
    disabledAttribute: u
  };
  return qc(FD, h), h;
}
function vhe(t) {
  return Fa(FD, () => VD(t), !0);
}
function HD(t) {
  return `__vc_slot_${t}__`;
}
function YD(t, e = {}) {
  Object.keys(t).forEach((n) => {
    var r;
    qc(HD((r = e[n]) != null ? r : n), t[n]);
  });
}
function WD(t) {
  return Fa(HD(t), null);
}
const yhe = {
  ...zD,
  view: {
    type: String,
    default: "monthly",
    validator(t) {
      return ["daily", "weekly", "monthly"].includes(t);
    }
  },
  rows: {
    type: Number,
    default: 1
  },
  columns: {
    type: Number,
    default: 1
  },
  step: Number,
  titlePosition: {
    type: String,
    default: () => bs("titlePosition")
  },
  navVisibility: {
    type: String,
    default: () => bs("navVisibility")
  },
  showWeeknumbers: [Boolean, String],
  showIsoWeeknumbers: [Boolean, String],
  expanded: Boolean,
  borderless: Boolean,
  transparent: Boolean,
  initialPage: Object,
  initialPagePosition: { type: Number, default: 1 },
  minPage: Object,
  maxPage: Object,
  transition: String,
  attributes: Array,
  trimWeeks: Boolean,
  disablePageSwipe: Boolean
}, bhe = [
  "dayclick",
  "daymouseenter",
  "daymouseleave",
  "dayfocusin",
  "dayfocusout",
  "daykeydown",
  "weeknumberclick",
  "transition-start",
  "transition-end",
  "did-move",
  "update:view",
  "update:pages"
], jD = Symbol("__vc_calendar_context__");
function xhe(t, { slots: e, emit: n }) {
  const r = le(null), i = le(null), s = le((/* @__PURE__ */ new Date()).getDate()), o = le(!1), a = le(Symbol()), l = le(Symbol()), c = le(t.view), u = le([]), h = le("");
  let f = null, d = null;
  YD(e);
  const {
    theme: p,
    color: m,
    displayMode: v,
    locale: g,
    masks: y,
    minDate: x,
    maxDate: b,
    disabledAttribute: w,
    disabledDates: k
  } = vhe(t), _ = T(() => t.rows * t.columns), C = T(() => t.step || _.value), E = T(() => {
    var q;
    return (q = dD(u.value)) != null ? q : null;
  }), L = T(() => {
    var q;
    return (q = Ko(u.value)) != null ? q : null;
  }), M = T(
    () => t.minPage || (x.value ? I(x.value) : null)
  ), O = T(
    () => t.maxPage || (b.value ? I(b.value) : null)
  ), N = T(() => t.navVisibility), R = T(() => !!t.showWeeknumbers), $ = T(() => !!t.showIsoWeeknumbers), F = T(() => c.value === "monthly"), U = T(() => c.value === "weekly"), ee = T(() => c.value === "daily"), ie = () => {
    o.value = !0, n("transition-start");
  }, z = () => {
    o.value = !1, n("transition-end"), f && (f.resolve(!0), f = null);
  }, te = (q, ne, A = c.value) => xD(q, ne, A, g.value), I = (q) => bD(q, c.value, g.value), X = (q) => {
    !w.value || !Y.value || (q.isDisabled = Y.value.cellExists(
      w.value.key,
      q.dayIndex
    ));
  }, Q = (q) => {
    q.isFocusable = q.inMonth && q.day === s.value;
  }, ce = (q, ne) => {
    for (const A of q)
      for (const K of A.days)
        if (ne(K) === !1)
          return;
  }, he = T(
    () => u.value.reduce((q, ne) => (q.push(...ne.viewDays), q), [])
  ), J = T(() => {
    const q = [];
    return (t.attributes || []).forEach((ne, A) => {
      !ne || !ne.dates || q.push(
        new LD(
          {
            ...ne,
            order: ne.order || 0
          },
          p.value,
          g.value
        )
      );
    }), w.value && q.push(w.value), q;
  }), pe = T(() => di(J.value)), Y = T(() => {
    const q = new tfe();
    return J.value.forEach((ne) => {
      ne.ranges.forEach((A) => {
        q.render(ne, A, he.value);
      });
    }), q;
  }), se = T(() => he.value.reduce((q, ne) => (q[ne.dayIndex] = { day: ne, cells: [] }, q[ne.dayIndex].cells.push(...Y.value.getCells(ne)), q), {})), ge = (q, ne) => {
    const A = t.showWeeknumbers || t.showIsoWeeknumbers;
    return A == null ? "" : Mae(A) ? A ? "left" : "" : A.startsWith("right") ? ne > 1 ? "right" : A : q > 1 ? "left" : A;
  }, V = () => {
    var q, ne;
    if (!pe.value)
      return null;
    const A = J.value.find((Re) => Re.pinPage) || J.value[0];
    if (!A || !A.hasRanges)
      return null;
    const [K] = A.ranges, ue = ((q = K.start) == null ? void 0 : q.date) || ((ne = K.end) == null ? void 0 : ne.date);
    return ue ? I(ue) : null;
  }, Ee = () => {
    if (zr(E.value))
      return E.value;
    const q = V();
    return zr(q) ? q : I(/* @__PURE__ */ new Date());
  }, ke = (q, ne = {}) => {
    const { view: A = c.value, position: K = 1, force: ue } = ne, Re = K > 0 ? 1 - K : -(_.value + K);
    let et = te(q, Re, A), vn = te(et, _.value - 1, A);
    return ue || (dv(et, M.value) ? et = M.value : pd(vn, O.value) && (et = te(O.value, 1 - _.value)), vn = te(et, _.value - 1)), { fromPage: et, toPage: vn };
  }, Ie = (q, ne, A = "") => {
    if (A === "none" || A === "fade")
      return A;
    if ((q == null ? void 0 : q.view) !== (ne == null ? void 0 : ne.view))
      return "fade";
    const K = pd(ne, q), ue = dv(ne, q);
    return !K && !ue ? "fade" : A === "slide-v" ? ue ? "slide-down" : "slide-up" : ue ? "slide-right" : "slide-left";
  }, He = (q = {}) => new Promise((ne, A) => {
    const { position: K = 1, force: ue = !1, transition: Re } = q, et = zr(q.page) ? q.page : Ee(), { fromPage: vn } = ke(et, {
      position: K,
      force: ue
    }), yn = [];
    for (let sr = 0; sr < _.value; sr++) {
      const Dp = te(vn, sr), sl = sr + 1, bn = Math.ceil(sl / t.columns), jy = t.rows - bn + 1, Eo = sl % t.columns || t.columns, Eu = t.columns - Eo + 1, Pu = ge(Eo, Eu);
      yn.push(
        g.value.getPage({
          ...Dp,
          view: c.value,
          titlePosition: t.titlePosition,
          trimWeeks: t.trimWeeks,
          position: sl,
          row: bn,
          rowFromEnd: jy,
          column: Eo,
          columnFromEnd: Eu,
          showWeeknumbers: R.value,
          showIsoWeeknumbers: $.value,
          weeknumberPosition: Pu
        })
      );
    }
    h.value = Ie(
      u.value[0],
      yn[0],
      Re
    ), u.value = yn, h.value && h.value !== "none" ? f = {
      resolve: ne,
      reject: A
    } : ne(!0);
  }), st = (q) => {
    var A;
    const ne = (A = E.value) != null ? A : I(/* @__PURE__ */ new Date());
    return te(ne, q);
  }, gn = (q, ne = {}) => {
    const A = zr(q) ? q : I(q);
    return Object.assign(
      ne,
      ke(A, {
        ...ne,
        force: !0
      })
    ), Jue(
      ne.fromPage,
      ne.toPage,
      c.value,
      g.value
    ).map((ue) => Xue(ue, M.value, O.value)).some((ue) => ue);
  }, ir = (q, ne = {}) => gn(st(q), ne), Mt = T(() => ir(-C.value)), Li = T(() => ir(C.value)), Ni = async (q, ne = {}) => !ne.force && !gn(q, ne) ? !1 : (ne.fromPage && !Zue(ne.fromPage, E.value) && (jc({ id: a.value, hideDelay: 0 }), ne.view && (she("view", 10), c.value = ne.view), await He({
    ...ne,
    page: ne.fromPage,
    position: 1,
    force: !0
  }), n("did-move", u.value)), !0), Ii = (q, ne = {}) => Ni(st(q), ne), Ri = () => Ii(-C.value), Bi = () => Ii(C.value), Fi = (q) => {
    const ne = F.value ? ".in-month" : "", A = `.id-${g.value.getDayId(q)}${ne}`, K = `${A}.vc-focusable, ${A} .vc-focusable`, ue = r.value;
    if (ue) {
      const Re = ue.querySelector(K);
      if (Re)
        return Re.focus(), !0;
    }
    return !1;
  }, Es = async (q, ne = {}) => Fi(q) ? !0 : (await Ni(q, ne), Fi(q)), Oo = (q, ne) => {
    s.value = q.day, n("dayclick", q, ne);
  }, Cp = (q, ne) => {
    n("daymouseenter", q, ne);
  }, il = (q, ne) => {
    n("daymouseleave", q, ne);
  }, $p = (q, ne) => {
    s.value = q.day, i.value = q, q.isFocused = !0, n("dayfocusin", q, ne);
  }, Au = (q, ne) => {
    i.value = null, q.isFocused = !1, n("dayfocusout", q, ne);
  }, Du = (q, ne) => {
    n("daykeydown", q, ne);
    const A = q.noonDate;
    let K = null;
    switch (ne.key) {
      case "ArrowLeft": {
        K = Zt(A, -1);
        break;
      }
      case "ArrowRight": {
        K = Zt(A, 1);
        break;
      }
      case "ArrowUp": {
        K = Zt(A, -7);
        break;
      }
      case "ArrowDown": {
        K = Zt(A, 7);
        break;
      }
      case "Home": {
        K = Zt(A, -q.weekdayPosition + 1);
        break;
      }
      case "End": {
        K = Zt(A, q.weekdayPositionFromEnd);
        break;
      }
      case "PageUp": {
        ne.altKey ? K = m_(A, -1) : K = dd(A, -1);
        break;
      }
      case "PageDown": {
        ne.altKey ? K = m_(A, 1) : K = dd(A, 1);
        break;
      }
    }
    K && (ne.preventDefault(), Es(K).catch());
  }, Ap = (q) => {
    const ne = i.value;
    ne != null && Du(ne, q);
  }, Tu = (q, ne) => {
    n("weeknumberclick", q, ne);
  };
  He({
    page: t.initialPage,
    position: t.initialPagePosition
  }), rn(() => {
    !t.disablePageSwipe && r.value && (d = ihe(
      r.value,
      ({ toLeft: q = !1, toRight: ne = !1 }) => {
        q ? Bi() : ne && Ri();
      },
      bs("touch")
    ));
  }), bd(() => {
    u.value = [], d && d();
  }), Se(
    () => g.value,
    () => {
      He();
    }
  ), Se(
    () => _.value,
    () => He()
  ), Se(
    () => t.view,
    () => c.value = t.view
  ), Se(
    () => c.value,
    () => {
      ohe("view", () => {
        He();
      }), n("update:view", c.value);
    }
  ), Se(
    () => s.value,
    () => {
      ce(u.value, (q) => Q(q));
    }
  ), lc(() => {
    n("update:pages", u.value), ce(u.value, (q) => {
      X(q), Q(q);
    });
  });
  const Ou = {
    emit: n,
    containerRef: r,
    focusedDay: i,
    inTransition: o,
    navPopoverId: a,
    dayPopoverId: l,
    view: c,
    pages: u,
    transitionName: h,
    theme: p,
    color: m,
    displayMode: v,
    locale: g,
    masks: y,
    attributes: J,
    disabledAttribute: w,
    disabledDates: k,
    attributeContext: Y,
    days: he,
    dayCells: se,
    count: _,
    step: C,
    firstPage: E,
    lastPage: L,
    canMovePrev: Mt,
    canMoveNext: Li,
    minPage: M,
    maxPage: O,
    isMonthly: F,
    isWeekly: U,
    isDaily: ee,
    navVisibility: N,
    showWeeknumbers: R,
    showIsoWeeknumbers: $,
    getDateAddress: I,
    canMove: gn,
    canMoveBy: ir,
    move: Ni,
    moveBy: Ii,
    movePrev: Ri,
    moveNext: Bi,
    onTransitionBeforeEnter: ie,
    onTransitionAfterEnter: z,
    tryFocusDate: Fi,
    focusDate: Es,
    onKeydown: Ap,
    onDayKeydown: Du,
    onDayClick: Oo,
    onDayMouseenter: Cp,
    onDayMouseleave: il,
    onDayFocusin: $p,
    onDayFocusout: Au,
    onWeeknumberClick: Tu
  };
  return qc(jD, Ou), Ou;
}
function To() {
  const t = Fa(jD);
  if (t)
    return t;
  throw new Error(
    "Calendar context missing. Please verify this component is nested within a valid context provider."
  );
}
const whe = oe({
  inheritAttrs: !1,
  emits: ["before-show", "after-show", "before-hide", "after-hide"],
  props: {
    id: { type: [Number, String, Symbol], required: !0 },
    showDelay: { type: Number, default: 0 },
    hideDelay: { type: Number, default: 110 },
    boundarySelector: { type: String }
  },
  setup(t, { emit: e }) {
    let n;
    const r = le();
    let i = null, s = null;
    const o = yd({
      isVisible: !1,
      target: null,
      data: null,
      transition: "slide-fade",
      placement: "bottom",
      direction: "",
      positionFixed: !1,
      modifiers: [],
      isInteractive: !0,
      visibility: "click",
      isHovered: !1,
      isFocused: !1,
      autoHide: !1,
      force: !1
    });
    function a(z) {
      z && (o.direction = z.split("-")[0]);
    }
    function l({ placement: z, options: te }) {
      a(z || (te == null ? void 0 : te.placement));
    }
    const c = T(() => ({
      placement: o.placement,
      strategy: o.positionFixed ? "fixed" : "absolute",
      boundary: "",
      modifiers: [
        {
          name: "onUpdate",
          enabled: !0,
          phase: "afterWrite",
          fn: l
        },
        ...o.modifiers || []
      ],
      onFirstUpdate: l
    })), u = T(() => {
      const z = o.direction === "left" || o.direction === "right";
      let te = "";
      if (o.placement) {
        const I = o.placement.split("-");
        I.length > 1 && (te = I[1]);
      }
      return ["start", "top", "left"].includes(te) ? z ? "top" : "left" : ["end", "bottom", "right"].includes(te) ? z ? "bottom" : "right" : z ? "middle" : "center";
    });
    function h() {
      s && (s.destroy(), s = null);
    }
    function f() {
      gt(() => {
        const z = cd(o.target);
        !z || !r.value || (s && s.state.elements.reference !== z && h(), s ? s.update() : s = pJ(
          z,
          r.value,
          c.value
        ));
      });
    }
    function d(z) {
      Object.assign(o, mD(z, "force"));
    }
    function p(z, te) {
      clearTimeout(n), z > 0 ? n = setTimeout(te, z) : te();
    }
    function m(z) {
      return !z || !s ? !1 : cd(z) === s.state.elements.reference;
    }
    async function v(z = {}) {
      var te;
      o.force || (z.force && (o.force = !0), p((te = z.showDelay) != null ? te : t.showDelay, () => {
        o.isVisible && (o.force = !1), d({
          ...z,
          isVisible: !0
        }), f();
      }));
    }
    function g(z = {}) {
      var te;
      s && (z.target && !m(z.target) || o.force || (z.force && (o.force = !0), p((te = z.hideDelay) != null ? te : t.hideDelay, () => {
        o.isVisible || (o.force = !1), o.isVisible = !1;
      })));
    }
    function y(z = {}) {
      z.target != null && (o.isVisible && m(z.target) ? g(z) : v(z));
    }
    function x(z) {
      if (!s)
        return;
      const te = s.state.elements.reference;
      if (!r.value || !te)
        return;
      const I = z.target;
      jf(r.value, I) || jf(te, I) || g({ force: !0 });
    }
    function b(z) {
      (z.key === "Esc" || z.key === "Escape") && g();
    }
    function w({ detail: z }) {
      !z.id || z.id !== t.id || v(z);
    }
    function k({ detail: z }) {
      !z.id || z.id !== t.id || g(z);
    }
    function _({ detail: z }) {
      !z.id || z.id !== t.id || y(z);
    }
    function C() {
      Ki(document, "keydown", b), Ki(document, "click", x), Ki(document, "show-popover", w), Ki(document, "hide-popover", k), Ki(document, "toggle-popover", _);
    }
    function E() {
      Ui(document, "keydown", b), Ui(document, "click", x), Ui(document, "show-popover", w), Ui(document, "hide-popover", k), Ui(document, "toggle-popover", _);
    }
    function L(z) {
      e("before-show", z);
    }
    function M(z) {
      o.force = !1, e("after-show", z);
    }
    function O(z) {
      e("before-hide", z);
    }
    function N(z) {
      o.force = !1, h(), e("after-hide", z);
    }
    function R(z) {
      z.stopPropagation();
    }
    function $() {
      o.isHovered = !0, o.isInteractive && ["hover", "hover-focus"].includes(o.visibility) && v();
    }
    function F() {
      if (o.isHovered = !1, !s)
        return;
      const z = s.state.elements.reference;
      o.autoHide && !o.isFocused && (!z || z !== document.activeElement) && ["hover", "hover-focus"].includes(o.visibility) && g();
    }
    function U() {
      o.isFocused = !0, o.isInteractive && ["focus", "hover-focus"].includes(o.visibility) && v();
    }
    function ee(z) {
      ["focus", "hover-focus"].includes(o.visibility) && (!z.relatedTarget || !jf(r.value, z.relatedTarget)) && (o.isFocused = !1, !o.isHovered && o.autoHide && g());
    }
    function ie() {
      i != null && (i.disconnect(), i = null);
    }
    return Se(
      () => r.value,
      (z) => {
        ie(), z && (i = new ResizeObserver(() => {
          s && s.update();
        }), i.observe(z));
      }
    ), Se(() => o.placement, a, {
      immediate: !0
    }), rn(() => {
      C();
    }), bd(() => {
      h(), ie(), E();
    }), {
      ...H_(o),
      popoverRef: r,
      alignment: u,
      hide: g,
      setupPopper: f,
      beforeEnter: L,
      afterEnter: M,
      beforeLeave: O,
      afterLeave: N,
      onClick: R,
      onMouseOver: $,
      onMouseLeave: F,
      onFocusIn: U,
      onFocusOut: ee
    };
  }
}), Os = (t, e) => {
  const n = t.__vccOpts || t;
  for (const [r, i] of e)
    n[r] = i;
  return n;
};
function khe(t, e, n, r, i, s) {
  return S(), D("div", {
    class: j(["vc-popover-content-wrapper", { "is-interactive": t.isInteractive }]),
    ref: "popoverRef",
    onClick: e[0] || (e[0] = (...o) => t.onClick && t.onClick(...o)),
    onMouseover: e[1] || (e[1] = (...o) => t.onMouseOver && t.onMouseOver(...o)),
    onMouseleave: e[2] || (e[2] = (...o) => t.onMouseLeave && t.onMouseLeave(...o)),
    onFocusin: e[3] || (e[3] = (...o) => t.onFocusIn && t.onFocusIn(...o)),
    onFocusout: e[4] || (e[4] = (...o) => t.onFocusOut && t.onFocusOut(...o))
  }, [
    re(Gn, {
      name: `vc-${t.transition}`,
      appear: "",
      onBeforeEnter: t.beforeEnter,
      onAfterEnter: t.afterEnter,
      onBeforeLeave: t.beforeLeave,
      onAfterLeave: t.afterLeave
    }, {
      default: G(() => [
        t.isVisible ? (S(), D("div", Nt({
          key: 0,
          tabindex: "-1",
          class: `vc-popover-content direction-${t.direction}`
        }, t.$attrs), [
          H(t.$slots, "default", {
            direction: t.direction,
            alignment: t.alignment,
            data: t.data,
            hide: t.hide
          }, () => [
            ft(Pe(t.data), 1)
          ]),
          B("span", {
            class: j([
              "vc-popover-caret",
              `direction-${t.direction}`,
              `align-${t.alignment}`
            ])
          }, null, 2)
        ], 16)) : Z("", !0)
      ]),
      _: 3
    }, 8, ["name", "onBeforeEnter", "onAfterEnter", "onBeforeLeave", "onAfterLeave"])
  ], 34);
}
const Vy = /* @__PURE__ */ Os(whe, [["render", khe]]), _he = { class: "vc-day-popover-row" }, She = {
  key: 0,
  class: "vc-day-popover-row-indicator"
}, Mhe = { class: "vc-day-popover-row-label" }, Che = /* @__PURE__ */ oe({
  __name: "PopoverRow",
  props: {
    attribute: null
  },
  setup(t) {
    const e = t, n = T(() => {
      const { content: r, highlight: i, dot: s, bar: o, popover: a } = e.attribute;
      return a && a.hideIndicator ? null : r ? {
        class: `vc-bar vc-day-popover-row-bar vc-attr vc-${r.base.color}`
      } : i ? {
        class: `vc-highlight-bg-solid vc-day-popover-row-highlight vc-attr vc-${i.base.color}`
      } : s ? {
        class: `vc-dot vc-attr vc-${s.base.color}`
      } : o ? {
        class: `vc-bar vc-day-popover-row-bar vc-attr vc-${o.base.color}`
      } : null;
    });
    return (r, i) => (S(), D("div", _he, [
      P(n) ? (S(), D("div", She, [
        B("span", {
          class: j(P(n).class)
        }, null, 2)
      ])) : Z("", !0),
      B("div", Mhe, [
        H(r.$slots, "default", {}, () => [
          ft(Pe(t.attribute.popover ? t.attribute.popover.label : "No content provided"), 1)
        ])
      ])
    ]));
  }
}), $he = {
  inheritAttrs: !1
}, Hn = /* @__PURE__ */ oe({
  ...$he,
  __name: "CalendarSlot",
  props: {
    name: null
  },
  setup(t) {
    const n = WD(t.name);
    return (r, i) => P(n) ? (S(), ye(ht(P(n)), Ct(Nt({ key: 0 }, r.$attrs)), null, 16)) : H(r.$slots, "default", { key: 1 });
  }
}), Ahe = { class: "vc-day-popover-container" }, Dhe = {
  key: 0,
  class: "vc-day-popover-header"
}, The = /* @__PURE__ */ oe({
  __name: "CalendarDayPopover",
  setup(t) {
    const { dayPopoverId: e, displayMode: n, color: r, masks: i, locale: s } = To();
    function o(l, c) {
      return s.value.formatDate(l, c);
    }
    function a(l) {
      return s.value.formatDate(l.date, i.value.dayPopover);
    }
    return (l, c) => (S(), ye(Vy, {
      id: P(e),
      class: j([`vc-${P(r)}`, `vc-${P(n)}`])
    }, {
      default: G(({ data: { day: u, attributes: h }, hide: f }) => [
        re(Hn, {
          name: "day-popover",
          day: u,
          "day-title": a(u),
          attributes: h,
          format: o,
          masks: P(i),
          hide: f
        }, {
          default: G(() => [
            B("div", Ahe, [
              P(i).dayPopover ? (S(), D("div", Dhe, Pe(a(u)), 1)) : Z("", !0),
              (S(!0), D(_e, null, Fe(h, (d) => (S(), ye(Che, {
                key: d.key,
                attribute: d
              }, null, 8, ["attribute"]))), 128))
            ])
          ]),
          _: 2
        }, 1032, ["day", "day-title", "attributes", "masks", "hide"])
      ]),
      _: 1
    }, 8, ["id", "class"]));
  }
}), Ohe = {}, Ehe = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, Phe = /* @__PURE__ */ B("polyline", { points: "9 18 15 12 9 6" }, null, -1), Lhe = [
  Phe
];
function Nhe(t, e) {
  return S(), D("svg", Ehe, Lhe);
}
const Ihe = /* @__PURE__ */ Os(Ohe, [["render", Nhe]]), Rhe = {}, Bhe = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, Fhe = /* @__PURE__ */ B("polyline", { points: "15 18 9 12 15 6" }, null, -1), zhe = [
  Fhe
];
function Vhe(t, e) {
  return S(), D("svg", Bhe, zhe);
}
const Hhe = /* @__PURE__ */ Os(Rhe, [["render", Vhe]]), Yhe = {}, Whe = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, jhe = /* @__PURE__ */ B("polyline", { points: "6 9 12 15 18 9" }, null, -1), qhe = [
  jhe
];
function Uhe(t, e) {
  return S(), D("svg", Whe, qhe);
}
const Khe = /* @__PURE__ */ Os(Yhe, [["render", Uhe]]), Ghe = {}, Xhe = {
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
}, Zhe = /* @__PURE__ */ B("path", { d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" }, null, -1), Jhe = [
  Zhe
];
function Qhe(t, e) {
  return S(), D("svg", Xhe, Jhe);
}
const ede = /* @__PURE__ */ Os(Ghe, [["render", Qhe]]), tde = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IconChevronDown: Khe,
  IconChevronLeft: Hhe,
  IconChevronRight: Ihe,
  IconClock: ede
}, Symbol.toStringTag, { value: "Module" })), Ra = /* @__PURE__ */ oe({
  __name: "BaseIcon",
  props: {
    name: { type: String, required: !0 },
    width: { type: String },
    height: { type: String },
    size: { type: String, default: "26" },
    viewBox: { type: String }
  },
  setup(t) {
    const e = t, n = T(() => e.width || e.size), r = T(() => e.height || e.size), i = T(() => tde[`Icon${e.name}`]);
    return (s, o) => (S(), ye(ht(P(i)), {
      width: P(n),
      height: P(r),
      class: "vc-base-icon"
    }, null, 8, ["width", "height"]));
  }
}), nde = ["disabled"], rde = {
  key: 1,
  class: "vc-title-wrapper"
}, ide = {
  type: "button",
  class: "vc-title"
}, sde = ["disabled"], qD = /* @__PURE__ */ oe({
  __name: "CalendarHeader",
  props: {
    page: null,
    layout: null,
    isLg: { type: Boolean },
    isXl: { type: Boolean },
    is2xl: { type: Boolean },
    hideTitle: { type: Boolean },
    hideArrows: { type: Boolean }
  },
  setup(t) {
    const e = t, {
      navPopoverId: n,
      navVisibility: r,
      canMovePrev: i,
      movePrev: s,
      canMoveNext: o,
      moveNext: a
    } = To(), l = T(() => {
      switch (e.page.titlePosition) {
        case "left":
          return "bottom-start";
        case "right":
          return "bottom-end";
        default:
          return "bottom";
      }
    }), c = T(() => {
      const { page: m } = e;
      return {
        id: n.value,
        visibility: r.value,
        placement: l.value,
        modifiers: [{ name: "flip", options: { fallbackPlacements: ["bottom"] } }],
        data: { page: m },
        isInteractive: !0
      };
    }), u = T(() => e.page.titlePosition.includes("left")), h = T(() => e.page.titlePosition.includes("right")), f = T(() => e.layout ? e.layout : u.value ? "tu-pn" : h.value ? "pn-tu" : "p-tu-n;"), d = T(() => ({
      prev: f.value.includes("p") && !e.hideArrows,
      title: f.value.includes("t") && !e.hideTitle,
      next: f.value.includes("n") && !e.hideArrows
    })), p = T(() => ({ gridTemplateColumns: f.value.split("").map((v) => {
      switch (v) {
        case "p":
          return "[prev] auto";
        case "n":
          return "[next] auto";
        case "t":
          return "[title] auto";
        case "-":
          return "1fr";
        default:
          return "";
      }
    }).join(" ") }));
    return (m, v) => (S(), D("div", {
      class: j(["vc-header", { "is-lg": t.isLg, "is-xl": t.isXl, "is-2xl": t.is2xl }]),
      style: yt(P(p))
    }, [
      P(d).prev ? (S(), D("button", {
        key: 0,
        type: "button",
        class: "vc-arrow vc-prev vc-focus",
        disabled: !P(i),
        onClick: v[0] || (v[0] = //@ts-ignore
        (...g) => P(s) && P(s)(...g)),
        onKeydown: v[1] || (v[1] = Yt(
          //@ts-ignore
          (...g) => P(s) && P(s)(...g),
          ["space", "enter"]
        ))
      }, [
        re(Hn, {
          name: "header-prev-button",
          disabled: !P(i)
        }, {
          default: G(() => [
            re(Ra, {
              name: "ChevronLeft",
              size: "24"
            })
          ]),
          _: 1
        }, 8, ["disabled"])
      ], 40, nde)) : Z("", !0),
      P(d).title ? (S(), D("div", rde, [
        re(Hn, { name: "header-title-wrapper" }, {
          default: G(() => [
            Yn((S(), D("button", ide, [
              re(Hn, {
                name: "header-title",
                title: t.page.title
              }, {
                default: G(() => [
                  B("span", null, Pe(t.page.title), 1)
                ]),
                _: 1
              }, 8, ["title"])
            ])), [
              [P(RD), P(c)]
            ])
          ]),
          _: 1
        })
      ])) : Z("", !0),
      P(d).next ? (S(), D("button", {
        key: 2,
        type: "button",
        class: "vc-arrow vc-next vc-focus",
        disabled: !P(o),
        onClick: v[2] || (v[2] = //@ts-ignore
        (...g) => P(a) && P(a)(...g)),
        onKeydown: v[3] || (v[3] = Yt(
          //@ts-ignore
          (...g) => P(a) && P(a)(...g),
          ["space", "enter"]
        ))
      }, [
        re(Hn, {
          name: "header-next-button",
          disabled: !P(o)
        }, {
          default: G(() => [
            re(Ra, {
              name: "ChevronRight",
              size: "24"
            })
          ]),
          _: 1
        }, 8, ["disabled"])
      ], 40, sde)) : Z("", !0)
    ], 6));
  }
}), UD = Symbol("__vc_page_context__");
function ode(t) {
  const { locale: e, getDateAddress: n, canMove: r } = To();
  function i(a, l) {
    const { month: c, year: u } = n(/* @__PURE__ */ new Date());
    return PD().map((h, f) => {
      const d = f + 1;
      return {
        month: d,
        year: a,
        id: Gue(d, a),
        label: e.value.formatDate(h, l),
        ariaLabel: e.value.formatDate(h, "MMMM"),
        isActive: d === t.value.month && a === t.value.year,
        isCurrent: d === c && a === u,
        isDisabled: !r(
          { month: d, year: a },
          { position: t.value.position }
        )
      };
    });
  }
  function s(a, l) {
    const { year: c } = n(/* @__PURE__ */ new Date()), { position: u } = t.value, h = [];
    for (let f = a; f <= l; f += 1) {
      const d = [...Array(12).keys()].some(
        (p) => r({ month: p + 1, year: f }, { position: u })
      );
      h.push({
        year: f,
        id: f.toString(),
        label: f.toString(),
        ariaLabel: f.toString(),
        isActive: f === t.value.year,
        isCurrent: f === c,
        isDisabled: !d
      });
    }
    return h;
  }
  const o = { page: t, getMonthItems: i, getYearItems: s };
  return qc(UD, o), o;
}
function KD() {
  const t = Fa(UD);
  if (t)
    return t;
  throw new Error(
    "Page context missing. Please verify this component is nested within a valid context provider."
  );
}
const ade = { class: "vc-nav-header" }, lde = ["disabled"], cde = ["disabled"], ude = { class: "vc-nav-items" }, fde = ["data-id", "aria-label", "disabled", "onClick", "onKeydown"], hde = /* @__PURE__ */ oe({
  __name: "CalendarNav",
  setup(t) {
    const { masks: e, move: n } = To(), { page: r, getMonthItems: i, getYearItems: s } = KD(), o = le(!0), a = 12, l = le(r.value.year), c = le(f(r.value.year)), u = le(null);
    function h() {
      setTimeout(() => {
        if (u.value == null)
          return;
        const I = u.value.querySelector(
          ".vc-nav-item:not(:disabled)"
        );
        I && I.focus();
      }, 10);
    }
    function f(I) {
      return Math.floor(I / a);
    }
    function d() {
      o.value = !o.value;
    }
    function p(I) {
      return I * a;
    }
    function m(I) {
      return a * (I + 1) - 1;
    }
    function v() {
      U.value && (o.value && y(), b());
    }
    function g() {
      ee.value && (o.value && x(), w());
    }
    function y() {
      l.value--;
    }
    function x() {
      l.value++;
    }
    function b() {
      c.value--;
    }
    function w() {
      c.value++;
    }
    const k = T(
      () => i(l.value, e.value.navMonths).map((I) => ({
        ...I,
        click: () => n(
          { month: I.month, year: I.year },
          { position: r.value.position }
        )
      }))
    ), _ = T(
      () => i(l.value - 1, e.value.navMonths)
    ), C = T(
      () => _.value.some((I) => !I.isDisabled)
    ), E = T(
      () => i(l.value + 1, e.value.navMonths)
    ), L = T(
      () => E.value.some((I) => !I.isDisabled)
    ), M = T(
      () => s(
        p(c.value),
        m(c.value)
      ).map((I) => ({
        ...I,
        click: () => {
          l.value = I.year, o.value = !0, h();
        }
      }))
    ), O = T(
      () => s(
        p(c.value - 1),
        m(c.value - 1)
      )
    ), N = T(
      () => O.value.some((I) => !I.isDisabled)
    ), R = T(
      () => s(
        p(c.value + 1),
        m(c.value + 1)
      )
    ), $ = T(
      () => R.value.some((I) => !I.isDisabled)
    ), F = T(
      () => o.value ? k.value : M.value
    ), U = T(
      () => o.value ? C.value : N.value
    ), ee = T(
      () => o.value ? L.value : $.value
    ), ie = T(() => dD(M.value.map((I) => I.year))), z = T(() => Ko(M.value.map((I) => I.year))), te = T(() => o.value ? l.value : `${ie.value} - ${z.value}`);
    return lc(() => {
      l.value = r.value.year, h();
    }), Se(
      () => l.value,
      (I) => c.value = f(I)
    ), rn(() => h()), (I, X) => (S(), D("div", {
      class: "vc-nav-container",
      ref_key: "navContainer",
      ref: u
    }, [
      B("div", ade, [
        B("button", {
          type: "button",
          class: "vc-nav-arrow is-left vc-focus",
          disabled: !P(U),
          onClick: v,
          onKeydown: X[0] || (X[0] = (Q) => P(Mf)(Q, v))
        }, [
          re(Hn, {
            name: "nav-prev-button",
            move: v,
            disabled: !P(U)
          }, {
            default: G(() => [
              re(Ra, {
                name: "ChevronLeft",
                width: "22px",
                height: "24px"
              })
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 40, lde),
        B("button", {
          type: "button",
          class: "vc-nav-title vc-focus",
          onClick: d,
          onKeydown: X[1] || (X[1] = (Q) => P(Mf)(Q, d))
        }, Pe(P(te)), 33),
        B("button", {
          type: "button",
          class: "vc-nav-arrow is-right vc-focus",
          disabled: !P(ee),
          onClick: g,
          onKeydown: X[2] || (X[2] = (Q) => P(Mf)(Q, g))
        }, [
          re(Hn, {
            name: "nav-next-button",
            move: g,
            disabled: !P(ee)
          }, {
            default: G(() => [
              re(Ra, {
                name: "ChevronRight",
                width: "22px",
                height: "24px"
              })
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 40, cde)
      ]),
      B("div", ude, [
        (S(!0), D(_e, null, Fe(P(F), (Q) => (S(), D("button", {
          key: Q.label,
          type: "button",
          "data-id": Q.id,
          "aria-label": Q.ariaLabel,
          class: j(["vc-nav-item vc-focus", [
            Q.isActive ? "is-active" : Q.isCurrent ? "is-current" : ""
          ]]),
          disabled: Q.isDisabled,
          onClick: Q.click,
          onKeydown: (ce) => P(Mf)(ce, Q.click)
        }, Pe(Q.label), 43, fde))), 128))
      ])
    ], 512));
  }
}), GD = /* @__PURE__ */ oe({
  __name: "CalendarPageProvider",
  props: {
    page: null
  },
  setup(t) {
    return ode(jl(t, "page")), (n, r) => H(n.$slots, "default");
  }
}), dde = /* @__PURE__ */ oe({
  __name: "CalendarNavPopover",
  setup(t) {
    const { navPopoverId: e, color: n, displayMode: r } = To();
    return (i, s) => (S(), ye(Vy, {
      id: P(e),
      class: j(["vc-nav-popover-container", `vc-${P(n)}`, `vc-${P(r)}`])
    }, {
      default: G(({ data: o }) => [
        re(GD, {
          page: o.page
        }, {
          default: G(() => [
            re(Hn, { name: "nav" }, {
              default: G(() => [
                re(hde)
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1032, ["page"])
      ]),
      _: 1
    }, 8, ["id", "class"]));
  }
}), pde = oe({
  directives: { popover: RD },
  components: { CalendarSlot: Hn },
  props: {
    day: { type: Object, required: !0 }
  },
  setup(t) {
    const {
      locale: e,
      theme: n,
      attributeContext: r,
      dayPopoverId: i,
      onDayClick: s,
      onDayMouseenter: o,
      onDayMouseleave: a,
      onDayFocusin: l,
      onDayFocusout: c,
      onDayKeydown: u
    } = To(), h = T(() => t.day), f = T(() => r.value.getCells(h.value)), d = T(
      () => f.value.map(($) => $.data)
    ), p = T(() => ({
      ...h.value,
      attributes: d.value,
      attributeCells: f.value
    }));
    function m({ data: $ }, { popovers: F }) {
      const { key: U, customData: ee, popover: ie } = $;
      if (!ie)
        return;
      const z = Zk(
        {
          key: U,
          customData: ee,
          attribute: $
        },
        { ...ie },
        {
          visibility: ie.label ? "hover" : "click",
          placement: "bottom",
          isInteractive: !ie.label
        }
      );
      F.splice(0, 0, z);
    }
    const v = T(() => {
      const $ = {
        ...n.value.prepareRender({}),
        popovers: []
      };
      return f.value.forEach((F) => {
        n.value.render(F, $), m(F, $);
      }), $;
    }), g = T(() => v.value.highlights), y = T(() => !!di(g.value)), x = T(() => v.value.content), b = T(() => v.value.dots), w = T(() => !!di(b.value)), k = T(() => v.value.bars), _ = T(() => !!di(k.value)), C = T(() => v.value.popovers), E = T(
      () => C.value.map(($) => $.attribute)
    ), L = WD("day-content"), M = T(() => [
      "vc-day",
      ...h.value.classes,
      { "vc-day-box-center-center": !L },
      { "is-not-in-month": !t.day.inMonth }
    ]), O = T(() => {
      let $;
      h.value.isFocusable ? $ = "0" : $ = "-1";
      const F = [
        "vc-day-content vc-focusable vc-focus vc-attr",
        { "vc-disabled": h.value.isDisabled },
        js(Ko(g.value), "contentClass"),
        js(Ko(x.value), "class") || ""
      ], U = {
        ...js(Ko(g.value), "contentStyle"),
        ...js(Ko(x.value), "style")
      };
      return {
        class: F,
        style: U,
        tabindex: $,
        "aria-label": h.value.ariaLabel,
        "aria-disabled": !!h.value.isDisabled,
        role: "button"
      };
    }), N = T(() => ({
      click($) {
        s(p.value, $);
      },
      mouseenter($) {
        o(p.value, $);
      },
      mouseleave($) {
        a(p.value, $);
      },
      focusin($) {
        l(p.value, $);
      },
      focusout($) {
        c(p.value, $);
      },
      keydown($) {
        u(p.value, $);
      }
    })), R = T(() => di(C.value) ? Zk(
      {
        id: i.value,
        data: { day: h, attributes: E.value }
      },
      ...C.value
    ) : null);
    return {
      attributes: d,
      attributeCells: f,
      bars: k,
      dayClasses: M,
      dayContentProps: O,
      dayContentEvents: N,
      dayPopover: R,
      glyphs: v,
      dots: b,
      hasDots: w,
      hasBars: _,
      highlights: g,
      hasHighlights: y,
      locale: e,
      popovers: C
    };
  }
}), mde = {
  key: 0,
  class: "vc-highlights vc-day-layer"
}, gde = {
  key: 1,
  class: "vc-day-layer vc-day-box-center-bottom"
}, vde = { class: "vc-dots" }, yde = {
  key: 2,
  class: "vc-day-layer vc-day-box-center-bottom"
}, bde = { class: "vc-bars" };
function xde(t, e, n, r, i, s) {
  const o = ai("CalendarSlot"), a = Y_("popover");
  return S(), D("div", {
    class: j(t.dayClasses)
  }, [
    t.hasHighlights ? (S(), D("div", mde, [
      (S(!0), D(_e, null, Fe(t.highlights, ({ key: l, wrapperClass: c, class: u, style: h }) => (S(), D("div", {
        key: l,
        class: j(c)
      }, [
        B("div", {
          class: j(u),
          style: yt(h)
        }, null, 6)
      ], 2))), 128))
    ])) : Z("", !0),
    re(o, {
      name: "day-content",
      day: t.day,
      attributes: t.attributes,
      "attribute-cells": t.attributeCells,
      dayProps: t.dayContentProps,
      dayEvents: t.dayContentEvents,
      locale: t.locale
    }, {
      default: G(() => [
        Yn((S(), D("div", Nt(t.dayContentProps, W_(t.dayContentEvents, !0)), [
          ft(Pe(t.day.label), 1)
        ], 16)), [
          [a, t.dayPopover]
        ])
      ]),
      _: 1
    }, 8, ["day", "attributes", "attribute-cells", "dayProps", "dayEvents", "locale"]),
    t.hasDots ? (S(), D("div", gde, [
      B("div", vde, [
        (S(!0), D(_e, null, Fe(t.dots, ({ key: l, class: c, style: u }) => (S(), D("span", {
          key: l,
          class: j(c),
          style: yt(u)
        }, null, 6))), 128))
      ])
    ])) : Z("", !0),
    t.hasBars ? (S(), D("div", yde, [
      B("div", bde, [
        (S(!0), D(_e, null, Fe(t.bars, ({ key: l, class: c, style: u }) => (S(), D("span", {
          key: l,
          class: j(c),
          style: yt(u)
        }, null, 6))), 128))
      ])
    ])) : Z("", !0)
  ], 2);
}
const wde = /* @__PURE__ */ Os(pde, [["render", xde]]), kde = { class: "vc-weekdays" }, _de = ["onClick"], Sde = {
  inheritAttrs: !1
}, Mde = /* @__PURE__ */ oe({
  ...Sde,
  __name: "CalendarPage",
  setup(t) {
    const { page: e } = KD(), { onWeeknumberClick: n } = To();
    return (r, i) => (S(), D("div", {
      class: j([
        "vc-pane",
        `row-${P(e).row}`,
        `row-from-end-${P(e).rowFromEnd}`,
        `column-${P(e).column}`,
        `column-from-end-${P(e).columnFromEnd}`
      ]),
      ref: "pane"
    }, [
      re(qD, {
        page: P(e),
        "is-lg": "",
        "hide-arrows": ""
      }, null, 8, ["page"]),
      B("div", {
        class: j(["vc-weeks", {
          [`vc-show-weeknumbers-${P(e).weeknumberPosition}`]: P(e).weeknumberPosition
        }])
      }, [
        B("div", kde, [
          (S(!0), D(_e, null, Fe(P(e).weekdays, ({ weekday: s, label: o }, a) => (S(), D("div", {
            key: a,
            class: j(`vc-weekday vc-weekday-${s}`)
          }, Pe(o), 3))), 128))
        ]),
        (S(!0), D(_e, null, Fe(P(e).viewWeeks, (s) => (S(), D("div", {
          key: `weeknumber-${s.weeknumber}`,
          class: "vc-week"
        }, [
          P(e).weeknumberPosition ? (S(), D("div", {
            key: 0,
            class: j(["vc-weeknumber", `is-${P(e).weeknumberPosition}`])
          }, [
            B("span", {
              class: j(["vc-weeknumber-content"]),
              onClick: (o) => P(n)(s, o)
            }, Pe(s.weeknumberDisplay), 9, _de)
          ], 2)) : Z("", !0),
          (S(!0), D(_e, null, Fe(s.days, (o) => (S(), ye(wde, {
            key: o.id,
            day: o
          }, null, 8, ["day"]))), 128))
        ]))), 128))
      ], 2)
    ], 2));
  }
}), Cde = oe({
  components: {
    CalendarHeader: qD,
    CalendarPage: Mde,
    CalendarNavPopover: dde,
    CalendarDayPopover: The,
    CalendarPageProvider: GD,
    CalendarSlot: Hn
  },
  props: yhe,
  emit: bhe,
  setup(t, { emit: e, slots: n }) {
    return xhe(t, { emit: e, slots: n });
  }
}), $de = { class: "vc-pane-header-wrapper" };
function Ade(t, e, n, r, i, s) {
  const o = ai("CalendarHeader"), a = ai("CalendarPage"), l = ai("CalendarSlot"), c = ai("CalendarPageProvider"), u = ai("CalendarDayPopover"), h = ai("CalendarNavPopover");
  return S(), D(_e, null, [
    B("div", Nt({ "data-helptext": "Press the arrow keys to navigate by day, Home and End to navigate to week ends, PageUp and PageDown to navigate by month, Alt+PageUp and Alt+PageDown to navigate by year" }, t.$attrs, {
      class: [
        "vc-container",
        `vc-${t.view}`,
        `vc-${t.color}`,
        `vc-${t.displayMode}`,
        {
          "vc-expanded": t.expanded,
          "vc-bordered": !t.borderless,
          "vc-transparent": t.transparent
        }
      ],
      onMouseup: e[0] || (e[0] = Lt(() => {
      }, ["prevent"])),
      ref: "containerRef"
    }), [
      B("div", {
        class: j(["vc-pane-container", { "in-transition": t.inTransition }])
      }, [
        B("div", $de, [
          t.firstPage ? (S(), ye(o, {
            key: 0,
            page: t.firstPage,
            "is-lg": "",
            "hide-title": ""
          }, null, 8, ["page"])) : Z("", !0)
        ]),
        re(Gn, {
          name: `vc-${t.transitionName}`,
          onBeforeEnter: t.onTransitionBeforeEnter,
          onAfterEnter: t.onTransitionAfterEnter
        }, {
          default: G(() => [
            (S(), D("div", {
              key: t.pages[0].id,
              class: "vc-pane-layout",
              style: yt({
                gridTemplateColumns: `repeat(${t.columns}, 1fr)`
              })
            }, [
              (S(!0), D(_e, null, Fe(t.pages, (f) => (S(), ye(c, {
                key: f.id,
                page: f
              }, {
                default: G(() => [
                  re(l, {
                    name: "page",
                    page: f
                  }, {
                    default: G(() => [
                      re(a)
                    ]),
                    _: 2
                  }, 1032, ["page"])
                ]),
                _: 2
              }, 1032, ["page"]))), 128))
            ], 4))
          ]),
          _: 1
        }, 8, ["name", "onBeforeEnter", "onAfterEnter"]),
        re(l, { name: "footer" })
      ], 2)
    ], 16),
    re(u),
    re(h)
  ], 64);
}
const Dde = /* @__PURE__ */ Os(Cde, [["render", Ade]]), XD = Symbol("__vc_date_picker_context__"), Tde = {
  ...zD,
  mode: { type: String, default: "date" },
  modelValue: {
    type: [Number, String, Date, Object]
  },
  modelModifiers: {
    type: Object,
    default: () => ({})
  },
  rules: [String, Object],
  is24hr: Boolean,
  hideTimeHeader: Boolean,
  timeAccuracy: { type: Number, default: 2 },
  isRequired: Boolean,
  isRange: Boolean,
  updateOnInput: {
    type: Boolean,
    default: () => bs("datePicker.updateOnInput")
  },
  inputDebounce: {
    type: Number,
    default: () => bs("datePicker.inputDebounce")
  },
  popover: {
    type: [Boolean, Object],
    default: !0
  },
  dragAttribute: Object,
  selectAttribute: Object,
  attributes: [Object, Array]
}, Ode = [
  "update:modelValue",
  "drag",
  "dayclick",
  "daykeydown",
  "popover-will-show",
  "popover-did-show",
  "popover-will-hide",
  "popover-did-hide"
];
function Ede(t, { emit: e, slots: n }) {
  var ne;
  YD(n, { footer: "dp-footer" });
  const r = VD(t), { locale: i, masks: s, disabledAttribute: o } = r, a = le(!1), l = le(Symbol()), c = le(null), u = le(null), h = le(["", ""]), f = le(null), d = le(null);
  let p, m, v = !0;
  const g = T(() => t.isRange || t.modelModifiers.range === !0), y = T(
    () => g.value && c.value != null ? c.value.start : null
  ), x = T(
    () => g.value && c.value != null ? c.value.end : null
  ), b = T(() => t.mode.toLowerCase() === "date"), w = T(
    () => t.mode.toLowerCase() === "datetime"
  ), k = T(() => t.mode.toLowerCase() === "time"), _ = T(() => !!u.value), C = T(() => {
    let A = "date";
    t.modelModifiers.number && (A = "number"), t.modelModifiers.string && (A = "string");
    const K = s.value.modelValue || "iso";
    return X({ type: A, mask: K });
  }), E = T(
    () => {
      var A;
      return ir((A = u.value) != null ? A : c.value);
    }
  ), L = T(() => k.value ? t.is24hr ? s.value.inputTime24hr : s.value.inputTime : w.value ? t.is24hr ? s.value.inputDateTime24hr : s.value.inputDateTime : s.value.input), M = T(() => /[Hh]/g.test(L.value)), O = T(
    () => /[dD]{1,2}|Do|W{1,4}|M{1,4}|YY(?:YY)?/g.test(L.value)
  ), N = T(() => {
    if (M.value && O.value)
      return "dateTime";
    if (O.value)
      return "date";
    if (M.value)
      return "time";
  }), R = T(() => {
    var ue;
    var A;
    const K = (ue = (A = f.value) == null ? void 0 : A.$el.previousElementSibling) != null ? ue : void 0;
    return Wc({}, t.popover, bs("datePicker.popover"), {
      target: K
    });
  }), $ = T(
    () => ID({
      ...R.value,
      id: l.value
    })
  ), F = T(() => g.value ? {
    start: h.value[0],
    end: h.value[1]
  } : h.value[0]), U = T(() => {
    const A = ["start", "end"].map((K) => ({
      input: He(K),
      change: st(K),
      keyup: gn,
      ...t.popover && $.value
    }));
    return g.value ? {
      start: A[0],
      end: A[1]
    } : A[0];
  }), ee = T(() => {
    if (!J(c.value))
      return null;
    const A = {
      key: "select-drag",
      ...t.selectAttribute,
      dates: c.value,
      pinPage: !0
    }, { dot: K, bar: ue, highlight: Re, content: et } = A;
    return !K && !ue && !Re && !et && (A.highlight = !0), A;
  }), ie = T(() => {
    if (!g.value || !J(u.value))
      return null;
    const A = {
      key: "select-drag",
      ...t.dragAttribute,
      dates: u.value
    }, { dot: K, bar: ue, highlight: Re, content: et } = A;
    return !K && !ue && !Re && !et && (A.highlight = {
      startEnd: {
        fillMode: "outline"
      }
    }), A;
  }), z = T(() => {
    const A = Kn(t.attributes) ? [...t.attributes] : [];
    return ie.value ? A.unshift(ie.value) : ee.value && A.unshift(ee.value), A;
  }), te = T(() => {
    var A;
    return X(
      t.rules === "auto" ? I() : (A = t.rules) != null ? A : {}
    );
  });
  function I() {
    const A = {
      ms: [0, 999],
      sec: [0, 59],
      min: [0, 59],
      hr: [0, 23]
    }, K = b.value ? 0 : t.timeAccuracy;
    return [0, 1].map((ue) => {
      switch (K) {
        case 0:
          return {
            hours: A.hr[ue],
            minutes: A.min[ue],
            seconds: A.sec[ue],
            milliseconds: A.ms[ue]
          };
        case 1:
          return {
            minutes: A.min[ue],
            seconds: A.sec[ue],
            milliseconds: A.ms[ue]
          };
        case 3:
          return { milliseconds: A.ms[ue] };
        case 4:
          return {};
        default:
          return { seconds: A.sec[ue], milliseconds: A.ms[ue] };
      }
    });
  }
  function X(A) {
    return Kn(A) ? A.length === 1 ? [A[0], A[0]] : A : [A, A];
  }
  function Q(A) {
    return X(A).map(
      (K, ue) => ({
        ...K,
        rules: te.value[ue]
      })
    );
  }
  function ce(A) {
    return A == null ? !1 : gr(A) ? !isNaN(A) : oa(A) ? !isNaN(A.getTime()) : Fr(A) ? A !== "" : Ry(A);
  }
  function he(A) {
    var K, ue;
    return Ci(A) && "start" in A && "end" in A && ce((K = A.start) != null ? K : null) && ce((ue = A.end) != null ? ue : null);
  }
  function J(A) {
    return he(A) || ce(A);
  }
  function pe(A, K) {
    if (A == null && K == null)
      return !0;
    if (A == null || K == null)
      return !1;
    const ue = oa(A), Re = oa(K);
    return ue && Re ? A.getTime() === K.getTime() : ue || Re ? !1 : pe(A.start, K.start) && pe(A.end, K.end);
  }
  function Y(A) {
    return !J(A) || !o.value ? !1 : o.value.intersectsRange(i.value.range(A));
  }
  function se(A, K, ue, Re) {
    var et, vn;
    if (!J(A))
      return null;
    if (he(A)) {
      const yn = i.value.toDate(A.start, {
        ...K[0],
        fillDate: (et = y.value) != null ? et : void 0,
        patch: ue
      }), sr = i.value.toDate(A.end, {
        ...K[1],
        fillDate: (vn = x.value) != null ? vn : void 0,
        patch: ue
      });
      return Au({ start: yn, end: sr }, Re);
    }
    return i.value.toDateOrNull(A, {
      ...K[0],
      fillDate: c.value,
      patch: ue
    });
  }
  function ge(A, K) {
    return he(A) ? {
      start: i.value.fromDate(A.start, K[0]),
      end: i.value.fromDate(A.end, K[1])
    } : g.value ? null : i.value.fromDate(A, K[0]);
  }
  function V(A, K = {}) {
    return clearTimeout(p), new Promise((ue) => {
      const { debounce: Re = 0, ...et } = K;
      Re > 0 ? p = window.setTimeout(() => {
        ue(Ee(A, et));
      }, Re) : ue(Ee(A, et));
    });
  }
  function Ee(A, {
    config: K = C.value,
    patch: ue = "dateTime",
    clearIfEqual: Re = !1,
    formatInput: et = !0,
    hidePopover: vn = !1,
    dragging: yn = _.value,
    targetPriority: sr,
    moveToValue: Dp = !1
  } = {}) {
    const sl = Q(K);
    let bn = se(
      A,
      sl,
      ue,
      sr
    );
    if (Y(bn)) {
      if (yn)
        return null;
      bn = c.value, vn = !1;
    } else bn == null && t.isRequired ? bn = c.value : (
      // Clear value if same value was passed
      bn != null && pe(c.value, bn) && Re && (bn = null)
    );
    const Eo = yn ? u : c, Eu = !pe(Eo.value, bn);
    Eo.value = bn, yn || (u.value = null);
    const Pu = ge(
      bn,
      C.value
    );
    return Eu && (v = !1, e(yn ? "drag" : "update:modelValue", Pu), gt(() => v = !0)), vn && !yn && il(), et && ke(), Dp && gt(() => Tu(sr != null ? sr : "start")), Pu;
  }
  function ke() {
    gt(() => {
      var ue;
      const A = Q({
        type: "string",
        mask: L.value
      }), K = ge(
        (ue = u.value) != null ? ue : c.value,
        A
      );
      g.value ? h.value = [K && K.start, K && K.end] : h.value = [K, ""];
    });
  }
  function Ie(A, K, ue) {
    h.value.splice(K === "start" ? 0 : 1, 1, A);
    const Re = g.value ? {
      start: h.value[0],
      end: h.value[1] || h.value[0]
    } : A, et = {
      type: "string",
      mask: L.value
    };
    V(Re, {
      ...ue,
      config: et,
      patch: N.value,
      targetPriority: K,
      moveToValue: !0
    });
  }
  function He(A) {
    return (K) => {
      t.updateOnInput && Ie(K.currentTarget.value, A, {
        formatInput: !1,
        hidePopover: !1,
        debounce: t.inputDebounce
      });
    };
  }
  function st(A) {
    return (K) => {
      Ie(K.currentTarget.value, A, {
        formatInput: !0,
        hidePopover: !1
      });
    };
  }
  function gn(A) {
    A.key === "Escape" && V(c.value, {
      formatInput: !0,
      hidePopover: !0
    });
  }
  function ir(A) {
    return g.value ? [
      A && A.start ? i.value.getDateParts(A.start) : null,
      A && A.end ? i.value.getDateParts(A.end) : null
    ] : [A ? i.value.getDateParts(A) : null];
  }
  function Mt() {
    u.value = null, ke();
  }
  function Li(A) {
    e("popover-will-show", A);
  }
  function Ni(A) {
    e("popover-did-show", A);
  }
  function Ii(A) {
    Mt(), e("popover-will-hide", A);
  }
  function Ri(A) {
    e("popover-did-hide", A);
  }
  function Bi(A) {
    const K = {
      patch: "date",
      formatInput: !0,
      hidePopover: !0
    };
    if (g.value) {
      const ue = !_.value;
      ue ? m = { start: A.startDate, end: A.endDate } : m != null && (m.end = A.date), V(m, {
        ...K,
        dragging: ue
      });
    } else
      V(A.date, {
        ...K,
        clearIfEqual: !t.isRequired
      });
  }
  function Fi(A, K) {
    Bi(A), e("dayclick", A, K);
  }
  function Es(A, K) {
    switch (K.key) {
      case " ":
      case "Enter": {
        Bi(A), K.preventDefault();
        break;
      }
      case "Escape":
        il();
    }
    e("daykeydown", A, K);
  }
  function Oo(A, K) {
    !_.value || m == null || (m.end = A.date, V(Au(m), {
      patch: "date",
      formatInput: !0
    }));
  }
  function Cp(A = {}) {
    gv({
      ...R.value,
      ...A,
      isInteractive: !0,
      id: l.value
    });
  }
  function il(A = {}) {
    jc({
      hideDelay: 10,
      force: !0,
      ...R.value,
      ...A,
      id: l.value
    });
  }
  function $p(A) {
    ND({
      ...R.value,
      ...A,
      isInteractive: !0,
      id: l.value
    });
  }
  function Au(A, K) {
    const { start: ue, end: Re } = A;
    if (ue > Re)
      switch (K) {
        case "start":
          return { start: ue, end: ue };
        case "end":
          return { start: Re, end: Re };
        default:
          return { start: Re, end: ue };
      }
    return { start: ue, end: Re };
  }
  async function Du(A, K = {}) {
    return d.value == null ? !1 : d.value.move(A, K);
  }
  async function Ap(A, K = {}) {
    return d.value == null ? !1 : d.value.moveBy(A, K);
  }
  async function Tu(A, K = {}) {
    const ue = c.value;
    if (d.value == null || !J(ue))
      return !1;
    const Re = A !== "end", et = Re ? 1 : -1, vn = he(ue) ? Re ? ue.start : ue.end : ue, yn = bD(vn, "monthly", i.value);
    return d.value.move(yn, { position: et, ...K });
  }
  Se(
    () => t.isRange,
    (A) => {
      A && console.warn(
        "The `is-range` prop will be deprecated in future releases. Please use the `range` modifier."
      );
    },
    { immediate: !0 }
  ), Se(
    () => g.value,
    () => {
      Ee(null, { formatInput: !0 });
    }
  ), Se(
    () => L.value,
    () => ke()
  ), Se(
    () => t.modelValue,
    (A) => {
      v && Ee(A, {
        formatInput: !0,
        hidePopover: !1
      });
    }
  ), Se(
    () => te.value,
    () => {
      Ci(t.rules) && Ee(t.modelValue, {
        formatInput: !0,
        hidePopover: !1
      });
    }
  ), Se(
    () => t.timezone,
    () => {
      Ee(c.value, { formatInput: !0 });
    }
  );
  const Ou = X(C.value);
  c.value = se(
    (ne = t.modelValue) != null ? ne : null,
    Ou,
    "dateTime"
  ), rn(() => {
    Ee(t.modelValue, {
      formatInput: !0,
      hidePopover: !1
    });
  }), gt(() => a.value = !0);
  const q = {
    ...r,
    showCalendar: a,
    datePickerPopoverId: l,
    popoverRef: f,
    popoverEvents: $,
    calendarRef: d,
    isRange: g,
    isTimeMode: k,
    isDateTimeMode: w,
    is24hr: jl(t, "is24hr"),
    hideTimeHeader: jl(t, "hideTimeHeader"),
    timeAccuracy: jl(t, "timeAccuracy"),
    isDragging: _,
    inputValue: F,
    inputEvents: U,
    dateParts: E,
    attributes: z,
    rules: te,
    move: Du,
    moveBy: Ap,
    moveToValue: Tu,
    updateValue: V,
    showPopover: Cp,
    hidePopover: il,
    togglePopover: $p,
    onDayClick: Fi,
    onDayKeydown: Es,
    onDayMouseEnter: Oo,
    onPopoverBeforeShow: Li,
    onPopoverAfterShow: Ni,
    onPopoverBeforeHide: Ii,
    onPopoverAfterHide: Ri
  };
  return qc(XD, q), q;
}
function Hy() {
  const t = Fa(XD);
  if (t)
    return t;
  throw new Error(
    "DatePicker context missing. Please verify this component is nested within a valid context provider."
  );
}
const Pde = [
  { value: 0, label: "12" },
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: 7, label: "7" },
  { value: 8, label: "8" },
  { value: 9, label: "9" },
  { value: 10, label: "10" },
  { value: 11, label: "11" }
], Lde = [
  { value: 12, label: "12" },
  { value: 13, label: "1" },
  { value: 14, label: "2" },
  { value: 15, label: "3" },
  { value: 16, label: "4" },
  { value: 17, label: "5" },
  { value: 18, label: "6" },
  { value: 19, label: "7" },
  { value: 20, label: "8" },
  { value: 21, label: "9" },
  { value: 22, label: "10" },
  { value: 23, label: "11" }
];
function Nde(t) {
  const e = Hy(), {
    locale: n,
    isRange: r,
    isTimeMode: i,
    dateParts: s,
    rules: o,
    is24hr: a,
    hideTimeHeader: l,
    timeAccuracy: c,
    updateValue: u
  } = e;
  function h(O) {
    O = Object.assign(d.value, O);
    let N = null;
    if (r.value) {
      const R = f.value ? O : s.value[0], $ = f.value ? s.value[1] : O;
      N = { start: R, end: $ };
    } else
      N = O;
    u(N, {
      patch: "time",
      targetPriority: f.value ? "start" : "end",
      moveToValue: !0
    });
  }
  const f = T(() => t.position === 0), d = T(
    () => s.value[t.position] || { isValid: !1 }
  ), p = T(() => Ry(d.value)), m = T(() => !!d.value.isValid), v = T(() => !l.value && m.value), g = T(() => {
    if (!p.value)
      return null;
    let O = n.value.toDate(d.value);
    return d.value.hours === 24 && (O = new Date(O.getTime() - 1)), O;
  }), y = T({
    get() {
      return d.value.hours;
    },
    set(O) {
      h({ hours: O });
    }
  }), x = T({
    get() {
      return d.value.minutes;
    },
    set(O) {
      h({ minutes: O });
    }
  }), b = T({
    get() {
      return d.value.seconds;
    },
    set(O) {
      h({ seconds: O });
    }
  }), w = T({
    get() {
      return d.value.milliseconds;
    },
    set(O) {
      h({ milliseconds: O });
    }
  }), k = T({
    get() {
      return d.value.hours < 12;
    },
    set(O) {
      O = String(O).toLowerCase() == "true";
      let N = y.value;
      O && N >= 12 ? N -= 12 : !O && N < 12 && (N += 12), h({ hours: N });
    }
  }), _ = T(
    () => Qfe(d.value, o.value[t.position])
  ), C = T(() => Pde.filter(
    (O) => _.value.hours.some((N) => N.value === O.value)
  )), E = T(() => Lde.filter(
    (O) => _.value.hours.some((N) => N.value === O.value)
  )), L = T(() => a.value ? _.value.hours : k.value ? C.value : E.value), M = T(() => {
    const O = [];
    return di(C.value) && O.push({ value: !0, label: "AM" }), di(E.value) && O.push({ value: !1, label: "PM" }), O;
  });
  return {
    ...e,
    showHeader: v,
    timeAccuracy: c,
    parts: d,
    isValid: m,
    date: g,
    hours: y,
    minutes: x,
    seconds: b,
    milliseconds: w,
    options: _,
    hourOptions: L,
    isAM: k,
    isAMOptions: M,
    is24hr: a
  };
}
const Ide = ["value"], Rde = ["value", "disabled"], Bde = {
  key: 1,
  class: "vc-base-sizer",
  "aria-hidden": "true"
}, Fde = {
  inheritAttrs: !1
}, _l = /* @__PURE__ */ oe({
  ...Fde,
  __name: "BaseSelect",
  props: {
    options: null,
    modelValue: null,
    alignRight: { type: Boolean },
    alignLeft: { type: Boolean },
    showIcon: { type: Boolean },
    fitContent: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, n = T(() => {
      const r = e.options.find((i) => i.value === e.modelValue);
      return r == null ? void 0 : r.label;
    });
    return (r, i) => (S(), D("div", {
      class: j(["vc-base-select", {
        "vc-fit-content": t.fitContent,
        "vc-has-icon": t.showIcon
      }])
    }, [
      B("select", Nt(r.$attrs, {
        value: t.modelValue,
        class: ["vc-focus", {
          "vc-align-right": t.alignRight,
          "vc-align-left": t.alignLeft
        }],
        onChange: i[0] || (i[0] = (s) => r.$emit("update:modelValue", s.target.value))
      }), [
        (S(!0), D(_e, null, Fe(t.options, (s) => (S(), D("option", {
          key: s.value,
          value: s.value,
          disabled: s.disabled
        }, Pe(s.label), 9, Rde))), 128))
      ], 16, Ide),
      t.showIcon ? (S(), ye(Ra, {
        key: 0,
        name: "ChevronDown",
        size: "18"
      })) : Z("", !0),
      t.fitContent ? (S(), D("div", Bde, Pe(P(n)), 1)) : Z("", !0)
    ], 2));
  }
}), zde = {
  key: 0,
  class: "vc-time-header"
}, Vde = { class: "vc-time-weekday" }, Hde = { class: "vc-time-month" }, Yde = { class: "vc-time-day" }, Wde = { class: "vc-time-year" }, jde = { class: "vc-time-select-group" }, qde = /* @__PURE__ */ B("span", { class: "vc-time-colon" }, ":", -1), Ude = /* @__PURE__ */ B("span", { class: "vc-time-colon" }, ":", -1), Kde = /* @__PURE__ */ B("span", { class: "vc-time-decimal" }, ".", -1), C_ = /* @__PURE__ */ oe({
  __name: "TimePicker",
  props: {
    position: null
  },
  setup(t, { expose: e }) {
    const r = Nde(t);
    e(r);
    const {
      locale: i,
      isValid: s,
      date: o,
      hours: a,
      minutes: l,
      seconds: c,
      milliseconds: u,
      options: h,
      hourOptions: f,
      isTimeMode: d,
      isAM: p,
      isAMOptions: m,
      is24hr: v,
      showHeader: g,
      timeAccuracy: y
    } = r;
    return (x, b) => (S(), D("div", {
      class: j(["vc-time-picker", [{ "vc-invalid": !P(s), "vc-attached": !P(d) }]])
    }, [
      re(Hn, { name: "time-header" }, {
        default: G(() => [
          P(g) && P(o) ? (S(), D("div", zde, [
            B("span", Vde, Pe(P(i).formatDate(P(o), "WWW")), 1),
            B("span", Hde, Pe(P(i).formatDate(P(o), "MMM")), 1),
            B("span", Yde, Pe(P(i).formatDate(P(o), "D")), 1),
            B("span", Wde, Pe(P(i).formatDate(P(o), "YYYY")), 1)
          ])) : Z("", !0)
        ]),
        _: 1
      }),
      B("div", jde, [
        re(Ra, {
          name: "Clock",
          size: "17"
        }),
        re(_l, {
          modelValue: P(a),
          "onUpdate:modelValue": b[0] || (b[0] = (w) => ol(a) ? a.value = w : null),
          modelModifiers: { number: !0 },
          options: P(f),
          class: "vc-time-select-hours",
          "align-right": ""
        }, null, 8, ["modelValue", "options"]),
        P(y) > 1 ? (S(), D(_e, { key: 0 }, [
          qde,
          re(_l, {
            modelValue: P(l),
            "onUpdate:modelValue": b[1] || (b[1] = (w) => ol(l) ? l.value = w : null),
            modelModifiers: { number: !0 },
            options: P(h).minutes,
            class: "vc-time-select-minutes",
            "align-left": P(y) === 2
          }, null, 8, ["modelValue", "options", "align-left"])
        ], 64)) : Z("", !0),
        P(y) > 2 ? (S(), D(_e, { key: 1 }, [
          Ude,
          re(_l, {
            modelValue: P(c),
            "onUpdate:modelValue": b[2] || (b[2] = (w) => ol(c) ? c.value = w : null),
            modelModifiers: { number: !0 },
            options: P(h).seconds,
            class: "vc-time-select-seconds",
            "align-left": P(y) === 3
          }, null, 8, ["modelValue", "options", "align-left"])
        ], 64)) : Z("", !0),
        P(y) > 3 ? (S(), D(_e, { key: 2 }, [
          Kde,
          re(_l, {
            modelValue: P(u),
            "onUpdate:modelValue": b[3] || (b[3] = (w) => ol(u) ? u.value = w : null),
            modelModifiers: { number: !0 },
            options: P(h).milliseconds,
            class: "vc-time-select-milliseconds",
            "align-left": ""
          }, null, 8, ["modelValue", "options"])
        ], 64)) : Z("", !0),
        P(v) ? Z("", !0) : (S(), ye(_l, {
          key: 3,
          modelValue: P(p),
          "onUpdate:modelValue": b[4] || (b[4] = (w) => ol(p) ? p.value = w : null),
          options: P(m)
        }, null, 8, ["modelValue", "options"]))
      ])
    ], 2));
  }
}), ZD = /* @__PURE__ */ oe({
  __name: "DatePickerBase",
  setup(t) {
    const {
      attributes: e,
      calendarRef: n,
      color: r,
      displayMode: i,
      isDateTimeMode: s,
      isTimeMode: o,
      isRange: a,
      onDayClick: l,
      onDayMouseEnter: c,
      onDayKeydown: u
    } = Hy(), h = a.value ? [0, 1] : [0];
    return (f, d) => P(o) ? (S(), D("div", {
      key: 0,
      class: j(`vc-container vc-bordered vc-${P(r)} vc-${P(i)}`)
    }, [
      (S(!0), D(_e, null, Fe(P(h), (p) => (S(), ye(C_, {
        key: p,
        position: p
      }, null, 8, ["position"]))), 128))
    ], 2)) : (S(), ye(Dde, {
      key: 1,
      attributes: P(e),
      ref_key: "calendarRef",
      ref: n,
      onDayclick: P(l),
      onDaymouseenter: P(c),
      onDaykeydown: P(u)
    }, {
      footer: G(() => [
        P(s) ? (S(!0), D(_e, { key: 0 }, Fe(P(h), (p) => (S(), ye(C_, {
          key: p,
          position: p
        }, null, 8, ["position"]))), 128)) : Z("", !0),
        re(Hn, { name: "dp-footer" })
      ]),
      _: 1
    }, 8, ["attributes", "onDayclick", "onDaymouseenter", "onDaykeydown"]));
  }
}), Gde = {
  inheritAttrs: !1
}, Xde = /* @__PURE__ */ oe({
  ...Gde,
  __name: "DatePickerPopover",
  setup(t) {
    const {
      datePickerPopoverId: e,
      color: n,
      displayMode: r,
      popoverRef: i,
      onPopoverBeforeShow: s,
      onPopoverAfterShow: o,
      onPopoverBeforeHide: a,
      onPopoverAfterHide: l
    } = Hy();
    return (c, u) => (S(), ye(Vy, {
      id: P(e),
      placement: "bottom-start",
      class: j(`vc-date-picker-content vc-${P(n)} vc-${P(r)}`),
      ref_key: "popoverRef",
      ref: i,
      onBeforeShow: P(s),
      onAfterShow: P(o),
      onBeforeHide: P(a),
      onAfterHide: P(l)
    }, {
      default: G(() => [
        re(ZD, Ct(on(c.$attrs)), null, 16)
      ]),
      _: 1
    }, 8, ["id", "class", "onBeforeShow", "onAfterShow", "onBeforeHide", "onAfterHide"]));
  }
}), Zde = oe({
  inheritAttrs: !1,
  emits: Ode,
  props: Tde,
  components: { DatePickerBase: ZD, DatePickerPopover: Xde },
  setup(t, e) {
    const n = Ede(t, e), r = yd(mD(n, "calendarRef", "popoverRef"));
    return { ...n, slotCtx: r };
  }
});
function Jde(t, e, n, r, i, s) {
  const o = ai("DatePickerPopover"), a = ai("DatePickerBase");
  return t.$slots.default ? (S(), D(_e, { key: 0 }, [
    H(t.$slots, "default", Ct(on(t.slotCtx))),
    re(o, Ct(on(t.$attrs)), null, 16)
  ], 64)) : (S(), ye(a, Ct(Nt({ key: 1 }, t.$attrs)), null, 16));
}
const Qde = /* @__PURE__ */ Os(Zde, [["render", Jde]]), epe = {
  inheritAttrs: !1
}, tpe = /* @__PURE__ */ oe({
  ...epe,
  __name: "vx-date-picker",
  props: {
    size: {
      type: String,
      default: "lg"
    },
    mode: {
      type: String,
      default: "dateTime"
    },
    attached: {
      type: Boolean,
      default: !1,
      required: !1
    },
    setsToNow: {
      type: Boolean,
      default: !1,
      required: !1
    }
  },
  setup(t) {
    const e = t, n = u7(), r = T(() => {
      var i;
      return (i = n.modelModifiers) == null ? void 0 : i.range;
    });
    return (i, s) => (S(), D("div", {
      class: j(["vx-date-picker", `vx-date-picker--${e.size}`, {
        "vx-date-picker--attached": e.attached,
        "vx-date-picker--sets-to-now": e.setsToNow
      }])
    }, [
      re(P(Qde), Nt(i.$attrs, {
        mode: e.mode,
        shortMonthLabel: !0
      }), null, 16, ["mode"]),
      e.setsToNow ? (S(), D("div", {
        key: 0,
        class: j({
          "vx-mx-6 vx-mb-6 vx-mt-3": e.attached,
          "vx-mt-3": !e.attached
        })
      }, [
        re(cs, {
          size: "sm",
          color: "muted",
          outline: "",
          block: "",
          onClick: s[0] || (s[0] = (o) => i.$emit("update:modelValue", r.value ? { start: /* @__PURE__ */ new Date(), end: /* @__PURE__ */ new Date() } : /* @__PURE__ */ new Date()))
        }, {
          default: G(() => [
            ft(" Set to now "),
            re(P(rt), { icon: P(wO) }, null, 8, ["icon"])
          ]),
          _: 1
        })
      ], 2)) : Z("", !0)
    ], 2));
  }
}), qge = /* @__PURE__ */ jt(tpe, [["__scopeId", "data-v-9e84f5e9"]]), npe = { class: "vx-flex vx-gap-1 vx-items-center" }, Uge = /* @__PURE__ */ oe({
  __name: "vx-disclosure",
  props: /* @__PURE__ */ Zm({
    appearance: {
      type: String,
      required: !1,
      default: "default"
    }
  }, {
    active: {
      type: Boolean,
      required: !1,
      default: !1
    },
    activeModifiers: {}
  }),
  emits: ["update:active"],
  setup(t) {
    const e = t, n = j_(t, "active"), r = () => {
      n.value = !n.value;
    }, i = T(() => {
      if (e.appearance === "boxed") {
        const l = "vx-border vx-border-solid  vx-border-slate-300 vx-rounded-md", c = ["vx-text-xs vx-font-semibold vx-flex vx-items-center vx-justify-between vx-cursor-pointer vx-bg-slate-100 vx-text-slate-600 vx-px-2 vx-h-7"], u = "vx-bg-white vx-rounded-b-md vx-text-xs vx-text-slate-700 vx-p-2";
        return n.value ? c.push("vx-rounded-t-md") : c.push("vx-rounded-md"), {
          wrapper: l,
          header: c,
          content: u
        };
      }
      const s = "vx-border vx-border-solid vx-border-slate-200 vx-rounded-2xl vx-w-full vx-bg-white", o = ["vx-py-4 vx-px-6 vx-text-sm vx-text-slate-600 vx-font-semibold vx-cursor-pointer vx-flex vx-w-full vx-justify-between vx-border-solid vx-border-x-0 vx-border-t-0"];
      return n.value ? o.push("vx-border-b vx-border-slate-200") : o.push("vx-border-b-0"), {
        wrapper: s,
        header: o,
        content: "vx-p-6 vx-text-sm vx-text-slate-700"
      };
    });
    return (s, o) => (S(), D("div", {
      class: j(["vx-font-sans", i.value.wrapper])
    }, [
      B("div", {
        onClick: o[0] || (o[0] = Lt((a) => r(), ["prevent"])),
        onKeydown: [
          o[1] || (o[1] = Yt((a) => r(), ["space"])),
          o[2] || (o[2] = Yt((a) => r(), ["enter"]))
        ],
        tabindex: "0",
        class: j(i.value.header)
      }, [
        B("div", npe, [
          H(s.$slots, "header")
        ]),
        B("div", null, [
          n.value ? (S(), ye(P(rt), {
            key: 0,
            icon: P(O3)
          }, null, 8, ["icon"])) : (S(), ye(P(rt), {
            key: 1,
            icon: P(Tv)
          }, null, 8, ["icon"]))
        ])
      ], 34),
      n.value ? (S(), D("div", {
        key: 0,
        class: j(i.value.content)
      }, [
        H(s.$slots, "content")
      ], 2)) : Z("", !0)
    ], 2));
  }
}), Kge = /* @__PURE__ */ oe({
  __name: "vx-dropdown",
  props: {
    placement: {
      type: String,
      default: "left"
    },
    teleport: {
      type: Boolean,
      default: !1
    }
  },
  setup(t, { expose: e }) {
    const n = t, r = le(), i = le(), s = le(!1), o = yd({
      bottom: "auto",
      top: "auto",
      left: "auto",
      right: "auto"
    }), a = () => {
      s.value = !s.value;
    }, l = () => {
      if (!r.value || !s.value || !i.value)
        return;
      const c = r.value.getBoundingClientRect(), u = c.right + c.width > window.innerWidth, h = c.left - c.width < 0, f = c.bottom + c.height > window.innerHeight;
      if (n.teleport) {
        (n.placement === "right" || u) && !h ? (o.right = "auto", o.left = `${c.right - i.value.offsetWidth}px`) : (o.right = "auto", o.left = `${c.left}px`), f ? (o.bottom = "auto", o.top = `${c.top + window.scrollY - i.value.offsetWidth + 8}px`) : (o.bottom = "auto", o.top = `${c.bottom + window.scrollY + 8}px`);
        return;
      }
      (n.placement === "right" || u) && !h ? (o.left = "auto", o.right = "0px") : (o.left = "0px", o.right = "auto"), f ? (o.top = "auto", o.bottom = `${c.height + 8}px`) : (o.top = `${c.height + 8}px`, o.bottom = "auto");
    };
    return e({
      open: s
    }), Xo(window, "scrollend", l), Xo(window, "resize", l), lc(l), (c, u) => Yn((S(), D("div", {
      ref_key: "containerRef",
      ref: r,
      class: "vx-relative",
      onClick: a
    }, [
      H(c.$slots, "default", Ct(on({ open: s.value }))),
      s.value ? (S(), ye(V_, {
        key: 0,
        to: "body",
        disabled: !n.teleport
      }, [
        B("div", {
          ref_key: "itemsRef",
          ref: i,
          class: "action-dropdown vx-absolute vx-border vx-border-solid vx-border-slate-200 vx-shadow-xl vx-font-semibold vx-max-h-52 vx-rounded-lg vx-bg-white vx-z-50",
          style: yt(o),
          onClick: u[0] || (u[0] = Lt((h) => s.value = !1, ["stop"]))
        }, [
          H(c.$slots, "items")
        ], 4)
      ], 8, ["disabled"])) : Z("", !0)
    ])), [
      [P(Sd), () => s.value = !1]
    ]);
  }
}), Gge = /* @__PURE__ */ oe({
  __name: "vx-dropdown-item",
  props: {
    href: {
      type: String,
      required: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String
    }
  },
  setup(t) {
    const e = t, n = T(() => e.href ? "a" : "button");
    return (r, i) => (S(), ye(ht(n.value), {
      href: t.href,
      disabled: t.disabled,
      class: "action-dropdown-item vx-border-solid vx-border-0 vx-border-b vx-border-slate-200 vx-font-sans vx-font-semibold vx-text-black vx-text-xs vx-no-underline vx-flex vx-w-full vx-justify-between vx-items-center vx-gap-2 vx-px-6 vx-py-4 vx-bg-white vx-transition-all vx-whitespace-nowrap hover:vx-bg-slate-50 hover:vx-no-underline hover:vx-text-black active:vx-bg-slate-100 disabled:vx-opacity-50 disabled:vx-pointer-events-none"
    }, {
      default: G(() => [
        H(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["href", "disabled"]));
  }
}), rpe = ["tabindex"], ipe = {
  key: 0,
  class: "vx-font-sans vx-text-sm vx-text-slate-500"
}, $_ = /* @__PURE__ */ oe({
  __name: "vx-expandable-card-header",
  props: {
    active: {
      type: Boolean,
      required: !1,
      default: void 0
    }
  },
  emits: ["click"],
  setup(t, { emit: e }) {
    const n = t, r = e;
    return (i, s) => (S(), D("div", {
      onClick: s[0] || (s[0] = Lt((o) => r("click"), ["prevent"])),
      onKeydown: [
        s[1] || (s[1] = Yt((o) => r("click"), ["space"])),
        s[2] || (s[2] = Yt((o) => r("click"), ["enter"]))
      ],
      tabindex: n.active === void 0 ? void 0 : 0,
      class: j([{
        "vx-pb-3": n.active === void 0,
        "vx-cursor-pointer": n.active
      }])
    }, [
      B("div", {
        class: j(["vx-flex vx-justify-between vx-items-center vx-text-base vx-font-extrabold vx-text-slate-700 vx-leading-none lg:vx-text-xl", {
          "vx-pt-4 vx-pb-3 vx-px-4 lg:vx-pt-0 lg:vx-pb-0 lg:vx-h-20 lg:vx-px-8": n.active !== void 0
        }])
      }, [
        B("div", null, [
          H(i.$slots, "default")
        ]),
        B("div", null, [
          H(i.$slots, "right")
        ])
      ], 2),
      i.$slots.subtitle ? (S(), D("div", ipe, [
        H(i.$slots, "subtitle")
      ])) : Z("", !0)
    ], 42, rpe));
  }
}), Xge = /* @__PURE__ */ oe({
  __name: "vx-expandable-card",
  props: {
    active: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    toggleable: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: ["update:active"],
  setup(t, { emit: e }) {
    const n = t, r = e, i = le(!!n.active);
    Se(
      () => n.active,
      (a) => {
        i.value = !!a;
      }
    );
    const s = () => {
      n.active === void 0 && (i.value = !i.value), r("update:active", n.active !== void 0 ? !n.active : i.value);
    }, o = T(() => n.toggleable ? n.active !== void 0 ? n.active : i.value : !0);
    return (a, l) => (S(), D("div", {
      class: j(["vx-border-white vx-border vx-w-full vx-rounded-2xl vx-bg-slate-50", [{
        "vx-shadow": !i.value,
        "vx-shadow-xl": i.value
      }]])
    }, [
      n.toggleable && a.$slots.header ? (S(), ye($_, {
        key: 0,
        onClick: l[0] || (l[0] = (c) => s()),
        active: i.value
      }, ca({
        right: G(() => [
          H(a.$slots, "headerRight")
        ]),
        default: G(() => [
          H(a.$slots, "header")
        ]),
        _: 2
      }, [
        a.$slots.headerSubtitle ? {
          name: "subtitle",
          fn: G(() => [
            H(a.$slots, "headerSubtitle")
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["active"])) : Z("", !0),
      o.value ? (S(), D("div", {
        key: 1,
        class: j(["vx-px-4 vx-pb-4 vx-text-slate-900 lg:vx-pb-8 lg:vx-px-8", [{
          "vx-pt-4 lg:vx-pt-8": !n.toggleable
        }]])
      }, [
        !n.toggleable && a.$slots.header ? (S(), ye($_, { key: 0 }, ca({
          right: G(() => [
            H(a.$slots, "headerRight")
          ]),
          default: G(() => [
            H(a.$slots, "header")
          ]),
          _: 2
        }, [
          a.$slots.headerSubtitle ? {
            name: "subtitle",
            fn: G(() => [
              H(a.$slots, "headerSubtitle")
            ]),
            key: "0"
          } : void 0
        ]), 1024)) : Z("", !0),
        H(a.$slots, "content")
      ], 2)) : Z("", !0)
    ], 2));
  }
}), spe = { class: "vx-relative vx-grow vx-font-sans" }, ope = { class: "vx-relative" }, ape = { class: "vx-flex vx-items-center vx-gap-1" }, lpe = { class: "vx-pointer-events-none vx-flex vx-items-center vx-gap-4" }, cpe = { class: "vx-relative vx-flex vx-h-4 vx-w-4 vx-items-center vx-justify-center" }, Zge = /* @__PURE__ */ oe({
  __name: "vx-filterable",
  props: {
    active: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["toggle"],
  setup(t, { emit: e }) {
    const n = e, r = t, i = le(r.active), s = () => {
      i.value = !i.value, n("toggle", i.value);
    }, o = () => {
      i.value = !1, n("toggle", i.value);
    };
    return Se(
      () => r.active,
      (a) => {
        i.value = a;
      }
    ), (a, l) => Yn((S(), D("div", spe, [
      B("button", {
        class: j(["vx-relative vx-flex vx-h-12 vx-w-full vx-grow vx-appearance-none vx-items-center vx-justify-between vx-rounded-t-xl vx-border-none vx-bg-white vx-p-5 vx-text-base vx-font-sans vx-shadow vx-outline-none vx-ring-offset-slate-300 vx-transition-all focus-visible:vx-ring-2 focus-visible:vx-ring-blue-500 focus-visible:vx-ring-offset-2 mouse:hover:vx-shadow-md", {
          "vx-rounded-b-xl": !i.value
        }]),
        tabindex: "0",
        onClick: s
      }, [
        B("span", ope, [
          B("span", ape, [
            H(a.$slots, "placeholder")
          ])
        ]),
        B("span", lpe, [
          B("span", cpe, [
            i.value ? (S(), ye(P(rt), {
              key: 0,
              icon: P(O3)
            }, null, 8, ["icon"])) : (S(), ye(P(rt), {
              key: 1,
              icon: P(xO)
            }, null, 8, ["icon"]))
          ])
        ])
      ], 2),
      re(Gn, {
        "enter-from-class": "vx-opacity-0 -vx-translate-y-4",
        "enter-to-class": "vx-opacity-100 vx-translate-y-0",
        "leave-from-class": "vx-opacity-100 vx-translate-y-0",
        "leave-to-class": "vx-opacity-0 -vx-translate-y-4"
      }, {
        default: G(() => [
          i.value ? (S(), D("div", {
            key: 0,
            class: "vx-absolute vx-z-20 vx-mb-8 vx-w-full vx-rounded-b-xl vx-border-t vx-border-slate-100 vx-bg-white vx-p-5 vx-shadow-xl vx-transition lg:vx-max-w-md",
            onClick: l[0] || (l[0] = Lt(() => {
            }, ["stop"]))
          }, [
            H(a.$slots, "form")
          ])) : Z("", !0)
        ]),
        _: 3
      })
    ])), [
      [P(Sd), o]
    ]);
  }
}), upe = { class: "vx-block vx-relative" }, fpe = { class: "vx-block vx-relative" }, hpe = {
  key: 0,
  class: "vx-mt-2 vx-px-0.5 vx-mb-1"
}, dpe = {
  key: 1,
  class: "vx-mt-2 vx-px-0.5 vx-text-xs vx-text-rose-800"
}, ppe = {
  key: 2,
  class: "vx-mt-2 vx-px-0.5 vx-text-xs vx-text-slate-600"
}, mpe = {
  inheritAttrs: !1
}, Jge = /* @__PURE__ */ oe({
  ...mpe,
  __name: "vx-input",
  props: {
    modelValue: {
      type: String
    },
    rows: {
      type: Number,
      default: 1,
      required: !1
    },
    autoresize: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "md"
    },
    error: {
      type: [String, Array],
      default: void 0
    },
    hint: {
      type: String,
      default: void 0
    },
    maxlength: {
      type: Number
    },
    minlength: {
      type: Number
    },
    minlengthWarning: {
      type: Number
    },
    counter: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(t, { expose: e, emit: n }) {
    const r = t, i = n, s = T(() => {
      const m = {
        field: ["vx-text-base", "vx-rounded-lg"],
        box: ["vx-text-base", "vx-rounded-l-lg"]
      };
      if (o.value || m.field.push("vx-h-10"), o.value && m.field.push("vx-py-[7px]"), r.size === "lg") {
        const v = {
          field: ["vx-text-base", "vx-rounded-xl"],
          box: ["vx-text-base", "vx-rounded-l-xl"]
        };
        return o.value || v.field.push("vx-h-12"), o.value && v.field.push("vx-py-[11px]"), v;
      }
      return m;
    }), o = T(() => r.rows && r.rows > 1 || r.autoresize), a = le(null), l = le(null), c = le(null), u = le(null), h = T(() => {
      var m, v;
      return c.value ? r.size === "lg" ? 60 : 55 : (m = l.value) != null && m.clientWidth ? ((v = l.value) == null ? void 0 : v.clientWidth) + 16 : 16;
    }), f = T(() => {
      var m, v;
      return (m = a.value) != null && m.clientWidth ? ((v = a.value) == null ? void 0 : v.clientWidth) + 20 : 16;
    }), d = (m) => {
      const v = m.target;
      i("update:modelValue", v.value);
    }, p = () => {
      !u.value || !r.autoresize || (u.value.style.height = "auto", u.value.style.height = u.value.scrollHeight + 2 + "px");
    };
    return Se(() => r.modelValue, () => {
      gt().then(p);
    }, {
      immediate: !0
    }), e({
      field: u
    }), (m, v) => (S(), D("div", upe, [
      B("div", fpe, [
        m.$slots.box ? (S(), D("div", {
          key: 0,
          ref_key: "box",
          ref: c,
          class: j(["vx-absolute vx-flex vx-items-center vx-justify-center vx-border vx-border-solid vx-h-full vx-w-12 vx-text-sm vx-bg-slate-100 vx-text-slate-900 vx-text-opacity-30", [{
            "vx-border-rose-300": r.error,
            "vx-border-slate-300": !r.error
          }, s.value.box]])
        }, [
          H(m.$slots, "box")
        ], 2)) : Z("", !0),
        (S(), ye(ht(o.value ? "textarea" : "input"), Nt({
          ref_key: "field",
          ref: u
        }, m.$attrs, {
          rows: r.rows,
          value: r.modelValue,
          onInput: d,
          maxlength: !r.counter && r.maxlength,
          minlength: !r.counter && r.minlength,
          class: ["vx-block vx-w-full vx-appearance-none vx-border vx-border-solid vx-bg-white vx-font-sans vx-text-slate-900 vx-transition focus:vx-outline-none focus:vx-ring-2 focus:vx-ring-blue-500 focus:vx-ring-offset-2 focus:vx-ring-offset-slate-50 disabled:vx-cursor-not-allowed disabled:vx-border-neutral-200 disabled:vx-bg-neutral-50 disabled:vx-text-neutral-500", [
            {
              "vx-border-rose-300 vx-text-rose-600": r.error,
              "vx-border-slate-300": !r.error,
              "vx-max-h-[50vh] vx-overflow-auto": o.value,
              "vx-resize-none": r.autoresize
            },
            s.value.field
          ]],
          style: {
            paddingRight: `${f.value}px`,
            paddingLeft: `${h.value}px`
          }
        }), null, 16, ["rows", "value", "maxlength", "minlength", "class", "style"])),
        m.$slots.left && !m.$slots.box ? (S(), D("div", {
          key: 1,
          ref_key: "leftSlot",
          ref: l,
          class: "vx-absolute vx-top-1/2 -vx-translate-y-1/2 vx-left-3"
        }, [
          H(m.$slots, "left")
        ], 512)) : Z("", !0),
        m.$slots.right ? (S(), D("div", {
          key: 2,
          ref_key: "rightSlot",
          ref: a,
          class: "vx-absolute vx-top-1/2 -vx-translate-y-1/2 vx-right-4"
        }, [
          H(m.$slots, "right")
        ], 512)) : Z("", !0)
      ]),
      r.counter && r.maxlength ? (S(), D("div", hpe, [
        re(e9, {
          characters: r.modelValue || "",
          max: r.maxlength,
          min: r.minlength,
          minWarning: r.minlengthWarning
        }, null, 8, ["characters", "max", "min", "minWarning"])
      ])) : Z("", !0),
      m.$slots.error || r.error ? (S(), D("div", dpe, [
        m.$slots.error ? H(m.$slots, "error", { key: 0 }) : Z("", !0),
        r.error ? (S(), D(_e, { key: 1 }, [
          Array.isArray(r.error) ? (S(!0), D(_e, { key: 0 }, Fe(r.error, (g) => (S(), D("div", { key: g }, Pe(g), 1))), 128)) : (S(), D(_e, { key: 1 }, [
            ft(Pe(r.error), 1)
          ], 64))
        ], 64)) : Z("", !0)
      ])) : Z("", !0),
      m.$slots.hint || r.hint ? (S(), D("div", ppe, [
        m.$slots.hint ? H(m.$slots, "hint", { key: 0 }) : Z("", !0),
        r.hint ? (S(), D(_e, { key: 1 }, [
          ft(Pe(r.hint), 1)
        ], 64)) : Z("", !0)
      ])) : Z("", !0)
    ]));
  }
}), gpe = {
  key: 0,
  class: "vx-block vx-text-slate-500 vx-text-sm vx-font-normal"
}, Qge = /* @__PURE__ */ oe({
  __name: "vx-label",
  props: {
    size: {
      type: String,
      default: "sm"
    }
  },
  setup(t) {
    const e = t;
    return (n, r) => (S(), D("label", {
      class: j({
        "vx-mb-1": !n.$slots.description,
        "vx-mb-2": n.$slots.description
      })
    }, [
      B("span", {
        class: j(["vx-flex vx-items-center vx-justify-between vx-font-extrabold vx-text-slate-800 vx-font-sans", {
          "vx-text-base": e.size === "md",
          "vx-text-sm": e.size === "sm"
        }])
      }, [
        H(n.$slots, "default")
      ], 2),
      n.$slots.description ? (S(), D("span", gpe, [
        H(n.$slots, "description")
      ])) : Z("", !0)
    ], 2));
  }
}), vpe = {}, ype = { class: "vx-flex vx-flex-col vx-border-solid vx-border-l-0 vx-border-r-0 vx-border-t vx-border-b vx-border-slate-100" };
function bpe(t, e) {
  return S(), D("div", ype, [
    H(t.$slots, "default")
  ]);
}
const e0e = /* @__PURE__ */ jt(vpe, [["render", bpe]]), xpe = {}, wpe = { class: "vx-flex vx-justify-center vx-items-center vx-rounded-[8px] vx-h-9 vx-w-9 vx-text-black" };
function kpe(t, e) {
  return S(), D("div", wpe, [
    H(t.$slots, "default")
  ]);
}
const t0e = /* @__PURE__ */ jt(xpe, [["render", kpe]]), n0e = /* @__PURE__ */ oe({
  __name: "vx-list-item",
  props: {
    href: {
      type: String,
      required: !1
    }
  },
  setup(t) {
    const e = t, n = T(() => e.href ? "a" : "button");
    return (r, i) => (S(), ye(ht(n.value), {
      href: t.href,
      class: "vx-flex vx-items-center vx-gap-3 vx-px-6 vx-py-2 vx-bg-white vx-transition-all vx-text-slate-500 vx-text-sm vx-font-normal vx-border-solid vx-border-l-0 vx-border-r-0 vx-border-t-0 vx-border-b vx-appearance-none last:vx-border-b-0 vx-border-slate-100 hover:vx-bg-slate-50 hover:vx-no-underline hover:vx-text-slate-500 active:vx-bg-slate-100"
    }, {
      default: G(() => [
        H(r.$slots, "default"),
        re(P(rt), {
          class: "vx-ml-auto vx-text-black",
          icon: P($3)
        }, null, 8, ["icon"])
      ]),
      _: 3
    }, 8, ["href"]));
  }
}), _pe = ["onClick"], Spe = { class: "vx-truncate vx-content-[''] vx-relative vx-transition after:vx-absolute after:-vx-inset-x-1 after:vx-top-1/2 after:vx-h-px after:vx-origin-left after:-vx-translate-y-1/2 after:vx-scale-x-0 after:vx-bg-black after:vx-transition peer-hover:vx-opacity-50 peer-hover:after:vx-scale-x-100" }, r0e = /* @__PURE__ */ oe({
  __name: "vx-list-animated",
  props: /* @__PURE__ */ Zm({
    value: {
      type: String,
      default: "value"
    },
    label: {
      type: String,
      default: "label"
    }
  }, {
    modelValue: {
      type: Array,
      required: !0
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Zm(["removed"], ["update:modelValue"]),
  setup(t, { emit: e }) {
    const n = j_(t, "modelValue"), r = t, i = e, s = (l) => {
      n.value = n.value.filter((c) => o(c) != o(l)), typeof l == "object" ? i("removed", { ...l }) : i("removed");
    }, o = (l) => typeof l == "object" ? l[r.value] : l, a = (l) => typeof l == "object" ? l[r.label] : l;
    return (l, c) => (S(), ye(f7, {
      tag: "div",
      class: "vx-relative",
      "enter-active-class": "vx-transition-all vx-transition-ease-out vx-duration-300 vx-origin-right",
      "enter-from-class": "vx-opacity-0 -vx-translate-y-20 vx-scale-95",
      "enter-to-class": "vx-opacity-100 vx-translate-y-0",
      "leave-active-class": "vx-transition-all vx-transition-ease-out vx-absolute vx-duration-150",
      "leave-from-class": "vx-opacity-100 vx-translate-y-0",
      "leave-to-class": "vx-opacity-0 vx-scale-90",
      "move-class": "vx-transition-all vx-transition-ease-out vx-duration-300"
    }, {
      default: G(() => [
        (S(!0), D(_e, null, Fe(n.value, (u, h) => (S(), D("div", {
          key: `animated-list-${o(u)}`,
          class: j(["vx-flex vx-w-full vx-flex-row-reverse vx-items-center vx-justify-between vx-border-0", {
            "vx-border-b vx-border-solid vx-border-b-slate-200": h !== n.value.length - 1
          }])
        }, [
          H(l.$slots, "remove", {}, () => [
            B("button", {
              onClick: (f) => s(u),
              class: "vx-group/del vx-peer vx-relative vx-px-4 vx-py-2 vx-transition vx-cursor-pointer vx-appearance-none vx-bg-transparent"
            }, [
              re(P(rt), {
                icon: P(yb),
                class: "vx-text-slate-400 vx-transition group-hover/del:vx-opacity-0"
              }, null, 8, ["icon"]),
              re(P(rt), {
                icon: P(yb),
                class: "vx-absolute vx-inset-0 vx-m-auto vx-text-rose-500 vx-opacity-0 vx-transition group-hover/del:vx-opacity-100"
              }, null, 8, ["icon"])
            ], 8, _pe)
          ]),
          H(l.$slots, "item", { item: u }, () => [
            B("span", Spe, Pe(a(u)), 1)
          ])
        ], 2))), 128))
      ]),
      _: 3
    }));
  }
}), Mpe = {}, Cpe = {
  width: "80",
  height: "86",
  viewBox: "0 0 80 86",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "vx-h-auto vx-w-14 vx-transition vx-duration-500"
}, $pe = /* @__PURE__ */ z_('<path d="M62.3172 0H17.6918C15.3683 -3.38786e-08 13.0674 0.457713 10.9208 1.347C8.7741 2.23629 6.82363 3.53973 5.18075 5.18289C3.53787 6.82605 2.23476 8.77674 1.34584 10.9236C0.456923 13.0704 -0.000396528 15.3713 2.57977e-07 17.6949V56.1571C2.57977e-07 60.8493 1.86396 65.3492 5.18182 68.6671C8.49968 71.985 12.9997 73.8489 17.6918 73.8489V85.4018L32.7643 73.8489H62.3081C67.0003 73.8489 71.5003 71.985 74.8182 68.6671C78.136 65.3492 80 60.8493 80 56.1571V17.6949C80.0008 13.0037 78.1384 8.50435 74.8224 5.18609C71.5065 1.86784 67.0083 0.00240317 62.3172 0Z" fill="#14ABE0"></path><line x1="24" y1="24" x2="24" y2="24" stroke-width="16" stroke="white" stroke-linecap="round"><animate attributeName="x2" dur="1.5s" repeatCount="indefinite" calcMode="spline" values="24;40;40;24" keyTimes="0;.25;.75;1" keySplines="1 0 .8 .6; 0 0 0 0; 0 .6 0 1"></animate><animate attributeName="y2" dur="1.5s" repeatCount="indefinite" calcMode="spline" values="24;50;50;24" keyTimes="0;.25;.75;1" keySplines="1 0 .8 .6;  0 0 0 0; 0 .6 0 1"></animate></line><line x1="40" y1="50" x2="40" y2="50" opacity="0" stroke-width="17" stroke="white" stroke-linecap="round"><animate attributeName="x1" dur="1.5s" repeatCount="indefinite" calcMode="spline" values="40;40;56;56;40;40" keyTimes="0;.25;.48;.5;.75;1" keySplines="0 0 0 0; 0 0.5 0 1; 0 0 0 0; .7 0 .8 .6; 0 0 0 0"></animate><animate attributeName="y1" dur="1.5s" repeatCount="indefinite" calcMode="spline" values="50;50;24;24;50;50" keyTimes="0;.25;.48;.5;.75;1" keySplines="0 0 0 0; 0 0.5 0 1; 0 0 0 0; .7 0 .8 .6; 0 0 0 0"></animate><animate attributeName="x2" dur="1.5s" repeatCount="indefinite" calcMode="spline" values="40;40;56;56;40;40" keyTimes="0;.3;.48;.6;.75;1" keySplines="0 0 0 0; 0 0.7 0 1; 0 0 0 0; 1 0 .8 .6; 0 0 0 0"></animate><animate attributeName="y2" dur="1.5s" repeatCount="indefinite" calcMode="spline" values="50;50;24;24;50;50" keyTimes="0;.3;.48;.6;.75;1" keySplines="0 0 0 0; 0 0.7 0 1; 0 0 0 0; 1 0 .8 .6; 0 0 0 0"></animate><animate attributeName="opacity" dur="1.5s" repeatCount="indefinite" values="0;0;1;1;0;0" keyTimes="0;.24;.26;.75;.75;1"></animate></line>', 3), Ape = [
  $pe
];
function Dpe(t, e) {
  return S(), D("svg", Cpe, Ape);
}
const i0e = /* @__PURE__ */ jt(Mpe, [["render", Dpe]]), Tpe = /* @__PURE__ */ oe({
  __name: "vx-navbar-action-marker",
  props: {
    active: {
      type: Boolean
    },
    open: {
      type: Boolean
    }
  },
  setup(t) {
    const e = t;
    return (n, r) => (S(), D("div", {
      class: j(["vx-absolute vx-bottom-0 vx-left-0 vx-right-0 vx-h-1.5 vx-rounded-tl vx-rounded-tr", {
        "vx-block vx-bg-sky-500": e.active,
        "sm:vx-hidden group-hover/item:sm:vx-block vx-bg-slate-500": !e.active,
        "vx-block": e.open && !e.active,
        "vx-hidden": !e.open && !e.active
      }])
    }, null, 2));
  }
}), Ope = { class: "vx-relative vx-h-full vx-w-full" }, Epe = {
  inheritAttrs: !1
}, vd = /* @__PURE__ */ oe({
  ...Epe,
  __name: "vx-navbar-action",
  props: {
    placement: {
      type: String,
      default: "left"
    },
    icon: {
      type: Object
    },
    href: {
      type: String,
      required: !1
    },
    active: {
      type: Boolean
    },
    open: {
      type: Boolean
    },
    nested: {
      type: Boolean
    }
  },
  emits: ["update:open"],
  setup(t, { emit: e }) {
    const n = t, r = xs(), i = T(() => {
      var d, p;
      const f = ((d = r.items) == null ? void 0 : d.call(r)) || [];
      return f.length === 1 && ((p = f[0].children) != null && p.length) ? f[0].children : f;
    }), s = T(() => {
      var f;
      return (f = r.default) != null && f.call(r).find(
        (d) => d.type === "button" || d.type === "a" || d.type === cs
      ) ? "div" : n.href ? "a" : "button";
    }), o = le(!1), a = e, l = le(!!n.open), c = () => {
      n.nested || (l.value = !1);
    }, u = () => {
      l.value = !l.value, a("update:open", l.value);
    };
    Se(
      () => n.open,
      (f) => {
        l.value = f;
      }
    );
    const h = () => {
      o.value = window.innerWidth < 640;
    };
    return rn(() => {
      gt().then(h), window.addEventListener("resize", h);
    }), Ba(() => {
      window.removeEventListener("resize", h);
    }), (f, d) => Yn((S(), D("div", {
      class: j(["vx-h-full vx-group/item sm:vx-relative vx-flex", {
        "vx-items-center": !n.nested,
        "vx-flex-col vx-items-start lg:vx-min-w-[224px] vx-w-full": n.nested
      }])
    }, [
      B("div", Ope, [
        (S(), ye(ht(s.value), Nt(f.$attrs, {
          href: n.href,
          onClick: d[0] || (d[0] = (p) => u()),
          class: ["vx-flex vx-items-center vx-text-sm vx-font-sans vx-cursor-pointer !vx-no-underline vx-whitespace-nowrap vx-group/item-pointer vx-bg-transparent vx-p-0", {
            "!vx-text-white vx-h-full vx-gap-2": !n.nested,
            "vx-justify-between vx-w-full": n.nested
          }]
        }), {
          default: G(() => [
            B("span", {
              class: j(["vx-flex vx-items-center vx-gap-2", {
                "!vx-text-slate-900 vx-justify-between vx-rounded vx-px-2 vx-py-1 group-hover/item-pointer:vx-bg-sky-100": n.nested
              }])
            }, [
              n.icon ? (S(), ye(P(rt), {
                key: 0,
                icon: n.icon,
                class: "vx-text-slate-400 vx-text-sm",
                "fixed-width": ""
              }, null, 8, ["icon"])) : Z("", !0),
              H(f.$slots, "default")
            ], 2),
            s.value !== "div" ? (S(), ye(P(rt), {
              key: 0,
              icon: n.href ? P($3) : n.nested && l.value ? P(vO) : P(D3),
              class: j({
                "vx-text-slate-900": n.nested
              })
            }, null, 8, ["icon", "class"])) : Z("", !0)
          ]),
          _: 3
        }, 16, ["href", "class"])),
        n.nested ? Z("", !0) : (S(), ye(Tpe, {
          key: 0,
          active: n.active,
          open: l.value
        }, null, 8, ["active", "open"]))
      ]),
      re(Gn, {
        "enter-from-class": "vx-opacity-0",
        "enter-to-class": "vx-opacity-100 ",
        "leave-from-class": "vx-opacity-100 ",
        "leave-to-class": "vx-opacity-0"
      }, {
        default: G(() => [
          f.$slots.items && l.value ? (S(), D("div", {
            key: 0,
            class: j(["vx-rounded-br vx-rounded-bl vx-bg-white vx-transition-opacity vx-duration-100 vx-ease-linear", {
              "vx-w-full": n.nested,
              "vx-shadow-lg vx-absolute vx-top-full vx-left-4 vx-w-[calc(100%_-_32px)] sm:vx-w-auto sm:vx-left-0": !n.nested,
              "sm:vx-right-0 sm:vx-left-auto": n.placement === "right" && !n.nested
            }])
          }, [
            n.nested ? Z("", !0) : (S(), D("div", {
              key: 0,
              class: j(["vx-hidden vx-h-1.5 vx-w-full vx-translate-y-[-6px] vx-bg-slate-500 sm:vx-block", {
                "vx-rounded-tl": n.placement === "right",
                "vx-rounded-tr": n.placement === "left"
              }])
            }, null, 2)),
            B("div", {
              class: j(["vx-flex vx-flex-col vx-items-start vx-px-4", {
                "vx-pt-5 sm:vx-pt-3 vx-pb-4 vx-gap-2": !n.nested
              }])
            }, [
              (S(!0), D(_e, null, Fe(i.value, (p, m) => {
                var v;
                return S(), ye(ht(p), {
                  key: ((v = p == null ? void 0 : p.props) == null ? void 0 : v.key) || `item-${m}`,
                  nested: p.type === vd || n.nested,
                  open: !(p.type === vd && o.value)
                }, null, 8, ["nested", "open"]);
              }), 128))
            ], 2)
          ], 2)) : Z("", !0)
        ]),
        _: 1
      })
    ], 2)), [
      [P(Sd), c]
    ]);
  }
}), Ppe = { class: "vx-bg-slate-700 vx-relative vx-flex vx-justify-between vx-items-center vx-h-16 vx-px-4 vx-max-w-full vx-z-20 sm:vx-h-20 sm:vx-px-6 md:vx-px-8" }, s0e = /* @__PURE__ */ oe({
  __name: "vx-navbar",
  props: {
    responsiveOffset: {
      type: Number,
      default: 160
    }
  },
  setup(t) {
    const e = t, n = le(!1), r = le(null), i = le(null), s = le(null), o = (p) => (p == null ? void 0 : p.offsetWidth) || 0, a = xs(), l = T(() => {
      var p;
      return la(_e, ((p = a.default) == null ? void 0 : p.call(a)) || []);
    }), c = le([]), u = le([]);
    let h;
    const f = () => {
      h && clearTimeout(h), h = setTimeout(() => {
        d();
      }, 500);
    }, d = async () => {
      var k;
      n.value = !1, await gt();
      let p = l.value.children;
      if (!p)
        return;
      p.length === 1 && ((k = p[0].children) != null && k.length) && (p = p[0].children);
      const v = o(s.value) + o(r.value) + 64 + e.responsiveOffset, g = o(i.value) - v, y = [], x = [];
      let b = 0, w = !1;
      p.forEach((_) => {
        var E;
        if (_.type !== vd)
          return;
        const C = ((E = _.el) == null ? void 0 : E.offsetWidth) || 0;
        C && (!w && b + C < g ? (b = b + C, y.push(_)) : (w = !0, x.push(_)));
      }), y.length === 1 && x.unshift(y.pop()), await gt(), c.value = y, u.value = x, n.value = !0;
    };
    return rn(async () => {
      await gt(), d(), window.addEventListener("resize", f);
    }), Ba(() => {
      window.removeEventListener("resize", f);
    }), (p, m) => (S(), D("div", Ppe, [
      B("div", {
        ref_key: "centerElement",
        ref: i,
        class: j(["vx-h-full vx-grow vx-flex vx-gap-2 sm:vx-gap-6 md:vx-gap-8", {
          "vx-overflow-hidden": !n.value
        }])
      }, [
        p.$slots.left ? (S(), D("div", {
          key: 0,
          ref_key: "leftElement",
          ref: r,
          class: "vx-flex vx-items-center vx-h-full"
        }, [
          H(p.$slots, "left")
        ], 512)) : Z("", !0),
        n.value ? (S(!0), D(_e, { key: 2 }, Fe(c.value, (v, g) => {
          var y;
          return S(), ye(ht(v), {
            key: ((y = v == null ? void 0 : v.props) == null ? void 0 : y.key) || `default-${g}`,
            nested: !1
          });
        }), 128)) : (S(), ye(P(l), { key: 1 })),
        !n.value || u.value.length ? (S(), ye(vd, { key: 3 }, {
          items: G(() => [
            (S(!0), D(_e, null, Fe(u.value, (v, g) => {
              var y;
              return S(), ye(ht(v), {
                key: ((y = v == null ? void 0 : v.props) == null ? void 0 : y.key) || `nested-${g}`,
                nested: !0
              });
            }), 128))
          ]),
          default: G(() => [
            Yn(re(cs, {
              size: "sm",
              color: "secondary"
            }, {
              default: G(() => [
                re(P(rt), {
                  class: "vx-text-sm",
                  icon: P(pO)
                }, null, 8, ["icon"])
              ]),
              _: 1
            }, 512), [
              [cc, !c.value.length]
            ]),
            Yn(B("span", null, [
              ft(" More "),
              re(P(rt), {
                class: "vx-ml-2",
                icon: P(D3)
              }, null, 8, ["icon"])
            ], 512), [
              [cc, c.value.length]
            ])
          ]),
          _: 1
        })) : Z("", !0)
      ], 2),
      B("div", {
        ref_key: "rightElement",
        ref: s,
        class: "vx-h-full vx-flex vx-gap-2 vx-items-center sm:vx-gap-4"
      }, [
        H(p.$slots, "right")
      ], 512)
    ]));
  }
}), Lpe = { class: "vx-cursor-pointer vx-flex vx-gap-2 vx-rounded vx-px-2 vx-py-1 vx-text-sm vx-text-slate-900 group-hover/subitem:vx-bg-sky-100 vx-text-left" }, o0e = /* @__PURE__ */ oe({
  __name: "vx-navbar-action-item",
  props: {
    active: {
      type: Boolean
    },
    nested: {
      type: Boolean
    },
    href: {
      type: String,
      required: !1
    }
  },
  setup(t) {
    const e = t, n = T(() => e.href ? "a" : "button");
    return (r, i) => (S(), ye(ht(n.value), {
      href: e.href,
      class: j(["vx-group/subitem vx-relative vx-flex vx-items-start vx-whitespace-nowrap vx-p-0 vx-bg-transparent vx-appearance-none vx-font-sans vx-w-full hover:vx-no-underline", {
        "vx-border-solid vx-border-slate-200 vx-border-y-0 vx-border-r-0 vx-border-l vx-pl-2": e.nested
      }])
    }, {
      default: G(() => [
        e.active ? (S(), D("div", {
          key: 0,
          class: j(["vx-absolute vx-block vx-h-full vx-w-1.5 vx-rounded-tr vx-rounded-br vx-bg-sky-500", {
            "!vx-block ": e.active,
            "-vx-left-4": !e.nested,
            "-vx-left-[33px]": e.nested
          }])
        }, null, 2)) : Z("", !0),
        B("div", Lpe, [
          H(r.$slots, "default")
        ])
      ]),
      _: 3
    }, 8, ["href", "class"]));
  }
}), Npe = {
  key: 0,
  class: "vx-absolute vx-h-px vx-opacity-30 vx-bg-sky-700 vx-bottom-0 vx-left-0 vx-w-full"
}, A_ = /* @__PURE__ */ oe({
  __name: "vx-navigation-item",
  props: {
    href: {
      type: String,
      required: !1
    },
    active: {
      type: Boolean,
      default: !1
    },
    value: {
      type: String,
      required: !1
    }
  },
  setup(t) {
    const e = t, n = T(() => e.href ? "a" : "button");
    return (r, i) => (S(), ye(ht(n.value), {
      href: t.href,
      class: j(["vx-border-0 vx-bg-transparent vx-text-xs vx-font-sans vx-inline-flex vx-items-center vx-justify-center vx-h-6 vx-gap-1 vx-relative vx-no-underline hover:vx-no-underline", {
        "vx-text-sky-700": e.active,
        "vx-text-slate-500": !e.active
      }])
    }, {
      default: G(() => [
        H(r.$slots, "default"),
        e.active ? (S(), D("span", Npe)) : Z("", !0)
      ]),
      _: 3
    }, 8, ["href", "class"]));
  }
}), Ipe = { class: "vx-relative vx-flex vx-gap-4" }, a0e = /* @__PURE__ */ oe({
  __name: "vx-navigation",
  props: {
    modelValue: {
      type: String,
      required: !1,
      default: "default"
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = xs(), r = t, i = e, s = (a) => {
      a && i("update:modelValue", a);
    }, o = T(() => {
      var l, c, u;
      const a = n.default ? n.default().filter((h) => h.type === A_) : [];
      return !a.length && ((u = (c = (l = n.default) == null ? void 0 : l.call(n)) == null ? void 0 : c[0].children) != null && u.length) ? n.default()[0].children.filter((h) => h.type === A_) : a;
    });
    return (a, l) => (S(), D("div", Ipe, [
      (S(!0), D(_e, null, Fe(o.value, (c, u) => (S(), D(_e, {
        key: `navigation-item-${u}`
      }, [
        c.props !== null ? (S(), ye(ht(c), {
          key: 0,
          value: c.props.value,
          onClick: (h) => {
            var f;
            return s((f = c.props) == null ? void 0 : f.value);
          },
          onKeyup: Yt((h) => {
            var f;
            return s((f = c.props) == null ? void 0 : f.value);
          }, ["enter"]),
          active: c.props.value === r.modelValue || c.props.active,
          role: "tab",
          "aria-selected": c.props.value === r.modelValue,
          tabindex: "0"
        }, null, 40, ["value", "onClick", "onKeyup", "active", "aria-selected"])) : Z("", !0)
      ], 64))), 128))
    ]));
  }
}), Rpe = {}, Bpe = { class: "vx-w-10 vx-aspect-square vx-h-10 vx-flex vx-items-center vx-justify-center vx-bg-slate-300 vx-rounded-full vx-text-xs vx-font-extrabold" };
function Fpe(t, e) {
  return S(), D("div", Bpe, [
    H(t.$slots, "default")
  ]);
}
const l0e = /* @__PURE__ */ jt(Rpe, [["render", Fpe]]);
var Yy = { exports: {} };
function JD(t, e = 100, n = {}) {
  if (typeof t != "function")
    throw new TypeError(`Expected the first parameter to be a function, got \`${typeof t}\`.`);
  if (e < 0)
    throw new RangeError("`wait` must not be negative.");
  const { immediate: r } = typeof n == "boolean" ? { immediate: n } : n;
  let i, s, o, a, l;
  function c() {
    const f = i, d = s;
    return i = void 0, s = void 0, l = t.apply(f, d), l;
  }
  function u() {
    const f = Date.now() - a;
    f < e && f >= 0 ? o = setTimeout(u, e - f) : (o = void 0, r || (l = c()));
  }
  const h = function(...f) {
    if (i && this !== i)
      throw new Error("Debounced method called with different contexts.");
    i = this, s = f, a = Date.now();
    const d = r && !o;
    return o || (o = setTimeout(u, e)), d && (l = c()), l;
  };
  return h.clear = () => {
    o && (clearTimeout(o), o = void 0);
  }, h.flush = () => {
    o && h.trigger();
  }, h.trigger = () => {
    l = c(), h.clear();
  }, h;
}
Yy.exports.debounce = JD;
Yy.exports = JD;
var zpe = Yy.exports;
const Xm = /* @__PURE__ */ RY(zpe);
function Vpe({
  arrowPadding: t,
  emit: e,
  locked: n,
  placement: r,
  popperElement: i,
  triggerElement: s
}) {
  const o = le(null), a = le(!1), l = (p) => {
    var m;
    (m = o.value) == null || m.setOptions((v) => ({
      ...v,
      modifiers: [
        ...v.modifiers || [],
        { name: "eventListeners", enabled: p }
      ]
    }));
  }, c = () => l(!0), u = () => l(!1), h = () => {
    a.value && (a.value = !1, e("close"));
  }, f = () => {
    a.value || (a.value = !0, e("open"));
  };
  Se([a, r], async ([p]) => {
    await gt(), p ? (await d(), c()) : u();
  });
  const d = async () => {
    var p;
    if (await gt(), !s.value) {
      console.error("[VxPopover] No trigger element");
      return;
    }
    if (!i.value) {
      console.error("[VxPopover] No popper element");
      return;
    }
    o.value = hJ(
      s.value,
      i.value,
      {
        placement: r.value,
        modifiers: [
          TA,
          AA,
          {
            name: "flip",
            enabled: !n.value
          },
          _A,
          {
            name: "arrow",
            options: {
              padding: t.value
            }
          }
        ]
      }
    ), (p = o.value) == null || p.update();
  };
  return Ba(() => {
    var p;
    (p = o.value) == null || p.destroy();
  }), {
    isOpen: a,
    popperInstance: o,
    open: f,
    close: h
  };
}
function Hpe(t, e, n) {
  let r = null;
  const i = le(!1);
  rn(() => {
    if ((t.content !== void 0 || n.value) && (i.value = !0), !e.value) {
      console.error("[VxPopover] No popper element");
      return;
    }
    r = new MutationObserver(s), r.observe(e.value, {
      childList: !0,
      subtree: !0
    });
  }), Ba(() => r == null ? void 0 : r.disconnect()), Se(n, (o) => {
    o ? i.value = !0 : i.value = !1;
  });
  const s = () => {
    t.content ? i.value = !0 : i.value = !1;
  };
  return {
    hasContent: i
  };
}
const Ype = {}, Wpe = {
  class: "vx-popover-arrow",
  "data-popper-arrow": ""
};
function jpe(t, e) {
  return S(), D("div", Wpe);
}
const qpe = /* @__PURE__ */ jt(Ype, [["render", jpe], ["__scopeId", "data-v-fa4695ba"]]), Upe = [
  "auto",
  "auto-start",
  "auto-end",
  "top",
  "top-start",
  "top-end",
  "bottom",
  "bottom-start",
  "bottom-end",
  "right",
  "right-start",
  "right-end",
  "left",
  "left-start",
  "left-end"
], Kpe = {
  /**
   * Preferred placement (the "auto" placements will choose the side with most space.)
   */
  placement: {
    type: String,
    default: "bottom",
    validator: (t) => Upe.includes(t)
  },
  /**
   * Disables automatically closing the popover when the user clicks away from it
   */
  disableClickAway: {
    type: Boolean,
    default: !1
  },
  /**
   * Trigger the popper on hover
   */
  hover: {
    type: Boolean,
    default: !1
  },
  /**
   * Manually open/close the Popper, other events are ignored if this prop is set
   */
  show: {
    type: Boolean,
    default: null
  },
  /**
   * Disables the Popper. If it was already open, it will be closed.
   */
  disabled: {
    type: Boolean,
    default: !1
  },
  /**
   * Open the Popper after a delay (ms).
   */
  openDelay: {
    type: Number,
    default: 0
  },
  /**
   * Close the Popper after a delay (ms).
   */
  closeDelay: {
    type: Number,
    default: 0
  },
  /**
   * The z-index of the Popper.
   */
  zIndex: {
    type: Number,
    default: 9999
  },
  /**
   * Display an arrow on the popper
   */
  arrow: {
    type: Boolean,
    default: !1
  },
  /**
   * Stop arrow from reaching the edge of the popper
   */
  arrowPadding: {
    type: Number,
    default: 0
  },
  /**
   * If the Popper should be interactive, it will close when clicked/hovered if false
   */
  interactive: {
    type: Boolean,
    default: !0
  },
  /**
   * Lock the Popper into place, it will not flip dynamically when it runs out of space if true
   */
  locked: {
    type: Boolean,
    default: !1
  },
  /**
   * If the content is just a simple string, it can be passed in as a prop
   */
  content: {
    type: String,
    default: null
  }
}, Gpe = { class: "vx-bg-white vx-border-none vx-font-sans vx-p-4 vx-rounded-lg vx-shadow-lg vx-text-slate-800 vx-text-sm vx-overflow-visible vx-transition vx-font-normal" }, c0e = /* @__PURE__ */ oe({
  __name: "vx-popover",
  props: Kpe,
  emits: ["open", "close"],
  setup(t, { emit: e }) {
    const n = e, r = xs(), i = t, s = le(), o = le(), a = le(), l = le(!1);
    rn(() => {
      var U;
      const F = (U = r.default) == null ? void 0 : U.call(r);
      if (F && F.length > 1)
        return console.error(
          `[VxPopover]: The <VxPopover> component expects only one child element at its root. You passed ${F.length} child nodes.`
        );
    });
    const {
      arrowPadding: c,
      closeDelay: u,
      content: h,
      disableClickAway: f,
      disabled: d,
      interactive: p,
      locked: m,
      openDelay: v,
      placement: g,
      show: y
    } = H_(i), { isOpen: x, open: b, close: w } = Vpe({
      arrowPadding: c,
      emit: n,
      locked: m,
      placement: g,
      popperElement: o,
      triggerElement: a
    }), { hasContent: k } = Hpe(r, o, h), _ = T(() => y.value !== null), C = T(() => d.value || !k.value), E = T(() => x.value && !C.value), L = T(
      () => !f.value && !_.value
    ), M = Xm(b, v.value), O = Xm(w, u.value), N = async () => {
      C.value || _.value || (O.clear(), M());
    }, R = async () => {
      _.value || (M.clear(), O());
    }, $ = () => {
      x.value ? R() : N();
    };
    return Se([k, d], ([F, U]) => {
      x.value && (!F || U) && w();
    }), Se(x, (F) => {
      F ? l.value = !0 : Xm(() => {
        l.value = !1;
      }, 200);
    }), lc(() => {
      _.value && (y.value ? M() : O());
    }), lc(() => {
      L.value && o9(s, R);
    }), (F, U) => (S(), D("div", {
      class: "vx-inline-block",
      onMouseleave: U[2] || (U[2] = (ee) => F.hover && R()),
      ref_key: "containerElement",
      ref: s
    }, [
      B("div", {
        ref_key: "triggerElement",
        ref: a,
        onMouseover: U[0] || (U[0] = (ee) => F.hover && N()),
        onClick: $,
        onFocus: N,
        onKeyup: Yt(R, ["esc"])
      }, [
        H(F.$slots, "default")
      ], 544),
      re(Gn, {
        "enter-from-class": "vx-opacity-0",
        "enter-to-class": "vx-opacity-100",
        "leave-from-class": "vx-opacity-100",
        "leave-to-class": "vx-opacity-0"
      }, {
        default: G(() => [
          Yn(B("div", {
            onClick: U[1] || (U[1] = (ee) => !P(p) && R()),
            class: j(["vx-popover", {
              "vx-pb-2": i.placement.includes("top"),
              "vx-pr-3": i.placement.includes("left"),
              "vx-pl-3": i.placement.includes("right")
            }]),
            style: yt({
              zIndex: i.zIndex
            }),
            ref_key: "popperElement",
            ref: o
          }, [
            B("div", Gpe, [
              H(F.$slots, "content", {
                close: P(w),
                isOpen: l.value
              }, () => [
                ft(Pe(P(h)), 1)
              ]),
              i.arrow ? (S(), ye(qpe, { key: 0 })) : Z("", !0)
            ])
          ], 6), [
            [cc, E.value]
          ])
        ]),
        _: 3
      })
    ], 544));
  }
}), Xpe = {
  key: 0,
  class: "vx-rounded-full vx-h-[10px] vx-w-[10px] vx-bg-sky-500"
}, Zpe = /* @__PURE__ */ oe({
  __name: "vx-radio",
  props: {
    modelValue: {
      type: Boolean
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, r = e, i = () => {
      n.disabled || r("update:modelValue", !n.modelValue);
    };
    return (s, o) => (S(), D("div", {
      class: j(["vx-rounded-full vx-h-4 vx-w-4 vx-border-solid vx-border-[1.5px] vx-flex vx-items-center vx-justify-center vx-shrink-0", {
        "vx-border-slate-400": !n.modelValue,
        "vx-border-sky-500": n.modelValue,
        "vx-opacity-60 vx-cursor-not-allowed": n.disabled,
        "vx-cursor-pointer": !n.disabled
      }]),
      onClick: i
    }, [
      n.modelValue ? (S(), D("div", Xpe)) : Z("", !0)
    ], 2));
  }
}), Jpe = ["aria-selected"], Qpe = { class: "vx-grow-0" }, eme = { class: "vx-ml-2 vx-grow lg:vx-ml-4" }, tme = { class: "vx-text-slate-800 vx-text-sm vx-leading-4 vx-font-semibold vx-flex vx-items-center vx-justify-between" }, nme = {
  key: 0,
  class: "vx-transition vx-basis-full lg:vx-hidden"
}, D_ = "vx-text-slate-500 vx-text-xs", rme = /* @__PURE__ */ oe({
  __name: "vx-radio-selection-item",
  props: {
    active: {
      type: Boolean,
      required: !1,
      default: !1
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    value: {
      type: String
    }
  },
  emits: ["selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, i = () => {
      n.disabled || r("selected", n.value);
    }, s = le(!1), o = (a) => {
      a.stopPropagation(), s.value = !s.value;
    };
    return (a, l) => (S(), D("div", {
      onClick: l[1] || (l[1] = Lt((c) => i(), ["prevent"])),
      tabindex: "0",
      onKeydown: [
        l[2] || (l[2] = Yt(Lt((c) => i(), ["prevent"]), ["space"])),
        l[3] || (l[3] = Yt(Lt((c) => i(), ["prevent"]), ["enter"]))
      ],
      "aria-selected": n.active,
      class: j(["vx-flex vx-items-center vx-py-1.5 vx-pl-4 vx-pr-2 vx-border vx-border-solid vx-rounded-xl vx-font-sans vx-flex-wrap lg:vx-flex-nowrap lg:vx-py-4 lg:vx-px-5", {
        "vx-bg-slate-50 vx-border-slate-300": !n.active,
        "vx-bg-white vx-border-sky-500": n.active,
        "vx-opacity-60 vx-cursor-not-allowed": n.disabled,
        "vx-cursor-pointer": !n.disabled
      }])
    }, [
      B("div", Qpe, [
        re(Zpe, {
          "model-value": n.active,
          disabled: n.disabled
        }, null, 8, ["model-value", "disabled"])
      ]),
      B("div", eme, [
        B("div", tme, [
          H(a.$slots, "header"),
          H(a.$slots, "default"),
          re(cs, {
            class: j(["lg:vx-hidden", {
              "vx-opacity-0 vx-pointer-events-none": !a.$slots.content
              // hide button without breaking height on mobile
            }]),
            type: "button",
            onClick: l[0] || (l[0] = (c) => o(c)),
            size: "sm",
            color: n.active ? "muted-light" : "muted"
          }, {
            default: G(() => [
              re(P(rt), {
                icon: s.value ? P(C3) : P(A3),
                class: "vx-text-sm vx-mx-0.5"
              }, null, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["class", "color"])
        ]),
        a.$slots.content ? (S(), D("p", {
          key: 0,
          class: j([D_, "vx-hidden vx-mt-1 lg:vx-block"])
        }, [
          H(a.$slots, "content")
        ], 2)) : Z("", !0)
      ]),
      re(Gn, {
        "enter-from-class": "vx-opacity-0 -vx-translate-y-4 vx-duration-300",
        "enter-to-class": "vx-opacity-100 vx-translate-y-0 vx-duration-300",
        "leave-from-class": "vx-opacity-100 vx-duration-0",
        "leave-to-class": "vx-opacity-0 vx-duration-0"
      }, {
        default: G(() => [
          s.value && a.$slots.content ? (S(), D("div", nme, [
            B("p", {
              class: j([D_, "vx-mb-1"])
            }, [
              H(a.$slots, "content")
            ], 2)
          ])) : Z("", !0)
        ]),
        _: 3
      })
    ], 42, Jpe));
  }
}), u0e = /* @__PURE__ */ oe({
  __name: "vx-radio-selection",
  props: {
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    modelValue: {
      type: String,
      required: !1
    },
    class: {
      type: String,
      required: !1,
      default: "vx-flex vx-flex-col vx-gap-2"
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, r = e, i = xs(), s = T(() => {
      var l, c;
      let a = ((l = i.default) == null ? void 0 : l.call(i)) || [];
      return a.length === 1 && ((c = a[0].children) != null && c.length) && (a = a[0].children), a.filter((u) => u.type === rme);
    }), o = (a) => {
      n.disabled || r("update:modelValue", a);
    };
    return (a, l) => (S(), D("div", {
      class: j(n.class)
    }, [
      (S(!0), D(_e, null, Fe(s.value, (c, u) => (S(), D(_e, {
        key: `radio-selection-item-${String(c.key || u)}`
      }, [
        c.props !== null ? (S(), ye(ht(c), {
          key: 0,
          value: c.props.value,
          onSelected: (h) => {
            var f;
            return o((f = c.props) == null ? void 0 : f.value);
          },
          active: c.props.value === n.modelValue,
          disabled: c.props.disabled || n.disabled
        }, null, 40, ["value", "onSelected", "active", "disabled"])) : Z("", !0)
      ], 64))), 128))
    ], 2));
  }
}), ime = { class: "vx-block vx-w-full vx-m-0" }, sme = { class: "vx-relative" }, ome = ["value"], ame = ["value"], lme = {
  key: 0,
  class: "vx-mt-1 vx-pl-0.5 vx-text-xs vx-text-rose-800"
}, cme = {
  inheritAttrs: !1
}, f0e = /* @__PURE__ */ oe({
  ...cme,
  __name: "vx-select",
  props: {
    options: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: "lg"
    },
    modelValue: {},
    error: {
      type: String,
      default: void 0
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, r = e, i = (o) => {
      r("update:modelValue", o.target.value);
    }, s = T(() => {
      const o = {
        element: ["vx-h-12"]
      };
      return n.size === "xs" ? {
        element: ["vx-h-6"]
      } : n.size === "sm" ? {
        element: ["vx-h-8"]
      } : n.size === "md" ? {
        element: ["vx-h-10"]
      } : n.size === "lg" ? o : n.size === "xl" ? {
        element: ["vx-h-16"]
      } : o;
    });
    return (o, a) => (S(), D("label", ime, [
      B("div", sme, [
        B("select", Nt(o.$attrs, {
          value: n.modelValue,
          onChange: i,
          class: [[s.value.element, {
            "vx-border vx-border-solid vx-border-rose-300 vx-text-rose-600": n.error,
            "vx-border-none": !n.error
          }], "vx-shadow mouse:hover:vx-shadow-md vx-relative vx-block vx-w-full vx-appearance-none vx-rounded-lg vx-bg-white vx-pl-4 vx-pr-11 vx-font-sans vx-text-base vx-transition focus:vx-outline-none focus:vx-ring-2 focus:vx-ring-blue-500 focus:vx-ring-offset-2 focus:vx-ring-offset-slate-50 disabled:vx-cursor-not-allowed disabled:vx-border-neutral-200 disabled:vx-bg-neutral-50 disabled:vx-text-neutral-500"]
        }), [
          (S(!0), D(_e, null, Fe(n.options, (l) => (S(), D("option", {
            value: l.value,
            key: l.value
          }, Pe(l.label), 9, ame))), 128))
        ], 16, ome),
        re(P(rt), {
          class: j(["vx-pointer-events-none vx-absolute vx-right-4 vx-top-1/2 -vx-translate-y-1/2", { "vx-text-rose-600": n.error }]),
          icon: P(Tv)
        }, null, 8, ["class", "icon"])
      ]),
      t.error ? (S(), D("div", lme, Pe(t.error), 1)) : Z("", !0)
    ]));
  }
});
var ume = Object.defineProperty, fme = Object.defineProperties, hme = Object.getOwnPropertyDescriptors, T_ = Object.getOwnPropertySymbols, dme = Object.prototype.hasOwnProperty, pme = Object.prototype.propertyIsEnumerable, O_ = (t, e, n) => e in t ? ume(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, Bo = (t, e) => {
  for (var n in e || (e = {}))
    dme.call(e, n) && O_(t, n, e[n]);
  if (T_)
    for (var n of T_(e))
      pme.call(e, n) && O_(t, n, e[n]);
  return t;
}, E_ = (t, e) => fme(t, hme(e));
const mme = {
  props: {
    autoscroll: {
      type: Boolean,
      default: !0
    }
  },
  watch: {
    typeAheadPointer() {
      this.autoscroll && this.maybeAdjustScroll();
    },
    open(t) {
      this.autoscroll && t && this.$nextTick(() => this.maybeAdjustScroll());
    }
  },
  methods: {
    maybeAdjustScroll() {
      var t;
      const e = ((t = this.$refs.dropdownMenu) == null ? void 0 : t.children[this.typeAheadPointer]) || !1;
      if (e) {
        const n = this.getDropdownViewport(), { top: r, bottom: i, height: s } = e.getBoundingClientRect();
        if (r < n.top)
          return this.$refs.dropdownMenu.scrollTop = e.offsetTop;
        if (i > n.bottom)
          return this.$refs.dropdownMenu.scrollTop = e.offsetTop - (n.height - s);
      }
    },
    getDropdownViewport() {
      return this.$refs.dropdownMenu ? this.$refs.dropdownMenu.getBoundingClientRect() : {
        height: 0,
        top: 0,
        bottom: 0
      };
    }
  }
}, gme = {
  data() {
    return {
      typeAheadPointer: -1
    };
  },
  watch: {
    filteredOptions() {
      for (let t = 0; t < this.filteredOptions.length; t++)
        if (this.selectable(this.filteredOptions[t])) {
          this.typeAheadPointer = t;
          break;
        }
    },
    open(t) {
      t && this.typeAheadToLastSelected();
    },
    selectedValue() {
      this.open && this.typeAheadToLastSelected();
    }
  },
  methods: {
    typeAheadUp() {
      for (let t = this.typeAheadPointer - 1; t >= 0; t--)
        if (this.selectable(this.filteredOptions[t])) {
          this.typeAheadPointer = t;
          break;
        }
    },
    typeAheadDown() {
      for (let t = this.typeAheadPointer + 1; t < this.filteredOptions.length; t++)
        if (this.selectable(this.filteredOptions[t])) {
          this.typeAheadPointer = t;
          break;
        }
    },
    typeAheadSelect() {
      const t = this.filteredOptions[this.typeAheadPointer];
      t && this.selectable(t) && this.select(t);
    },
    typeAheadToLastSelected() {
      this.typeAheadPointer = this.selectedValue.length !== 0 ? this.filteredOptions.indexOf(this.selectedValue[this.selectedValue.length - 1]) : -1;
    }
  }
}, vme = {
  props: {
    loading: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      mutableLoading: !1
    };
  },
  watch: {
    search() {
      this.$emit("search", this.search, this.toggleLoading);
    },
    loading(t) {
      this.mutableLoading = t;
    }
  },
  methods: {
    toggleLoading(t = null) {
      return t == null ? this.mutableLoading = !this.mutableLoading : this.mutableLoading = t;
    }
  }
}, Wy = (t, e) => {
  const n = t.__vccOpts || t;
  for (const [r, i] of e)
    n[r] = i;
  return n;
}, yme = {}, bme = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "10"
}, xme = /* @__PURE__ */ B("path", { d: "M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z" }, null, -1), wme = [
  xme
];
function kme(t, e) {
  return S(), D("svg", bme, wme);
}
const _me = /* @__PURE__ */ Wy(yme, [["render", kme]]), Sme = {}, Mme = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "10"
}, Cme = /* @__PURE__ */ B("path", { d: "M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z" }, null, -1), $me = [
  Cme
];
function Ame(t, e) {
  return S(), D("svg", Mme, $me);
}
const Dme = /* @__PURE__ */ Wy(Sme, [["render", Ame]]), P_ = {
  Deselect: _me,
  OpenIndicator: Dme
}, Tme = {
  mounted(t, { instance: e }) {
    if (e.appendToBody) {
      const {
        height: n,
        top: r,
        left: i,
        width: s
      } = e.$refs.toggle.getBoundingClientRect();
      let o = window.scrollX || window.pageXOffset, a = window.scrollY || window.pageYOffset;
      t.unbindPosition = e.calculatePosition(t, e, {
        width: s + "px",
        left: o + i + "px",
        top: a + r + n + "px"
      }), document.body.appendChild(t);
    }
  },
  unmounted(t, { instance: e }) {
    e.appendToBody && (t.unbindPosition && typeof t.unbindPosition == "function" && t.unbindPosition(), t.parentNode && t.parentNode.removeChild(t));
  }
};
function Ome(t) {
  const e = {};
  return Object.keys(t).sort().forEach((n) => {
    e[n] = t[n];
  }), JSON.stringify(e);
}
let Eme = 0;
function Pme() {
  return ++Eme;
}
const Lme = {
  components: Bo({}, P_),
  directives: { appendToBody: Tme },
  mixins: [mme, gme, vme],
  compatConfig: {
    MODE: 3
  },
  emits: [
    "open",
    "close",
    "update:modelValue",
    "search",
    "search:compositionstart",
    "search:compositionend",
    "search:keydown",
    "search:blur",
    "search:focus",
    "search:input",
    "option:created",
    "option:selecting",
    "option:selected",
    "option:deselecting",
    "option:deselected"
  ],
  props: {
    modelValue: {},
    components: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    clearable: {
      type: Boolean,
      default: !0
    },
    deselectFromDropdown: {
      type: Boolean,
      default: !1
    },
    searchable: {
      type: Boolean,
      default: !0
    },
    multiple: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    transition: {
      type: String,
      default: "vs__fade"
    },
    clearSearchOnSelect: {
      type: Boolean,
      default: !0
    },
    closeOnSelect: {
      type: Boolean,
      default: !0
    },
    label: {
      type: String,
      default: "label"
    },
    autocomplete: {
      type: String,
      default: "off"
    },
    reduce: {
      type: Function,
      default: (t) => t
    },
    selectable: {
      type: Function,
      default: (t) => !0
    },
    getOptionLabel: {
      type: Function,
      default(t) {
        return typeof t == "object" ? t.hasOwnProperty(this.label) ? t[this.label] : console.warn(`[vue-select warn]: Label key "option.${this.label}" does not exist in options object ${JSON.stringify(t)}.
https://vue-select.org/api/props.html#getoptionlabel`) : t;
      }
    },
    getOptionKey: {
      type: Function,
      default(t) {
        if (typeof t != "object")
          return t;
        try {
          return t.hasOwnProperty("id") ? t.id : Ome(t);
        } catch (e) {
          return console.warn(`[vue-select warn]: Could not stringify this option to generate unique key. Please provide'getOptionKey' prop to return a unique key for each option.
https://vue-select.org/api/props.html#getoptionkey`, t, e);
        }
      }
    },
    onTab: {
      type: Function,
      default: function() {
        this.selectOnTab && !this.isComposing && this.typeAheadSelect();
      }
    },
    taggable: {
      type: Boolean,
      default: !1
    },
    tabindex: {
      type: Number,
      default: null
    },
    pushTags: {
      type: Boolean,
      default: !1
    },
    filterable: {
      type: Boolean,
      default: !0
    },
    filterBy: {
      type: Function,
      default(t, e, n) {
        return (e || "").toLocaleLowerCase().indexOf(n.toLocaleLowerCase()) > -1;
      }
    },
    filter: {
      type: Function,
      default(t, e) {
        return t.filter((n) => {
          let r = this.getOptionLabel(n);
          return typeof r == "number" && (r = r.toString()), this.filterBy(n, r, e);
        });
      }
    },
    createOption: {
      type: Function,
      default(t) {
        return typeof this.optionList[0] == "object" ? { [this.label]: t } : t;
      }
    },
    resetOnOptionsChange: {
      default: !1,
      validator: (t) => ["function", "boolean"].includes(typeof t)
    },
    clearSearchOnBlur: {
      type: Function,
      default: function({ clearSearchOnSelect: t, multiple: e }) {
        return t && !e;
      }
    },
    noDrop: {
      type: Boolean,
      default: !1
    },
    inputId: {
      type: String
    },
    dir: {
      type: String,
      default: "auto"
    },
    selectOnTab: {
      type: Boolean,
      default: !1
    },
    selectOnKeyCodes: {
      type: Array,
      default: () => [13]
    },
    searchInputQuerySelector: {
      type: String,
      default: "[type=search]"
    },
    mapKeydown: {
      type: Function,
      default: (t, e) => t
    },
    appendToBody: {
      type: Boolean,
      default: !1
    },
    calculatePosition: {
      type: Function,
      default(t, e, { width: n, top: r, left: i }) {
        t.style.top = r, t.style.left = i, t.style.width = n;
      }
    },
    dropdownShouldOpen: {
      type: Function,
      default({ noDrop: t, open: e, mutableLoading: n }) {
        return t ? !1 : e && !n;
      }
    },
    uid: {
      type: [String, Number],
      default: () => Pme()
    }
  },
  data() {
    return {
      search: "",
      open: !1,
      isComposing: !1,
      pushedTags: [],
      _value: [],
      deselectButtons: []
    };
  },
  computed: {
    isReducingValues() {
      return this.$props.reduce !== this.$options.props.reduce.default;
    },
    isTrackingValues() {
      return typeof this.modelValue == "undefined" || this.isReducingValues;
    },
    selectedValue() {
      let t = this.modelValue;
      return this.isTrackingValues && (t = this.$data._value), t != null && t !== "" ? [].concat(t) : [];
    },
    optionList() {
      return this.options.concat(this.pushTags ? this.pushedTags : []);
    },
    searchEl() {
      return this.$slots.search ? this.$refs.selectedOptions.querySelector(this.searchInputQuerySelector) : this.$refs.search;
    },
    scope() {
      const t = {
        search: this.search,
        loading: this.loading,
        searching: this.searching,
        filteredOptions: this.filteredOptions
      };
      return {
        search: {
          attributes: Bo({
            disabled: this.disabled,
            placeholder: this.searchPlaceholder,
            tabindex: this.tabindex,
            readonly: !this.searchable,
            id: this.inputId,
            "aria-autocomplete": "list",
            "aria-labelledby": `vs${this.uid}__combobox`,
            "aria-controls": `vs${this.uid}__listbox`,
            ref: "search",
            type: "search",
            autocomplete: this.autocomplete,
            value: this.search
          }, this.dropdownOpen && this.filteredOptions[this.typeAheadPointer] ? {
            "aria-activedescendant": `vs${this.uid}__option-${this.typeAheadPointer}`
          } : {}),
          events: {
            compositionstart: () => this.isComposing = !0,
            compositionend: () => this.isComposing = !1,
            keydown: this.onSearchKeyDown,
            blur: this.onSearchBlur,
            focus: this.onSearchFocus,
            input: (e) => this.search = e.target.value
          }
        },
        spinner: {
          loading: this.mutableLoading
        },
        noOptions: {
          search: this.search,
          loading: this.mutableLoading,
          searching: this.searching
        },
        openIndicator: {
          attributes: {
            ref: "openIndicator",
            role: "presentation",
            class: "vs__open-indicator"
          }
        },
        listHeader: t,
        listFooter: t,
        header: E_(Bo({}, t), { deselect: this.deselect }),
        footer: E_(Bo({}, t), { deselect: this.deselect })
      };
    },
    childComponents() {
      return Bo(Bo({}, P_), this.components);
    },
    stateClasses() {
      return {
        "vs--open": this.dropdownOpen,
        "vs--single": !this.multiple,
        "vs--multiple": this.multiple,
        "vs--searching": this.searching && !this.noDrop,
        "vs--searchable": this.searchable && !this.noDrop,
        "vs--unsearchable": !this.searchable,
        "vs--loading": this.mutableLoading,
        "vs--disabled": this.disabled
      };
    },
    searching() {
      return !!this.search;
    },
    dropdownOpen() {
      return this.dropdownShouldOpen(this);
    },
    searchPlaceholder() {
      return this.isValueEmpty && this.placeholder ? this.placeholder : void 0;
    },
    filteredOptions() {
      const t = [].concat(this.optionList);
      if (!this.filterable && !this.taggable)
        return t;
      const e = this.search.length ? this.filter(t, this.search, this) : t;
      if (this.taggable && this.search.length) {
        const n = this.createOption(this.search);
        this.optionExists(n) || e.unshift(n);
      }
      return e;
    },
    isValueEmpty() {
      return this.selectedValue.length === 0;
    },
    showClearButton() {
      return !this.multiple && this.clearable && !this.open && !this.isValueEmpty;
    }
  },
  watch: {
    options(t, e) {
      const n = () => typeof this.resetOnOptionsChange == "function" ? this.resetOnOptionsChange(t, e, this.selectedValue) : this.resetOnOptionsChange;
      !this.taggable && n() && this.clearSelection(), this.modelValue && this.isTrackingValues && this.setInternalValueFromOptions(this.modelValue);
    },
    modelValue: {
      immediate: !0,
      handler(t) {
        this.isTrackingValues && this.setInternalValueFromOptions(t);
      }
    },
    multiple() {
      this.clearSelection();
    },
    open(t) {
      this.$emit(t ? "open" : "close");
    }
  },
  created() {
    this.mutableLoading = this.loading;
  },
  methods: {
    setInternalValueFromOptions(t) {
      Array.isArray(t) ? this.$data._value = t.map((e) => this.findOptionFromReducedValue(e)) : this.$data._value = this.findOptionFromReducedValue(t);
    },
    select(t) {
      this.$emit("option:selecting", t), this.isOptionSelected(t) ? this.deselectFromDropdown && (this.clearable || this.multiple && this.selectedValue.length > 1) && this.deselect(t) : (this.taggable && !this.optionExists(t) && (this.$emit("option:created", t), this.pushTag(t)), this.multiple && (t = this.selectedValue.concat(t)), this.updateValue(t), this.$emit("option:selected", t)), this.onAfterSelect(t);
    },
    deselect(t) {
      this.$emit("option:deselecting", t), this.updateValue(this.selectedValue.filter((e) => !this.optionComparator(e, t))), this.$emit("option:deselected", t);
    },
    clearSelection() {
      this.updateValue(this.multiple ? [] : null);
    },
    onAfterSelect(t) {
      this.closeOnSelect && (this.open = !this.open, this.searchEl.blur()), this.clearSearchOnSelect && (this.search = "");
    },
    updateValue(t) {
      typeof this.modelValue == "undefined" && (this.$data._value = t), t !== null && (Array.isArray(t) ? t = t.map((e) => this.reduce(e)) : t = this.reduce(t)), this.$emit("update:modelValue", t);
    },
    toggleDropdown(t) {
      const e = t.target !== this.searchEl;
      e && t.preventDefault();
      const n = [
        ...this.deselectButtons || [],
        this.$refs.clearButton
      ];
      if (this.searchEl === void 0 || n.filter(Boolean).some((r) => r.contains(t.target) || r === t.target)) {
        t.preventDefault();
        return;
      }
      this.open && e ? this.searchEl.blur() : this.disabled || (this.open = !0, this.searchEl.focus());
    },
    isOptionSelected(t) {
      return this.selectedValue.some((e) => this.optionComparator(e, t));
    },
    isOptionDeselectable(t) {
      return this.isOptionSelected(t) && this.deselectFromDropdown;
    },
    optionComparator(t, e) {
      return this.getOptionKey(t) === this.getOptionKey(e);
    },
    findOptionFromReducedValue(t) {
      const e = (r) => JSON.stringify(this.reduce(r)) === JSON.stringify(t), n = [...this.options, ...this.pushedTags].filter(e);
      return n.length === 1 ? n[0] : n.find((r) => this.optionComparator(r, this.$data._value)) || t;
    },
    closeSearchOptions() {
      this.open = !1, this.$emit("search:blur");
    },
    maybeDeleteValue() {
      if (!this.searchEl.value.length && this.selectedValue && this.selectedValue.length && this.clearable) {
        let t = null;
        this.multiple && (t = [
          ...this.selectedValue.slice(0, this.selectedValue.length - 1)
        ]), this.updateValue(t);
      }
    },
    optionExists(t) {
      return this.optionList.some((e) => this.optionComparator(e, t));
    },
    normalizeOptionForSlot(t) {
      return typeof t == "object" ? t : { [this.label]: t };
    },
    pushTag(t) {
      this.pushedTags.push(t);
    },
    onEscape() {
      this.search.length ? this.search = "" : this.searchEl.blur();
    },
    onSearchBlur() {
      if (this.mousedown && !this.searching)
        this.mousedown = !1;
      else {
        const { clearSearchOnSelect: t, multiple: e } = this;
        this.clearSearchOnBlur({ clearSearchOnSelect: t, multiple: e }) && (this.search = ""), this.closeSearchOptions();
        return;
      }
      if (this.search.length === 0 && this.options.length === 0) {
        this.closeSearchOptions();
        return;
      }
    },
    onSearchFocus() {
      this.open = !0, this.$emit("search:focus");
    },
    onMousedown() {
      this.mousedown = !0;
    },
    onMouseUp() {
      this.mousedown = !1;
    },
    onSearchKeyDown(t) {
      const e = (i) => (i.preventDefault(), !this.isComposing && this.typeAheadSelect()), n = {
        8: (i) => this.maybeDeleteValue(),
        9: (i) => this.onTab(),
        27: (i) => this.onEscape(),
        38: (i) => (i.preventDefault(), this.typeAheadUp()),
        40: (i) => (i.preventDefault(), this.typeAheadDown())
      };
      this.selectOnKeyCodes.forEach((i) => n[i] = e);
      const r = this.mapKeydown(n, this);
      if (typeof r[t.keyCode] == "function")
        return r[t.keyCode](t);
    }
  }
}, Nme = ["dir"], Ime = ["id", "aria-expanded", "aria-owns"], Rme = {
  ref: "selectedOptions",
  class: "vs__selected-options"
}, Bme = ["disabled", "title", "aria-label", "onClick"], Fme = {
  ref: "actions",
  class: "vs__actions"
}, zme = ["disabled"], Vme = { class: "vs__spinner" }, Hme = ["id"], Yme = ["id", "aria-selected", "onMouseover", "onClick"], Wme = {
  key: 0,
  class: "vs__no-options"
}, jme = /* @__PURE__ */ ft(" Sorry, no matching options. "), qme = ["id"];
function Ume(t, e, n, r, i, s) {
  const o = Y_("append-to-body");
  return S(), D("div", {
    dir: n.dir,
    class: j(["v-select", s.stateClasses])
  }, [
    H(t.$slots, "header", Ct(on(s.scope.header))),
    B("div", {
      id: `vs${n.uid}__combobox`,
      ref: "toggle",
      class: "vs__dropdown-toggle",
      role: "combobox",
      "aria-expanded": s.dropdownOpen.toString(),
      "aria-owns": `vs${n.uid}__listbox`,
      "aria-label": "Search for option",
      onMousedown: e[1] || (e[1] = (a) => s.toggleDropdown(a))
    }, [
      B("div", Rme, [
        (S(!0), D(_e, null, Fe(s.selectedValue, (a, l) => H(t.$slots, "selected-option-container", {
          option: s.normalizeOptionForSlot(a),
          deselect: s.deselect,
          multiple: n.multiple,
          disabled: n.disabled
        }, () => [
          (S(), D("span", {
            key: n.getOptionKey(a),
            class: "vs__selected"
          }, [
            H(t.$slots, "selected-option", Ct(on(s.normalizeOptionForSlot(a))), () => [
              ft(Pe(n.getOptionLabel(a)), 1)
            ]),
            n.multiple ? (S(), D("button", {
              key: 0,
              ref_for: !0,
              ref: (c) => i.deselectButtons[l] = c,
              disabled: n.disabled,
              type: "button",
              class: "vs__deselect",
              title: `Deselect ${n.getOptionLabel(a)}`,
              "aria-label": `Deselect ${n.getOptionLabel(a)}`,
              onClick: (c) => s.deselect(a)
            }, [
              (S(), ye(ht(s.childComponents.Deselect)))
            ], 8, Bme)) : Z("", !0)
          ]))
        ])), 256)),
        H(t.$slots, "search", Ct(on(s.scope.search)), () => [
          B("input", Nt({ class: "vs__search" }, s.scope.search.attributes, W_(s.scope.search.events)), null, 16)
        ])
      ], 512),
      B("div", Fme, [
        Yn(B("button", {
          ref: "clearButton",
          disabled: n.disabled,
          type: "button",
          class: "vs__clear",
          title: "Clear Selected",
          "aria-label": "Clear Selected",
          onClick: e[0] || (e[0] = (...a) => s.clearSelection && s.clearSelection(...a))
        }, [
          (S(), ye(ht(s.childComponents.Deselect)))
        ], 8, zme), [
          [cc, s.showClearButton]
        ]),
        H(t.$slots, "open-indicator", Ct(on(s.scope.openIndicator)), () => [
          n.noDrop ? Z("", !0) : (S(), ye(ht(s.childComponents.OpenIndicator), Ct(Nt({ key: 0 }, s.scope.openIndicator.attributes)), null, 16))
        ]),
        H(t.$slots, "spinner", Ct(on(s.scope.spinner)), () => [
          Yn(B("div", Vme, "Loading...", 512), [
            [cc, t.mutableLoading]
          ])
        ])
      ], 512)
    ], 40, Ime),
    re(Gn, { name: n.transition }, {
      default: G(() => [
        s.dropdownOpen ? Yn((S(), D("ul", {
          id: `vs${n.uid}__listbox`,
          ref: "dropdownMenu",
          key: `vs${n.uid}__listbox`,
          class: "vs__dropdown-menu",
          role: "listbox",
          tabindex: "-1",
          onMousedown: e[2] || (e[2] = Lt((...a) => s.onMousedown && s.onMousedown(...a), ["prevent"])),
          onMouseup: e[3] || (e[3] = (...a) => s.onMouseUp && s.onMouseUp(...a))
        }, [
          H(t.$slots, "list-header", Ct(on(s.scope.listHeader))),
          (S(!0), D(_e, null, Fe(s.filteredOptions, (a, l) => (S(), D("li", {
            id: `vs${n.uid}__option-${l}`,
            key: n.getOptionKey(a),
            role: "option",
            class: j(["vs__dropdown-option", {
              "vs__dropdown-option--deselect": s.isOptionDeselectable(a) && l === t.typeAheadPointer,
              "vs__dropdown-option--selected": s.isOptionSelected(a),
              "vs__dropdown-option--highlight": l === t.typeAheadPointer,
              "vs__dropdown-option--disabled": !n.selectable(a)
            }]),
            "aria-selected": l === t.typeAheadPointer ? !0 : null,
            onMouseover: (c) => n.selectable(a) ? t.typeAheadPointer = l : null,
            onClick: Lt((c) => n.selectable(a) ? s.select(a) : null, ["prevent", "stop"])
          }, [
            H(t.$slots, "option", Ct(on(s.normalizeOptionForSlot(a))), () => [
              ft(Pe(n.getOptionLabel(a)), 1)
            ])
          ], 42, Yme))), 128)),
          s.filteredOptions.length === 0 ? (S(), D("li", Wme, [
            H(t.$slots, "no-options", Ct(on(s.scope.noOptions)), () => [
              jme
            ])
          ])) : Z("", !0),
          H(t.$slots, "list-footer", Ct(on(s.scope.listFooter)))
        ], 40, Hme)), [
          [o]
        ]) : (S(), D("ul", {
          key: 1,
          id: `vs${n.uid}__listbox`,
          role: "listbox",
          style: { display: "none", visibility: "hidden" }
        }, null, 8, qme))
      ]),
      _: 3
    }, 8, ["name"]),
    H(t.$slots, "footer", Ct(on(s.scope.footer)))
  ], 10, Nme);
}
const Kme = /* @__PURE__ */ Wy(Lme, [["render", Ume]]), Gme = { class: "vx-relative vx-w-full" }, Xme = {
  key: 1,
  class: "vx-mt-1 vx-pl-0.5 vx-text-xs vx-text-rose-800"
}, Zme = {
  inheritAttrs: !1
}, Jme = /* @__PURE__ */ oe({
  ...Zme,
  __name: "vx-selectable",
  props: {
    modelValue: {},
    noTags: {
      type: Boolean,
      default: !1
    },
    relativeDropdown: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    error: {
      type: String,
      default: void 0
    },
    size: {
      type: String,
      default: "md"
    },
    appearance: {
      type: String,
      default: "input"
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue", "option:selected"],
  setup(t, { emit: e }) {
    const n = la(rt, { icon: SO }), r = la(rt, { icon: Tv, class: "vx-text-base" }), i = t, s = e, o = T(() => i.placeholder && Array.isArray(i.modelValue) ? i.noTags || i.modelValue.length === 0 : !!(i.placeholder && !i.modelValue)), a = T(() => i.size === "lg" ? "vx-selectable--lg" : i.size === "xl" ? "vx-selectable--xl" : "");
    return (l, c) => (S(), D("div", Gme, [
      re(P(Kme), Nt({
        class: ["vx-selectable", [{
          "vx-selectable--no-tags": i.noTags,
          "vx-selectable--relative-dropdown": i.relativeDropdown,
          "vx-selectable--appearance-select": i.appearance === "select",
          "vx-selectable--invalid": i.error,
          "vx-selectable--disabled": i.disabled
        }, a.value]],
        components: {
          Deselect: P(n),
          OpenIndicator: P(r)
        }
      }, l.$attrs, {
        modelValue: i.modelValue,
        "onUpdate:modelValue": c[0] || (c[0] = (u) => s("update:modelValue", u)),
        "onOption:selected": c[1] || (c[1] = (u) => s("option:selected", u)),
        disabled: i.disabled
      }), {
        "no-options": G(({ search: u, searching: h, loading: f }) => [
          H(l.$slots, "no-options", {
            search: u,
            searching: h,
            loading: f
          }, void 0, !0)
        ]),
        option: G((u) => [
          H(l.$slots, "option", { option: u }, void 0, !0)
        ]),
        "selected-option": G((u) => [
          H(l.$slots, "selected-option", { option: u }, void 0, !0)
        ]),
        "selected-option-container": G(({
          option: u,
          deselect: h,
          multiple: f,
          disabled: d
        }) => [
          H(l.$slots, "selected-option-container", {
            option: u,
            deselect: h,
            multiple: f,
            disabled: d
          }, void 0, !0)
        ]),
        spinner: G(({ loading: u }) => [
          u ? (S(), ye(Ov, {
            key: 0,
            spin: "",
            class: "vx-w-4"
          })) : Z("", !0)
        ]),
        _: 3
      }, 16, ["class", "components", "modelValue", "disabled"]),
      o.value ? (S(), D("span", {
        key: 0,
        class: j(["vx-selectable__placeholder vx-font-sans vx-text-base vx-text-slate-900 vx-absolute vx-z-[1] vx-left-4 vx-top-[0.5px] vx-flex vx-items-center vx-pointer-events-none vx-border vx-border-solid vx-border-transparent vx-opacity-70", {
          "vx-h-10": i.size === "md",
          "vx-h-12": i.size === "lg",
          "vx-h-14": i.size === "xl"
        }])
      }, Pe(i.placeholder), 3)) : Z("", !0),
      i.error ? (S(), D("div", Xme, Pe(i.error), 1)) : Z("", !0)
    ]));
  }
}), h0e = /* @__PURE__ */ jt(Jme, [["__scopeId", "data-v-4aaa96ae"]]), Qme = {}, ege = { class: "vx-sticky vx-bottom-3 vx-flex vx-w-full vx-flex-row vx-items-stretch vx-gap-2 vx-rounded-2xl vx-border vx-border-white vx-bg-white/70 vx-p-4 vx-shadow-2xl vx-backdrop-blur-md vx-z-10 sm:vx-p-6" };
function tge(t, e) {
  return S(), D("div", ege, [
    H(t.$slots, "default")
  ]);
}
const d0e = /* @__PURE__ */ jt(Qme, [["render", tge]]), nge = { class: "vx-flex vx-items-center vx-gap-8 vx-flex-col vx-pb-[50rem] lg:vx-gap-12" }, rge = ["id", "onClick"], ige = { class: "vx-w-full" }, p0e = /* @__PURE__ */ oe({
  __name: "vx-sticky-nav",
  props: {
    sections: {
      type: Array,
      required: !0
    },
    navClasses: {
      type: String,
      required: !1
    },
    modelValue: {
      type: String,
      required: !1
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, r = e, i = le(null), s = le(null), o = le(null), a = async (f) => {
      await gt();
      const d = document.getElementById(f);
      d && window.scrollTo({
        top: d.getBoundingClientRect().top + window.scrollY - 70,
        behavior: "smooth"
      });
    };
    Se(() => n.modelValue, async (f) => {
      i.value = f || null, await gt(), f && (a(f), l(f));
    });
    const l = async (f) => {
      await gt(), Array.from(s.value || []).forEach((d) => {
        if (!d.getAttribute("id").includes(f))
          return;
        const m = d.offsetWidth / 2 + d.offsetLeft - 3;
        o.value && (o.value.style.left = m + "px");
      });
    }, c = (f, d) => {
      var p;
      n.modelValue && ((p = n.sections.find((m) => m.id === f)) == null ? void 0 : p.disabled) !== !0 ? (r("update:modelValue", f), a(f)) : !n.modelValue && d && a(f);
    }, u = (f) => {
      const d = f.getBoundingClientRect();
      return d.top > -(d.height / 2);
    }, h = () => {
      var p;
      const d = ((p = n.sections.map((m) => {
        const v = document.getElementById(m.id);
        return v ? {
          visible: u(v),
          sectionId: m.id
        } : null;
      }).filter((m) => m !== null).find((m) => m == null ? void 0 : m.visible)) == null ? void 0 : p.sectionId) || null;
      i.value = d, !(!s.value || !d) && l(d);
    };
    return rn(async () => {
      n.modelValue ? (i.value = n.modelValue, l(n.modelValue)) : (await gt(), h(), window.addEventListener("scroll", () => {
        h();
      }), window.addEventListener("resize", () => {
        h();
      }));
    }), (f, d) => (S(), D("div", nge, [
      B("div", {
        class: j(["vx-sticky vx-top-4 vx-overflow-hidden vx-rounded-full vx-border-solid vx-border vx-border-white vx-bg-slate-100/50 vx-px-4 vx-shadow-xl vx-backdrop-blur-md vx-z-10", [n.navClasses]])
      }, [
        (S(!0), D(_e, null, Fe(n.sections, (p) => (S(), D("div", {
          key: p.id,
          id: "nav-" + p.id,
          class: j([{
            "vx-text-sky-600": p.id === i.value,
            "vx-text-slate-700": p.id !== i.value
          }, "vx-relative vx-no-underline hover:vx-no-underline vx-overflow-hidden vx-py-2 vx-px-2 vx-text-xs vx-transition vx-inline-flex vx-justify-center vx-cursor-pointer"]),
          "data-test": "sticky-nav-item",
          ref_for: !0,
          ref_key: "navItems",
          ref: s,
          onClick: () => c(p.id, !0)
        }, [
          B("span", null, Pe(p.label), 1)
        ], 10, rge))), 128)),
        B("div", {
          ref_key: "dotMain",
          ref: o,
          class: "vx-absolute vx-left-0 vx-bottom-0 vx-block vx-h-2 vx-w-2 vx-translate-y-1/2 vx-rounded-full vx-bg-sky-600 vx-transition-all"
        }, null, 512)
      ], 2),
      B("div", ige, [
        H(f.$slots, "default")
      ])
    ]));
  }
}), m0e = /* @__PURE__ */ oe({
  __name: "vx-switch",
  props: {
    modelValue: {
      type: Boolean,
      required: !0
    },
    loading: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "md"
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, r = e;
    return (i, s) => (S(), D("button", {
      type: "button",
      role: "switch",
      class: j([
        "vx-group/toggle vx-rounded-full vx-relative vx-inline-block vx-cursor-pointer vx-shadow-[0_1px_2px_#00000022_inset] vx-outline-none vx-ring-offset-slate-50 vx-transition after:vx-absolute after:vx-inset-0 after:vx-block after:vx-rounded-full after:vx-shadow-[0_1px_0_#fff] focus-visible:vx-ring-2 focus-visible:vx-ring-blue-500 focus-visible:vx-ring-offset-2",
        {
          "vx-animate-pulse vx-cursor-progress": n.loading,
          "vx-bg-sky-400 hover:vx-bg-sky-500/80": n.modelValue,
          "vx-bg-slate-300 hover:vx-bg-slate-400/60": !n.modelValue,
          "vx-p-0.5": n.size === "sm",
          "vx-p-1": n.size === "md"
        }
      ]),
      onClick: s[0] || (s[0] = (o) => r("update:modelValue", !t.modelValue))
    }, [
      B("div", {
        class: j(["vx-relative vx-grid vx-origin-top-left vx-select-none vx-grid-cols-2 vx-place-items-center vx-items-start vx-text-xs vx-font-semibold vx-text-slate-800 vx-duration-300", {
          "vx-h-3 vx-w-6": n.size === "sm",
          "vx-h-4 vx-w-8": n.size === "md"
        }])
      }, [
        B("div", {
          "aria-hidden": "true",
          class: j(["vx-absolute vx-top-0 vx-left-0 vx-z-20 vx-h-full vx-w-1/2 vx-transition vx-duration-[.4s] vx-ease-[cubic-bezier(0.35,1.3,0.5,1)]", {
            "vx-translate-x-full": t.modelValue
          }])
        }, [
          B("div", {
            class: j(["vx-h-full vx-w-full vx-bg-white vx-rounded-full vx-shadow-md vx-transition vx-duration-300 group-hover/toggle:vx-scale-x-105 group-active/toggle:vx-scale-x-110", [
              t.modelValue ? "vx-origin-right vx-shadow-sky-600" : "vx-origin-left vx-shadow-slate-800/30"
            ]])
          }, null, 2)
        ], 2)
      ], 2)
    ], 2));
  }
}), sge = ["value"], oge = /* @__PURE__ */ oe({
  __name: "vx-tab",
  props: {
    active: {
      type: Boolean,
      required: !1,
      default: !1
    },
    value: {
      type: String,
      required: !0
    },
    size: {
      type: String,
      required: !1,
      default: "md"
    }
  },
  setup(t) {
    const e = t, n = T(() => e.size === "sm" ? ["vx-h-6", "vx-px-2", "vx-py-1", "vx-rounded", "vx-text-black"] : e.size === "lg" ? ["vx-w-full", "vx-h-10", "vx-px-4", "vx-py-2", "vx-rounded-md"] : ["vx-w-full", "vx-h-8", "vx-px-4", "vx-py-2", "vx-rounded-md"]);
    return (r, i) => (S(), D("div", {
      value: e.value,
      class: j(["vx-flex vx-justify-center vx-items-center vx-text-xs vx-font-semibold vx-cursor-pointer", [
        {
          "vx-text-slate-600": !e.active,
          "vx-text-slate-800": e.active,
          "vx-bg-white vx-shadow": e.active
        },
        n.value
      ]])
    }, [
      H(r.$slots, "default")
    ], 10, sge));
  }
}), g0e = /* @__PURE__ */ oe({
  __name: "vx-tabs",
  props: {
    modelValue: {
      type: String,
      required: !1,
      default: "default"
    },
    size: {
      type: String,
      required: !1,
      default: "md"
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, r = e, i = le(n.modelValue);
    Se(
      () => n.modelValue,
      (c) => {
        i.value = c;
      }
    );
    const s = xs(), o = T(
      () => s.default ? s.default().filter((c) => c.type === oge) : []
    ), a = (c) => {
      !c || n.disabled || (i.value = c, r("update:modelValue", i.value));
    }, l = T(() => n.size === "sm" ? ["vx-inline-flex", "vx-p-1"] : ["vx-flex", "vx-p-1", "vx-gap-2"]);
    return (c, u) => (S(), D("div", {
      class: j(["vx-justify-between vx-items-center vx-rounded-lg vx-bg-slate-300 vx-shadow-inner", [l.value, {
        "vx-opacity-40": n.disabled
      }]])
    }, [
      (S(!0), D(_e, null, Fe(o.value, (h, f) => (S(), D(_e, {
        key: `tab-${f}`
      }, [
        h.props !== null ? (S(), ye(ht(h), {
          key: 0,
          value: h.props.value,
          onClick: (d) => {
            var p;
            return a((p = h.props) == null ? void 0 : p.value);
          },
          onKeyup: Yt((d) => {
            var p;
            return a((p = h.props) == null ? void 0 : p.value);
          }, ["enter"]),
          active: h.props.value === i.value,
          role: "tab",
          "aria-selected": h.props.value === i.value,
          tabindex: "0",
          size: n.size
        }, null, 40, ["value", "onClick", "onKeyup", "active", "aria-selected", "size"])) : Z("", !0)
      ], 64))), 128))
    ], 2));
  }
}), v0e = /* @__PURE__ */ oe({
  __name: "vx-table",
  props: {
    rowBreakpoint: {
      type: String,
      required: !0,
      validator: (t) => ["sm", "md", "lg", "xl"].includes(t)
    }
  },
  setup(t) {
    const e = t, n = T(() => ({
      "sm-table-classes": e.rowBreakpoint === "sm",
      "md-table-classes": e.rowBreakpoint === "md",
      "lg-table-classes": e.rowBreakpoint === "lg",
      "xl-table-classes": e.rowBreakpoint === "xl"
    }));
    return (r, i) => (S(), D("div", {
      class: j(["vx-font-sans vx-grid vx-gap-2 vx-mt-10", [n.value]])
    }, [
      H(r.$slots, "default")
    ], 2));
  }
}), age = ["disabled"], lge = {
  inheritAttrs: !1
}, y0e = /* @__PURE__ */ oe({
  ...lge,
  __name: "vx-table-row",
  props: {
    disabled: {
      type: Boolean
    },
    isHeader: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = t, n = le(), r = le();
    return rn(() => {
      var i;
      if (!e.isHeader) {
        const s = (i = n.value) == null ? void 0 : i.getBoxElement().childElementCount;
        r.value = `grid-template-rows: repeat(${s - 1},auto) 1fr;`;
      }
    }), (i, s) => (S(), D(_e, null, [
      e.isHeader ? (S(), D("div", Nt({ key: 0 }, i.$attrs, {
        class: "table-row vx-items-center vx-grid-cols-[auto_1fr] vx-gap-x-2 sm:vx-gap-x-4 lg:vx-gap-x-6 vx-content-start vx-px-6 vx-h-10 vx-hidden vx-text-xs vx-text-slate-800",
        style: r.value,
        disabled: e.disabled,
        ref_key: "row",
        ref: n
      }), [
        H(i.$slots, "default")
      ], 16, age)) : Z("", !0),
      e.isHeader ? Z("", !0) : (S(), ye(E3, Nt({ key: 1 }, i.$attrs, {
        class: "table-row vx-text-slate-700 vx-items-center vx-grid-cols-[auto_1fr] vx-gap-y-1 vx-gap-x-2 sm:vx-gap-x-4 lg:vx-gap-x-6 vx-content-start vx-p-6 vx-grid",
        style: r.value,
        disabled: e.disabled,
        ref_key: "row",
        ref: n
      }), {
        default: G(() => [
          H(i.$slots, "default")
        ]),
        _: 3
      }, 16, ["style", "disabled"]))
    ], 64));
  }
}), cge = { class: "vx-items-center vx-col-span-full vx-grid-cols-subgrid vx-grid table-row-item vx-min-w-0" }, b0e = /* @__PURE__ */ oe({
  __name: "vx-table-row-item",
  props: {
    labelClasses: {
      type: String,
      default: ""
    },
    contentClasses: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t;
    return (n, r) => (S(), D("div", cge, [
      B("div", {
        class: j(["vx-text-xs vx-text-slate-500", [e.labelClasses]])
      }, [
        H(n.$slots, "label")
      ], 2),
      B("div", {
        class: j(["vx-text-sm vx-flex vx-items-center vx-max-w-full vx-min-w-0 [&>*]:vx-min-w-0", [e.contentClasses]])
      }, [
        H(n.$slots, "default")
      ], 2)
    ]));
  }
}), uge = {}, fge = { class: "table-row-title vx-font-bold vx-text-slate-700 vx-leading-tight vx-col-span-full vx-pb-2" }, hge = { class: "vx-text-ellipsis" };
function dge(t, e) {
  return S(), D("div", fge, [
    B("span", hge, [
      H(t.$slots, "default")
    ])
  ]);
}
const x0e = /* @__PURE__ */ jt(uge, [["render", dge]]), pge = {}, mge = { class: "table-row-buttons vx-col-span-full vx-flex vx-justify-end vx-self-end vx-pt-3 vx-gap-1 [&>:last-child]:vx-grow" };
function gge(t, e) {
  return S(), D("div", mge, [
    H(t.$slots, "default")
  ]);
}
const w0e = /* @__PURE__ */ jt(pge, [["render", gge]]), L_ = /* @__PURE__ */ oe({
  __name: "vx-toggle-choice",
  props: {
    active: {
      type: Boolean,
      required: !0
    }
  },
  setup(t) {
    const e = t;
    return (n, r) => (S(), D("span", {
      class: j(["vx-flex vx-items-center vx-h-full vx-px-3 vx-transition vx-duration-300 vx-z-10", {
        "vx-opacity-30 vx-bg-blend-multiply": !e.active
      }])
    }, [
      H(n.$slots, "default")
    ], 2));
  }
}), vge = ["tabindex"], yge = { class: "vx-grid vx-grid-cols-2 vx-place-items-center vx-items-start vx-duration-300 vx-text-xs vx-text-slate-800 vx-font-semibold vx-select-none vx-relative vx-origin-top-left vx-h-full" }, k0e = /* @__PURE__ */ oe({
  __name: "vx-toggle",
  props: {
    modelValue: {
      type: Boolean,
      required: !0
    },
    loading: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "md"
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, r = e, i = () => {
      n.disabled || r("update:modelValue", !n.modelValue);
    };
    return (s, o) => (S(), D("div", {
      class: j(["vx-p-1 vx-inline-block vx-group/toggle", {
        "vx-bg-slate-300 ": !n.modelValue,
        "vx-bg-sky-300 ": n.modelValue,
        "vx-animate-pulse vx-cursor-progress": n.loading,
        "vx-cursor-not-allowed vx-opacity-60": n.disabled,
        "vx-cursor-pointer": !n.disabled,
        "vx-rounded-md vx-h-8": n.size === "sm",
        "vx-rounded-xl vx-h-10": n.size === "md"
      }]),
      tabindex: n.disabled ? void 0 : 0,
      onClick: o[0] || (o[0] = Lt((a) => i(), ["prevent", "stop"])),
      onKeydown: [
        o[1] || (o[1] = Yt(Lt((a) => i(), ["prevent"]), ["space"])),
        o[2] || (o[2] = Yt(Lt((a) => i(), ["prevent"]), ["enter"]))
      ]
    }, [
      B("div", yge, [
        re(L_, {
          size: n.size,
          active: !n.modelValue
        }, {
          default: G(() => [
            H(s.$slots, "no", {}, () => [
              ft("No")
            ])
          ]),
          _: 3
        }, 8, ["size", "active"]),
        re(L_, {
          size: n.size,
          active: n.modelValue
        }, {
          default: G(() => [
            H(s.$slots, "yes", {}, () => [
              ft("Yes")
            ])
          ]),
          _: 3
        }, 8, ["size", "active"]),
        B("div", {
          "aria-hidden": "true",
          class: j(["vx-w-1/2 vx-top-0 vx-left-0 vx-h-full vx-absolute vx-transition vx-duration-[.4s] vx-ease-[cubic-bezier(0.35,1.3,0.5,1)]", {
            "vx-translate-x-full": n.modelValue
          }])
        }, [
          B("div", {
            class: j(["vx-bg-white vx-shadow vx-h-full vx-w-full group-hover/toggle:vx-scale-x-105 vx-duration-300 vx-transition", {
              "vx-origin-top-left": !n.modelValue,
              "vx-origin-top-right": n.modelValue,
              "vx-rounded-sm": n.size === "sm",
              "vx-rounded-md": n.size === "md"
            }])
          }, null, 2)
        ], 2)
      ])
    ], 42, vge));
  }
}), _0e = /* @__PURE__ */ oe({
  __name: "vx-writer",
  props: {
    text: {
      type: String,
      required: !0
    },
    speed: {
      type: Number,
      required: !1,
      default: 50
    }
  },
  emits: ["completed"],
  setup(t, { emit: e }) {
    const n = e, r = t;
    let i = 0;
    const s = le("");
    let o;
    const a = () => {
      if (i >= r.text.length) {
        n("completed");
        return;
      }
      s.value = `${s.value}${r.text[i]}`, o = setTimeout(() => {
        i++, a();
      }, r.speed);
    };
    return rn(() => {
      a();
    }), bd(() => {
      o && clearTimeout(o);
    }), (l, c) => Pe(s.value);
  }
}), bge = {
  "aria-hidden": "true",
  class: "vx-absolute vx-inset-y-0 vx-right-0 vx-z-0 vx-flex vx-w-full vx-flex-col vx-items-end vx-justify-center vx-@container"
}, xge = /* @__PURE__ */ B("div", { class: "vx-absolute vx-inset-0 vx-bg-[linear-gradient(140deg,#fff_20%,rgba(255,255,255,0.98)_30%,rgba(255,255,255,0))]" }, null, -1), wge = /* @__PURE__ */ B("div", { class: "vx-absolute vx-inset-0 vx-bg-[linear-gradient(140deg,#fff_20%,rgba(255,255,255,0.8)_80%,rgba(255,255,255,0))] @3xl:vx-bg-[linear-gradient(140deg,#fff_20%,rgba(255,255,255,0.8)_50%,rgba(255,255,255,0))] @5xl:vx-bg-[linear-gradient(140deg,#fff_30%,rgba(255,255,255,0)_80%)]" }, null, -1), S0e = /* @__PURE__ */ oe({
  __name: "vx-wallpaper",
  props: {
    icon: {
      type: Object,
      required: !0
    },
    spaceY: {
      type: Number,
      default: 4
    },
    spaceX: {
      type: Number,
      default: 8
    },
    offset: {
      type: Number,
      default: -20
    }
  },
  setup(t) {
    const e = t;
    return (n, r) => (S(), D("div", bge, [
      B("div", {
        class: "vx-flex vx-flex-col vx-items-end vx-justify-center",
        style: yt({
          transform: "translateY(" + -t.spaceY / 2 + "px)"
        })
      }, [
        (S(), D(_e, null, Fe(12, (i) => B("div", {
          key: i,
          class: "vx-flex",
          style: yt({
            marginTop: t.spaceY + "px",
            marginRight: i % 2 == 0 ? t.offset + "px" : "0px"
          })
        }, [
          (S(), D(_e, null, Fe(30, (s) => re(P(rt), {
            icon: e.icon,
            key: s,
            class: j(["vx-text-[32px] vx-text-cyan-100", [
              s == Math.floor(Math.random() * 30) && "!vx-text-amber-200",
              s == Math.floor(Math.random() * 30) && "!vx-text-violet-200",
              s == Math.floor(Math.random() * 30) && "!vx-text-emerald-200"
            ]]),
            style: yt({
              marginRight: t.spaceX + "px"
            })
          }, null, 8, ["icon", "class", "style"])), 64))
        ], 4)), 64)),
        xge
      ], 4),
      wge
    ]));
  }
});
function kge(t, e) {
  return Object.keys(t.values).forEach(
    (n) => t.values[n] = t.values[n] && parseFloat(t.values[n].toFixed(e))
  ), t;
}
function QD(t, e, n) {
  const r = e - 1, i = n[t7(r, n.length)];
  return i.marker !== "Z" ? i : QD(t, r, n);
}
function e7(t, e, n) {
  const r = e + 1, i = n[t7(r, n.length)];
  return i.marker === "Z" ? e7(t, r, n) : i;
}
function _ge(t, e, n) {
  const r = n[e - 1] || { values: { x: 0, y: 0 } };
  if (t.marker === t.marker.toLowerCase())
    switch (t.marker = t.marker.toUpperCase(), t.marker) {
      case "M":
        t.values.x += r.values.x, t.values.y += r.values.y;
        break;
      case "L":
      case "A":
        t.values.x += r.values.x, t.values.y += r.values.y;
        break;
      case "H":
        t.marker = "L", t.values.x += r.values.x, t.values.y = r.values.y;
        break;
      case "V":
        t.marker = "L", t.values.x = r.values.x, t.values.y += r.values.y;
        break;
      case "C":
        t.values.x += r.values.x, t.values.y += r.values.y, t.values.x1 += r.values.x, t.values.y1 += r.values.y, t.values.x2 += r.values.x, t.values.y2 += r.values.y;
        break;
      case "S":
        t.values.x += r.values.x, t.values.y += r.values.y, t.values.x2 += r.values.x, t.values.y2 += r.values.y;
        break;
      case "Q":
        t.values.x += r.values.x, t.values.y += r.values.y, t.values.x1 += r.values.x, t.values.y1 += r.values.y;
        break;
      case "T":
        t.values.x += r.values.x, t.values.y += r.values.y;
        break;
    }
  else if (t.marker === t.marker.toUpperCase())
    switch (t.marker) {
      case "H":
        t.marker = "L", t.values.y = r.values.y;
        break;
      case "V":
        t.marker = "L", t.values.x = r.values.x;
        break;
    }
  if (t.marker === "Z") {
    const i = n7(n, e);
    t.values.x = i.values.x, t.values.y = i.values.y;
  }
  return t;
}
function Sge(t, e) {
  const n = [];
  switch (t.toUpperCase()) {
    case "M":
      for (let r = 0; r < e.length; r += 2) {
        let i;
        t === t.toUpperCase() ? i = r === 0 ? "M" : "L" : i = r === 0 ? "m" : "l", n.push({
          marker: i,
          values: {
            x: e[r],
            y: e[r + 1]
          }
        });
      }
      break;
    case "L":
      for (let r = 0; r < e.length; r += 2)
        n.push({
          marker: t,
          values: {
            x: e[r],
            y: e[r + 1]
          }
        });
      break;
    case "H":
      for (let r = 0; r < e.length; r++)
        n.push({
          marker: t,
          values: {
            x: e[r],
            y: 0
          }
        });
      break;
    case "V":
      for (let r = 0; r < e.length; r++)
        n.push({
          marker: t,
          values: {
            x: 0,
            y: e[r]
          }
        });
      break;
    case "C":
      for (let r = 0; r < e.length; r += 6)
        n.push({
          marker: t,
          values: {
            x1: e[r],
            y1: e[r + 1],
            x2: e[r + 2],
            y2: e[r + 3],
            x: e[r + 4],
            y: e[r + 5]
          }
        });
      break;
    case "S":
      for (let r = 0; r < e.length; r += 4)
        n.push({
          marker: t,
          values: {
            x2: e[r],
            y2: e[r + 1],
            x: e[r + 2],
            y: e[r + 3]
          }
        });
      break;
    case "Q":
      for (let r = 0; r < e.length; r += 4)
        n.push({
          marker: t,
          values: {
            x1: e[r],
            y1: e[r + 1],
            x: e[r + 2],
            y: e[r + 3]
          }
        });
      break;
    case "T":
      for (let r = 0; r < e.length; r += 2)
        n.push({
          marker: t,
          values: {
            x: e[r],
            y: e[r + 1]
          }
        });
      break;
    case "A":
      for (let r = 0; r < e.length; r += 7)
        n.push({
          marker: t,
          values: {
            radiusX: e[r],
            radiusY: e[r + 1],
            rotation: e[r + 2],
            largeArc: e[r + 3],
            sweep: e[r + 4],
            x: e[r + 5],
            y: e[r + 6]
          }
        });
      break;
    case "Z":
      n.push({
        marker: t,
        values: {
          // values will be overriden later by convertToAbsolute()
          x: 0,
          y: 0
        }
      });
      break;
  }
  return n;
}
function t7(t, e) {
  return (t % e + e) % e;
}
function Mge(t, e, n) {
  if (e !== 0 && t.marker === "L") {
    const r = n[e - 1];
    ["x", "y"].every((s) => Math.round(Math.abs(r.values[s] - t.values[s])) === 0) && (t.overlap = !0);
  }
  return t;
}
function vv(t, e) {
  const n = ["x", "y"].every((r) => Math.round(Math.abs(t[e].values[r] - t[0].values[r])) === 0);
  t[e].marker === "L" && n && (t[e].overlap = !0, vv(t, e - 1)), t[e].marker === "Z" && vv(t, e - 1);
}
function Cge(t, e, n) {
  const r = I_(t.values, n.values), i = I_(e.values, t.values);
  return Math.min(i, r);
}
function N_(t, e) {
  return Math.atan2(e.x - t.x, e.y - t.y);
}
function I_(t, e) {
  const n = t.x - e.x, r = t.y - e.y;
  return Math.sqrt(Math.pow(n, 2) + Math.pow(r, 2));
}
function R_(t, e) {
  return Math.sin(t) * e;
}
function B_(t, e) {
  return Math.cos(t) * e;
}
function F_(t, e) {
  const n = e / Math.tan(t);
  return n === 1 / 0 || n === -1 / 0 || isNaN(n) ? e : n;
}
function $ge(t, e) {
  return e * Math.tan(t);
}
function Age(t, e) {
  let n, r = 0;
  const i = t * (180 / Math.PI);
  return i < 0 && i >= -180 || i > 180 && i < 360 ? n = F_(t / 2, -e) : (n = F_(t / 2, e), r = 1, n === 1 / 0 && (n = e)), {
    offset: n,
    sweepFlag: r
  };
}
function Dge(t) {
  const e = [
    "radiusX",
    "radiusY",
    "rotation",
    "largeArc",
    "sweep",
    "x1",
    "y1",
    "x2",
    "y2",
    "x",
    "y"
  ];
  return t.map((n) => {
    let r = "";
    if (n.marker !== "Z") {
      const i = Object.keys(n.values);
      r = e.filter((s) => i.indexOf(s) !== -1).map((s) => n.values[s]).join();
    }
    return `${n.marker}${r}`;
  }).join("").trim();
}
function n7(t, e) {
  return t[e].marker === "M" ? t[e] : n7(t, e - 1);
}
function r7(t) {
  const e = /[MmLlSsQqLlHhVvCcSsQqTtAaZz]/g, n = /-?[0-9]*\.?\d+/g;
  return [...t.matchAll(e)].map((r) => ({ marker: r[0], index: r.index })).reduceRight((r, i) => {
    const s = t.substring(
      i.index,
      r.length ? r[r.length - 1].index : t.length
    );
    return r.concat([
      {
        marker: i.marker,
        index: i.index,
        chunk: s.length > 0 ? s.substr(1, s.length - 1) : s
      }
    ]);
  }, []).reverse().flatMap((r) => {
    const i = r.chunk.match(n), s = i ? i.map(parseFloat) : [];
    return Sge(r.marker, s);
  }).map(_ge);
}
function i7(t, e, n) {
  const r = [], i = [];
  return n && t.forEach((s) => kge(s, n)), t.forEach((s) => {
    s.marker === "M" && r.push([]), r[r.length - 1].push(s);
  }), r.forEach((s) => {
    s.map(Mge), vv(s, s.length - 1);
    const o = s[s.length - 1].marker == "Z";
    s.filter((a) => !a.overlap).map((a, l, c) => {
      const h = QD(a, l, c), f = e7(a, l, c), d = N_(a.values, h.values), p = N_(a.values, f.values), m = p - d, v = m * (180 / Math.PI), g = Cge(a, h, f), y = Math.abs($ge(m / 2, g / 2)), x = Math.min(e, y), b = Age(m, x), w = b.offset, k = b.sweepFlag, _ = (l == 0 || l == c.length - 1) && !o;
      switch (a.marker) {
        case "M":
        case "L":
          const C = [
            a.values.x + R_(d, w),
            a.values.y + B_(d, w)
          ], E = [
            a.values.x + R_(p, w),
            a.values.y + B_(p, w)
          ];
          _ ? i.push({
            marker: a.marker,
            values: a.values
          }) : i.push({
            marker: a.marker,
            values: {
              x: parseFloat(C[0].toFixed(3)),
              y: parseFloat(C[1].toFixed(3))
            }
          }), !_ && (f.marker === "L" || f.marker === "M") && i.push({
            marker: "A",
            radius: x,
            values: {
              radiusX: x,
              radiusY: x,
              rotation: v,
              largeArc: 0,
              sweep: k,
              x: parseFloat(E[0].toFixed(3)),
              y: parseFloat(E[1].toFixed(3))
            }
          });
          break;
        case "C":
        case "S":
        case "Q":
        case "T":
        case "A":
        case "Z":
          i.push({ marker: a.marker, values: a.values });
          break;
      }
    });
  }), {
    path: Dge(i),
    commands: i
  };
}
function Tge(t, e, n) {
  return i7([...r7(t)], e, n);
}
const M0e = { parsePath: r7, roundCommands: i7, roundCorners: Tge };
export {
  Ege as VxAlert,
  Pge as VxBadge,
  E3 as VxBox,
  Lge as VxBoxGlass,
  cs as VxButton,
  Nge as VxButtonGroup,
  e9 as VxCharCounter,
  Ige as VxChartCategorical,
  Fge as VxChartColumn,
  zge as VxChartLine,
  Vge as VxChartRecord,
  iW as VxCheckbox,
  Hge as VxCheckboxSelection,
  fW as VxCheckboxSelectionItem,
  jge as VxCodeEditor,
  qge as VxDatePicker,
  Uge as VxDisclosure,
  Kge as VxDropdown,
  Gge as VxDropdownItem,
  Xge as VxExpandableCard,
  Zge as VxFilterable,
  Ov as VxIconLoading,
  Jge as VxInput,
  Qge as VxLabel,
  e0e as VxList,
  r0e as VxListAnimated,
  t0e as VxListIcon,
  n0e as VxListItem,
  i0e as VxLogoLoading,
  y9 as VxModal,
  s0e as VxNavbar,
  vd as VxNavbarAction,
  o0e as VxNavbarActionItem,
  a0e as VxNavigation,
  A_ as VxNavigationItem,
  l0e as VxPaddedIcon,
  c0e as VxPopover,
  Zpe as VxRadio,
  u0e as VxRadioSelection,
  rme as VxRadioSelectionItem,
  f0e as VxSelect,
  h0e as VxSelectable,
  d0e as VxStickyFooter,
  p0e as VxStickyNav,
  m0e as VxSwitch,
  oge as VxTab,
  v0e as VxTable,
  y0e as VxTableRow,
  w0e as VxTableRowButtons,
  b0e as VxTableRowItem,
  x0e as VxTableRowTitle,
  g0e as VxTabs,
  k0e as VxToggle,
  S0e as VxWallpaper,
  _0e as VxWriter,
  B3 as vxFormatCount,
  F3 as vxFormatPercentage,
  M0e as vxSvg
};
